/* eslint-disable */
import { gql } from '@apollo/client';
import * as ApolloReactCommon from '@apollo/client';
import * as ApolloReactHooks from '@apollo/client';
export type Maybe<T> = T | null;
export type Exact<T extends { [key: string]: unknown }> = { [K in keyof T]: T[K] };
export type MakeOptional<T, K extends keyof T> = Omit<T, K> & { [SubKey in K]?: Maybe<T[SubKey]> };
export type MakeMaybe<T, K extends keyof T> = Omit<T, K> & { [SubKey in K]: Maybe<T[SubKey]> };
const defaultOptions =  {}
/** All built-in and custom scalars, mapped to their actual values */
export type Scalars = {
  ID: string;
  String: string;
  Boolean: boolean;
  Int: number;
  Float: number;
  /**
   * Represents non-fractional signed whole numeric values. Since the value may
   * exceed the size of a 32-bit integer, it's encoded as a string.
   */
  BigInt: any;
  /** An ISO 8601-encoded datetime */
  ISO8601DateTime: string;
  /** Represents untyped JSON */
  JSON: Record<string, any>;
  Upload: any;
};

/** An input type for updating accepted payments */
export type AcceptedPaymentsAttributes = {
  readonly achEnabled?: Maybe<Scalars['Boolean']>;
  readonly cardEnabled?: Maybe<Scalars['Boolean']>;
  readonly creditCardEnabled?: Maybe<Scalars['Boolean']>;
  readonly customerPaysAchFee?: Maybe<Scalars['Boolean']>;
  readonly customerPaysCardFee?: Maybe<Scalars['Boolean']>;
  readonly debitCardEnabled?: Maybe<Scalars['Boolean']>;
};

export type AddOnPricing = {
  readonly __typename?: 'AddOnPricing';
  readonly endDate: Scalars['String'];
  readonly proratedAmount: Scalars['Float'];
  readonly tax: Scalars['Float'];
  readonly unitAmount: Scalars['Float'];
};

export type AddPlaidTokenToConnectInvoiceFailure = {
  readonly __typename?: 'AddPlaidTokenToConnectInvoiceFailure';
  readonly errors: ReadonlyArray<Error>;
};

export type AddPlaidTokenToConnectInvoiceResult = AddPlaidTokenToConnectInvoiceFailure | AddPlaidTokenToConnectInvoiceSuccess;

export type AddPlaidTokenToConnectInvoiceSuccess = {
  readonly __typename?: 'AddPlaidTokenToConnectInvoiceSuccess';
  readonly connectInvoice: ConnectInvoice;
};

/** Bundle of address information */
export type AddressAttributes = {
  readonly addressLineOne: Scalars['String'];
  readonly addressLineTwo?: Maybe<Scalars['String']>;
  readonly city: Scalars['String'];
  readonly state: Scalars['String'];
  readonly zipCode: Scalars['String'];
};

export type AllInOneRequestFormFailure = {
  readonly __typename?: 'AllInOneRequestFormFailure';
  readonly errors: ReadonlyArray<Error>;
};

export type AllInOneRequestFormResult = AllInOneRequestFormFailure | AllInOneRequestFormSuccess;

export type AllInOneRequestFormSuccess = {
  readonly __typename?: 'AllInOneRequestFormSuccess';
  readonly connectInvoices: ConnectInvoiceConnection;
  readonly financingSent: Scalars['Boolean'];
  readonly homeowner: Homeowner;
};


export type AllInOneRequestFormSuccessConnectInvoicesArgs = {
  after?: Maybe<Scalars['String']>;
  before?: Maybe<Scalars['String']>;
  first?: Maybe<Scalars['Int']>;
  last?: Maybe<Scalars['Int']>;
};

/** ApiToken for an Organization */
export type ApiToken = {
  readonly __typename?: 'ApiToken';
  readonly delimitedPlaintextKey: Scalars['String'];
  readonly id: Scalars['ID'];
};

/** An input type for a single applicant */
export type ApplicantAttributes = {
  readonly address?: Maybe<Scalars['String']>;
  readonly birthday?: Maybe<Scalars['String']>;
  readonly city?: Maybe<Scalars['String']>;
  readonly email?: Maybe<Scalars['String']>;
  readonly employmentStatus?: Maybe<Scalars['String']>;
  readonly fico?: Maybe<Scalars['String']>;
  readonly firstName?: Maybe<Scalars['String']>;
  readonly income?: Maybe<Scalars['String']>;
  readonly lastFourSsn?: Maybe<Scalars['String']>;
  readonly lastName?: Maybe<Scalars['String']>;
  readonly phoneNumber?: Maybe<Scalars['String']>;
  readonly ssn?: Maybe<Scalars['String']>;
  readonly state?: Maybe<Scalars['String']>;
  readonly zipCode?: Maybe<Scalars['String']>;
};

export type ArchiveHomeownerFailure = {
  readonly __typename?: 'ArchiveHomeownerFailure';
  readonly errors: ReadonlyArray<Error>;
};

export type ArchiveHomeownerResult = ArchiveHomeownerFailure | ArchiveHomeownerSuccess;

export type ArchiveHomeownerSuccess = {
  readonly __typename?: 'ArchiveHomeownerSuccess';
  readonly contractor: Contractor;
  readonly homeowner: Homeowner;
};

/** Describes a piece of content from contentful whose interactions we wish to track */
export type Article = {
  readonly __typename?: 'Article';
  readonly contentType?: Maybe<Scalars['String']>;
  readonly contentfulId: Scalars['String'];
  readonly id: Scalars['ID'];
  readonly stringId: Scalars['String'];
  readonly subtitle: Scalars['String'];
  readonly title: Scalars['String'];
};

export enum ArticleInteractable {
  CONTRACTOR = 'Contractor',
  PRESALELEAD = 'PresaleLead'
}

/** Describes an interaction with a piece of content from contentful */
export type ArticleInteraction = {
  readonly __typename?: 'ArticleInteraction';
  readonly article: Article;
  readonly createdAt: Scalars['ISO8601DateTime'];
  readonly id: Scalars['ID'];
  readonly interactionType?: Maybe<ArticleInteractionType>;
  readonly interactionValue?: Maybe<Scalars['String']>;
  readonly optionSelected?: Maybe<Scalars['String']>;
};

/** The connection type for ArticleInteraction. */
export type ArticleInteractionConnection = {
  readonly __typename?: 'ArticleInteractionConnection';
  /** A list of edges. */
  readonly edges?: Maybe<ReadonlyArray<Maybe<ArticleInteractionEdge>>>;
  /** A list of nodes. */
  readonly nodes?: Maybe<ReadonlyArray<Maybe<ArticleInteraction>>>;
  /** Information to aid in pagination. */
  readonly pageInfo: PageInfo;
  readonly totalCount: Scalars['Int'];
};

/** An edge in a connection. */
export type ArticleInteractionEdge = {
  readonly __typename?: 'ArticleInteractionEdge';
  /** A cursor for use in pagination. */
  readonly cursor: Scalars['String'];
  /** The item at the end of the edge. */
  readonly node?: Maybe<ArticleInteraction>;
};

export enum ArticleInteractionType {
  HELPFUL = 'helpful',
  PERCENTAGE_COMPLETE = 'percentage_complete',
  READ = 'read',
  VIDEO_COMPLETE = 'video_complete',
  VIDEO_START = 'video_start',
  VIDEO_WATCHED = 'video_watched'
}

export type AttachExternalAccountFailure = {
  readonly __typename?: 'AttachExternalAccountFailure';
  readonly errors: ReadonlyArray<Error>;
};

export type AttachExternalAccountResult = AttachExternalAccountFailure | AttachExternalAccountSuccess;

export type AttachExternalAccountSuccess = {
  readonly __typename?: 'AttachExternalAccountSuccess';
  readonly stripeConnectAccount: StripeConnectAccount;
};

export type AttachPlaidBankAccountToConnectAccountFailure = {
  readonly __typename?: 'AttachPlaidBankAccountToConnectAccountFailure';
  readonly errors: ReadonlyArray<Error>;
};

export type AttachPlaidBankAccountToConnectAccountResult = AttachPlaidBankAccountToConnectAccountFailure | AttachPlaidBankAccountToConnectAccountSuccess;

export type AttachPlaidBankAccountToConnectAccountSuccess = {
  readonly __typename?: 'AttachPlaidBankAccountToConnectAccountSuccess';
  readonly kycBusiness: KycBusiness;
  readonly stripeConnectAccount: StripeConnectAccount;
};

/** Given credentials, can return a contractor object */
export type Authentication = {
  readonly __typename?: 'Authentication';
  readonly authToken?: Maybe<Scalars['String']>;
  readonly contractor?: Maybe<Contractor>;
  readonly error?: Maybe<Scalars['String']>;
};

export enum Background {
  PATTERN = 'pattern',
  SOLID = 'solid'
}


/** Autogenerated return type of CancelConnectInvoice */
export type CancelConnectInvoicePayload = {
  readonly __typename?: 'CancelConnectInvoicePayload';
  readonly connectInvoice?: Maybe<ConnectInvoice>;
  readonly errors?: Maybe<ReadonlyArray<ValidationError>>;
};

export type CancelInvoiceFailure = {
  readonly __typename?: 'CancelInvoiceFailure';
  readonly errors: ReadonlyArray<Error>;
};

export type CancelInvoiceResult = CancelInvoiceFailure | CancelInvoiceSuccess;

export type CancelInvoiceSuccess = {
  readonly __typename?: 'CancelInvoiceSuccess';
  readonly connectInvoice?: Maybe<ConnectInvoice>;
};

export type ClaimHearthRewardsGiftcardFailure = {
  readonly __typename?: 'ClaimHearthRewardsGiftcardFailure';
  readonly errors: ReadonlyArray<Error>;
};

export type ClaimHearthRewardsGiftcardResult = ClaimHearthRewardsGiftcardFailure | ClaimHearthRewardsGiftcardSuccess;

export type ClaimHearthRewardsGiftcardSuccess = {
  readonly __typename?: 'ClaimHearthRewardsGiftcardSuccess';
  readonly claimAmount: Scalars['Float'];
  readonly contractor: Contractor;
};

export type ClickCtaFailure = {
  readonly __typename?: 'ClickCtaFailure';
  readonly errors: ReadonlyArray<Error>;
};

export type ClickCtaResult = ClickCtaFailure | ClickCtaSuccess;

export type ClickCtaSuccess = {
  readonly __typename?: 'ClickCtaSuccess';
  readonly suggestedAction: SuggestedAction;
  readonly suggestedActionCta: SuggestedActionCta;
};

/** A coapplicant for a loan inquiry */
export type Coapplicant = {
  readonly __typename?: 'Coapplicant';
  readonly address?: Maybe<Scalars['String']>;
  readonly city?: Maybe<Scalars['String']>;
  readonly email?: Maybe<Scalars['String']>;
  readonly employmentStatus?: Maybe<Scalars['String']>;
  readonly fico?: Maybe<Scalars['String']>;
  readonly firstName?: Maybe<Scalars['String']>;
  readonly fullName?: Maybe<Scalars['String']>;
  readonly id: Scalars['ID'];
  readonly income?: Maybe<Scalars['String']>;
  readonly lastName?: Maybe<Scalars['String']>;
  readonly loanInquiry: LoanInquiry;
  readonly phoneNumber?: Maybe<Scalars['String']>;
  readonly state?: Maybe<Scalars['String']>;
  readonly zipCode?: Maybe<Scalars['String']>;
};

export enum ConnectAccountStatus {
  FULL_ACCESS = 'full_access',
  NOT_SUBMITTED = 'not_submitted',
  PENDING_VERIFICATION = 'pending_verification',
  REJECTED = 'rejected',
  REQUIRE_INFORMATION = 'require_information'
}

/** A stripe connect activity */
export type ConnectActivity = {
  readonly __typename?: 'ConnectActivity';
  readonly activityDate: Scalars['ISO8601DateTime'];
  readonly connectActivityTypeId: ConnectActivityId;
  readonly connectInvoice: ConnectInvoice;
  readonly connectInvoiceId: Scalars['ID'];
  readonly content: Scalars['String'];
  readonly createdAt: Scalars['ISO8601DateTime'];
  readonly id: Scalars['ID'];
};

/** The connection type for ConnectActivity. */
export type ConnectActivityConnection = {
  readonly __typename?: 'ConnectActivityConnection';
  /** A list of edges. */
  readonly edges?: Maybe<ReadonlyArray<Maybe<ConnectActivityEdge>>>;
  /** A list of nodes. */
  readonly nodes?: Maybe<ReadonlyArray<Maybe<ConnectActivity>>>;
  /** Information to aid in pagination. */
  readonly pageInfo: PageInfo;
  readonly totalCount: Scalars['Int'];
};

/** An edge in a connection. */
export type ConnectActivityEdge = {
  readonly __typename?: 'ConnectActivityEdge';
  /** A cursor for use in pagination. */
  readonly cursor: Scalars['String'];
  /** The item at the end of the edge. */
  readonly node?: Maybe<ConnectActivity>;
};

export enum ConnectActivityId {
  CHARGE_FAILED = 'charge_failed',
  CHARGE_SUCCEEDED = 'charge_succeeded',
  HOMEOWNER_EMAIL_OVERDUE_REMINDER_SENT = 'homeowner_email_overdue_reminder_sent',
  HOMEOWNER_EMAIL_REMINDER_SENT = 'homeowner_email_reminder_sent',
  HOMEOWNER_EMAIL_SENT = 'homeowner_email_sent',
  HOMEOWNER_MANUAL_EMAIL_REMINDER_SENT = 'homeowner_manual_email_reminder_sent',
  HOMEOWNER_MANUAL_TEXT_REMINDER_SENT = 'homeowner_manual_text_reminder_sent',
  HOMEOWNER_REQUESTED_ONLINE_PAYMENTS = 'homeowner_requested_online_payments',
  HOMEOWNER_TEXT_OVERDUE_REMINDER_SENT = 'homeowner_text_overdue_reminder_sent',
  HOMEOWNER_TEXT_REMINDER_SENT = 'homeowner_text_reminder_sent',
  HOMEOWNER_TEXT_SENT = 'homeowner_text_sent',
  HOMEOWNER_VIEWED_AT = 'homeowner_viewed_at',
  INVOICE_CREATED = 'invoice_created',
  INVOICE_FINALIZED = 'invoice_finalized',
  INVOICE_MANUALLY_PAID = 'invoice_manually_paid',
  INVOICE_PAID = 'invoice_paid',
  INVOICE_PAYMENT_CANCELLED = 'invoice_payment_cancelled',
  INVOICE_PAYMENT_FAILED = 'invoice_payment_failed',
  INVOICE_QUICKBOOKS_SYNCED = 'invoice_quickbooks_synced',
  PAYMENT_COLLECTED = 'payment_collected',
  PAYMENT_DECLINED = 'payment_declined',
  PAYMENT_INITIATED = 'payment_initiated',
  PAYMENT_REQUEST_SCHEDULED = 'payment_request_scheduled',
  PAYMENT_REQUEST_SENT = 'payment_request_sent',
  REFUND_FAILED = 'refund_failed',
  REFUND_INITIATED = 'refund_initiated',
  REFUND_PENDING = 'refund_pending'
}

/** Invoice object for payment requests */
export type ConnectInvoice = {
  readonly __typename?: 'ConnectInvoice';
  readonly achEnabled: Scalars['Boolean'];
  /** Calculated ACH payment fee */
  readonly achFee: Scalars['Int'];
  readonly amountRequested: Scalars['Int'];
  readonly cancelled: Scalars['Boolean'];
  readonly cardEnabled: Scalars['Boolean'];
  /** Calculated card payment fee */
  readonly cardFee: Scalars['Int'];
  readonly chargedAmount?: Maybe<Scalars['Int']>;
  readonly contractor: Contractor;
  /** Fee the contractor paid after the payment completed */
  readonly contractorFeeAmount?: Maybe<Scalars['Int']>;
  readonly createdAt: Scalars['ISO8601DateTime'];
  readonly creditCardEnabled: Scalars['Boolean'];
  readonly customerPaysAchFee: Scalars['Boolean'];
  readonly customerPaysCardFee: Scalars['Boolean'];
  readonly customizedInvoiceTemplate?: Maybe<CustomizedInvoiceTemplate>;
  readonly debitCardEnabled: Scalars['Boolean'];
  /** Calculated debit card payment fee */
  readonly debitCardFee: Scalars['Int'];
  readonly description: Scalars['String'];
  readonly dueDate?: Maybe<Scalars['ISO8601DateTime']>;
  readonly email: Scalars['String'];
  readonly firstName: Scalars['String'];
  readonly fullName: Scalars['String'];
  readonly hasAttachments: Scalars['Boolean'];
  readonly homeowner: Homeowner;
  /** Calculated ACH fee if customer pays the fee */
  readonly homeownerAchFee: Scalars['Int'];
  /** Calculated card fee if customer pays the fee */
  readonly homeownerCardFee: Scalars['Int'];
  /** Debit card fee, always $0 by state law */
  readonly homeownerDebitCardFee: Scalars['Int'];
  /** Fee the homeowner paid after the payment completed */
  readonly homeownerFeeAmount?: Maybe<Scalars['Int']>;
  readonly id: Scalars['ID'];
  readonly includesFinancing?: Maybe<Scalars['Boolean']>;
  readonly initialStatus: ConnectInvoiceStatus;
  readonly initiatedRefunds: ConnectRefundConnection;
  /** All attachments for a Connect Invoice */
  readonly invoiceAttachments: InvoiceAttachmentConnection;
  readonly invoiceNumber: Scalars['Int'];
  readonly invoiceSentFrom?: Maybe<ConnectInvoiceOrigin>;
  readonly lastName: Scalars['String'];
  readonly lastRefundedAt?: Maybe<Scalars['ISO8601DateTime']>;
  readonly manuallyPaid: Scalars['Boolean'];
  readonly onlinePaymentsRequested: Scalars['Boolean'];
  readonly organization: Organization;
  readonly outstandingInvoiceNumber?: Maybe<Scalars['Int']>;
  readonly paid: Scalars['Boolean'];
  readonly paidAt?: Maybe<Scalars['ISO8601DateTime']>;
  readonly paidWith?: Maybe<ConnectInvoicePayment>;
  readonly paidWithCardType?: Maybe<StripeChargeCard>;
  readonly paymentsCapabilityStatus?: Maybe<PaymentsCapabilityStatus>;
  readonly personalNote?: Maybe<Scalars['String']>;
  readonly phoneNumber: Scalars['String'];
  readonly plaidAccount?: Maybe<PlaidAccount>;
  readonly plaidLinkToken?: Maybe<Scalars['String']>;
  readonly postRefundAmount: Scalars['Int'];
  readonly refundableAmount?: Maybe<Scalars['Int']>;
  readonly refundedAmount?: Maybe<Scalars['Int']>;
  readonly requirePaymentMethod: Scalars['Boolean'];
  readonly scheduledFor?: Maybe<Scalars['ISO8601DateTime']>;
  readonly sentAt?: Maybe<Scalars['ISO8601DateTime']>;
  readonly status: ConnectInvoiceStatus;
  readonly statusLabel: Scalars['String'];
  readonly syncedToQuickbooks: Scalars['Boolean'];
  readonly viewableActivities: ConnectActivityConnection;
};


/** Invoice object for payment requests */
export type ConnectInvoiceInitiatedRefundsArgs = {
  after?: Maybe<Scalars['String']>;
  before?: Maybe<Scalars['String']>;
  first?: Maybe<Scalars['Int']>;
  last?: Maybe<Scalars['Int']>;
};


/** Invoice object for payment requests */
export type ConnectInvoiceInvoiceAttachmentsArgs = {
  after?: Maybe<Scalars['String']>;
  before?: Maybe<Scalars['String']>;
  first?: Maybe<Scalars['Int']>;
  last?: Maybe<Scalars['Int']>;
};


/** Invoice object for payment requests */
export type ConnectInvoiceViewableActivitiesArgs = {
  after?: Maybe<Scalars['String']>;
  before?: Maybe<Scalars['String']>;
  first?: Maybe<Scalars['Int']>;
  last?: Maybe<Scalars['Int']>;
};

/** The connection type for ConnectInvoice. */
export type ConnectInvoiceConnection = {
  readonly __typename?: 'ConnectInvoiceConnection';
  /** A list of edges. */
  readonly edges?: Maybe<ReadonlyArray<Maybe<ConnectInvoiceEdge>>>;
  /** A list of nodes. */
  readonly nodes?: Maybe<ReadonlyArray<Maybe<ConnectInvoice>>>;
  /** Information to aid in pagination. */
  readonly pageInfo: PageInfo;
  readonly totalCount: Scalars['Int'];
};

/** An edge in a connection. */
export type ConnectInvoiceEdge = {
  readonly __typename?: 'ConnectInvoiceEdge';
  /** A cursor for use in pagination. */
  readonly cursor: Scalars['String'];
  /** The item at the end of the edge. */
  readonly node?: Maybe<ConnectInvoice>;
};

export enum ConnectInvoiceOrigin {
  MOBILE_APP = 'MOBILE_APP',
  WEB_APP = 'WEB_APP'
}

/**
 * Parameters for creating a single connect invoice. Depending on the mutation,
 * some of the non-required fields may be overwritten
 */
export type ConnectInvoiceParams = {
  readonly achEnabled?: Maybe<Scalars['Boolean']>;
  readonly amountRequested: Scalars['Int'];
  readonly attachmentIds?: Maybe<ReadonlyArray<Scalars['String']>>;
  readonly creditCardEnabled?: Maybe<Scalars['Boolean']>;
  readonly customerPaysAchFee?: Maybe<Scalars['Boolean']>;
  readonly customerPaysCardFee?: Maybe<Scalars['Boolean']>;
  readonly debitCardEnabled?: Maybe<Scalars['Boolean']>;
  readonly description: Scalars['String'];
  readonly dueDate?: Maybe<Scalars['ISO8601DateTime']>;
  readonly personalNote?: Maybe<Scalars['String']>;
  readonly scheduledDate?: Maybe<Scalars['ISO8601DateTime']>;
  readonly sendAfterFund?: Maybe<Scalars['Boolean']>;
};

export enum ConnectInvoicePayment {
  ACH_DEBIT = 'ach_debit',
  CARD = 'card',
  CASH = 'cash',
  CHECK = 'check',
  OTHER = 'other'
}

export type ConnectInvoiceRequestOnlinePaymentsFailure = {
  readonly __typename?: 'ConnectInvoiceRequestOnlinePaymentsFailure';
  readonly errors: ReadonlyArray<Error>;
};

export type ConnectInvoiceRequestOnlinePaymentsResult = ConnectInvoiceRequestOnlinePaymentsFailure | ConnectInvoiceRequestOnlinePaymentsSuccess;

export type ConnectInvoiceRequestOnlinePaymentsSuccess = {
  readonly __typename?: 'ConnectInvoiceRequestOnlinePaymentsSuccess';
  readonly connectInvoice?: Maybe<ConnectInvoice>;
};

export enum ConnectInvoiceStatus {
  AWAITING_CONTRACT_SEND = 'awaiting_contract_send',
  CANCELLED = 'cancelled',
  COLLECTED = 'collected',
  CREATED = 'created',
  DECLINED = 'declined',
  MANUALLY_COLLECTED = 'manually_collected',
  PROCESSING = 'processing',
  SCHEDULED = 'scheduled',
  SCHEDULED_AFTER_FUND = 'scheduled_after_fund',
  SCHEDULED_AFTER_SIGNATURE = 'scheduled_after_signature'
}

/** A refund, u know money back to homeowner */
export type ConnectRefund = {
  readonly __typename?: 'ConnectRefund';
  readonly amount: Scalars['Int'];
  readonly description: Scalars['String'];
  readonly id: Scalars['ID'];
  readonly initiatedAt?: Maybe<Scalars['ISO8601DateTime']>;
};

/** The connection type for ConnectRefund. */
export type ConnectRefundConnection = {
  readonly __typename?: 'ConnectRefundConnection';
  /** A list of edges. */
  readonly edges?: Maybe<ReadonlyArray<Maybe<ConnectRefundEdge>>>;
  /** A list of nodes. */
  readonly nodes?: Maybe<ReadonlyArray<Maybe<ConnectRefund>>>;
  /** Information to aid in pagination. */
  readonly pageInfo: PageInfo;
  readonly totalCount: Scalars['Int'];
};

/** An edge in a connection. */
export type ConnectRefundEdge = {
  readonly __typename?: 'ConnectRefundEdge';
  /** A cursor for use in pagination. */
  readonly cursor: Scalars['String'];
  /** The item at the end of the edge. */
  readonly node?: Maybe<ConnectRefund>;
};

export enum ConnectRefundReason {
  DUPLICATE = 'duplicate',
  FRAUDULENT = 'fraudulent',
  REQUESTED_BY_CUSTOMER = 'requested_by_customer'
}

export type ConnectWistiaFailure = {
  readonly __typename?: 'ConnectWistiaFailure';
  readonly errors: ReadonlyArray<Error>;
};

export type ConnectWistiaResult = ConnectWistiaFailure | ConnectWistiaSuccess;

export type ConnectWistiaSuccess = {
  readonly __typename?: 'ConnectWistiaSuccess';
  readonly contractor?: Maybe<Contractor>;
};

export enum ContactMedium {
  /** To send something via an email */
  EMAIL = 'EMAIL',
  /** To send something via a text message */
  TEXT = 'TEXT'
}

/** Contentful */
export type Contentful = {
  readonly __typename?: 'Contentful';
  /** Returns a contentful article */
  readonly article?: Maybe<ContentfulArticle>;
  /** Returns sections based on group */
  readonly sections: ReadonlyArray<ContentfulSection>;
};


/** Contentful */
export type ContentfulArticleArgs = {
  id: Scalars['ID'];
};


/** Contentful */
export type ContentfulSectionsArgs = {
  group?: Maybe<ContentfulSectionGroup>;
};

/** Contentful article */
export type ContentfulArticle = {
  readonly __typename?: 'ContentfulArticle';
  readonly body: Scalars['JSON'];
  readonly id: Scalars['ID'];
  readonly subtitle?: Maybe<Scalars['String']>;
  readonly thumbnailUrl: Scalars['String'];
  readonly title: Scalars['String'];
};

/** Contentful section */
export type ContentfulSection = {
  readonly __typename?: 'ContentfulSection';
  readonly articles: ReadonlyArray<ContentfulArticle>;
  readonly id: Scalars['ID'];
  readonly subtitle?: Maybe<Scalars['String']>;
  readonly title: Scalars['String'];
};

export enum ContentfulSectionGroup {
  /** Lifecycles */
  LIFECYCLES = 'lifecycles',
  /** Resource Center */
  RESOURCE_CENTER_HOME = 'resource_center_home'
}

/** A contract */
export type Contract = {
  readonly __typename?: 'Contract';
  readonly id: Scalars['ID'];
  readonly text: Scalars['String'];
};

export type ContractGeneratorRestGeneratePdfInput = {
  readonly html: Scalars['String'];
};

export type ContractGeneratorRestGeneratePdfResult = {
  readonly __typename?: 'ContractGeneratorRestGeneratePdfResult';
  readonly pdf: Scalars['String'];
};

/** ContractServiceAccount in relation to a contract */
export type ContractServiceAccount = {
  readonly __typename?: 'ContractServiceAccount';
  readonly contractTemplates: ContractServiceContractTemplateConnection;
  /** All of the contracts associated with this Contract Service Account. */
  readonly contracts: ContractServiceContractConnection;
  readonly id: Scalars['ID'];
  /** Returns this accounts template type with the highest version number */
  readonly latestTemplateVersion?: Maybe<ContractServiceContractTemplate>;
  /** Returns the latest templates, grouped by version_name */
  readonly latestVersionContractTemplates?: Maybe<ContractServiceContractTemplateConnection>;
  readonly termsAgreed?: Maybe<Scalars['String']>;
  readonly termsAgreedAt?: Maybe<Scalars['ISO8601DateTime']>;
  /** Only contracts that should appear on an index page. */
  readonly visibleContracts: ContractServiceContractConnection;
};


/** ContractServiceAccount in relation to a contract */
export type ContractServiceAccountContractTemplatesArgs = {
  after?: Maybe<Scalars['String']>;
  before?: Maybe<Scalars['String']>;
  first?: Maybe<Scalars['Int']>;
  last?: Maybe<Scalars['Int']>;
};


/** ContractServiceAccount in relation to a contract */
export type ContractServiceAccountContractsArgs = {
  after?: Maybe<Scalars['String']>;
  before?: Maybe<Scalars['String']>;
  first?: Maybe<Scalars['Int']>;
  last?: Maybe<Scalars['Int']>;
};


/** ContractServiceAccount in relation to a contract */
export type ContractServiceAccountLatestTemplateVersionArgs = {
  type: ContractType;
};


/** ContractServiceAccount in relation to a contract */
export type ContractServiceAccountLatestVersionContractTemplatesArgs = {
  after?: Maybe<Scalars['String']>;
  before?: Maybe<Scalars['String']>;
  first?: Maybe<Scalars['Int']>;
  last?: Maybe<Scalars['Int']>;
};


/** ContractServiceAccount in relation to a contract */
export type ContractServiceAccountVisibleContractsArgs = {
  after?: Maybe<Scalars['String']>;
  before?: Maybe<Scalars['String']>;
  first?: Maybe<Scalars['Int']>;
  last?: Maybe<Scalars['Int']>;
};

export type ContractServiceAccountCreateFailure = {
  readonly __typename?: 'ContractServiceAccountCreateFailure';
  readonly errors: ReadonlyArray<Error>;
};

export type ContractServiceAccountCreateResult = ContractServiceAccountCreateFailure | ContractServiceAccountCreateSuccess;

export type ContractServiceAccountCreateSuccess = {
  readonly __typename?: 'ContractServiceAccountCreateSuccess';
  readonly contractServiceAccount: ContractServiceAccount;
};

/** Versioned base templates for the contract service */
export type ContractServiceBaseTemplate = {
  readonly __typename?: 'ContractServiceBaseTemplate';
  readonly id: Scalars['ID'];
  readonly template: Scalars['JSON'];
  readonly type: ContractType;
  readonly version: Scalars['Int'];
};

export type ContractServiceCancelContractFailure = {
  readonly __typename?: 'ContractServiceCancelContractFailure';
  readonly errors: ReadonlyArray<Error>;
};

export type ContractServiceCancelContractResult = ContractServiceCancelContractFailure | ContractServiceCancelContractSuccess;

export type ContractServiceCancelContractSuccess = {
  readonly __typename?: 'ContractServiceCancelContractSuccess';
  readonly contractServiceContract: ContractServiceContract;
};

/** ContractServiceContractType in relation to a contract */
export type ContractServiceContract = {
  readonly __typename?: 'ContractServiceContract';
  readonly amount?: Maybe<Scalars['Float']>;
  readonly attachedInvoice?: Maybe<ConnectInvoice>;
  readonly base64Pdf?: Maybe<Scalars['String']>;
  readonly contractNumber: Scalars['Int'];
  readonly createdAt: Scalars['ISO8601DateTime'];
  readonly creatorId?: Maybe<Scalars['ID']>;
  readonly dueDate: Scalars['ISO8601DateTime'];
  readonly helloSignId: Scalars['String'];
  readonly homeownerAddress?: Maybe<Scalars['String']>;
  readonly id: Scalars['ID'];
  readonly name: Scalars['String'];
  /**
   * Returns the homeowner for this contract, assuming it is of type
   * project_contract. Note this cannot yet be eager loaded, so it is best used in
   * the context of a show page.
   */
  readonly projectContractContractor?: Maybe<Contractor>;
  /**
   * Returns the homeowner for this contract, assuming it is of type
   * project_contract. Note this cannot yet be eager loaded, so it is best used in
   * the context of a show page.
   */
  readonly projectContractHomeowner?: Maybe<Homeowner>;
  /** Assuming there is only one receiver, returns it. Eager loaded for efficiency. */
  readonly receiverSignature: ContractServiceSignature;
  readonly renderedContract: Scalars['String'];
  /** Assuming there is only one sender, returns it. Eager loaded for efficiency. */
  readonly senderSignature: ContractServiceSignature;
  readonly signatures: ContractServiceSignatureConnection;
  readonly status: ContractStatus;
};


/** ContractServiceContractType in relation to a contract */
export type ContractServiceContractSignaturesArgs = {
  after?: Maybe<Scalars['String']>;
  before?: Maybe<Scalars['String']>;
  first?: Maybe<Scalars['Int']>;
  last?: Maybe<Scalars['Int']>;
};

/** The connection type for ContractServiceContract. */
export type ContractServiceContractConnection = {
  readonly __typename?: 'ContractServiceContractConnection';
  /** A list of edges. */
  readonly edges?: Maybe<ReadonlyArray<Maybe<ContractServiceContractEdge>>>;
  /** A list of nodes. */
  readonly nodes?: Maybe<ReadonlyArray<Maybe<ContractServiceContract>>>;
  /** Information to aid in pagination. */
  readonly pageInfo: PageInfo;
  readonly totalCount: Scalars['Int'];
};

/** An edge in a connection. */
export type ContractServiceContractEdge = {
  readonly __typename?: 'ContractServiceContractEdge';
  /** A cursor for use in pagination. */
  readonly cursor: Scalars['String'];
  /** The item at the end of the edge. */
  readonly node?: Maybe<ContractServiceContract>;
};

/** ContractServiceContractTemplateType in relation to a contract */
export type ContractServiceContractTemplate = {
  readonly __typename?: 'ContractServiceContractTemplate';
  readonly baseTemplate: ContractServiceBaseTemplate;
  readonly contractServiceAccount: ContractServiceAccount;
  readonly default?: Maybe<Scalars['Boolean']>;
  readonly editedBy?: Maybe<Scalars['ID']>;
  readonly editor?: Maybe<Contractor>;
  readonly id: Scalars['ID'];
  readonly template: Scalars['JSON'];
  readonly type: ContractType;
  readonly updatedAt: Scalars['ISO8601DateTime'];
  readonly version: Scalars['Int'];
  readonly versionDescription?: Maybe<Scalars['String']>;
  readonly versionName?: Maybe<Scalars['String']>;
};

/** The connection type for ContractServiceContractTemplate. */
export type ContractServiceContractTemplateConnection = {
  readonly __typename?: 'ContractServiceContractTemplateConnection';
  /** A list of edges. */
  readonly edges?: Maybe<ReadonlyArray<Maybe<ContractServiceContractTemplateEdge>>>;
  /** A list of nodes. */
  readonly nodes?: Maybe<ReadonlyArray<Maybe<ContractServiceContractTemplate>>>;
  /** Information to aid in pagination. */
  readonly pageInfo: PageInfo;
  readonly totalCount: Scalars['Int'];
};

/** An edge in a connection. */
export type ContractServiceContractTemplateEdge = {
  readonly __typename?: 'ContractServiceContractTemplateEdge';
  /** A cursor for use in pagination. */
  readonly cursor: Scalars['String'];
  /** The item at the end of the edge. */
  readonly node?: Maybe<ContractServiceContractTemplate>;
};

export type ContractServiceCreateContractFailure = {
  readonly __typename?: 'ContractServiceCreateContractFailure';
  readonly errors: ReadonlyArray<Error>;
};

export type ContractServiceCreateContractResult = ContractServiceCreateContractFailure | ContractServiceCreateContractSuccess;

export type ContractServiceCreateContractSuccess = {
  readonly __typename?: 'ContractServiceCreateContractSuccess';
  readonly attachedInvoice?: Maybe<ConnectInvoice>;
  readonly contractServiceContract: ContractServiceContract;
  readonly contractorSignature: ContractServiceSignature;
  readonly contractorSignatureToken: Scalars['String'];
};

export type ContractServiceMarkDefaultTemplateFailure = {
  readonly __typename?: 'ContractServiceMarkDefaultTemplateFailure';
  readonly errors: ReadonlyArray<Error>;
};

export type ContractServiceMarkDefaultTemplateResult = ContractServiceMarkDefaultTemplateFailure | ContractServiceMarkDefaultTemplateSuccess;

export type ContractServiceMarkDefaultTemplateSuccess = {
  readonly __typename?: 'ContractServiceMarkDefaultTemplateSuccess';
  readonly contractServiceContractTemplate: ContractServiceContractTemplate;
};

export type ContractServiceResendProjectContractFailure = {
  readonly __typename?: 'ContractServiceResendProjectContractFailure';
  readonly errors: ReadonlyArray<Error>;
};

export type ContractServiceResendProjectContractResult = ContractServiceResendProjectContractFailure | ContractServiceResendProjectContractSuccess;

export type ContractServiceResendProjectContractSuccess = {
  readonly __typename?: 'ContractServiceResendProjectContractSuccess';
  readonly contractServiceContract: ContractServiceContract;
};

export type ContractServiceSignTermsFailure = {
  readonly __typename?: 'ContractServiceSignTermsFailure';
  readonly errors: ReadonlyArray<Error>;
};

export type ContractServiceSignTermsResult = ContractServiceSignTermsFailure | ContractServiceSignTermsSuccess;

export type ContractServiceSignTermsSuccess = {
  readonly __typename?: 'ContractServiceSignTermsSuccess';
  readonly contractServiceAccount: ContractServiceAccount;
};

/** ContractServiceSignature in relation to a contract */
export type ContractServiceSignature = {
  readonly __typename?: 'ContractServiceSignature';
  readonly contract: ContractServiceContract;
  readonly contractServiceContract: ContractServiceContract;
  readonly contractServiceSigner: ContractServiceSigner;
  readonly email?: Maybe<Scalars['String']>;
  readonly fullName?: Maybe<Scalars['String']>;
  readonly helloSignId: Scalars['String'];
  readonly id: Scalars['ID'];
  readonly lastSeenAt: Scalars['ISO8601DateTime'];
  readonly requestedAt: Scalars['ISO8601DateTime'];
  readonly role: SignatureRole;
  readonly signedAt: Scalars['ISO8601DateTime'];
  readonly signer: ContractServiceSigner;
  readonly status: SignatureStatus;
};

/** The connection type for ContractServiceSignature. */
export type ContractServiceSignatureConnection = {
  readonly __typename?: 'ContractServiceSignatureConnection';
  /** A list of edges. */
  readonly edges?: Maybe<ReadonlyArray<Maybe<ContractServiceSignatureEdge>>>;
  /** A list of nodes. */
  readonly nodes?: Maybe<ReadonlyArray<Maybe<ContractServiceSignature>>>;
  /** Information to aid in pagination. */
  readonly pageInfo: PageInfo;
  readonly totalCount: Scalars['Int'];
};

/** An edge in a connection. */
export type ContractServiceSignatureEdge = {
  readonly __typename?: 'ContractServiceSignatureEdge';
  /** A cursor for use in pagination. */
  readonly cursor: Scalars['String'];
  /** The item at the end of the edge. */
  readonly node?: Maybe<ContractServiceSignature>;
};

/** ContractServiceSigner attributes */
export type ContractServiceSigner = {
  readonly __typename?: 'ContractServiceSigner';
  readonly email: Scalars['String'];
  readonly fullName: Scalars['String'];
  readonly homeowner?: Maybe<Homeowner>;
  readonly id: Scalars['ID'];
};

export type ContractServiceSigningLinkFetchFailure = {
  readonly __typename?: 'ContractServiceSigningLinkFetchFailure';
  readonly errors: ReadonlyArray<Error>;
};

export type ContractServiceSigningLinkFetchResult = ContractServiceSigningLinkFetchFailure | ContractServiceSigningLinkFetchSuccess;

export type ContractServiceSigningLinkFetchSuccess = {
  readonly __typename?: 'ContractServiceSigningLinkFetchSuccess';
  readonly contractServiceSignature: ContractServiceSignature;
  readonly signatureLink: Scalars['String'];
};

export type ContractServiceTemplateDeleteByNameFailure = {
  readonly __typename?: 'ContractServiceTemplateDeleteByNameFailure';
  readonly errors: ReadonlyArray<Error>;
};

export type ContractServiceTemplateDeleteByNameResult = ContractServiceTemplateDeleteByNameFailure | ContractServiceTemplateDeleteByNameSuccess;

export type ContractServiceTemplateDeleteByNameSuccess = {
  readonly __typename?: 'ContractServiceTemplateDeleteByNameSuccess';
  readonly contractServiceContractTemplateVersionName: Scalars['String'];
};

export type ContractServiceTemplateDeleteFailure = {
  readonly __typename?: 'ContractServiceTemplateDeleteFailure';
  readonly errors: ReadonlyArray<Error>;
};

export type ContractServiceTemplateDeleteResult = ContractServiceTemplateDeleteFailure | ContractServiceTemplateDeleteSuccess;

export type ContractServiceTemplateDeleteSuccess = {
  readonly __typename?: 'ContractServiceTemplateDeleteSuccess';
  readonly contractServiceContractTemplate?: Maybe<ContractServiceContractTemplate>;
};

export type ContractServiceTemplateUpsertFailure = {
  readonly __typename?: 'ContractServiceTemplateUpsertFailure';
  readonly errors: ReadonlyArray<Error>;
};

export type ContractServiceTemplateUpsertResult = ContractServiceTemplateUpsertFailure | ContractServiceTemplateUpsertSuccess;

export type ContractServiceTemplateUpsertSuccess = {
  readonly __typename?: 'ContractServiceTemplateUpsertSuccess';
  readonly contractServiceContractTemplate: ContractServiceContractTemplate;
};

export type ContractServiceTemplateVersionUpsertFailure = {
  readonly __typename?: 'ContractServiceTemplateVersionUpsertFailure';
  readonly errors: ReadonlyArray<Error>;
};

export type ContractServiceTemplateVersionUpsertResult = ContractServiceTemplateVersionUpsertFailure | ContractServiceTemplateVersionUpsertSuccess;

export type ContractServiceTemplateVersionUpsertSuccess = {
  readonly __typename?: 'ContractServiceTemplateVersionUpsertSuccess';
  readonly contractServiceContractTemplate: ContractServiceContractTemplate;
};

export enum ContractStatus {
  AWAITING_PRE_SEND_SIGNATURE = 'awaiting_pre_send_signature',
  CANCELED = 'canceled',
  PRE_SIGNED = 'pre_signed',
  SENT = 'sent',
  SIGNED = 'signed',
  SIGNED_BY_SENDERS = 'signed_by_senders'
}

export type ContractTemplateParams = {
  readonly baseTemplateId?: Maybe<Scalars['String']>;
  readonly template: Scalars['JSON'];
  readonly type: ContractType;
};

export type ContractTemplateVersioningParams = {
  readonly baseTemplateId?: Maybe<Scalars['String']>;
  readonly editedBy: Scalars['ID'];
  readonly id?: Maybe<Scalars['ID']>;
  readonly template?: Maybe<Scalars['JSON']>;
  readonly type: ContractType;
  readonly versionDescription?: Maybe<Scalars['String']>;
  readonly versionName?: Maybe<Scalars['String']>;
};

export enum ContractType {
  PROJECT_CONTRACT = 'project_contract'
}

/** Come on, you know what a contractor is */
export type Contractor = {
  readonly __typename?: 'Contractor';
  readonly activeCustomizedInvoiceTemplate?: Maybe<CustomizedInvoiceTemplate>;
  readonly admin: Scalars['Boolean'];
  readonly affiliateReferralCode?: Maybe<Scalars['String']>;
  readonly affiliateUrl?: Maybe<Scalars['String']>;
  readonly appVersion?: Maybe<Scalars['String']>;
  readonly articleInteractions: ArticleInteractionConnection;
  readonly authorizedViewableConnectInvoices: ConnectInvoiceConnection;
  readonly bannerInstalledAt?: Maybe<Scalars['ISO8601DateTime']>;
  readonly calendlyCancelLink?: Maybe<Scalars['String']>;
  readonly contractorReminderSettings: ReadonlyArray<ReminderSetting>;
  readonly createdAt: Scalars['ISO8601DateTime'];
  readonly currentDeviceId?: Maybe<Scalars['String']>;
  readonly customSettings: CustomContractorSettings;
  readonly customizedInvoiceTemplates: CustomizedInvoiceTemplateConnection;
  readonly defaultSuggestedActions: SuggestedActionConnection;
  readonly demoMode: Scalars['Boolean'];
  readonly demoModeSetAt?: Maybe<Scalars['ISO8601DateTime']>;
  readonly email: Scalars['String'];
  readonly emailNotifications: Scalars['Boolean'];
  readonly emailSignatureAdditionalText?: Maybe<Scalars['String']>;
  readonly emailSignatureClosing?: Maybe<Scalars['String']>;
  readonly emailSignatureCompanyEmail?: Maybe<Scalars['Boolean']>;
  readonly emailSignatureCompanyName?: Maybe<Scalars['Boolean']>;
  readonly emailSignatureCompanyPhone?: Maybe<Scalars['Boolean']>;
  readonly emailSignatureCompanyWebsite?: Maybe<Scalars['Boolean']>;
  readonly emailSignatureLogo?: Maybe<Scalars['Boolean']>;
  readonly emailSignaturePersonalEmail?: Maybe<Scalars['Boolean']>;
  readonly emailSignaturePersonalPhone?: Maybe<Scalars['Boolean']>;
  readonly emailTemplate: Template;
  readonly emailTemplateId: Scalars['String'];
  readonly enterpriseAdmin: Scalars['Boolean'];
  readonly enterpriseOrgs?: Maybe<OrganizationConnection>;
  readonly facebookUrl?: Maybe<Scalars['String']>;
  readonly featureFlags: ReadonlyArray<FeatureFlag>;
  readonly firstAppLoginAt?: Maybe<Scalars['ISO8601DateTime']>;
  readonly firstConnectInvoiceSent?: Maybe<Scalars['ISO8601DateTime']>;
  readonly firstContractSent?: Maybe<Scalars['ISO8601DateTime']>;
  readonly firstFundDate?: Maybe<Scalars['ISO8601DateTime']>;
  readonly firstMemberInviteSent?: Maybe<Scalars['ISO8601DateTime']>;
  readonly firstName: Scalars['String'];
  readonly firstPasswordSetAt?: Maybe<Scalars['ISO8601DateTime']>;
  readonly firstQuoteSent?: Maybe<Scalars['ISO8601DateTime']>;
  readonly firstUnblockedAt?: Maybe<Scalars['ISO8601DateTime']>;
  readonly firstVisit: Scalars['Boolean'];
  readonly fullName: Scalars['String'];
  readonly fullUrl: Scalars['String'];
  readonly fundedAmount: Scalars['Int'];
  readonly fundedCount: Scalars['Int'];
  readonly hasClientNotifications: Scalars['Boolean'];
  readonly hasEditedCustomizedInvoiceTemplate: Scalars['Boolean'];
  readonly hasHomeownerFeedback: Scalars['Boolean'];
  readonly hasSeenGraduationScreen: Scalars['Boolean'];
  readonly hearthEvents: HearthEventConnection;
  readonly hearthRewardsPaymentsVolume: Scalars['Int'];
  readonly hearthUid: Scalars['String'];
  readonly hidePaymentsTab: Scalars['Boolean'];
  readonly homeownerFeedback: ContractorFeedback;
  readonly homeownerFinancingFeedback: HomeownerFeedbackResponseConnection;
  readonly homeownerFinancingFeedbackMetrics: HomeownerFinancingFeedbackMetrics;
  readonly homeownerPaymentsFeedback: HomeownerFeedbackResponseConnection;
  readonly homeownerPaymentsFeedbackMetrics: HomeownerPaymentsFeedbackMetrics;
  readonly homeownerReminderSettings: ReadonlyArray<ReminderSetting>;
  readonly homeowners: ContractorHomeownerConnection;
  readonly homeownersByFinancingStatus: ContractorHomeownerConnection;
  readonly id: Scalars['ID'];
  readonly instagram?: Maybe<Scalars['String']>;
  readonly lastName: Scalars['String'];
  readonly lastPayoutAt?: Maybe<Scalars['ISO8601DateTime']>;
  readonly lastSignInAt?: Maybe<Scalars['ISO8601DateTime']>;
  readonly leadsCount: Scalars['Int'];
  /** Lifecycle used for recommended articles on the Learn Center Screen */
  readonly learnCenterLifecycle: LearnCenterLifecycle;
  readonly linkedinUrl?: Maybe<Scalars['String']>;
  readonly loanInquiries: LoanInquiryConnection;
  readonly magicLoginLink: Scalars['String'];
  readonly manualEntry: Scalars['Boolean'];
  readonly needsMoreTraining: Scalars['Boolean'];
  readonly notifications: NotificationConnection;
  readonly onboarded: Scalars['Boolean'];
  readonly onboardedAt?: Maybe<Scalars['ISO8601DateTime']>;
  readonly organization: Organization;
  readonly outstandingPaymentsAmount: Scalars['Int'];
  readonly overduePaymentsAmount: Scalars['Int'];
  readonly paidConnectInvoices: ConnectInvoiceConnection;
  readonly paidPaymentsAmount: Scalars['Int'];
  readonly passwordSet: Scalars['Boolean'];
  readonly paymentReminders: Scalars['Boolean'];
  readonly paymentsAdmin: Scalars['Boolean'];
  readonly paymentsRole: PaymentsRole;
  readonly payoutCount?: Maybe<Scalars['Int']>;
  readonly phoneNumber: Scalars['String'];
  readonly profileCompletedAt?: Maybe<Scalars['ISO8601DateTime']>;
  readonly pushNotifications: Scalars['Boolean'];
  readonly quickPollResponse?: Maybe<QuestionnaireResponse>;
  readonly quickbooksOauthLink?: Maybe<Scalars['String']>;
  readonly reminderSettings: ReminderSettingConnection;
  readonly role: Scalars['String'];
  readonly sendFinancingLinkTemplate: Template;
  readonly settings: Scalars['JSON'];
  readonly setupFlowAddTeamMembers?: Maybe<Scalars['Boolean']>;
  readonly setupFlowAppLoginLater?: Maybe<Scalars['Boolean']>;
  readonly setupFlowInstallBanners?: Maybe<Scalars['Boolean']>;
  readonly setupFlowInstallBannersLater?: Maybe<Scalars['Boolean']>;
  readonly setupFlowInviteTeamLater?: Maybe<Scalars['Boolean']>;
  readonly setupFlowTextLinkSent?: Maybe<Scalars['Boolean']>;
  readonly setupFlowWatchArticleVideo?: Maybe<Scalars['Boolean']>;
  readonly setupFlowWatchArticleVideoLater?: Maybe<Scalars['Boolean']>;
  readonly signInCount: Scalars['Int'];
  readonly signatureTemplate: Template;
  readonly status: ContractorStatus;
  readonly suggestedActions: SuggestedActionConnection;
  readonly suggestedActionsComplete: Scalars['Boolean'];
  readonly textNotifications: Scalars['Boolean'];
  /** @deprecated Use `send_financing_link_template` instead */
  readonly textTemplate: Template;
  /** @deprecated Use `send_financing_link_template` instead */
  readonly textTemplateId: Scalars['String'];
  readonly trainingCompleted: Scalars['Boolean'];
  readonly trainingScheduled: Scalars['Boolean'];
  readonly trainingScheduledAt?: Maybe<Scalars['ISO8601DateTime']>;
  readonly trainingSessionId?: Maybe<Scalars['String']>;
  readonly trainingTime?: Maybe<Scalars['ISO8601DateTime']>;
  readonly trainingVideoWatchedAt?: Maybe<Scalars['ISO8601DateTime']>;
  readonly tryPaymentsSeen: Scalars['Boolean'];
  readonly twitterUrl?: Maybe<Scalars['String']>;
  readonly unpaidPaymentsAmount: Scalars['Int'];
  readonly upcomingWebinars: HearthEventConnection;
  readonly urlPath: Scalars['String'];
  readonly uuid: Scalars['String'];
  readonly vertical: Scalars['String'];
  readonly visibleConnectInvoices: ConnectInvoiceConnection;
  readonly walkthroughPaymentFlags: WalkthroughPaymentFlags;
  readonly webinarRedirectLink: Scalars['String'];
  readonly weeklyQualifiedVolume?: Maybe<Scalars['String']>;
};


/** Come on, you know what a contractor is */
export type ContractorArticleInteractionsArgs = {
  after?: Maybe<Scalars['String']>;
  before?: Maybe<Scalars['String']>;
  first?: Maybe<Scalars['Int']>;
  last?: Maybe<Scalars['Int']>;
};


/** Come on, you know what a contractor is */
export type ContractorAuthorizedViewableConnectInvoicesArgs = {
  after?: Maybe<Scalars['String']>;
  before?: Maybe<Scalars['String']>;
  first?: Maybe<Scalars['Int']>;
  last?: Maybe<Scalars['Int']>;
};


/** Come on, you know what a contractor is */
export type ContractorCustomizedInvoiceTemplatesArgs = {
  after?: Maybe<Scalars['String']>;
  before?: Maybe<Scalars['String']>;
  first?: Maybe<Scalars['Int']>;
  last?: Maybe<Scalars['Int']>;
};


/** Come on, you know what a contractor is */
export type ContractorDefaultSuggestedActionsArgs = {
  after?: Maybe<Scalars['String']>;
  before?: Maybe<Scalars['String']>;
  first?: Maybe<Scalars['Int']>;
  last?: Maybe<Scalars['Int']>;
};


/** Come on, you know what a contractor is */
export type ContractorEnterpriseOrgsArgs = {
  after?: Maybe<Scalars['String']>;
  before?: Maybe<Scalars['String']>;
  first?: Maybe<Scalars['Int']>;
  last?: Maybe<Scalars['Int']>;
};


/** Come on, you know what a contractor is */
export type ContractorHearthEventsArgs = {
  after?: Maybe<Scalars['String']>;
  before?: Maybe<Scalars['String']>;
  eventTypes?: Maybe<ReadonlyArray<HearthEventEventTypes>>;
  first?: Maybe<Scalars['Int']>;
  last?: Maybe<Scalars['Int']>;
};


/** Come on, you know what a contractor is */
export type ContractorHomeownerFinancingFeedbackArgs = {
  after?: Maybe<Scalars['String']>;
  before?: Maybe<Scalars['String']>;
  first?: Maybe<Scalars['Int']>;
  last?: Maybe<Scalars['Int']>;
};


/** Come on, you know what a contractor is */
export type ContractorHomeownerPaymentsFeedbackArgs = {
  after?: Maybe<Scalars['String']>;
  before?: Maybe<Scalars['String']>;
  first?: Maybe<Scalars['Int']>;
  last?: Maybe<Scalars['Int']>;
};


/** Come on, you know what a contractor is */
export type ContractorHomeownersArgs = {
  after?: Maybe<Scalars['String']>;
  before?: Maybe<Scalars['String']>;
  first?: Maybe<Scalars['Int']>;
  last?: Maybe<Scalars['Int']>;
  limit?: Maybe<Scalars['Int']>;
  teamView?: Maybe<Scalars['Boolean']>;
};


/** Come on, you know what a contractor is */
export type ContractorHomeownersByFinancingStatusArgs = {
  after?: Maybe<Scalars['String']>;
  before?: Maybe<Scalars['String']>;
  first?: Maybe<Scalars['Int']>;
  last?: Maybe<Scalars['Int']>;
  statuses: ReadonlyArray<HomeownerFinancingStatus>;
};


/** Come on, you know what a contractor is */
export type ContractorLoanInquiriesArgs = {
  after?: Maybe<Scalars['String']>;
  before?: Maybe<Scalars['String']>;
  first?: Maybe<Scalars['Int']>;
  last?: Maybe<Scalars['Int']>;
};


/** Come on, you know what a contractor is */
export type ContractorMagicLoginLinkArgs = {
  noPasswordSet?: Maybe<Scalars['Boolean']>;
  webOnly?: Maybe<Scalars['Boolean']>;
};


/** Come on, you know what a contractor is */
export type ContractorNotificationsArgs = {
  after?: Maybe<Scalars['String']>;
  before?: Maybe<Scalars['String']>;
  first?: Maybe<Scalars['Int']>;
  last?: Maybe<Scalars['Int']>;
  status?: Maybe<ContractorNotificationStatus>;
};


/** Come on, you know what a contractor is */
export type ContractorPaidConnectInvoicesArgs = {
  after?: Maybe<Scalars['String']>;
  before?: Maybe<Scalars['String']>;
  first?: Maybe<Scalars['Int']>;
  last?: Maybe<Scalars['Int']>;
};


/** Come on, you know what a contractor is */
export type ContractorQuickbooksOauthLinkArgs = {
  finalRedirectUrl?: Maybe<Scalars['String']>;
};


/** Come on, you know what a contractor is */
export type ContractorReminderSettingsArgs = {
  after?: Maybe<Scalars['String']>;
  before?: Maybe<Scalars['String']>;
  first?: Maybe<Scalars['Int']>;
  last?: Maybe<Scalars['Int']>;
};


/** Come on, you know what a contractor is */
export type ContractorSuggestedActionsArgs = {
  after?: Maybe<Scalars['String']>;
  before?: Maybe<Scalars['String']>;
  first?: Maybe<Scalars['Int']>;
  last?: Maybe<Scalars['Int']>;
  scope?: Maybe<SuggestedActionScopeType>;
  type?: Maybe<SuggestedActionActionType>;
};


/** Come on, you know what a contractor is */
export type ContractorUpcomingWebinarsArgs = {
  after?: Maybe<Scalars['String']>;
  before?: Maybe<Scalars['String']>;
  first?: Maybe<Scalars['Int']>;
  last?: Maybe<Scalars['Int']>;
};


/** Come on, you know what a contractor is */
export type ContractorVisibleConnectInvoicesArgs = {
  after?: Maybe<Scalars['String']>;
  before?: Maybe<Scalars['String']>;
  first?: Maybe<Scalars['Int']>;
  last?: Maybe<Scalars['Int']>;
  origin?: Maybe<ConnectInvoiceOrigin>;
};

/** An input type for updating a contractor */
export type ContractorAttributes = {
  readonly appVersion?: Maybe<Scalars['String']>;
  readonly demoMode?: Maybe<Scalars['Boolean']>;
  readonly email?: Maybe<Scalars['String']>;
  readonly emailNotifications?: Maybe<Scalars['Boolean']>;
  readonly emailSignatureAdditionalText?: Maybe<Scalars['String']>;
  readonly emailSignatureClosing?: Maybe<Scalars['String']>;
  readonly emailSignatureCompanyEmail?: Maybe<Scalars['Boolean']>;
  readonly emailSignatureCompanyName?: Maybe<Scalars['Boolean']>;
  readonly emailSignatureCompanyPhone?: Maybe<Scalars['Boolean']>;
  readonly emailSignatureCompanyWebsite?: Maybe<Scalars['Boolean']>;
  readonly emailSignatureLogo?: Maybe<Scalars['Boolean']>;
  readonly emailSignaturePersonalEmail?: Maybe<Scalars['Boolean']>;
  readonly emailSignaturePersonalPhone?: Maybe<Scalars['Boolean']>;
  readonly firstName?: Maybe<Scalars['String']>;
  readonly firstPasswordSetAt?: Maybe<Scalars['ISO8601DateTime']>;
  readonly hidePaymentsTab?: Maybe<Scalars['Boolean']>;
  readonly insuranceInquiryRequestMethod?: Maybe<Scalars['String']>;
  readonly insuranceSidebarTooltipSeen?: Maybe<Scalars['Boolean']>;
  readonly lastName?: Maybe<Scalars['String']>;
  readonly onboarded?: Maybe<Scalars['Boolean']>;
  readonly password?: Maybe<Scalars['String']>;
  readonly passwordConfirmation?: Maybe<Scalars['String']>;
  readonly paymentReminders?: Maybe<Scalars['Boolean']>;
  readonly paymentsClientsTabTooltipSeen?: Maybe<Scalars['Boolean']>;
  readonly paymentsIndexTooltipSeen?: Maybe<Scalars['Boolean']>;
  readonly paymentsRole?: Maybe<PaymentsRole>;
  readonly phoneNumber?: Maybe<Scalars['String']>;
  readonly setupFlowAddTeamMembers?: Maybe<Scalars['Boolean']>;
  readonly setupFlowAppLoginLater?: Maybe<Scalars['Boolean']>;
  readonly setupFlowInstallBanners?: Maybe<Scalars['Boolean']>;
  readonly setupFlowInstallBannersLater?: Maybe<Scalars['Boolean']>;
  readonly setupFlowInviteTeamLater?: Maybe<Scalars['Boolean']>;
  readonly setupFlowTextLinkSent?: Maybe<Scalars['Boolean']>;
  readonly setupFlowWatchArticleVideo?: Maybe<Scalars['Boolean']>;
  readonly setupFlowWatchArticleVideoLater?: Maybe<Scalars['Boolean']>;
  readonly textNotifications?: Maybe<Scalars['Boolean']>;
  readonly trainingCompleted?: Maybe<Scalars['Boolean']>;
  readonly trainingVideoWatchedAt?: Maybe<Scalars['ISO8601DateTime']>;
  readonly tryPaymentsSeen?: Maybe<Scalars['Boolean']>;
  readonly tryPaymentsSeenWeb?: Maybe<Scalars['Boolean']>;
};

/** The connection type for Contractor. */
export type ContractorConnection = {
  readonly __typename?: 'ContractorConnection';
  /** A list of edges. */
  readonly edges?: Maybe<ReadonlyArray<Maybe<ContractorEdge>>>;
  /** A list of nodes. */
  readonly nodes?: Maybe<ReadonlyArray<Maybe<Contractor>>>;
  /** Information to aid in pagination. */
  readonly pageInfo: PageInfo;
  readonly totalCount: Scalars['Int'];
};

/** An edge in a connection. */
export type ContractorEdge = {
  readonly __typename?: 'ContractorEdge';
  /** A cursor for use in pagination. */
  readonly cursor: Scalars['String'];
  /** The item at the end of the edge. */
  readonly node?: Maybe<Contractor>;
};

/** Contractor feedback data from homeowner_feedback_responses */
export type ContractorFeedback = {
  readonly __typename?: 'ContractorFeedback';
  /** @deprecated Deprecated in favor of avg_financing_contractor_satisfaction */
  readonly avgContractorSatisfaction?: Maybe<Scalars['Float']>;
  /** @deprecated Deprecated in favor of avg_financing_contractor_satisfaction_difference */
  readonly avgContractorSatisfactionDifference?: Maybe<Scalars['Float']>;
  /** @deprecated Deprecated in favor of avg_financing_hearth_satisfaction */
  readonly avgHearthSatisfaction?: Maybe<Scalars['Float']>;
  /** @deprecated Deprecated in favor of avg_financing_hearth_satisfaction_differnce */
  readonly avgHearthSatisfactionDifference?: Maybe<Scalars['Float']>;
  readonly hasHomeownerFeedback: Scalars['Boolean'];
};

/** The connection type for Homeowner. */
export type ContractorHomeownerConnection = {
  readonly __typename?: 'ContractorHomeownerConnection';
  /** A list of edges. */
  readonly edges?: Maybe<ReadonlyArray<Maybe<ContractorHomeownerEdge>>>;
  /** A list of nodes. */
  readonly nodes?: Maybe<ReadonlyArray<Maybe<Homeowner>>>;
  /** Information to aid in pagination. */
  readonly pageInfo: PageInfo;
  readonly totalCount: Scalars['Int'];
};

/** An edge in a connection. */
export type ContractorHomeownerEdge = {
  readonly __typename?: 'ContractorHomeownerEdge';
  readonly archived: Scalars['Boolean'];
  /** A cursor for use in pagination. */
  readonly cursor: Scalars['String'];
  /** The item at the end of the edge. */
  readonly node?: Maybe<Homeowner>;
  readonly unseenUpdates: Scalars['Boolean'];
};

export enum ContractorNotificationStatus {
  /** Read */
  READ = 'read',
  /** Unread */
  UNREAD = 'unread'
}

export enum ContractorStatus {
  ACTIVE = 'active',
  INACTIVE = 'inactive',
  TRAINING_INCOMPLETE = 'training_incomplete'
}

export type CreateConnectInvoiceFailure = {
  readonly __typename?: 'CreateConnectInvoiceFailure';
  readonly errors: ReadonlyArray<Error>;
};

export type CreateConnectInvoiceResult = CreateConnectInvoiceFailure | CreateConnectInvoiceSuccess;

export type CreateConnectInvoiceSuccess = {
  readonly __typename?: 'CreateConnectInvoiceSuccess';
  readonly connectInvoice: ConnectInvoice;
};

export type CreateConnectPayoutFailure = {
  readonly __typename?: 'CreateConnectPayoutFailure';
  readonly errors: ReadonlyArray<Error>;
};

export type CreateConnectPayoutResult = CreateConnectPayoutFailure | CreateConnectPayoutSuccess;

export type CreateConnectPayoutSuccess = {
  readonly __typename?: 'CreateConnectPayoutSuccess';
  readonly amountInCents: Scalars['Int'];
  readonly stripePayouts: ReadonlyArray<Payout>;
};

export type CreateHomeownerAndSendFinancingInfoFailure = {
  readonly __typename?: 'CreateHomeownerAndSendFinancingInfoFailure';
  readonly errors: ReadonlyArray<Error>;
};

export type CreateHomeownerAndSendFinancingInfoResult = CreateHomeownerAndSendFinancingInfoFailure | CreateHomeownerAndSendFinancingInfoSuccess;

export type CreateHomeownerAndSendFinancingInfoSuccess = {
  readonly __typename?: 'CreateHomeownerAndSendFinancingInfoSuccess';
  readonly homeowner?: Maybe<Homeowner>;
};

/** Autogenerated return type of CreateHomeowner */
export type CreateHomeownerPayload = {
  readonly __typename?: 'CreateHomeownerPayload';
  readonly errors?: Maybe<ReadonlyArray<ValidationError>>;
  readonly homeowner?: Maybe<Homeowner>;
};

export type CreateInsightsFeedbackFailure = {
  readonly __typename?: 'CreateInsightsFeedbackFailure';
  readonly errors: ReadonlyArray<Error>;
};

export type CreateInsightsFeedbackResult = CreateInsightsFeedbackFailure | CreateInsightsFeedbackSuccess;

export type CreateInsightsFeedbackSuccess = {
  readonly __typename?: 'CreateInsightsFeedbackSuccess';
  readonly contractor: Contractor;
};

export type CreateLoanInquiryFromExistingFailure = {
  readonly __typename?: 'CreateLoanInquiryFromExistingFailure';
  readonly errors: ReadonlyArray<Error>;
};

export type CreateLoanInquiryFromExistingResult = CreateLoanInquiryFromExistingFailure | CreateLoanInquiryFromExistingSuccess;

export type CreateLoanInquiryFromExistingSuccess = {
  readonly __typename?: 'CreateLoanInquiryFromExistingSuccess';
  readonly loanInquiry: LoanInquiry;
};

export type CreateLoginLinkFailure = {
  readonly __typename?: 'CreateLoginLinkFailure';
  readonly errors: ReadonlyArray<Error>;
};

export type CreateLoginLinkResult = CreateLoginLinkFailure | CreateLoginLinkSuccess;

export type CreateLoginLinkSuccess = {
  readonly __typename?: 'CreateLoginLinkSuccess';
  readonly contractor: Contractor;
};

/** Autogenerated return type of CreateMagicLink */
export type CreateMagicLinkPayload = {
  readonly __typename?: 'CreateMagicLinkPayload';
  readonly contractor: Contractor;
  readonly errors?: Maybe<ReadonlyArray<ValidationError>>;
};

/** Autogenerated return type of CreateStripePayout */
export type CreateStripePayoutPayload = {
  readonly __typename?: 'CreateStripePayoutPayload';
  readonly amountInCents: Scalars['Int'];
  readonly errors?: Maybe<ReadonlyArray<ValidationError>>;
};

/** Contractors custom settings attributes */
export type CustomContractorSettings = {
  readonly __typename?: 'CustomContractorSettings';
  readonly clientViewViewByTooltipSeen: Scalars['Boolean'];
  readonly contractsPaintedDoorCardClicked: Scalars['Boolean'];
  readonly customizeInvoiceBannerDismissed: Scalars['Boolean'];
  readonly financingUnlockedHighlightSeen: Scalars['Boolean'];
  readonly financingUnlockedModalSeen: Scalars['Boolean'];
  readonly firstTemplateBannerDismissed: Scalars['Boolean'];
  readonly hearthCashPaintedDoorWaitlistJoined: Scalars['Boolean'];
  readonly hearthOnboardingModalSeen: Scalars['Boolean'];
  readonly highlightPaymentsOverlaySeenCount: Scalars['Int'];
  readonly insightsCalloutSeen: Scalars['Boolean'];
  readonly insuranceInquiryRequestMethod?: Maybe<Scalars['String']>;
  readonly insuranceSidebarTooltipSeen: Scalars['Boolean'];
  readonly newDashboardWelcomeModalSeen: Scalars['Boolean'];
  readonly paymentRewardsEarned: Scalars['Int'];
  readonly paymentsApprovalModalSeen: Scalars['Boolean'];
  readonly paymentsClientsTabTooltipSeen: Scalars['Boolean'];
  readonly paymentsIndexTooltipSeen: Scalars['Boolean'];
  readonly quickbooksBannerDismissed: Scalars['Boolean'];
  readonly rewardsAvailable: Scalars['Int'];
  readonly rewardsClaimed: Scalars['Int'];
  readonly sendNewProductTourSeen202201: Scalars['Boolean'];
  readonly showNewProductTour202201: Scalars['Boolean'];
  readonly tryPaymentsSeenWeb: Scalars['Boolean'];
};

/** An input type for custom contractor settings */
export type CustomContractorSettingsAttributes = {
  readonly clientViewViewByTooltipSeen?: Maybe<Scalars['Boolean']>;
  readonly contractsPaintedDoorCardClicked?: Maybe<Scalars['Boolean']>;
  readonly contractsWaitlistJoined?: Maybe<Scalars['Boolean']>;
  readonly customizeInvoiceBannerDismissed?: Maybe<Scalars['Boolean']>;
  readonly emailSignatureAdditionalText?: Maybe<Scalars['String']>;
  readonly emailSignatureClosing?: Maybe<Scalars['String']>;
  readonly emailSignatureCompanyEmail?: Maybe<Scalars['Boolean']>;
  readonly emailSignatureCompanyName?: Maybe<Scalars['Boolean']>;
  readonly emailSignatureCompanyPhone?: Maybe<Scalars['Boolean']>;
  readonly emailSignatureCompanyWebsite?: Maybe<Scalars['Boolean']>;
  readonly emailSignatureLogo?: Maybe<Scalars['Boolean']>;
  readonly emailSignaturePersonalEmail?: Maybe<Scalars['Boolean']>;
  readonly emailSignaturePersonalPhone?: Maybe<Scalars['Boolean']>;
  readonly financingUnlockedHighlightSeen?: Maybe<Scalars['Boolean']>;
  readonly financingUnlockedModalSeen?: Maybe<Scalars['Boolean']>;
  readonly firstPasswordSetAt?: Maybe<Scalars['ISO8601DateTime']>;
  readonly firstTemplateBannerDismissed?: Maybe<Scalars['Boolean']>;
  readonly hearthCashPaintedDoorWaitlistJoined?: Maybe<Scalars['Boolean']>;
  readonly hearthOnboardingModalSeen?: Maybe<Scalars['Boolean']>;
  readonly hidePaymentsTab?: Maybe<Scalars['Boolean']>;
  readonly highlightPaymentsOverlaySeenCount?: Maybe<Scalars['Int']>;
  readonly insightsCalloutSeen?: Maybe<Scalars['Boolean']>;
  readonly insuranceInquiryRequestMethod?: Maybe<Scalars['String']>;
  readonly insuranceSidebarTooltipSeen?: Maybe<Scalars['Boolean']>;
  readonly newDashboardWelcomeModalSeen?: Maybe<Scalars['Boolean']>;
  readonly paymentReminders?: Maybe<Scalars['Boolean']>;
  readonly paymentsApprovalModalSeen?: Maybe<Scalars['Boolean']>;
  readonly paymentsClientsTabTooltipSeen?: Maybe<Scalars['Boolean']>;
  readonly paymentsIndexTooltipSeen?: Maybe<Scalars['Boolean']>;
  readonly quickbooksBannerDismissed?: Maybe<Scalars['Boolean']>;
  readonly rewardsAvailable?: Maybe<Scalars['Int']>;
  readonly rewardsClaimed?: Maybe<Scalars['Int']>;
  readonly sendNewProductTourSeen202201?: Maybe<Scalars['Boolean']>;
  readonly setupFlowAddTeamMembers?: Maybe<Scalars['Boolean']>;
  readonly setupFlowAppLoginLater?: Maybe<Scalars['Boolean']>;
  readonly setupFlowInstallBanners?: Maybe<Scalars['Boolean']>;
  readonly setupFlowInstallBannersLater?: Maybe<Scalars['Boolean']>;
  readonly setupFlowInviteTeamLater?: Maybe<Scalars['Boolean']>;
  readonly setupFlowTextLinkSent?: Maybe<Scalars['Boolean']>;
  readonly setupFlowWatchArticleVideo?: Maybe<Scalars['Boolean']>;
  readonly setupFlowWatchArticleVideoLater?: Maybe<Scalars['Boolean']>;
  readonly showNewProductTour202201?: Maybe<Scalars['Boolean']>;
  readonly tryPaymentsSeen?: Maybe<Scalars['Boolean']>;
  readonly tryPaymentsSeenWeb?: Maybe<Scalars['Boolean']>;
  readonly walkthroughPaymentBalanceAvailableCalloutSeen?: Maybe<Scalars['Boolean']>;
  readonly walkthroughPaymentDetailsCalloutSeen?: Maybe<Scalars['Boolean']>;
  readonly walkthroughPaymentRequestCalloutSeen?: Maybe<Scalars['Boolean']>;
  readonly walkthroughPaymentSentDialogSeen?: Maybe<Scalars['Boolean']>;
  readonly walkthroughPaymentSettingsCalloutSeen?: Maybe<Scalars['Boolean']>;
};

/** Organizations custom settings attributes */
export type CustomOrganizationSettings = {
  readonly __typename?: 'CustomOrganizationSettings';
  readonly paymentsRewardsExpiredAt?: Maybe<Scalars['ISO8601DateTime']>;
  readonly paymentsRewardsQualifiedAt?: Maybe<Scalars['ISO8601DateTime']>;
};

/** Contractors can customize their invoice templates */
export type CustomizedInvoiceTemplate = {
  readonly __typename?: 'CustomizedInvoiceTemplate';
  readonly background: Background;
  readonly connectInvoices: ConnectInvoiceConnection;
  readonly createdAt: Scalars['ISO8601DateTime'];
  readonly id: Scalars['ID'];
  readonly logo: Scalars['Boolean'];
  readonly organization: Organization;
  readonly primaryColor: OrganizationTheme;
  readonly signatureMessage?: Maybe<SignatureMessage>;
  readonly socialLinks: SocialMediaLinks;
  readonly templateType: InvoiceTemplateType;
  readonly updatedAt: Scalars['ISO8601DateTime'];
  readonly website: Scalars['Boolean'];
};


/** Contractors can customize their invoice templates */
export type CustomizedInvoiceTemplateConnectInvoicesArgs = {
  after?: Maybe<Scalars['String']>;
  before?: Maybe<Scalars['String']>;
  first?: Maybe<Scalars['Int']>;
  last?: Maybe<Scalars['Int']>;
};

/** An input type for a customized invoice template */
export type CustomizedInvoiceTemplateAttributes = {
  readonly background?: Maybe<Background>;
  readonly logo: Scalars['Boolean'];
  readonly primaryColor: OrganizationTheme;
  readonly signatureMessage?: Maybe<SignatureMessage>;
  readonly socialLinks?: Maybe<Scalars['JSON']>;
  readonly templateType: InvoiceTemplateType;
  readonly website: Scalars['Boolean'];
};

/** The connection type for CustomizedInvoiceTemplate. */
export type CustomizedInvoiceTemplateConnection = {
  readonly __typename?: 'CustomizedInvoiceTemplateConnection';
  /** A list of edges. */
  readonly edges?: Maybe<ReadonlyArray<Maybe<CustomizedInvoiceTemplateEdge>>>;
  /** A list of nodes. */
  readonly nodes?: Maybe<ReadonlyArray<Maybe<CustomizedInvoiceTemplate>>>;
  /** Information to aid in pagination. */
  readonly pageInfo: PageInfo;
  readonly totalCount: Scalars['Int'];
};

/** An edge in a connection. */
export type CustomizedInvoiceTemplateEdge = {
  readonly __typename?: 'CustomizedInvoiceTemplateEdge';
  /** A cursor for use in pagination. */
  readonly cursor: Scalars['String'];
  /** The item at the end of the edge. */
  readonly node?: Maybe<CustomizedInvoiceTemplate>;
};

/** Amount type */
export type DailyCount = {
  readonly __typename?: 'DailyCount';
  readonly amount: Scalars['Float'];
  readonly count: Scalars['Int'];
  readonly date: Scalars['ISO8601DateTime'];
};

export enum DashboardPersonalizationPreferences {
  /** Advertise my business */
  ADVERTISE = 'advertise',
  /** Get paid faster */
  GET_PAID = 'get_paid',
  /** Grow my new business */
  GROW_BUSINESS = 'grow_business',
  /** Management coaching */
  MANAGEMENT_COACHING = 'management_coaching',
  /** Other */
  OTHER = 'other',
  /** Save money on insurance */
  SAVE_MONEY = 'save_money',
  /** Send digital contracts */
  SEND_CONTRACTS = 'send_contracts',
  /** Train my sales team */
  TRAIN_SALES = 'train_sales',
  /** Win business with financing */
  WIN_BUSINESS = 'win_business'
}

export type DeactivateContractorFailure = {
  readonly __typename?: 'DeactivateContractorFailure';
  readonly errors: ReadonlyArray<Error>;
};

export type DeactivateContractorResult = DeactivateContractorFailure | DeactivateContractorSuccess;

export type DeactivateContractorSuccess = {
  readonly __typename?: 'DeactivateContractorSuccess';
  readonly organization: Organization;
};

export type DeletePersonFailure = {
  readonly __typename?: 'DeletePersonFailure';
  readonly errors: ReadonlyArray<Error>;
};

export type DeletePersonResult = DeletePersonFailure | DeletePersonSuccess;

export type DeletePersonSuccess = {
  readonly __typename?: 'DeletePersonSuccess';
  readonly kycBusiness: KycBusiness;
  readonly stripeConnectAccount: StripeConnectAccount;
};

/** Stores information related to an uploaded document. */
export type Document = {
  readonly __typename?: 'Document';
  readonly attachableId: Scalars['String'];
  readonly attachableType: Scalars['String'];
  readonly attachmentContentType: Scalars['String'];
  readonly attachmentFileName: Scalars['String'];
  readonly attachmentUpdatedAt: Scalars['ISO8601DateTime'];
  readonly attachmentUrl: Scalars['String'];
  readonly createdAt: Scalars['ISO8601DateTime'];
  readonly documentType?: Maybe<Scalars['String']>;
  readonly id: Scalars['ID'];
  readonly updatedAt: Scalars['ISO8601DateTime'];
};

export type DocumentAttributes = {
  readonly document: Scalars['String'];
  readonly documentName: Scalars['String'];
  readonly documentType: Scalars['String'];
};

/** The connection type for Document. */
export type DocumentConnection = {
  readonly __typename?: 'DocumentConnection';
  /** A list of edges. */
  readonly edges?: Maybe<ReadonlyArray<Maybe<DocumentEdge>>>;
  /** A list of nodes. */
  readonly nodes?: Maybe<ReadonlyArray<Maybe<Document>>>;
  /** Information to aid in pagination. */
  readonly pageInfo: PageInfo;
  readonly totalCount: Scalars['Int'];
};

/** An edge in a connection. */
export type DocumentEdge = {
  readonly __typename?: 'DocumentEdge';
  /** A cursor for use in pagination. */
  readonly cursor: Scalars['String'];
  /** The item at the end of the edge. */
  readonly node?: Maybe<Document>;
};

/** Interface that any errors can implement */
export type Error = {
  /** The code to switch off of for errors */
  readonly code: ErrorCodes;
  /** Extra information about this error type */
  readonly extensions?: Maybe<Extension>;
  /** A description of the error */
  readonly message: Scalars['String'];
  /** Which input value this error came from */
  readonly path?: Maybe<ReadonlyArray<Scalars['String']>>;
};

export enum ErrorCodes {
  DRY_VALIDATION_INTERNAL_ERROR = 'DRY_VALIDATION_INTERNAL_ERROR',
  INTERNAL_ERROR = 'INTERNAL_ERROR',
  INVALID_INPUT_ERROR = 'INVALID_INPUT_ERROR',
  NOT_FOUND_ERROR = 'NOT_FOUND_ERROR',
  OPERATION_NOT_PERMITTED_ERROR = 'OPERATION_NOT_PERMITTED_ERROR',
  RECURLY_BILLING_VERIFICATION_ERROR = 'RECURLY_BILLING_VERIFICATION_ERROR',
  STRIPE_ERROR = 'STRIPE_ERROR',
  THIRD_PARTY_ERROR = 'THIRD_PARTY_ERROR'
}

export enum ExportPaymentData {
  /** To export payment history */
  PAYMENT = 'PAYMENT',
  /** To export payout history */
  PAYOUT = 'PAYOUT'
}

export type ExportPaymentDataFailure = {
  readonly __typename?: 'ExportPaymentDataFailure';
  readonly errors: ReadonlyArray<Error>;
};

export type ExportPaymentDataResult = ExportPaymentDataFailure | ExportPaymentDataSuccess;

export type ExportPaymentDataSuccess = {
  readonly __typename?: 'ExportPaymentDataSuccess';
  readonly contractor: Contractor;
};

/** A user-readable error */
export type Extension = {
  readonly __typename?: 'Extension';
  /** The error type string */
  readonly code: Scalars['String'];
  /** Any extra accoutrement */
  readonly extra: Scalars['JSON'];
};

/** External transfer destination accounts */
export type ExternalTransferDestinations = {
  readonly __typename?: 'ExternalTransferDestinations';
  readonly instantDestinations: ReadonlyArray<StripeCard>;
  readonly standardDestinations: ReadonlyArray<TransferDestination>;
};

/** A specific feature flag */
export type FeatureFlag = {
  readonly __typename?: 'FeatureFlag';
  readonly active: Scalars['Boolean'];
  readonly deactivatedAt?: Maybe<Scalars['ISO8601DateTime']>;
  readonly id: Scalars['ID'];
};

export enum FeedbackResponse {
  FINANCING = 'financing',
  PAYMENTS = 'payments',
  ZAPIER = 'zapier'
}

export enum FeedbackResponseStatus {
  INCOMPLETE = 'incomplete',
  SUBMITTED = 'submitted'
}

export type File = {
  readonly encodedBytes: Scalars['String'];
  readonly name: Scalars['String'];
};

/** Financing insights amount data */
export type FinancingInsightsAmount = {
  readonly __typename?: 'FinancingInsightsAmount';
  readonly countByDay: ReadonlyArray<DailyCount>;
};

/** Financing insights funnel data */
export type FinancingInsightsCustomerProfile = {
  readonly __typename?: 'FinancingInsightsCustomerProfile';
  readonly meanFico?: Maybe<Scalars['Float']>;
  readonly meanIncome?: Maybe<Scalars['Float']>;
  readonly meanRequestedAmount?: Maybe<Scalars['Float']>;
  readonly medianApr?: Maybe<Scalars['Float']>;
  readonly medianIncome?: Maybe<Scalars['Float']>;
  readonly priorMeanFico?: Maybe<Scalars['Float']>;
  readonly priorMeanIncome?: Maybe<Scalars['Float']>;
  readonly priorMeanRequestedAmount?: Maybe<Scalars['Float']>;
  readonly priorMedianApr?: Maybe<Scalars['Float']>;
  readonly priorMedianIncome?: Maybe<Scalars['Float']>;
};

export enum FinancingInsightsFilter {
  /** To get completed counts */
  COMPLETED = 'completed',
  /** To get funded counts */
  FUNDED = 'funded',
  /** To get pre-qualified counts */
  PRE_QUALIFIED = 'pre_qualified'
}

/** Financing insights funnel data */
export type FinancingInsightsFunnel = {
  readonly __typename?: 'FinancingInsightsFunnel';
  readonly fundedAmount?: Maybe<Scalars['Float']>;
  readonly fundedCount?: Maybe<Scalars['Float']>;
  readonly preQualifiedAmount?: Maybe<Scalars['Float']>;
  readonly preQualifiedCount?: Maybe<Scalars['Float']>;
  readonly requestedAmount?: Maybe<Scalars['Float']>;
  readonly requestedCount?: Maybe<Scalars['Float']>;
};

export enum FinancingInsightsTimeRange {
  /** All time */
  ALL_TIME = 'all_time',
  /** Month */
  MONTH = 'month',
  /** Quarter */
  QUARTER = 'quarter',
  /** Year to date */
  YEAR_TO_DATE = 'year_to_date'
}

/** Financing insights trend data */
export type FinancingInsightsTrend = {
  readonly __typename?: 'FinancingInsightsTrend';
  readonly pastYearSum: Scalars['Float'];
  readonly rollingCounts: ReadonlyArray<RollingCounts>;
};

export enum FinancingLinkMedium {
  FB = 'fb',
  FLYERS = 'flyers',
  MOBILE = 'mobile',
  MOBILE_EMAIL = 'mobile_email',
  MOBILE_FB = 'mobile_fb',
  MOBILE_TEXT = 'mobile_text',
  PARTNERS = 'partners',
  WEB_EMAIL = 'web_email',
  WEB_TEXT = 'web_text'
}

/** params related to financing */
export type FinancingParams = {
  readonly personalNote?: Maybe<Scalars['String']>;
  readonly utmContent?: Maybe<Scalars['String']>;
  readonly utmMediumEmail?: Maybe<FinancingLinkMedium>;
  readonly utmMediumText?: Maybe<FinancingLinkMedium>;
};

export type GenerateApiTokenFailure = {
  readonly __typename?: 'GenerateApiTokenFailure';
  readonly errors: ReadonlyArray<Error>;
};

export type GenerateApiTokenResult = GenerateApiTokenFailure | GenerateApiTokenSuccess;

export type GenerateApiTokenSuccess = {
  readonly __typename?: 'GenerateApiTokenSuccess';
  readonly organization: Organization;
};

export type GetStripeAccountLinkFailure = {
  readonly __typename?: 'GetStripeAccountLinkFailure';
  readonly errors: ReadonlyArray<Error>;
};

export type GetStripeAccountLinkResult = GetStripeAccountLinkFailure | GetStripeAccountLinkSuccess;

export type GetStripeAccountLinkSuccess = {
  readonly __typename?: 'GetStripeAccountLinkSuccess';
  readonly connectAccountLoginLink: Scalars['String'];
};

/** Hearth events with timestamps */
export type HearthEvent = {
  readonly __typename?: 'HearthEvent';
  readonly createdAt: Scalars['ISO8601DateTime'];
  readonly eventAt: Scalars['ISO8601DateTime'];
  readonly eventBody?: Maybe<Scalars['JSON']>;
  readonly eventType: HearthEventEventTypes;
  readonly id: Scalars['ID'];
};

/** The connection type for HearthEvent. */
export type HearthEventConnection = {
  readonly __typename?: 'HearthEventConnection';
  /** A list of edges. */
  readonly edges?: Maybe<ReadonlyArray<Maybe<HearthEventEdge>>>;
  /** A list of nodes. */
  readonly nodes?: Maybe<ReadonlyArray<Maybe<HearthEvent>>>;
  /** Information to aid in pagination. */
  readonly pageInfo: PageInfo;
  readonly totalCount: Scalars['Int'];
};

/** An edge in a connection. */
export type HearthEventEdge = {
  readonly __typename?: 'HearthEventEdge';
  /** A cursor for use in pagination. */
  readonly cursor: Scalars['String'];
  /** The item at the end of the edge. */
  readonly node?: Maybe<HearthEvent>;
};

export enum HearthEventEventTypes {
  CONTRACTOR_WEBINAR_ATTENDED = 'contractor_webinar_attended',
  CONTRACTOR_WEBINAR_REGISTERED = 'contractor_webinar_registered',
  HOMEOWNER_APPLICATION_CLICKED = 'homeowner_application_clicked',
  HOMEOWNER_APPLICATION_CREATED = 'homeowner_application_created',
  HOMEOWNER_APPLICATION_FUNDED = 'homeowner_application_funded',
  HOMEOWNER_APPLICATION_QUALIFIED = 'homeowner_application_qualified',
  HOMEOWNER_APPLICATION_REJECTED = 'homeowner_application_rejected',
  HOMEOWNER_APPLICATION_SENT = 'homeowner_application_sent',
  HOMEOWNER_CONNECT_INVOICE_ACTIVITY_CREATED = 'homeowner_connect_invoice_activity_created',
  HOMEOWNER_CONNECT_INVOICE_CANCELED = 'homeowner_connect_invoice_canceled',
  HOMEOWNER_CONNECT_INVOICE_CREATED = 'homeowner_connect_invoice_created',
  HOMEOWNER_CONNECT_INVOICE_MANUAL_REMINDER_SENT = 'homeowner_connect_invoice_manual_reminder_sent',
  HOMEOWNER_CONNECT_INVOICE_OVERDUE = 'homeowner_connect_invoice_overdue',
  HOMEOWNER_CONNECT_INVOICE_OVERDUE_REMINDER_SENT = 'homeowner_connect_invoice_overdue_reminder_sent',
  HOMEOWNER_CONNECT_INVOICE_PARTIAL_REFUND_COMPLETED = 'homeowner_connect_invoice_partial_refund_completed',
  HOMEOWNER_CONNECT_INVOICE_PAYMENT_COMPLETED = 'homeowner_connect_invoice_payment_completed',
  HOMEOWNER_CONNECT_INVOICE_PAYMENT_FAILED = 'homeowner_connect_invoice_payment_failed',
  HOMEOWNER_CONNECT_INVOICE_PAYMENT_INITIATED = 'homeowner_connect_invoice_payment_initiated',
  HOMEOWNER_CONNECT_INVOICE_REFUND_COMPLETED = 'homeowner_connect_invoice_refund_completed',
  HOMEOWNER_CONNECT_INVOICE_SCHEDULED = 'homeowner_connect_invoice_scheduled',
  HOMEOWNER_CONNECT_INVOICE_SENT = 'homeowner_connect_invoice_sent',
  HOMEOWNER_CREATED = 'homeowner_created',
  HOMEOWNER_CREDIT_CARD_LEAD = 'homeowner_credit_card_lead',
  HOMEOWNER_CREDIT_CARD_SOLD = 'homeowner_credit_card_sold',
  HOMEOWNER_PROJECT_CONTRACT_CANCELED = 'homeowner_project_contract_canceled',
  HOMEOWNER_PROJECT_CONTRACT_SENT = 'homeowner_project_contract_sent',
  HOMEOWNER_PROJECT_CONTRACT_SIGNED = 'homeowner_project_contract_signed',
  HOMEOWNER_PROJECT_CONTRACT_VIEWED = 'homeowner_project_contract_viewed',
  HOMEOWNER_QUOTE_APPROVED = 'homeowner_quote_approved',
  HOMEOWNER_QUOTE_CANCELED = 'homeowner_quote_canceled',
  HOMEOWNER_QUOTE_CHANGES_REQUESTED = 'homeowner_quote_changes_requested',
  HOMEOWNER_QUOTE_EXPIRED = 'homeowner_quote_expired',
  HOMEOWNER_QUOTE_REVISION_SENT = 'homeowner_quote_revision_sent',
  HOMEOWNER_QUOTE_SENT = 'homeowner_quote_sent',
  HOMEOWNER_QUOTE_VIEWED = 'homeowner_quote_viewed',
  HOMEOWNER_UPDATED = 'homeowner_updated'
}

export enum HearthEventScope {
  PRIORITY = 'PRIORITY',
  RECENCY = 'RECENCY'
}

export type HearthOnboardingResponseAttributes = {
  readonly answer: DashboardPersonalizationPreferences;
  readonly answerMeta?: Maybe<Scalars['JSON']>;
};

/** A selector to find all associated items relating to a Hearth Uid */
export type HearthUidSelector = {
  readonly __typename?: 'HearthUidSelector';
  readonly contractor?: Maybe<Contractor>;
  readonly loanInquiries?: Maybe<LoanInquiryConnection>;
};


/** A selector to find all associated items relating to a Hearth Uid */
export type HearthUidSelectorLoanInquiriesArgs = {
  after?: Maybe<Scalars['String']>;
  before?: Maybe<Scalars['String']>;
  first?: Maybe<Scalars['Int']>;
  last?: Maybe<Scalars['Int']>;
};

export enum HearthWebinar {
  /** Livestorm webinar for A/B testing industries */
  HEARTH_INDUSTRY = 'HEARTH_INDUSTRY',
  /** Livestorm webinar for seats */
  HEARTH_TEAM_TRAINING = 'HEARTH_TEAM_TRAINING',
  /** Livestorm webinar for admins + seats that join them */
  HEARTH_TRAINING = 'HEARTH_TRAINING'
}

/** Come on, you know what a homeowner is */
export type Homeowner = {
  readonly __typename?: 'Homeowner';
  readonly activeInvoiceCount: Scalars['Int'];
  readonly address?: Maybe<Scalars['String']>;
  readonly birthday: Scalars['ISO8601DateTime'];
  readonly city?: Maybe<Scalars['String']>;
  readonly connectInvoices?: Maybe<ConnectInvoiceConnection>;
  readonly contractServiceSignatures: ContractServiceSignatureConnection;
  readonly contractor?: Maybe<Contractor>;
  readonly defaultHomeownerAddress?: Maybe<HomeownerAddress>;
  readonly email: Scalars['String'];
  readonly fico?: Maybe<Scalars['Int']>;
  readonly financingStatus: HomeownerFinancingStatus;
  readonly firstName: Scalars['String'];
  readonly fullName: Scalars['String'];
  readonly fundingAmount: Scalars['Int'];
  readonly fundingDate?: Maybe<Scalars['ISO8601DateTime']>;
  readonly fundingLender?: Maybe<Scalars['String']>;
  readonly fundingTime?: Maybe<Scalars['Int']>;
  readonly hasFinancingExperienceResponse: Scalars['Boolean'];
  /** @deprecated Deprecated in favor of selected_hearth_events */
  readonly hearthEvents: HearthEventConnection;
  readonly homeownerAddresses?: Maybe<HomeownerAddressConnection>;
  /** @deprecated Query all homeowner feedback responses with a given argument */
  readonly homeownerFeedbackResponse?: Maybe<HomeownerFeedbackResponse>;
  readonly homeownerFeedbackResponses?: Maybe<HomeownerFeedbackResponseConnection>;
  readonly homeownerFinancingFeedback?: Maybe<HomeownerFeedbackResponse>;
  readonly homeownerPaymentsFeedback?: Maybe<HomeownerFeedbackResponse>;
  readonly id: Scalars['ID'];
  readonly lastName: Scalars['String'];
  readonly latestLoanInquiry?: Maybe<LoanInquiry>;
  readonly linkOpened: Scalars['Boolean'];
  readonly linkOpenedAt: Scalars['Boolean'];
  readonly loanInquiries: LoanInquiryConnection;
  readonly numLendersQualified?: Maybe<Scalars['Int']>;
  readonly organization?: Maybe<Organization>;
  readonly outstandingInvoiceAmount: Scalars['Int'];
  readonly outstandingInvoiceCount: Scalars['Int'];
  readonly outstandingPaymentsAmount: Scalars['Int'];
  readonly overduePaymentsAmount: Scalars['Int'];
  readonly paidPaymentsAmount: Scalars['Int'];
  readonly phoneNumber: Scalars['String'];
  readonly primaryLoanInquiry?: Maybe<LoanInquiry>;
  readonly projectType?: Maybe<Scalars['String']>;
  readonly qualifiedLoanInquiries: LoanInquiryConnection;
  readonly quotes: QuoteConnection;
  readonly requestedAmount?: Maybe<Scalars['String']>;
  readonly searchKey: Scalars['ID'];
  readonly selectedHearthEvents: HearthEventConnection;
  readonly state?: Maybe<Scalars['String']>;
  readonly status?: Maybe<Scalars['String']>;
  readonly syncedToQuickbooks: Scalars['Boolean'];
  readonly unpaidPaymentsAmount: Scalars['Int'];
  readonly zipCode?: Maybe<Scalars['String']>;
};


/** Come on, you know what a homeowner is */
export type HomeownerConnectInvoicesArgs = {
  after?: Maybe<Scalars['String']>;
  before?: Maybe<Scalars['String']>;
  first?: Maybe<Scalars['Int']>;
  last?: Maybe<Scalars['Int']>;
  organizationId?: Maybe<Scalars['ID']>;
  statuses?: Maybe<ReadonlyArray<Maybe<ConnectInvoiceStatus>>>;
};


/** Come on, you know what a homeowner is */
export type HomeownerContractServiceSignaturesArgs = {
  after?: Maybe<Scalars['String']>;
  before?: Maybe<Scalars['String']>;
  first?: Maybe<Scalars['Int']>;
  last?: Maybe<Scalars['Int']>;
};


/** Come on, you know what a homeowner is */
export type HomeownerHearthEventsArgs = {
  after?: Maybe<Scalars['String']>;
  before?: Maybe<Scalars['String']>;
  bucket?: Maybe<HomeownerEventBucket>;
  first?: Maybe<Scalars['Int']>;
  last?: Maybe<Scalars['Int']>;
};


/** Come on, you know what a homeowner is */
export type HomeownerHomeownerAddressesArgs = {
  after?: Maybe<Scalars['String']>;
  before?: Maybe<Scalars['String']>;
  first?: Maybe<Scalars['Int']>;
  last?: Maybe<Scalars['Int']>;
};


/** Come on, you know what a homeowner is */
export type HomeownerHomeownerFeedbackResponsesArgs = {
  after?: Maybe<Scalars['String']>;
  before?: Maybe<Scalars['String']>;
  feedbackType?: Maybe<FeedbackResponse>;
  first?: Maybe<Scalars['Int']>;
  last?: Maybe<Scalars['Int']>;
};


/** Come on, you know what a homeowner is */
export type HomeownerLoanInquiriesArgs = {
  after?: Maybe<Scalars['String']>;
  before?: Maybe<Scalars['String']>;
  first?: Maybe<Scalars['Int']>;
  last?: Maybe<Scalars['Int']>;
};


/** Come on, you know what a homeowner is */
export type HomeownerQualifiedLoanInquiriesArgs = {
  after?: Maybe<Scalars['String']>;
  before?: Maybe<Scalars['String']>;
  first?: Maybe<Scalars['Int']>;
  last?: Maybe<Scalars['Int']>;
};


/** Come on, you know what a homeowner is */
export type HomeownerQuotesArgs = {
  after?: Maybe<Scalars['String']>;
  before?: Maybe<Scalars['String']>;
  first?: Maybe<Scalars['Int']>;
  last?: Maybe<Scalars['Int']>;
};


/** Come on, you know what a homeowner is */
export type HomeownerSelectedHearthEventsArgs = {
  after?: Maybe<Scalars['String']>;
  before?: Maybe<Scalars['String']>;
  events: ReadonlyArray<HearthEventEventTypes>;
  first?: Maybe<Scalars['Int']>;
  last?: Maybe<Scalars['Int']>;
  scope?: Maybe<HearthEventScope>;
};

/** One of Homeowner's addresses */
export type HomeownerAddress = {
  readonly __typename?: 'HomeownerAddress';
  readonly addressLineOne?: Maybe<Scalars['String']>;
  readonly addressLineTwo?: Maybe<Scalars['String']>;
  readonly city: Scalars['String'];
  readonly homeowner: Homeowner;
  readonly id: Scalars['ID'];
  readonly state?: Maybe<Scalars['String']>;
  readonly zipCode?: Maybe<Scalars['String']>;
};

/** The connection type for HomeownerAddress. */
export type HomeownerAddressConnection = {
  readonly __typename?: 'HomeownerAddressConnection';
  /** A list of edges. */
  readonly edges?: Maybe<ReadonlyArray<Maybe<HomeownerAddressEdge>>>;
  /** A list of nodes. */
  readonly nodes?: Maybe<ReadonlyArray<Maybe<HomeownerAddress>>>;
  /** Information to aid in pagination. */
  readonly pageInfo: PageInfo;
  readonly totalCount: Scalars['Int'];
};

/** An edge in a connection. */
export type HomeownerAddressEdge = {
  readonly __typename?: 'HomeownerAddressEdge';
  /** A cursor for use in pagination. */
  readonly cursor: Scalars['String'];
  /** The item at the end of the edge. */
  readonly node?: Maybe<HomeownerAddress>;
};

export type HomeownerAttributes = {
  readonly email?: Maybe<Scalars['String']>;
  readonly firstName?: Maybe<Scalars['String']>;
  readonly lastName?: Maybe<Scalars['String']>;
  readonly phoneNumber?: Maybe<Scalars['String']>;
};

/** The connection type for Homeowner. */
export type HomeownerConnection = {
  readonly __typename?: 'HomeownerConnection';
  /** A list of edges. */
  readonly edges?: Maybe<ReadonlyArray<Maybe<HomeownerEdge>>>;
  /** A list of nodes. */
  readonly nodes?: Maybe<ReadonlyArray<Maybe<Homeowner>>>;
  /** Information to aid in pagination. */
  readonly pageInfo: PageInfo;
  readonly totalCount: Scalars['Int'];
};

/** An edge in a connection. */
export type HomeownerEdge = {
  readonly __typename?: 'HomeownerEdge';
  /** A cursor for use in pagination. */
  readonly cursor: Scalars['String'];
  /** The item at the end of the edge. */
  readonly node?: Maybe<Homeowner>;
};

export enum HomeownerEventBucket {
  CONTRACTS = 'CONTRACTS',
  CONTRACTS_INDEX = 'CONTRACTS_INDEX',
  FINANCING = 'FINANCING',
  FINANCING_AND_PAYMENTS = 'FINANCING_AND_PAYMENTS',
  FINANCING_INDEX = 'FINANCING_INDEX',
  GLOBAL = 'GLOBAL',
  PAYMENTS = 'PAYMENTS',
  PAYMENTS_INDEX = 'PAYMENTS_INDEX',
  QUOTES = 'QUOTES',
  QUOTES_INDEX = 'QUOTES_INDEX'
}

/** homeowner feedback response */
export type HomeownerFeedbackResponse = {
  readonly __typename?: 'HomeownerFeedbackResponse';
  readonly additionalFinancingFeedback?: Maybe<Scalars['String']>;
  readonly additionalPaymentsFeedback?: Maybe<Scalars['String']>;
  readonly averageFinancingRating?: Maybe<Scalars['Float']>;
  readonly averagePaymentsRating?: Maybe<Scalars['Float']>;
  readonly contractorExperience?: Maybe<Scalars['Int']>;
  readonly contractorFeedback?: Maybe<Scalars['String']>;
  readonly contractorSatisfaction?: Maybe<Scalars['Int']>;
  readonly createdAt: Scalars['ISO8601DateTime'];
  readonly customerService?: Maybe<Scalars['Int']>;
  readonly digitalPayments?: Maybe<Scalars['Int']>;
  readonly fullName: Scalars['String'];
  readonly hearthRating?: Maybe<Scalars['Int']>;
  readonly homeowner: Homeowner;
  readonly homeownerId: Scalars['ID'];
  readonly id: Scalars['ID'];
  readonly lenderFeedback?: Maybe<Scalars['String']>;
  readonly lenderSatisfaction?: Maybe<Scalars['Int']>;
  readonly status: FeedbackResponseStatus;
  readonly submittedAt?: Maybe<Scalars['ISO8601DateTime']>;
  readonly terms?: Maybe<Scalars['String']>;
  readonly uuid: Scalars['String'];
  readonly workQuality?: Maybe<Scalars['Int']>;
};

/** An input type for homeowner financing feedback */
export type HomeownerFeedbackResponseAttributes = {
  readonly financingFeedback?: Maybe<HomeownerFinancingFeedbackAttributes>;
  readonly paymentsFeedback?: Maybe<HomeownerPaymentsFeedbackAttributes>;
};

/** The connection type for HomeownerFeedbackResponse. */
export type HomeownerFeedbackResponseConnection = {
  readonly __typename?: 'HomeownerFeedbackResponseConnection';
  /** A list of edges. */
  readonly edges?: Maybe<ReadonlyArray<Maybe<HomeownerFeedbackResponseEdge>>>;
  /** A list of nodes. */
  readonly nodes?: Maybe<ReadonlyArray<Maybe<HomeownerFeedbackResponse>>>;
  /** Information to aid in pagination. */
  readonly pageInfo: PageInfo;
  readonly totalCount: Scalars['Int'];
};

/** An edge in a connection. */
export type HomeownerFeedbackResponseEdge = {
  readonly __typename?: 'HomeownerFeedbackResponseEdge';
  /** A cursor for use in pagination. */
  readonly cursor: Scalars['String'];
  /** The item at the end of the edge. */
  readonly node?: Maybe<HomeownerFeedbackResponse>;
};

/** An input type for homeowner financing feedback */
export type HomeownerFinancingFeedbackAttributes = {
  readonly additionalFinancingFeedback?: Maybe<Scalars['String']>;
  readonly contractorExperience: Scalars['Int'];
  readonly hearthRating: Scalars['Int'];
};

/** Homeowner financing feedback metrics from homeowner_feedback_responses */
export type HomeownerFinancingFeedbackMetrics = {
  readonly __typename?: 'HomeownerFinancingFeedbackMetrics';
  readonly avgContractorSatisfaction?: Maybe<Scalars['Float']>;
  readonly avgContractorSatisfactionDifference?: Maybe<Scalars['Float']>;
  readonly avgHearthSatisfaction?: Maybe<Scalars['Float']>;
  readonly avgHearthSatisfactionDifference?: Maybe<Scalars['Float']>;
};

export enum HomeownerFinancingStatus {
  FORM_SENT = 'form_sent',
  FORM_STARTED = 'form_started',
  FUNDED = 'funded',
  NOT_OFFERED = 'not_offered',
  NOT_QUALIFIED = 'not_qualified',
  PREQUALIFIED = 'prequalified'
}

export enum HomeownerOrderers {
  /** Order by amount_requested ascendent */
  AMOUNT_REQUESTED_ASC = 'amount_requested_asc',
  /** Order by amount_requested descendent */
  AMOUNT_REQUESTED_DESC = 'amount_requested_desc',
  /** Order by authenticity_token ascendent */
  AUTHENTICITY_TOKEN_ASC = 'authenticity_token_asc',
  /** Order by authenticity_token descendent */
  AUTHENTICITY_TOKEN_DESC = 'authenticity_token_desc',
  /** Order by by_recent_contracts_events */
  BY_RECENT_CONTRACTS_EVENTS = 'by_recent_contracts_events',
  /** Order by by_recent_events */
  BY_RECENT_EVENTS = 'by_recent_events',
  /** Order by by_recent_financing_events */
  BY_RECENT_FINANCING_EVENTS = 'by_recent_financing_events',
  /** Order by by_recent_payment_events */
  BY_RECENT_PAYMENT_EVENTS = 'by_recent_payment_events',
  /** Order by by_recent_quote_events */
  BY_RECENT_QUOTE_EVENTS = 'by_recent_quote_events',
  /** Order by by_status_contract_events */
  BY_STATUS_CONTRACT_EVENTS = 'by_status_contract_events',
  /** Order by by_status_financing_events */
  BY_STATUS_FINANCING_EVENTS = 'by_status_financing_events',
  /** Order by by_status_payment_events */
  BY_STATUS_PAYMENT_EVENTS = 'by_status_payment_events',
  /** Order by by_status_quote_events */
  BY_STATUS_QUOTE_EVENTS = 'by_status_quote_events',
  /** Order by contractor_id ascendent */
  CONTRACTOR_ID_ASC = 'contractor_id_asc',
  /** Order by contractor_id descendent */
  CONTRACTOR_ID_DESC = 'contractor_id_desc',
  /** Order by contractor_inquiry_rating ascendent */
  CONTRACTOR_INQUIRY_RATING_ASC = 'contractor_inquiry_rating_asc',
  /** Order by contractor_inquiry_rating descendent */
  CONTRACTOR_INQUIRY_RATING_DESC = 'contractor_inquiry_rating_desc',
  /** Order by created_at ascendent */
  CREATED_AT_ASC = 'created_at_asc',
  /** Order by created_at descendent */
  CREATED_AT_DESC = 'created_at_desc',
  /** Order by email ascendent */
  EMAIL_ASC = 'email_asc',
  /** Order by email descendent */
  EMAIL_DESC = 'email_desc',
  /** Order by financing_experience_response_id ascendent */
  FINANCING_EXPERIENCE_RESPONSE_ID_ASC = 'financing_experience_response_id_asc',
  /** Order by financing_experience_response_id descendent */
  FINANCING_EXPERIENCE_RESPONSE_ID_DESC = 'financing_experience_response_id_desc',
  /** Order by first_name ascendent */
  FIRST_NAME_ASC = 'first_name_asc',
  /** Order by first_name descendent */
  FIRST_NAME_DESC = 'first_name_desc',
  /** Order by id ascendent */
  ID_ASC = 'id_asc',
  /** Order by id descendent */
  ID_DESC = 'id_desc',
  /** Order by job_failures ascendent */
  JOB_FAILURES_ASC = 'job_failures_asc',
  /** Order by job_failures descendent */
  JOB_FAILURES_DESC = 'job_failures_desc',
  /** Order by last_name ascendent */
  LAST_NAME_ASC = 'last_name_asc',
  /** Order by last_name descendent */
  LAST_NAME_DESC = 'last_name_desc',
  /** Order by organization_id ascendent */
  ORGANIZATION_ID_ASC = 'organization_id_asc',
  /** Order by organization_id descendent */
  ORGANIZATION_ID_DESC = 'organization_id_desc',
  /** Order by phone_number ascendent */
  PHONE_NUMBER_ASC = 'phone_number_asc',
  /** Order by phone_number descendent */
  PHONE_NUMBER_DESC = 'phone_number_desc',
  /** Order by salesforce_contact_id ascendent */
  SALESFORCE_CONTACT_ID_ASC = 'salesforce_contact_id_asc',
  /** Order by salesforce_contact_id descendent */
  SALESFORCE_CONTACT_ID_DESC = 'salesforce_contact_id_desc',
  /** Order by search_key ascendent */
  SEARCH_KEY_ASC = 'search_key_asc',
  /** Order by search_key descendent */
  SEARCH_KEY_DESC = 'search_key_desc',
  /** Order by settings ascendent */
  SETTINGS_ASC = 'settings_asc',
  /** Order by settings descendent */
  SETTINGS_DESC = 'settings_desc',
  /** Order by signer_id ascendent */
  SIGNER_ID_ASC = 'signer_id_asc',
  /** Order by signer_id descendent */
  SIGNER_ID_DESC = 'signer_id_desc',
  /** Order by source ascendent */
  SOURCE_ASC = 'source_asc',
  /** Order by source descendent */
  SOURCE_DESC = 'source_desc',
  /** Order by updated_at ascendent */
  UPDATED_AT_ASC = 'updated_at_asc',
  /** Order by updated_at descendent */
  UPDATED_AT_DESC = 'updated_at_desc',
  /** Order by vertical_id ascendent */
  VERTICAL_ID_ASC = 'vertical_id_asc',
  /** Order by vertical_id descendent */
  VERTICAL_ID_DESC = 'vertical_id_desc'
}

/** Homeowner monthly payment calculation */
export type HomeownerPaymentCalculation = {
  readonly __typename?: 'HomeownerPaymentCalculation';
  readonly id: Scalars['ID'];
  readonly monthlyPayment35th: Scalars['Float'];
  readonly monthlyPayment50th: Scalars['Float'];
  readonly monthlyPayment75th: Scalars['Float'];
};

/** The connection type for HomeownerPaymentCalculation. */
export type HomeownerPaymentCalculationConnection = {
  readonly __typename?: 'HomeownerPaymentCalculationConnection';
  /** A list of edges. */
  readonly edges?: Maybe<ReadonlyArray<Maybe<HomeownerPaymentCalculationEdge>>>;
  /** A list of nodes. */
  readonly nodes?: Maybe<ReadonlyArray<Maybe<HomeownerPaymentCalculation>>>;
  /** Information to aid in pagination. */
  readonly pageInfo: PageInfo;
  readonly totalCount: Scalars['Int'];
};

/** An edge in a connection. */
export type HomeownerPaymentCalculationEdge = {
  readonly __typename?: 'HomeownerPaymentCalculationEdge';
  /** A cursor for use in pagination. */
  readonly cursor: Scalars['String'];
  /** The item at the end of the edge. */
  readonly node?: Maybe<HomeownerPaymentCalculation>;
};

/** An input type for homeowner payments feedback */
export type HomeownerPaymentsFeedbackAttributes = {
  readonly additionalPaymentsFeedback?: Maybe<Scalars['String']>;
  readonly customerService: Scalars['Int'];
  readonly digitalPayments: Scalars['Int'];
  readonly workQuality: Scalars['Int'];
};

/** Homeowner payments feedback metrics from homeowner_feedback_responses */
export type HomeownerPaymentsFeedbackMetrics = {
  readonly __typename?: 'HomeownerPaymentsFeedbackMetrics';
  readonly avgContractorSatisfaction?: Maybe<Scalars['Float']>;
  readonly avgContractorSatisfactionDifference?: Maybe<Scalars['Float']>;
  readonly avgHearthSatisfaction?: Maybe<Scalars['Float']>;
  readonly avgHearthSatisfactionDifference?: Maybe<Scalars['Float']>;
};

export type HomeownerResendOffersEmailFailure = {
  readonly __typename?: 'HomeownerResendOffersEmailFailure';
  readonly errors: ReadonlyArray<Error>;
};

export type HomeownerResendOffersEmailResult = HomeownerResendOffersEmailFailure | HomeownerResendOffersEmailSuccess;

export type HomeownerResendOffersEmailSuccess = {
  readonly __typename?: 'HomeownerResendOffersEmailSuccess';
  readonly loanInquiry: LoanInquiry;
};


export enum InsightsFeedback {
  /** Contracts feedback */
  CONTRACTS = 'contracts',
  /** Financing feedback */
  FINANCING = 'financing',
  /** Payments feedback */
  PAYMENTS = 'payments',
  /** Quotes feedback */
  QUOTES = 'quotes'
}

/** An internal, non user-readable error */
export type InternalError = Error & {
  readonly __typename?: 'InternalError';
  /** The code to switch off of for errors */
  readonly code: ErrorCodes;
  /** Extra information about this error type */
  readonly extensions?: Maybe<Extension>;
  /** A description of the error */
  readonly message: Scalars['String'];
  /** Which input value this error came from */
  readonly path?: Maybe<ReadonlyArray<Scalars['String']>>;
};

/** Invoice attachment for payment requests */
export type InvoiceAttachment = {
  readonly __typename?: 'InvoiceAttachment';
  readonly attachmentContentType: Scalars['String'];
  readonly attachmentFileName: Scalars['String'];
  readonly id: Scalars['ID'];
  /** Public URL to the attachment */
  readonly link: Scalars['String'];
};

/** The connection type for InvoiceAttachment. */
export type InvoiceAttachmentConnection = {
  readonly __typename?: 'InvoiceAttachmentConnection';
  /** A list of edges. */
  readonly edges?: Maybe<ReadonlyArray<Maybe<InvoiceAttachmentEdge>>>;
  /** A list of nodes. */
  readonly nodes?: Maybe<ReadonlyArray<Maybe<InvoiceAttachment>>>;
  /** Information to aid in pagination. */
  readonly pageInfo: PageInfo;
  readonly totalCount: Scalars['Int'];
};

/** An edge in a connection. */
export type InvoiceAttachmentEdge = {
  readonly __typename?: 'InvoiceAttachmentEdge';
  /** A cursor for use in pagination. */
  readonly cursor: Scalars['String'];
  /** The item at the end of the edge. */
  readonly node?: Maybe<InvoiceAttachment>;
};

export enum InvoiceTemplateType {
  CLASSIC_TEMPLATE = 'classic_template',
  FUN_TEMPLATE = 'fun_template',
  MODERN_TEMPLATE = 'modern_template'
}


/** Stores the information needed for the KYC flow. */
export type KycBusiness = {
  readonly __typename?: 'KycBusiness';
  readonly addressLine1?: Maybe<Scalars['String']>;
  readonly addressLine2?: Maybe<Scalars['String']>;
  readonly businessType?: Maybe<Scalars['String']>;
  readonly city?: Maybe<Scalars['String']>;
  readonly dbaName?: Maybe<Scalars['String']>;
  readonly email: Scalars['String'];
  readonly foundedDate?: Maybe<Scalars['ISO8601DateTime']>;
  readonly hasLiens?: Maybe<Scalars['Boolean']>;
  readonly id: Scalars['ID'];
  readonly kycDocuments: DocumentConnection;
  readonly kycPeople: KycPersonConnection;
  readonly kycRequirements: KycRequirementConnection;
  readonly legalName?: Maybe<Scalars['String']>;
  readonly mcc: Scalars['String'];
  readonly mccDescription?: Maybe<Scalars['String']>;
  readonly pastDueKycRequirements: KycRequirementConnection;
  readonly phoneNumber?: Maybe<Scalars['String']>;
  readonly plaidAccount?: Maybe<PlaidAccount>;
  readonly plaidLinkToken: Scalars['String'];
  readonly productDescription?: Maybe<Scalars['String']>;
  readonly ratingScore?: Maybe<Scalars['String']>;
  readonly ratingWebsite?: Maybe<Scalars['String']>;
  readonly revenueRange?: Maybe<Scalars['String']>;
  readonly state?: Maybe<Scalars['String']>;
  readonly taxId?: Maybe<Scalars['String']>;
  readonly url?: Maybe<Scalars['String']>;
  readonly yearlyRevenueInCents?: Maybe<Scalars['BigInt']>;
  readonly zipCode?: Maybe<Scalars['String']>;
};


/** Stores the information needed for the KYC flow. */
export type KycBusinessKycDocumentsArgs = {
  after?: Maybe<Scalars['String']>;
  before?: Maybe<Scalars['String']>;
  first?: Maybe<Scalars['Int']>;
  last?: Maybe<Scalars['Int']>;
};


/** Stores the information needed for the KYC flow. */
export type KycBusinessKycPeopleArgs = {
  after?: Maybe<Scalars['String']>;
  before?: Maybe<Scalars['String']>;
  first?: Maybe<Scalars['Int']>;
  last?: Maybe<Scalars['Int']>;
};


/** Stores the information needed for the KYC flow. */
export type KycBusinessKycRequirementsArgs = {
  after?: Maybe<Scalars['String']>;
  before?: Maybe<Scalars['String']>;
  first?: Maybe<Scalars['Int']>;
  last?: Maybe<Scalars['Int']>;
};


/** Stores the information needed for the KYC flow. */
export type KycBusinessPastDueKycRequirementsArgs = {
  after?: Maybe<Scalars['String']>;
  before?: Maybe<Scalars['String']>;
  first?: Maybe<Scalars['Int']>;
  last?: Maybe<Scalars['Int']>;
};

/** The form data for the kyc business */
export type KycBusinessAttributes = {
  readonly addressLine1: Scalars['String'];
  readonly addressLine2?: Maybe<Scalars['String']>;
  readonly businessSsn?: Maybe<Scalars['String']>;
  readonly city: Scalars['String'];
  readonly dbaName: Scalars['String'];
  readonly email: Scalars['String'];
  readonly foundedDate: Scalars['ISO8601DateTime'];
  readonly hasLiens: Scalars['Boolean'];
  readonly legalName: Scalars['String'];
  readonly mcc: Scalars['String'];
  readonly mccDescription: Scalars['String'];
  readonly phoneNumber: Scalars['String'];
  readonly productDescription?: Maybe<Scalars['String']>;
  readonly ratingScore: Scalars['String'];
  readonly ratingWebsite: Scalars['String'];
  readonly state: Scalars['String'];
  readonly taxId?: Maybe<Scalars['String']>;
  readonly url?: Maybe<Scalars['String']>;
  readonly yearlyRevenueInCents: Scalars['BigInt'];
  readonly zipCode: Scalars['String'];
};

/** Stores the information needed for the KYC person. */
export type KycPerson = {
  readonly __typename?: 'KycPerson';
  readonly addressLine1?: Maybe<Scalars['String']>;
  readonly addressLine2?: Maybe<Scalars['String']>;
  readonly birthday?: Maybe<Scalars['ISO8601DateTime']>;
  readonly city?: Maybe<Scalars['String']>;
  readonly email: Scalars['String'];
  readonly firstName: Scalars['String'];
  readonly id: Scalars['ID'];
  readonly kycBusiness: KycBusiness;
  readonly kycBusinessId: Scalars['String'];
  readonly lastName: Scalars['String'];
  readonly owner: Scalars['Boolean'];
  readonly phoneNumber?: Maybe<Scalars['String']>;
  readonly representative: Scalars['Boolean'];
  readonly state?: Maybe<Scalars['String']>;
  readonly stripeRequirements: StripeConnectAccountRequirements;
  readonly stripeVerificationStatus: StripePersonVerificationStatus;
  readonly title?: Maybe<Scalars['String']>;
  readonly zipCode?: Maybe<Scalars['String']>;
};

/** The form data for the kyc owner */
export type KycPersonAttributes = {
  readonly addressLine1?: Maybe<Scalars['String']>;
  readonly addressLine2?: Maybe<Scalars['String']>;
  readonly birthday?: Maybe<Scalars['ISO8601DateTime']>;
  readonly city?: Maybe<Scalars['String']>;
  readonly email: Scalars['String'];
  readonly firstName: Scalars['String'];
  readonly idNumber?: Maybe<Scalars['String']>;
  readonly lastName: Scalars['String'];
  readonly owner: Scalars['Boolean'];
  readonly phoneNumber?: Maybe<Scalars['String']>;
  readonly representative: Scalars['Boolean'];
  readonly ssnLastFour?: Maybe<Scalars['String']>;
  readonly state?: Maybe<Scalars['String']>;
  readonly title?: Maybe<Scalars['String']>;
  readonly zipCode?: Maybe<Scalars['String']>;
};

/** The connection type for KycPerson. */
export type KycPersonConnection = {
  readonly __typename?: 'KycPersonConnection';
  /** A list of edges. */
  readonly edges?: Maybe<ReadonlyArray<Maybe<KycPersonEdge>>>;
  /** A list of nodes. */
  readonly nodes?: Maybe<ReadonlyArray<Maybe<KycPerson>>>;
  /** Information to aid in pagination. */
  readonly pageInfo: PageInfo;
  readonly totalCount: Scalars['Int'];
};

/** An edge in a connection. */
export type KycPersonEdge = {
  readonly __typename?: 'KycPersonEdge';
  /** A cursor for use in pagination. */
  readonly cursor: Scalars['String'];
  /** The item at the end of the edge. */
  readonly node?: Maybe<KycPerson>;
};

/** Requirements for the KYC re-apply flow */
export type KycRequirement = {
  readonly __typename?: 'KycRequirement';
  readonly createdAt: Scalars['ISO8601DateTime'];
  readonly group: KycRequirementGroup;
  readonly id: Scalars['ID'];
  readonly kycBusiness: KycBusiness;
  readonly kycBusinessId: Scalars['String'];
  readonly requiredFields: ReadonlyArray<Scalars['String']>;
  readonly resolvedAt?: Maybe<Scalars['ISO8601DateTime']>;
  readonly resolvedReason?: Maybe<KycRequirementResolvedReason>;
  readonly updatedAt: Scalars['ISO8601DateTime'];
};

/** The connection type for KycRequirement. */
export type KycRequirementConnection = {
  readonly __typename?: 'KycRequirementConnection';
  /** A list of edges. */
  readonly edges?: Maybe<ReadonlyArray<Maybe<KycRequirementEdge>>>;
  /** A list of nodes. */
  readonly nodes?: Maybe<ReadonlyArray<Maybe<KycRequirement>>>;
  /** Information to aid in pagination. */
  readonly pageInfo: PageInfo;
  readonly totalCount: Scalars['Int'];
};

/** An edge in a connection. */
export type KycRequirementEdge = {
  readonly __typename?: 'KycRequirementEdge';
  /** A cursor for use in pagination. */
  readonly cursor: Scalars['String'];
  /** The item at the end of the edge. */
  readonly node?: Maybe<KycRequirement>;
};

export enum KycRequirementGroup {
  INVALID_COMPANY_REVIEW = 'invalid_company_review',
  INVALID_SOS = 'invalid_sos',
  INVALID_WEBSITE = 'invalid_website'
}

export enum KycRequirementResolvedReason {
  ALL_FIELDS_COLLECTED = 'all_fields_collected',
  ALTERNATIVE_REQUIREMENT_RESOLVED = 'alternative_requirement_resolved',
  MANUALLY_COLLECTED = 'manually_collected'
}

export enum LearnCenterLifecycle {
  COMPLETE_LIFECYCLE = 'COMPLETE_LIFECYCLE',
  DEFAULT_LIFECYCLE = 'DEFAULT_LIFECYCLE',
  FUND_LIFECYCLE = 'FUND_LIFECYCLE',
  NO_COMPLETES_LIFECYCLE = 'NO_COMPLETES_LIFECYCLE',
  QUALIFIED_LIFECYCLE = 'QUALIFIED_LIFECYCLE'
}

/** An input type for the loan application */
export type LoanApplicationAttributes = {
  readonly heapAnonymousId?: Maybe<Scalars['String']>;
  readonly homeownerCalling?: Maybe<Scalars['String']>;
  readonly intentContractAgreed?: Maybe<Scalars['Boolean']>;
  readonly intentContractText?: Maybe<Scalars['String']>;
  readonly jointApplication?: Maybe<Scalars['Boolean']>;
  readonly loanPrincipal?: Maybe<Scalars['String']>;
  readonly maxQual?: Maybe<Scalars['Boolean']>;
  readonly monthlyHousingCosts?: Maybe<Scalars['String']>;
  readonly projectType?: Maybe<Scalars['String']>;
  readonly terms?: Maybe<Scalars['String']>;
  readonly termsString?: Maybe<Scalars['String']>;
  readonly wvContractSigned?: Maybe<Scalars['Boolean']>;
};

/** Come on, you know what a loan inquiry is */
export type LoanInquiry = {
  readonly __typename?: 'LoanInquiry';
  readonly address?: Maybe<Scalars['String']>;
  readonly city?: Maybe<Scalars['String']>;
  readonly coapplicant?: Maybe<Homeowner>;
  readonly contractor?: Maybe<Contractor>;
  readonly createdAt: Scalars['ISO8601DateTime'];
  readonly deletedByContractor?: Maybe<Scalars['Boolean']>;
  readonly email?: Maybe<Scalars['String']>;
  readonly employmentStatus?: Maybe<Scalars['String']>;
  readonly fico?: Maybe<Scalars['String']>;
  readonly fieldsComplete: Scalars['Boolean'];
  readonly firstName?: Maybe<Scalars['String']>;
  readonly fullName?: Maybe<Scalars['String']>;
  readonly hearthUid?: Maybe<Scalars['String']>;
  readonly highestOffer?: Maybe<Offer>;
  readonly homeowner?: Maybe<Homeowner>;
  readonly householdIncome?: Maybe<Scalars['Int']>;
  readonly id: Scalars['ID'];
  readonly income?: Maybe<Scalars['String']>;
  readonly jointApplication: Scalars['Boolean'];
  readonly lastName?: Maybe<Scalars['String']>;
  readonly loanInquiryUuid: Scalars['ID'];
  readonly loanPrincipal?: Maybe<Scalars['Int']>;
  readonly lowestOffer?: Maybe<Offer>;
  readonly maxAmountByLender?: Maybe<Scalars['Int']>;
  readonly maxOffer?: Maybe<Scalars['Float']>;
  readonly maxQualAmount: Scalars['Int'];
  readonly minAmountByLender?: Maybe<Scalars['Int']>;
  readonly minOffer?: Maybe<Scalars['Float']>;
  readonly monthlyPaymentMax?: Maybe<Scalars['Int']>;
  readonly monthlyPaymentMin?: Maybe<Scalars['Int']>;
  readonly offers?: Maybe<OfferConnection>;
  readonly organization?: Maybe<Organization>;
  readonly phoneNumber?: Maybe<Scalars['String']>;
  readonly projectType?: Maybe<Scalars['String']>;
  readonly qualified: Scalars['Boolean'];
  readonly rateCap?: Maybe<Scalars['Float']>;
  readonly recommendedLoanAmount?: Maybe<Scalars['Int']>;
  readonly remainingCoapplicantFields?: Maybe<ReadonlyArray<Scalars['String']>>;
  readonly remainingFields?: Maybe<ReadonlyArray<Scalars['String']>>;
  readonly requestedAmount?: Maybe<Scalars['Int']>;
  readonly requestedOffer?: Maybe<Offer>;
  readonly state?: Maybe<Scalars['String']>;
  readonly status: Scalars['String'];
  readonly stubbedCall?: Maybe<Scalars['Boolean']>;
  readonly totalOffers: Scalars['Int'];
  readonly zeroPercentCards: Scalars['Boolean'];
  readonly zipCode?: Maybe<Scalars['String']>;
};


/** Come on, you know what a loan inquiry is */
export type LoanInquiryOffersArgs = {
  after?: Maybe<Scalars['String']>;
  before?: Maybe<Scalars['String']>;
  first?: Maybe<Scalars['Int']>;
  last?: Maybe<Scalars['Int']>;
};

/** The connection type for LoanInquiry. */
export type LoanInquiryConnection = {
  readonly __typename?: 'LoanInquiryConnection';
  /** A list of edges. */
  readonly edges?: Maybe<ReadonlyArray<Maybe<LoanInquiryEdge>>>;
  /** A list of nodes. */
  readonly nodes?: Maybe<ReadonlyArray<Maybe<LoanInquiry>>>;
  /** Information to aid in pagination. */
  readonly pageInfo: PageInfo;
  readonly totalCount: Scalars['Int'];
};

/** An edge in a connection. */
export type LoanInquiryEdge = {
  readonly __typename?: 'LoanInquiryEdge';
  /** A cursor for use in pagination. */
  readonly cursor: Scalars['String'];
  /** The item at the end of the edge. */
  readonly node?: Maybe<LoanInquiry>;
};

/** Autogenerated return type of ManuallyPayConnectInvoice */
export type ManuallyPayConnectInvoicePayload = {
  readonly __typename?: 'ManuallyPayConnectInvoicePayload';
  readonly connectInvoice: ConnectInvoice;
  readonly errors?: Maybe<ReadonlyArray<ValidationError>>;
};

export type ManuallyPayInvoiceFailure = {
  readonly __typename?: 'ManuallyPayInvoiceFailure';
  readonly errors: ReadonlyArray<Error>;
};

export type ManuallyPayInvoiceResult = ManuallyPayInvoiceFailure | ManuallyPayInvoiceSuccess;

export type ManuallyPayInvoiceSuccess = {
  readonly __typename?: 'ManuallyPayInvoiceSuccess';
  readonly connectInvoice: ConnectInvoice;
};

export type MarkConnectInvoiceFirstViewedAtFailure = {
  readonly __typename?: 'MarkConnectInvoiceFirstViewedAtFailure';
  readonly errors: ReadonlyArray<Error>;
};

export type MarkConnectInvoiceFirstViewedAtResult = MarkConnectInvoiceFirstViewedAtFailure | MarkConnectInvoiceFirstViewedAtSuccess;

export type MarkConnectInvoiceFirstViewedAtSuccess = {
  readonly __typename?: 'MarkConnectInvoiceFirstViewedAtSuccess';
  readonly connectInvoice?: Maybe<ConnectInvoice>;
};

export type MarkHomeownerFinancingLinkSentFailure = {
  readonly __typename?: 'MarkHomeownerFinancingLinkSentFailure';
  readonly errors: ReadonlyArray<Error>;
};

export type MarkHomeownerFinancingLinkSentResult = MarkHomeownerFinancingLinkSentFailure | MarkHomeownerFinancingLinkSentSuccess;

export type MarkHomeownerFinancingLinkSentSuccess = {
  readonly __typename?: 'MarkHomeownerFinancingLinkSentSuccess';
  readonly homeowner?: Maybe<Homeowner>;
};

export type MarkReadAllNotificationsFailure = {
  readonly __typename?: 'MarkReadAllNotificationsFailure';
  readonly errors: ReadonlyArray<Error>;
};

export type MarkReadAllNotificationsResult = MarkReadAllNotificationsFailure | MarkReadAllNotificationsSuccess;

export type MarkReadAllNotificationsSuccess = {
  readonly __typename?: 'MarkReadAllNotificationsSuccess';
  readonly contractor: Contractor;
};

/** Come on, you know what a member invite is */
export type MemberInvite = {
  readonly __typename?: 'MemberInvite';
  readonly email: Scalars['String'];
  readonly id: Scalars['ID'];
  readonly lastSentAt?: Maybe<Scalars['ISO8601DateTime']>;
  readonly organization: Organization;
  readonly preunlock?: Maybe<Scalars['Boolean']>;
  readonly reminderSentAt?: Maybe<Scalars['ISO8601DateTime']>;
};

/** The connection type for MemberInvite. */
export type MemberInviteConnection = {
  readonly __typename?: 'MemberInviteConnection';
  /** A list of edges. */
  readonly edges?: Maybe<ReadonlyArray<Maybe<MemberInviteEdge>>>;
  /** A list of nodes. */
  readonly nodes?: Maybe<ReadonlyArray<Maybe<MemberInvite>>>;
  /** Information to aid in pagination. */
  readonly pageInfo: PageInfo;
  readonly totalCount: Scalars['Int'];
};

/** An edge in a connection. */
export type MemberInviteEdge = {
  readonly __typename?: 'MemberInviteEdge';
  /** A cursor for use in pagination. */
  readonly cursor: Scalars['String'];
  /** The item at the end of the edge. */
  readonly node?: Maybe<MemberInvite>;
};

/** Input type for basic attributes needed to create a homeowner */
export type MinimalHomeownerAttributes = {
  readonly email: Scalars['String'];
  readonly firstName: Scalars['String'];
  readonly lastName: Scalars['String'];
  readonly phoneNumber: Scalars['String'];
};

export type ModifyPaymentsRoleFailure = {
  readonly __typename?: 'ModifyPaymentsRoleFailure';
  readonly errors: ReadonlyArray<Error>;
};

export type ModifyPaymentsRoleResult = ModifyPaymentsRoleFailure | ModifyPaymentsRoleSuccess;

export type ModifyPaymentsRoleSuccess = {
  readonly __typename?: 'ModifyPaymentsRoleSuccess';
  readonly contractor?: Maybe<Contractor>;
};

/** Monthly payment calculation */
export type MonthlyPaymentCalculation = {
  readonly __typename?: 'MonthlyPaymentCalculation';
  readonly ficoBucket: Scalars['String'];
  readonly id: Scalars['ID'];
  readonly loanTermInMonths: Scalars['String'];
  readonly maxApr: Scalars['Float'];
  readonly maxPaymentBucket: Scalars['Float'];
  readonly minApr: Scalars['Float'];
  readonly minPaymentBucket: Scalars['Float'];
};

/** The connection type for MonthlyPaymentCalculation. */
export type MonthlyPaymentCalculationConnection = {
  readonly __typename?: 'MonthlyPaymentCalculationConnection';
  /** A list of edges. */
  readonly edges?: Maybe<ReadonlyArray<Maybe<MonthlyPaymentCalculationEdge>>>;
  /** A list of nodes. */
  readonly nodes?: Maybe<ReadonlyArray<Maybe<MonthlyPaymentCalculation>>>;
  /** Information to aid in pagination. */
  readonly pageInfo: PageInfo;
  readonly totalCount: Scalars['Int'];
};

/** An edge in a connection. */
export type MonthlyPaymentCalculationEdge = {
  readonly __typename?: 'MonthlyPaymentCalculationEdge';
  /** A cursor for use in pagination. */
  readonly cursor: Scalars['String'];
  /** The item at the end of the edge. */
  readonly node?: Maybe<MonthlyPaymentCalculation>;
};

export type Mutation = {
  readonly __typename?: 'Mutation';
  /** Close account by account id. */
  readonly CloseGinzaAccount: ModelsModifyAccountResponse;
  /** Close card by ID */
  readonly CloseGinzaCard: ModelsUpdateCardResponse;
  /** creates account. */
  readonly CreateGinzaAccount: ModelsDepositAccountResource;
  /**
   * Attempts to create an unit business bank account URL with appropriate prefill
   * information. If one exists it returns 409 and the existing record.
   */
  readonly CreateGinzaApplicationForm: ModelsApplicationFormResponse;
  /** Create a new card by type */
  readonly CreateGinzaCard: ModelsCardCreationResponse;
  /** Create a couterparty without instant verification */
  readonly CreateGinzaCounterparty: ModelsCounterpartyResponseResource;
  /** Attempts to create an fee. */
  readonly CreateGinzaFee: ModelsFeeResponseResource;
  /** Create an organization's onboarding status */
  readonly CreateGinzaOnboarding: ModelsOnboardingFlowResponse;
  /** Delete counterparty by given ID. */
  readonly DeleteGinzaCounterpartyById: ModelsDeleteCounterpartyResponse;
  /** Freeze account by account id. */
  readonly FreezeGinzaAccount: ModelsModifyAccountResponse;
  /** Freeze card by ID */
  readonly FreezeGinzaCard: ModelsUpdateCardResponse;
  /** Get a tokenverification by customer id. */
  readonly GetGinzaCustomerTokenVerification: ModelsCustomerTokenVerificationResponse;
  /** reopen account by account id. */
  readonly ReopenGinzaAccount: ModelsModifyAccountResponse;
  /** Replace card by ID */
  readonly ReplaceGinzaCard: ModelsReplaceCardResponse;
  /** Report a lost card by ID */
  readonly ReportGinzaLostCard: ModelsUpdateCardResponse;
  /** Report a stolen card by ID */
  readonly ReportGinzaStolenCard: ModelsUpdateCardResponse;
  /** Unfreeze account by account id. */
  readonly UnfreezeGinzaAccount: ModelsModifyAccountResponse;
  /** Unfreeze card by ID */
  readonly UnfreezeGinzaCard: ModelsUpdateCardResponse;
  /** relinks existing counterparty with a new Plaid processor token. */
  readonly UpdateGinzaCounterpartyById: ModelsCounterpartyResponseResource;
  /** Update an organization's onboarding status */
  readonly UpdateGinzaOnboarding: ModelsOnboardingFlowResponse;
  readonly addPlaidTokenToConnectInvoice?: Maybe<AddPlaidTokenToConnectInvoiceResult>;
  readonly archiveHomeowner?: Maybe<ArchiveHomeownerResult>;
  readonly cancelConnectInvoice?: Maybe<CancelConnectInvoicePayload>;
  readonly cancelInvoice?: Maybe<CancelInvoiceResult>;
  readonly claimHearthRewardsGiftcard?: Maybe<ClaimHearthRewardsGiftcardResult>;
  readonly clientAllInOneRequestForm?: Maybe<AllInOneRequestFormResult>;
  readonly connectInvoiceRequestOnlinePayments?: Maybe<ConnectInvoiceRequestOnlinePaymentsResult>;
  readonly connectWistia?: Maybe<ConnectWistiaResult>;
  readonly contractGeneratorRestGeneratePdf: ContractGeneratorRestGeneratePdfResult;
  readonly contractServiceAccountCreate?: Maybe<ContractServiceAccountCreateResult>;
  readonly contractServiceCancelContract?: Maybe<ContractServiceCancelContractResult>;
  readonly contractServiceContractTemplateDelete?: Maybe<ContractServiceTemplateDeleteResult>;
  readonly contractServiceContractTemplateDeleteByName?: Maybe<ContractServiceTemplateDeleteByNameResult>;
  readonly contractServiceContractTemplateUpsert?: Maybe<ContractServiceTemplateUpsertResult>;
  readonly contractServiceContractTemplateVersionUpsert?: Maybe<ContractServiceTemplateVersionUpsertResult>;
  readonly contractServiceCreateContract?: Maybe<ContractServiceCreateContractResult>;
  readonly contractServiceMarkDefaultTemplate?: Maybe<ContractServiceMarkDefaultTemplateResult>;
  readonly contractServiceResendProjectContract?: Maybe<ContractServiceResendProjectContractResult>;
  readonly contractServiceSignTerms?: Maybe<ContractServiceSignTermsResult>;
  readonly contractServiceSigningLinkFetch?: Maybe<ContractServiceSigningLinkFetchResult>;
  readonly createConnectInvoice?: Maybe<CreateConnectInvoiceResult>;
  readonly createConnectPayout?: Maybe<CreateConnectPayoutResult>;
  readonly createHomeowner?: Maybe<CreateHomeownerPayload>;
  readonly createHomeownerAndSendFinancingInfo?: Maybe<CreateHomeownerAndSendFinancingInfoResult>;
  readonly createInsightsFeedback?: Maybe<CreateInsightsFeedbackResult>;
  readonly createLoanInquiryFromExisting?: Maybe<CreateLoanInquiryFromExistingResult>;
  readonly createLoginLink?: Maybe<CreateLoginLinkResult>;
  readonly createMagicLink?: Maybe<CreateMagicLinkPayload>;
  readonly createStripePayout?: Maybe<CreateStripePayoutPayload>;
  readonly deactivateContractor?: Maybe<DeactivateContractorResult>;
  readonly exportPaymentData?: Maybe<ExportPaymentDataResult>;
  readonly generateApiToken?: Maybe<GenerateApiTokenResult>;
  readonly getStripeAccountLink?: Maybe<GetStripeAccountLinkResult>;
  readonly homeownerResendOffersEmail?: Maybe<HomeownerResendOffersEmailResult>;
  readonly kycSubmitVerificationDocuments?: Maybe<SubmitVerificationDocumentsResult>;
  readonly manuallyPayConnectInvoice?: Maybe<ManuallyPayConnectInvoicePayload>;
  readonly manuallyPayInvoice?: Maybe<ManuallyPayInvoiceResult>;
  readonly markConnectInvoiceFirstViewedAt?: Maybe<MarkConnectInvoiceFirstViewedAtResult>;
  readonly markHomeownerFinancingLinkSent?: Maybe<MarkHomeownerFinancingLinkSentResult>;
  readonly markReadAllNotifications?: Maybe<MarkReadAllNotificationsResult>;
  readonly modifyPaymentsRole?: Maybe<ModifyPaymentsRoleResult>;
  readonly payConnectInvoice?: Maybe<PayConnectInvoiceResult>;
  readonly paymentsSetupAddExternalAccount?: Maybe<AttachExternalAccountResult>;
  readonly paymentsSetupAttachPlaidBankAccountToConnectAccount?: Maybe<AttachPlaidBankAccountToConnectAccountResult>;
  readonly paymentsSetupDeletePerson?: Maybe<DeletePersonResult>;
  readonly paymentsSetupSubmitApplication?: Maybe<SubmitApplicationResult>;
  readonly paymentsSetupSubmitBusinessInfo?: Maybe<SubmitBusinessInfoResult>;
  readonly paymentsSetupSubmitPersonInfo?: Maybe<SubmitPersonInfoResult>;
  readonly purchasePaymentsAddOn?: Maybe<PurchasePaymentsAddOnResult>;
  readonly quoteAccountCreate?: Maybe<QuoteAccountCreateResult>;
  readonly quoteAssociateContract?: Maybe<QuoteAssociateContractResult>;
  readonly quoteCancel?: Maybe<QuoteCancelResult>;
  readonly quoteCreate?: Maybe<QuoteCreateResult>;
  readonly quoteHomeownerAccept?: Maybe<QuoteHomeownerAcceptResult>;
  readonly quoteHomeownerDecline?: Maybe<QuoteHomeownerDeclineResult>;
  readonly quoteHomeownerRequestChanges?: Maybe<QuoteHomeownerRequestChangesResult>;
  readonly quoteResend?: Maybe<QuoteResendResult>;
  readonly quoteTemplateCreate?: Maybe<QuoteTemplateCreateResult>;
  readonly quoteTemplateDestroy?: Maybe<QuoteTemplateDestroyResult>;
  readonly quoteTemplateUpdate?: Maybe<QuoteTemplateUpdateResult>;
  readonly quoteUploadCreate?: Maybe<QuoteUploadCreateResult>;
  readonly quoteUploadDocument?: Maybe<QuoteUploadDocumentResult>;
  readonly quoteUploadPhoto?: Maybe<QuoteUploadPhotoResult>;
  readonly quoteViewed?: Maybe<QuoteViewedResult>;
  readonly recordPersonalizeDashboardResponse?: Maybe<RecordHearthOnboardingPersonalizeDashboardResponseResult>;
  readonly recordQuickPollResponse?: Maybe<RecordQuickPollResponseResult>;
  readonly refundConnectInvoice?: Maybe<RefundConnectInvoiceResult>;
  readonly removePlaidTokenFromConnectInvoice?: Maybe<RemovePlaidTokenFromConnectInvoiceResult>;
  readonly resendMemberInviteEmail?: Maybe<ResendMemberInviteEmailResult>;
  readonly scheduleWebinar?: Maybe<ScheduleWebinarResult>;
  readonly sendContractorSampleInvoice?: Maybe<SendContractorSampleInvoicePayload>;
  readonly sendDefaultFinancingInfo?: Maybe<SendDefaultFinancingInfoResult>;
  readonly sendEmailLead?: Maybe<SendEmailLeadResult>;
  readonly sendExampleReminder?: Maybe<SendExampleReminderPayload>;
  readonly sendHearthAppDownloadLink?: Maybe<SendHearthAppDownloadLinkResult>;
  readonly sendHomeownerPaymentReminder?: Maybe<SendHomeownerPaymentReminderPayload>;
  readonly sendInviteAndScheduleWebinar?: Maybe<SendInviteAndScheduleWebinarResult>;
  readonly sendMemberInvites?: Maybe<SendMemberInvitesResult>;
  readonly sendResetPasswordLink?: Maybe<SendResetPasswordLinkResult>;
  readonly sendSamplePaymentRequest?: Maybe<SendSamplePaymentRequestResult>;
  readonly setHearthUid: Session;
  readonly signAccountContract?: Maybe<SignAccountContractResult>;
  readonly submitLoanInquiry?: Maybe<SubmitLoanInquiryPayload>;
  readonly suggestedActionClick?: Maybe<SuggestedActionClickResult>;
  readonly suggestedActionClickCta?: Maybe<ClickCtaResult>;
  readonly suggestedActionDismiss?: Maybe<SuggestedActionDismissResult>;
  readonly switchEnterpriseOrg?: Maybe<SwitchEnterpriseOrgResult>;
  readonly updateAcceptedPayments?: Maybe<UpdateAcceptedPaymentsResult>;
  readonly updateCoapplicant?: Maybe<UpdateCoapplicantPayload>;
  readonly updateConnectInvoicePaymentsCapabilityStatus?: Maybe<UpdateConnectInvoicePaymentsCapabilityStatusResult>;
  readonly updateContractor?: Maybe<UpdateContractorPayload>;
  readonly updateHackathonHomeowner?: Maybe<UpdateHackathonHomeownerLeadResult>;
  readonly updateHomeowner?: Maybe<UpdateHomeownerResult>;
  readonly updateLoanInquiry?: Maybe<UpdateLoanInquiryPayload>;
  readonly updateOrganization?: Maybe<UpdateOrganizationPayload>;
  readonly updatePresaleCourseVideoInteraction?: Maybe<UpsertPresaleCourseVideoInteractionPayload>;
  readonly updateQuickbooksSyncSettings?: Maybe<UpdateQuickbooksSyncSettingsResult>;
  readonly updateReminderSetting?: Maybe<UpdateReminderSettingResult>;
  readonly updateReminderSettings?: Maybe<UpdateReminderSettingsPayload>;
  readonly updateResources?: Maybe<UpdateResourcesPayload>;
  readonly updateStripeConnectAccount?: Maybe<UpdateStripeConnectAccountResult>;
  readonly upsertArticleInteraction?: Maybe<UpsertArticleInteractionResult>;
  readonly upsertContractor?: Maybe<UpsertContractorResult>;
  readonly upsertCustomizedInvoiceTemplate?: Maybe<UpsertCustomizedInvoiceTemplateResult>;
  readonly upsertHomeowner?: Maybe<UpsertHomeownerResult>;
  readonly upsertHomeownerFinancingFeedback?: Maybe<UpsertHomeownerFinancingFeedbackResult>;
  readonly upsertHomeownerPaymentsFeedback?: Maybe<UpsertHomeownerPaymentsFeedbackResult>;
  readonly upsertNotification?: Maybe<UpsertNotificationResult>;
  readonly upsertOrganization?: Maybe<UpsertOrganizationResult>;
  readonly upsertTemplate?: Maybe<UpsertTemplateResult>;
};


export type MutationCloseGinzaAccountArgs = {
  accountID: Scalars['String'];
};


export type MutationCloseGinzaCardArgs = {
  cardID: Scalars['String'];
};


export type MutationCreateGinzaAccountArgs = {
  Body: ModelsCreateAccountRequestBodyInput;
};


export type MutationCreateGinzaApplicationFormArgs = {
  orgID: Scalars['String'];
};


export type MutationCreateGinzaCardArgs = {
  Body: ModelsCreateCardRequestInput;
};


export type MutationCreateGinzaCounterpartyArgs = {
  Body: ModelsCreateCounterpartyRequestInput;
};


export type MutationCreateGinzaFeeArgs = {
  Body: ModelsCreateFeeRequestBodyInput;
};


export type MutationCreateGinzaOnboardingArgs = {
  orgID: Scalars['String'];
};


export type MutationDeleteGinzaCounterpartyByIdArgs = {
  counterpartyID: Scalars['String'];
};


export type MutationFreezeGinzaAccountArgs = {
  Body: ModelsFreezeAccountRequestInput;
};


export type MutationFreezeGinzaCardArgs = {
  cardID: Scalars['String'];
};


export type MutationGetGinzaCustomerTokenVerificationArgs = {
  customerID: Scalars['String'];
};


export type MutationReopenGinzaAccountArgs = {
  accountID: Scalars['String'];
};


export type MutationReplaceGinzaCardArgs = {
  Body: ModelsReplaceCardRequestInput;
  cardID: Scalars['String'];
};


export type MutationReportGinzaLostCardArgs = {
  cardID: Scalars['String'];
};


export type MutationReportGinzaStolenCardArgs = {
  cardID: Scalars['String'];
};


export type MutationUnfreezeGinzaAccountArgs = {
  accountID: Scalars['String'];
};


export type MutationUnfreezeGinzaCardArgs = {
  cardID: Scalars['String'];
};


export type MutationUpdateGinzaCounterpartyByIdArgs = {
  Body: ModelsUpdateCounterpartyRequestInput;
  counterpartyID: Scalars['String'];
};


export type MutationUpdateGinzaOnboardingArgs = {
  Body: ModelsOnboardingFlowRequestInput;
  orgID: Scalars['String'];
};


export type MutationAddPlaidTokenToConnectInvoiceArgs = {
  connectInvoiceId: Scalars['ID'];
  plaidAccountId: Scalars['String'];
  plaidPublicToken: Scalars['String'];
};


export type MutationArchiveHomeownerArgs = {
  archive: Scalars['Boolean'];
  contractorId: Scalars['ID'];
  homeownerId: Scalars['ID'];
};


export type MutationCancelConnectInvoiceArgs = {
  connectInvoiceId: Scalars['ID'];
};


export type MutationCancelInvoiceArgs = {
  connectInvoiceId: Scalars['ID'];
};


export type MutationClaimHearthRewardsGiftcardArgs = {
  contractorId?: Maybe<Scalars['ID']>;
};


export type MutationClientAllInOneRequestFormArgs = {
  financingAttributes?: Maybe<FinancingParams>;
  homeownerAttributes?: Maybe<MinimalHomeownerAttributes>;
  homeownerId?: Maybe<Scalars['ID']>;
  invoiceAttributes?: Maybe<ReadonlyArray<ConnectInvoiceParams>>;
  mediums: ReadonlyArray<ContactMedium>;
  paymentIncludesFinancing?: Maybe<Scalars['Boolean']>;
};


export type MutationConnectInvoiceRequestOnlinePaymentsArgs = {
  connectInvoiceId: Scalars['ID'];
};


export type MutationConnectWistiaArgs = {
  contractorId: Scalars['ID'];
};


export type MutationContractGeneratorRestGeneratePdfArgs = {
  input: ContractGeneratorRestGeneratePdfInput;
};


export type MutationContractServiceCancelContractArgs = {
  contractServiceContractId: Scalars['ID'];
};


export type MutationContractServiceContractTemplateDeleteArgs = {
  contractServiceContractTemplateId: Scalars['ID'];
};


export type MutationContractServiceContractTemplateDeleteByNameArgs = {
  versionName: Scalars['String'];
};


export type MutationContractServiceContractTemplateUpsertArgs = {
  contractServiceAccountId: Scalars['ID'];
  templateParams: ContractTemplateParams;
};


export type MutationContractServiceContractTemplateVersionUpsertArgs = {
  contractServiceAccountId: Scalars['ID'];
  templateParams: ContractTemplateVersioningParams;
};


export type MutationContractServiceCreateContractArgs = {
  attachedInvoiceParams?: Maybe<ConnectInvoiceParams>;
  dueDate: Scalars['ISO8601DateTime'];
  files?: Maybe<ReadonlyArray<File>>;
  homeownerId: Scalars['ID'];
  mediums: ReadonlyArray<ContactMedium>;
  name?: Maybe<Scalars['String']>;
  personalNote?: Maybe<Scalars['String']>;
  renderArgs?: Maybe<Scalars['JSON']>;
  renderedHtml: Scalars['String'];
  sendFinancingLink?: Maybe<Scalars['Boolean']>;
  templateId: Scalars['ID'];
};


export type MutationContractServiceMarkDefaultTemplateArgs = {
  contractServiceContractTemplateId: Scalars['ID'];
};


export type MutationContractServiceResendProjectContractArgs = {
  contractServiceContractId: Scalars['ID'];
};


export type MutationContractServiceSignTermsArgs = {
  contractServiceAccountId: Scalars['String'];
  termsAgreed: Scalars['String'];
};


export type MutationContractServiceSigningLinkFetchArgs = {
  contractServiceSignatureId: Scalars['ID'];
  signingToken: Scalars['String'];
};


export type MutationCreateConnectInvoiceArgs = {
  achEnabled?: Maybe<Scalars['Boolean']>;
  amountRequested: Scalars['Int'];
  attachmentIds?: Maybe<ReadonlyArray<Scalars['String']>>;
  cardEnabled?: Maybe<Scalars['Boolean']>;
  contractorId?: Maybe<Scalars['ID']>;
  creditCardEnabled?: Maybe<Scalars['Boolean']>;
  customerPaysAchFee?: Maybe<Scalars['Boolean']>;
  customerPaysCardFee?: Maybe<Scalars['Boolean']>;
  debitCardEnabled?: Maybe<Scalars['Boolean']>;
  description: Scalars['String'];
  dueDate: Scalars['ISO8601DateTime'];
  homeownerId: Scalars['ID'];
  mediums: ReadonlyArray<ContactMedium>;
  personalNote?: Maybe<Scalars['String']>;
  scheduledDate?: Maybe<Scalars['ISO8601DateTime']>;
};


export type MutationCreateConnectPayoutArgs = {
  amountInCents: Scalars['Int'];
  contractorId: Scalars['ID'];
  destination: Scalars['String'];
  instant: Scalars['Boolean'];
};


export type MutationCreateHomeownerArgs = {
  contractorId?: Maybe<Scalars['ID']>;
  email: Scalars['String'];
  firstName: Scalars['String'];
  lastName: Scalars['String'];
  phoneNumber: Scalars['String'];
};


export type MutationCreateHomeownerAndSendFinancingInfoArgs = {
  attributes: MinimalHomeownerAttributes;
  financingParams: SendFinancingParams;
};


export type MutationCreateInsightsFeedbackArgs = {
  feedback: Scalars['String'];
  type: InsightsFeedback;
};


export type MutationCreateLoanInquiryFromExistingArgs = {
  loanInquiryUuid: Scalars['String'];
  loanPrincipal: Scalars['Int'];
  submit?: Maybe<Scalars['Boolean']>;
  terms: Scalars['Boolean'];
  termsString: Scalars['String'];
};


export type MutationCreateLoginLinkArgs = {
  contractorId?: Maybe<Scalars['ID']>;
};


export type MutationCreateMagicLinkArgs = {
  contractorId: Scalars['ID'];
};


export type MutationCreateStripePayoutArgs = {
  amountInCents: Scalars['Int'];
  contractorId: Scalars['ID'];
  destination: Scalars['String'];
  instant: Scalars['Boolean'];
};


export type MutationDeactivateContractorArgs = {
  contractorId: Scalars['ID'];
};


export type MutationExportPaymentDataArgs = {
  type: ExportPaymentData;
};


export type MutationGenerateApiTokenArgs = {
  organizationId?: Maybe<Scalars['ID']>;
};


export type MutationGetStripeAccountLinkArgs = {
  organizationId: Scalars['ID'];
  refreshUrl: Scalars['String'];
  returnUrl: Scalars['String'];
  type: Scalars['String'];
};


export type MutationHomeownerResendOffersEmailArgs = {
  addressTo: Scalars['String'];
  loanInquiryUuid: Scalars['ID'];
};


export type MutationKycSubmitVerificationDocumentsArgs = {
  kycBusinessId: Scalars['ID'];
  removedUploadIds?: Maybe<ReadonlyArray<Scalars['String']>>;
  uploads?: Maybe<ReadonlyArray<DocumentAttributes>>;
};


export type MutationManuallyPayConnectInvoiceArgs = {
  connectInvoiceId: Scalars['ID'];
  paymentDate: Scalars['ISO8601DateTime'];
  paymentType: Scalars['String'];
};


export type MutationManuallyPayInvoiceArgs = {
  connectInvoiceId: Scalars['ID'];
  paymentDate: Scalars['ISO8601DateTime'];
  paymentType: Scalars['String'];
};


export type MutationMarkConnectInvoiceFirstViewedAtArgs = {
  connectInvoiceId: Scalars['ID'];
};


export type MutationMarkHomeownerFinancingLinkSentArgs = {
  homeownerId: Scalars['ID'];
  linkSentParams: SentFinancingParams;
};


export type MutationMarkReadAllNotificationsArgs = {
  contractorId?: Maybe<Scalars['ID']>;
};


export type MutationModifyPaymentsRoleArgs = {
  contractorId: Scalars['ID'];
  newPaymentsRole: PaymentsRole;
};


export type MutationPayConnectInvoiceArgs = {
  cardType?: Maybe<StripeChargeCard>;
  connectInvoiceId: Scalars['ID'];
  homeownerTermsAgreed: Scalars['String'];
  token?: Maybe<Scalars['String']>;
};


export type MutationPaymentsSetupAddExternalAccountArgs = {
  externalAccountToken: Scalars['String'];
  stripeConnectAccountId: Scalars['ID'];
};


export type MutationPaymentsSetupAttachPlaidBankAccountToConnectAccountArgs = {
  kycBusinessId: Scalars['ID'];
  plaidAccountId: Scalars['String'];
  plaidPublicToken: Scalars['String'];
  stripeConnectAccountId: Scalars['ID'];
};


export type MutationPaymentsSetupDeletePersonArgs = {
  kycPersonId: Scalars['ID'];
  stripeConnectAccountId: Scalars['ID'];
};


export type MutationPaymentsSetupSubmitApplicationArgs = {
  reapplication: Scalars['Boolean'];
  stripeConnectAccountId: Scalars['ID'];
};


export type MutationPaymentsSetupSubmitBusinessInfoArgs = {
  kycBusinessData: KycBusinessAttributes;
  stripeConnectAccountId: Scalars['ID'];
};


export type MutationPaymentsSetupSubmitPersonInfoArgs = {
  kycPersonData: KycPersonAttributes;
  kycPersonId?: Maybe<Scalars['ID']>;
  stripeConnectAccountId: Scalars['ID'];
};


export type MutationPurchasePaymentsAddOnArgs = {
  contractId: Scalars['ID'];
  organizationId: Scalars['ID'];
};


export type MutationQuoteAccountCreateArgs = {
  termsString: Scalars['String'];
};


export type MutationQuoteAssociateContractArgs = {
  contractServiceContractId: Scalars['ID'];
  quoteId: Scalars['ID'];
};


export type MutationQuoteCancelArgs = {
  quoteId: Scalars['ID'];
};


export type MutationQuoteCreateArgs = {
  description: Scalars['String'];
  discountInCents: Scalars['Int'];
  documentUploadIds: ReadonlyArray<Scalars['ID']>;
  expiresAt: Scalars['ISO8601DateTime'];
  homeownerAddressId: Scalars['ID'];
  lineItems: ReadonlyArray<QuoteLineItemParams>;
  mediums?: Maybe<ReadonlyArray<ContactMedium>>;
  name: Scalars['String'];
  personalNote?: Maybe<Scalars['String']>;
  photoUploadIds: ReadonlyArray<Scalars['ID']>;
  priorQuoteId?: Maybe<Scalars['ID']>;
  quoteTemplateId: Scalars['ID'];
  showFinancing?: Maybe<Scalars['Boolean']>;
  theme: OrganizationTheme;
  totalFeesInCents: Scalars['Int'];
  totalTaxInCents: Scalars['Int'];
};


export type MutationQuoteHomeownerAcceptArgs = {
  quoteId: Scalars['ID'];
};


export type MutationQuoteHomeownerDeclineArgs = {
  quoteId: Scalars['ID'];
};


export type MutationQuoteHomeownerRequestChangesArgs = {
  changesRequested: Scalars['String'];
  quoteId: Scalars['ID'];
};


export type MutationQuoteResendArgs = {
  quoteId: Scalars['ID'];
};


export type MutationQuoteTemplateCreateArgs = {
  description: Scalars['String'];
  discountInCents: Scalars['Int'];
  lineItems: ReadonlyArray<TemplateLineItemParams>;
  name: Scalars['String'];
  theme: QuoteTheme;
  totalFeesInCents: Scalars['Int'];
  totalTaxInCents: Scalars['Int'];
};


export type MutationQuoteTemplateDestroyArgs = {
  quoteTemplateId: Scalars['ID'];
};


export type MutationQuoteTemplateUpdateArgs = {
  description: Scalars['String'];
  discountInCents?: Maybe<Scalars['Int']>;
  lineItems: ReadonlyArray<TemplateLineItemUpdateParams>;
  name: Scalars['String'];
  quoteTemplateId: Scalars['ID'];
  theme: OrganizationTheme;
  totalFeesInCents?: Maybe<Scalars['Int']>;
  totalTaxInCents?: Maybe<Scalars['Int']>;
};


export type MutationQuoteUploadCreateArgs = {
  base64String: Scalars['ID'];
  filename: Scalars['ID'];
  quoteAccountId: Scalars['ID'];
  uploadType: Scalars['ID'];
};


export type MutationQuoteUploadDocumentArgs = {
  document: Scalars['Upload'];
};


export type MutationQuoteUploadPhotoArgs = {
  document: Scalars['Upload'];
};


export type MutationQuoteViewedArgs = {
  contractorId: Scalars['ID'];
  quoteId: Scalars['ID'];
};


export type MutationRecordPersonalizeDashboardResponseArgs = {
  organizationId?: Maybe<Scalars['ID']>;
  response: ReadonlyArray<HearthOnboardingResponseAttributes>;
};


export type MutationRecordQuickPollResponseArgs = {
  contractorId?: Maybe<Scalars['ID']>;
  response: Scalars['JSON'];
};


export type MutationRefundConnectInvoiceArgs = {
  amount: Scalars['Int'];
  connectInvoiceId: Scalars['ID'];
  description?: Maybe<Scalars['String']>;
  reasonType?: Maybe<ConnectRefundReason>;
};


export type MutationRemovePlaidTokenFromConnectInvoiceArgs = {
  connectInvoiceId: Scalars['ID'];
};


export type MutationResendMemberInviteEmailArgs = {
  memberInviteId: Scalars['ID'];
};


export type MutationScheduleWebinarArgs = {
  contractorId: Scalars['ID'];
  sessionId: Scalars['String'];
  trainingScheduledAt: Scalars['ISO8601DateTime'];
};


export type MutationSendContractorSampleInvoiceArgs = {
  contractorId: Scalars['ID'];
};


export type MutationSendDefaultFinancingInfoArgs = {
  homeownerId: Scalars['ID'];
  mediums: ReadonlyArray<ContactMedium>;
};


export type MutationSendEmailLeadArgs = {
  contractorId: Scalars['ID'];
  emails?: Maybe<Scalars['String']>;
  file?: Maybe<Scalars['String']>;
};


export type MutationSendExampleReminderArgs = {
  contractorId: Scalars['ID'];
};


export type MutationSendHearthAppDownloadLinkArgs = {
  contractorId?: Maybe<Scalars['ID']>;
};


export type MutationSendHomeownerPaymentReminderArgs = {
  connectInvoiceId: Scalars['ID'];
  mediums: ReadonlyArray<ContactMedium>;
};


export type MutationSendInviteAndScheduleWebinarArgs = {
  emails: ReadonlyArray<Scalars['String']>;
  sessionId: Scalars['String'];
  trainingScheduledAt: Scalars['ISO8601DateTime'];
};


export type MutationSendMemberInvitesArgs = {
  emails: ReadonlyArray<Scalars['String']>;
  organizationId?: Maybe<Scalars['ID']>;
};


export type MutationSendResetPasswordLinkArgs = {
  contractorId?: Maybe<Scalars['ID']>;
  email?: Maybe<Scalars['String']>;
};


export type MutationSendSamplePaymentRequestArgs = {
  contractorId?: Maybe<Scalars['ID']>;
};


export type MutationSetHearthUidArgs = {
  hearthUid: Scalars['String'];
};


export type MutationSignAccountContractArgs = {
  contractId: Scalars['ID'];
  organizationId?: Maybe<Scalars['ID']>;
  stripeTosAcceptance?: Maybe<Scalars['Boolean']>;
};


export type MutationSubmitLoanInquiryArgs = {
  loanInquiryUuid: Scalars['String'];
};


export type MutationSuggestedActionClickArgs = {
  suggestedActionId: Scalars['ID'];
};


export type MutationSuggestedActionClickCtaArgs = {
  id: Scalars['ID'];
};


export type MutationSuggestedActionDismissArgs = {
  suggestedActionId: Scalars['ID'];
};


export type MutationSwitchEnterpriseOrgArgs = {
  organizationId: Scalars['ID'];
};


export type MutationUpdateAcceptedPaymentsArgs = {
  attributes: AcceptedPaymentsAttributes;
  id?: Maybe<Scalars['ID']>;
};


export type MutationUpdateCoapplicantArgs = {
  coapplicantAttributes: ApplicantAttributes;
  loanInquiryUuid: Scalars['String'];
};


export type MutationUpdateConnectInvoicePaymentsCapabilityStatusArgs = {
  achEnabled: Scalars['Boolean'];
  connectInvoiceId: Scalars['ID'];
  creditCardEnabled: Scalars['Boolean'];
  debitCardEnabled: Scalars['Boolean'];
};


export type MutationUpdateContractorArgs = {
  attributes?: Maybe<ContractorAttributes>;
  customSettings?: Maybe<CustomContractorSettingsAttributes>;
  id: Scalars['ID'];
};


export type MutationUpdateHackathonHomeownerArgs = {
  contractorId?: Maybe<Scalars['ID']>;
  homeownerId?: Maybe<Scalars['ID']>;
};


export type MutationUpdateHomeownerArgs = {
  attributes: HomeownerAttributes;
  homeownerId: Scalars['ID'];
};


export type MutationUpdateLoanInquiryArgs = {
  applicantAttributes?: Maybe<ApplicantAttributes>;
  applicationAttributes?: Maybe<LoanApplicationAttributes>;
  loanInquiryUuid: Scalars['String'];
};


export type MutationUpdateOrganizationArgs = {
  organizationAttributes?: Maybe<OrganizationAttributes>;
  organizationId: Scalars['ID'];
};


export type MutationUpdatePresaleCourseVideoInteractionArgs = {
  articleContentfulId?: Maybe<Scalars['String']>;
  articleId?: Maybe<Scalars['ID']>;
  articleInteractableId?: Maybe<Scalars['String']>;
  articleInteractableType?: Maybe<ArticleInteractable>;
  interactionType: ArticleInteractionType;
  interactionValue?: Maybe<Scalars['String']>;
  metadata?: Maybe<Scalars['JSON']>;
  presaleLeadId: Scalars['String'];
};


export type MutationUpdateQuickbooksSyncSettingsArgs = {
  quickbooksBusinessId: Scalars['ID'];
  settings: QuickbooksBusinessSettings;
};


export type MutationUpdateReminderSettingArgs = {
  enable: Scalars['Boolean'];
  reminderSettingId: Scalars['ID'];
};


export type MutationUpdateReminderSettingsArgs = {
  enable: Scalars['Boolean'];
  settingId: Scalars['ID'];
};


export type MutationUpdateResourcesArgs = {
  category: Scalars['String'];
  key: Scalars['String'];
  type: Scalars['String'];
  value: Scalars['String'];
  valuesMap: ReadonlyArray<Scalars['String']>;
};


export type MutationUpdateStripeConnectAccountArgs = {
  attributes: StripeConnectAccountAttributes;
  stripeConnectAccountId: Scalars['ID'];
};


export type MutationUpsertArticleInteractionArgs = {
  articleContentfulId?: Maybe<Scalars['String']>;
  articleId?: Maybe<Scalars['ID']>;
  articleInteractableId?: Maybe<Scalars['String']>;
  articleInteractableType?: Maybe<ArticleInteractable>;
  interactionType: ArticleInteractionType;
  interactionValue?: Maybe<Scalars['String']>;
  metadata?: Maybe<Scalars['JSON']>;
};


export type MutationUpsertContractorArgs = {
  attributes?: Maybe<ContractorAttributes>;
  contractorId?: Maybe<Scalars['ID']>;
  customSettings?: Maybe<CustomContractorSettingsAttributes>;
};


export type MutationUpsertCustomizedInvoiceTemplateArgs = {
  contractorId?: Maybe<Scalars['ID']>;
  templateAttributes: CustomizedInvoiceTemplateAttributes;
};


export type MutationUpsertHomeownerArgs = {
  contractorId?: Maybe<Scalars['ID']>;
  defaultAddress?: Maybe<AddressAttributes>;
  email: Scalars['String'];
  firstName: Scalars['String'];
  homeownerId?: Maybe<Scalars['ID']>;
  lastName: Scalars['String'];
  phoneNumber: Scalars['String'];
};


export type MutationUpsertHomeownerFinancingFeedbackArgs = {
  attributes: HomeownerFeedbackResponseAttributes;
  uuid: Scalars['ID'];
};


export type MutationUpsertHomeownerPaymentsFeedbackArgs = {
  attributes: HomeownerFeedbackResponseAttributes;
  connectInvoiceId: Scalars['ID'];
};


export type MutationUpsertNotificationArgs = {
  attributes?: Maybe<NotificationAttributes>;
  notificationId: Scalars['ID'];
};


export type MutationUpsertOrganizationArgs = {
  attributes: OrganizationAttributes;
  organizationId?: Maybe<Scalars['ID']>;
};


export type MutationUpsertTemplateArgs = {
  templateId: Scalars['ID'];
  templateString: Scalars['String'];
};

/** Come on, you know what a notification is */
export type Notification = {
  readonly __typename?: 'Notification';
  readonly createdAt: Scalars['ISO8601DateTime'];
  readonly ctaContent?: Maybe<Scalars['String']>;
  readonly id: Scalars['ID'];
  readonly linkContent?: Maybe<Scalars['String']>;
  readonly notificationContent?: Maybe<Scalars['String']>;
  readonly notificationTypeCategory: NotificationCategory;
  readonly notificationTypeName: NotificationName;
  readonly popupContent?: Maybe<Scalars['String']>;
  readonly popupTitle?: Maybe<Scalars['String']>;
  readonly readAt?: Maybe<Scalars['ISO8601DateTime']>;
};

export type NotificationAttributes = {
  readonly readAt?: Maybe<Scalars['ISO8601DateTime']>;
};

export enum NotificationCategory {
  CONTRACTOR_REMINDER = 'contractor_reminder',
  DIRECTIONAL = 'directional',
  HOMEOWNER_REMINDER = 'homeowner_reminder',
  HOMEOWNER_REQUEST = 'homeowner_request',
  MODAL = 'modal',
  POP_UP = 'pop_up'
}

/** The connection type for Notification. */
export type NotificationConnection = {
  readonly __typename?: 'NotificationConnection';
  /** A list of edges. */
  readonly edges?: Maybe<ReadonlyArray<Maybe<NotificationEdge>>>;
  /** A list of nodes. */
  readonly nodes?: Maybe<ReadonlyArray<Maybe<Notification>>>;
  /** Information to aid in pagination. */
  readonly pageInfo: PageInfo;
  readonly totalCount: Scalars['Int'];
};

/** An edge in a connection. */
export type NotificationEdge = {
  readonly __typename?: 'NotificationEdge';
  /** A cursor for use in pagination. */
  readonly cursor: Scalars['String'];
  /** The item at the end of the edge. */
  readonly node?: Maybe<Notification>;
};

export enum NotificationName {
  AB_TESTING_FIRST_FUND = 'ab_testing_first_fund',
  AB_TESTING_FUND = 'ab_testing_fund',
  AB_TESTING_PREQUAL = 'ab_testing_prequal',
  ACCOUNT_BALANCE = 'account_balance',
  CASE_STUDY_NOTIFICATION = 'case_study_notification',
  COMPLETE_REMINDER = 'complete_reminder',
  CREDIT_CARD_FUND = 'credit_card_fund',
  CREDIT_CARD_SELECT = 'credit_card_select',
  DENIED = 'denied',
  FIRST_APP_BAD_COMPLETE_REJECTION = 'first_app_bad_complete_rejection',
  FIRST_DENIAL = 'first_denial',
  FIRST_FUND = 'first_fund',
  FIRST_PREQUAL = 'first_prequal',
  FIRST_SELECT = 'first_select',
  FIRST_START = 'first_start',
  FIRST_WEB_BAD_COMPLETE_HIGH_APR = 'first_web_bad_complete_high_apr',
  FUND = 'fund',
  FUND_REMINDER = 'fund_reminder',
  FUNDED_LOAN_FEEDBACK = 'funded_loan_feedback',
  GAMIFICATION = 'gamification',
  HOMEOWNER_PAYMENT_DUE = 'homeowner_payment_due',
  HOMEOWNER_PAYMENT_OVERDUE = 'homeowner_payment_overdue',
  HOMEOWNER_PAYMENT_OVERDUE_3_DAYS = 'homeowner_payment_overdue_3_days',
  HOMEOWNER_PAYMENT_OVERDUE_7_DAYS = 'homeowner_payment_overdue_7_days',
  PAYMENT_ACH_AUTOMATED_MICRODEPOSIT_FAILED = 'payment_ach_automated_microdeposit_failed',
  PAYMENT_ACH_AUTOMATED_MICRODEPOSIT_SUCCESS = 'payment_ach_automated_microdeposit_success',
  PAYMENT_ACH_DECLINED = 'payment_ach_declined',
  PAYMENT_ACH_MANUAL_REMINDER = 'payment_ach_manual_reminder',
  PAYMENT_COMPLETE_FEEDBACK = 'payment_complete_feedback',
  PAYMENT_COMPLETED = 'payment_completed',
  PAYMENT_DUE = 'payment_due',
  PAYMENT_OVERDUE_3_DAYS = 'payment_overdue_3_days',
  PAYMENT_OVERDUE_7_DAYS = 'payment_overdue_7_days',
  PAYMENT_REFUND_FAILED = 'payment_refund_failed',
  PAYMENT_REQUEST = 'payment_request',
  PAYMENT_REQUEST_WITH_NOTE = 'payment_request_with_note',
  PREQUAL = 'prequal',
  PREQUAL_APP = 'prequal_app',
  PREQUAL_BANNER = 'prequal_banner',
  PREQUAL_MONTHLY_PAYMENTS = 'prequal_monthly_payments',
  PROCESSING = 'processing',
  QUOTE_ACCEPTED = 'quote_accepted',
  QUOTE_ALMOST_DUE = 'quote_almost_due',
  QUOTE_CHANGES_REQUESTED = 'quote_changes_requested',
  QUOTE_VIEWED = 'quote_viewed',
  REFERRAL = 'referral',
  SELECT = 'select',
  START = 'start',
  START_REMINDER = 'start_reminder',
  YETI_RAFFLE_ENTRY = 'yeti_raffle_entry'
}

/** Come on, you know what an offer is */
export type Offer = {
  readonly __typename?: 'Offer';
  readonly apr: Scalars['String'];
  readonly autopay?: Maybe<Scalars['Boolean']>;
  readonly clicked?: Maybe<Scalars['Boolean']>;
  readonly disclosure: Scalars['String'];
  readonly id: Scalars['ID'];
  readonly inMonthlyPaymentRange: Scalars['Boolean'];
  readonly join?: Maybe<Scalars['Boolean']>;
  readonly lender: Scalars['String'];
  readonly lenderImageSlug: Scalars['String'];
  readonly lenderName: Scalars['String'];
  readonly loanAmount: Scalars['Float'];
  readonly loanInquiry: LoanInquiry;
  readonly loanRate: Scalars['String'];
  readonly loanTermInMonths: Scalars['Int'];
  readonly monthlyPayment: Scalars['String'];
  readonly offerType: Scalars['String'];
  readonly originationFee?: Maybe<Scalars['Float']>;
  readonly primary?: Maybe<Scalars['Boolean']>;
  readonly redirectUrl: Scalars['String'];
  readonly score: Scalars['Float'];
  readonly secure?: Maybe<Scalars['Boolean']>;
  readonly totalCost?: Maybe<Scalars['Float']>;
};

/** The connection type for Offer. */
export type OfferConnection = {
  readonly __typename?: 'OfferConnection';
  /** A list of edges. */
  readonly edges?: Maybe<ReadonlyArray<Maybe<OfferEdge>>>;
  /** A list of nodes. */
  readonly nodes?: Maybe<ReadonlyArray<Maybe<Offer>>>;
  /** Information to aid in pagination. */
  readonly pageInfo: PageInfo;
  readonly totalCount: Scalars['Int'];
};

/** An edge in a connection. */
export type OfferEdge = {
  readonly __typename?: 'OfferEdge';
  /** A cursor for use in pagination. */
  readonly cursor: Scalars['String'];
  /** The item at the end of the edge. */
  readonly node?: Maybe<Offer>;
};

/** Come on, you know what an organization is */
export type Organization = {
  readonly __typename?: 'Organization';
  readonly activeContractorCount: Scalars['Int'];
  readonly activeSubscription: StripeSubscription;
  readonly address?: Maybe<Scalars['String']>;
  readonly addressLine2?: Maybe<Scalars['String']>;
  readonly analytics: OrganizationAnalytics;
  readonly answeredBusinessQuestions: Scalars['Boolean'];
  readonly answeredProjectLeads: Scalars['Boolean'];
  readonly apiToken?: Maybe<ApiToken>;
  readonly availableSeats: Scalars['Int'];
  readonly backgroundPicture?: Maybe<Scalars['String']>;
  readonly bannerInstalledAt?: Maybe<Scalars['ISO8601DateTime']>;
  readonly businessEmail?: Maybe<Scalars['String']>;
  readonly businessLicenseNumber?: Maybe<Scalars['String']>;
  readonly businessPhone?: Maybe<Scalars['String']>;
  readonly businessQuestionnaireResponse?: Maybe<QuestionnaireResponse>;
  readonly calendlyLink?: Maybe<Scalars['String']>;
  readonly canceledAt?: Maybe<Scalars['ISO8601DateTime']>;
  readonly city: Scalars['String'];
  readonly companyName: Scalars['String'];
  readonly companyType: Scalars['String'];
  readonly companyTypeLabel: Scalars['String'];
  readonly contractServiceAccount?: Maybe<ContractServiceAccount>;
  readonly contractors: ContractorConnection;
  readonly createdAt: Scalars['ISO8601DateTime'];
  readonly currentTransactionForNewPaymentsAccounts: PaymentsProductTransactionFees;
  readonly customSettings: CustomOrganizationSettings;
  readonly defaultTheme: OrganizationTheme;
  readonly descriptionOfOperations?: Maybe<Scalars['String']>;
  readonly earliestSubscription: StripeSubscription;
  readonly facebookUrl?: Maybe<Scalars['String']>;
  readonly featureFlags: ReadonlyArray<FeatureFlag>;
  readonly financingInsightsAmountData: FinancingInsightsAmount;
  readonly financingInsightsCustomerProfile: FinancingInsightsCustomerProfile;
  readonly financingInsightsFunnelData: FinancingInsightsFunnel;
  readonly financingInsightsTrendData: FinancingInsightsTrend;
  readonly financingOffered: Scalars['Int'];
  readonly firstFundDate?: Maybe<Scalars['ISO8601DateTime']>;
  readonly firstSignedUpAt: Scalars['ISO8601DateTime'];
  readonly firstUploadedLogoAt?: Maybe<Scalars['ISO8601DateTime']>;
  readonly fullAddress: Scalars['String'];
  readonly fullMailingAddress: Scalars['String'];
  readonly hasFinancing: Scalars['Boolean'];
  readonly hasPaymentsSystemInRecurly?: Maybe<Scalars['Boolean']>;
  readonly homeowners: HomeownerConnection;
  readonly homeownersFunded: Scalars['Int'];
  readonly id: Scalars['ID'];
  readonly infoSetting: Scalars['String'];
  readonly instagramUrl?: Maybe<Scalars['String']>;
  readonly insuranceEligible: Scalars['Boolean'];
  readonly kycBusiness?: Maybe<KycBusiness>;
  readonly kycSkippedAt?: Maybe<Scalars['ISO8601DateTime']>;
  readonly latitude?: Maybe<Scalars['String']>;
  readonly linkedinUrl?: Maybe<Scalars['String']>;
  readonly logo?: Maybe<Scalars['String']>;
  readonly logoUrl?: Maybe<Scalars['String']>;
  readonly longitude?: Maybe<Scalars['String']>;
  readonly mailingAddress?: Maybe<Scalars['String']>;
  readonly mailingAddressLineTwo?: Maybe<Scalars['String']>;
  readonly mailingCity?: Maybe<Scalars['String']>;
  readonly mailingState?: Maybe<Scalars['String']>;
  readonly mailingZipCode?: Maybe<Scalars['String']>;
  readonly memberInvites: MemberInviteConnection;
  /** @deprecated Deprecated in favor of setup_flow_completed_at */
  readonly onboarded: Scalars['Boolean'];
  readonly onboardedAt?: Maybe<Scalars['ISO8601DateTime']>;
  readonly outstandingMemberInvites: MemberInviteConnection;
  readonly partnership?: Maybe<Partnership>;
  readonly paymentsAddOnPricing?: Maybe<AddOnPricing>;
  readonly paymentsContract?: Maybe<Contract>;
  readonly planFeatureFlags: ReadonlyArray<FeatureFlag>;
  readonly planName: Scalars['String'];
  readonly quickbooksBusiness?: Maybe<QuickbooksBusiness>;
  readonly quoteAccount?: Maybe<QuoteAccount>;
  readonly rateCap?: Maybe<Scalars['Float']>;
  readonly recurlyDefaultPaymentMethod?: Maybe<RecurlyPaymentMethod>;
  readonly renewsAt?: Maybe<Scalars['ISO8601DateTime']>;
  readonly requireContract: Scalars['Boolean'];
  readonly rewardsFlagSetAt?: Maybe<Scalars['ISO8601DateTime']>;
  readonly sandboxOrg: Scalars['Boolean'];
  readonly sentMemberInvites?: Maybe<Scalars['Boolean']>;
  readonly settings: Scalars['JSON'];
  readonly setupFlowCompleted: Scalars['Boolean'];
  readonly setupFlowCompletedAt?: Maybe<Scalars['ISO8601DateTime']>;
  readonly state?: Maybe<Scalars['String']>;
  readonly statedNoTeam?: Maybe<Scalars['Boolean']>;
  readonly status: Scalars['String'];
  readonly stripeConnectAccount?: Maybe<StripeConnectAccount>;
  readonly stripeSubscriptions: StripeSubscriptionConnection;
  /** @deprecated Query the active_subscription on the organization directly */
  readonly subscriptionActivatedAt?: Maybe<Scalars['ISO8601DateTime']>;
  readonly subscriptionContract: SubscriptionContract;
  readonly subscriptionFeatureFlags: ReadonlyArray<FeatureFlag>;
  readonly totalSeats: Scalars['Int'];
  readonly trainingCallLink?: Maybe<Scalars['String']>;
  readonly twitterUrl?: Maybe<Scalars['String']>;
  readonly urlPath: Scalars['String'];
  readonly usedSeats: Scalars['Int'];
  readonly uuid: Scalars['String'];
  readonly verticalId: Scalars['ID'];
  readonly visibleConnectInvoices: ConnectInvoiceConnection;
  readonly website?: Maybe<Scalars['String']>;
  readonly zipCode?: Maybe<Scalars['String']>;
};


/** Come on, you know what an organization is */
export type OrganizationContractorsArgs = {
  after?: Maybe<Scalars['String']>;
  before?: Maybe<Scalars['String']>;
  first?: Maybe<Scalars['Int']>;
  last?: Maybe<Scalars['Int']>;
};


/** Come on, you know what an organization is */
export type OrganizationFinancingInsightsAmountDataArgs = {
  range: FinancingInsightsTimeRange;
  type: FinancingInsightsFilter;
};


/** Come on, you know what an organization is */
export type OrganizationFinancingInsightsCustomerProfileArgs = {
  range: FinancingInsightsTimeRange;
};


/** Come on, you know what an organization is */
export type OrganizationFinancingInsightsFunnelDataArgs = {
  range: FinancingInsightsTimeRange;
};


/** Come on, you know what an organization is */
export type OrganizationFinancingInsightsTrendDataArgs = {
  type: FinancingInsightsFilter;
};


/** Come on, you know what an organization is */
export type OrganizationHomeownersArgs = {
  after?: Maybe<Scalars['String']>;
  before?: Maybe<Scalars['String']>;
  first?: Maybe<Scalars['Int']>;
  last?: Maybe<Scalars['Int']>;
};


/** Come on, you know what an organization is */
export type OrganizationMemberInvitesArgs = {
  after?: Maybe<Scalars['String']>;
  before?: Maybe<Scalars['String']>;
  first?: Maybe<Scalars['Int']>;
  last?: Maybe<Scalars['Int']>;
};


/** Come on, you know what an organization is */
export type OrganizationOutstandingMemberInvitesArgs = {
  after?: Maybe<Scalars['String']>;
  before?: Maybe<Scalars['String']>;
  first?: Maybe<Scalars['Int']>;
  last?: Maybe<Scalars['Int']>;
};


/** Come on, you know what an organization is */
export type OrganizationStripeSubscriptionsArgs = {
  after?: Maybe<Scalars['String']>;
  before?: Maybe<Scalars['String']>;
  first?: Maybe<Scalars['Int']>;
  last?: Maybe<Scalars['Int']>;
};


/** Come on, you know what an organization is */
export type OrganizationVisibleConnectInvoicesArgs = {
  after?: Maybe<Scalars['String']>;
  before?: Maybe<Scalars['String']>;
  first?: Maybe<Scalars['Int']>;
  last?: Maybe<Scalars['Int']>;
};

/** Analytics for an organization */
export type OrganizationAnalytics = {
  readonly __typename?: 'OrganizationAnalytics';
  readonly averageFico?: Maybe<Scalars['Int']>;
  readonly averageIncome?: Maybe<Scalars['Float']>;
  readonly hearthAverageFico?: Maybe<Scalars['Int']>;
  readonly hearthAverageIncome?: Maybe<Scalars['Float']>;
  readonly hearthPrequalRate?: Maybe<Scalars['Float']>;
  readonly prequalRate?: Maybe<Scalars['Float']>;
  readonly returnOnInvestment?: Maybe<Scalars['String']>;
};

export type OrganizationAttributes = {
  readonly address?: Maybe<Scalars['String']>;
  readonly addressLine2?: Maybe<Scalars['String']>;
  readonly backgroundPicture?: Maybe<Scalars['String']>;
  readonly businessEmail?: Maybe<Scalars['String']>;
  readonly businessLicenseNumber?: Maybe<Scalars['String']>;
  readonly businessPhone?: Maybe<Scalars['String']>;
  readonly city?: Maybe<Scalars['String']>;
  readonly companyName?: Maybe<Scalars['String']>;
  readonly defaultTheme?: Maybe<OrganizationTheme>;
  readonly descriptionOfOperations?: Maybe<Scalars['String']>;
  readonly facebookUrl?: Maybe<Scalars['String']>;
  readonly fullAddress?: Maybe<Scalars['String']>;
  readonly infoSetting?: Maybe<Scalars['String']>;
  readonly instagramUrl?: Maybe<Scalars['String']>;
  readonly linkedinUrl?: Maybe<Scalars['String']>;
  readonly logo?: Maybe<Scalars['String']>;
  readonly logoUrl?: Maybe<Scalars['String']>;
  readonly mailingAddress?: Maybe<Scalars['String']>;
  readonly mailingAddressLineTwo?: Maybe<Scalars['String']>;
  readonly mailingCity?: Maybe<Scalars['String']>;
  readonly mailingState?: Maybe<Scalars['String']>;
  readonly mailingZipCode?: Maybe<Scalars['String']>;
  readonly rateCap?: Maybe<Scalars['Float']>;
  readonly requireContract?: Maybe<Scalars['Boolean']>;
  readonly setupFlowCompleted?: Maybe<Scalars['Boolean']>;
  readonly state?: Maybe<Scalars['String']>;
  readonly statedNoTeam?: Maybe<Scalars['Boolean']>;
  readonly twitterUrl?: Maybe<Scalars['String']>;
  readonly zipCode?: Maybe<Scalars['String']>;
};

/** The connection type for Organization. */
export type OrganizationConnection = {
  readonly __typename?: 'OrganizationConnection';
  /** A list of edges. */
  readonly edges?: Maybe<ReadonlyArray<Maybe<OrganizationEdge>>>;
  /** A list of nodes. */
  readonly nodes?: Maybe<ReadonlyArray<Maybe<Organization>>>;
  /** Information to aid in pagination. */
  readonly pageInfo: PageInfo;
  readonly totalCount: Scalars['Int'];
};

/** An edge in a connection. */
export type OrganizationEdge = {
  readonly __typename?: 'OrganizationEdge';
  /** A cursor for use in pagination. */
  readonly cursor: Scalars['String'];
  /** The item at the end of the edge. */
  readonly node?: Maybe<Organization>;
};

export enum OrganizationTheme {
  BLACK = 'black',
  BLUE = 'blue',
  BROWN = 'brown',
  GREEN = 'green',
  ORANGE = 'orange',
  PURPLE = 'purple',
  RED = 'red'
}

/** Information about pagination in a connection. */
export type PageInfo = {
  readonly __typename?: 'PageInfo';
  /** When paginating forwards, the cursor to continue. */
  readonly endCursor?: Maybe<Scalars['String']>;
  /** When paginating forwards, are there more items? */
  readonly hasNextPage: Scalars['Boolean'];
  /** When paginating backwards, are there more items? */
  readonly hasPreviousPage: Scalars['Boolean'];
  /** When paginating backwards, the cursor to continue. */
  readonly startCursor?: Maybe<Scalars['String']>;
};

/** Org partnership */
export type Partnership = {
  readonly __typename?: 'Partnership';
  readonly coupon?: Maybe<Scalars['String']>;
  readonly label?: Maybe<Scalars['String']>;
  readonly logoUrl?: Maybe<Scalars['String']>;
  readonly pageVariant?: Maybe<Scalars['String']>;
  readonly referralType?: Maybe<Scalars['String']>;
  readonly urlPath?: Maybe<Scalars['String']>;
};

export type PayConnectInvoiceFailure = {
  readonly __typename?: 'PayConnectInvoiceFailure';
  readonly errors: ReadonlyArray<Error>;
};

export type PayConnectInvoiceResult = PayConnectInvoiceFailure | PayConnectInvoiceSuccess;

export type PayConnectInvoiceSuccess = {
  readonly __typename?: 'PayConnectInvoiceSuccess';
  readonly connectInvoice?: Maybe<ConnectInvoice>;
};

/** Payment plans rate for a specific fico and month */
export type PaymentPlansApr = {
  readonly __typename?: 'PaymentPlansApr';
  readonly apr: Scalars['Float'];
  readonly loanTermInMonths: Scalars['Int'];
};

/** Payment plans rate for a specific fico */
export type PaymentPlansRate = {
  readonly __typename?: 'PaymentPlansRate';
  readonly fico: Scalars['String'];
  readonly rates: ReadonlyArray<PaymentPlansApr>;
};

export enum PaymentsCapabilityStatus {
  DISABLED = 'disabled',
  ENABLED = 'enabled'
}

export enum PaymentsHearthVerificationStatus {
  CLEARED = 'cleared',
  DECLINED = 'declined',
  ESCALATED = 'escalated',
  HIGH_RISK = 'high_risk',
  INCOMPLETE = 'incomplete',
  PENDING_VERIFICATION = 'pending_verification'
}

/** Payments product signup intent object */
export type PaymentsProductSignupIntent = {
  readonly __typename?: 'PaymentsProductSignupIntent';
  readonly achFeeFixedAmount: Scalars['Int'];
  readonly achFeePercentageAmount: Scalars['Float'];
  readonly cardFeeFixedAmount: Scalars['Int'];
  readonly cardFeePercentageAmount: Scalars['Float'];
  readonly id: Scalars['ID'];
  readonly paymentSubscriptionId: Scalars['ID'];
};

/** The connection type for PaymentsProductSignupIntent. */
export type PaymentsProductSignupIntentConnection = {
  readonly __typename?: 'PaymentsProductSignupIntentConnection';
  /** A list of edges. */
  readonly edges?: Maybe<ReadonlyArray<Maybe<PaymentsProductSignupIntentEdge>>>;
  /** A list of nodes. */
  readonly nodes?: Maybe<ReadonlyArray<Maybe<PaymentsProductSignupIntent>>>;
  /** Information to aid in pagination. */
  readonly pageInfo: PageInfo;
  readonly totalCount: Scalars['Int'];
};

/** An edge in a connection. */
export type PaymentsProductSignupIntentEdge = {
  readonly __typename?: 'PaymentsProductSignupIntentEdge';
  /** A cursor for use in pagination. */
  readonly cursor: Scalars['String'];
  /** The item at the end of the edge. */
  readonly node?: Maybe<PaymentsProductSignupIntent>;
};

export type PaymentsProductTransactionFees = {
  readonly __typename?: 'PaymentsProductTransactionFees';
  readonly achFeeFixedAmount: Scalars['Int'];
  readonly achFeePercentageAmount: Scalars['Float'];
  readonly cardFeeFixedAmount: Scalars['Int'];
  readonly cardFeePercentageAmount: Scalars['Float'];
};

export enum PaymentsRole {
  ADMIN = 'Admin',
  BLOCKED = 'Blocked',
  REQUEST = 'Request'
}

/** PayoutType for stripe payouts */
export type Payout = {
  readonly __typename?: 'Payout';
  readonly amountInCents: Scalars['Int'];
  readonly stripePayoutId: Scalars['ID'];
};

/** Plaid account type */
export type PlaidAccount = {
  readonly __typename?: 'PlaidAccount';
  readonly id: Scalars['ID'];
  readonly mask: Scalars['String'];
  readonly name: Scalars['String'];
  readonly subtype: Scalars['String'];
  readonly type: Scalars['String'];
  readonly verificationStatus: PlaidVerificationStatus;
  readonly verified: Scalars['Boolean'];
};

export enum PlaidVerificationStatus {
  AUTOMATICALLY_VERIFIED = 'automatically_verified',
  MANUALLY_VERIFIED = 'manually_verified',
  PENDING_AUTOMATIC_VERIFICATION = 'pending_automatic_verification',
  PENDING_MANUAL_VERIFICATION = 'pending_manual_verification',
  VERIFICATION_FAILED = 'verification_failed'
}

/** Describes a type of user who has access to the presale course */
export type PresaleLead = {
  readonly __typename?: 'PresaleLead';
  readonly articleInteractions: ArticleInteractionConnection;
  readonly courseCompletedAt?: Maybe<Scalars['ISO8601DateTime']>;
  readonly createdAt: Scalars['ISO8601DateTime'];
  readonly email: Scalars['String'];
  readonly firstName: Scalars['String'];
  readonly id: Scalars['ID'];
  readonly lastName: Scalars['String'];
  readonly marketoUuid?: Maybe<Scalars['String']>;
  readonly salesforceLeadId?: Maybe<Scalars['String']>;
};


/** Describes a type of user who has access to the presale course */
export type PresaleLeadArticleInteractionsArgs = {
  after?: Maybe<Scalars['String']>;
  before?: Maybe<Scalars['String']>;
  first?: Maybe<Scalars['Int']>;
  last?: Maybe<Scalars['Int']>;
  whereId?: Maybe<Scalars['String']>;
  whereType?: Maybe<Scalars['String']>;
};

export type PurchasePaymentsAddOnFailure = {
  readonly __typename?: 'PurchasePaymentsAddOnFailure';
  readonly errors: ReadonlyArray<Error>;
};

export type PurchasePaymentsAddOnResult = PurchasePaymentsAddOnFailure | PurchasePaymentsAddOnSuccess;

export type PurchasePaymentsAddOnSuccess = {
  readonly __typename?: 'PurchasePaymentsAddOnSuccess';
  readonly organization: Organization;
};

export type Query = {
  readonly __typename?: 'Query';
  /** Creates a plaid link token to initiate a connection unit (hearth) bank account and existing bank account. */
  readonly CreateGinzaPlaidLinkToken: ModelsPlaidLinkTokenResponse;
  /** Look up an account by ID. */
  readonly GetGinzaAccount: ModelsGetAccountResponse;
  /** Get account balance history by account id. */
  readonly GetGinzaAccountBalance: ReadonlyArray<ModelsGetDepositAccountBalanceHistoryResponse>;
  /** Get account limits by account id. */
  readonly GetGinzaAccountLimits: ModelsGetDepositAccountLimitsResponse;
  /** Get all accounts. */
  readonly GetGinzaAccounts: ReadonlyArray<ModelsGetAccountResponse>;
  /** Get application form by given ID. */
  readonly GetGinzaApplicationForm: ModelsApplicationFormResponse;
  /** Get all application forms. */
  readonly GetGinzaApplicationForms: ReadonlyArray<ModelsApplicationFormResponse>;
  /** Get card by given ID. */
  readonly GetGinzaCardByID: ModelsGetCardResource;
  /** Get a card's limits by ID */
  readonly GetGinzaCardLimitsByID: ModelsGetCardLimitResource;
  /** Get a list of cards */
  readonly GetGinzaCards: ReadonlyArray<ModelsGetCardResource>;
  /** List counterparties */
  readonly GetGinzaCounterparties: ReadonlyArray<ModelsCounterpartyResponseResource>;
  /** Get counterparty balance by given ID. */
  readonly GetGinzaCounterpartyBalanceById: ModelsGetCounterpartyBalanceResponse;
  /** Get counterparty by given ID. */
  readonly GetGinzaCounterpartyById: ModelsCounterpartyResponseResource;
  /** Get customer by given ID. */
  readonly GetGinzaCustomer: ModelsGetCustomerResponse;
  /** Get customer balance history by account id. */
  readonly GetGinzaCustomerBalance: ReadonlyArray<ModelsGetDepositAccountBalanceHistoryResponse>;
  /** Get all customers if OrgID present, and Get the customer if OrgID not present. */
  readonly GetGinzaCustomers: ReadonlyArray<ModelsGetCustomersResponse>;
  /** Get the status of an organization's onboarding */
  readonly GetGinzaOnboarding: ModelsOnboardingFlowResponse;
  /** Look up a payment by ID. */
  readonly GetGinzaPayment: ModelsPaymentResource;
  /** Looks up a statement. */
  readonly GetGinzaStatement: ModelsGetStatement;
  /** Looks up a list of statements filtered by account | customer ID. */
  readonly GetGinzaStatementsList: ReadonlyArray<ModelsGetStatementResponse>;
  /** Get a transaction by given ID */
  readonly GetGinzaTransaction: ModelsGetTransactionResponse;
  /** Get list of transactions */
  readonly GetGinzaTransactionsList: ReadonlyArray<ModelsGetTransactionResponse>;
  /** Returns connect activity given invoice id and activity type id */
  readonly connectActivity?: Maybe<ConnectActivity>;
  /** Returns a Connect Invoice object */
  readonly connectInvoice: ConnectInvoice;
  /** All visible connect invoices for an organization or contractor */
  readonly connectInvoices?: Maybe<ConnectInvoiceConnection>;
  readonly contentful: Contentful;
  /** Returns the latest version of the base template with the provided type */
  readonly contractServiceBaseTemplate: ContractServiceBaseTemplate;
  /** Returns ContractServiceContract */
  readonly contractServiceContract?: Maybe<ContractServiceContract>;
  /** Returns the latest personalized template with the provided type */
  readonly contractServiceContractTemplate?: Maybe<ContractServiceContractTemplate>;
  /** Returns contract service signature */
  readonly contractServiceSignature?: Maybe<ContractServiceSignature>;
  /** Returns a contractor by uuid. Defaults to current_contractor */
  readonly contractor?: Maybe<Contractor>;
  /** Returns a customized invoice template object */
  readonly customizedInvoiceTemplate: CustomizedInvoiceTemplate;
  /** Returns customized invoice templates for a contractor */
  readonly customizedInvoiceTemplates: CustomizedInvoiceTemplateConnection;
  /** Fetch all active feature flags associated to the current user */
  readonly featureFlags: ReadonlyArray<FeatureFlag>;
  /** Fetch all related items to a Hearth Uid */
  readonly hearthUidSelector?: Maybe<HearthUidSelector>;
  /** Fetch a homeowner by its id */
  readonly homeowner?: Maybe<Homeowner>;
  /** Returns a HomeownerAddressType */
  readonly homeownerAddress?: Maybe<HomeownerAddress>;
  /** Returns homeowner feedback response given a UUID */
  readonly homeownerFeedbackResponse?: Maybe<HomeownerFeedbackResponse>;
  /** Homeowner monthly payment calculation for Homeowner flow */
  readonly homeownerPaymentCalculation?: Maybe<HomeownerPaymentCalculationConnection>;
  /** Filter and sorting for homeowners */
  readonly homeownerSearch: HomeownerConnection;
  /** A connection of homeowners for an organization or contractor */
  readonly homeowners?: Maybe<HomeownerConnection>;
  /** webinars */
  readonly livestormWebinars?: Maybe<ReadonlyArray<Webinar>>;
  /** Fetches a loan inquiry by loan inquiry uuid */
  readonly loanInquiry?: Maybe<LoanInquiry>;
  /** Returns authentication token if successful login */
  readonly login?: Maybe<Authentication>;
  /** Monthly payment calculation for a given fico and loan term */
  readonly monthlyPaymentCalculation?: Maybe<MonthlyPaymentCalculationConnection>;
  /** All monthly payment calculations */
  readonly monthlyPaymentCalculations: MonthlyPaymentCalculationConnection;
  /** Returns a organization by uuid. */
  readonly organization?: Maybe<Organization>;
  /** Fetch the payments product signup intent object */
  readonly paymentsProductSignupIntent?: Maybe<PaymentsProductSignupIntentConnection>;
  /** Fetches a presale user by id, given email as authorization */
  readonly presaleLead?: Maybe<PresaleLead>;
  /** Fetches loan inquiries by email and birthday */
  readonly qualifiedLoanInquiries?: Maybe<LoanInquiryConnection>;
  /** A specific questionnaire by id */
  readonly questionnaire?: Maybe<Questionnaire>;
  /** A list of all of our questionnaires */
  readonly questionnaires: QuestionnaireConnection;
  /**
   * Returns a QuoteType. Meant to be used when viewing a Quote as a Homeowner, and
   * so will have a restricted set of permissions.
   */
  readonly quote?: Maybe<Quote>;
  /** Returns a QuoteAccountType */
  readonly quoteAccount?: Maybe<QuoteAccount>;
  /** Returns a QuoteTemplateType */
  readonly quoteTemplate?: Maybe<QuoteTemplate>;
  /** Returns a QuoteTemplateType */
  readonly quoteTemplateLineItem?: Maybe<QuoteLineItem>;
  /** Returns a QuoteUploadType */
  readonly quoteUpload?: Maybe<QuoteUpload>;
  /** Fetch reminder setting by required types. */
  readonly reminderSetting?: Maybe<ReminderSetting>;
  /** Returns resource availabilities by category and type. */
  readonly resource?: Maybe<Resource>;
  readonly serverConstants: ServerConstants;
  readonly session: Session;
  /** Returns stripe connect account fields */
  readonly stripeConnectAccount?: Maybe<StripeConnectAccount>;
  /** Template */
  readonly template?: Maybe<Template>;
};


export type QueryCreateGinzaPlaidLinkTokenArgs = {
  org_id: Scalars['String'];
};


export type QueryGetGinzaAccountArgs = {
  accountID: Scalars['String'];
};


export type QueryGetGinzaAccountBalanceArgs = {
  accountID: Scalars['String'];
  endDate?: Maybe<Scalars['String']>;
  startDate?: Maybe<Scalars['String']>;
};


export type QueryGetGinzaAccountLimitsArgs = {
  accountID: Scalars['String'];
};


export type QueryGetGinzaAccountsArgs = {
  orgID?: Maybe<Scalars['String']>;
};


export type QueryGetGinzaApplicationFormArgs = {
  formID: Scalars['String'];
};


export type QueryGetGinzaApplicationFormsArgs = {
  orgID?: Maybe<Scalars['String']>;
};


export type QueryGetGinzaCardByIdArgs = {
  cardID: Scalars['String'];
};


export type QueryGetGinzaCardLimitsByIdArgs = {
  cardID: Scalars['String'];
};


export type QueryGetGinzaCardsArgs = {
  accountId?: Maybe<Scalars['String']>;
  customerId?: Maybe<Scalars['String']>;
  limit?: Maybe<Scalars['String']>;
  offset?: Maybe<Scalars['String']>;
  query?: Maybe<Scalars['String']>;
};


export type QueryGetGinzaCounterpartiesArgs = {
  customerId?: Maybe<Scalars['String']>;
  limit?: Maybe<Scalars['String']>;
  offset?: Maybe<Scalars['String']>;
};


export type QueryGetGinzaCounterpartyBalanceByIdArgs = {
  counterpartyID: Scalars['String'];
};


export type QueryGetGinzaCounterpartyByIdArgs = {
  counterpartyID: Scalars['String'];
};


export type QueryGetGinzaCustomerArgs = {
  customerID: Scalars['String'];
};


export type QueryGetGinzaCustomerBalanceArgs = {
  customerID: Scalars['String'];
  endDate?: Maybe<Scalars['String']>;
  startDate?: Maybe<Scalars['String']>;
};


export type QueryGetGinzaCustomersArgs = {
  org_id?: Maybe<Scalars['String']>;
};


export type QueryGetGinzaOnboardingArgs = {
  orgID: Scalars['String'];
};


export type QueryGetGinzaPaymentArgs = {
  paymentID: Scalars['String'];
};


export type QueryGetGinzaStatementArgs = {
  statementID: Scalars['String'];
  statementType: Scalars['String'];
};


export type QueryGetGinzaStatementsListArgs = {
  ID: Scalars['String'];
};


export type QueryGetGinzaTransactionArgs = {
  transactionID: Scalars['String'];
};


export type QueryGetGinzaTransactionsListArgs = {
  accountId?: Maybe<Scalars['String']>;
  limit?: Maybe<Scalars['String']>;
  offset?: Maybe<Scalars['String']>;
  organizationId?: Maybe<Scalars['String']>;
  query?: Maybe<Scalars['String']>;
  since?: Maybe<Scalars['String']>;
  until?: Maybe<Scalars['String']>;
};


export type QueryConnectActivityArgs = {
  activityTypeId?: Maybe<Scalars['ID']>;
  id?: Maybe<Scalars['ID']>;
  invoiceId?: Maybe<Scalars['ID']>;
};


export type QueryConnectInvoiceArgs = {
  id: Scalars['ID'];
};


export type QueryConnectInvoicesArgs = {
  after?: Maybe<Scalars['String']>;
  before?: Maybe<Scalars['String']>;
  first?: Maybe<Scalars['Int']>;
  last?: Maybe<Scalars['Int']>;
  status?: Maybe<ReadonlyArray<Maybe<ConnectInvoiceStatus>>>;
};


export type QueryContractServiceBaseTemplateArgs = {
  type: ContractType;
};


export type QueryContractServiceContractArgs = {
  id: Scalars['ID'];
};


export type QueryContractServiceContractTemplateArgs = {
  type: ContractType;
};


export type QueryContractServiceSignatureArgs = {
  id: Scalars['ID'];
  signingToken: Scalars['String'];
};


export type QueryContractorArgs = {
  uuid?: Maybe<Scalars['ID']>;
};


export type QueryCustomizedInvoiceTemplateArgs = {
  id: Scalars['ID'];
};


export type QueryCustomizedInvoiceTemplatesArgs = {
  after?: Maybe<Scalars['String']>;
  before?: Maybe<Scalars['String']>;
  first?: Maybe<Scalars['Int']>;
  last?: Maybe<Scalars['Int']>;
};


export type QueryHearthUidSelectorArgs = {
  hearthUid: Scalars['String'];
};


export type QueryHomeownerArgs = {
  id?: Maybe<Scalars['String']>;
  searchKey?: Maybe<Scalars['String']>;
};


export type QueryHomeownerAddressArgs = {
  id: Scalars['ID'];
};


export type QueryHomeownerFeedbackResponseArgs = {
  uuid: Scalars['ID'];
};


export type QueryHomeownerPaymentCalculationArgs = {
  after?: Maybe<Scalars['String']>;
  before?: Maybe<Scalars['String']>;
  fico: Scalars['Float'];
  first?: Maybe<Scalars['Int']>;
  income: Scalars['Float'];
  last?: Maybe<Scalars['Int']>;
  loanAmount: Scalars['Float'];
};


export type QueryHomeownerSearchArgs = {
  admin?: Maybe<Scalars['Boolean']>;
  after?: Maybe<Scalars['String']>;
  before?: Maybe<Scalars['String']>;
  first?: Maybe<Scalars['Int']>;
  last?: Maybe<Scalars['Int']>;
  orderBy?: Maybe<HomeownerOrderers>;
  searchTerm?: Maybe<Scalars['String']>;
  type?: Maybe<HomeownerEventBucket>;
};


export type QueryHomeownersArgs = {
  after?: Maybe<Scalars['String']>;
  before?: Maybe<Scalars['String']>;
  first?: Maybe<Scalars['Int']>;
  hasConnectInvoices?: Maybe<Scalars['Boolean']>;
  last?: Maybe<Scalars['Int']>;
};


export type QueryLivestormWebinarsArgs = {
  dateFrom?: Maybe<Scalars['ISO8601DateTime']>;
  dateTo?: Maybe<Scalars['ISO8601DateTime']>;
  status?: Maybe<Scalars['String']>;
  webinarType: HearthWebinar;
};


export type QueryLoanInquiryArgs = {
  loanInquiryUuid: Scalars['String'];
};


export type QueryLoginArgs = {
  appVersion?: Maybe<Scalars['String']>;
  email: Scalars['String'];
  password: Scalars['String'];
};


export type QueryMonthlyPaymentCalculationArgs = {
  after?: Maybe<Scalars['String']>;
  before?: Maybe<Scalars['String']>;
  ficoBucket: Scalars['String'];
  first?: Maybe<Scalars['Int']>;
  last?: Maybe<Scalars['Int']>;
  loanPrincipal: Scalars['Float'];
};


export type QueryMonthlyPaymentCalculationsArgs = {
  after?: Maybe<Scalars['String']>;
  before?: Maybe<Scalars['String']>;
  first?: Maybe<Scalars['Int']>;
  last?: Maybe<Scalars['Int']>;
};


export type QueryOrganizationArgs = {
  uuid?: Maybe<Scalars['ID']>;
};


export type QueryPaymentsProductSignupIntentArgs = {
  after?: Maybe<Scalars['String']>;
  before?: Maybe<Scalars['String']>;
  first?: Maybe<Scalars['Int']>;
  id?: Maybe<Scalars['ID']>;
  last?: Maybe<Scalars['Int']>;
  paymentSubscriptionId?: Maybe<Scalars['ID']>;
};


export type QueryPresaleLeadArgs = {
  email: Scalars['String'];
};


export type QueryQualifiedLoanInquiriesArgs = {
  after?: Maybe<Scalars['String']>;
  before?: Maybe<Scalars['String']>;
  birthday: Scalars['ISO8601DateTime'];
  email: Scalars['String'];
  first?: Maybe<Scalars['Int']>;
  last?: Maybe<Scalars['Int']>;
};


export type QueryQuestionnaireArgs = {
  id: Scalars['String'];
};


export type QueryQuestionnairesArgs = {
  after?: Maybe<Scalars['String']>;
  before?: Maybe<Scalars['String']>;
  first?: Maybe<Scalars['Int']>;
  last?: Maybe<Scalars['Int']>;
};


export type QueryQuoteArgs = {
  id: Scalars['ID'];
};


export type QueryQuoteAccountArgs = {
  id: Scalars['ID'];
};


export type QueryQuoteTemplateArgs = {
  id: Scalars['ID'];
};


export type QueryQuoteTemplateLineItemArgs = {
  id: Scalars['ID'];
};


export type QueryQuoteUploadArgs = {
  id?: Maybe<Scalars['ID']>;
};


export type QueryReminderSettingArgs = {
  modelId?: Maybe<Scalars['ID']>;
  modelType?: Maybe<Scalars['String']>;
  notificationTypeId?: Maybe<Scalars['ID']>;
};


export type QueryResourceArgs = {
  category?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['ID']>;
  type?: Maybe<Scalars['String']>;
};


export type QueryStripeConnectAccountArgs = {
  accountId?: Maybe<Scalars['String']>;
  id: Scalars['ID'];
  organizationId?: Maybe<Scalars['ID']>;
};

/** All the necessary information for a questionnaire */
export type Questionnaire = {
  readonly __typename?: 'Questionnaire';
  readonly createdAt: Scalars['ISO8601DateTime'];
  readonly id: Scalars['ID'];
  readonly name: Scalars['String'];
  readonly questions: QuestionnaireQuestionConnection;
};


/** All the necessary information for a questionnaire */
export type QuestionnaireQuestionsArgs = {
  after?: Maybe<Scalars['String']>;
  before?: Maybe<Scalars['String']>;
  first?: Maybe<Scalars['Int']>;
  last?: Maybe<Scalars['Int']>;
};

/** The answers to each questions in a questionnaire */
export type QuestionnaireAnswer = {
  readonly __typename?: 'QuestionnaireAnswer';
  readonly answer: Scalars['String'];
  readonly answerMeta: Scalars['JSON'];
  readonly createdAt: Scalars['ISO8601DateTime'];
  readonly id: Scalars['ID'];
  readonly question: QuestionnaireQuestion;
  readonly questionnaire: Questionnaire;
  readonly response: Questionnaire;
};

/** The connection type for QuestionnaireAnswer. */
export type QuestionnaireAnswerConnection = {
  readonly __typename?: 'QuestionnaireAnswerConnection';
  /** A list of edges. */
  readonly edges?: Maybe<ReadonlyArray<Maybe<QuestionnaireAnswerEdge>>>;
  /** A list of nodes. */
  readonly nodes?: Maybe<ReadonlyArray<Maybe<QuestionnaireAnswer>>>;
  /** Information to aid in pagination. */
  readonly pageInfo: PageInfo;
  readonly totalCount: Scalars['Int'];
};

/** An edge in a connection. */
export type QuestionnaireAnswerEdge = {
  readonly __typename?: 'QuestionnaireAnswerEdge';
  /** A cursor for use in pagination. */
  readonly cursor: Scalars['String'];
  /** The item at the end of the edge. */
  readonly node?: Maybe<QuestionnaireAnswer>;
};

/** The connection type for Questionnaire. */
export type QuestionnaireConnection = {
  readonly __typename?: 'QuestionnaireConnection';
  /** A list of edges. */
  readonly edges?: Maybe<ReadonlyArray<Maybe<QuestionnaireEdge>>>;
  /** A list of nodes. */
  readonly nodes?: Maybe<ReadonlyArray<Maybe<Questionnaire>>>;
  /** Information to aid in pagination. */
  readonly pageInfo: PageInfo;
  readonly totalCount: Scalars['Int'];
};

/** An edge in a connection. */
export type QuestionnaireEdge = {
  readonly __typename?: 'QuestionnaireEdge';
  /** A cursor for use in pagination. */
  readonly cursor: Scalars['String'];
  /** The item at the end of the edge. */
  readonly node?: Maybe<Questionnaire>;
};

/** Data and metadata for a questionnaire question */
export type QuestionnaireQuestion = {
  readonly __typename?: 'QuestionnaireQuestion';
  readonly allowedAnswers: ReadonlyArray<Scalars['String']>;
  readonly archivedAt: Scalars['ISO8601DateTime'];
  readonly createdAt: Scalars['ISO8601DateTime'];
  readonly id: Scalars['ID'];
  readonly options: QuestionnaireQuestionOptionConnection;
  readonly questionMeta?: Maybe<Scalars['JSON']>;
  readonly questionnaire: Questionnaire;
  readonly required: Scalars['Boolean'];
  readonly strict: Scalars['Boolean'];
  readonly text: Scalars['String'];
};


/** Data and metadata for a questionnaire question */
export type QuestionnaireQuestionOptionsArgs = {
  after?: Maybe<Scalars['String']>;
  before?: Maybe<Scalars['String']>;
  first?: Maybe<Scalars['Int']>;
  last?: Maybe<Scalars['Int']>;
};

/** The connection type for QuestionnaireQuestion. */
export type QuestionnaireQuestionConnection = {
  readonly __typename?: 'QuestionnaireQuestionConnection';
  /** A list of edges. */
  readonly edges?: Maybe<ReadonlyArray<Maybe<QuestionnaireQuestionEdge>>>;
  /** A list of nodes. */
  readonly nodes?: Maybe<ReadonlyArray<Maybe<QuestionnaireQuestion>>>;
  /** Information to aid in pagination. */
  readonly pageInfo: PageInfo;
  readonly totalCount: Scalars['Int'];
};

/** An edge in a connection. */
export type QuestionnaireQuestionEdge = {
  readonly __typename?: 'QuestionnaireQuestionEdge';
  /** A cursor for use in pagination. */
  readonly cursor: Scalars['String'];
  /** The item at the end of the edge. */
  readonly node?: Maybe<QuestionnaireQuestion>;
};

/** Enriched options for a multiple choice questionnaire question */
export type QuestionnaireQuestionOption = {
  readonly __typename?: 'QuestionnaireQuestionOption';
  readonly answerId: Scalars['String'];
  readonly archivedAt: Scalars['ISO8601DateTime'];
  readonly id: Scalars['ID'];
  readonly optionMeta?: Maybe<Scalars['JSON']>;
  readonly question: QuestionnaireQuestion;
  readonly text: Scalars['String'];
};

/** The connection type for QuestionnaireQuestionOption. */
export type QuestionnaireQuestionOptionConnection = {
  readonly __typename?: 'QuestionnaireQuestionOptionConnection';
  /** A list of edges. */
  readonly edges?: Maybe<ReadonlyArray<Maybe<QuestionnaireQuestionOptionEdge>>>;
  /** A list of nodes. */
  readonly nodes?: Maybe<ReadonlyArray<Maybe<QuestionnaireQuestionOption>>>;
  /** Information to aid in pagination. */
  readonly pageInfo: PageInfo;
  readonly totalCount: Scalars['Int'];
};

/** An edge in a connection. */
export type QuestionnaireQuestionOptionEdge = {
  readonly __typename?: 'QuestionnaireQuestionOptionEdge';
  /** A cursor for use in pagination. */
  readonly cursor: Scalars['String'];
  /** The item at the end of the edge. */
  readonly node?: Maybe<QuestionnaireQuestionOption>;
};

/** A single response to a questionnaire */
export type QuestionnaireResponse = {
  readonly __typename?: 'QuestionnaireResponse';
  readonly answers: QuestionnaireAnswerConnection;
  readonly completed: Scalars['Boolean'];
  readonly createdAt: Scalars['ISO8601DateTime'];
  readonly id: Scalars['ID'];
  readonly questionnaire: Questionnaire;
};


/** A single response to a questionnaire */
export type QuestionnaireResponseAnswersArgs = {
  after?: Maybe<Scalars['String']>;
  before?: Maybe<Scalars['String']>;
  first?: Maybe<Scalars['Int']>;
  last?: Maybe<Scalars['Int']>;
};

/** A list of settings and tokens for the quickbooks-connected user. */
export type QuickbooksBusiness = {
  readonly __typename?: 'QuickbooksBusiness';
  readonly autoSyncInvoices: Scalars['Boolean'];
  readonly id: Scalars['ID'];
  readonly realmId: Scalars['ID'];
};

export type QuickbooksBusinessSettings = {
  readonly autoSyncInvoices?: Maybe<Scalars['Boolean']>;
};

/** A Quote or "Bid" */
export type Quote = {
  readonly __typename?: 'Quote';
  readonly associatedContracts: ContractServiceContractConnection;
  readonly canceledAt?: Maybe<Scalars['ISO8601DateTime']>;
  readonly changesRequested?: Maybe<Scalars['String']>;
  readonly contractor: Contractor;
  readonly createdAt: Scalars['ISO8601DateTime'];
  readonly decisionAt?: Maybe<Scalars['ISO8601DateTime']>;
  readonly description: Scalars['String'];
  readonly discountInCents: Scalars['Int'];
  readonly documents: QuoteUploadConnection;
  readonly expiresAt: Scalars['ISO8601DateTime'];
  readonly firstViewedAt?: Maybe<Scalars['ISO8601DateTime']>;
  readonly homeownerAddress: HomeownerAddress;
  readonly id: Scalars['ID'];
  readonly lastViewedAt?: Maybe<Scalars['ISO8601DateTime']>;
  readonly latestQuote?: Maybe<Quote>;
  readonly lineItems: ReadonlyArray<QuoteLineItem>;
  readonly mediums: ReadonlyArray<ContactMedium>;
  readonly name: Scalars['String'];
  readonly organization: Organization;
  readonly personalNote?: Maybe<Scalars['String']>;
  readonly photos: QuoteUploadConnection;
  readonly priorQuote?: Maybe<Quote>;
  readonly quoteNumber: Scalars['Int'];
  readonly quoteTemplate: QuoteTemplate;
  readonly showFinancing: Scalars['Boolean'];
  readonly status: QuoteStatus;
  readonly theme: OrganizationTheme;
  readonly totalFeesInCents: Scalars['Int'];
  readonly totalInCents: Scalars['Int'];
  readonly totalTaxInCents: Scalars['Int'];
};


/** A Quote or "Bid" */
export type QuoteAssociatedContractsArgs = {
  after?: Maybe<Scalars['String']>;
  before?: Maybe<Scalars['String']>;
  first?: Maybe<Scalars['Int']>;
  last?: Maybe<Scalars['Int']>;
};


/** A Quote or "Bid" */
export type QuoteDocumentsArgs = {
  after?: Maybe<Scalars['String']>;
  before?: Maybe<Scalars['String']>;
  first?: Maybe<Scalars['Int']>;
  last?: Maybe<Scalars['Int']>;
};


/** A Quote or "Bid" */
export type QuotePhotosArgs = {
  after?: Maybe<Scalars['String']>;
  before?: Maybe<Scalars['String']>;
  first?: Maybe<Scalars['Int']>;
  last?: Maybe<Scalars['Int']>;
};

/** A per-org registration for the quotes service that contains preferences. */
export type QuoteAccount = {
  readonly __typename?: 'QuoteAccount';
  readonly id: Scalars['ID'];
  readonly quote: Quote;
  readonly quoteTemplate: QuoteTemplate;
  readonly quoteTemplates: QuoteTemplateConnection;
  readonly quoteUploads: ReadonlyArray<QuoteUpload>;
  /** Quotes by contractor/quote account */
  readonly quotes: QuoteConnection;
};


/** A per-org registration for the quotes service that contains preferences. */
export type QuoteAccountQuoteArgs = {
  id: Scalars['ID'];
};


/** A per-org registration for the quotes service that contains preferences. */
export type QuoteAccountQuoteTemplateArgs = {
  id: Scalars['ID'];
};


/** A per-org registration for the quotes service that contains preferences. */
export type QuoteAccountQuoteTemplatesArgs = {
  after?: Maybe<Scalars['String']>;
  before?: Maybe<Scalars['String']>;
  first?: Maybe<Scalars['Int']>;
  last?: Maybe<Scalars['Int']>;
};


/** A per-org registration for the quotes service that contains preferences. */
export type QuoteAccountQuoteUploadsArgs = {
  uploadType?: Maybe<Scalars['String']>;
};


/** A per-org registration for the quotes service that contains preferences. */
export type QuoteAccountQuotesArgs = {
  admin?: Maybe<Scalars['Boolean']>;
  after?: Maybe<Scalars['String']>;
  before?: Maybe<Scalars['String']>;
  first?: Maybe<Scalars['Int']>;
  homeownerSearch?: Maybe<Scalars['String']>;
  last?: Maybe<Scalars['Int']>;
  orderBy?: Maybe<QuoteOrderers>;
  status?: Maybe<ReadonlyArray<QuoteStatus>>;
};

export type QuoteAccountCreateFailure = {
  readonly __typename?: 'QuoteAccountCreateFailure';
  readonly errors: ReadonlyArray<Error>;
};

export type QuoteAccountCreateResult = QuoteAccountCreateFailure | QuoteAccountCreateSuccess;

export type QuoteAccountCreateSuccess = {
  readonly __typename?: 'QuoteAccountCreateSuccess';
  readonly quoteAccount: QuoteAccount;
};

export type QuoteAssociateContractFailure = {
  readonly __typename?: 'QuoteAssociateContractFailure';
  readonly errors: ReadonlyArray<Error>;
};

export type QuoteAssociateContractResult = QuoteAssociateContractFailure | QuoteAssociateContractSuccess;

export type QuoteAssociateContractSuccess = {
  readonly __typename?: 'QuoteAssociateContractSuccess';
  readonly quote: Quote;
};

export type QuoteCancelFailure = {
  readonly __typename?: 'QuoteCancelFailure';
  readonly errors: ReadonlyArray<Error>;
};

export type QuoteCancelResult = QuoteCancelFailure | QuoteCancelSuccess;

export type QuoteCancelSuccess = {
  readonly __typename?: 'QuoteCancelSuccess';
  readonly quote: Quote;
};

/** The connection type for Quote. */
export type QuoteConnection = {
  readonly __typename?: 'QuoteConnection';
  /** A list of edges. */
  readonly edges?: Maybe<ReadonlyArray<Maybe<QuoteEdge>>>;
  /** A list of nodes. */
  readonly nodes?: Maybe<ReadonlyArray<Maybe<Quote>>>;
  /** Information to aid in pagination. */
  readonly pageInfo: PageInfo;
  readonly totalCount: Scalars['Int'];
};

export type QuoteCreateFailure = {
  readonly __typename?: 'QuoteCreateFailure';
  readonly errors: ReadonlyArray<Error>;
};

export type QuoteCreateResult = QuoteCreateFailure | QuoteCreateSuccess;

export type QuoteCreateSuccess = {
  readonly __typename?: 'QuoteCreateSuccess';
  readonly quote: Quote;
};

/** An edge in a connection. */
export type QuoteEdge = {
  readonly __typename?: 'QuoteEdge';
  /** A cursor for use in pagination. */
  readonly cursor: Scalars['String'];
  /** The item at the end of the edge. */
  readonly node?: Maybe<Quote>;
};

export type QuoteHomeownerAcceptFailure = {
  readonly __typename?: 'QuoteHomeownerAcceptFailure';
  readonly errors: ReadonlyArray<Error>;
};

export type QuoteHomeownerAcceptResult = QuoteHomeownerAcceptFailure | QuoteHomeownerAcceptSuccess;

export type QuoteHomeownerAcceptSuccess = {
  readonly __typename?: 'QuoteHomeownerAcceptSuccess';
  readonly quote: Quote;
};

export type QuoteHomeownerDeclineFailure = {
  readonly __typename?: 'QuoteHomeownerDeclineFailure';
  readonly errors: ReadonlyArray<Error>;
};

export type QuoteHomeownerDeclineResult = QuoteHomeownerDeclineFailure | QuoteHomeownerDeclineSuccess;

export type QuoteHomeownerDeclineSuccess = {
  readonly __typename?: 'QuoteHomeownerDeclineSuccess';
  readonly quote: Quote;
};

export type QuoteHomeownerRequestChangesFailure = {
  readonly __typename?: 'QuoteHomeownerRequestChangesFailure';
  readonly errors: ReadonlyArray<Error>;
};

export type QuoteHomeownerRequestChangesResult = QuoteHomeownerRequestChangesFailure | QuoteHomeownerRequestChangesSuccess;

export type QuoteHomeownerRequestChangesSuccess = {
  readonly __typename?: 'QuoteHomeownerRequestChangesSuccess';
  readonly quote: Quote;
};

/** A line item on a created quote */
export type QuoteLineItem = {
  readonly __typename?: 'QuoteLineItem';
  readonly description: Scalars['String'];
  readonly id: Scalars['ID'];
  readonly index: Scalars['Int'];
  readonly name: Scalars['String'];
  readonly priceInCents: Scalars['Int'];
  readonly quantity: Scalars['Int'];
  readonly quote: Quote;
  readonly totalInCents: Scalars['Int'];
};

export type QuoteLineItemParams = {
  readonly baseLineItemId?: Maybe<Scalars['ID']>;
  readonly description: Scalars['String'];
  readonly name: Scalars['String'];
  readonly priceInCents: Scalars['Int'];
  readonly quantity: Scalars['Int'];
};

export enum QuoteOrderers {
  /** Order by canceled_at ascendent */
  CANCELED_AT_ASC = 'canceled_at_asc',
  /** Order by canceled_at descendent */
  CANCELED_AT_DESC = 'canceled_at_desc',
  /** Order by changes_requested ascendent */
  CHANGES_REQUESTED_ASC = 'changes_requested_asc',
  /** Order by changes_requested descendent */
  CHANGES_REQUESTED_DESC = 'changes_requested_desc',
  /** Order by created_at ascendent */
  CREATED_AT_ASC = 'created_at_asc',
  /** Order by created_at descendent */
  CREATED_AT_DESC = 'created_at_desc',
  /** Order by decision_at ascendent */
  DECISION_AT_ASC = 'decision_at_asc',
  /** Order by decision_at descendent */
  DECISION_AT_DESC = 'decision_at_desc',
  /** Order by description ascendent */
  DESCRIPTION_ASC = 'description_asc',
  /** Order by description descendent */
  DESCRIPTION_DESC = 'description_desc',
  /** Order by discount_in_cents ascendent */
  DISCOUNT_IN_CENTS_ASC = 'discount_in_cents_asc',
  /** Order by discount_in_cents descendent */
  DISCOUNT_IN_CENTS_DESC = 'discount_in_cents_desc',
  /** Order by email_asc */
  EMAIL_ASC = 'email_asc',
  /** Order by email_desc */
  EMAIL_DESC = 'email_desc',
  /** Order by expires_at ascendent */
  EXPIRES_AT_ASC = 'expires_at_asc',
  /** Order by expires_at descendent */
  EXPIRES_AT_DESC = 'expires_at_desc',
  /** Order by first_name_asc */
  FIRST_NAME_ASC = 'first_name_asc',
  /** Order by first_name_desc */
  FIRST_NAME_DESC = 'first_name_desc',
  /** Order by first_viewed_at ascendent */
  FIRST_VIEWED_AT_ASC = 'first_viewed_at_asc',
  /** Order by first_viewed_at descendent */
  FIRST_VIEWED_AT_DESC = 'first_viewed_at_desc',
  /** Order by homeowner_address_id ascendent */
  HOMEOWNER_ADDRESS_ID_ASC = 'homeowner_address_id_asc',
  /** Order by homeowner_address_id descendent */
  HOMEOWNER_ADDRESS_ID_DESC = 'homeowner_address_id_desc',
  /** Order by id ascendent */
  ID_ASC = 'id_asc',
  /** Order by id descendent */
  ID_DESC = 'id_desc',
  /** Order by last_name_asc */
  LAST_NAME_ASC = 'last_name_asc',
  /** Order by last_name_desc */
  LAST_NAME_DESC = 'last_name_desc',
  /** Order by last_viewed_at ascendent */
  LAST_VIEWED_AT_ASC = 'last_viewed_at_asc',
  /** Order by last_viewed_at descendent */
  LAST_VIEWED_AT_DESC = 'last_viewed_at_desc',
  /** Order by mediums ascendent */
  MEDIUMS_ASC = 'mediums_asc',
  /** Order by mediums descendent */
  MEDIUMS_DESC = 'mediums_desc',
  /** Order by name ascendent */
  NAME_ASC = 'name_asc',
  /** Order by name descendent */
  NAME_DESC = 'name_desc',
  /** Order by personal_note ascendent */
  PERSONAL_NOTE_ASC = 'personal_note_asc',
  /** Order by personal_note descendent */
  PERSONAL_NOTE_DESC = 'personal_note_desc',
  /** Order by prior_quote_id ascendent */
  PRIOR_QUOTE_ID_ASC = 'prior_quote_id_asc',
  /** Order by prior_quote_id descendent */
  PRIOR_QUOTE_ID_DESC = 'prior_quote_id_desc',
  /** Order by quote_number ascendent */
  QUOTE_NUMBER_ASC = 'quote_number_asc',
  /** Order by quote_number descendent */
  QUOTE_NUMBER_DESC = 'quote_number_desc',
  /** Order by quote_template_id ascendent */
  QUOTE_TEMPLATE_ID_ASC = 'quote_template_id_asc',
  /** Order by quote_template_id descendent */
  QUOTE_TEMPLATE_ID_DESC = 'quote_template_id_desc',
  /** Order by show_financing ascendent */
  SHOW_FINANCING_ASC = 'show_financing_asc',
  /** Order by show_financing descendent */
  SHOW_FINANCING_DESC = 'show_financing_desc',
  /** Order by status ascendent */
  STATUS_ASC = 'status_asc',
  /** Order by status descendent */
  STATUS_DESC = 'status_desc',
  /** Order by theme ascendent */
  THEME_ASC = 'theme_asc',
  /** Order by theme descendent */
  THEME_DESC = 'theme_desc',
  /** Order by total_fees_in_cents ascendent */
  TOTAL_FEES_IN_CENTS_ASC = 'total_fees_in_cents_asc',
  /** Order by total_fees_in_cents descendent */
  TOTAL_FEES_IN_CENTS_DESC = 'total_fees_in_cents_desc',
  /** Order by total_tax_in_cents ascendent */
  TOTAL_TAX_IN_CENTS_ASC = 'total_tax_in_cents_asc',
  /** Order by total_tax_in_cents descendent */
  TOTAL_TAX_IN_CENTS_DESC = 'total_tax_in_cents_desc',
  /** Order by updated_at ascendent */
  UPDATED_AT_ASC = 'updated_at_asc',
  /** Order by updated_at descendent */
  UPDATED_AT_DESC = 'updated_at_desc'
}

export type QuoteResendFailure = {
  readonly __typename?: 'QuoteResendFailure';
  readonly errors: ReadonlyArray<Error>;
};

export type QuoteResendResult = QuoteResendFailure | QuoteResendSuccess;

export type QuoteResendSuccess = {
  readonly __typename?: 'QuoteResendSuccess';
  readonly quote: Quote;
};

export enum QuoteStatus {
  ACCEPTED = 'accepted',
  CANCELED = 'canceled',
  CHANGES_REQUESTED = 'changes_requested',
  CREATED = 'created',
  EXPIRED = 'expired',
  OVERWRITTEN = 'overwritten',
  VIEWED = 'viewed'
}

/** A template used to create a new quote */
export type QuoteTemplate = {
  readonly __typename?: 'QuoteTemplate';
  readonly description: Scalars['String'];
  readonly discountInCents: Scalars['Int'];
  readonly id: Scalars['ID'];
  readonly lineItems: ReadonlyArray<QuoteTemplateLineItem>;
  readonly theme: OrganizationTheme;
  readonly totalFeesInCents: Scalars['Int'];
  readonly totalInCents: Scalars['Int'];
  readonly totalTaxInCents: Scalars['Int'];
};

/** The connection type for QuoteTemplate. */
export type QuoteTemplateConnection = {
  readonly __typename?: 'QuoteTemplateConnection';
  /** A list of edges. */
  readonly edges?: Maybe<ReadonlyArray<Maybe<QuoteTemplateEdge>>>;
  /** A list of nodes. */
  readonly nodes?: Maybe<ReadonlyArray<Maybe<QuoteTemplate>>>;
  /** Information to aid in pagination. */
  readonly pageInfo: PageInfo;
  readonly totalCount: Scalars['Int'];
};

export type QuoteTemplateCreateFailure = {
  readonly __typename?: 'QuoteTemplateCreateFailure';
  readonly errors: ReadonlyArray<Error>;
};

export type QuoteTemplateCreateResult = QuoteTemplateCreateFailure | QuoteTemplateCreateSuccess;

export type QuoteTemplateCreateSuccess = {
  readonly __typename?: 'QuoteTemplateCreateSuccess';
  readonly quoteTemplate: QuoteTemplate;
};

export type QuoteTemplateDestroyFailure = {
  readonly __typename?: 'QuoteTemplateDestroyFailure';
  readonly errors: ReadonlyArray<Error>;
};

export type QuoteTemplateDestroyResult = QuoteTemplateDestroyFailure | QuoteTemplateDestroySuccess;

export type QuoteTemplateDestroySuccess = {
  readonly __typename?: 'QuoteTemplateDestroySuccess';
  readonly deletedId: Scalars['ID'];
};

/** An edge in a connection. */
export type QuoteTemplateEdge = {
  readonly __typename?: 'QuoteTemplateEdge';
  /** A cursor for use in pagination. */
  readonly cursor: Scalars['String'];
  /** The item at the end of the edge. */
  readonly node?: Maybe<QuoteTemplate>;
};

/** A line item attached to a quote template */
export type QuoteTemplateLineItem = {
  readonly __typename?: 'QuoteTemplateLineItem';
  readonly description: Scalars['String'];
  readonly id: Scalars['ID'];
  readonly index: QuoteTemplateLineItem;
  readonly name: Scalars['String'];
  readonly priceInCents: Scalars['Int'];
  readonly quantity: Scalars['Int'];
  readonly quoteTemplate: QuoteTemplate;
  readonly totalInCents: Scalars['Int'];
};

export type QuoteTemplateUpdateFailure = {
  readonly __typename?: 'QuoteTemplateUpdateFailure';
  readonly errors: ReadonlyArray<Error>;
};

export type QuoteTemplateUpdateResult = QuoteTemplateUpdateFailure | QuoteTemplateUpdateSuccess;

export type QuoteTemplateUpdateSuccess = {
  readonly __typename?: 'QuoteTemplateUpdateSuccess';
  readonly quoteTemplate: QuoteTemplate;
};

export enum QuoteTheme {
  BLUE = 'blue',
  GREEN = 'green',
  RED = 'red'
}

/** An uploaded file to be attached to a Quote */
export type QuoteUpload = {
  readonly __typename?: 'QuoteUpload';
  readonly displayLink: Scalars['String'];
  readonly downloadLink: Scalars['String'];
  readonly filename: Scalars['String'];
  readonly id: Scalars['ID'];
  readonly quoteId: Scalars['String'];
  readonly uploadType: Scalars['String'];
};

/** The connection type for QuoteUpload. */
export type QuoteUploadConnection = {
  readonly __typename?: 'QuoteUploadConnection';
  /** A list of edges. */
  readonly edges?: Maybe<ReadonlyArray<Maybe<QuoteUploadEdge>>>;
  /** A list of nodes. */
  readonly nodes?: Maybe<ReadonlyArray<Maybe<QuoteUpload>>>;
  /** Information to aid in pagination. */
  readonly pageInfo: PageInfo;
  readonly totalCount: Scalars['Int'];
};

export type QuoteUploadCreateFailure = {
  readonly __typename?: 'QuoteUploadCreateFailure';
  readonly errors: ReadonlyArray<Error>;
};

export type QuoteUploadCreateResult = QuoteUploadCreateFailure | QuoteUploadCreateSuccess;

export type QuoteUploadCreateSuccess = {
  readonly __typename?: 'QuoteUploadCreateSuccess';
  readonly quoteUpload: QuoteUpload;
};

export type QuoteUploadDocumentFailure = {
  readonly __typename?: 'QuoteUploadDocumentFailure';
  readonly errors: ReadonlyArray<Error>;
};

export type QuoteUploadDocumentResult = QuoteUploadDocumentFailure | QuoteUploadDocumentSuccess;

export type QuoteUploadDocumentSuccess = {
  readonly __typename?: 'QuoteUploadDocumentSuccess';
  readonly quoteDocument: QuoteUpload;
};

/** An edge in a connection. */
export type QuoteUploadEdge = {
  readonly __typename?: 'QuoteUploadEdge';
  /** A cursor for use in pagination. */
  readonly cursor: Scalars['String'];
  /** The item at the end of the edge. */
  readonly node?: Maybe<QuoteUpload>;
};

export type QuoteUploadPhotoFailure = {
  readonly __typename?: 'QuoteUploadPhotoFailure';
  readonly errors: ReadonlyArray<Error>;
};

export type QuoteUploadPhotoResult = QuoteUploadPhotoFailure | QuoteUploadPhotoSuccess;

export type QuoteUploadPhotoSuccess = {
  readonly __typename?: 'QuoteUploadPhotoSuccess';
  readonly quotePhoto: QuoteUpload;
};

export type QuoteViewedFailure = {
  readonly __typename?: 'QuoteViewedFailure';
  readonly errors: ReadonlyArray<Error>;
};

export type QuoteViewedResult = QuoteViewedFailure | QuoteViewedSuccess;

export type QuoteViewedSuccess = {
  readonly __typename?: 'QuoteViewedSuccess';
  readonly quote: Quote;
};

export type RecordHearthOnboardingPersonalizeDashboardResponseFailure = {
  readonly __typename?: 'RecordHearthOnboardingPersonalizeDashboardResponseFailure';
  readonly errors: ReadonlyArray<Error>;
};

export type RecordHearthOnboardingPersonalizeDashboardResponseResult = RecordHearthOnboardingPersonalizeDashboardResponseFailure | RecordHearthOnboardingPersonalizeDashboardResponseSuccess;

export type RecordHearthOnboardingPersonalizeDashboardResponseSuccess = {
  readonly __typename?: 'RecordHearthOnboardingPersonalizeDashboardResponseSuccess';
  readonly questionnaireResponse?: Maybe<QuestionnaireResponse>;
};

export type RecordQuickPollResponseFailure = {
  readonly __typename?: 'RecordQuickPollResponseFailure';
  readonly errors: ReadonlyArray<Error>;
};

export type RecordQuickPollResponseResult = RecordQuickPollResponseFailure | RecordQuickPollResponseSuccess;

export type RecordQuickPollResponseSuccess = {
  readonly __typename?: 'RecordQuickPollResponseSuccess';
  readonly questionnaireResponse?: Maybe<QuestionnaireResponse>;
};

export type RecurlyPaymentMethod = {
  readonly __typename?: 'RecurlyPaymentMethod';
  readonly brand: Scalars['String'];
  readonly last4: Scalars['String'];
};

export type RefundConnectInvoiceFailure = {
  readonly __typename?: 'RefundConnectInvoiceFailure';
  readonly errors: ReadonlyArray<Error>;
};

export type RefundConnectInvoiceResult = RefundConnectInvoiceFailure | RefundConnectInvoiceSuccess;

export type RefundConnectInvoiceSuccess = {
  readonly __typename?: 'RefundConnectInvoiceSuccess';
  readonly connectInvoice?: Maybe<ConnectInvoice>;
};

/** For reminder settings for a model */
export type ReminderSetting = {
  readonly __typename?: 'ReminderSetting';
  readonly enabled: Scalars['Boolean'];
  readonly id: Scalars['ID'];
  readonly medium?: Maybe<Scalars['String']>;
  readonly name: Scalars['String'];
  readonly settingName: Scalars['String'];
  readonly settingRemindableId: Scalars['ID'];
  readonly settingRemindableType: Scalars['String'];
};

/** The connection type for ReminderSetting. */
export type ReminderSettingConnection = {
  readonly __typename?: 'ReminderSettingConnection';
  /** A list of edges. */
  readonly edges?: Maybe<ReadonlyArray<Maybe<ReminderSettingEdge>>>;
  /** A list of nodes. */
  readonly nodes?: Maybe<ReadonlyArray<Maybe<ReminderSetting>>>;
  /** Information to aid in pagination. */
  readonly pageInfo: PageInfo;
  readonly totalCount: Scalars['Int'];
};

/** An edge in a connection. */
export type ReminderSettingEdge = {
  readonly __typename?: 'ReminderSettingEdge';
  /** A cursor for use in pagination. */
  readonly cursor: Scalars['String'];
  /** The item at the end of the edge. */
  readonly node?: Maybe<ReminderSetting>;
};

export type RemovePlaidTokenFromConnectInvoiceFailure = {
  readonly __typename?: 'RemovePlaidTokenFromConnectInvoiceFailure';
  readonly errors: ReadonlyArray<Error>;
};

export type RemovePlaidTokenFromConnectInvoiceResult = RemovePlaidTokenFromConnectInvoiceFailure | RemovePlaidTokenFromConnectInvoiceSuccess;

export type RemovePlaidTokenFromConnectInvoiceSuccess = {
  readonly __typename?: 'RemovePlaidTokenFromConnectInvoiceSuccess';
  readonly connectInvoice: ConnectInvoice;
};

export type ResendMemberInviteEmailFailure = {
  readonly __typename?: 'ResendMemberInviteEmailFailure';
  readonly errors: ReadonlyArray<Error>;
};

export type ResendMemberInviteEmailResult = ResendMemberInviteEmailFailure | ResendMemberInviteEmailSuccess;

export type ResendMemberInviteEmailSuccess = {
  readonly __typename?: 'ResendMemberInviteEmailSuccess';
  readonly memberInvite: MemberInvite;
};

/** For different resources that dont really belong to any model */
export type Resource = {
  readonly __typename?: 'Resource';
  readonly category: Scalars['String'];
  readonly id: Scalars['ID'];
  readonly resourceKey: Scalars['String'];
  readonly resourceName: Scalars['String'];
  readonly resourceType: Scalars['String'];
  readonly resourceValue: Scalars['JSON'];
};

/** Monthly trend data */
export type RollingCounts = {
  readonly __typename?: 'RollingCounts';
  readonly amount: Scalars['Float'];
  readonly count: Scalars['Int'];
  readonly date: Scalars['ISO8601DateTime'];
};

export type ScheduleWebinarFailure = {
  readonly __typename?: 'ScheduleWebinarFailure';
  readonly errors: ReadonlyArray<Error>;
};

export type ScheduleWebinarResult = ScheduleWebinarFailure | ScheduleWebinarSuccess;

export type ScheduleWebinarSuccess = {
  readonly __typename?: 'ScheduleWebinarSuccess';
  readonly contractor: Contractor;
};

/** Autogenerated return type of SendContractorSampleInvoice */
export type SendContractorSampleInvoicePayload = {
  readonly __typename?: 'SendContractorSampleInvoicePayload';
  readonly contractor: Contractor;
};

export type SendDefaultFinancingInfoFailure = {
  readonly __typename?: 'SendDefaultFinancingInfoFailure';
  readonly errors: ReadonlyArray<Error>;
};

export type SendDefaultFinancingInfoResult = SendDefaultFinancingInfoFailure | SendDefaultFinancingInfoSuccess;

export type SendDefaultFinancingInfoSuccess = {
  readonly __typename?: 'SendDefaultFinancingInfoSuccess';
  readonly homeowner: Homeowner;
};

export type SendEmailLeadFailure = {
  readonly __typename?: 'SendEmailLeadFailure';
  readonly errors: ReadonlyArray<Error>;
};

export type SendEmailLeadResult = SendEmailLeadFailure | SendEmailLeadSuccess;

export type SendEmailLeadSuccess = {
  readonly __typename?: 'SendEmailLeadSuccess';
  readonly count: Scalars['Int'];
  readonly organization: Organization;
};

/** Autogenerated return type of SendExampleReminder */
export type SendExampleReminderPayload = {
  readonly __typename?: 'SendExampleReminderPayload';
  readonly contractor: Contractor;
};

/** params related to what gets sent to the homeowner */
export type SendFinancingParams = {
  readonly emailBody: Scalars['String'];
  readonly emailSubject: Scalars['String'];
  readonly sendEmail: Scalars['Boolean'];
  readonly sendText: Scalars['Boolean'];
  readonly textBody: Scalars['String'];
};

export type SendHearthAppDownloadLinkFailure = {
  readonly __typename?: 'SendHearthAppDownloadLinkFailure';
  readonly errors: ReadonlyArray<Error>;
};

export type SendHearthAppDownloadLinkResult = SendHearthAppDownloadLinkFailure | SendHearthAppDownloadLinkSuccess;

export type SendHearthAppDownloadLinkSuccess = {
  readonly __typename?: 'SendHearthAppDownloadLinkSuccess';
  readonly contractor: Contractor;
};

/** Autogenerated return type of SendHomeownerPaymentReminder */
export type SendHomeownerPaymentReminderPayload = {
  readonly __typename?: 'SendHomeownerPaymentReminderPayload';
  readonly connectInvoice?: Maybe<ConnectInvoice>;
  readonly errors?: Maybe<ReadonlyArray<ValidationError>>;
};

export type SendInviteAndScheduleWebinarFailure = {
  readonly __typename?: 'SendInviteAndScheduleWebinarFailure';
  readonly errors: ReadonlyArray<Error>;
};

export type SendInviteAndScheduleWebinarResult = SendInviteAndScheduleWebinarFailure | SendInviteAndScheduleWebinarSuccess;

export type SendInviteAndScheduleWebinarSuccess = {
  readonly __typename?: 'SendInviteAndScheduleWebinarSuccess';
  readonly organization: Organization;
};

export type SendMemberInvitesFailure = {
  readonly __typename?: 'SendMemberInvitesFailure';
  readonly errors: ReadonlyArray<Error>;
};

export type SendMemberInvitesResult = SendMemberInvitesFailure | SendMemberInvitesSuccess;

export type SendMemberInvitesSuccess = {
  readonly __typename?: 'SendMemberInvitesSuccess';
  readonly organization: Organization;
};

export type SendResetPasswordLinkFailure = {
  readonly __typename?: 'SendResetPasswordLinkFailure';
  readonly errors: ReadonlyArray<Error>;
};

export type SendResetPasswordLinkResult = SendResetPasswordLinkFailure | SendResetPasswordLinkSuccess;

export type SendResetPasswordLinkSuccess = {
  readonly __typename?: 'SendResetPasswordLinkSuccess';
  readonly contractor: Contractor;
};

export type SendSamplePaymentRequestFailure = {
  readonly __typename?: 'SendSamplePaymentRequestFailure';
  readonly errors: ReadonlyArray<Error>;
};

export type SendSamplePaymentRequestResult = SendSamplePaymentRequestFailure | SendSamplePaymentRequestSuccess;

export type SendSamplePaymentRequestSuccess = {
  readonly __typename?: 'SendSamplePaymentRequestSuccess';
  readonly contractor: Contractor;
};

/** params related to what gets sent to the homeowner */
export type SentFinancingParams = {
  readonly sendEmail: Scalars['Boolean'];
  readonly sendText: Scalars['Boolean'];
};

/** Server constants for the frontend applications */
export type ServerConstants = {
  readonly __typename?: 'ServerConstants';
  readonly activeLenderSlugs: ReadonlyArray<Scalars['String']>;
  readonly minimumAppVersion: Scalars['String'];
  readonly paymentPlansRates: ReadonlyArray<PaymentPlansRate>;
};

export type Session = {
  readonly __typename?: 'Session';
  readonly hearthUid: Scalars['String'];
};

export type SessionAttribute = {
  readonly __typename?: 'SessionAttribute';
  readonly canceledAt: Scalars['ISO8601DateTime'];
  readonly createdAt: Scalars['ISO8601DateTime'];
  readonly estimatedStartedAt: Scalars['ISO8601DateTime'];
  readonly status: Scalars['String'];
  readonly updatedAt: Scalars['ISO8601DateTime'];
};

export type SignAccountContractFailure = {
  readonly __typename?: 'SignAccountContractFailure';
  readonly errors: ReadonlyArray<Error>;
};

export type SignAccountContractResult = SignAccountContractFailure | SignAccountContractSuccess;

export type SignAccountContractSuccess = {
  readonly __typename?: 'SignAccountContractSuccess';
  readonly organization: Organization;
  readonly stripeConnectAccount: StripeConnectAccount;
};

export enum SignatureMessage {
  SCRIPT = 'script',
  SERIF = 'serif'
}

export enum SignatureRole {
  RECEIVER = 'receiver',
  SENDER = 'sender'
}

export enum SignatureStatus {
  SIGNED = 'signed',
  UNSIGNED = 'unsigned'
}

/** The contract that needs to be signed */
export type SignedContract = {
  readonly __typename?: 'SignedContract';
  readonly html: Scalars['String'];
  readonly id: Scalars['ID'];
  readonly text: Scalars['String'];
};

/** Invoice Template social media links */
export type SocialMediaLinks = {
  readonly __typename?: 'SocialMediaLinks';
  readonly facebookUrl?: Maybe<Scalars['Boolean']>;
  readonly instagramUrl?: Maybe<Scalars['Boolean']>;
  readonly linkedinUrl?: Maybe<Scalars['Boolean']>;
  readonly twitterUrl?: Maybe<Scalars['Boolean']>;
};

export enum StripeAccountDisabledReason {
  LISTED = 'listed',
  OTHER = 'other',
  REJECTED_FRAUD = 'rejected_fraud',
  REJECTED_LISTED = 'rejected_listed',
  REJECTED_OTHER = 'rejected_other',
  REJECTED_TERMS_OF_SERVICE = 'rejected_terms_of_service',
  REQUIREMENTS_PAST_DUE = 'requirements_past_due',
  REQUIREMENTS_PENDING_VERIFICATION = 'requirements_pending_verification',
  UNDER_REVIEW = 'under_review'
}

export enum StripeAccountRequirementsErrorCode {
  INVALID_ADDRESS_CITY_STATE_POSTAL_CODE = 'invalid_address_city_state_postal_code',
  INVALID_STREET_ADDRESS = 'invalid_street_address',
  INVALID_VALUE_OTHER = 'invalid_value_other',
  VERIFICATION_DOCUMENT_ADDRESS_MISMATCH = 'verification_document_address_mismatch',
  VERIFICATION_DOCUMENT_ADDRESS_MISSING = 'verification_document_address_missing',
  VERIFICATION_DOCUMENT_CORRUPT = 'verification_document_corrupt',
  VERIFICATION_DOCUMENT_COUNTRY_NOT_SUPPORTED = 'verification_document_country_not_supported',
  VERIFICATION_DOCUMENT_DOB_MISMATCH = 'verification_document_dob_mismatch',
  VERIFICATION_DOCUMENT_DUPLICATE_TYPE = 'verification_document_duplicate_type',
  VERIFICATION_DOCUMENT_EXPIRED = 'verification_document_expired',
  VERIFICATION_DOCUMENT_FAILED_COPY = 'verification_document_failed_copy',
  VERIFICATION_DOCUMENT_FAILED_GREYSCALE = 'verification_document_failed_greyscale',
  VERIFICATION_DOCUMENT_FAILED_OTHER = 'verification_document_failed_other',
  VERIFICATION_DOCUMENT_FAILED_TEST_MODE = 'verification_document_failed_test_mode',
  VERIFICATION_DOCUMENT_FRAUDULENT = 'verification_document_fraudulent',
  VERIFICATION_DOCUMENT_ID_NUMBER_MISMATCH = 'verification_document_id_number_mismatch',
  VERIFICATION_DOCUMENT_ID_NUMBER_MISSING = 'verification_document_id_number_missing',
  VERIFICATION_DOCUMENT_INCOMPLETE = 'verification_document_incomplete',
  VERIFICATION_DOCUMENT_INVALID = 'verification_document_invalid',
  VERIFICATION_DOCUMENT_ISSUE_OR_EXPIRY_DATE_MISSING = 'verification_document_issue_or_expiry_date_missing',
  VERIFICATION_DOCUMENT_MANIPULATED = 'verification_document_manipulated',
  VERIFICATION_DOCUMENT_MISSING_BACK = 'verification_document_missing_back',
  VERIFICATION_DOCUMENT_MISSING_FRONT = 'verification_document_missing_front',
  VERIFICATION_DOCUMENT_NAME_MISMATCH = 'verification_document_name_mismatch',
  VERIFICATION_DOCUMENT_NAME_MISSING = 'verification_document_name_missing',
  VERIFICATION_DOCUMENT_NATIONALITY_MISMATCH = 'verification_document_nationality_mismatch',
  VERIFICATION_DOCUMENT_NOT_READABLE = 'verification_document_not_readable',
  VERIFICATION_DOCUMENT_NOT_SIGNED = 'verification_document_not_signed',
  VERIFICATION_DOCUMENT_NOT_UPLOADED = 'verification_document_not_uploaded',
  VERIFICATION_DOCUMENT_PHOTO_MISMATCH = 'verification_document_photo_mismatch',
  VERIFICATION_DOCUMENT_TOO_LARGE = 'verification_document_too_large',
  VERIFICATION_DOCUMENT_TYPE_NOT_SUPPORTED = 'verification_document_type_not_supported',
  VERIFICATION_FAILED_ADDRESS_MATCH = 'verification_failed_address_match',
  VERIFICATION_FAILED_BUSINESS_IEC_NUMBER = 'verification_failed_business_iec_number',
  VERIFICATION_FAILED_DOCUMENT_MATCH = 'verification_failed_document_match',
  VERIFICATION_FAILED_ID_NUMBER_MATCH = 'verification_failed_id_number_match',
  VERIFICATION_FAILED_KEYED_IDENTITY = 'verification_failed_keyed_identity',
  VERIFICATION_FAILED_KEYED_MATCH = 'verification_failed_keyed_match',
  VERIFICATION_FAILED_NAME_MATCH = 'verification_failed_name_match',
  VERIFICATION_FAILED_OTHER = 'verification_failed_other',
  VERIFICATION_FAILED_TAX_ID_MATCH = 'verification_failed_tax_id_match',
  VERIFICATION_FAILED_TAX_ID_NOT_ISSUE = 'verification_failed_tax_id_not_issue'
}

/** Bank account destination */
export type StripeBankAccount = {
  readonly __typename?: 'StripeBankAccount';
  readonly accountHolderName?: Maybe<Scalars['String']>;
  readonly bankName: Scalars['String'];
  readonly defaultForCurrency: Scalars['Boolean'];
  readonly id: Scalars['String'];
  readonly last4: Scalars['String'];
  readonly routingNumber: Scalars['String'];
  readonly status: StripeBankAccountVerificationStatus;
};

export enum StripeBankAccountVerificationStatus {
  ERRORED = 'errored',
  NEW = 'new',
  VALIDATED = 'validated',
  VERIFICATION_FAILED = 'verification_failed',
  VERIFIED = 'verified'
}

/** Debit card destination */
export type StripeCard = {
  readonly __typename?: 'StripeCard';
  readonly brand: Scalars['String'];
  readonly defaultForCurrency: Scalars['Boolean'];
  readonly expMonth: Scalars['String'];
  readonly expYear: Scalars['String'];
  readonly id: Scalars['String'];
  readonly instantAvailable: Scalars['Boolean'];
  readonly last4: Scalars['String'];
  readonly name?: Maybe<Scalars['String']>;
  readonly standardAvailable: Scalars['Boolean'];
};

export enum StripeChargeCard {
  CREDIT = 'credit',
  DEBIT = 'debit',
  PREPAID = 'prepaid',
  UNKNOWN = 'unknown'
}

/** A stripe connect account */
export type StripeConnectAccount = {
  readonly __typename?: 'StripeConnectAccount';
  readonly accountId?: Maybe<Scalars['String']>;
  readonly accountType: Scalars['String'];
  readonly achEnabled: Scalars['Boolean'];
  readonly achFeeFixedAmount: Scalars['Int'];
  readonly achFeePercentageAmount: Scalars['Float'];
  readonly allowPassingCreditCardFeesToCustomer: Scalars['Boolean'];
  readonly approvedAt?: Maybe<Scalars['ISO8601DateTime']>;
  readonly balance: Scalars['Int'];
  readonly cardEnabled: Scalars['Boolean'];
  readonly cardFeeFixedAmount: Scalars['Int'];
  readonly cardFeePercentageAmount: Scalars['Float'];
  readonly createdAt: Scalars['ISO8601DateTime'];
  readonly creditCardEnabled: Scalars['Boolean'];
  readonly currentDeadline?: Maybe<Scalars['ISO8601DateTime']>;
  readonly customerPaysAchFee: Scalars['Boolean'];
  readonly customerPaysCardFee: Scalars['Boolean'];
  readonly deactivatedAt?: Maybe<Scalars['ISO8601DateTime']>;
  readonly debitCardEnabled: Scalars['Boolean'];
  readonly disabledReason?: Maybe<Scalars['String']>;
  readonly externalTransferDestinations: ExternalTransferDestinations;
  readonly firstPayoutAddedAt?: Maybe<Scalars['ISO8601DateTime']>;
  readonly fullAccess: Scalars['Boolean'];
  readonly futureRequirements: StripeConnectAccountRequirements;
  readonly hearthVerificationStatus: PaymentsHearthVerificationStatus;
  readonly id: Scalars['ID'];
  readonly kycSubmitted: Scalars['Boolean'];
  readonly loginLink?: Maybe<Scalars['String']>;
  readonly organization: Organization;
  readonly partialAccess: Scalars['Boolean'];
  readonly pendingBalance: Scalars['Int'];
  readonly requireStripeExternalAccount: Scalars['Boolean'];
  readonly requirements: StripeConnectAccountRequirements;
  readonly status: ConnectAccountStatus;
  readonly totalPaidOutAmount: Scalars['Int'];
  readonly transferBalances: TransferBalances;
};

export type StripeConnectAccountAttributes = {
  readonly achEnabled?: Maybe<Scalars['Boolean']>;
  readonly cardEnabled?: Maybe<Scalars['Boolean']>;
  readonly creditCardEnabled?: Maybe<Scalars['Boolean']>;
  readonly customerPaysAchFee?: Maybe<Scalars['Boolean']>;
  readonly customerPaysCardFee?: Maybe<Scalars['Boolean']>;
  readonly firstPayoutAddedAt?: Maybe<Scalars['ISO8601DateTime']>;
};

/** Stripe connect account error */
export type StripeConnectAccountRequirementError = {
  readonly __typename?: 'StripeConnectAccountRequirementError';
  readonly code: StripeAccountRequirementsErrorCode;
  readonly reason: Scalars['String'];
  readonly requirement: Scalars['String'];
};

/** Stripe connect account requirements hash */
export type StripeConnectAccountRequirements = {
  readonly __typename?: 'StripeConnectAccountRequirements';
  readonly currentlyDue: ReadonlyArray<Scalars['String']>;
  readonly disabledReason?: Maybe<StripeAccountDisabledReason>;
  readonly errors: ReadonlyArray<StripeConnectAccountRequirementError>;
  readonly eventuallyDue: ReadonlyArray<Scalars['String']>;
  readonly pastDue: ReadonlyArray<Scalars['String']>;
  readonly pendingVerification: ReadonlyArray<Scalars['String']>;
};

export enum StripePersonVerificationStatus {
  PENDING = 'pending',
  UNVERIFIED = 'unverified',
  VERIFIED = 'verified'
}

/** A single subscription */
export type StripeSubscription = {
  readonly __typename?: 'StripeSubscription';
  readonly canceledAt?: Maybe<Scalars['ISO8601DateTime']>;
  readonly createdAt: Scalars['ISO8601DateTime'];
  readonly currentPeriodEnd?: Maybe<Scalars['ISO8601DateTime']>;
  readonly currentPeriodStart?: Maybe<Scalars['ISO8601DateTime']>;
  readonly featureFlags: ReadonlyArray<FeatureFlag>;
  readonly id: Scalars['ID'];
  readonly planId: Scalars['String'];
  readonly status: Scalars['String'];
  readonly stripePlanId: Scalars['ID'];
};

/** The connection type for StripeSubscription. */
export type StripeSubscriptionConnection = {
  readonly __typename?: 'StripeSubscriptionConnection';
  /** A list of edges. */
  readonly edges?: Maybe<ReadonlyArray<Maybe<StripeSubscriptionEdge>>>;
  /** A list of nodes. */
  readonly nodes?: Maybe<ReadonlyArray<Maybe<StripeSubscription>>>;
  /** Information to aid in pagination. */
  readonly pageInfo: PageInfo;
  readonly totalCount: Scalars['Int'];
};

/** An edge in a connection. */
export type StripeSubscriptionEdge = {
  readonly __typename?: 'StripeSubscriptionEdge';
  /** A cursor for use in pagination. */
  readonly cursor: Scalars['String'];
  /** The item at the end of the edge. */
  readonly node?: Maybe<StripeSubscription>;
};

export type SubmitApplicationFailure = {
  readonly __typename?: 'SubmitApplicationFailure';
  readonly errors: ReadonlyArray<Error>;
};

export type SubmitApplicationResult = SubmitApplicationFailure | SubmitApplicationSuccess;

export type SubmitApplicationSuccess = {
  readonly __typename?: 'SubmitApplicationSuccess';
  readonly stripeConnectAccount: StripeConnectAccount;
};

export type SubmitBusinessInfoFailure = {
  readonly __typename?: 'SubmitBusinessInfoFailure';
  readonly errors: ReadonlyArray<Error>;
};

export type SubmitBusinessInfoResult = SubmitBusinessInfoFailure | SubmitBusinessInfoSuccess;

export type SubmitBusinessInfoSuccess = {
  readonly __typename?: 'SubmitBusinessInfoSuccess';
  readonly kycBusiness: KycBusiness;
  readonly stripeConnectAccount: StripeConnectAccount;
};

/** Autogenerated return type of SubmitLoanInquiry */
export type SubmitLoanInquiryPayload = {
  readonly __typename?: 'SubmitLoanInquiryPayload';
  readonly errors?: Maybe<ReadonlyArray<ValidationError>>;
  readonly loanInquiry?: Maybe<LoanInquiry>;
};

export type SubmitPersonInfoFailure = {
  readonly __typename?: 'SubmitPersonInfoFailure';
  readonly errors: ReadonlyArray<Error>;
};

export type SubmitPersonInfoResult = SubmitPersonInfoFailure | SubmitPersonInfoSuccess;

export type SubmitPersonInfoSuccess = {
  readonly __typename?: 'SubmitPersonInfoSuccess';
  readonly kycBusiness: KycBusiness;
  readonly kycPerson: KycPerson;
  readonly stripeConnectAccount: StripeConnectAccount;
};

export type SubmitVerificationDocumentsFailure = {
  readonly __typename?: 'SubmitVerificationDocumentsFailure';
  readonly errors: ReadonlyArray<Error>;
};

export type SubmitVerificationDocumentsResult = SubmitVerificationDocumentsFailure | SubmitVerificationDocumentsSuccess;

export type SubmitVerificationDocumentsSuccess = {
  readonly __typename?: 'SubmitVerificationDocumentsSuccess';
  readonly kycBusiness: KycBusiness;
};

/** The subscription contract */
export type SubscriptionContract = {
  readonly __typename?: 'SubscriptionContract';
  readonly status: Scalars['String'];
  readonly toBeSignedContract?: Maybe<SignedContract>;
};

/** A single event that a contractor can respond to */
export type SuggestedAction = {
  readonly __typename?: 'SuggestedAction';
  readonly contractor: Contractor;
  readonly copy: Scalars['String'];
  readonly createdAt: Scalars['ISO8601DateTime'];
  readonly ctas: SuggestedActionCtaConnection;
  readonly dismissedAt?: Maybe<Scalars['ISO8601DateTime']>;
  readonly expiredAt?: Maybe<Scalars['ISO8601DateTime']>;
  readonly id: Scalars['ID'];
  readonly metadata: Scalars['JSON'];
  readonly onboardingActionable: Scalars['Boolean'];
  readonly respondedAt?: Maybe<Scalars['ISO8601DateTime']>;
  readonly status: SuggestedActionStatusType;
  readonly suggestedActionTypeId: SuggestedActionActionType;
  readonly title: Scalars['String'];
  readonly updatedAt: Scalars['ISO8601DateTime'];
};


/** A single event that a contractor can respond to */
export type SuggestedActionCtasArgs = {
  after?: Maybe<Scalars['String']>;
  before?: Maybe<Scalars['String']>;
  first?: Maybe<Scalars['Int']>;
  last?: Maybe<Scalars['Int']>;
};

export enum SuggestedActionActionType {
  DORMANT_HOMEOWNER_ACTION = 'dormant_homeowner_action',
  HEARTH_CASH_PAINTED_DOOR = 'hearth_cash_painted_door',
  HOMEOWNER_FUNDED_ACTION = 'homeowner_funded_action',
  HOMEOWNER_PREQUALIFIED_ACTION = 'homeowner_prequalified_action',
  HOMEOWNER_REQUESTED_ONLINE_PAYMENTS_ACTION = 'homeowner_requested_online_payments_action',
  MULTIPLE_CONTRACT_TEMPLATES_ACTION = 'multiple_contract_templates_action',
  ONBOARDING_CONTRACTS_SETUP_ACTION = 'onboarding_contracts_setup_action',
  ONBOARDING_CUSTOMIZE_BRAND_ACTION = 'onboarding_customize_brand_action',
  ONBOARDING_CUSTOMIZE_HEARTH_PAY_SETTINGS_ACTION = 'onboarding_customize_hearth_pay_settings_action',
  ONBOARDING_CUSTOMIZE_INVOICE_ACTION = 'onboarding_customize_invoice_action',
  ONBOARDING_DOWNLOAD_APP_ACTION = 'onboarding_download_app_action',
  ONBOARDING_HEARTH_PAY_TRAINING_ACTION = 'onboarding_hearth_pay_training_action',
  ONBOARDING_INSTALL_BANNER_ACTION = 'onboarding_install_banner_action',
  ONBOARDING_INVITE_TEAM_ACTION = 'onboarding_invite_team_action',
  ONBOARDING_OFFER_FINANCING_ACTION = 'onboarding_offer_financing_action',
  ONBOARDING_REAPPLY_KYC_ACTION = 'onboarding_reapply_kyc_action',
  ONBOARDING_SEND_FIRST_CONTRACT_ACTION = 'onboarding_send_first_contract_action',
  ONBOARDING_SEND_FIRST_INVOICE_ACTION = 'onboarding_send_first_invoice_action',
  ONBOARDING_SEND_FIRST_QUOTE_ACTION = 'onboarding_send_first_quote_action',
  ONBOARDING_SUBMIT_KYC_ACTION = 'onboarding_submit_kyc_action',
  ONBOARDING_WATCH_FINANCING_VIDEO_ACTION = 'onboarding_watch_financing_video_action',
  ONBOARDING_WATCH_HEARTH_VIDEO_ACTION = 'onboarding_watch_hearth_video_action',
  PAYMENT_FUNDS_AVAILABLE_ACTION = 'payment_funds_available_action',
  PAYMENT_TEN_DAYS_OVERDUE_ACTION = 'payment_ten_days_overdue_action',
  PAYMENTS_FIRST_PAID_INVOICE = 'payments_first_paid_invoice'
}

export type SuggestedActionClickFailure = {
  readonly __typename?: 'SuggestedActionClickFailure';
  readonly errors: ReadonlyArray<Error>;
};

export type SuggestedActionClickResult = SuggestedActionClickFailure | SuggestedActionClickSuccess;

export type SuggestedActionClickSuccess = {
  readonly __typename?: 'SuggestedActionClickSuccess';
  readonly suggestedAction: SuggestedAction;
};

/** The connection type for SuggestedAction. */
export type SuggestedActionConnection = {
  readonly __typename?: 'SuggestedActionConnection';
  /** A list of edges. */
  readonly edges?: Maybe<ReadonlyArray<Maybe<SuggestedActionEdge>>>;
  /** A list of nodes. */
  readonly nodes?: Maybe<ReadonlyArray<Maybe<SuggestedAction>>>;
  /** Information to aid in pagination. */
  readonly pageInfo: PageInfo;
  readonly totalCount: Scalars['Int'];
};

/** CTAs that can respond to an event, each has its own deeplink */
export type SuggestedActionCta = {
  readonly __typename?: 'SuggestedActionCta';
  readonly clickedAt?: Maybe<Scalars['ISO8601DateTime']>;
  readonly copy: Scalars['String'];
  readonly createdAt: Scalars['ISO8601DateTime'];
  readonly id: Scalars['ID'];
  readonly mobileLink?: Maybe<Scalars['String']>;
  readonly suggestedAction: SuggestedAction;
  readonly updatedAt: Scalars['ISO8601DateTime'];
  readonly webLink?: Maybe<Scalars['String']>;
};

/** The connection type for SuggestedActionCta. */
export type SuggestedActionCtaConnection = {
  readonly __typename?: 'SuggestedActionCtaConnection';
  /** A list of edges. */
  readonly edges?: Maybe<ReadonlyArray<Maybe<SuggestedActionCtaEdge>>>;
  /** A list of nodes. */
  readonly nodes?: Maybe<ReadonlyArray<Maybe<SuggestedActionCta>>>;
  /** Information to aid in pagination. */
  readonly pageInfo: PageInfo;
  readonly totalCount: Scalars['Int'];
};

/** An edge in a connection. */
export type SuggestedActionCtaEdge = {
  readonly __typename?: 'SuggestedActionCtaEdge';
  /** A cursor for use in pagination. */
  readonly cursor: Scalars['String'];
  /** The item at the end of the edge. */
  readonly node?: Maybe<SuggestedActionCta>;
};

export type SuggestedActionDismissFailure = {
  readonly __typename?: 'SuggestedActionDismissFailure';
  readonly errors: ReadonlyArray<Error>;
};

export type SuggestedActionDismissResult = SuggestedActionDismissFailure | SuggestedActionDismissSuccess;

export type SuggestedActionDismissSuccess = {
  readonly __typename?: 'SuggestedActionDismissSuccess';
  readonly suggestedAction: SuggestedAction;
};

/** An edge in a connection. */
export type SuggestedActionEdge = {
  readonly __typename?: 'SuggestedActionEdge';
  /** A cursor for use in pagination. */
  readonly cursor: Scalars['String'];
  /** The item at the end of the edge. */
  readonly node?: Maybe<SuggestedAction>;
};

export enum SuggestedActionScopeType {
  ACTIONABLE = 'actionable',
  EXPIRED = 'expired',
  UNACTIONABLE = 'unactionable'
}

export enum SuggestedActionStatusType {
  DISMISSED = 'dismissed',
  OBSOLETE = 'obsolete',
  READ = 'read',
  RESOLVED = 'resolved',
  UNREAD = 'unread'
}

export type SwitchEnterpriseOrgFailure = {
  readonly __typename?: 'SwitchEnterpriseOrgFailure';
  readonly errors: ReadonlyArray<Error>;
};

export type SwitchEnterpriseOrgResult = SwitchEnterpriseOrgFailure | SwitchEnterpriseOrgSuccess;

export type SwitchEnterpriseOrgSuccess = {
  readonly __typename?: 'SwitchEnterpriseOrgSuccess';
  readonly contractor: Contractor;
};

/** A template, such as a contractor email template */
export type Template = {
  readonly __typename?: 'Template';
  readonly generatedTemplate: Scalars['String'];
  readonly id: Scalars['ID'];
  readonly optionalVariables?: Maybe<ReadonlyArray<Scalars['String']>>;
  readonly requiredVariables?: Maybe<ReadonlyArray<Scalars['String']>>;
  readonly subject: Scalars['String'];
  readonly templateString: Scalars['String'];
  readonly templateTypeId: Scalars['String'];
};


/** A template, such as a contractor email template */
export type TemplateGeneratedTemplateArgs = {
  templateParams?: Maybe<Scalars['JSON']>;
};

export type TemplateLineItemParams = {
  readonly baseLineItemId?: Maybe<Scalars['ID']>;
  readonly description: Scalars['String'];
  readonly name: Scalars['String'];
  readonly priceInCents: Scalars['Int'];
  readonly quantity: Scalars['Int'];
};

export type TemplateLineItemUpdateParams = {
  readonly baseLineItemId?: Maybe<Scalars['ID']>;
  readonly description: Scalars['String'];
  readonly name: Scalars['String'];
  readonly priceInCents: Scalars['Int'];
  readonly quantity: Scalars['Int'];
  readonly templateLineItemId?: Maybe<Scalars['ID']>;
};

/** Transfer balance info */
export type TransferBalances = {
  readonly __typename?: 'TransferBalances';
  readonly achTransferFees: Scalars['Int'];
  readonly alreadyPayedOut: Scalars['Int'];
  readonly cardTransferFees: Scalars['Int'];
  readonly grossTransferAmount: Scalars['Int'];
  readonly hasCompletedPayout: Scalars['Boolean'];
  readonly totalAvailableInstant: Scalars['Int'];
  readonly totalAvailableStandard: Scalars['Int'];
  readonly totalPending: Scalars['Int'];
};

/** Union of bank account and card */
export type TransferDestination = StripeBankAccount | StripeCard;

export type UpdateAcceptedPaymentsFailure = {
  readonly __typename?: 'UpdateAcceptedPaymentsFailure';
  readonly errors: ReadonlyArray<Error>;
};

export type UpdateAcceptedPaymentsResult = UpdateAcceptedPaymentsFailure | UpdateAcceptedPaymentsSuccess;

export type UpdateAcceptedPaymentsSuccess = {
  readonly __typename?: 'UpdateAcceptedPaymentsSuccess';
  readonly stripeConnectAccount: StripeConnectAccount;
};

/** Autogenerated return type of UpdateCoapplicant */
export type UpdateCoapplicantPayload = {
  readonly __typename?: 'UpdateCoapplicantPayload';
  readonly coapplicant?: Maybe<Coapplicant>;
  readonly errors?: Maybe<ReadonlyArray<ValidationError>>;
  readonly loanInquiry: LoanInquiry;
};

export type UpdateConnectInvoicePaymentsCapabilityStatusFailure = {
  readonly __typename?: 'UpdateConnectInvoicePaymentsCapabilityStatusFailure';
  readonly errors: ReadonlyArray<Error>;
};

export type UpdateConnectInvoicePaymentsCapabilityStatusResult = UpdateConnectInvoicePaymentsCapabilityStatusFailure | UpdateConnectInvoicePaymentsCapabilityStatusSuccess;

export type UpdateConnectInvoicePaymentsCapabilityStatusSuccess = {
  readonly __typename?: 'UpdateConnectInvoicePaymentsCapabilityStatusSuccess';
  readonly connectInvoice: ConnectInvoice;
};

/** Autogenerated return type of UpdateContractor */
export type UpdateContractorPayload = {
  readonly __typename?: 'UpdateContractorPayload';
  readonly contractor?: Maybe<Contractor>;
  readonly errors?: Maybe<ReadonlyArray<ValidationError>>;
};

export type UpdateHackathonHomeownerLeadFailure = {
  readonly __typename?: 'UpdateHackathonHomeownerLeadFailure';
  readonly errors: ReadonlyArray<Error>;
};

export type UpdateHackathonHomeownerLeadResult = UpdateHackathonHomeownerLeadFailure | UpdateHackathonHomeownerLeadSuccess;

export type UpdateHackathonHomeownerLeadSuccess = {
  readonly __typename?: 'UpdateHackathonHomeownerLeadSuccess';
  readonly homeowner?: Maybe<Homeowner>;
};

export type UpdateHomeownerFailure = {
  readonly __typename?: 'UpdateHomeownerFailure';
  readonly errors: ReadonlyArray<Error>;
};

export type UpdateHomeownerResult = UpdateHomeownerFailure | UpdateHomeownerSuccess;

export type UpdateHomeownerSuccess = {
  readonly __typename?: 'UpdateHomeownerSuccess';
  readonly homeowner: Homeowner;
};

/** Autogenerated return type of UpdateLoanInquiry */
export type UpdateLoanInquiryPayload = {
  readonly __typename?: 'UpdateLoanInquiryPayload';
  readonly errors?: Maybe<ReadonlyArray<ValidationError>>;
  readonly loanInquiry?: Maybe<LoanInquiry>;
};

/** Autogenerated return type of UpdateOrganization */
export type UpdateOrganizationPayload = {
  readonly __typename?: 'UpdateOrganizationPayload';
  readonly errors?: Maybe<ReadonlyArray<ValidationError>>;
  readonly organization: Organization;
};

export type UpdateQuickbooksSyncSettingsFailure = {
  readonly __typename?: 'UpdateQuickbooksSyncSettingsFailure';
  readonly errors: ReadonlyArray<Error>;
};

export type UpdateQuickbooksSyncSettingsResult = UpdateQuickbooksSyncSettingsFailure | UpdateQuickbooksSyncSettingsSuccess;

export type UpdateQuickbooksSyncSettingsSuccess = {
  readonly __typename?: 'UpdateQuickbooksSyncSettingsSuccess';
  readonly quickbooksBusiness: QuickbooksBusiness;
};

export type UpdateReminderSettingFailure = {
  readonly __typename?: 'UpdateReminderSettingFailure';
  readonly errors: ReadonlyArray<Error>;
};

export type UpdateReminderSettingResult = UpdateReminderSettingFailure | UpdateReminderSettingSuccess;

export type UpdateReminderSettingSuccess = {
  readonly __typename?: 'UpdateReminderSettingSuccess';
  readonly reminderSetting: ReminderSetting;
};

/** Autogenerated return type of UpdateReminderSettings */
export type UpdateReminderSettingsPayload = {
  readonly __typename?: 'UpdateReminderSettingsPayload';
  readonly errors?: Maybe<ReadonlyArray<ValidationError>>;
  readonly reminderSetting: ReminderSetting;
};

/** Autogenerated return type of UpdateResources */
export type UpdateResourcesPayload = {
  readonly __typename?: 'UpdateResourcesPayload';
  readonly errors?: Maybe<ReadonlyArray<ValidationError>>;
  readonly resource: Resource;
};

export type UpdateStripeConnectAccountFailure = {
  readonly __typename?: 'UpdateStripeConnectAccountFailure';
  readonly errors: ReadonlyArray<Error>;
};

export type UpdateStripeConnectAccountResult = UpdateStripeConnectAccountFailure | UpdateStripeConnectAccountSuccess;

export type UpdateStripeConnectAccountSuccess = {
  readonly __typename?: 'UpdateStripeConnectAccountSuccess';
  readonly stripeConnectAccount: StripeConnectAccount;
};


export type UpsertArticleInteractionFailure = {
  readonly __typename?: 'UpsertArticleInteractionFailure';
  readonly errors: ReadonlyArray<Error>;
};

export type UpsertArticleInteractionResult = UpsertArticleInteractionFailure | UpsertArticleInteractionSuccess;

export type UpsertArticleInteractionSuccess = {
  readonly __typename?: 'UpsertArticleInteractionSuccess';
  readonly articleInteraction: ArticleInteraction;
};

export type UpsertContractorFailure = {
  readonly __typename?: 'UpsertContractorFailure';
  readonly errors: ReadonlyArray<Error>;
};

export type UpsertContractorResult = UpsertContractorFailure | UpsertContractorSuccess;

export type UpsertContractorSuccess = {
  readonly __typename?: 'UpsertContractorSuccess';
  readonly contractor: Contractor;
};

export type UpsertCustomizedInvoiceTemplateFailure = {
  readonly __typename?: 'UpsertCustomizedInvoiceTemplateFailure';
  readonly errors: ReadonlyArray<Error>;
};

export type UpsertCustomizedInvoiceTemplateResult = UpsertCustomizedInvoiceTemplateFailure | UpsertCustomizedInvoiceTemplateSuccess;

export type UpsertCustomizedInvoiceTemplateSuccess = {
  readonly __typename?: 'UpsertCustomizedInvoiceTemplateSuccess';
  readonly invoiceTemplate: CustomizedInvoiceTemplate;
};

export type UpsertHomeownerFailure = {
  readonly __typename?: 'UpsertHomeownerFailure';
  readonly errors: ReadonlyArray<Error>;
};

export type UpsertHomeownerFinancingFeedbackFailure = {
  readonly __typename?: 'UpsertHomeownerFinancingFeedbackFailure';
  readonly errors: ReadonlyArray<Error>;
};

export type UpsertHomeownerFinancingFeedbackResult = UpsertHomeownerFinancingFeedbackFailure | UpsertHomeownerFinancingFeedbackSuccess;

export type UpsertHomeownerFinancingFeedbackSuccess = {
  readonly __typename?: 'UpsertHomeownerFinancingFeedbackSuccess';
  readonly homeownerFeedbackResponse: HomeownerFeedbackResponse;
};

export type UpsertHomeownerPaymentsFeedbackFailure = {
  readonly __typename?: 'UpsertHomeownerPaymentsFeedbackFailure';
  readonly errors: ReadonlyArray<Error>;
};

export type UpsertHomeownerPaymentsFeedbackResult = UpsertHomeownerPaymentsFeedbackFailure | UpsertHomeownerPaymentsFeedbackSuccess;

export type UpsertHomeownerPaymentsFeedbackSuccess = {
  readonly __typename?: 'UpsertHomeownerPaymentsFeedbackSuccess';
  readonly homeownerFeedbackResponse: HomeownerFeedbackResponse;
};

export type UpsertHomeownerResult = UpsertHomeownerFailure | UpsertHomeownerSuccess;

export type UpsertHomeownerSuccess = {
  readonly __typename?: 'UpsertHomeownerSuccess';
  readonly homeowner?: Maybe<Homeowner>;
};

export type UpsertNotificationFailure = {
  readonly __typename?: 'UpsertNotificationFailure';
  readonly errors: ReadonlyArray<Error>;
};

export type UpsertNotificationResult = UpsertNotificationFailure | UpsertNotificationSuccess;

export type UpsertNotificationSuccess = {
  readonly __typename?: 'UpsertNotificationSuccess';
  readonly notification: Notification;
};

export type UpsertOrganizationFailure = {
  readonly __typename?: 'UpsertOrganizationFailure';
  readonly errors: ReadonlyArray<Error>;
};

export type UpsertOrganizationResult = UpsertOrganizationFailure | UpsertOrganizationSuccess;

export type UpsertOrganizationSuccess = {
  readonly __typename?: 'UpsertOrganizationSuccess';
  readonly organization: Organization;
};

/** Autogenerated return type of UpsertPresaleCourseVideoInteraction */
export type UpsertPresaleCourseVideoInteractionPayload = {
  readonly __typename?: 'UpsertPresaleCourseVideoInteractionPayload';
  readonly presaleLead?: Maybe<PresaleLead>;
};

export type UpsertTemplateFailure = {
  readonly __typename?: 'UpsertTemplateFailure';
  readonly errors: ReadonlyArray<Error>;
};

export type UpsertTemplateResult = UpsertTemplateFailure | UpsertTemplateSuccess;

export type UpsertTemplateSuccess = {
  readonly __typename?: 'UpsertTemplateSuccess';
  readonly template: Template;
};

/** A user-readable error */
export type ValidationError = Error & {
  readonly __typename?: 'ValidationError';
  /** The code to switch off of for errors */
  readonly code: ErrorCodes;
  /** Extra information about this error type */
  readonly extensions?: Maybe<Extension>;
  /** A description of the error */
  readonly message: Scalars['String'];
  /** Which input value this error came from */
  readonly path?: Maybe<ReadonlyArray<Scalars['String']>>;
};

/** Enabled state for payment walkthrough components */
export type WalkthroughPaymentFlags = {
  readonly __typename?: 'WalkthroughPaymentFlags';
  readonly balanceAvailableCallout: Scalars['Boolean'];
  readonly detailsCallout: Scalars['Boolean'];
  readonly requestCallout: Scalars['Boolean'];
  readonly sentDialog: Scalars['Boolean'];
  readonly settingsCallout: Scalars['Boolean'];
};

/** Fields that on a livestorm webinar session object */
export type Webinar = {
  readonly __typename?: 'Webinar';
  readonly attributes: SessionAttribute;
  readonly id: Scalars['String'];
};

export type ModelsApplicationFormResponse = {
  readonly __typename?: 'models_ApplicationFormResponse';
  readonly URL?: Maybe<Scalars['String']>;
  readonly orgID?: Maybe<Scalars['String']>;
  readonly stage?: Maybe<Scalars['String']>;
  readonly status?: Maybe<Scalars['String']>;
  readonly unitApplicationID?: Maybe<Scalars['String']>;
};

export type ModelsCardCreationResponse = {
  readonly __typename?: 'models_CardCreationResponse';
  readonly createdAt?: Maybe<Scalars['String']>;
  readonly expirationDate?: Maybe<Scalars['String']>;
  readonly id?: Maybe<Scalars['String']>;
  readonly last4Digits?: Maybe<Scalars['String']>;
  readonly shippingAddress?: Maybe<ModelsCardCreationResponseShippingAddress>;
  readonly status?: Maybe<Scalars['String']>;
};

export type ModelsCardCreationResponseShippingAddress = {
  readonly __typename?: 'models_CardCreationResponse_shippingAddress';
  readonly city?: Maybe<Scalars['String']>;
  readonly country?: Maybe<Scalars['String']>;
  readonly postalCode?: Maybe<Scalars['String']>;
  readonly state?: Maybe<Scalars['String']>;
  readonly street?: Maybe<Scalars['String']>;
  readonly street2?: Maybe<Scalars['String']>;
};

export type ModelsCounterpartyResponseResource = {
  readonly __typename?: 'models_CounterpartyResponseResource';
  readonly accountName?: Maybe<Scalars['String']>;
  readonly accountNumber?: Maybe<Scalars['String']>;
  readonly accountType?: Maybe<Scalars['String']>;
  readonly bank?: Maybe<Scalars['String']>;
  readonly customerId?: Maybe<Scalars['String']>;
  readonly id?: Maybe<Scalars['String']>;
  readonly permissions?: Maybe<Scalars['String']>;
  readonly routingNumber?: Maybe<Scalars['String']>;
  readonly type?: Maybe<Scalars['String']>;
};

export type ModelsCreateAccountRequestBodyInput = {
  readonly customerId?: Maybe<Scalars['String']>;
  readonly customerType?: Maybe<Scalars['String']>;
  readonly depositProduct?: Maybe<Scalars['String']>;
  readonly orgID?: Maybe<Scalars['String']>;
  readonly purpose?: Maybe<Scalars['String']>;
  readonly type?: Maybe<Scalars['String']>;
};

export type ModelsCreateCardRequestInput = {
  readonly accountId?: Maybe<Scalars['String']>;
  readonly accountType?: Maybe<Scalars['String']>;
  readonly additionalEmbossedText?: Maybe<Scalars['String']>;
  readonly address?: Maybe<ModelsCreateCardRequestInputAddressInput>;
  readonly dateOfBirth?: Maybe<Scalars['String']>;
  readonly design?: Maybe<Scalars['String']>;
  readonly email?: Maybe<Scalars['String']>;
  readonly fullName?: Maybe<ModelsCreateCardRequestInputFullNameInput>;
  readonly idempotencyKey?: Maybe<Scalars['String']>;
  readonly limits?: Maybe<ModelsCreateCardRequestInputLimitsInput>;
  readonly orgID?: Maybe<Scalars['String']>;
  readonly phone?: Maybe<ModelsCreateCardRequestInputPhoneInput>;
  readonly shippingAddress?: Maybe<ModelsCreateCardRequestInputShippingAddressInput>;
  readonly type?: Maybe<Scalars['String']>;
};

export type ModelsCreateCardRequestInputAddressInput = {
  readonly city?: Maybe<Scalars['String']>;
  readonly country?: Maybe<Scalars['String']>;
  readonly postalCode?: Maybe<Scalars['String']>;
  readonly state?: Maybe<Scalars['String']>;
  readonly street?: Maybe<Scalars['String']>;
  readonly street2?: Maybe<Scalars['String']>;
};

export type ModelsCreateCardRequestInputFullNameInput = {
  readonly first?: Maybe<Scalars['String']>;
  readonly last?: Maybe<Scalars['String']>;
};

export type ModelsCreateCardRequestInputLimitsInput = {
  readonly dailyPurchase?: Maybe<Scalars['Int']>;
  readonly dailyWithdrawal?: Maybe<Scalars['Int']>;
  readonly monthlyPurchase?: Maybe<Scalars['Int']>;
  readonly monthlyWithdrawal?: Maybe<Scalars['Int']>;
};

export type ModelsCreateCardRequestInputPhoneInput = {
  readonly countryCode?: Maybe<Scalars['String']>;
  readonly number?: Maybe<Scalars['String']>;
};

export type ModelsCreateCardRequestInputShippingAddressInput = {
  readonly city?: Maybe<Scalars['String']>;
  readonly country?: Maybe<Scalars['String']>;
  readonly postalCode?: Maybe<Scalars['String']>;
  readonly state?: Maybe<Scalars['String']>;
  readonly street?: Maybe<Scalars['String']>;
  readonly street2?: Maybe<Scalars['String']>;
};

export type ModelsCreateCounterpartyRequestInput = {
  readonly accountName?: Maybe<Scalars['String']>;
  readonly accountNumber?: Maybe<Scalars['String']>;
  readonly accountType?: Maybe<Scalars['String']>;
  readonly organizationId?: Maybe<Scalars['String']>;
  readonly routingNumber?: Maybe<Scalars['String']>;
  readonly type?: Maybe<Scalars['String']>;
};

export type ModelsCreateFeeRequestBodyInput = {
  readonly accountID?: Maybe<Scalars['String']>;
  readonly amount?: Maybe<Scalars['String']>;
  readonly description?: Maybe<Scalars['String']>;
};

export type ModelsCustomerTokenVerificationResponse = {
  readonly __typename?: 'models_CustomerTokenVerificationResponse';
  readonly customerID?: Maybe<Scalars['String']>;
  readonly success?: Maybe<Scalars['Boolean']>;
  readonly verificationToken?: Maybe<Scalars['String']>;
};

export type ModelsDeleteCounterpartyResponse = {
  readonly __typename?: 'models_DeleteCounterpartyResponse';
  readonly success?: Maybe<Scalars['Boolean']>;
};

export type ModelsDepositAccountResource = {
  readonly __typename?: 'models_DepositAccountResource';
  readonly attributes?: Maybe<ModelsDepositAccountResourceAttributes>;
  readonly id?: Maybe<Scalars['String']>;
  readonly type?: Maybe<Scalars['String']>;
};

export type ModelsDepositAccountResourceAttributes = {
  readonly __typename?: 'models_DepositAccountResource_attributes';
  readonly accountNumber?: Maybe<Scalars['String']>;
  readonly available?: Maybe<Scalars['Int']>;
  readonly balance?: Maybe<Scalars['Int']>;
  readonly createdAt?: Maybe<Scalars['String']>;
  readonly currency?: Maybe<Scalars['String']>;
  readonly depositProduct?: Maybe<Scalars['String']>;
  readonly hold?: Maybe<Scalars['Int']>;
  readonly name?: Maybe<Scalars['String']>;
  readonly routingNumber?: Maybe<Scalars['String']>;
  readonly status?: Maybe<Scalars['String']>;
};

export type ModelsFeeResponseResource = {
  readonly __typename?: 'models_FeeResponseResource';
  readonly accountID?: Maybe<Scalars['String']>;
  readonly amount?: Maybe<Scalars['Int']>;
  readonly feeID?: Maybe<Scalars['String']>;
};

export type ModelsFreezeAccountRequestInput = {
  readonly accountID?: Maybe<Scalars['String']>;
  readonly reason?: Maybe<Scalars['String']>;
  readonly reasonText?: Maybe<Scalars['String']>;
};

export type ModelsGetAccountResponse = {
  readonly __typename?: 'models_GetAccountResponse';
  readonly accountNumber?: Maybe<Scalars['String']>;
  readonly available?: Maybe<Scalars['Int']>;
  readonly balance?: Maybe<Scalars['Int']>;
  readonly createdAt?: Maybe<Scalars['String']>;
  readonly currency?: Maybe<Scalars['String']>;
  readonly depositProduct?: Maybe<Scalars['String']>;
  readonly hold?: Maybe<Scalars['Int']>;
  readonly id?: Maybe<Scalars['String']>;
  readonly name?: Maybe<Scalars['String']>;
  readonly routingNumber?: Maybe<Scalars['String']>;
  readonly status?: Maybe<Scalars['String']>;
};

export type ModelsGetCardLimitResource = {
  readonly __typename?: 'models_GetCardLimitResource';
  readonly dailyTotals?: Maybe<ModelsGetCardLimitResourceDailyTotals>;
  readonly limits?: Maybe<ModelsGetCardLimitResourceLimits>;
  readonly monthlyTotals?: Maybe<ModelsGetCardLimitResourceMonthlyTotals>;
};

export type ModelsGetCardLimitResourceDailyTotals = {
  readonly __typename?: 'models_GetCardLimitResource_dailyTotals';
  readonly deposits?: Maybe<Scalars['Int']>;
  readonly purchases?: Maybe<Scalars['Int']>;
  readonly withdrawals?: Maybe<Scalars['Int']>;
};

export type ModelsGetCardLimitResourceLimits = {
  readonly __typename?: 'models_GetCardLimitResource_limits';
  readonly dailyPurchase?: Maybe<Scalars['Int']>;
  readonly dailyWithdrawal?: Maybe<Scalars['Int']>;
  readonly monthlyPurchase?: Maybe<Scalars['Int']>;
  readonly monthlyWithdrawal?: Maybe<Scalars['Int']>;
};

export type ModelsGetCardLimitResourceMonthlyTotals = {
  readonly __typename?: 'models_GetCardLimitResource_monthlyTotals';
  readonly deposits?: Maybe<Scalars['Int']>;
  readonly purchases?: Maybe<Scalars['Int']>;
  readonly withdrawals?: Maybe<Scalars['Int']>;
};

export type ModelsGetCardResource = {
  readonly __typename?: 'models_GetCardResource';
  readonly address?: Maybe<ModelsGetCardResourceAddress>;
  readonly createdAt?: Maybe<Scalars['String']>;
  readonly dateOfBirth?: Maybe<Scalars['String']>;
  readonly design?: Maybe<Scalars['String']>;
  readonly email?: Maybe<Scalars['String']>;
  readonly expirationDate?: Maybe<Scalars['String']>;
  readonly fullName?: Maybe<ModelsGetCardResourceFullName>;
  readonly id?: Maybe<Scalars['String']>;
  readonly last4Digits?: Maybe<Scalars['String']>;
  readonly nationality?: Maybe<Scalars['String']>;
  readonly passport?: Maybe<Scalars['String']>;
  readonly phone?: Maybe<ModelsGetCardResourcePhone>;
  readonly shippingAddress?: Maybe<ModelsGetCardResourceShippingAddress>;
  readonly ssn?: Maybe<Scalars['String']>;
  readonly status?: Maybe<Scalars['String']>;
};

export type ModelsGetCardResourceAddress = {
  readonly __typename?: 'models_GetCardResource_address';
  readonly city?: Maybe<Scalars['String']>;
  readonly country?: Maybe<Scalars['String']>;
  readonly postalCode?: Maybe<Scalars['String']>;
  readonly state?: Maybe<Scalars['String']>;
  readonly street?: Maybe<Scalars['String']>;
  readonly street2?: Maybe<Scalars['String']>;
};

export type ModelsGetCardResourceFullName = {
  readonly __typename?: 'models_GetCardResource_fullName';
  readonly first?: Maybe<Scalars['String']>;
  readonly last?: Maybe<Scalars['String']>;
};

export type ModelsGetCardResourcePhone = {
  readonly __typename?: 'models_GetCardResource_phone';
  readonly countryCode?: Maybe<Scalars['String']>;
  readonly number?: Maybe<Scalars['String']>;
};

export type ModelsGetCardResourceShippingAddress = {
  readonly __typename?: 'models_GetCardResource_shippingAddress';
  readonly city?: Maybe<Scalars['String']>;
  readonly country?: Maybe<Scalars['String']>;
  readonly postalCode?: Maybe<Scalars['String']>;
  readonly state?: Maybe<Scalars['String']>;
  readonly street?: Maybe<Scalars['String']>;
  readonly street2?: Maybe<Scalars['String']>;
};

export type ModelsGetCounterpartyBalanceResponse = {
  readonly __typename?: 'models_GetCounterpartyBalanceResponse';
  readonly available?: Maybe<Scalars['Float']>;
  readonly balance?: Maybe<Scalars['Float']>;
  readonly counterpartyId?: Maybe<Scalars['String']>;
  readonly customerId?: Maybe<Scalars['String']>;
};

export type ModelsGetCustomerResponse = {
  readonly __typename?: 'models_GetCustomerResponse';
  readonly address?: Maybe<ModelsGetCustomerResponseAddress>;
  readonly createdAt?: Maybe<Scalars['String']>;
  readonly dateOfBirth?: Maybe<Scalars['String']>;
  readonly ein?: Maybe<Scalars['String']>;
  readonly email?: Maybe<Scalars['String']>;
  readonly entityType?: Maybe<Scalars['String']>;
  readonly fullName?: Maybe<Scalars['String']>;
  readonly name?: Maybe<Scalars['String']>;
  readonly org_id?: Maybe<Scalars['String']>;
  readonly phone?: Maybe<Scalars['String']>;
  readonly ssn?: Maybe<Scalars['String']>;
  readonly stateOfIncorporation?: Maybe<Scalars['String']>;
  readonly type?: Maybe<Scalars['String']>;
  readonly unit_id?: Maybe<Scalars['String']>;
};

export type ModelsGetCustomerResponseAddress = {
  readonly __typename?: 'models_GetCustomerResponse_address';
  readonly city?: Maybe<Scalars['String']>;
  readonly country?: Maybe<Scalars['String']>;
  readonly postalCode?: Maybe<Scalars['String']>;
  readonly state?: Maybe<Scalars['String']>;
  readonly street?: Maybe<Scalars['String']>;
  readonly street2?: Maybe<Scalars['String']>;
};

export type ModelsGetCustomersResponse = {
  readonly __typename?: 'models_GetCustomersResponse';
  readonly customers?: Maybe<ReadonlyArray<ModelsGetCustomerResponse>>;
};

export type ModelsGetDepositAccountBalanceHistoryResponse = {
  readonly __typename?: 'models_GetDepositAccountBalanceHistoryResponse';
  readonly accountID?: Maybe<Scalars['String']>;
  readonly available?: Maybe<Scalars['Int']>;
  readonly balance?: Maybe<Scalars['Int']>;
  readonly customerID?: Maybe<Scalars['String']>;
  readonly date?: Maybe<Scalars['String']>;
  readonly hold?: Maybe<Scalars['Int']>;
};

export type ModelsGetDepositAccountLimitsResponse = {
  readonly __typename?: 'models_GetDepositAccountLimitsResponse';
  readonly ach?: Maybe<ModelsGetDepositAccountLimitsResponseAch>;
  readonly card?: Maybe<ModelsGetDepositAccountLimitsResponseCard>;
};

export type ModelsGetDepositAccountLimitsResponseAch = {
  readonly __typename?: 'models_GetDepositAccountLimitsResponse_ach';
  readonly limits?: Maybe<ModelsGetDepositAccountLimitsResponseAchLimits>;
  readonly totalsDaily?: Maybe<ModelsGetDepositAccountLimitsResponseAchTotalsDaily>;
  readonly totalsMonthly?: Maybe<ModelsGetDepositAccountLimitsResponseAchTotalsMonthly>;
};

export type ModelsGetDepositAccountLimitsResponseAchLimits = {
  readonly __typename?: 'models_GetDepositAccountLimitsResponse_ach_limits';
  readonly dailyCredit?: Maybe<Scalars['Int']>;
  readonly dailyDebit?: Maybe<Scalars['Int']>;
  readonly monthlyCredit?: Maybe<Scalars['Int']>;
  readonly monthlyDebit?: Maybe<Scalars['Int']>;
};

export type ModelsGetDepositAccountLimitsResponseAchTotalsDaily = {
  readonly __typename?: 'models_GetDepositAccountLimitsResponse_ach_totalsDaily';
  readonly credits?: Maybe<Scalars['Int']>;
  readonly debits?: Maybe<Scalars['Int']>;
};

export type ModelsGetDepositAccountLimitsResponseAchTotalsMonthly = {
  readonly __typename?: 'models_GetDepositAccountLimitsResponse_ach_totalsMonthly';
  readonly credits?: Maybe<Scalars['Int']>;
  readonly debits?: Maybe<Scalars['Int']>;
};

export type ModelsGetDepositAccountLimitsResponseCard = {
  readonly __typename?: 'models_GetDepositAccountLimitsResponse_card';
  readonly limits?: Maybe<ModelsGetDepositAccountLimitsResponseCardLimits>;
  readonly totalsDaily?: Maybe<ModelsGetDepositAccountLimitsResponseCardTotalsDaily>;
};

export type ModelsGetDepositAccountLimitsResponseCardLimits = {
  readonly __typename?: 'models_GetDepositAccountLimitsResponse_card_limits';
  readonly dailyDeposit?: Maybe<Scalars['Int']>;
  readonly dailyPurchase?: Maybe<Scalars['Int']>;
  readonly dailyWithdrawal?: Maybe<Scalars['Int']>;
  readonly dailycCrdTransaction?: Maybe<Scalars['Int']>;
};

export type ModelsGetDepositAccountLimitsResponseCardTotalsDaily = {
  readonly __typename?: 'models_GetDepositAccountLimitsResponse_card_totalsDaily';
  readonly cardTransactions?: Maybe<Scalars['Int']>;
  readonly deposits?: Maybe<Scalars['Int']>;
  readonly purchases?: Maybe<Scalars['Int']>;
  readonly withdrawals?: Maybe<Scalars['Int']>;
};

export type ModelsGetStatement = {
  readonly __typename?: 'models_GetStatement';
  readonly content?: Maybe<Scalars['String']>;
};

export type ModelsGetStatementResponse = {
  readonly __typename?: 'models_GetStatementResponse';
  readonly accountID?: Maybe<Scalars['String']>;
  readonly accountType?: Maybe<Scalars['String']>;
  readonly customerID?: Maybe<Scalars['String']>;
  readonly customerType?: Maybe<Scalars['String']>;
  readonly id?: Maybe<Scalars['String']>;
  readonly period?: Maybe<Scalars['String']>;
  readonly type?: Maybe<Scalars['String']>;
};

export type ModelsGetTransactionResponse = {
  readonly __typename?: 'models_GetTransactionResponse';
  readonly amount?: Maybe<Scalars['Int']>;
  readonly atmLocation?: Maybe<Scalars['String']>;
  readonly atmName?: Maybe<Scalars['String']>;
  readonly balance?: Maybe<Scalars['Int']>;
  readonly cardLast4Digits?: Maybe<Scalars['String']>;
  readonly cardPresent?: Maybe<Scalars['Boolean']>;
  readonly companyName?: Maybe<Scalars['String']>;
  readonly coordinates?: Maybe<ModelsGetTransactionResponseCoordinates>;
  readonly counterparty?: Maybe<ModelsGetTransactionResponseCounterparty>;
  readonly counterpartyName?: Maybe<Scalars['String']>;
  readonly counterpartyRoutingNumber?: Maybe<Scalars['String']>;
  readonly createdAt?: Maybe<Scalars['String']>;
  readonly description?: Maybe<Scalars['String']>;
  readonly direction?: Maybe<Scalars['String']>;
  readonly ecommerce?: Maybe<Scalars['Boolean']>;
  readonly id?: Maybe<Scalars['String']>;
  readonly interchange?: Maybe<Scalars['Float']>;
  readonly merchant?: Maybe<ModelsGetTransactionResponseMerchant>;
  readonly reason?: Maybe<Scalars['String']>;
  readonly recurring?: Maybe<Scalars['Boolean']>;
  readonly secCode?: Maybe<Scalars['String']>;
  readonly senderAccountNumber?: Maybe<Scalars['String']>;
  readonly senderAddress?: Maybe<ModelsGetTransactionResponseSenderAddress>;
  readonly senderName?: Maybe<Scalars['String']>;
  readonly summary?: Maybe<Scalars['String']>;
  readonly surcharge?: Maybe<Scalars['Int']>;
  readonly traceNumber?: Maybe<Scalars['String']>;
  readonly type?: Maybe<Scalars['String']>;
};

export type ModelsGetTransactionResponseCoordinates = {
  readonly __typename?: 'models_GetTransactionResponse_coordinates';
  readonly latitude?: Maybe<Scalars['Float']>;
  readonly longitude?: Maybe<Scalars['Float']>;
};

export type ModelsGetTransactionResponseCounterparty = {
  readonly __typename?: 'models_GetTransactionResponse_counterparty';
  readonly accountNumber?: Maybe<Scalars['String']>;
  readonly accountType?: Maybe<Scalars['String']>;
  readonly address?: Maybe<ModelsGetTransactionResponseCounterpartyAddress>;
  readonly name?: Maybe<Scalars['String']>;
  readonly routingNumber?: Maybe<Scalars['String']>;
};

export type ModelsGetTransactionResponseCounterpartyAddress = {
  readonly __typename?: 'models_GetTransactionResponse_counterparty_address';
  readonly city?: Maybe<Scalars['String']>;
  readonly country?: Maybe<Scalars['String']>;
  readonly postalCode?: Maybe<Scalars['String']>;
  readonly state?: Maybe<Scalars['String']>;
  readonly street?: Maybe<Scalars['String']>;
  readonly street2?: Maybe<Scalars['String']>;
};

export type ModelsGetTransactionResponseMerchant = {
  readonly __typename?: 'models_GetTransactionResponse_merchant';
  readonly category?: Maybe<Scalars['String']>;
  readonly location?: Maybe<Scalars['String']>;
  readonly name?: Maybe<Scalars['String']>;
  readonly type?: Maybe<Scalars['Int']>;
};

export type ModelsGetTransactionResponseSenderAddress = {
  readonly __typename?: 'models_GetTransactionResponse_senderAddress';
  readonly city?: Maybe<Scalars['String']>;
  readonly country?: Maybe<Scalars['String']>;
  readonly postalCode?: Maybe<Scalars['String']>;
  readonly state?: Maybe<Scalars['String']>;
  readonly street?: Maybe<Scalars['String']>;
  readonly street2?: Maybe<Scalars['String']>;
};

export type ModelsModifyAccountResponse = {
  readonly __typename?: 'models_ModifyAccountResponse';
  readonly accountID?: Maybe<Scalars['String']>;
  readonly status?: Maybe<Scalars['String']>;
  readonly success?: Maybe<Scalars['Boolean']>;
};

export type ModelsOnboardingFlowRequestInput = {
  readonly accountCreated?: Maybe<Scalars['Boolean']>;
  readonly bankConnected?: Maybe<Scalars['Boolean']>;
  readonly cardCreated?: Maybe<Scalars['Boolean']>;
  readonly completed?: Maybe<Scalars['Boolean']>;
  readonly firstDeposit?: Maybe<Scalars['Boolean']>;
};

export type ModelsOnboardingFlowResponse = {
  readonly __typename?: 'models_OnboardingFlowResponse';
  readonly accountCreated?: Maybe<Scalars['Boolean']>;
  readonly bankConnected?: Maybe<Scalars['Boolean']>;
  readonly cardCreated?: Maybe<Scalars['Boolean']>;
  readonly completed?: Maybe<Scalars['Boolean']>;
  readonly firstDeposit?: Maybe<Scalars['Boolean']>;
  readonly stage?: Maybe<Scalars['String']>;
};

export type ModelsPaymentResource = {
  readonly __typename?: 'models_PaymentResource';
  readonly amount?: Maybe<Scalars['Int']>;
  readonly counterParty?: Maybe<ModelsPaymentResourceCounterParty>;
  readonly createdAt?: Maybe<Scalars['String']>;
  readonly description?: Maybe<Scalars['String']>;
  readonly direction?: Maybe<Scalars['String']>;
  readonly id?: Maybe<Scalars['String']>;
  readonly imadOmad?: Maybe<ModelsPaymentResourceImadOmad>;
  readonly status?: Maybe<Scalars['String']>;
  readonly type?: Maybe<Scalars['String']>;
};

export type ModelsPaymentResourceCounterParty = {
  readonly __typename?: 'models_PaymentResource_counterParty';
  readonly accountNumber?: Maybe<Scalars['String']>;
  readonly accountType?: Maybe<Scalars['String']>;
  readonly address?: Maybe<ModelsPaymentResourceCounterPartyAddress>;
  readonly name?: Maybe<Scalars['String']>;
  readonly routingNumber?: Maybe<Scalars['String']>;
};

export type ModelsPaymentResourceCounterPartyAddress = {
  readonly __typename?: 'models_PaymentResource_counterParty_address';
  readonly city?: Maybe<Scalars['String']>;
  readonly country?: Maybe<Scalars['String']>;
  readonly postalCode?: Maybe<Scalars['String']>;
  readonly state?: Maybe<Scalars['String']>;
  readonly street?: Maybe<Scalars['String']>;
  readonly street2?: Maybe<Scalars['String']>;
};

export type ModelsPaymentResourceImadOmad = {
  readonly __typename?: 'models_PaymentResource_imadOmad';
  readonly imad?: Maybe<Scalars['String']>;
  readonly omad?: Maybe<Scalars['String']>;
};

export type ModelsPlaidLinkTokenResponse = {
  readonly __typename?: 'models_PlaidLinkTokenResponse';
  readonly linkToken?: Maybe<Scalars['String']>;
};

export type ModelsReplaceCardRequestInput = {
  readonly city?: Maybe<Scalars['String']>;
  readonly country?: Maybe<Scalars['String']>;
  readonly postalCode?: Maybe<Scalars['String']>;
  readonly state?: Maybe<Scalars['String']>;
  readonly street?: Maybe<Scalars['String']>;
  readonly street2?: Maybe<Scalars['String']>;
  readonly type?: Maybe<Scalars['String']>;
};

export type ModelsReplaceCardResponse = {
  readonly __typename?: 'models_ReplaceCardResponse';
  readonly expirationDate?: Maybe<Scalars['String']>;
  readonly last4Digits?: Maybe<Scalars['String']>;
  readonly status?: Maybe<Scalars['String']>;
};

export type ModelsUpdateCardResponse = {
  readonly __typename?: 'models_UpdateCardResponse';
  readonly id?: Maybe<Scalars['String']>;
  readonly last4Digits?: Maybe<Scalars['String']>;
  readonly status?: Maybe<Scalars['String']>;
};

export type ModelsUpdateCounterpartyRequestInput = {
  readonly plaidProcessorToken?: Maybe<Scalars['String']>;
};

export type UpdateOrganizationLogoMutationVariables = Exact<{
  attributes: OrganizationAttributes;
}>;


export type UpdateOrganizationLogoMutation = { readonly __typename?: 'Mutation', readonly upsertOrganization?: Maybe<{ readonly __typename?: 'UpsertOrganizationFailure', readonly errors: ReadonlyArray<{ readonly __typename?: 'InternalError', readonly message: string, readonly path?: Maybe<ReadonlyArray<string>>, readonly code: ErrorCodes } | { readonly __typename?: 'ValidationError', readonly message: string, readonly path?: Maybe<ReadonlyArray<string>>, readonly code: ErrorCodes }> } | { readonly __typename?: 'UpsertOrganizationSuccess', readonly organization: { readonly __typename?: 'Organization', readonly id: string, readonly logoUrl?: Maybe<string> } }> };

export type GetAuthenticatedInfoQueryVariables = Exact<{ [key: string]: never; }>;


export type GetAuthenticatedInfoQuery = { readonly __typename?: 'Query', readonly featureFlags: ReadonlyArray<{ readonly __typename?: 'FeatureFlag', readonly id: string }>, readonly contractor?: Maybe<{ readonly __typename?: 'Contractor', readonly id: string, readonly admin: boolean, readonly passwordSet: boolean }>, readonly organization?: Maybe<{ readonly __typename?: 'Organization', readonly id: string, readonly onboarded: boolean, readonly subscriptionContract: { readonly __typename?: 'SubscriptionContract', readonly status: string } }> };

export type GetSessionQueryVariables = Exact<{ [key: string]: never; }>;


export type GetSessionQuery = { readonly __typename?: 'Query', readonly session: { readonly __typename?: 'Session', readonly hearthUid: string } };

export type SendDefaultFinancingInfoMutationVariables = Exact<{
  id: Scalars['ID'];
  mediums: ReadonlyArray<ContactMedium> | ContactMedium;
}>;


export type SendDefaultFinancingInfoMutation = { readonly __typename?: 'Mutation', readonly sendDefaultFinancingInfo?: Maybe<{ readonly __typename?: 'SendDefaultFinancingInfoFailure', readonly errors: ReadonlyArray<{ readonly __typename?: 'InternalError', readonly message: string, readonly path?: Maybe<ReadonlyArray<string>>, readonly code: ErrorCodes } | { readonly __typename?: 'ValidationError', readonly message: string, readonly path?: Maybe<ReadonlyArray<string>>, readonly code: ErrorCodes }> } | { readonly __typename?: 'SendDefaultFinancingInfoSuccess', readonly homeowner: { readonly __typename?: 'Homeowner', readonly id: string, readonly email: string } }> };

export type GetTrainingWebinarSessionsQueryVariables = Exact<{
  webinarType: HearthWebinar;
  status: Scalars['String'];
}>;


export type GetTrainingWebinarSessionsQuery = { readonly __typename?: 'Query', readonly livestormWebinars?: Maybe<ReadonlyArray<{ readonly __typename?: 'Webinar', readonly id: string, readonly attributes: { readonly __typename?: 'SessionAttribute', readonly estimatedStartedAt: string } }>> };

export type SendInviteAndScheduleWebinarMutationVariables = Exact<{
  emails: ReadonlyArray<Scalars['String']> | Scalars['String'];
  trainingScheduledAt: Scalars['ISO8601DateTime'];
  sessionId: Scalars['String'];
}>;


export type SendInviteAndScheduleWebinarMutation = { readonly __typename?: 'Mutation', readonly sendInviteAndScheduleWebinar?: Maybe<{ readonly __typename?: 'SendInviteAndScheduleWebinarFailure', readonly errors: ReadonlyArray<{ readonly __typename?: 'InternalError', readonly message: string, readonly path?: Maybe<ReadonlyArray<string>>, readonly code: ErrorCodes } | { readonly __typename?: 'ValidationError', readonly message: string, readonly path?: Maybe<ReadonlyArray<string>>, readonly code: ErrorCodes }> } | { readonly __typename?: 'SendInviteAndScheduleWebinarSuccess', readonly organization: { readonly __typename?: 'Organization', readonly id: string } }> };

export type ScheduleWebinarMutationVariables = Exact<{
  id: Scalars['ID'];
  trainingScheduledAt: Scalars['ISO8601DateTime'];
  sessionId: Scalars['String'];
}>;


export type ScheduleWebinarMutation = { readonly __typename?: 'Mutation', readonly scheduleWebinar?: Maybe<{ readonly __typename?: 'ScheduleWebinarFailure', readonly errors: ReadonlyArray<{ readonly __typename?: 'InternalError', readonly message: string, readonly path?: Maybe<ReadonlyArray<string>>, readonly code: ErrorCodes } | { readonly __typename?: 'ValidationError', readonly message: string, readonly path?: Maybe<ReadonlyArray<string>>, readonly code: ErrorCodes }> } | { readonly __typename?: 'ScheduleWebinarSuccess', readonly contractor: { readonly __typename?: 'Contractor', readonly id: string, readonly trainingScheduledAt?: Maybe<string> } }> };

export type FullContractorFragment = { readonly __typename?: 'Contractor', readonly affiliateReferralCode?: Maybe<string>, readonly affiliateUrl?: Maybe<string>, readonly appVersion?: Maybe<string>, readonly createdAt: string, readonly currentDeviceId?: Maybe<string>, readonly email: string, readonly emailNotifications: boolean, readonly firstName: string, readonly firstVisit: boolean, readonly hearthUid: string, readonly id: string, readonly lastName: string, readonly manualEntry: boolean, readonly onboarded: boolean, readonly onboardedAt?: Maybe<string>, readonly passwordSet: boolean, readonly phoneNumber: string, readonly profileCompletedAt?: Maybe<string>, readonly pushNotifications: boolean, readonly role: string, readonly demoMode: boolean, readonly demoModeSetAt?: Maybe<string>, readonly signInCount: number, readonly textNotifications: boolean, readonly trainingScheduled: boolean, readonly trainingCompleted: boolean, readonly trainingScheduledAt?: Maybe<string>, readonly trainingTime?: Maybe<string>, readonly urlPath: string, readonly weeklyQualifiedVolume?: Maybe<string>, readonly emailTemplateId: string, readonly textTemplateId: string, readonly calendlyCancelLink?: Maybe<string>, readonly needsMoreTraining: boolean, readonly trainingVideoWatchedAt?: Maybe<string>, readonly hasSeenGraduationScreen: boolean, readonly vertical: string, readonly tryPaymentsSeen: boolean, readonly hidePaymentsTab: boolean, readonly admin: boolean, readonly enterpriseAdmin: boolean, readonly webinarRedirectLink: string, readonly featureFlags: ReadonlyArray<{ readonly __typename?: 'FeatureFlag', readonly id: string }> };

export type RefreshDataQueryVariables = Exact<{ [key: string]: never; }>;


export type RefreshDataQuery = { readonly __typename?: 'Query', readonly contractor?: Maybe<(
    { readonly __typename?: 'Contractor', readonly id: string }
    & FullContractorFragment
  )>, readonly organization?: Maybe<(
    { readonly __typename?: 'Organization', readonly id: string }
    & FullOrganizationFragment
  )>, readonly featureFlags: ReadonlyArray<{ readonly __typename?: 'FeatureFlag', readonly id: string }> };

export type FetchContractorQueryVariables = Exact<{ [key: string]: never; }>;


export type FetchContractorQuery = { readonly __typename?: 'Query', readonly contractor?: Maybe<(
    { readonly __typename?: 'Contractor', readonly id: string }
    & FullContractorFragment
  )> };

export type FullOrganizationFragment = { readonly __typename?: 'Organization', readonly activeContractorCount: number, readonly address?: Maybe<string>, readonly answeredBusinessQuestions: boolean, readonly answeredProjectLeads: boolean, readonly backgroundPicture?: Maybe<string>, readonly bannerInstalledAt?: Maybe<string>, readonly businessEmail?: Maybe<string>, readonly businessPhone?: Maybe<string>, readonly descriptionOfOperations?: Maybe<string>, readonly city: string, readonly companyName: string, readonly companyType: string, readonly createdAt: string, readonly fullAddress: string, readonly hasFinancing: boolean, readonly id: string, readonly infoSetting: string, readonly latitude?: Maybe<string>, readonly logoUrl?: Maybe<string>, readonly longitude?: Maybe<string>, readonly onboarded: boolean, readonly onboardedAt?: Maybe<string>, readonly planName: string, readonly renewsAt?: Maybe<string>, readonly requireContract: boolean, readonly sandboxOrg: boolean, readonly totalSeats: number, readonly usedSeats: number, readonly sentMemberInvites?: Maybe<boolean>, readonly settings: Record<string, any>, readonly setupFlowCompleted: boolean, readonly setupFlowCompletedAt?: Maybe<string>, readonly state?: Maybe<string>, readonly statedNoTeam?: Maybe<boolean>, readonly status: string, readonly trainingCallLink?: Maybe<string>, readonly urlPath: string, readonly verticalId: string, readonly website?: Maybe<string>, readonly zipCode?: Maybe<string>, readonly featureFlags: ReadonlyArray<{ readonly __typename?: 'FeatureFlag', readonly id: string }>, readonly planFeatureFlags: ReadonlyArray<{ readonly __typename?: 'FeatureFlag', readonly id: string }>, readonly partnership?: Maybe<{ readonly __typename?: 'Partnership', readonly coupon?: Maybe<string>, readonly label?: Maybe<string>, readonly logoUrl?: Maybe<string>, readonly pageVariant?: Maybe<string>, readonly referralType?: Maybe<string>, readonly urlPath?: Maybe<string> }>, readonly subscriptionContract: { readonly __typename?: 'SubscriptionContract', readonly status: string, readonly toBeSignedContract?: Maybe<{ readonly __typename?: 'SignedContract', readonly html: string, readonly id: string, readonly text: string }> } };

export type FetchFullOrganizationQueryVariables = Exact<{ [key: string]: never; }>;


export type FetchFullOrganizationQuery = { readonly __typename?: 'Query', readonly organization?: Maybe<(
    { readonly __typename?: 'Organization', readonly id: string }
    & FullOrganizationFragment
  )> };

export type GetPaywallInfoQueryVariables = Exact<{ [key: string]: never; }>;


export type GetPaywallInfoQuery = { readonly __typename?: 'Query', readonly organization?: Maybe<{ readonly __typename?: 'Organization', readonly id: string, readonly planName: string, readonly canceledAt?: Maybe<string> }> };

export type GetQuickBooksDismissibleBannerDataQueryVariables = Exact<{ [key: string]: never; }>;


export type GetQuickBooksDismissibleBannerDataQuery = { readonly __typename?: 'Query', readonly contractor?: Maybe<{ readonly __typename?: 'Contractor', readonly id: string, readonly admin: boolean, readonly paidConnectInvoices: { readonly __typename?: 'ConnectInvoiceConnection', readonly totalCount: number }, readonly customSettings: { readonly __typename?: 'CustomContractorSettings', readonly quickbooksBannerDismissed: boolean }, readonly organization: { readonly __typename?: 'Organization', readonly id: string, readonly quickbooksBusiness?: Maybe<{ readonly __typename?: 'QuickbooksBusiness', readonly id: string }> } }> };

export type SetQuickbooksBannerDismissedMutationVariables = Exact<{
  customSettings: CustomContractorSettingsAttributes;
}>;


export type SetQuickbooksBannerDismissedMutation = { readonly __typename?: 'Mutation', readonly upsertContractor?: Maybe<{ readonly __typename?: 'UpsertContractorFailure', readonly errors: ReadonlyArray<{ readonly __typename?: 'InternalError', readonly message: string, readonly path?: Maybe<ReadonlyArray<string>>, readonly code: ErrorCodes } | { readonly __typename?: 'ValidationError', readonly message: string, readonly path?: Maybe<ReadonlyArray<string>>, readonly code: ErrorCodes }> } | { readonly __typename?: 'UpsertContractorSuccess', readonly contractor: { readonly __typename?: 'Contractor', readonly id: string, readonly customSettings: { readonly __typename?: 'CustomContractorSettings', readonly quickbooksBannerDismissed: boolean } } }> };

export type OrganizationBrandFragment = { readonly __typename?: 'Organization', readonly id: string, readonly logoUrl?: Maybe<string>, readonly companyName: string };

export type ContractorUrlFragment = { readonly __typename?: 'Contractor', readonly id: string, readonly urlPath: string };

export type FetchHomeownerOrganizationQueryVariables = Exact<{
  homeownerId: Scalars['String'];
}>;


export type FetchHomeownerOrganizationQuery = { readonly __typename?: 'Query', readonly homeowner?: Maybe<{ readonly __typename?: 'Homeowner', readonly id: string, readonly organization?: Maybe<(
      { readonly __typename?: 'Organization', readonly id: string }
      & OrganizationBrandFragment
    )>, readonly contractor?: Maybe<(
      { readonly __typename?: 'Contractor', readonly id: string }
      & ContractorUrlFragment
    )> }> };

export type FetchInvoiceOrganizationQueryVariables = Exact<{
  invoiceId: Scalars['ID'];
}>;


export type FetchInvoiceOrganizationQuery = { readonly __typename?: 'Query', readonly connectInvoice: { readonly __typename?: 'ConnectInvoice', readonly id: string, readonly organization: (
      { readonly __typename?: 'Organization', readonly id: string }
      & OrganizationBrandFragment
    ), readonly contractor: (
      { readonly __typename?: 'Contractor', readonly id: string }
      & ContractorUrlFragment
    ) } };

export type AddClientFieldGroupHomeownerFragment = { readonly __typename?: 'Homeowner', readonly id: string, readonly firstName: string, readonly lastName: string, readonly phoneNumber: string, readonly email: string, readonly defaultHomeownerAddress?: Maybe<{ readonly __typename?: 'HomeownerAddress', readonly id: string, readonly addressLineOne?: Maybe<string>, readonly addressLineTwo?: Maybe<string>, readonly city: string, readonly state?: Maybe<string>, readonly zipCode?: Maybe<string>, readonly homeowner: { readonly __typename?: 'Homeowner', readonly id: string, readonly firstName: string, readonly lastName: string, readonly phoneNumber: string, readonly email: string } }> };

export type SendEmailLeadsMutationVariables = Exact<{
  contractorId: Scalars['ID'];
  file: Scalars['String'];
  emails: Scalars['String'];
}>;


export type SendEmailLeadsMutation = { readonly __typename?: 'Mutation', readonly sendEmailLead?: Maybe<{ readonly __typename?: 'SendEmailLeadFailure', readonly errors: ReadonlyArray<{ readonly __typename?: 'InternalError', readonly message: string, readonly path?: Maybe<ReadonlyArray<string>>, readonly code: ErrorCodes } | { readonly __typename?: 'ValidationError', readonly message: string, readonly path?: Maybe<ReadonlyArray<string>>, readonly code: ErrorCodes }> } | { readonly __typename?: 'SendEmailLeadSuccess', readonly count: number, readonly organization: { readonly __typename?: 'Organization', readonly id: string } }> };

export type GetSetupLaterQueryVariables = Exact<{ [key: string]: never; }>;


export type GetSetupLaterQuery = { readonly __typename?: 'Query', readonly contractor?: Maybe<{ readonly __typename?: 'Contractor', readonly id: string, readonly role: string, readonly appVersion?: Maybe<string>, readonly onboardedAt?: Maybe<string>, readonly setupFlowAppLoginLater?: Maybe<boolean>, readonly setupFlowInstallBannersLater?: Maybe<boolean>, readonly setupFlowWatchArticleVideoLater?: Maybe<boolean>, readonly setupFlowInviteTeamLater?: Maybe<boolean>, readonly setupFlowInstallBanners?: Maybe<boolean>, readonly setupFlowAddTeamMembers?: Maybe<boolean>, readonly setupFlowTextLinkSent?: Maybe<boolean>, readonly setupFlowWatchArticleVideo?: Maybe<boolean>, readonly admin: boolean, readonly enterpriseAdmin: boolean, readonly organization: { readonly __typename?: 'Organization', readonly id: string, readonly website?: Maybe<string>, readonly bannerInstalledAt?: Maybe<string>, readonly totalSeats: number, readonly statedNoTeam?: Maybe<boolean>, readonly sentMemberInvites?: Maybe<boolean> } }> };

export type GetEnterpriseInfoQueryVariables = Exact<{ [key: string]: never; }>;


export type GetEnterpriseInfoQuery = { readonly __typename?: 'Query', readonly contractor?: Maybe<{ readonly __typename?: 'Contractor', readonly id: string, readonly role: string, readonly admin: boolean, readonly enterpriseAdmin: boolean, readonly enterpriseOrgs?: Maybe<{ readonly __typename?: 'OrganizationConnection', readonly nodes?: Maybe<ReadonlyArray<Maybe<{ readonly __typename?: 'Organization', readonly id: string, readonly companyName: string, readonly logoUrl?: Maybe<string> }>>> }>, readonly organization: { readonly __typename?: 'Organization', readonly id: string, readonly companyName: string, readonly logoUrl?: Maybe<string> } }> };

export type SwitchEnterpriseOrgMutationVariables = Exact<{
  organizationId: Scalars['ID'];
}>;


export type SwitchEnterpriseOrgMutation = { readonly __typename?: 'Mutation', readonly switchEnterpriseOrg?: Maybe<{ readonly __typename?: 'SwitchEnterpriseOrgFailure', readonly errors: ReadonlyArray<{ readonly __typename?: 'InternalError', readonly code: ErrorCodes, readonly message: string } | { readonly __typename?: 'ValidationError', readonly code: ErrorCodes, readonly message: string }> } | { readonly __typename?: 'SwitchEnterpriseOrgSuccess', readonly contractor: { readonly __typename?: 'Contractor', readonly id: string, readonly admin: boolean } }> };

export type CreateUnitBankingApplicationMutationVariables = Exact<{
  orgId: Scalars['String'];
}>;


export type CreateUnitBankingApplicationMutation = { readonly __typename?: 'Mutation', readonly CreateGinzaApplicationForm: { readonly __typename?: 'models_ApplicationFormResponse', readonly URL?: Maybe<string> } };

export type GetOrganizationIdQueryVariables = Exact<{ [key: string]: never; }>;


export type GetOrganizationIdQuery = { readonly __typename?: 'Query', readonly organization?: Maybe<{ readonly __typename?: 'Organization', readonly id: string }> };

export type GetUnitBankingApplicationStageQueryVariables = Exact<{
  orgId?: Maybe<Scalars['String']>;
}>;


export type GetUnitBankingApplicationStageQuery = { readonly __typename?: 'Query', readonly GetGinzaApplicationForms: ReadonlyArray<{ readonly __typename?: 'models_ApplicationFormResponse', readonly stage?: Maybe<string> }> };

export type ClientImportHomeownerFragment = { readonly __typename?: 'Homeowner', readonly id: string, readonly firstName: string, readonly lastName: string, readonly fullName: string, readonly phoneNumber: string, readonly email: string, readonly defaultHomeownerAddress?: Maybe<{ readonly __typename?: 'HomeownerAddress', readonly id: string, readonly addressLineOne?: Maybe<string>, readonly addressLineTwo?: Maybe<string>, readonly city: string, readonly state?: Maybe<string>, readonly zipCode?: Maybe<string>, readonly homeowner: { readonly __typename?: 'Homeowner', readonly id: string, readonly firstName: string, readonly lastName: string, readonly phoneNumber: string, readonly email: string } }> };

export type GetClientImportDataQueryVariables = Exact<{
  searchTerm: Scalars['String'];
}>;


export type GetClientImportDataQuery = { readonly __typename?: 'Query', readonly homeownerSearch: { readonly __typename?: 'HomeownerConnection', readonly nodes?: Maybe<ReadonlyArray<Maybe<(
      { readonly __typename?: 'Homeowner', readonly id: string }
      & ClientImportHomeownerFragment
    )>>> } };

export type GetContractHomeownerNameQueryVariables = Exact<{ [key: string]: never; }>;


export type GetContractHomeownerNameQuery = { readonly __typename?: 'Query', readonly organization?: Maybe<{ readonly __typename?: 'Organization', readonly id: string, readonly contractServiceAccount?: Maybe<{ readonly __typename?: 'ContractServiceAccount', readonly id: string, readonly contracts: { readonly __typename?: 'ContractServiceContractConnection', readonly nodes?: Maybe<ReadonlyArray<Maybe<{ readonly __typename?: 'ContractServiceContract', readonly id: string, readonly receiverSignature: { readonly __typename?: 'ContractServiceSignature', readonly signer: { readonly __typename?: 'ContractServiceSigner', readonly id: string, readonly fullName: string, readonly email: string } } }>>> } }> }> };

export type ClientViewContractIndexFragment = { readonly __typename?: 'ContractServiceContract', readonly id: string, readonly name: string, readonly status: ContractStatus, readonly dueDate: string, readonly createdAt: string, readonly contractNumber: number, readonly creatorId?: Maybe<string>, readonly projectContractHomeowner?: Maybe<{ readonly __typename?: 'Homeowner', readonly id: string }>, readonly receiverSignature: { readonly __typename?: 'ContractServiceSignature', readonly id: string, readonly signer: { readonly __typename?: 'ContractServiceSigner', readonly id: string, readonly fullName: string, readonly email: string } } };

export type ContractServiceAccountStatusQueryVariables = Exact<{ [key: string]: never; }>;


export type ContractServiceAccountStatusQuery = { readonly __typename?: 'Query', readonly contractor?: Maybe<{ readonly __typename?: 'Contractor', readonly id: string, readonly admin: boolean }>, readonly organization?: Maybe<{ readonly __typename?: 'Organization', readonly id: string, readonly contractServiceAccount?: Maybe<{ readonly __typename?: 'ContractServiceAccount', readonly id: string, readonly termsAgreedAt?: Maybe<string>, readonly contracts: { readonly __typename?: 'ContractServiceContractConnection', readonly nodes?: Maybe<ReadonlyArray<Maybe<(
          { readonly __typename?: 'ContractServiceContract', readonly id: string }
          & ClientViewContractIndexFragment
        )>>> } }> }> };

export type ClientContractDetailHomeownerFragment = { readonly __typename?: 'Homeowner', readonly id: string, readonly fullName: string };

export type ClientContractDetailContractorFragment = { readonly __typename?: 'Contractor', readonly id: string, readonly fullName: string };

export type ClientContractDetailContractFragment = { readonly __typename?: 'ContractServiceContract', readonly id: string, readonly name: string, readonly contractNumber: number, readonly status: ContractStatus, readonly dueDate: string, readonly createdAt: string, readonly base64Pdf?: Maybe<string>, readonly creatorId?: Maybe<string>, readonly projectContractHomeowner?: Maybe<(
    { readonly __typename?: 'Homeowner', readonly id: string }
    & ClientContractDetailHomeownerFragment
  )>, readonly projectContractContractor?: Maybe<(
    { readonly __typename?: 'Contractor', readonly id: string }
    & ClientContractDetailContractorFragment
  )> };

export type GetClientDetailContractQueryVariables = Exact<{
  contractId: Scalars['ID'];
}>;


export type GetClientDetailContractQuery = { readonly __typename?: 'Query', readonly contractServiceContract?: Maybe<(
    { readonly __typename?: 'ContractServiceContract', readonly id: string }
    & ClientContractDetailContractFragment
  )> };

export type FinancingDetailOfferInfoFragment = { readonly __typename?: 'Offer', readonly id: string, readonly loanAmount: number, readonly apr: string, readonly loanTermInMonths: number, readonly monthlyPayment: string };

export type FinancingDetailLoanInfoFragment = { readonly __typename?: 'LoanInquiry', readonly id: string, readonly offers?: Maybe<{ readonly __typename?: 'OfferConnection', readonly totalCount: number }>, readonly highestOffer?: Maybe<(
    { readonly __typename?: 'Offer', readonly id: string }
    & FinancingDetailOfferInfoFragment
  )>, readonly lowestOffer?: Maybe<(
    { readonly __typename?: 'Offer', readonly id: string }
    & FinancingDetailOfferInfoFragment
  )>, readonly requestedOffer?: Maybe<(
    { readonly __typename?: 'Offer', readonly id: string }
    & FinancingDetailOfferInfoFragment
  )> };

export type FinancingDetailHomeownerFragment = { readonly __typename?: 'Homeowner', readonly id: string, readonly fullName: string, readonly fico?: Maybe<number>, readonly financingStatus: HomeownerFinancingStatus, readonly requestedAmount?: Maybe<string>, readonly firstName: string, readonly fundingDate?: Maybe<string>, readonly fundingAmount: number, readonly primaryLoanInquiry?: Maybe<(
    { readonly __typename?: 'LoanInquiry', readonly id: string }
    & FinancingDetailLoanInfoFragment
  )>, readonly selectedHearthEvents: { readonly __typename?: 'HearthEventConnection', readonly nodes?: Maybe<ReadonlyArray<Maybe<(
      { readonly __typename?: 'HearthEvent', readonly id: string }
      & FinancingDetailEventFragment
    )>>> } };

export type FinancingDetailEventFragment = { readonly __typename?: 'HearthEvent', readonly id: string, readonly eventBody?: Maybe<Record<string, any>>, readonly eventType: HearthEventEventTypes, readonly eventAt: string };

export type GetFinancingClientDetailsQueryVariables = Exact<{
  homeownerId: Scalars['String'];
  events: ReadonlyArray<HearthEventEventTypes> | HearthEventEventTypes;
  scope?: Maybe<HearthEventScope>;
}>;


export type GetFinancingClientDetailsQuery = { readonly __typename?: 'Query', readonly homeowner?: Maybe<(
    { readonly __typename?: 'Homeowner', readonly id: string }
    & FinancingDetailHomeownerFragment
  )> };

export type InvoiceDetailAttachmentFragment = { readonly __typename?: 'InvoiceAttachment', readonly id: string, readonly attachmentFileName: string, readonly link: string };

export type ClientDetailInvoiceFragment = { readonly __typename?: 'ConnectInvoice', readonly id: string, readonly invoiceNumber: number, readonly status: ConnectInvoiceStatus, readonly dueDate?: Maybe<string>, readonly description: string, readonly amountRequested: number, readonly creditCardEnabled: boolean, readonly debitCardEnabled: boolean, readonly achEnabled: boolean, readonly paidWith?: Maybe<ConnectInvoicePayment>, readonly paidWithCardType?: Maybe<StripeChargeCard>, readonly firstName: string, readonly refundedAmount?: Maybe<number>, readonly refundableAmount?: Maybe<number>, readonly lastRefundedAt?: Maybe<string>, readonly postRefundAmount: number, readonly customerPaysCardFee: boolean, readonly debitCardFee: number, readonly cardFee: number, readonly customerPaysAchFee: boolean, readonly personalNote?: Maybe<string>, readonly achFee: number, readonly contractor: { readonly __typename?: 'Contractor', readonly id: string, readonly fullName: string }, readonly invoiceAttachments: { readonly __typename?: 'InvoiceAttachmentConnection', readonly nodes?: Maybe<ReadonlyArray<Maybe<(
      { readonly __typename?: 'InvoiceAttachment', readonly id: string }
      & InvoiceDetailAttachmentFragment
    )>>> } };

export type ClientDetailInvoiceActivityFragment = { readonly __typename?: 'ConnectActivity', readonly id: string, readonly activityDate: string, readonly content: string, readonly connectActivityTypeId: ConnectActivityId };

export type GetClientDetailsInvoiceQueryVariables = Exact<{
  invoiceId: Scalars['ID'];
}>;


export type GetClientDetailsInvoiceQuery = { readonly __typename?: 'Query', readonly connectInvoice: (
    { readonly __typename?: 'ConnectInvoice', readonly id: string, readonly homeowner: { readonly __typename?: 'Homeowner', readonly fullName: string, readonly id: string, readonly primaryLoanInquiry?: Maybe<{ readonly __typename?: 'LoanInquiry', readonly id: string, readonly address?: Maybe<string>, readonly city?: Maybe<string>, readonly state?: Maybe<string>, readonly zipCode?: Maybe<string> }> }, readonly viewableActivities: { readonly __typename?: 'ConnectActivityConnection', readonly nodes?: Maybe<ReadonlyArray<Maybe<(
        { readonly __typename?: 'ConnectActivity', readonly id: string }
        & ClientDetailInvoiceActivityFragment
      )>>> }, readonly contractor: { readonly __typename?: 'Contractor', readonly id: string, readonly fullName: string } }
    & ClientDetailInvoiceFragment
  ) };

export type ClientDetailEventFragment = { readonly __typename?: 'HearthEvent', readonly id: string, readonly eventBody?: Maybe<Record<string, any>>, readonly eventType: HearthEventEventTypes, readonly eventAt: string };

export type GetClientDetailsRecentActivityQueryVariables = Exact<{
  homeownerId: Scalars['String'];
  events: ReadonlyArray<HearthEventEventTypes> | HearthEventEventTypes;
  scope?: Maybe<HearthEventScope>;
}>;


export type GetClientDetailsRecentActivityQuery = { readonly __typename?: 'Query', readonly homeowner?: Maybe<{ readonly __typename?: 'Homeowner', readonly id: string, readonly selectedHearthEvents: { readonly __typename?: 'HearthEventConnection', readonly nodes?: Maybe<ReadonlyArray<Maybe<(
        { readonly __typename?: 'HearthEvent', readonly id: string }
        & ClientViewEventFragment
      )>>> } }> };

export type ClientDetailQuoteFragment = (
  { readonly __typename?: 'Quote', readonly id: string, readonly showFinancing: boolean, readonly priorQuote?: Maybe<{ readonly __typename?: 'Quote', readonly id: string }> }
  & HomeownerQuoteViewQuoteFragment
);

export type ClientDetailQuoteContractorFragment = (
  { readonly __typename?: 'Contractor', readonly id: string, readonly trainingCompleted: boolean, readonly firstUnblockedAt?: Maybe<string>, readonly admin: boolean }
  & HomeownerQuoteViewContractorFragment
);

export type ClientDetailQuoteOrganizationFragment = (
  { readonly __typename?: 'Organization', readonly id: string, readonly contractServiceAccount?: Maybe<{ readonly __typename?: 'ContractServiceAccount', readonly id: string, readonly termsAgreedAt?: Maybe<string> }> }
  & QuoteRequestFlowOrganizationFragment
);

export type GetClientDetailQuoteQueryVariables = Exact<{
  quoteId: Scalars['ID'];
}>;


export type GetClientDetailQuoteQuery = { readonly __typename?: 'Query', readonly quote?: Maybe<(
    { readonly __typename?: 'Quote', readonly id: string }
    & ClientDetailQuoteFragment
  )>, readonly organization?: Maybe<(
    { readonly __typename?: 'Organization', readonly id: string }
    & ClientDetailQuoteOrganizationFragment
  )>, readonly contractor?: Maybe<(
    { readonly __typename?: 'Contractor', readonly id: string }
    & ClientDetailQuoteContractorFragment
  )> };

export type QuoteCancelMutationVariables = Exact<{
  quoteId: Scalars['ID'];
}>;


export type QuoteCancelMutation = { readonly __typename?: 'Mutation', readonly quoteCancel?: Maybe<{ readonly __typename?: 'QuoteCancelFailure', readonly errors: ReadonlyArray<{ readonly __typename?: 'InternalError', readonly message: string, readonly path?: Maybe<ReadonlyArray<string>>, readonly code: ErrorCodes } | { readonly __typename?: 'ValidationError', readonly message: string, readonly path?: Maybe<ReadonlyArray<string>>, readonly code: ErrorCodes }> } | { readonly __typename?: 'QuoteCancelSuccess', readonly quote: { readonly __typename?: 'Quote', readonly id: string } }> };

export type QuoteResendMutationVariables = Exact<{
  quoteId: Scalars['ID'];
}>;


export type QuoteResendMutation = { readonly __typename?: 'Mutation', readonly quoteResend?: Maybe<{ readonly __typename?: 'QuoteResendFailure', readonly errors: ReadonlyArray<{ readonly __typename?: 'InternalError', readonly message: string, readonly path?: Maybe<ReadonlyArray<string>>, readonly code: ErrorCodes } | { readonly __typename?: 'ValidationError', readonly message: string, readonly path?: Maybe<ReadonlyArray<string>>, readonly code: ErrorCodes }> } | { readonly __typename?: 'QuoteResendSuccess', readonly quote: { readonly __typename?: 'Quote', readonly id: string } }> };

export type UpsertHomeownerMutationVariables = Exact<{
  homeownerId?: Maybe<Scalars['ID']>;
  firstName: Scalars['String'];
  lastName: Scalars['String'];
  phoneNumber: Scalars['String'];
  email: Scalars['String'];
  defaultAddress?: Maybe<AddressAttributes>;
}>;


export type UpsertHomeownerMutation = { readonly __typename?: 'Mutation', readonly upsertHomeowner?: Maybe<{ readonly __typename?: 'UpsertHomeownerFailure', readonly errors: ReadonlyArray<{ readonly __typename?: 'InternalError', readonly message: string, readonly path?: Maybe<ReadonlyArray<string>>, readonly code: ErrorCodes } | { readonly __typename?: 'ValidationError', readonly message: string, readonly path?: Maybe<ReadonlyArray<string>>, readonly code: ErrorCodes }> } | { readonly __typename?: 'UpsertHomeownerSuccess', readonly homeowner?: Maybe<{ readonly __typename?: 'Homeowner', readonly id: string, readonly defaultHomeownerAddress?: Maybe<{ readonly __typename?: 'HomeownerAddress', readonly id: string }> }> }> };

export type ClientOfferDetailFragment = { readonly __typename?: 'Offer', readonly id: string, readonly loanAmount: number };

export type ClientLoanInquiryInfoFragment = { readonly __typename?: 'LoanInquiry', readonly id: string, readonly address?: Maybe<string>, readonly city?: Maybe<string>, readonly state?: Maybe<string>, readonly zipCode?: Maybe<string>, readonly offers?: Maybe<{ readonly __typename?: 'OfferConnection', readonly totalCount: number }>, readonly highestOffer?: Maybe<(
    { readonly __typename?: 'Offer', readonly id: string }
    & ClientOfferDetailFragment
  )> };

export type ClientDetailContractFragment = { readonly __typename?: 'ContractServiceContract', readonly id: string, readonly name: string, readonly status: ContractStatus, readonly createdAt: string, readonly dueDate: string, readonly contractNumber: number, readonly homeownerAddress?: Maybe<string>, readonly projectContractContractor?: Maybe<{ readonly __typename?: 'Contractor', readonly id: string, readonly fullName: string }> };

export type ClientQuoteDetailsFragment = { readonly __typename?: 'Quote', readonly id: string, readonly name: string, readonly createdAt: string, readonly expiresAt: string, readonly status: QuoteStatus, readonly totalInCents: number, readonly priorQuote?: Maybe<{ readonly __typename?: 'Quote', readonly id: string }>, readonly contractor: { readonly __typename?: 'Contractor', readonly id: string, readonly fullName: string } };

export type ClientOverviewInvoiceFragment = { readonly __typename?: 'ConnectInvoice', readonly id: string, readonly invoiceNumber: number, readonly status: ConnectInvoiceStatus, readonly dueDate?: Maybe<string>, readonly description: string, readonly refundedAmount?: Maybe<number>, readonly refundableAmount?: Maybe<number>, readonly amountRequested: number, readonly sentAt?: Maybe<string>, readonly contractor: { readonly __typename?: 'Contractor', readonly id: string, readonly fullName: string } };

export type ClientOverviewEventFragment = { readonly __typename?: 'HearthEvent', readonly id: string, readonly eventBody?: Maybe<Record<string, any>>, readonly eventType: HearthEventEventTypes, readonly eventAt: string };

export type ClientDetailOverviewFragment = { readonly __typename?: 'Homeowner', readonly id: string, readonly fullName: string, readonly firstName: string, readonly lastName: string, readonly email: string, readonly phoneNumber: string, readonly fundingDate?: Maybe<string>, readonly fundingAmount: number, readonly requestedAmount?: Maybe<string>, readonly paidPaymentsAmount: number, readonly outstandingPaymentsAmount: number, readonly overduePaymentsAmount: number, readonly defaultHomeownerAddress?: Maybe<{ readonly __typename?: 'HomeownerAddress', readonly id: string, readonly addressLineOne?: Maybe<string>, readonly addressLineTwo?: Maybe<string>, readonly city: string, readonly state?: Maybe<string>, readonly zipCode?: Maybe<string> }>, readonly contractServiceSignatures: { readonly __typename?: 'ContractServiceSignatureConnection', readonly nodes?: Maybe<ReadonlyArray<Maybe<{ readonly __typename?: 'ContractServiceSignature', readonly id: string, readonly status: SignatureStatus, readonly role: SignatureRole, readonly contract: (
        { readonly __typename?: 'ContractServiceContract', readonly id: string }
        & ClientDetailContractFragment
      ) }>>> }, readonly primaryLoanInquiry?: Maybe<(
    { readonly __typename?: 'LoanInquiry', readonly id: string }
    & ClientLoanInquiryInfoFragment
  )>, readonly selectedHearthEvents: { readonly __typename?: 'HearthEventConnection', readonly nodes?: Maybe<ReadonlyArray<Maybe<(
      { readonly __typename?: 'HearthEvent', readonly id: string }
      & ClientOverviewEventFragment
    )>>> } };

export type GetClientOverviewQueryVariables = Exact<{
  homeownerId: Scalars['String'];
  events: ReadonlyArray<HearthEventEventTypes> | HearthEventEventTypes;
  scope?: Maybe<HearthEventScope>;
}>;


export type GetClientOverviewQuery = { readonly __typename?: 'Query', readonly homeowner?: Maybe<(
    { readonly __typename?: 'Homeowner', readonly id: string, readonly connectInvoices?: Maybe<{ readonly __typename?: 'ConnectInvoiceConnection', readonly nodes?: Maybe<ReadonlyArray<Maybe<(
        { readonly __typename?: 'ConnectInvoice', readonly id: string }
        & ClientOverviewInvoiceFragment
      )>>> }>, readonly contractServiceSignatures: { readonly __typename?: 'ContractServiceSignatureConnection', readonly nodes?: Maybe<ReadonlyArray<Maybe<{ readonly __typename?: 'ContractServiceSignature', readonly id: string, readonly contract: (
          { readonly __typename?: 'ContractServiceContract', readonly id: string }
          & ClientDetailContractFragment
        ) }>>> }, readonly quotes: { readonly __typename?: 'QuoteConnection', readonly nodes?: Maybe<ReadonlyArray<Maybe<(
        { readonly __typename?: 'Quote', readonly id: string }
        & ClientQuoteDetailsFragment
      )>>> } }
    & ClientDetailOverviewFragment
  )>, readonly contractor?: Maybe<{ readonly __typename?: 'Contractor', readonly id: string, readonly paymentsRole: PaymentsRole, readonly paymentsAdmin: boolean, readonly admin: boolean }>, readonly organization?: Maybe<{ readonly __typename?: 'Organization', readonly id: string, readonly stripeConnectAccount?: Maybe<{ readonly __typename?: 'StripeConnectAccount', readonly id: string, readonly status: ConnectAccountStatus }>, readonly contractServiceAccount?: Maybe<{ readonly __typename?: 'ContractServiceAccount', readonly id: string, readonly termsAgreedAt?: Maybe<string> }> }> };

export type AddNewButtonQueryVariables = Exact<{ [key: string]: never; }>;


export type AddNewButtonQuery = { readonly __typename?: 'Query', readonly organization?: Maybe<{ readonly __typename?: 'Organization', readonly id: string, readonly stripeConnectAccount?: Maybe<{ readonly __typename?: 'StripeConnectAccount', readonly id: string, readonly status: ConnectAccountStatus, readonly fullAccess: boolean }>, readonly contractServiceAccount?: Maybe<{ readonly __typename?: 'ContractServiceAccount', readonly id: string, readonly termsAgreedAt?: Maybe<string> }> }>, readonly contractor?: Maybe<{ readonly __typename?: 'Contractor', readonly id: string, readonly admin: boolean, readonly role: string, readonly paymentsRole: PaymentsRole, readonly trainingCompleted: boolean }> };

export type ClientViewMenuQueryVariables = Exact<{ [key: string]: never; }>;


export type ClientViewMenuQuery = { readonly __typename?: 'Query', readonly contractor?: Maybe<{ readonly __typename?: 'Contractor', readonly id: string, readonly admin: boolean, readonly paymentsRole: PaymentsRole, readonly customSettings: { readonly __typename?: 'CustomContractorSettings', readonly clientViewViewByTooltipSeen: boolean } }>, readonly organization?: Maybe<{ readonly __typename?: 'Organization', readonly id: string, readonly stripeConnectAccount?: Maybe<{ readonly __typename?: 'StripeConnectAccount', readonly id: string, readonly fullAccess: boolean }>, readonly contractServiceAccount?: Maybe<{ readonly __typename?: 'ContractServiceAccount', readonly id: string, readonly termsAgreedAt?: Maybe<string> }> }> };

export type SetClientViewViewBySeenMutationVariables = Exact<{
  customSettings: CustomContractorSettingsAttributes;
}>;


export type SetClientViewViewBySeenMutation = { readonly __typename?: 'Mutation', readonly upsertContractor?: Maybe<{ readonly __typename?: 'UpsertContractorFailure', readonly errors: ReadonlyArray<{ readonly __typename?: 'InternalError', readonly message: string, readonly path?: Maybe<ReadonlyArray<string>>, readonly code: ErrorCodes } | { readonly __typename?: 'ValidationError', readonly message: string, readonly path?: Maybe<ReadonlyArray<string>>, readonly code: ErrorCodes }> } | { readonly __typename?: 'UpsertContractorSuccess', readonly contractor: { readonly __typename?: 'Contractor', readonly id: string, readonly customSettings: { readonly __typename?: 'CustomContractorSettings', readonly clientViewViewByTooltipSeen: boolean } } }> };

export type GetClientIndexContractorAndOrganizationQueryVariables = Exact<{ [key: string]: never; }>;


export type GetClientIndexContractorAndOrganizationQuery = { readonly __typename?: 'Query', readonly contractor?: Maybe<{ readonly __typename?: 'Contractor', readonly id: string, readonly role: string, readonly paymentsRole: PaymentsRole, readonly admin: boolean }>, readonly organization?: Maybe<{ readonly __typename?: 'Organization', readonly id: string, readonly stripeConnectAccount?: Maybe<{ readonly __typename?: 'StripeConnectAccount', readonly id: string, readonly status: ConnectAccountStatus, readonly fullAccess: boolean }>, readonly contractServiceAccount?: Maybe<{ readonly __typename?: 'ContractServiceAccount', readonly id: string, readonly termsAgreedAt?: Maybe<string> }> }> };

export type ClientEventFragment = { readonly __typename?: 'HearthEvent', readonly id: string, readonly eventType: HearthEventEventTypes, readonly eventBody?: Maybe<Record<string, any>>, readonly eventAt: string };

export type IndexClientFragment = { readonly __typename?: 'Homeowner', readonly id: string, readonly fullName: string, readonly hearthEvents: { readonly __typename?: 'HearthEventConnection', readonly nodes?: Maybe<ReadonlyArray<Maybe<(
      { readonly __typename?: 'HearthEvent', readonly id: string }
      & ClientEventFragment
    )>>> }, readonly selectedHearthEvents: { readonly __typename?: 'HearthEventConnection', readonly nodes?: Maybe<ReadonlyArray<Maybe<{ readonly __typename?: 'HearthEvent', readonly id: string, readonly eventAt: string, readonly eventType: HearthEventEventTypes }>>> } };

export type GetClientsQueryVariables = Exact<{
  admin?: Maybe<Scalars['Boolean']>;
  type?: Maybe<HomeownerEventBucket>;
  orderBy?: Maybe<HomeownerOrderers>;
  searchTerm?: Maybe<Scalars['String']>;
  afterCursor?: Maybe<Scalars['String']>;
}>;


export type GetClientsQuery = { readonly __typename?: 'Query', readonly homeownerSearch: { readonly __typename?: 'HomeownerConnection', readonly totalCount: number, readonly edges?: Maybe<ReadonlyArray<Maybe<{ readonly __typename?: 'HomeownerEdge', readonly node?: Maybe<(
        { readonly __typename?: 'Homeowner', readonly id: string }
        & IndexClientFragment
      )> }>>>, readonly pageInfo: { readonly __typename?: 'PageInfo', readonly startCursor?: Maybe<string>, readonly endCursor?: Maybe<string>, readonly hasNextPage: boolean, readonly hasPreviousPage: boolean } } };

export type ContractorPaymentsRoleQueryVariables = Exact<{ [key: string]: never; }>;


export type ContractorPaymentsRoleQuery = { readonly __typename?: 'Query', readonly contractor?: Maybe<{ readonly __typename?: 'Contractor', readonly id: string, readonly paymentsRole: PaymentsRole }> };

export type ClientInvoiceIndexConnectInvoiceFragment = { readonly __typename?: 'ConnectInvoice', readonly id: string, readonly invoiceNumber: number, readonly fullName: string, readonly description: string, readonly amountRequested: number, readonly status: ConnectInvoiceStatus, readonly dueDate?: Maybe<string>, readonly refundedAmount?: Maybe<number>, readonly refundableAmount?: Maybe<number>, readonly contractor: { readonly __typename?: 'Contractor', readonly id: string }, readonly homeowner: { readonly __typename?: 'Homeowner', readonly id: string } };

export type ClientInvoiceIndexQueryVariables = Exact<{ [key: string]: never; }>;


export type ClientInvoiceIndexQuery = { readonly __typename?: 'Query', readonly contractor?: Maybe<{ readonly __typename?: 'Contractor', readonly id: string, readonly paymentsRole: PaymentsRole, readonly authorizedViewableConnectInvoices: { readonly __typename?: 'ConnectInvoiceConnection', readonly nodes?: Maybe<ReadonlyArray<Maybe<(
        { readonly __typename?: 'ConnectInvoice', readonly id: string }
        & ClientInvoiceIndexConnectInvoiceFragment
      )>>> } }> };

export type FetchAccountBalanceQueryVariables = Exact<{ [key: string]: never; }>;


export type FetchAccountBalanceQuery = { readonly __typename?: 'Query', readonly contractor?: Maybe<{ readonly __typename?: 'Contractor', readonly id: string, readonly paidPaymentsAmount: number, readonly unpaidPaymentsAmount: number, readonly overduePaymentsAmount: number, readonly paymentsRole: PaymentsRole }>, readonly organization?: Maybe<{ readonly __typename?: 'Organization', readonly id: string, readonly stripeConnectAccount?: Maybe<{ readonly __typename?: 'StripeConnectAccount', readonly id: string, readonly balance: number, readonly pendingBalance: number }> }> };

export type GetClientViewContainerQueryVariables = Exact<{ [key: string]: never; }>;


export type GetClientViewContainerQuery = { readonly __typename?: 'Query', readonly contractor?: Maybe<{ readonly __typename?: 'Contractor', readonly id: string, readonly demoMode: boolean }> };

export type GetClientContractQueryVariables = Exact<{
  contractId: Scalars['ID'];
}>;


export type GetClientContractQuery = { readonly __typename?: 'Query', readonly contractServiceContract?: Maybe<{ readonly __typename?: 'ContractServiceContract', readonly id: string, readonly contractNumber: number, readonly name: string, readonly status: ContractStatus, readonly dueDate: string, readonly createdAt: string, readonly base64Pdf?: Maybe<string>, readonly creatorId?: Maybe<string> }> };

export type ResendContractMutationVariables = Exact<{
  contractId: Scalars['ID'];
}>;


export type ResendContractMutation = { readonly __typename?: 'Mutation', readonly contractServiceResendProjectContract?: Maybe<{ readonly __typename?: 'ContractServiceResendProjectContractFailure', readonly errors: ReadonlyArray<{ readonly __typename?: 'InternalError', readonly message: string, readonly path?: Maybe<ReadonlyArray<string>>, readonly code: ErrorCodes } | { readonly __typename?: 'ValidationError', readonly message: string, readonly path?: Maybe<ReadonlyArray<string>>, readonly code: ErrorCodes }> } | { readonly __typename: 'ContractServiceResendProjectContractSuccess' }> };

export type CancelContractMutationVariables = Exact<{
  contractId: Scalars['ID'];
}>;


export type CancelContractMutation = { readonly __typename?: 'Mutation', readonly contractServiceCancelContract?: Maybe<{ readonly __typename?: 'ContractServiceCancelContractFailure', readonly errors: ReadonlyArray<{ readonly __typename?: 'InternalError', readonly message: string, readonly path?: Maybe<ReadonlyArray<string>>, readonly code: ErrorCodes } | { readonly __typename?: 'ValidationError', readonly message: string, readonly path?: Maybe<ReadonlyArray<string>>, readonly code: ErrorCodes }> } | { readonly __typename?: 'ContractServiceCancelContractSuccess', readonly contractServiceContract: { readonly __typename?: 'ContractServiceContract', readonly id: string } }> };

export type ConnectInvoiceAttachmentFragment = { readonly __typename?: 'InvoiceAttachment', readonly id: string, readonly attachmentFileName: string, readonly link: string };

export type ClientInvoiceFragment = { readonly __typename?: 'ConnectInvoice', readonly id: string, readonly invoiceNumber: number, readonly achFee: number, readonly amountRequested: number, readonly cardFee: number, readonly customerPaysAchFee: boolean, readonly customerPaysCardFee: boolean, readonly debitCardFee: number, readonly description: string, readonly dueDate?: Maybe<string>, readonly email: string, readonly fullName: string, readonly firstName: string, readonly lastRefundedAt?: Maybe<string>, readonly paidWith?: Maybe<ConnectInvoicePayment>, readonly paidWithCardType?: Maybe<StripeChargeCard>, readonly personalNote?: Maybe<string>, readonly phoneNumber: string, readonly postRefundAmount: number, readonly refundableAmount?: Maybe<number>, readonly refundedAmount?: Maybe<number>, readonly status: ConnectInvoiceStatus, readonly sentAt?: Maybe<string>, readonly scheduledFor?: Maybe<string>, readonly syncedToQuickbooks: boolean, readonly creditCardEnabled: boolean, readonly debitCardEnabled: boolean, readonly achEnabled: boolean, readonly paymentsCapabilityStatus?: Maybe<PaymentsCapabilityStatus>, readonly viewableActivities: { readonly __typename?: 'ConnectActivityConnection', readonly nodes?: Maybe<ReadonlyArray<Maybe<(
      { readonly __typename?: 'ConnectActivity', readonly id: string }
      & ClientInvoiceViewableActivityFragment
    )>>> }, readonly invoiceAttachments: { readonly __typename?: 'InvoiceAttachmentConnection', readonly nodes?: Maybe<ReadonlyArray<Maybe<(
      { readonly __typename?: 'InvoiceAttachment', readonly id: string }
      & ConnectInvoiceAttachmentFragment
    )>>> } };

export type ClientInvoiceViewableActivityFragment = { readonly __typename?: 'ConnectActivity', readonly id: string, readonly activityDate: string, readonly content: string, readonly connectActivityTypeId: ConnectActivityId };

export type GetClientInvoiceQueryVariables = Exact<{
  invoiceId: Scalars['ID'];
}>;


export type GetClientInvoiceQuery = { readonly __typename?: 'Query', readonly connectInvoice: (
    { readonly __typename?: 'ConnectInvoice', readonly id: string, readonly homeowner: { readonly __typename?: 'Homeowner', readonly id: string, readonly primaryLoanInquiry?: Maybe<{ readonly __typename?: 'LoanInquiry', readonly id: string, readonly address?: Maybe<string>, readonly city?: Maybe<string>, readonly state?: Maybe<string>, readonly zipCode?: Maybe<string> }> }, readonly contractor: { readonly __typename?: 'Contractor', readonly id: string, readonly fullName: string } }
    & ClientInvoiceFragment
  ) };

export type ManuallyPayInvoiceMutationVariables = Exact<{
  connectInvoiceId: Scalars['ID'];
  paymentType: Scalars['String'];
  paymentDate: Scalars['ISO8601DateTime'];
}>;


export type ManuallyPayInvoiceMutation = { readonly __typename?: 'Mutation', readonly manuallyPayInvoice?: Maybe<{ readonly __typename?: 'ManuallyPayInvoiceFailure', readonly errors: ReadonlyArray<{ readonly __typename?: 'InternalError', readonly message: string, readonly path?: Maybe<ReadonlyArray<string>>, readonly code: ErrorCodes } | { readonly __typename?: 'ValidationError', readonly message: string, readonly path?: Maybe<ReadonlyArray<string>>, readonly code: ErrorCodes }> } | { readonly __typename?: 'ManuallyPayInvoiceSuccess', readonly connectInvoice: { readonly __typename?: 'ConnectInvoice', readonly id: string } }> };

export type SendPaymentReminderMutationVariables = Exact<{
  invoiceId: Scalars['ID'];
  mediums: ReadonlyArray<ContactMedium> | ContactMedium;
}>;


export type SendPaymentReminderMutation = { readonly __typename?: 'Mutation', readonly sendHomeownerPaymentReminder?: Maybe<{ readonly __typename?: 'SendHomeownerPaymentReminderPayload', readonly connectInvoice?: Maybe<{ readonly __typename?: 'ConnectInvoice', readonly id: string }> }> };

export type CancelInvoiceMutationVariables = Exact<{
  connectInvoiceId: Scalars['ID'];
}>;


export type CancelInvoiceMutation = { readonly __typename?: 'Mutation', readonly cancelInvoice?: Maybe<{ readonly __typename?: 'CancelInvoiceFailure', readonly errors: ReadonlyArray<{ readonly __typename?: 'InternalError', readonly message: string, readonly path?: Maybe<ReadonlyArray<string>>, readonly code: ErrorCodes } | { readonly __typename?: 'ValidationError', readonly message: string, readonly path?: Maybe<ReadonlyArray<string>>, readonly code: ErrorCodes }> } | { readonly __typename?: 'CancelInvoiceSuccess', readonly connectInvoice?: Maybe<{ readonly __typename?: 'ConnectInvoice', readonly id: string }> }> };

export type ClientViewConnectInvoiceFragment = { readonly __typename?: 'ConnectInvoice', readonly id: string, readonly invoiceNumber: number, readonly status: ConnectInvoiceStatus, readonly dueDate?: Maybe<string>, readonly description: string, readonly refundedAmount?: Maybe<number>, readonly refundableAmount?: Maybe<number>, readonly amountRequested: number, readonly sentAt?: Maybe<string>, readonly scheduledFor?: Maybe<string>, readonly syncedToQuickbooks: boolean };

export type ClientOfferInfoFragment = { readonly __typename?: 'Offer', readonly id: string, readonly loanAmount: number, readonly loanTermInMonths: number, readonly monthlyPayment: string, readonly apr: string };

export type ClientViewPrimaryLoanInquiryFragment = { readonly __typename?: 'LoanInquiry', readonly id: string, readonly address?: Maybe<string>, readonly city?: Maybe<string>, readonly state?: Maybe<string>, readonly zipCode?: Maybe<string>, readonly totalOffers: number, readonly createdAt: string, readonly qualified: boolean, readonly offers?: Maybe<{ readonly __typename?: 'OfferConnection', readonly nodes?: Maybe<ReadonlyArray<Maybe<{ readonly __typename?: 'Offer', readonly id: string }>>> }>, readonly lowestOffer?: Maybe<(
    { readonly __typename?: 'Offer', readonly id: string }
    & ClientOfferInfoFragment
  )>, readonly requestedOffer?: Maybe<(
    { readonly __typename?: 'Offer', readonly id: string }
    & ClientOfferInfoFragment
  )>, readonly highestOffer?: Maybe<(
    { readonly __typename?: 'Offer', readonly id: string }
    & ClientOfferInfoFragment
  )> };

export type ClientViewHomeownerFragment = { readonly __typename?: 'Homeowner', readonly id: string, readonly fullName: string, readonly firstName: string, readonly lastName: string, readonly email: string, readonly fico?: Maybe<number>, readonly phoneNumber: string, readonly financingStatus: HomeownerFinancingStatus, readonly fundingAmount: number, readonly fundingDate?: Maybe<string>, readonly fundingLender?: Maybe<string>, readonly requestedAmount?: Maybe<string>, readonly contractServiceSignatures: { readonly __typename?: 'ContractServiceSignatureConnection', readonly nodes?: Maybe<ReadonlyArray<Maybe<{ readonly __typename?: 'ContractServiceSignature', readonly id: string, readonly status: SignatureStatus, readonly role: SignatureRole, readonly contract: { readonly __typename?: 'ContractServiceContract', readonly id: string, readonly status: ContractStatus, readonly createdAt: string, readonly dueDate: string, readonly name: string, readonly contractNumber: number } }>>> }, readonly connectInvoices?: Maybe<{ readonly __typename?: 'ConnectInvoiceConnection', readonly nodes?: Maybe<ReadonlyArray<Maybe<(
      { readonly __typename?: 'ConnectInvoice', readonly id: string }
      & ClientViewConnectInvoiceFragment
    )>>> }>, readonly primaryLoanInquiry?: Maybe<(
    { readonly __typename?: 'LoanInquiry', readonly id: string }
    & ClientViewPrimaryLoanInquiryFragment
  )>, readonly selectedHearthEvents: { readonly __typename?: 'HearthEventConnection', readonly nodes?: Maybe<ReadonlyArray<Maybe<(
      { readonly __typename?: 'HearthEvent', readonly id: string }
      & ClientViewEventFragment
    )>>> } };

export type ClientViewEventFragment = { readonly __typename?: 'HearthEvent', readonly id: string, readonly eventBody?: Maybe<Record<string, any>>, readonly eventType: HearthEventEventTypes, readonly eventAt: string };

export type ClientProfileContractFragment = { readonly __typename?: 'ContractServiceContract', readonly id: string, readonly status: ContractStatus, readonly name: string };

export type ContractServiceAccountStatusFragment = { readonly __typename?: 'ContractServiceAccount', readonly id: string, readonly termsAgreedAt?: Maybe<string>, readonly contracts: { readonly __typename?: 'ContractServiceContractConnection', readonly nodes?: Maybe<ReadonlyArray<Maybe<(
      { readonly __typename?: 'ContractServiceContract', readonly id: string }
      & ClientProfileContractFragment
    )>>> } };

export type GetClientProfileQueryVariables = Exact<{
  homeownerId: Scalars['String'];
  events: ReadonlyArray<HearthEventEventTypes> | HearthEventEventTypes;
  scope?: Maybe<HearthEventScope>;
}>;


export type GetClientProfileQuery = { readonly __typename?: 'Query', readonly homeowner?: Maybe<(
    { readonly __typename?: 'Homeowner', readonly id: string }
    & ClientViewHomeownerFragment
  )>, readonly contractor?: Maybe<{ readonly __typename?: 'Contractor', readonly id: string, readonly role: string, readonly paymentsRole: PaymentsRole, readonly admin: boolean }>, readonly organization?: Maybe<{ readonly __typename?: 'Organization', readonly id: string, readonly stripeConnectAccount?: Maybe<{ readonly __typename?: 'StripeConnectAccount', readonly id: string, readonly status: ConnectAccountStatus, readonly fullAccess: boolean }>, readonly contractServiceAccount?: Maybe<(
      { readonly __typename?: 'ContractServiceAccount', readonly id: string }
      & ContractServiceAccountStatusFragment
    )> }> };

export type ArchiveClientMutationVariables = Exact<{
  homeownerId: Scalars['ID'];
  contractorId: Scalars['ID'];
  archive: Scalars['Boolean'];
}>;


export type ArchiveClientMutation = { readonly __typename?: 'Mutation', readonly archiveHomeowner?: Maybe<{ readonly __typename?: 'ArchiveHomeownerFailure', readonly errors: ReadonlyArray<{ readonly __typename?: 'InternalError', readonly message: string, readonly path?: Maybe<ReadonlyArray<string>>, readonly code: ErrorCodes } | { readonly __typename?: 'ValidationError', readonly message: string, readonly path?: Maybe<ReadonlyArray<string>>, readonly code: ErrorCodes }> } | { readonly __typename?: 'ArchiveHomeownerSuccess', readonly homeowner: { readonly __typename?: 'Homeowner', readonly id: string }, readonly contractor: { readonly __typename?: 'Contractor', readonly id: string } }> };

export type HomeownerResendOffersEmailMutationVariables = Exact<{
  id: Scalars['ID'];
  email: Scalars['String'];
}>;


export type HomeownerResendOffersEmailMutation = { readonly __typename?: 'Mutation', readonly homeownerResendOffersEmail?: Maybe<{ readonly __typename?: 'HomeownerResendOffersEmailFailure', readonly errors: ReadonlyArray<{ readonly __typename?: 'InternalError', readonly message: string, readonly path?: Maybe<ReadonlyArray<string>>, readonly code: ErrorCodes } | { readonly __typename?: 'ValidationError', readonly message: string, readonly path?: Maybe<ReadonlyArray<string>>, readonly code: ErrorCodes }> } | { readonly __typename?: 'HomeownerResendOffersEmailSuccess', readonly loanInquiry: { readonly __typename?: 'LoanInquiry', readonly id: string } }> };

export type OrganizationContractWizardInfoFragment = { readonly __typename?: 'Organization', readonly id: string, readonly logo?: Maybe<string>, readonly companyName: string, readonly businessLicenseNumber?: Maybe<string>, readonly address?: Maybe<string>, readonly state?: Maybe<string>, readonly city: string, readonly zipCode?: Maybe<string>, readonly logoUrl?: Maybe<string>, readonly contractServiceAccount?: Maybe<{ readonly __typename?: 'ContractServiceAccount', readonly id: string }> };

export type GetContractWizardDataQueryVariables = Exact<{ [key: string]: never; }>;


export type GetContractWizardDataQuery = { readonly __typename?: 'Query', readonly contractor?: Maybe<{ readonly __typename?: 'Contractor', readonly id: string, readonly email: string, readonly fullName: string, readonly phoneNumber: string }>, readonly organization?: Maybe<(
    { readonly __typename?: 'Organization', readonly id: string }
    & OrganizationContractWizardInfoFragment
  )>, readonly contractServiceBaseTemplate: { readonly __typename?: 'ContractServiceBaseTemplate', readonly id: string, readonly template: Record<string, any> } };

export type UpdateOrganizationCompanyInfoMutationVariables = Exact<{
  attributes: OrganizationAttributes;
}>;


export type UpdateOrganizationCompanyInfoMutation = { readonly __typename?: 'Mutation', readonly upsertOrganization?: Maybe<{ readonly __typename?: 'UpsertOrganizationFailure', readonly errors: ReadonlyArray<{ readonly __typename?: 'InternalError', readonly message: string, readonly path?: Maybe<ReadonlyArray<string>>, readonly code: ErrorCodes } | { readonly __typename?: 'ValidationError', readonly message: string, readonly path?: Maybe<ReadonlyArray<string>>, readonly code: ErrorCodes }> } | { readonly __typename?: 'UpsertOrganizationSuccess', readonly organization: (
      { readonly __typename?: 'Organization', readonly id: string }
      & OrganizationContractWizardInfoFragment
    ) }> };

export type CreateContractServiceAccountMutationVariables = Exact<{ [key: string]: never; }>;


export type CreateContractServiceAccountMutation = { readonly __typename?: 'Mutation', readonly contractServiceAccountCreate?: Maybe<{ readonly __typename?: 'ContractServiceAccountCreateFailure', readonly errors: ReadonlyArray<{ readonly __typename?: 'InternalError', readonly message: string, readonly path?: Maybe<ReadonlyArray<string>>, readonly code: ErrorCodes } | { readonly __typename?: 'ValidationError', readonly message: string, readonly path?: Maybe<ReadonlyArray<string>>, readonly code: ErrorCodes }> } | { readonly __typename?: 'ContractServiceAccountCreateSuccess', readonly contractServiceAccount: { readonly __typename?: 'ContractServiceAccount', readonly id: string } }> };

export type UpsertContractServiceContractTemplateMutationVariables = Exact<{
  contractServiceAccountId: Scalars['ID'];
  baseTemplateId: Scalars['String'];
  template: Scalars['JSON'];
}>;


export type UpsertContractServiceContractTemplateMutation = { readonly __typename?: 'Mutation', readonly contractServiceContractTemplateUpsert?: Maybe<{ readonly __typename?: 'ContractServiceTemplateUpsertFailure', readonly errors: ReadonlyArray<{ readonly __typename?: 'InternalError', readonly message: string, readonly path?: Maybe<ReadonlyArray<string>>, readonly code: ErrorCodes } | { readonly __typename?: 'ValidationError', readonly message: string, readonly path?: Maybe<ReadonlyArray<string>>, readonly code: ErrorCodes }> } | { readonly __typename?: 'ContractServiceTemplateUpsertSuccess', readonly contractServiceContractTemplate: { readonly __typename?: 'ContractServiceContractTemplate', readonly id: string, readonly version: number, readonly baseTemplate: { readonly __typename?: 'ContractServiceBaseTemplate', readonly id: string } } }> };

export type UpsertContractTemplateVersionMutationVariables = Exact<{
  contractServiceAccountId: Scalars['ID'];
  baseTemplateId: Scalars['String'];
  template: Scalars['JSON'];
  versionName: Scalars['String'];
  contractorId: Scalars['ID'];
}>;


export type UpsertContractTemplateVersionMutation = { readonly __typename?: 'Mutation', readonly contractServiceContractTemplateVersionUpsert?: Maybe<{ readonly __typename?: 'ContractServiceTemplateVersionUpsertFailure', readonly errors: ReadonlyArray<{ readonly __typename?: 'InternalError', readonly message: string, readonly path?: Maybe<ReadonlyArray<string>>, readonly code: ErrorCodes } | { readonly __typename?: 'ValidationError', readonly message: string, readonly path?: Maybe<ReadonlyArray<string>>, readonly code: ErrorCodes }> } | { readonly __typename?: 'ContractServiceTemplateVersionUpsertSuccess', readonly contractServiceContractTemplate: { readonly __typename?: 'ContractServiceContractTemplate', readonly id: string, readonly version: number, readonly baseTemplate: { readonly __typename?: 'ContractServiceBaseTemplate', readonly id: string } } }> };

export type GenerateWizardContractPreviewPdfMutationVariables = Exact<{
  html: Scalars['String'];
}>;


export type GenerateWizardContractPreviewPdfMutation = { readonly __typename?: 'Mutation', readonly contractGeneratorRestGeneratePdf: { readonly __typename?: 'ContractGeneratorRestGeneratePdfResult', readonly pdf: string } };

export type GetMapDataQueryVariables = Exact<{
  homeownerSearchKey: Scalars['String'];
}>;


export type GetMapDataQuery = { readonly __typename?: 'Query', readonly homeowner?: Maybe<{ readonly __typename?: 'Homeowner', readonly numLendersQualified?: Maybe<number>, readonly fundingTime?: Maybe<number>, readonly fundingAmount: number, readonly fundingLender?: Maybe<string>, readonly projectType?: Maybe<string>, readonly contractor?: Maybe<{ readonly __typename?: 'Contractor', readonly id: string, readonly firstName: string, readonly organization: { readonly __typename?: 'Organization', readonly companyTypeLabel: string, readonly city: string, readonly firstSignedUpAt: string, readonly firstFundDate?: Maybe<string> } }> }> };

export type OrganizationTemplateInfoFragment = { readonly __typename?: 'Organization', readonly id: string, readonly companyName: string, readonly businessEmail?: Maybe<string>, readonly businessPhone?: Maybe<string>, readonly fullAddress: string, readonly facebookUrl?: Maybe<string>, readonly twitterUrl?: Maybe<string>, readonly linkedinUrl?: Maybe<string>, readonly instagramUrl?: Maybe<string>, readonly website?: Maybe<string>, readonly logoUrl?: Maybe<string>, readonly kycBusiness?: Maybe<{ readonly __typename?: 'KycBusiness', readonly id: string, readonly url?: Maybe<string> }> };

export type InvoiceCustomizationSettingsFragment = { readonly __typename?: 'CustomizedInvoiceTemplate', readonly id: string, readonly templateType: InvoiceTemplateType, readonly primaryColor: OrganizationTheme, readonly background: Background, readonly logo: boolean, readonly website: boolean, readonly signatureMessage?: Maybe<SignatureMessage>, readonly socialLinks: { readonly __typename?: 'SocialMediaLinks', readonly facebookUrl?: Maybe<boolean>, readonly twitterUrl?: Maybe<boolean>, readonly instagramUrl?: Maybe<boolean>, readonly linkedinUrl?: Maybe<boolean> } };

export type ContractorTemplateInfoFragment = { readonly __typename?: 'Contractor', readonly id: string, readonly role: string, readonly fullName: string, readonly customSettings: { readonly __typename?: 'CustomContractorSettings', readonly paymentsApprovalModalSeen: boolean }, readonly customizedInvoiceTemplates: { readonly __typename?: 'CustomizedInvoiceTemplateConnection', readonly totalCount: number }, readonly activeCustomizedInvoiceTemplate?: Maybe<(
    { readonly __typename?: 'CustomizedInvoiceTemplate', readonly id: string }
    & InvoiceCustomizationSettingsFragment
  )> };

export type GetCustomizedInvoiceTemplateInfoQueryVariables = Exact<{ [key: string]: never; }>;


export type GetCustomizedInvoiceTemplateInfoQuery = { readonly __typename?: 'Query', readonly contractor?: Maybe<(
    { readonly __typename?: 'Contractor', readonly id: string }
    & ContractorTemplateInfoFragment
  )>, readonly organization?: Maybe<(
    { readonly __typename?: 'Organization', readonly id: string }
    & OrganizationTemplateInfoFragment
  )> };

export type UpdateOrganizationInvoiceTemplateSettingsMutationVariables = Exact<{
  attributes: OrganizationAttributes;
}>;


export type UpdateOrganizationInvoiceTemplateSettingsMutation = { readonly __typename?: 'Mutation', readonly upsertOrganization?: Maybe<{ readonly __typename?: 'UpsertOrganizationFailure', readonly errors: ReadonlyArray<{ readonly __typename?: 'InternalError', readonly message: string, readonly path?: Maybe<ReadonlyArray<string>>, readonly code: ErrorCodes } | { readonly __typename?: 'ValidationError', readonly message: string, readonly path?: Maybe<ReadonlyArray<string>>, readonly code: ErrorCodes }> } | { readonly __typename?: 'UpsertOrganizationSuccess', readonly organization: (
      { readonly __typename?: 'Organization', readonly id: string }
      & OrganizationTemplateInfoFragment
    ) }> };

export type CreateInvoiceTemplateMutationVariables = Exact<{
  attributes: CustomizedInvoiceTemplateAttributes;
}>;


export type CreateInvoiceTemplateMutation = { readonly __typename?: 'Mutation', readonly upsertCustomizedInvoiceTemplate?: Maybe<{ readonly __typename?: 'UpsertCustomizedInvoiceTemplateFailure', readonly errors: ReadonlyArray<{ readonly __typename?: 'InternalError', readonly message: string, readonly path?: Maybe<ReadonlyArray<string>>, readonly code: ErrorCodes } | { readonly __typename?: 'ValidationError', readonly message: string, readonly path?: Maybe<ReadonlyArray<string>>, readonly code: ErrorCodes }> } | { readonly __typename?: 'UpsertCustomizedInvoiceTemplateSuccess', readonly invoiceTemplate: (
      { readonly __typename?: 'CustomizedInvoiceTemplate', readonly id: string }
      & InvoiceCustomizationSettingsFragment
    ) }> };

export type ApprovedContractorFragment = { readonly __typename?: 'Contractor', readonly id: string, readonly firstName: string, readonly paymentsAdmin: boolean, readonly customSettings: { readonly __typename?: 'CustomContractorSettings', readonly paymentsApprovalModalSeen: boolean }, readonly allInvoices: { readonly __typename?: 'ConnectInvoiceConnection', readonly totalCount: number } };

export type ApprovedOrgFragment = { readonly __typename?: 'Organization', readonly id: string, readonly stripeConnectAccount?: Maybe<{ readonly __typename?: 'StripeConnectAccount', readonly id: string, readonly status: ConnectAccountStatus }> };

export type GetHearthPayApprovedDataQueryVariables = Exact<{ [key: string]: never; }>;


export type GetHearthPayApprovedDataQuery = { readonly __typename?: 'Query', readonly contractor?: Maybe<(
    { readonly __typename?: 'Contractor', readonly id: string }
    & ApprovedContractorFragment
  )>, readonly organization?: Maybe<(
    { readonly __typename?: 'Organization', readonly id: string }
    & ApprovedOrgFragment
  )> };

export type GetInsightsCalloutDataQueryVariables = Exact<{ [key: string]: never; }>;


export type GetInsightsCalloutDataQuery = { readonly __typename?: 'Query', readonly contractor?: Maybe<{ readonly __typename?: 'Contractor', readonly id: string, readonly admin: boolean, readonly customSettings: { readonly __typename?: 'CustomContractorSettings', readonly insightsCalloutSeen: boolean } }> };

export type SetInsightsCalloutSeenMutationVariables = Exact<{ [key: string]: never; }>;


export type SetInsightsCalloutSeenMutation = { readonly __typename?: 'Mutation', readonly upsertContractor?: Maybe<{ readonly __typename?: 'UpsertContractorFailure', readonly errors: ReadonlyArray<{ readonly __typename?: 'InternalError', readonly message: string, readonly path?: Maybe<ReadonlyArray<string>>, readonly code: ErrorCodes } | { readonly __typename?: 'ValidationError', readonly message: string, readonly path?: Maybe<ReadonlyArray<string>>, readonly code: ErrorCodes }> } | { readonly __typename?: 'UpsertContractorSuccess' }> };

export type ActionBarContractorFragment = { readonly __typename?: 'Contractor', readonly id: string, readonly admin: boolean, readonly paymentsAdmin: boolean, readonly paymentsRole: PaymentsRole };

export type GetDashboardActionBarInfoQueryVariables = Exact<{ [key: string]: never; }>;


export type GetDashboardActionBarInfoQuery = { readonly __typename?: 'Query', readonly contractor?: Maybe<(
    { readonly __typename?: 'Contractor', readonly id: string }
    & ActionBarContractorFragment
  )>, readonly organization?: Maybe<{ readonly __typename?: 'Organization', readonly id: string, readonly stripeConnectAccount?: Maybe<{ readonly __typename?: 'StripeConnectAccount', readonly id: string, readonly status: ConnectAccountStatus }>, readonly contractServiceAccount?: Maybe<{ readonly __typename?: 'ContractServiceAccount', readonly id: string, readonly termsAgreedAt?: Maybe<string> }> }> };

export type PaymentsCardConnectAccountFragment = { readonly __typename?: 'StripeConnectAccount', readonly id: string, readonly status: ConnectAccountStatus, readonly balance: number, readonly approvedAt?: Maybe<string>, readonly pendingBalance: number, readonly requireStripeExternalAccount: boolean };

export type GetOrganizationHearthPayDataQueryVariables = Exact<{ [key: string]: never; }>;


export type GetOrganizationHearthPayDataQuery = { readonly __typename?: 'Query', readonly contractor?: Maybe<{ readonly __typename?: 'Contractor', readonly id: string, readonly paymentsAdmin: boolean, readonly paidPaymentsAmount: number, readonly unpaidPaymentsAmount: number, readonly overduePaymentsAmount: number }>, readonly organization?: Maybe<{ readonly __typename?: 'Organization', readonly id: string, readonly stripeConnectAccount?: Maybe<(
      { readonly __typename?: 'StripeConnectAccount', readonly id: string }
      & PaymentsCardConnectAccountFragment
    )>, readonly visibleConnectInvoices: { readonly __typename?: 'ConnectInvoiceConnection', readonly totalCount: number, readonly nodes?: Maybe<ReadonlyArray<Maybe<{ readonly __typename?: 'ConnectInvoice', readonly id: string, readonly amountRequested: number, readonly dueDate?: Maybe<string>, readonly status: ConnectInvoiceStatus }>>> } }> };

export type GetHearthPayStatusInfoQueryVariables = Exact<{ [key: string]: never; }>;


export type GetHearthPayStatusInfoQuery = { readonly __typename?: 'Query', readonly contractor?: Maybe<{ readonly __typename?: 'Contractor', readonly id: string, readonly paymentsAdmin: boolean, readonly paymentsRole: PaymentsRole }>, readonly organization?: Maybe<{ readonly __typename?: 'Organization', readonly id: string, readonly stripeConnectAccount?: Maybe<{ readonly __typename?: 'StripeConnectAccount', readonly id: string, readonly status: ConnectAccountStatus }> }> };

export type GetPaymentsStatusQueryVariables = Exact<{ [key: string]: never; }>;


export type GetPaymentsStatusQuery = { readonly __typename?: 'Query', readonly organization?: Maybe<{ readonly __typename?: 'Organization', readonly id: string, readonly stripeConnectAccount?: Maybe<{ readonly __typename?: 'StripeConnectAccount', readonly id: string, readonly status: ConnectAccountStatus }> }> };

export type GetRewardsAvailabilityQueryVariables = Exact<{ [key: string]: never; }>;


export type GetRewardsAvailabilityQuery = { readonly __typename?: 'Query', readonly resource?: Maybe<{ readonly __typename?: 'Resource', readonly id: string, readonly resourceValue: Record<string, any> }> };

export type OrganizationRewardsFragment = { readonly __typename?: 'Organization', readonly id: string, readonly rewardsFlagSetAt?: Maybe<string> };

export type ContractorRewardsFragment = { readonly __typename?: 'Contractor', readonly id: string, readonly email: string, readonly firstName: string, readonly firstUnblockedAt?: Maybe<string>, readonly hearthRewardsPaymentsVolume: number, readonly customSettings: { readonly __typename?: 'CustomContractorSettings', readonly rewardsAvailable: number, readonly rewardsClaimed: number, readonly paymentRewardsEarned: number } };

export type GetContractorRewardsDataQueryVariables = Exact<{ [key: string]: never; }>;


export type GetContractorRewardsDataQuery = { readonly __typename?: 'Query', readonly organization?: Maybe<(
    { readonly __typename?: 'Organization', readonly id: string }
    & OrganizationRewardsFragment
  )>, readonly contractor?: Maybe<(
    { readonly __typename?: 'Contractor', readonly id: string }
    & ContractorRewardsFragment
  )> };

export type ClaimRewardsGiftcardMutationVariables = Exact<{ [key: string]: never; }>;


export type ClaimRewardsGiftcardMutation = { readonly __typename?: 'Mutation', readonly claimHearthRewardsGiftcard?: Maybe<{ readonly __typename?: 'ClaimHearthRewardsGiftcardFailure', readonly errors: ReadonlyArray<{ readonly __typename?: 'InternalError', readonly message: string, readonly path?: Maybe<ReadonlyArray<string>>, readonly code: ErrorCodes } | { readonly __typename?: 'ValidationError', readonly message: string, readonly path?: Maybe<ReadonlyArray<string>>, readonly code: ErrorCodes }> } | { readonly __typename?: 'ClaimHearthRewardsGiftcardSuccess', readonly claimAmount: number, readonly contractor: { readonly __typename?: 'Contractor', readonly id: string, readonly customSettings: { readonly __typename?: 'CustomContractorSettings', readonly rewardsAvailable: number } } }> };

export type QuickPollFragment = { readonly __typename?: 'QuestionnaireQuestion', readonly id: string, readonly text: string, readonly allowedAnswers: ReadonlyArray<string>, readonly questionMeta?: Maybe<Record<string, any>>, readonly options: { readonly __typename?: 'QuestionnaireQuestionOptionConnection', readonly nodes?: Maybe<ReadonlyArray<Maybe<{ readonly __typename?: 'QuestionnaireQuestionOption', readonly id: string, readonly answerId: string, readonly text: string }>>> } };

export type GetQuickPollDataQueryVariables = Exact<{ [key: string]: never; }>;


export type GetQuickPollDataQuery = { readonly __typename?: 'Query', readonly questionnaire?: Maybe<{ readonly __typename?: 'Questionnaire', readonly id: string, readonly questions: { readonly __typename?: 'QuestionnaireQuestionConnection', readonly nodes?: Maybe<ReadonlyArray<Maybe<(
        { readonly __typename?: 'QuestionnaireQuestion', readonly id: string }
        & QuickPollFragment
      )>>> } }> };

export type RecordQuickPollResponseMutationVariables = Exact<{
  response: Scalars['JSON'];
}>;


export type RecordQuickPollResponseMutation = { readonly __typename?: 'Mutation', readonly recordQuickPollResponse?: Maybe<{ readonly __typename?: 'RecordQuickPollResponseFailure', readonly errors: ReadonlyArray<{ readonly __typename?: 'InternalError', readonly message: string, readonly path?: Maybe<ReadonlyArray<string>>, readonly code: ErrorCodes } | { readonly __typename?: 'ValidationError', readonly message: string, readonly path?: Maybe<ReadonlyArray<string>>, readonly code: ErrorCodes }> } | { readonly __typename?: 'RecordQuickPollResponseSuccess', readonly questionnaireResponse?: Maybe<{ readonly __typename?: 'QuestionnaireResponse', readonly id: string }> }> };

export type GetSeatsTrainingStatusQueryVariables = Exact<{ [key: string]: never; }>;


export type GetSeatsTrainingStatusQuery = { readonly __typename?: 'Query', readonly contractor?: Maybe<{ readonly __typename?: 'Contractor', readonly id: string, readonly admin: boolean, readonly trainingScheduledAt?: Maybe<string>, readonly trainingCompleted: boolean }> };

export type SuggestedActionCtaPartsFragment = { readonly __typename?: 'SuggestedActionCta', readonly id: string, readonly copy: string, readonly webLink?: Maybe<string> };

export type SuggestedActionPartsFragment = { readonly __typename?: 'SuggestedAction', readonly id: string, readonly suggestedActionTypeId: SuggestedActionActionType, readonly onboardingActionable: boolean, readonly metadata: Record<string, any>, readonly title: string, readonly copy: string, readonly createdAt: string, readonly ctas: { readonly __typename?: 'SuggestedActionCtaConnection', readonly nodes?: Maybe<ReadonlyArray<Maybe<(
      { readonly __typename?: 'SuggestedActionCta', readonly id: string }
      & SuggestedActionCtaPartsFragment
    )>>> } };

export type ContractorSuggestedActionsInfoFragment = { readonly __typename?: 'Contractor', readonly id: string, readonly urlPath: string, readonly suggestedActionsComplete: boolean, readonly suggestedActions: { readonly __typename?: 'SuggestedActionConnection', readonly nodes?: Maybe<ReadonlyArray<Maybe<(
      { readonly __typename?: 'SuggestedAction', readonly id: string }
      & SuggestedActionPartsFragment
    )>>> } };

export type OrganizationSuggestedActionsInfoFragment = { readonly __typename?: 'Organization', readonly id: string, readonly stripeConnectAccount?: Maybe<{ readonly __typename?: 'StripeConnectAccount', readonly id: string, readonly fullAccess: boolean }> };

export type GetSuggestedActionsDataQueryVariables = Exact<{ [key: string]: never; }>;


export type GetSuggestedActionsDataQuery = { readonly __typename?: 'Query', readonly organization?: Maybe<(
    { readonly __typename?: 'Organization', readonly id: string }
    & OrganizationSuggestedActionsInfoFragment
  )>, readonly contractor?: Maybe<(
    { readonly __typename?: 'Contractor', readonly id: string }
    & ContractorSuggestedActionsInfoFragment
  )> };

export type ClickSuggestedActionMutationVariables = Exact<{
  id: Scalars['ID'];
}>;


export type ClickSuggestedActionMutation = { readonly __typename?: 'Mutation', readonly suggestedActionClick?: Maybe<{ readonly __typename?: 'SuggestedActionClickFailure', readonly errors: ReadonlyArray<{ readonly __typename?: 'InternalError', readonly message: string, readonly path?: Maybe<ReadonlyArray<string>>, readonly code: ErrorCodes } | { readonly __typename?: 'ValidationError', readonly message: string, readonly path?: Maybe<ReadonlyArray<string>>, readonly code: ErrorCodes }> } | { readonly __typename?: 'SuggestedActionClickSuccess', readonly suggestedAction: { readonly __typename?: 'SuggestedAction', readonly id: string, readonly status: SuggestedActionStatusType } }> };

export type DismissSuggestedActionMutationVariables = Exact<{
  id: Scalars['ID'];
}>;


export type DismissSuggestedActionMutation = { readonly __typename?: 'Mutation', readonly suggestedActionDismiss?: Maybe<{ readonly __typename?: 'SuggestedActionDismissFailure', readonly errors: ReadonlyArray<{ readonly __typename?: 'InternalError', readonly message: string, readonly path?: Maybe<ReadonlyArray<string>>, readonly code: ErrorCodes } | { readonly __typename?: 'ValidationError', readonly message: string, readonly path?: Maybe<ReadonlyArray<string>>, readonly code: ErrorCodes }> } | { readonly __typename?: 'SuggestedActionDismissSuccess', readonly suggestedAction: { readonly __typename?: 'SuggestedAction', readonly id: string, readonly status: SuggestedActionStatusType } }> };

export type WebinarEventFragment = { readonly __typename?: 'HearthEvent', readonly id: string, readonly eventBody?: Maybe<Record<string, any>> };

export type GetUpcomingWebinarsQueryVariables = Exact<{ [key: string]: never; }>;


export type GetUpcomingWebinarsQuery = { readonly __typename?: 'Query', readonly contractor?: Maybe<{ readonly __typename?: 'Contractor', readonly id: string, readonly upcomingWebinars: { readonly __typename?: 'HearthEventConnection', readonly nodes?: Maybe<ReadonlyArray<Maybe<(
        { readonly __typename?: 'HearthEvent', readonly id: string }
        & WebinarEventFragment
      )>>> } }> };

export type DashboardContractFragment = { readonly __typename?: 'SubscriptionContract', readonly status: string, readonly toBeSignedContract?: Maybe<{ readonly __typename?: 'SignedContract', readonly id: string, readonly html: string, readonly text: string }> };

export type DashboardOrgFragment = { readonly __typename?: 'Organization', readonly id: string, readonly createdAt: string, readonly subscriptionContract: (
    { readonly __typename?: 'SubscriptionContract' }
    & DashboardContractFragment
  ), readonly stripeConnectAccount?: Maybe<{ readonly __typename?: 'StripeConnectAccount', readonly id: string, readonly approvedAt?: Maybe<string>, readonly status: ConnectAccountStatus }> };

export type DashboardContractorFragment = { readonly __typename?: 'Contractor', readonly id: string, readonly urlPath: string, readonly admin: boolean, readonly paymentsAdmin: boolean, readonly firstName: string, readonly trainingCompleted: boolean, readonly firstUnblockedAt?: Maybe<string>, readonly trainingScheduledAt?: Maybe<string>, readonly customSettings: { readonly __typename?: 'CustomContractorSettings', readonly newDashboardWelcomeModalSeen: boolean, readonly hearthOnboardingModalSeen: boolean, readonly highlightPaymentsOverlaySeenCount: number, readonly paymentsApprovalModalSeen: boolean, readonly financingUnlockedModalSeen: boolean, readonly financingUnlockedHighlightSeen: boolean, readonly sendNewProductTourSeen202201: boolean }, readonly allInvoices: { readonly __typename?: 'ConnectInvoiceConnection', readonly totalCount: number } };

export type GetBaseDashboardInfoQueryVariables = Exact<{ [key: string]: never; }>;


export type GetBaseDashboardInfoQuery = { readonly __typename?: 'Query', readonly featureFlags: ReadonlyArray<{ readonly __typename?: 'FeatureFlag', readonly id: string }>, readonly contractor?: Maybe<(
    { readonly __typename?: 'Contractor', readonly id: string }
    & DashboardContractorFragment
  )>, readonly organization?: Maybe<(
    { readonly __typename?: 'Organization', readonly id: string }
    & DashboardOrgFragment
  )> };

export type UpsertContractorDashoardInfoMutationVariables = Exact<{
  customSettings: CustomContractorSettingsAttributes;
}>;


export type UpsertContractorDashoardInfoMutation = { readonly __typename?: 'Mutation', readonly upsertContractor?: Maybe<{ readonly __typename?: 'UpsertContractorFailure', readonly errors: ReadonlyArray<{ readonly __typename?: 'InternalError', readonly message: string, readonly path?: Maybe<ReadonlyArray<string>>, readonly code: ErrorCodes } | { readonly __typename?: 'ValidationError', readonly message: string, readonly path?: Maybe<ReadonlyArray<string>>, readonly code: ErrorCodes }> } | { readonly __typename?: 'UpsertContractorSuccess', readonly contractor: { readonly __typename?: 'Contractor', readonly id: string, readonly customSettings: { readonly __typename?: 'CustomContractorSettings', readonly newDashboardWelcomeModalSeen: boolean, readonly highlightPaymentsOverlaySeenCount: number, readonly paymentsApprovalModalSeen: boolean, readonly hearthOnboardingModalSeen: boolean, readonly financingUnlockedModalSeen: boolean, readonly financingUnlockedHighlightSeen: boolean } } }> };

export type GetFirstTemplateBannerDataQueryVariables = Exact<{ [key: string]: never; }>;


export type GetFirstTemplateBannerDataQuery = { readonly __typename?: 'Query', readonly contractor?: Maybe<{ readonly __typename?: 'Contractor', readonly id: string, readonly customSettings: { readonly __typename?: 'CustomContractorSettings', readonly firstTemplateBannerDismissed: boolean } }> };

export type GetViewContractTemplateQueryVariables = Exact<{ [key: string]: never; }>;


export type GetViewContractTemplateQuery = { readonly __typename?: 'Query', readonly contractor?: Maybe<{ readonly __typename?: 'Contractor', readonly id: string, readonly phoneNumber: string, readonly fullName: string, readonly email: string }>, readonly organization?: Maybe<{ readonly __typename?: 'Organization', readonly id: string, readonly companyName: string, readonly fullAddress: string, readonly address?: Maybe<string>, readonly city: string, readonly state?: Maybe<string>, readonly zipCode?: Maybe<string>, readonly logoUrl?: Maybe<string>, readonly businessPhone?: Maybe<string>, readonly businessLicenseNumber?: Maybe<string> }>, readonly contractServiceContractTemplate?: Maybe<{ readonly __typename?: 'ContractServiceContractTemplate', readonly id: string, readonly template: Record<string, any> }> };

export type GenerateViewContractPreviewPdfMutationVariables = Exact<{
  html: Scalars['String'];
}>;


export type GenerateViewContractPreviewPdfMutation = { readonly __typename?: 'Mutation', readonly contractGeneratorRestGeneratePdf: { readonly __typename?: 'ContractGeneratorRestGeneratePdfResult', readonly pdf: string } };

export type EditContractAdminCheckQueryVariables = Exact<{ [key: string]: never; }>;


export type EditContractAdminCheckQuery = { readonly __typename?: 'Query', readonly contractor?: Maybe<{ readonly __typename?: 'Contractor', readonly id: string, readonly admin: boolean }>, readonly contractServiceContractTemplate?: Maybe<{ readonly __typename?: 'ContractServiceContractTemplate', readonly id: string, readonly updatedAt: string }> };

export type GetDefaultTosQueryVariables = Exact<{ [key: string]: never; }>;


export type GetDefaultTosQuery = { readonly __typename?: 'Query', readonly contractServiceBaseTemplate: { readonly __typename?: 'ContractServiceBaseTemplate', readonly id: string, readonly template: Record<string, any> } };

export type SetFirstTemplateBannerDismissedMutationVariables = Exact<{ [key: string]: never; }>;


export type SetFirstTemplateBannerDismissedMutation = { readonly __typename?: 'Mutation', readonly upsertContractor?: Maybe<{ readonly __typename?: 'UpsertContractorFailure', readonly errors: ReadonlyArray<{ readonly __typename?: 'InternalError', readonly message: string, readonly path?: Maybe<ReadonlyArray<string>>, readonly code: ErrorCodes } | { readonly __typename?: 'ValidationError', readonly message: string, readonly path?: Maybe<ReadonlyArray<string>>, readonly code: ErrorCodes }> } | { readonly __typename?: 'UpsertContractorSuccess' }> };

export type GetContractServiceAccountIdQueryVariables = Exact<{ [key: string]: never; }>;


export type GetContractServiceAccountIdQuery = { readonly __typename?: 'Query', readonly organization?: Maybe<{ readonly __typename?: 'Organization', readonly id: string, readonly contractServiceAccount?: Maybe<{ readonly __typename?: 'ContractServiceAccount', readonly id: string }> }> };

export type SetTermsAcceptanceMutationVariables = Exact<{
  contractServiceAccountId: Scalars['String'];
  termsAgreed: Scalars['String'];
}>;


export type SetTermsAcceptanceMutation = { readonly __typename?: 'Mutation', readonly contractServiceSignTerms?: Maybe<{ readonly __typename?: 'ContractServiceSignTermsFailure', readonly errors: ReadonlyArray<{ readonly __typename?: 'InternalError', readonly message: string, readonly path?: Maybe<ReadonlyArray<string>>, readonly code: ErrorCodes } | { readonly __typename?: 'ValidationError', readonly message: string, readonly path?: Maybe<ReadonlyArray<string>>, readonly code: ErrorCodes }> } | { readonly __typename?: 'ContractServiceSignTermsSuccess', readonly contractServiceAccount: { readonly __typename?: 'ContractServiceAccount', readonly id: string, readonly termsAgreed?: Maybe<string> } }> };

export type OrganizationContractTemplateInfoFragment = { readonly __typename?: 'Organization', readonly id: string, readonly companyName: string, readonly businessLicenseNumber?: Maybe<string>, readonly businessPhone?: Maybe<string>, readonly address?: Maybe<string>, readonly city: string, readonly state?: Maybe<string>, readonly zipCode?: Maybe<string>, readonly logoUrl?: Maybe<string>, readonly contractServiceAccount?: Maybe<{ readonly __typename?: 'ContractServiceAccount', readonly id: string }> };

export type GetEditContractTemplateQueryVariables = Exact<{ [key: string]: never; }>;


export type GetEditContractTemplateQuery = { readonly __typename?: 'Query', readonly organization?: Maybe<(
    { readonly __typename?: 'Organization', readonly id: string }
    & OrganizationContractTemplateInfoFragment
  )>, readonly contractor?: Maybe<{ readonly __typename?: 'Contractor', readonly id: string, readonly phoneNumber: string, readonly email: string, readonly admin: boolean, readonly fullName: string }>, readonly contractServiceContractTemplate?: Maybe<{ readonly __typename?: 'ContractServiceContractTemplate', readonly id: string, readonly versionName?: Maybe<string>, readonly template: Record<string, any>, readonly baseTemplate: { readonly __typename?: 'ContractServiceBaseTemplate', readonly id: string } }> };

export type GetContractBaseTemplatesQueryVariables = Exact<{ [key: string]: never; }>;


export type GetContractBaseTemplatesQuery = { readonly __typename?: 'Query', readonly contractServiceBaseTemplate: { readonly __typename?: 'ContractServiceBaseTemplate', readonly id: string, readonly template: Record<string, any> } };

export type UpsertOrganizationContractHeaderInfoMutationVariables = Exact<{
  attributes: OrganizationAttributes;
}>;


export type UpsertOrganizationContractHeaderInfoMutation = { readonly __typename?: 'Mutation', readonly upsertOrganization?: Maybe<{ readonly __typename?: 'UpsertOrganizationFailure', readonly errors: ReadonlyArray<{ readonly __typename?: 'InternalError', readonly message: string, readonly path?: Maybe<ReadonlyArray<string>>, readonly code: ErrorCodes } | { readonly __typename?: 'ValidationError', readonly message: string, readonly path?: Maybe<ReadonlyArray<string>>, readonly code: ErrorCodes }> } | { readonly __typename?: 'UpsertOrganizationSuccess', readonly organization: (
      { readonly __typename?: 'Organization', readonly id: string }
      & OrganizationContractTemplateInfoFragment
    ) }> };

export type UpsertContractTemplateMutationVariables = Exact<{
  contractServiceAccountId: Scalars['ID'];
  baseTemplateId: Scalars['String'];
  template: Scalars['JSON'];
}>;


export type UpsertContractTemplateMutation = { readonly __typename?: 'Mutation', readonly contractServiceContractTemplateUpsert?: Maybe<{ readonly __typename?: 'ContractServiceTemplateUpsertFailure', readonly errors: ReadonlyArray<{ readonly __typename?: 'InternalError', readonly message: string, readonly path?: Maybe<ReadonlyArray<string>>, readonly code: ErrorCodes } | { readonly __typename?: 'ValidationError', readonly message: string, readonly path?: Maybe<ReadonlyArray<string>>, readonly code: ErrorCodes }> } | { readonly __typename?: 'ContractServiceTemplateUpsertSuccess', readonly contractServiceContractTemplate: { readonly __typename?: 'ContractServiceContractTemplate', readonly id: string, readonly version: number, readonly baseTemplate: { readonly __typename?: 'ContractServiceBaseTemplate', readonly id: string } } }> };

export type UpsertEditContractTemplateVersionMutationVariables = Exact<{
  templateId?: Maybe<Scalars['ID']>;
  contractServiceAccountId: Scalars['ID'];
  baseTemplateId: Scalars['String'];
  template: Scalars['JSON'];
  versionName: Scalars['String'];
  contractorId: Scalars['ID'];
}>;


export type UpsertEditContractTemplateVersionMutation = { readonly __typename?: 'Mutation', readonly contractServiceContractTemplateVersionUpsert?: Maybe<{ readonly __typename?: 'ContractServiceTemplateVersionUpsertFailure', readonly errors: ReadonlyArray<{ readonly __typename?: 'InternalError', readonly message: string, readonly path?: Maybe<ReadonlyArray<string>>, readonly code: ErrorCodes } | { readonly __typename?: 'ValidationError', readonly message: string, readonly path?: Maybe<ReadonlyArray<string>>, readonly code: ErrorCodes }> } | { readonly __typename?: 'ContractServiceTemplateVersionUpsertSuccess', readonly contractServiceContractTemplate: { readonly __typename?: 'ContractServiceContractTemplate', readonly id: string, readonly version: number, readonly baseTemplate: { readonly __typename?: 'ContractServiceBaseTemplate', readonly id: string } } }> };

export type ContractTemplateVersionFragment = { readonly __typename?: 'ContractServiceContractTemplate', readonly id: string, readonly template: Record<string, any>, readonly versionName?: Maybe<string>, readonly default?: Maybe<boolean>, readonly updatedAt: string, readonly baseTemplate: { readonly __typename?: 'ContractServiceBaseTemplate', readonly id: string }, readonly editor?: Maybe<{ readonly __typename?: 'Contractor', readonly id: string, readonly fullName: string }> };

export type GetAllContractTemplatesQueryVariables = Exact<{ [key: string]: never; }>;


export type GetAllContractTemplatesQuery = { readonly __typename?: 'Query', readonly organization?: Maybe<{ readonly __typename?: 'Organization', readonly id: string, readonly contractServiceAccount?: Maybe<{ readonly __typename?: 'ContractServiceAccount', readonly id: string, readonly latestVersionContractTemplates?: Maybe<{ readonly __typename?: 'ContractServiceContractTemplateConnection', readonly nodes?: Maybe<ReadonlyArray<Maybe<(
          { readonly __typename?: 'ContractServiceContractTemplate', readonly id: string }
          & ContractTemplateVersionFragment
        )>>> }> }> }> };

export type SetDefaultContractTemplateMutationVariables = Exact<{
  contractServiceContractTemplateId: Scalars['ID'];
}>;


export type SetDefaultContractTemplateMutation = { readonly __typename?: 'Mutation', readonly contractServiceMarkDefaultTemplate?: Maybe<{ readonly __typename?: 'ContractServiceMarkDefaultTemplateFailure', readonly errors: ReadonlyArray<{ readonly __typename?: 'InternalError', readonly message: string, readonly path?: Maybe<ReadonlyArray<string>>, readonly code: ErrorCodes } | { readonly __typename?: 'ValidationError', readonly message: string, readonly path?: Maybe<ReadonlyArray<string>>, readonly code: ErrorCodes }> } | { readonly __typename?: 'ContractServiceMarkDefaultTemplateSuccess', readonly contractServiceContractTemplate: { readonly __typename?: 'ContractServiceContractTemplate', readonly id: string } }> };

export type DeleteAllTemplatesByVersionNameMutationVariables = Exact<{
  versionName: Scalars['String'];
}>;


export type DeleteAllTemplatesByVersionNameMutation = { readonly __typename?: 'Mutation', readonly contractServiceContractTemplateDeleteByName?: Maybe<{ readonly __typename?: 'ContractServiceTemplateDeleteByNameFailure', readonly errors: ReadonlyArray<{ readonly __typename?: 'InternalError', readonly message: string, readonly path?: Maybe<ReadonlyArray<string>>, readonly code: ErrorCodes } | { readonly __typename?: 'ValidationError', readonly message: string, readonly path?: Maybe<ReadonlyArray<string>>, readonly code: ErrorCodes }> } | { readonly __typename?: 'ContractServiceTemplateDeleteByNameSuccess', readonly contractServiceContractTemplateVersionName: string }> };

export type GenerateEditContractPreviewPdfMutationVariables = Exact<{
  html: Scalars['String'];
}>;


export type GenerateEditContractPreviewPdfMutation = { readonly __typename?: 'Mutation', readonly contractGeneratorRestGeneratePdf: { readonly __typename?: 'ContractGeneratorRestGeneratePdfResult', readonly pdf: string } };

export type HearthCashPaintedDoorResponseMutationVariables = Exact<{
  customSettings: CustomContractorSettingsAttributes;
}>;


export type HearthCashPaintedDoorResponseMutation = { readonly __typename?: 'Mutation', readonly upsertContractor?: Maybe<{ readonly __typename?: 'UpsertContractorFailure', readonly errors: ReadonlyArray<{ readonly __typename?: 'InternalError', readonly message: string, readonly path?: Maybe<ReadonlyArray<string>>, readonly code: ErrorCodes } | { readonly __typename?: 'ValidationError', readonly message: string, readonly path?: Maybe<ReadonlyArray<string>>, readonly code: ErrorCodes }> } | { readonly __typename?: 'UpsertContractorSuccess', readonly contractor: { readonly __typename?: 'Contractor', readonly id: string, readonly customSettings: { readonly __typename?: 'CustomContractorSettings', readonly hearthCashPaintedDoorWaitlistJoined: boolean } } }> };

export type GetIncompleteFinancingFeedbackResponseQueryVariables = Exact<{
  uuid: Scalars['ID'];
}>;


export type GetIncompleteFinancingFeedbackResponseQuery = { readonly __typename?: 'Query', readonly homeownerFeedbackResponse?: Maybe<{ readonly __typename?: 'HomeownerFeedbackResponse', readonly id: string, readonly uuid: string, readonly status: FeedbackResponseStatus }> };

export type CreateHomeownerFinancingFeedbackResponseMutationVariables = Exact<{
  uuid: Scalars['ID'];
  attributes: HomeownerFeedbackResponseAttributes;
}>;


export type CreateHomeownerFinancingFeedbackResponseMutation = { readonly __typename?: 'Mutation', readonly upsertHomeownerFinancingFeedback?: Maybe<{ readonly __typename?: 'UpsertHomeownerFinancingFeedbackFailure', readonly errors: ReadonlyArray<{ readonly __typename?: 'InternalError', readonly message: string, readonly path?: Maybe<ReadonlyArray<string>>, readonly code: ErrorCodes } | { readonly __typename?: 'ValidationError', readonly message: string, readonly path?: Maybe<ReadonlyArray<string>>, readonly code: ErrorCodes }> } | { readonly __typename?: 'UpsertHomeownerFinancingFeedbackSuccess', readonly homeownerFeedbackResponse: { readonly __typename?: 'HomeownerFeedbackResponse', readonly id: string, readonly uuid: string, readonly status: FeedbackResponseStatus } }> };

export type OrganizationBasicBusinessInfoFragment = { readonly __typename?: 'Organization', readonly id: string, readonly companyName: string, readonly businessEmail?: Maybe<string>, readonly businessPhone?: Maybe<string>, readonly fullAddress: string, readonly facebookUrl?: Maybe<string>, readonly twitterUrl?: Maybe<string>, readonly linkedinUrl?: Maybe<string>, readonly instagramUrl?: Maybe<string>, readonly website?: Maybe<string>, readonly logoUrl?: Maybe<string>, readonly stripeConnectAccount?: Maybe<{ readonly __typename?: 'StripeConnectAccount', readonly id: string, readonly cardFeeFixedAmount: number, readonly cardFeePercentageAmount: number }> };

export type OrganizationBusinessInfoFragment = (
  { readonly __typename?: 'Organization', readonly id: string, readonly fullAddress: string }
  & OrganizationBasicBusinessInfoFragment
);

export type FetchOrganizationQueryVariables = Exact<{
  organizationUuid: Scalars['ID'];
}>;


export type FetchOrganizationQuery = { readonly __typename?: 'Query', readonly organization?: Maybe<(
    { readonly __typename?: 'Organization', readonly id: string }
    & OrganizationBusinessInfoFragment
  )> };

export type VisibleAttachmentFragment = { readonly __typename?: 'InvoiceAttachment', readonly id: string, readonly attachmentFileName: string, readonly link: string };

export type CurrentConnectInvoiceHomeownerFragment = { readonly __typename?: 'Homeowner', readonly id: string, readonly firstName: string, readonly lastName: string, readonly fullName: string, readonly email: string, readonly phoneNumber: string, readonly financingStatus: HomeownerFinancingStatus, readonly activeInvoiceCount: number, readonly outstandingInvoiceCount: number, readonly outstandingInvoiceAmount: number, readonly homeownerFeedbackResponses?: Maybe<{ readonly __typename?: 'HomeownerFeedbackResponseConnection', readonly totalCount: number }> };

export type FetchInvoiceQueryVariables = Exact<{
  connectInvoiceId: Scalars['ID'];
}>;


export type FetchInvoiceQuery = { readonly __typename?: 'Query', readonly connectInvoice: { readonly __typename?: 'ConnectInvoice', readonly id: string, readonly invoiceNumber: number, readonly amountRequested: number, readonly description: string, readonly personalNote?: Maybe<string>, readonly scheduledFor?: Maybe<string>, readonly dueDate?: Maybe<string>, readonly status: ConnectInvoiceStatus, readonly paymentsCapabilityStatus?: Maybe<PaymentsCapabilityStatus>, readonly paid: boolean, readonly paidWith?: Maybe<ConnectInvoicePayment>, readonly requirePaymentMethod: boolean, readonly achEnabled: boolean, readonly creditCardEnabled: boolean, readonly debitCardEnabled: boolean, readonly refundedAmount?: Maybe<number>, readonly refundableAmount?: Maybe<number>, readonly chargedAmount?: Maybe<number>, readonly includesFinancing?: Maybe<boolean>, readonly outstandingInvoiceNumber?: Maybe<number>, readonly onlinePaymentsRequested: boolean, readonly sentAt?: Maybe<string>, readonly fullName: string, readonly phoneNumber: string, readonly email: string, readonly plaidLinkToken?: Maybe<string>, readonly homeownerAchFee: number, readonly homeownerCardFee: number, readonly homeownerDebitCardFee: number, readonly initiatedRefunds: { readonly __typename?: 'ConnectRefundConnection', readonly nodes?: Maybe<ReadonlyArray<Maybe<{ readonly __typename?: 'ConnectRefund', readonly id: string, readonly amount: number, readonly description: string }>>> }, readonly plaidAccount?: Maybe<{ readonly __typename?: 'PlaidAccount', readonly id: string, readonly mask: string, readonly name: string, readonly verificationStatus: PlaidVerificationStatus, readonly verified: boolean }>, readonly organization: (
      { readonly __typename?: 'Organization', readonly id: string }
      & OrganizationBusinessInfoFragment
    ), readonly contractor: { readonly __typename?: 'Contractor', readonly id: string, readonly fullUrl: string, readonly featureFlags: ReadonlyArray<{ readonly __typename?: 'FeatureFlag', readonly id: string }> }, readonly homeowner: (
      { readonly __typename?: 'Homeowner', readonly id: string }
      & CurrentConnectInvoiceHomeownerFragment
    ), readonly invoiceAttachments: { readonly __typename?: 'InvoiceAttachmentConnection', readonly nodes?: Maybe<ReadonlyArray<Maybe<(
        { readonly __typename?: 'InvoiceAttachment', readonly id: string }
        & VisibleAttachmentFragment
      )>>> }, readonly customizedInvoiceTemplate?: Maybe<{ readonly __typename?: 'CustomizedInvoiceTemplate', readonly id: string, readonly templateType: InvoiceTemplateType, readonly primaryColor: OrganizationTheme, readonly logo: boolean, readonly website: boolean, readonly background: Background, readonly signatureMessage?: Maybe<SignatureMessage>, readonly socialLinks: { readonly __typename?: 'SocialMediaLinks', readonly facebookUrl?: Maybe<boolean>, readonly twitterUrl?: Maybe<boolean>, readonly linkedinUrl?: Maybe<boolean>, readonly instagramUrl?: Maybe<boolean> } }> } };

export type PayConnectInvoiceMutationVariables = Exact<{
  connectInvoiceId: Scalars['ID'];
  token?: Maybe<Scalars['String']>;
  homeownerTermsAgreed: Scalars['String'];
  cardType?: Maybe<StripeChargeCard>;
}>;


export type PayConnectInvoiceMutation = { readonly __typename?: 'Mutation', readonly payConnectInvoice?: Maybe<{ readonly __typename?: 'PayConnectInvoiceFailure', readonly errors: ReadonlyArray<{ readonly __typename?: 'InternalError', readonly code: ErrorCodes, readonly message: string } | { readonly __typename?: 'ValidationError', readonly code: ErrorCodes, readonly message: string }> } | { readonly __typename?: 'PayConnectInvoiceSuccess', readonly connectInvoice?: Maybe<{ readonly __typename?: 'ConnectInvoice', readonly id: string, readonly status: ConnectInvoiceStatus, readonly paidWith?: Maybe<ConnectInvoicePayment>, readonly paidWithCardType?: Maybe<StripeChargeCard>, readonly organization: { readonly __typename?: 'Organization', readonly id: string }, readonly homeowner: (
        { readonly __typename?: 'Homeowner', readonly id: string }
        & CurrentConnectInvoiceHomeownerFragment
      ) }> }> };

export type UpdatePlaidTokenMutationVariables = Exact<{
  plaidPublicToken: Scalars['String'];
  connectInvoiceId: Scalars['ID'];
  plaidAccountId: Scalars['String'];
}>;


export type UpdatePlaidTokenMutation = { readonly __typename?: 'Mutation', readonly addPlaidTokenToConnectInvoice?: Maybe<{ readonly __typename?: 'AddPlaidTokenToConnectInvoiceFailure', readonly errors: ReadonlyArray<{ readonly __typename?: 'InternalError', readonly code: ErrorCodes, readonly message: string } | { readonly __typename?: 'ValidationError', readonly code: ErrorCodes, readonly message: string }> } | { readonly __typename?: 'AddPlaidTokenToConnectInvoiceSuccess', readonly connectInvoice: { readonly __typename?: 'ConnectInvoice', readonly id: string, readonly plaidAccount?: Maybe<{ readonly __typename?: 'PlaidAccount', readonly id: string, readonly mask: string, readonly name: string, readonly verificationStatus: PlaidVerificationStatus, readonly verified: boolean }> } }> };

export type RemovePlaidTokenMutationVariables = Exact<{
  connectInvoiceId: Scalars['ID'];
}>;


export type RemovePlaidTokenMutation = { readonly __typename?: 'Mutation', readonly removePlaidTokenFromConnectInvoice?: Maybe<{ readonly __typename?: 'RemovePlaidTokenFromConnectInvoiceFailure', readonly errors: ReadonlyArray<{ readonly __typename?: 'InternalError', readonly code: ErrorCodes, readonly message: string } | { readonly __typename?: 'ValidationError', readonly code: ErrorCodes, readonly message: string }> } | { readonly __typename?: 'RemovePlaidTokenFromConnectInvoiceSuccess', readonly connectInvoice: { readonly __typename?: 'ConnectInvoice', readonly id: string, readonly status: ConnectInvoiceStatus, readonly plaidLinkToken?: Maybe<string>, readonly plaidAccount?: Maybe<{ readonly __typename?: 'PlaidAccount', readonly id: string, readonly mask: string, readonly name: string, readonly verificationStatus: PlaidVerificationStatus, readonly verified: boolean }> } }> };

export type MarkInvoiceFirstViewedAtMutationVariables = Exact<{
  connectInvoiceId: Scalars['ID'];
}>;


export type MarkInvoiceFirstViewedAtMutation = { readonly __typename?: 'Mutation', readonly markConnectInvoiceFirstViewedAt?: Maybe<{ readonly __typename?: 'MarkConnectInvoiceFirstViewedAtFailure' } | { readonly __typename?: 'MarkConnectInvoiceFirstViewedAtSuccess', readonly connectInvoice?: Maybe<{ readonly __typename?: 'ConnectInvoice', readonly id: string }> }> };

export type ConnectInvoiceRequestOnlinePaymentsMutationVariables = Exact<{
  connectInvoiceId: Scalars['ID'];
}>;


export type ConnectInvoiceRequestOnlinePaymentsMutation = { readonly __typename?: 'Mutation', readonly connectInvoiceRequestOnlinePayments?: Maybe<{ readonly __typename?: 'ConnectInvoiceRequestOnlinePaymentsFailure', readonly errors: ReadonlyArray<{ readonly __typename?: 'InternalError', readonly message: string, readonly path?: Maybe<ReadonlyArray<string>>, readonly code: ErrorCodes } | { readonly __typename?: 'ValidationError', readonly message: string, readonly path?: Maybe<ReadonlyArray<string>>, readonly code: ErrorCodes }> } | { readonly __typename?: 'ConnectInvoiceRequestOnlinePaymentsSuccess', readonly connectInvoice?: Maybe<{ readonly __typename?: 'ConnectInvoice', readonly id: string, readonly onlinePaymentsRequested: boolean }> }> };

export type CreateHomeownerPaymentsFeedbackResponseMutationVariables = Exact<{
  connectInvoiceId: Scalars['ID'];
  attributes: HomeownerFeedbackResponseAttributes;
}>;


export type CreateHomeownerPaymentsFeedbackResponseMutation = { readonly __typename?: 'Mutation', readonly upsertHomeownerPaymentsFeedback?: Maybe<{ readonly __typename?: 'UpsertHomeownerPaymentsFeedbackFailure', readonly errors: ReadonlyArray<{ readonly __typename?: 'InternalError', readonly message: string, readonly path?: Maybe<ReadonlyArray<string>>, readonly code: ErrorCodes } | { readonly __typename?: 'ValidationError', readonly message: string, readonly path?: Maybe<ReadonlyArray<string>>, readonly code: ErrorCodes }> } | { readonly __typename?: 'UpsertHomeownerPaymentsFeedbackSuccess', readonly homeownerFeedbackResponse: { readonly __typename?: 'HomeownerFeedbackResponse', readonly id: string } }> };

export type ConnectInvoiceHomeownerFragment = { readonly __typename?: 'ConnectInvoice', readonly id: string, readonly invoiceNumber: number, readonly description: string, readonly status: ConnectInvoiceStatus, readonly statusLabel: string, readonly dueDate?: Maybe<string>, readonly paidAt?: Maybe<string>, readonly lastRefundedAt?: Maybe<string>, readonly amountRequested: number, readonly postRefundAmount: number, readonly refundedAmount?: Maybe<number>, readonly refundableAmount?: Maybe<number>, readonly invoiceAttachments: { readonly __typename?: 'InvoiceAttachmentConnection', readonly nodes?: Maybe<ReadonlyArray<Maybe<{ readonly __typename?: 'InvoiceAttachment', readonly id: string, readonly attachmentFileName: string, readonly link: string }>>> } };

export type ConnectInvoiceOrganizationFragment = { readonly __typename?: 'Organization', readonly id: string, readonly companyName: string, readonly fullAddress: string, readonly businessPhone?: Maybe<string>, readonly businessEmail?: Maybe<string>, readonly logoUrl?: Maybe<string> };

export type FetchHomeownerInvoicesQueryVariables = Exact<{
  homeownerId: Scalars['String'];
  organizationId?: Maybe<Scalars['ID']>;
  statuses?: Maybe<ReadonlyArray<Maybe<ConnectInvoiceStatus>> | Maybe<ConnectInvoiceStatus>>;
}>;


export type FetchHomeownerInvoicesQuery = { readonly __typename?: 'Query', readonly homeowner?: Maybe<{ readonly __typename?: 'Homeowner', readonly id: string, readonly firstName: string, readonly lastName: string, readonly fullName: string, readonly phoneNumber: string, readonly email: string, readonly contractor?: Maybe<{ readonly __typename?: 'Contractor', readonly id: string, readonly featureFlags: ReadonlyArray<{ readonly __typename?: 'FeatureFlag', readonly id: string }> }>, readonly connectInvoices?: Maybe<{ readonly __typename?: 'ConnectInvoiceConnection', readonly nodes?: Maybe<ReadonlyArray<Maybe<(
        { readonly __typename?: 'ConnectInvoice', readonly id: string }
        & ConnectInvoiceHomeownerFragment
      )>>> }>, readonly organization?: Maybe<(
      { readonly __typename?: 'Organization', readonly id: string }
      & ConnectInvoiceOrganizationFragment
    )> }> };

export type HomeownerLeadFragment = { readonly __typename?: 'Homeowner', readonly id: string, readonly firstName: string, readonly lastName: string, readonly phoneNumber: string };

export type LeadsContractorFragment = { readonly __typename?: 'Contractor', readonly id: string, readonly createdAt: string, readonly homeowners: { readonly __typename?: 'ContractorHomeownerConnection', readonly nodes?: Maybe<ReadonlyArray<Maybe<(
      { readonly __typename?: 'Homeowner', readonly id: string }
      & HomeownerLeadFragment
    )>>> } };

export type GetHomeownerLeadsInfoQueryVariables = Exact<{ [key: string]: never; }>;


export type GetHomeownerLeadsInfoQuery = { readonly __typename?: 'Query', readonly contractor?: Maybe<(
    { readonly __typename?: 'Contractor', readonly id: string }
    & LeadsContractorFragment
  )> };

export type UpdateHackathonHomeownerLeadMutationVariables = Exact<{ [key: string]: never; }>;


export type UpdateHackathonHomeownerLeadMutation = { readonly __typename?: 'Mutation', readonly updateHackathonHomeowner?: Maybe<{ readonly __typename?: 'UpdateHackathonHomeownerLeadFailure', readonly errors: ReadonlyArray<{ readonly __typename?: 'InternalError', readonly message: string, readonly path?: Maybe<ReadonlyArray<string>>, readonly code: ErrorCodes } | { readonly __typename?: 'ValidationError', readonly message: string, readonly path?: Maybe<ReadonlyArray<string>>, readonly code: ErrorCodes }> } | { readonly __typename?: 'UpdateHackathonHomeownerLeadSuccess', readonly homeowner?: Maybe<{ readonly __typename?: 'Homeowner', readonly id: string }> }> };

export type CreateFeedbackMutationVariables = Exact<{
  feedback: Scalars['String'];
  type: InsightsFeedback;
}>;


export type CreateFeedbackMutation = { readonly __typename?: 'Mutation', readonly createInsightsFeedback?: Maybe<{ readonly __typename?: 'CreateInsightsFeedbackFailure', readonly errors: ReadonlyArray<{ readonly __typename?: 'InternalError', readonly message: string, readonly path?: Maybe<ReadonlyArray<string>>, readonly code: ErrorCodes } | { readonly __typename?: 'ValidationError', readonly message: string, readonly path?: Maybe<ReadonlyArray<string>>, readonly code: ErrorCodes }> } | { readonly __typename?: 'CreateInsightsFeedbackSuccess', readonly contractor: { readonly __typename?: 'Contractor', readonly id: string } }> };

export type InsightsInvoiceFragment = { readonly __typename?: 'ConnectInvoice', readonly id: string, readonly createdAt: string, readonly sentAt?: Maybe<string>, readonly paidAt?: Maybe<string>, readonly amountRequested: number, readonly dueDate?: Maybe<string>, readonly status: ConnectInvoiceStatus };

export type InsightsContractFragment = { readonly __typename?: 'ContractServiceContract', readonly id: string, readonly status: ContractStatus, readonly createdAt: string, readonly dueDate: string, readonly amount?: Maybe<number>, readonly receiverSignature: { readonly __typename?: 'ContractServiceSignature', readonly id: string, readonly signer: { readonly __typename?: 'ContractServiceSigner', readonly id: string, readonly fullName: string } } };

export type InsightsFinancingInsightsAmountFragment = { readonly __typename?: 'FinancingInsightsAmount', readonly countByDay: ReadonlyArray<{ readonly __typename?: 'DailyCount', readonly date: string, readonly count: number, readonly amount: number }> };

export type GetInsightsQueryVariables = Exact<{ [key: string]: never; }>;


export type GetInsightsQuery = { readonly __typename?: 'Query', readonly organization?: Maybe<{ readonly __typename?: 'Organization', readonly id: string, readonly stripeConnectAccount?: Maybe<{ readonly __typename?: 'StripeConnectAccount', readonly id: string, readonly status: ConnectAccountStatus }>, readonly visibleConnectInvoices: { readonly __typename?: 'ConnectInvoiceConnection', readonly nodes?: Maybe<ReadonlyArray<Maybe<(
        { readonly __typename?: 'ConnectInvoice', readonly id: string }
        & InsightsInvoiceFragment
      )>>> }, readonly contractServiceAccount?: Maybe<{ readonly __typename?: 'ContractServiceAccount', readonly id: string, readonly termsAgreedAt?: Maybe<string>, readonly contracts: { readonly __typename?: 'ContractServiceContractConnection', readonly nodes?: Maybe<ReadonlyArray<Maybe<(
          { readonly __typename?: 'ContractServiceContract', readonly id: string }
          & InsightsContractFragment
        )>>> } }>, readonly allTimePrequalifiedFinancingAmount: (
      { readonly __typename?: 'FinancingInsightsAmount' }
      & InsightsFinancingInsightsAmountFragment
    ), readonly allTimeCompletedFinancingAmount: (
      { readonly __typename?: 'FinancingInsightsAmount' }
      & InsightsFinancingInsightsAmountFragment
    ), readonly allTimeFundedFinancingAmount: (
      { readonly __typename?: 'FinancingInsightsAmount' }
      & InsightsFinancingInsightsAmountFragment
    ) }> };

export type TrendDataQueryVariables = Exact<{
  type: FinancingInsightsFilter;
}>;


export type TrendDataQuery = { readonly __typename?: 'Query', readonly organization?: Maybe<{ readonly __typename?: 'Organization', readonly id: string, readonly financingInsightsTrendData: { readonly __typename?: 'FinancingInsightsTrend', readonly pastYearSum: number, readonly rollingCounts: ReadonlyArray<{ readonly __typename?: 'RollingCounts', readonly date: string, readonly count: number, readonly amount: number }> } }> };

export type FinancingInsightsCustomerProfileQueryVariables = Exact<{
  range: FinancingInsightsTimeRange;
}>;


export type FinancingInsightsCustomerProfileQuery = { readonly __typename?: 'Query', readonly organization?: Maybe<{ readonly __typename?: 'Organization', readonly id: string, readonly financingInsightsCustomerProfile: { readonly __typename?: 'FinancingInsightsCustomerProfile', readonly meanFico?: Maybe<number>, readonly meanIncome?: Maybe<number>, readonly medianIncome?: Maybe<number>, readonly medianApr?: Maybe<number>, readonly meanRequestedAmount?: Maybe<number>, readonly priorMedianApr?: Maybe<number>, readonly priorMeanRequestedAmount?: Maybe<number> } }> };

export type FunnelDataQueryVariables = Exact<{
  range: FinancingInsightsTimeRange;
}>;


export type FunnelDataQuery = { readonly __typename?: 'Query', readonly organization?: Maybe<{ readonly __typename?: 'Organization', readonly id: string, readonly financingInsightsFunnelData: { readonly __typename?: 'FinancingInsightsFunnel', readonly requestedAmount?: Maybe<number>, readonly preQualifiedAmount?: Maybe<number>, readonly fundedAmount?: Maybe<number>, readonly requestedCount?: Maybe<number>, readonly preQualifiedCount?: Maybe<number>, readonly fundedCount?: Maybe<number> } }> };

export type GetInsuranceDataQueryVariables = Exact<{ [key: string]: never; }>;


export type GetInsuranceDataQuery = { readonly __typename?: 'Query', readonly organization?: Maybe<{ readonly __typename?: 'Organization', readonly id: string, readonly insuranceEligible: boolean }>, readonly contractor?: Maybe<{ readonly __typename?: 'Contractor', readonly id: string, readonly customSettings: { readonly __typename?: 'CustomContractorSettings', readonly insuranceInquiryRequestMethod?: Maybe<string> } }> };

export type SetInsuranceSeenMutationVariables = Exact<{
  id: Scalars['ID'];
}>;


export type SetInsuranceSeenMutation = { readonly __typename?: 'Mutation', readonly updateContractor?: Maybe<{ readonly __typename?: 'UpdateContractorPayload', readonly contractor?: Maybe<{ readonly __typename?: 'Contractor', readonly id: string, readonly customSettings: { readonly __typename?: 'CustomContractorSettings', readonly insuranceSidebarTooltipSeen: boolean } }>, readonly errors?: Maybe<ReadonlyArray<{ readonly __typename?: 'ValidationError', readonly message: string, readonly path?: Maybe<ReadonlyArray<string>> }>> }> };

export type SetInsuranceInquiryRequestMethodMutationVariables = Exact<{
  id: Scalars['ID'];
  method: Scalars['String'];
}>;


export type SetInsuranceInquiryRequestMethodMutation = { readonly __typename?: 'Mutation', readonly updateContractor?: Maybe<{ readonly __typename?: 'UpdateContractorPayload', readonly contractor?: Maybe<{ readonly __typename?: 'Contractor', readonly id: string, readonly customSettings: { readonly __typename?: 'CustomContractorSettings', readonly insuranceInquiryRequestMethod?: Maybe<string> } }>, readonly errors?: Maybe<ReadonlyArray<{ readonly __typename?: 'ValidationError', readonly message: string, readonly path?: Maybe<ReadonlyArray<string>> }>> }> };

export type ActiveInvoiceTemplateFragment = { readonly __typename?: 'CustomizedInvoiceTemplate', readonly id: string, readonly templateType: InvoiceTemplateType, readonly primaryColor: OrganizationTheme, readonly logo: boolean, readonly website: boolean, readonly background: Background, readonly signatureMessage?: Maybe<SignatureMessage>, readonly socialLinks: { readonly __typename?: 'SocialMediaLinks', readonly facebookUrl?: Maybe<boolean>, readonly twitterUrl?: Maybe<boolean>, readonly linkedinUrl?: Maybe<boolean>, readonly instagramUrl?: Maybe<boolean> } };

export type FetchCustomInvoicePreviewQueryVariables = Exact<{ [key: string]: never; }>;


export type FetchCustomInvoicePreviewQuery = { readonly __typename?: 'Query', readonly organization?: Maybe<(
    { readonly __typename?: 'Organization', readonly id: string, readonly kycBusiness?: Maybe<{ readonly __typename?: 'KycBusiness', readonly id: string, readonly url?: Maybe<string> }> }
    & OrganizationBusinessInfoFragment
  )>, readonly contractor?: Maybe<{ readonly __typename?: 'Contractor', readonly id: string, readonly activeCustomizedInvoiceTemplate?: Maybe<(
      { readonly __typename?: 'CustomizedInvoiceTemplate', readonly id: string }
      & ActiveInvoiceTemplateFragment
    )> }> };

export type GetCustomInvoiceBannerConditionsQueryVariables = Exact<{ [key: string]: never; }>;


export type GetCustomInvoiceBannerConditionsQuery = { readonly __typename?: 'Query', readonly contractor?: Maybe<{ readonly __typename?: 'Contractor', readonly id: string, readonly paymentsAdmin: boolean }>, readonly organization?: Maybe<{ readonly __typename?: 'Organization', readonly id: string, readonly stripeConnectAccount?: Maybe<{ readonly __typename?: 'StripeConnectAccount', readonly id: string, readonly fullAccess: boolean }> }> };

export type StripeConnectAccountKycFragment = { readonly __typename?: 'StripeConnectAccount', readonly id: string, readonly hearthVerificationStatus: PaymentsHearthVerificationStatus, readonly status: ConnectAccountStatus, readonly accountType: string, readonly requirements: { readonly __typename?: 'StripeConnectAccountRequirements', readonly currentlyDue: ReadonlyArray<string>, readonly pendingVerification: ReadonlyArray<string>, readonly disabledReason?: Maybe<StripeAccountDisabledReason>, readonly errors: ReadonlyArray<{ readonly __typename?: 'StripeConnectAccountRequirementError', readonly code: StripeAccountRequirementsErrorCode, readonly reason: string, readonly requirement: string }> } };

export type StripeConnectAccountKycTransferDestinationFragment = { readonly __typename?: 'StripeConnectAccount', readonly id: string, readonly externalTransferDestinations: { readonly __typename?: 'ExternalTransferDestinations', readonly standardDestinations: ReadonlyArray<{ readonly __typename?: 'StripeBankAccount', readonly id: string, readonly bankName: string, readonly routingNumber: string, readonly last4: string, readonly status: StripeBankAccountVerificationStatus } | { readonly __typename?: 'StripeCard', readonly id: string, readonly name?: Maybe<string>, readonly brand: string, readonly last4: string }> } };

export type KycPersonInfoFragment = { readonly __typename?: 'KycPerson', readonly id: string, readonly birthday?: Maybe<string>, readonly email: string, readonly firstName: string, readonly lastName: string, readonly phoneNumber?: Maybe<string>, readonly representative: boolean, readonly title?: Maybe<string>, readonly addressLine1?: Maybe<string>, readonly addressLine2?: Maybe<string>, readonly city?: Maybe<string>, readonly state?: Maybe<string>, readonly zipCode?: Maybe<string>, readonly owner: boolean, readonly stripeVerificationStatus: StripePersonVerificationStatus, readonly stripeRequirements: { readonly __typename?: 'StripeConnectAccountRequirements', readonly pastDue: ReadonlyArray<string>, readonly errors: ReadonlyArray<{ readonly __typename?: 'StripeConnectAccountRequirementError', readonly code: StripeAccountRequirementsErrorCode, readonly reason: string, readonly requirement: string }> } };

export type KycRequirementInfoFragment = { readonly __typename?: 'KycRequirement', readonly id: string, readonly group: KycRequirementGroup, readonly updatedAt: string, readonly requiredFields: ReadonlyArray<string> };

export type KycDocumentsInfoFragment = { readonly __typename?: 'Document', readonly id: string, readonly attachmentUrl: string, readonly attachmentFileName: string, readonly documentType?: Maybe<string> };

export type KycBusinessInfoFragment = { readonly __typename?: 'KycBusiness', readonly id: string, readonly addressLine1?: Maybe<string>, readonly addressLine2?: Maybe<string>, readonly city?: Maybe<string>, readonly state?: Maybe<string>, readonly dbaName?: Maybe<string>, readonly email: string, readonly foundedDate?: Maybe<string>, readonly hasLiens?: Maybe<boolean>, readonly legalName?: Maybe<string>, readonly mccDescription?: Maybe<string>, readonly phoneNumber?: Maybe<string>, readonly productDescription?: Maybe<string>, readonly ratingScore?: Maybe<string>, readonly ratingWebsite?: Maybe<string>, readonly revenueRange?: Maybe<string>, readonly taxId?: Maybe<string>, readonly businessType?: Maybe<string>, readonly url?: Maybe<string>, readonly yearlyRevenueInCents?: Maybe<any>, readonly zipCode?: Maybe<string>, readonly plaidLinkToken: string, readonly kycDocuments: { readonly __typename?: 'DocumentConnection', readonly nodes?: Maybe<ReadonlyArray<Maybe<(
      { readonly __typename?: 'Document', readonly id: string }
      & KycDocumentsInfoFragment
    )>>> }, readonly kycPeople: { readonly __typename?: 'KycPersonConnection', readonly nodes?: Maybe<ReadonlyArray<Maybe<(
      { readonly __typename?: 'KycPerson', readonly id: string }
      & KycPersonInfoFragment
    )>>> }, readonly kycRequirements: { readonly __typename?: 'KycRequirementConnection', readonly nodes?: Maybe<ReadonlyArray<Maybe<(
      { readonly __typename?: 'KycRequirement', readonly id: string }
      & KycRequirementInfoFragment
    )>>> } };

export type OrganizationKycFragment = { readonly __typename?: 'Organization', readonly id: string, readonly companyName: string, readonly businessPhone?: Maybe<string>, readonly fullAddress: string, readonly address?: Maybe<string>, readonly addressLine2?: Maybe<string>, readonly state?: Maybe<string>, readonly city: string, readonly zipCode?: Maybe<string>, readonly stripeConnectAccount?: Maybe<(
    { readonly __typename?: 'StripeConnectAccount', readonly id: string }
    & StripeConnectAccountKycFragment
    & StripeConnectAccountKycTransferDestinationFragment
  )>, readonly kycBusiness?: Maybe<(
    { readonly __typename?: 'KycBusiness', readonly id: string, readonly pastDueKycRequirements: { readonly __typename?: 'KycRequirementConnection', readonly nodes?: Maybe<ReadonlyArray<Maybe<(
        { readonly __typename?: 'KycRequirement', readonly id: string }
        & KycRequirementInfoFragment
      )>>> } }
    & KycBusinessInfoFragment
  )> };

export type ContractorKycFragment = { readonly __typename?: 'Contractor', readonly id: string, readonly firstName: string, readonly lastName: string, readonly phoneNumber: string, readonly email: string, readonly paymentsRole: PaymentsRole, readonly admin: boolean };

export type GetKycDataQueryVariables = Exact<{ [key: string]: never; }>;


export type GetKycDataQuery = { readonly __typename?: 'Query', readonly organization?: Maybe<(
    { readonly __typename?: 'Organization', readonly id: string }
    & OrganizationKycFragment
  )>, readonly contractor?: Maybe<(
    { readonly __typename?: 'Contractor', readonly id: string }
    & ContractorKycFragment
  )> };

export type InitiateKycMutationVariables = Exact<{
  contractId: Scalars['ID'];
}>;


export type InitiateKycMutation = { readonly __typename?: 'Mutation', readonly signAccountContract?: Maybe<{ readonly __typename?: 'SignAccountContractFailure', readonly errors: ReadonlyArray<{ readonly __typename?: 'InternalError', readonly message: string, readonly path?: Maybe<ReadonlyArray<string>>, readonly code: ErrorCodes } | { readonly __typename?: 'ValidationError', readonly message: string, readonly path?: Maybe<ReadonlyArray<string>>, readonly code: ErrorCodes }> } | { readonly __typename?: 'SignAccountContractSuccess', readonly stripeConnectAccount: (
      { readonly __typename?: 'StripeConnectAccount', readonly id: string }
      & StripeConnectAccountKycFragment
    ) }> };

export type UpsertKycBusinessInfoMutationVariables = Exact<{
  stripeConnectAccountId: Scalars['ID'];
  attributes: KycBusinessAttributes;
}>;


export type UpsertKycBusinessInfoMutation = { readonly __typename?: 'Mutation', readonly paymentsSetupSubmitBusinessInfo?: Maybe<{ readonly __typename?: 'SubmitBusinessInfoFailure', readonly errors: ReadonlyArray<{ readonly __typename?: 'InternalError', readonly message: string, readonly path?: Maybe<ReadonlyArray<string>>, readonly code: ErrorCodes } | { readonly __typename?: 'ValidationError', readonly message: string, readonly path?: Maybe<ReadonlyArray<string>>, readonly code: ErrorCodes }> } | { readonly __typename?: 'SubmitBusinessInfoSuccess', readonly stripeConnectAccount: (
      { readonly __typename?: 'StripeConnectAccount', readonly id: string }
      & StripeConnectAccountKycFragment
    ), readonly kycBusiness: (
      { readonly __typename?: 'KycBusiness', readonly id: string }
      & KycBusinessInfoFragment
    ) }> };

export type UpsertKycPersonInfoMutationVariables = Exact<{
  id?: Maybe<Scalars['ID']>;
  stripeConnectAccountId: Scalars['ID'];
  attributes: KycPersonAttributes;
}>;


export type UpsertKycPersonInfoMutation = { readonly __typename?: 'Mutation', readonly paymentsSetupSubmitPersonInfo?: Maybe<{ readonly __typename?: 'SubmitPersonInfoFailure', readonly errors: ReadonlyArray<{ readonly __typename?: 'InternalError', readonly message: string, readonly path?: Maybe<ReadonlyArray<string>>, readonly code: ErrorCodes } | { readonly __typename?: 'ValidationError', readonly message: string, readonly path?: Maybe<ReadonlyArray<string>>, readonly code: ErrorCodes }> } | { readonly __typename?: 'SubmitPersonInfoSuccess', readonly stripeConnectAccount: (
      { readonly __typename?: 'StripeConnectAccount', readonly id: string }
      & StripeConnectAccountKycFragment
    ), readonly kycBusiness: (
      { readonly __typename?: 'KycBusiness', readonly id: string }
      & KycBusinessInfoFragment
    ) }> };

export type DeleteKycPersonMutationVariables = Exact<{
  id: Scalars['ID'];
  stripeConnectAccountId: Scalars['ID'];
}>;


export type DeleteKycPersonMutation = { readonly __typename?: 'Mutation', readonly paymentsSetupDeletePerson?: Maybe<{ readonly __typename?: 'DeletePersonFailure', readonly errors: ReadonlyArray<{ readonly __typename?: 'InternalError', readonly message: string, readonly path?: Maybe<ReadonlyArray<string>>, readonly code: ErrorCodes } | { readonly __typename?: 'ValidationError', readonly message: string, readonly path?: Maybe<ReadonlyArray<string>>, readonly code: ErrorCodes }> } | { readonly __typename?: 'DeletePersonSuccess', readonly stripeConnectAccount: (
      { readonly __typename?: 'StripeConnectAccount', readonly id: string }
      & StripeConnectAccountKycFragment
    ), readonly kycBusiness: (
      { readonly __typename?: 'KycBusiness', readonly id: string }
      & KycBusinessInfoFragment
    ) }> };

export type SubmitApplicationKycMutationVariables = Exact<{
  stripeConnectAccountId: Scalars['ID'];
  reapplication: Scalars['Boolean'];
}>;


export type SubmitApplicationKycMutation = { readonly __typename?: 'Mutation', readonly paymentsSetupSubmitApplication?: Maybe<{ readonly __typename?: 'SubmitApplicationFailure', readonly errors: ReadonlyArray<{ readonly __typename?: 'InternalError', readonly message: string, readonly path?: Maybe<ReadonlyArray<string>>, readonly code: ErrorCodes } | { readonly __typename?: 'ValidationError', readonly message: string, readonly path?: Maybe<ReadonlyArray<string>>, readonly code: ErrorCodes }> } | { readonly __typename?: 'SubmitApplicationSuccess', readonly stripeConnectAccount: (
      { readonly __typename?: 'StripeConnectAccount', readonly id: string }
      & StripeConnectAccountKycFragment
    ) }> };

export type GetConnectAccountOnboardingLoginMutationVariables = Exact<{
  organizationId: Scalars['ID'];
  refreshUrl: Scalars['String'];
  returnUrl: Scalars['String'];
  type: Scalars['String'];
}>;


export type GetConnectAccountOnboardingLoginMutation = { readonly __typename?: 'Mutation', readonly getStripeAccountLink?: Maybe<{ readonly __typename?: 'GetStripeAccountLinkFailure', readonly errors: ReadonlyArray<{ readonly __typename?: 'InternalError', readonly code: ErrorCodes, readonly message: string, readonly path?: Maybe<ReadonlyArray<string>> } | { readonly __typename?: 'ValidationError', readonly code: ErrorCodes, readonly message: string, readonly path?: Maybe<ReadonlyArray<string>> }> } | { readonly __typename?: 'GetStripeAccountLinkSuccess', readonly connectAccountLoginLink: string }> };

export type UploadKycReapplyDocumentsMutationVariables = Exact<{
  kycBusinessId: Scalars['ID'];
  documents?: Maybe<ReadonlyArray<DocumentAttributes> | DocumentAttributes>;
  removedUploadIds?: Maybe<ReadonlyArray<Scalars['String']> | Scalars['String']>;
}>;


export type UploadKycReapplyDocumentsMutation = { readonly __typename?: 'Mutation', readonly kycSubmitVerificationDocuments?: Maybe<{ readonly __typename?: 'SubmitVerificationDocumentsFailure', readonly errors: ReadonlyArray<{ readonly __typename?: 'InternalError', readonly message: string, readonly path?: Maybe<ReadonlyArray<string>>, readonly code: ErrorCodes } | { readonly __typename?: 'ValidationError', readonly message: string, readonly path?: Maybe<ReadonlyArray<string>>, readonly code: ErrorCodes }> } | { readonly __typename?: 'SubmitVerificationDocumentsSuccess', readonly kycBusiness: { readonly __typename?: 'KycBusiness', readonly id: string } }> };

export type UpdateOrganizationKycInfoMutationVariables = Exact<{
  attributes: OrganizationAttributes;
}>;


export type UpdateOrganizationKycInfoMutation = { readonly __typename?: 'Mutation', readonly upsertOrganization?: Maybe<{ readonly __typename?: 'UpsertOrganizationFailure', readonly errors: ReadonlyArray<{ readonly __typename?: 'InternalError', readonly message: string, readonly path?: Maybe<ReadonlyArray<string>>, readonly code: ErrorCodes } | { readonly __typename?: 'ValidationError', readonly message: string, readonly path?: Maybe<ReadonlyArray<string>>, readonly code: ErrorCodes }> } | { readonly __typename?: 'UpsertOrganizationSuccess', readonly organization: (
      { readonly __typename?: 'Organization', readonly id: string }
      & OrganizationKycFragment
    ) }> };

export type UpdateContractorKycInfoMutationVariables = Exact<{
  attributes: ContractorAttributes;
}>;


export type UpdateContractorKycInfoMutation = { readonly __typename?: 'Mutation', readonly upsertContractor?: Maybe<{ readonly __typename?: 'UpsertContractorFailure', readonly errors: ReadonlyArray<{ readonly __typename?: 'InternalError', readonly message: string, readonly path?: Maybe<ReadonlyArray<string>>, readonly code: ErrorCodes } | { readonly __typename?: 'ValidationError', readonly message: string, readonly path?: Maybe<ReadonlyArray<string>>, readonly code: ErrorCodes }> } | { readonly __typename?: 'UpsertContractorSuccess', readonly contractor: (
      { readonly __typename?: 'Contractor', readonly id: string }
      & ContractorKycFragment
    ) }> };

export type StripeCardPartsFragment = { readonly __typename?: 'StripeCard', readonly id: string, readonly name?: Maybe<string>, readonly brand: string, readonly expMonth: string, readonly expYear: string, readonly last4: string, readonly defaultForCurrency: boolean, readonly instantAvailable: boolean, readonly standardAvailable: boolean };

export type StripeBankAccountPartsFragment = { readonly __typename?: 'StripeBankAccount', readonly id: string, readonly accountHolderName?: Maybe<string>, readonly bankName: string, readonly last4: string, readonly routingNumber: string, readonly status: StripeBankAccountVerificationStatus, readonly defaultForCurrency: boolean };

export type GetPayoutDataQueryVariables = Exact<{ [key: string]: never; }>;


export type GetPayoutDataQuery = { readonly __typename?: 'Query', readonly contractor?: Maybe<{ readonly __typename?: 'Contractor', readonly id: string }>, readonly organization?: Maybe<{ readonly __typename?: 'Organization', readonly id: string, readonly stripeConnectAccount?: Maybe<{ readonly __typename?: 'StripeConnectAccount', readonly id: string, readonly transferBalances: { readonly __typename?: 'TransferBalances', readonly grossTransferAmount: number, readonly alreadyPayedOut: number, readonly totalAvailableStandard: number, readonly totalAvailableInstant: number, readonly totalPending: number, readonly hasCompletedPayout: boolean, readonly cardTransferFees: number, readonly achTransferFees: number }, readonly externalTransferDestinations: { readonly __typename?: 'ExternalTransferDestinations', readonly standardDestinations: ReadonlyArray<(
          { readonly __typename?: 'StripeBankAccount', readonly id: string }
          & StripeBankAccountPartsFragment
        ) | (
          { readonly __typename?: 'StripeCard', readonly id: string }
          & StripeCardPartsFragment
        )>, readonly instantDestinations: ReadonlyArray<(
          { readonly __typename?: 'StripeCard', readonly id: string }
          & StripeCardPartsFragment
        )> } }> }> };

export type CreatePayoutMutationVariables = Exact<{
  contractorId: Scalars['ID'];
  amountInCents: Scalars['Int'];
  destination: Scalars['String'];
  instant: Scalars['Boolean'];
}>;


export type CreatePayoutMutation = { readonly __typename?: 'Mutation', readonly createConnectPayout?: Maybe<{ readonly __typename?: 'CreateConnectPayoutFailure', readonly errors: ReadonlyArray<{ readonly __typename?: 'InternalError', readonly message: string, readonly path?: Maybe<ReadonlyArray<string>>, readonly code: ErrorCodes } | { readonly __typename?: 'ValidationError', readonly message: string, readonly path?: Maybe<ReadonlyArray<string>>, readonly code: ErrorCodes }> } | { readonly __typename?: 'CreateConnectPayoutSuccess', readonly amountInCents: number, readonly stripePayouts: ReadonlyArray<{ readonly __typename?: 'Payout', readonly stripePayoutId: string, readonly amountInCents: number }> }> };

export type GetPaymentPayoutDetailsQueryVariables = Exact<{ [key: string]: never; }>;


export type GetPaymentPayoutDetailsQuery = { readonly __typename?: 'Query', readonly organization?: Maybe<{ readonly __typename?: 'Organization', readonly id: string, readonly stripeConnectAccount?: Maybe<{ readonly __typename?: 'StripeConnectAccount', readonly id: string, readonly firstPayoutAddedAt?: Maybe<string> }>, readonly kycBusiness?: Maybe<{ readonly __typename?: 'KycBusiness', readonly id: string, readonly plaidLinkToken: string }> }> };

export type AddPayoutExternalAccountMutationVariables = Exact<{
  stripeConnectAccountId: Scalars['ID'];
  externalAccountToken: Scalars['String'];
}>;


export type AddPayoutExternalAccountMutation = { readonly __typename?: 'Mutation', readonly paymentsSetupAddExternalAccount?: Maybe<{ readonly __typename?: 'AttachExternalAccountFailure', readonly errors: ReadonlyArray<{ readonly __typename?: 'InternalError', readonly message: string, readonly path?: Maybe<ReadonlyArray<string>>, readonly code: ErrorCodes } | { readonly __typename?: 'ValidationError', readonly message: string, readonly path?: Maybe<ReadonlyArray<string>>, readonly code: ErrorCodes }> } | { readonly __typename?: 'AttachExternalAccountSuccess', readonly stripeConnectAccount: { readonly __typename?: 'StripeConnectAccount', readonly id: string } }> };

export type AttachPlaidBankAccountMutationVariables = Exact<{
  stripeConnectAccountId: Scalars['ID'];
  kycBusinessId: Scalars['ID'];
  plaidAccountId: Scalars['String'];
  plaidPublicToken: Scalars['String'];
}>;


export type AttachPlaidBankAccountMutation = { readonly __typename?: 'Mutation', readonly paymentsSetupAttachPlaidBankAccountToConnectAccount?: Maybe<{ readonly __typename?: 'AttachPlaidBankAccountToConnectAccountFailure', readonly errors: ReadonlyArray<{ readonly __typename?: 'InternalError', readonly message: string, readonly path?: Maybe<ReadonlyArray<string>>, readonly code: ErrorCodes } | { readonly __typename?: 'ValidationError', readonly message: string, readonly path?: Maybe<ReadonlyArray<string>>, readonly code: ErrorCodes }> } | { readonly __typename?: 'AttachPlaidBankAccountToConnectAccountSuccess', readonly kycBusiness: { readonly __typename?: 'KycBusiness', readonly id: string, readonly plaidLinkToken: string } }> };

export type UpdateConnectAccountPayoutMutationVariables = Exact<{
  stripeConnectAccountId: Scalars['ID'];
  attributes: StripeConnectAccountAttributes;
}>;


export type UpdateConnectAccountPayoutMutation = { readonly __typename?: 'Mutation', readonly updateStripeConnectAccount?: Maybe<{ readonly __typename?: 'UpdateStripeConnectAccountFailure', readonly errors: ReadonlyArray<{ readonly __typename?: 'InternalError', readonly message: string, readonly path?: Maybe<ReadonlyArray<string>>, readonly code: ErrorCodes } | { readonly __typename?: 'ValidationError', readonly message: string, readonly path?: Maybe<ReadonlyArray<string>>, readonly code: ErrorCodes }> } | { readonly __typename?: 'UpdateStripeConnectAccountSuccess', readonly stripeConnectAccount: { readonly __typename?: 'StripeConnectAccount', readonly id: string, readonly firstPayoutAddedAt?: Maybe<string> } }> };

export type PaymentRefundFragmentFragment = { readonly __typename?: 'ConnectInvoice', readonly id: string, readonly amountRequested: number, readonly refundedAmount?: Maybe<number>, readonly refundableAmount?: Maybe<number>, readonly chargedAmount?: Maybe<number>, readonly homeownerFeeAmount?: Maybe<number> };

export type GetPaymentRefundInformationQueryVariables = Exact<{
  id: Scalars['ID'];
}>;


export type GetPaymentRefundInformationQuery = { readonly __typename?: 'Query', readonly connectInvoice: (
    { readonly __typename?: 'ConnectInvoice', readonly id: string, readonly fullName: string, readonly paid: boolean, readonly manuallyPaid: boolean }
    & PaymentRefundFragmentFragment
  ) };

export type RefundConnectInvoiceMutationVariables = Exact<{
  id: Scalars['ID'];
  amount: Scalars['Int'];
  reasonType?: Maybe<ConnectRefundReason>;
  description?: Maybe<Scalars['String']>;
}>;


export type RefundConnectInvoiceMutation = { readonly __typename?: 'Mutation', readonly refundConnectInvoice?: Maybe<{ readonly __typename?: 'RefundConnectInvoiceFailure', readonly errors: ReadonlyArray<{ readonly __typename?: 'InternalError', readonly code: ErrorCodes, readonly message: string, readonly path?: Maybe<ReadonlyArray<string>> } | { readonly __typename?: 'ValidationError', readonly code: ErrorCodes, readonly message: string, readonly path?: Maybe<ReadonlyArray<string>> }> } | { readonly __typename?: 'RefundConnectInvoiceSuccess', readonly connectInvoice?: Maybe<(
      { readonly __typename?: 'ConnectInvoice', readonly id: string, readonly viewableActivities: { readonly __typename?: 'ConnectActivityConnection', readonly nodes?: Maybe<ReadonlyArray<Maybe<{ readonly __typename?: 'ConnectActivity', readonly id: string, readonly activityDate: string, readonly content: string, readonly connectActivityTypeId: ConnectActivityId }>>> } }
      & PaymentRefundFragmentFragment
    )> }> };

export type GetPaymentFaqDataQueryVariables = Exact<{ [key: string]: never; }>;


export type GetPaymentFaqDataQuery = { readonly __typename?: 'Query', readonly organization?: Maybe<{ readonly __typename?: 'Organization', readonly id: string, readonly currentTransactionForNewPaymentsAccounts: { readonly __typename?: 'PaymentsProductTransactionFees', readonly achFeeFixedAmount: number, readonly cardFeePercentageAmount: number } }> };

export type GetPaymentSetupDataQueryVariables = Exact<{ [key: string]: never; }>;


export type GetPaymentSetupDataQuery = { readonly __typename?: 'Query', readonly organization?: Maybe<{ readonly __typename?: 'Organization', readonly id: string, readonly stripeConnectAccount?: Maybe<{ readonly __typename?: 'StripeConnectAccount', readonly id: string }>, readonly customSettings: { readonly __typename?: 'CustomOrganizationSettings', readonly paymentsRewardsExpiredAt?: Maybe<string>, readonly paymentsRewardsQualifiedAt?: Maybe<string> }, readonly currentTransactionForNewPaymentsAccounts: { readonly __typename?: 'PaymentsProductTransactionFees', readonly achFeeFixedAmount: number, readonly cardFeePercentageAmount: number }, readonly paymentsContract?: Maybe<{ readonly __typename?: 'Contract', readonly id: string, readonly text: string }> }> };

export type GetPaymentsApprovedDataQueryVariables = Exact<{ [key: string]: never; }>;


export type GetPaymentsApprovedDataQuery = { readonly __typename?: 'Query', readonly contractor?: Maybe<{ readonly __typename?: 'Contractor', readonly id: string, readonly firstName: string, readonly paymentsAdmin: boolean }> };

export type PaymentStripeRedirectStripeConnectAccountFragment = { readonly __typename?: 'StripeConnectAccount', readonly id: string, readonly hearthVerificationStatus: PaymentsHearthVerificationStatus, readonly status: ConnectAccountStatus, readonly accountType: string, readonly requirements: { readonly __typename?: 'StripeConnectAccountRequirements', readonly currentlyDue: ReadonlyArray<string>, readonly eventuallyDue: ReadonlyArray<string>, readonly pendingVerification: ReadonlyArray<string>, readonly disabledReason?: Maybe<StripeAccountDisabledReason>, readonly errors: ReadonlyArray<{ readonly __typename?: 'StripeConnectAccountRequirementError', readonly code: StripeAccountRequirementsErrorCode, readonly reason: string, readonly requirement: string }> }, readonly futureRequirements: { readonly __typename?: 'StripeConnectAccountRequirements', readonly currentlyDue: ReadonlyArray<string>, readonly eventuallyDue: ReadonlyArray<string> } };

export type PaymentStripeRedirectOrganizationFragment = { readonly __typename?: 'Organization', readonly id: string, readonly stripeConnectAccount?: Maybe<(
    { readonly __typename?: 'StripeConnectAccount', readonly id: string }
    & PaymentStripeRedirectStripeConnectAccountFragment
  )> };

export type GetPaymentStripeRedirectDataQueryVariables = Exact<{ [key: string]: never; }>;


export type GetPaymentStripeRedirectDataQuery = { readonly __typename?: 'Query', readonly organization?: Maybe<(
    { readonly __typename?: 'Organization', readonly id: string }
    & PaymentStripeRedirectOrganizationFragment
  )> };

export type PaymentStripeRedirectGenerateConnectOnboardingLinkMutationVariables = Exact<{
  organizationId: Scalars['ID'];
  refreshUrl: Scalars['String'];
  returnUrl: Scalars['String'];
}>;


export type PaymentStripeRedirectGenerateConnectOnboardingLinkMutation = { readonly __typename?: 'Mutation', readonly getStripeAccountLink?: Maybe<{ readonly __typename?: 'GetStripeAccountLinkFailure', readonly errors: ReadonlyArray<{ readonly __typename?: 'InternalError', readonly code: ErrorCodes, readonly message: string, readonly path?: Maybe<ReadonlyArray<string>> } | { readonly __typename?: 'ValidationError', readonly code: ErrorCodes, readonly message: string, readonly path?: Maybe<ReadonlyArray<string>> }> } | { readonly __typename?: 'GetStripeAccountLinkSuccess', readonly connectAccountLoginLink: string }> };

export type GetPrePaymentsDataQueryVariables = Exact<{ [key: string]: never; }>;


export type GetPrePaymentsDataQuery = { readonly __typename?: 'Query', readonly contractor?: Maybe<{ readonly __typename?: 'Contractor', readonly id: string, readonly tryPaymentsSeen: boolean, readonly paymentsRole: PaymentsRole, readonly customSettings: { readonly __typename?: 'CustomContractorSettings', readonly tryPaymentsSeenWeb: boolean } }>, readonly organization?: Maybe<{ readonly __typename?: 'Organization', readonly id: string, readonly paymentsContract?: Maybe<{ readonly __typename?: 'Contract', readonly id: string, readonly text: string }> }> };

export type SendSampleInvoiceMutationVariables = Exact<{
  id: Scalars['ID'];
}>;


export type SendSampleInvoiceMutation = { readonly __typename?: 'Mutation', readonly sendContractorSampleInvoice?: Maybe<{ readonly __typename?: 'SendContractorSampleInvoicePayload', readonly contractor: { readonly __typename?: 'Contractor', readonly id: string, readonly tryPaymentsSeen: boolean } }> };

export type UpdateContractorPaymentsDataMutationVariables = Exact<{
  id: Scalars['ID'];
  attributes: ContractorAttributes;
}>;


export type UpdateContractorPaymentsDataMutation = { readonly __typename?: 'Mutation', readonly updateContractor?: Maybe<{ readonly __typename?: 'UpdateContractorPayload', readonly contractor?: Maybe<{ readonly __typename?: 'Contractor', readonly id: string, readonly tryPaymentsSeen: boolean }>, readonly errors?: Maybe<ReadonlyArray<{ readonly __typename?: 'ValidationError', readonly message: string }>> }> };

export type GetPresaleCourseDataQueryVariables = Exact<{
  email: Scalars['String'];
}>;


export type GetPresaleCourseDataQuery = { readonly __typename?: 'Query', readonly presaleLead?: Maybe<{ readonly __typename?: 'PresaleLead', readonly id: string, readonly email: string, readonly marketoUuid?: Maybe<string>, readonly courseCompletedAt?: Maybe<string>, readonly articleInteractions: { readonly __typename?: 'ArticleInteractionConnection', readonly nodes?: Maybe<ReadonlyArray<Maybe<{ readonly __typename?: 'ArticleInteraction', readonly id: string, readonly interactionType?: Maybe<ArticleInteractionType>, readonly interactionValue?: Maybe<string>, readonly article: { readonly __typename?: 'Article', readonly id: string, readonly contentfulId: string } }>>> } }> };

export type ProfileOrganizationFragment = { readonly __typename?: 'Organization', readonly id: string, readonly address?: Maybe<string>, readonly city: string, readonly state?: Maybe<string>, readonly zipCode?: Maybe<string>, readonly companyName: string, readonly businessEmail?: Maybe<string>, readonly businessPhone?: Maybe<string>, readonly logoUrl?: Maybe<string> };

export type ProfileContractorFragment = { readonly __typename?: 'Contractor', readonly id: string, readonly firstName: string, readonly lastName: string, readonly email: string, readonly phoneNumber: string, readonly admin: boolean };

export type GetProfileDataQueryVariables = Exact<{ [key: string]: never; }>;


export type GetProfileDataQuery = { readonly __typename?: 'Query', readonly organization?: Maybe<(
    { readonly __typename?: 'Organization', readonly id: string }
    & ProfileOrganizationFragment
  )>, readonly contractor?: Maybe<(
    { readonly __typename?: 'Contractor', readonly id: string }
    & ProfileContractorFragment
  )> };

export type UpdateOrganizationProfileMutationVariables = Exact<{
  attributes: OrganizationAttributes;
}>;


export type UpdateOrganizationProfileMutation = { readonly __typename?: 'Mutation', readonly upsertOrganization?: Maybe<{ readonly __typename?: 'UpsertOrganizationFailure', readonly errors: ReadonlyArray<{ readonly __typename?: 'InternalError', readonly message: string, readonly path?: Maybe<ReadonlyArray<string>>, readonly code: ErrorCodes } | { readonly __typename?: 'ValidationError', readonly message: string, readonly path?: Maybe<ReadonlyArray<string>>, readonly code: ErrorCodes }> } | { readonly __typename?: 'UpsertOrganizationSuccess', readonly organization: (
      { readonly __typename?: 'Organization', readonly id: string }
      & ProfileOrganizationFragment
    ) }> };

export type UpdateContractorProfileMutationVariables = Exact<{
  attributes: ContractorAttributes;
}>;


export type UpdateContractorProfileMutation = { readonly __typename?: 'Mutation', readonly upsertContractor?: Maybe<{ readonly __typename?: 'UpsertContractorFailure', readonly errors: ReadonlyArray<{ readonly __typename?: 'InternalError', readonly message: string, readonly path?: Maybe<ReadonlyArray<string>>, readonly code: ErrorCodes } | { readonly __typename?: 'ValidationError', readonly message: string, readonly path?: Maybe<ReadonlyArray<string>>, readonly code: ErrorCodes }> } | { readonly __typename?: 'UpsertContractorSuccess', readonly contractor: (
      { readonly __typename?: 'Contractor', readonly id: string }
      & ProfileContractorFragment
    ) }> };

export type FinancingFeedbackFragment = { readonly __typename?: 'HomeownerFeedbackResponse', readonly id: string, readonly hearthRating?: Maybe<number>, readonly contractorExperience?: Maybe<number>, readonly additionalFinancingFeedback?: Maybe<string>, readonly submittedAt?: Maybe<string>, readonly averageFinancingRating?: Maybe<number> };

export type PaymentsFeedbackFragment = { readonly __typename?: 'HomeownerFeedbackResponse', readonly id: string, readonly digitalPayments?: Maybe<number>, readonly workQuality?: Maybe<number>, readonly customerService?: Maybe<number>, readonly additionalPaymentsFeedback?: Maybe<string>, readonly submittedAt?: Maybe<string>, readonly averagePaymentsRating?: Maybe<number> };

export type GetHomeownerFeedbackInfoQueryVariables = Exact<{
  homeownerId: Scalars['String'];
}>;


export type GetHomeownerFeedbackInfoQuery = { readonly __typename?: 'Query', readonly homeowner?: Maybe<{ readonly __typename?: 'Homeowner', readonly id: string, readonly fullName: string, readonly homeownerPaymentsFeedback?: Maybe<(
      { readonly __typename?: 'HomeownerFeedbackResponse', readonly id: string }
      & PaymentsFeedbackFragment
    )>, readonly homeownerFinancingFeedback?: Maybe<(
      { readonly __typename?: 'HomeownerFeedbackResponse', readonly id: string }
      & FinancingFeedbackFragment
    )> }> };

export type GetReportingDataQueryVariables = Exact<{ [key: string]: never; }>;


export type GetReportingDataQuery = { readonly __typename?: 'Query', readonly contractor?: Maybe<{ readonly __typename?: 'Contractor', readonly id: string, readonly fullName: string, readonly email: string, readonly fullUrl: string, readonly homeownerFinancingFeedbackMetrics: { readonly __typename?: 'HomeownerFinancingFeedbackMetrics', readonly avgContractorSatisfaction?: Maybe<number>, readonly avgContractorSatisfactionDifference?: Maybe<number>, readonly avgHearthSatisfaction?: Maybe<number>, readonly avgHearthSatisfactionDifference?: Maybe<number> }, readonly homeownerPaymentsFeedbackMetrics: { readonly __typename?: 'HomeownerPaymentsFeedbackMetrics', readonly avgContractorSatisfaction?: Maybe<number>, readonly avgContractorSatisfactionDifference?: Maybe<number>, readonly avgHearthSatisfaction?: Maybe<number>, readonly avgHearthSatisfactionDifference?: Maybe<number> }, readonly homeownerFinancingFeedback: { readonly __typename?: 'HomeownerFeedbackResponseConnection', readonly nodes?: Maybe<ReadonlyArray<Maybe<{ readonly __typename?: 'HomeownerFeedbackResponse', readonly id: string, readonly homeownerId: string, readonly fullName: string, readonly submittedAt?: Maybe<string>, readonly contractorExperience?: Maybe<number>, readonly hearthRating?: Maybe<number>, readonly additionalFinancingFeedback?: Maybe<string> }>>> }, readonly homeownerPaymentsFeedback: { readonly __typename?: 'HomeownerFeedbackResponseConnection', readonly nodes?: Maybe<ReadonlyArray<Maybe<{ readonly __typename?: 'HomeownerFeedbackResponse', readonly id: string, readonly homeownerId: string, readonly fullName: string, readonly submittedAt?: Maybe<string>, readonly digitalPayments?: Maybe<number>, readonly workQuality?: Maybe<number>, readonly customerService?: Maybe<number>, readonly additionalPaymentsFeedback?: Maybe<string> }>>> } }> };

export type ContractTemplateInfoFragment = { readonly __typename?: 'ContractServiceContractTemplate', readonly id: string, readonly versionName?: Maybe<string>, readonly template: Record<string, any>, readonly updatedAt: string, readonly default?: Maybe<boolean>, readonly baseTemplate: { readonly __typename?: 'ContractServiceBaseTemplate', readonly id: string } };

export type GetContractTemplatesDetailsQueryVariables = Exact<{ [key: string]: never; }>;


export type GetContractTemplatesDetailsQuery = { readonly __typename?: 'Query', readonly organization?: Maybe<{ readonly __typename?: 'Organization', readonly id: string, readonly contractServiceAccount?: Maybe<{ readonly __typename?: 'ContractServiceAccount', readonly id: string, readonly latestVersionContractTemplates?: Maybe<{ readonly __typename?: 'ContractServiceContractTemplateConnection', readonly nodes?: Maybe<ReadonlyArray<Maybe<(
          { readonly __typename?: 'ContractServiceContractTemplate', readonly id: string }
          & ContractTemplateInfoFragment
        )>>> }> }> }>, readonly contractor?: Maybe<{ readonly __typename?: 'Contractor', readonly id: string }> };

export type CreateContractMutationVariables = Exact<{
  renderedHtml: Scalars['String'];
  homeownerId: Scalars['ID'];
  templateId: Scalars['ID'];
  mediums: ReadonlyArray<ContactMedium> | ContactMedium;
  attachedInvoiceParams?: Maybe<ConnectInvoiceParams>;
  dueDate: Scalars['ISO8601DateTime'];
  personalNote?: Maybe<Scalars['String']>;
  files?: Maybe<ReadonlyArray<File> | File>;
  renderArgs?: Maybe<Scalars['JSON']>;
  sendFinancingLink?: Maybe<Scalars['Boolean']>;
  name?: Maybe<Scalars['String']>;
}>;


export type CreateContractMutation = { readonly __typename?: 'Mutation', readonly contractServiceCreateContract?: Maybe<{ readonly __typename?: 'ContractServiceCreateContractFailure', readonly errors: ReadonlyArray<{ readonly __typename?: 'InternalError', readonly message: string, readonly path?: Maybe<ReadonlyArray<string>>, readonly code: ErrorCodes } | { readonly __typename?: 'ValidationError', readonly message: string, readonly path?: Maybe<ReadonlyArray<string>>, readonly code: ErrorCodes }> } | { readonly __typename?: 'ContractServiceCreateContractSuccess', readonly contractorSignatureToken: string, readonly contractServiceContract: { readonly __typename?: 'ContractServiceContract', readonly id: string }, readonly contractorSignature: { readonly __typename?: 'ContractServiceSignature', readonly id: string }, readonly attachedInvoice?: Maybe<{ readonly __typename?: 'ConnectInvoice', readonly id: string }> }> };

export type FetchContractorSignatureLinkMutationVariables = Exact<{
  contractServiceSignatureId: Scalars['ID'];
  signingToken: Scalars['String'];
}>;


export type FetchContractorSignatureLinkMutation = { readonly __typename?: 'Mutation', readonly contractServiceSigningLinkFetch?: Maybe<{ readonly __typename?: 'ContractServiceSigningLinkFetchFailure', readonly errors: ReadonlyArray<{ readonly __typename?: 'InternalError', readonly message: string, readonly path?: Maybe<ReadonlyArray<string>>, readonly code: ErrorCodes } | { readonly __typename?: 'ValidationError', readonly message: string, readonly path?: Maybe<ReadonlyArray<string>>, readonly code: ErrorCodes }> } | { readonly __typename?: 'ContractServiceSigningLinkFetchSuccess', readonly signatureLink: string, readonly contractServiceSignature: { readonly __typename?: 'ContractServiceSignature', readonly id: string, readonly contractServiceContract: { readonly __typename?: 'ContractServiceContract', readonly id: string, readonly projectContractHomeowner?: Maybe<{ readonly __typename?: 'Homeowner', readonly id: string }>, readonly attachedInvoice?: Maybe<{ readonly __typename?: 'ConnectInvoice', readonly id: string }> } } }> };

export type QuoteAssociateContractMutationVariables = Exact<{
  contractServiceContractId: Scalars['ID'];
  quoteId: Scalars['ID'];
}>;


export type QuoteAssociateContractMutation = { readonly __typename?: 'Mutation', readonly quoteAssociateContract?: Maybe<{ readonly __typename?: 'QuoteAssociateContractFailure', readonly errors: ReadonlyArray<{ readonly __typename?: 'InternalError', readonly message: string, readonly path?: Maybe<ReadonlyArray<string>>, readonly code: ErrorCodes } | { readonly __typename?: 'ValidationError', readonly message: string, readonly path?: Maybe<ReadonlyArray<string>>, readonly code: ErrorCodes }> } | { readonly __typename?: 'QuoteAssociateContractSuccess', readonly quote: { readonly __typename?: 'Quote', readonly id: string } }> };

export type GetTooltipNameFieldQueryVariables = Exact<{
  eventTypes?: Maybe<ReadonlyArray<HearthEventEventTypes> | HearthEventEventTypes>;
}>;


export type GetTooltipNameFieldQuery = { readonly __typename?: 'Query', readonly contractor?: Maybe<{ readonly __typename?: 'Contractor', readonly id: string, readonly hearthEvents: { readonly __typename?: 'HearthEventConnection', readonly totalCount: number } }> };

export type GetPersonalizedTemplateQueryVariables = Exact<{ [key: string]: never; }>;


export type GetPersonalizedTemplateQuery = { readonly __typename?: 'Query', readonly contractor?: Maybe<{ readonly __typename?: 'Contractor', readonly id: string, readonly sendFinancingLinkTemplate: { readonly __typename?: 'Template', readonly id: string, readonly templateString: string, readonly subject: string, readonly generatedTemplate: string } }> };

export type SubmitClientRequestFormMutationVariables = Exact<{
  homeownerId?: Maybe<Scalars['ID']>;
  homeownerAttributes?: Maybe<MinimalHomeownerAttributes>;
  invoiceAttributes?: Maybe<ReadonlyArray<ConnectInvoiceParams> | ConnectInvoiceParams>;
  financingAttributes?: Maybe<FinancingParams>;
  mediums: ReadonlyArray<ContactMedium> | ContactMedium;
  paymentIncludesFinancing?: Maybe<Scalars['Boolean']>;
}>;


export type SubmitClientRequestFormMutation = { readonly __typename?: 'Mutation', readonly clientAllInOneRequestForm?: Maybe<{ readonly __typename?: 'AllInOneRequestFormFailure', readonly errors: ReadonlyArray<{ readonly __typename?: 'InternalError', readonly code: ErrorCodes, readonly message: string, readonly path?: Maybe<ReadonlyArray<string>> } | { readonly __typename?: 'ValidationError', readonly code: ErrorCodes, readonly message: string, readonly path?: Maybe<ReadonlyArray<string>> }> } | { readonly __typename?: 'AllInOneRequestFormSuccess', readonly financingSent: boolean, readonly homeowner: { readonly __typename?: 'Homeowner', readonly id: string, readonly fullName: string, readonly financingStatus: HomeownerFinancingStatus, readonly contractor?: Maybe<{ readonly __typename?: 'Contractor', readonly id: string, readonly visibleConnectInvoices: { readonly __typename?: 'ConnectInvoiceConnection', readonly totalCount: number } }> }, readonly connectInvoices: { readonly __typename?: 'ConnectInvoiceConnection', readonly nodes?: Maybe<ReadonlyArray<Maybe<{ readonly __typename?: 'ConnectInvoice', readonly id: string, readonly customerPaysAchFee: boolean, readonly customerPaysCardFee: boolean, readonly scheduledFor?: Maybe<string> }>>> } }> };

export type SetCustomizeInvoiceBannerDismissedMutationVariables = Exact<{
  customSettings: CustomContractorSettingsAttributes;
}>;


export type SetCustomizeInvoiceBannerDismissedMutation = { readonly __typename?: 'Mutation', readonly upsertContractor?: Maybe<{ readonly __typename?: 'UpsertContractorFailure', readonly errors: ReadonlyArray<{ readonly __typename?: 'InternalError', readonly message: string, readonly path?: Maybe<ReadonlyArray<string>>, readonly code: ErrorCodes } | { readonly __typename?: 'ValidationError', readonly message: string, readonly path?: Maybe<ReadonlyArray<string>>, readonly code: ErrorCodes }> } | { readonly __typename?: 'UpsertContractorSuccess', readonly contractor: { readonly __typename?: 'Contractor', readonly id: string, readonly customSettings: { readonly __typename?: 'CustomContractorSettings', readonly customizeInvoiceBannerDismissed: boolean } } }> };

export type RequestFlowContractorFragment = { readonly __typename?: 'Contractor', readonly id: string, readonly demoMode: boolean, readonly hasEditedCustomizedInvoiceTemplate: boolean, readonly paymentsAdmin: boolean, readonly phoneNumber: string, readonly email: string, readonly fullName: string, readonly trainingCompleted: boolean, readonly firstUnblockedAt?: Maybe<string>, readonly customSettings: { readonly __typename?: 'CustomContractorSettings', readonly customizeInvoiceBannerDismissed: boolean } };

export type RequestFlowOrganizationFragment = { readonly __typename?: 'Organization', readonly id: string, readonly companyName: string, readonly fullAddress: string, readonly mailingAddress?: Maybe<string>, readonly mailingAddressLineTwo?: Maybe<string>, readonly address?: Maybe<string>, readonly city: string, readonly state?: Maybe<string>, readonly zipCode?: Maybe<string>, readonly businessLicenseNumber?: Maybe<string>, readonly logoUrl?: Maybe<string>, readonly stripeConnectAccount?: Maybe<{ readonly __typename?: 'StripeConnectAccount', readonly id: string, readonly achEnabled: boolean, readonly creditCardEnabled: boolean, readonly debitCardEnabled: boolean, readonly customerPaysCardFee: boolean, readonly customerPaysAchFee: boolean, readonly achFeeFixedAmount: number, readonly achFeePercentageAmount: number, readonly cardFeeFixedAmount: number, readonly cardFeePercentageAmount: number, readonly fullAccess: boolean, readonly requireStripeExternalAccount: boolean }> };

export type RequestFlowContractServiceContractTemplateFragment = { readonly __typename?: 'ContractServiceContractTemplate', readonly id: string, readonly template: Record<string, any> };

export type FetchHomeownerFlowValuesQueryVariables = Exact<{
  homeownerId?: Maybe<Scalars['String']>;
}>;


export type FetchHomeownerFlowValuesQuery = { readonly __typename?: 'Query', readonly contractor?: Maybe<(
    { readonly __typename?: 'Contractor', readonly id: string }
    & RequestFlowContractorFragment
  )>, readonly organization?: Maybe<(
    { readonly __typename?: 'Organization', readonly id: string }
    & RequestFlowOrganizationFragment
  )>, readonly homeowner?: Maybe<{ readonly __typename?: 'Homeowner', readonly id: string, readonly firstName: string, readonly lastName: string, readonly phoneNumber: string, readonly email: string, readonly defaultHomeownerAddress?: Maybe<{ readonly __typename?: 'HomeownerAddress', readonly id: string, readonly addressLineOne?: Maybe<string>, readonly addressLineTwo?: Maybe<string>, readonly city: string, readonly state?: Maybe<string>, readonly zipCode?: Maybe<string> }> }>, readonly contractServiceContractTemplate?: Maybe<(
    { readonly __typename?: 'ContractServiceContractTemplate', readonly id: string }
    & RequestFlowContractServiceContractTemplateFragment
  )> };

export type GenerateRequestFlowContractPreviewPdfMutationVariables = Exact<{
  html: Scalars['String'];
}>;


export type GenerateRequestFlowContractPreviewPdfMutation = { readonly __typename?: 'Mutation', readonly contractGeneratorRestGeneratePdf: { readonly __typename?: 'ContractGeneratorRestGeneratePdfResult', readonly pdf: string } };

export type UpsertArticleInteractionMutationVariables = Exact<{
  articleContentfulId?: Maybe<Scalars['String']>;
  interactionType: ArticleInteractionType;
  interactableType: ArticleInteractable;
  metadata?: Maybe<Scalars['JSON']>;
}>;


export type UpsertArticleInteractionMutation = { readonly __typename?: 'Mutation', readonly upsertArticleInteraction?: Maybe<{ readonly __typename?: 'UpsertArticleInteractionFailure', readonly errors: ReadonlyArray<{ readonly __typename?: 'InternalError', readonly code: ErrorCodes, readonly message: string } | { readonly __typename?: 'ValidationError', readonly code: ErrorCodes, readonly message: string }> } | { readonly __typename?: 'UpsertArticleInteractionSuccess', readonly articleInteraction: { readonly __typename?: 'ArticleInteraction', readonly id: string, readonly interactionType?: Maybe<ArticleInteractionType> } }> };

export type FetchContractorLifecycleQueryVariables = Exact<{ [key: string]: never; }>;


export type FetchContractorLifecycleQuery = { readonly __typename?: 'Query', readonly contractor?: Maybe<{ readonly __typename?: 'Contractor', readonly id: string, readonly learnCenterLifecycle: LearnCenterLifecycle }> };

export type CheckReturningApplicantQueryVariables = Exact<{
  hearthUid: Scalars['String'];
}>;


export type CheckReturningApplicantQuery = { readonly __typename?: 'Query', readonly hearthUidSelector?: Maybe<{ readonly __typename?: 'HearthUidSelector', readonly loanInquiries?: Maybe<{ readonly __typename?: 'LoanInquiryConnection', readonly nodes?: Maybe<ReadonlyArray<Maybe<{ readonly __typename?: 'LoanInquiry', readonly id: string, readonly createdAt: string, readonly qualified: boolean }>>> }> }> };

export type FindPreviousOffersQueryVariables = Exact<{
  email: Scalars['String'];
  date: Scalars['ISO8601DateTime'];
}>;


export type FindPreviousOffersQuery = { readonly __typename?: 'Query', readonly qualifiedLoanInquiries?: Maybe<{ readonly __typename?: 'LoanInquiryConnection', readonly nodes?: Maybe<ReadonlyArray<Maybe<{ readonly __typename?: 'LoanInquiry', readonly id: string, readonly projectType?: Maybe<string>, readonly hearthUid?: Maybe<string>, readonly loanPrincipal?: Maybe<number>, readonly createdAt: string, readonly contractor?: Maybe<{ readonly __typename?: 'Contractor', readonly id: string, readonly urlPath: string }> }>>> }> };

export type GetApiTokenQueryVariables = Exact<{ [key: string]: never; }>;


export type GetApiTokenQuery = { readonly __typename?: 'Query', readonly organization?: Maybe<{ readonly __typename?: 'Organization', readonly id: string, readonly apiToken?: Maybe<{ readonly __typename?: 'ApiToken', readonly id: string, readonly delimitedPlaintextKey: string }> }> };

export type ReminderFragment = { readonly __typename?: 'ReminderSetting', readonly id: string, readonly name: string, readonly settingName: string, readonly enabled: boolean, readonly medium?: Maybe<string> };

export type StripeCardSettingsFragment = { readonly __typename?: 'StripeCard', readonly id: string, readonly brand: string, readonly last4: string, readonly defaultForCurrency: boolean };

export type StripeBankAccountSettingsFragment = { readonly __typename?: 'StripeBankAccount', readonly id: string, readonly bankName: string, readonly last4: string, readonly defaultForCurrency: boolean };

export type GetHearthPaySettingsQueryVariables = Exact<{ [key: string]: never; }>;


export type GetHearthPaySettingsQuery = { readonly __typename?: 'Query', readonly organization?: Maybe<{ readonly __typename?: 'Organization', readonly id: string, readonly quickbooksBusiness?: Maybe<{ readonly __typename?: 'QuickbooksBusiness', readonly id: string, readonly autoSyncInvoices: boolean }>, readonly stripeConnectAccount?: Maybe<{ readonly __typename?: 'StripeConnectAccount', readonly id: string, readonly achEnabled: boolean, readonly creditCardEnabled: boolean, readonly debitCardEnabled: boolean, readonly achFeeFixedAmount: number, readonly cardFeeFixedAmount: number, readonly cardFeePercentageAmount: number, readonly customerPaysAchFee: boolean, readonly customerPaysCardFee: boolean, readonly allowPassingCreditCardFeesToCustomer: boolean, readonly externalTransferDestinations: { readonly __typename?: 'ExternalTransferDestinations', readonly standardDestinations: ReadonlyArray<(
          { readonly __typename?: 'StripeBankAccount', readonly id: string }
          & StripeBankAccountSettingsFragment
        ) | (
          { readonly __typename?: 'StripeCard', readonly id: string }
          & StripeCardSettingsFragment
        )> } }> }>, readonly contractor?: Maybe<{ readonly __typename?: 'Contractor', readonly id: string, readonly email: string, readonly role: string, readonly paymentReminders: boolean, readonly paymentsRole: PaymentsRole, readonly firstName: string, readonly contractorReminderSettings: ReadonlyArray<(
      { readonly __typename?: 'ReminderSetting', readonly id: string }
      & ReminderFragment
    )>, readonly homeownerReminderSettings: ReadonlyArray<(
      { readonly __typename?: 'ReminderSetting', readonly id: string }
      & ReminderFragment
    )> }>, readonly connectInvoices?: Maybe<{ readonly __typename?: 'ConnectInvoiceConnection', readonly nodes?: Maybe<ReadonlyArray<Maybe<{ readonly __typename?: 'ConnectInvoice', readonly id: string, readonly fullName: string, readonly amountRequested: number, readonly dueDate?: Maybe<string> }>>> }> };

export type UpdateAcceptedPaymentsMutationVariables = Exact<{
  attributes: AcceptedPaymentsAttributes;
}>;


export type UpdateAcceptedPaymentsMutation = { readonly __typename?: 'Mutation', readonly updateAcceptedPayments?: Maybe<{ readonly __typename?: 'UpdateAcceptedPaymentsFailure', readonly errors: ReadonlyArray<{ readonly __typename?: 'InternalError', readonly message: string, readonly path?: Maybe<ReadonlyArray<string>>, readonly code: ErrorCodes } | { readonly __typename?: 'ValidationError', readonly message: string, readonly path?: Maybe<ReadonlyArray<string>>, readonly code: ErrorCodes }> } | { readonly __typename?: 'UpdateAcceptedPaymentsSuccess', readonly stripeConnectAccount: { readonly __typename?: 'StripeConnectAccount', readonly id: string, readonly achEnabled: boolean, readonly creditCardEnabled: boolean, readonly debitCardEnabled: boolean, readonly customerPaysAchFee: boolean, readonly customerPaysCardFee: boolean } }> };

export type UpdateRemindersMutationVariables = Exact<{
  enable: Scalars['Boolean'];
  id: Scalars['ID'];
}>;


export type UpdateRemindersMutation = { readonly __typename?: 'Mutation', readonly updateReminderSetting?: Maybe<{ readonly __typename?: 'UpdateReminderSettingFailure', readonly errors: ReadonlyArray<{ readonly __typename?: 'InternalError', readonly message: string, readonly path?: Maybe<ReadonlyArray<string>>, readonly code: ErrorCodes } | { readonly __typename?: 'ValidationError', readonly message: string, readonly path?: Maybe<ReadonlyArray<string>>, readonly code: ErrorCodes }> } | { readonly __typename?: 'UpdateReminderSettingSuccess', readonly reminderSetting: { readonly __typename?: 'ReminderSetting', readonly id: string, readonly enabled: boolean, readonly name: string, readonly settingName: string } }> };

export type UpdateQuickbooksSyncSettingsMutationVariables = Exact<{
  quickbooksBusinessId: Scalars['ID'];
  settings: QuickbooksBusinessSettings;
}>;


export type UpdateQuickbooksSyncSettingsMutation = { readonly __typename?: 'Mutation', readonly updateQuickbooksSyncSettings?: Maybe<{ readonly __typename?: 'UpdateQuickbooksSyncSettingsFailure', readonly errors: ReadonlyArray<{ readonly __typename?: 'InternalError', readonly message: string, readonly path?: Maybe<ReadonlyArray<string>>, readonly code: ErrorCodes } | { readonly __typename?: 'ValidationError', readonly message: string, readonly path?: Maybe<ReadonlyArray<string>>, readonly code: ErrorCodes }> } | { readonly __typename?: 'UpdateQuickbooksSyncSettingsSuccess', readonly quickbooksBusiness: { readonly __typename?: 'QuickbooksBusiness', readonly id: string, readonly autoSyncInvoices: boolean } }> };

export type ExportPaymentDataMutationVariables = Exact<{
  type: ExportPaymentData;
}>;


export type ExportPaymentDataMutation = { readonly __typename?: 'Mutation', readonly exportPaymentData?: Maybe<{ readonly __typename?: 'ExportPaymentDataFailure', readonly errors: ReadonlyArray<{ readonly __typename?: 'InternalError', readonly message: string, readonly path?: Maybe<ReadonlyArray<string>>, readonly code: ErrorCodes } | { readonly __typename?: 'ValidationError', readonly message: string, readonly path?: Maybe<ReadonlyArray<string>>, readonly code: ErrorCodes }> } | { readonly __typename?: 'ExportPaymentDataSuccess', readonly contractor: { readonly __typename?: 'Contractor', readonly id: string } }> };

export type SettingsOrganizationFragment = { readonly __typename?: 'Organization', readonly id: string, readonly infoSetting: string, readonly requireContract: boolean, readonly rateCap?: Maybe<number>, readonly stripeConnectAccount?: Maybe<{ readonly __typename?: 'StripeConnectAccount', readonly id: string, readonly fullAccess: boolean }> };

export type SettingsContractorFragment = { readonly __typename?: 'Contractor', readonly id: string, readonly admin: boolean, readonly textNotifications: boolean, readonly emailNotifications: boolean, readonly demoMode: boolean };

export type GetSettingsDataQueryVariables = Exact<{ [key: string]: never; }>;


export type GetSettingsDataQuery = { readonly __typename?: 'Query', readonly organization?: Maybe<(
    { readonly __typename?: 'Organization', readonly id: string }
    & SettingsOrganizationFragment
  )>, readonly contractor?: Maybe<(
    { readonly __typename?: 'Contractor', readonly id: string }
    & SettingsContractorFragment
  )> };

export type UpdateOrganizationSettingsMutationVariables = Exact<{
  attributes: OrganizationAttributes;
}>;


export type UpdateOrganizationSettingsMutation = { readonly __typename?: 'Mutation', readonly upsertOrganization?: Maybe<{ readonly __typename?: 'UpsertOrganizationFailure', readonly errors: ReadonlyArray<{ readonly __typename?: 'InternalError', readonly message: string, readonly path?: Maybe<ReadonlyArray<string>>, readonly code: ErrorCodes } | { readonly __typename?: 'ValidationError', readonly message: string, readonly path?: Maybe<ReadonlyArray<string>>, readonly code: ErrorCodes }> } | { readonly __typename?: 'UpsertOrganizationSuccess', readonly organization: (
      { readonly __typename?: 'Organization', readonly id: string }
      & SettingsOrganizationFragment
    ) }> };

export type UpdateContractorSettingsMutationVariables = Exact<{
  attributes: ContractorAttributes;
}>;


export type UpdateContractorSettingsMutation = { readonly __typename?: 'Mutation', readonly upsertContractor?: Maybe<{ readonly __typename?: 'UpsertContractorFailure', readonly errors: ReadonlyArray<{ readonly __typename?: 'InternalError', readonly message: string, readonly path?: Maybe<ReadonlyArray<string>>, readonly code: ErrorCodes } | { readonly __typename?: 'ValidationError', readonly message: string, readonly path?: Maybe<ReadonlyArray<string>>, readonly code: ErrorCodes }> } | { readonly __typename?: 'UpsertContractorSuccess', readonly contractor: (
      { readonly __typename?: 'Contractor', readonly id: string }
      & SettingsContractorFragment
    ) }> };

export type SendResetPasswordLinkMutationVariables = Exact<{ [key: string]: never; }>;


export type SendResetPasswordLinkMutation = { readonly __typename?: 'Mutation', readonly sendResetPasswordLink?: Maybe<{ readonly __typename?: 'SendResetPasswordLinkFailure', readonly errors: ReadonlyArray<{ readonly __typename?: 'InternalError', readonly message: string, readonly path?: Maybe<ReadonlyArray<string>>, readonly code: ErrorCodes } | { readonly __typename?: 'ValidationError', readonly message: string, readonly path?: Maybe<ReadonlyArray<string>>, readonly code: ErrorCodes }> } | { readonly __typename?: 'SendResetPasswordLinkSuccess', readonly contractor: { readonly __typename?: 'Contractor', readonly id: string } }> };

export type GenerateApiTokenMutationVariables = Exact<{ [key: string]: never; }>;


export type GenerateApiTokenMutation = { readonly __typename?: 'Mutation', readonly generateApiToken?: Maybe<{ readonly __typename?: 'GenerateApiTokenFailure', readonly errors: ReadonlyArray<{ readonly __typename?: 'InternalError', readonly message: string, readonly path?: Maybe<ReadonlyArray<string>>, readonly code: ErrorCodes } | { readonly __typename?: 'ValidationError', readonly message: string, readonly path?: Maybe<ReadonlyArray<string>>, readonly code: ErrorCodes }> } | { readonly __typename?: 'GenerateApiTokenSuccess', readonly organization: { readonly __typename?: 'Organization', readonly id: string, readonly apiToken?: Maybe<{ readonly __typename?: 'ApiToken', readonly id: string, readonly delimitedPlaintextKey: string }> } }> };

export type UpdateTemplateMutationVariables = Exact<{
  templateId: Scalars['ID'];
  templateString: Scalars['String'];
}>;


export type UpdateTemplateMutation = { readonly __typename?: 'Mutation', readonly upsertTemplate?: Maybe<{ readonly __typename?: 'UpsertTemplateFailure', readonly errors: ReadonlyArray<{ readonly __typename?: 'InternalError', readonly message: string, readonly path?: Maybe<ReadonlyArray<string>>, readonly code: ErrorCodes } | { readonly __typename?: 'ValidationError', readonly message: string, readonly path?: Maybe<ReadonlyArray<string>>, readonly code: ErrorCodes }> } | { readonly __typename?: 'UpsertTemplateSuccess', readonly template: { readonly __typename?: 'Template', readonly id: string, readonly templateString: string } }> };

export type CreateLoanInquiryFromExistingMutationVariables = Exact<{
  loanInquiryUuid: Scalars['String'];
  terms: Scalars['Boolean'];
  termsString: Scalars['String'];
  loanPrincipal: Scalars['Int'];
}>;


export type CreateLoanInquiryFromExistingMutation = { readonly __typename?: 'Mutation', readonly createLoanInquiryFromExisting?: Maybe<{ readonly __typename?: 'CreateLoanInquiryFromExistingFailure', readonly errors: ReadonlyArray<{ readonly __typename?: 'InternalError', readonly code: ErrorCodes, readonly message: string } | { readonly __typename?: 'ValidationError', readonly code: ErrorCodes, readonly message: string }> } | { readonly __typename?: 'CreateLoanInquiryFromExistingSuccess', readonly loanInquiry: { readonly __typename?: 'LoanInquiry', readonly id: string, readonly state?: Maybe<string> } }> };

export type CreateAndSubmitLoanInquiryFromExistingMutationVariables = Exact<{
  loanInquiryUuid: Scalars['String'];
  terms: Scalars['Boolean'];
  termsString: Scalars['String'];
  loanPrincipal: Scalars['Int'];
}>;


export type CreateAndSubmitLoanInquiryFromExistingMutation = { readonly __typename?: 'Mutation', readonly createLoanInquiryFromExisting?: Maybe<{ readonly __typename?: 'CreateLoanInquiryFromExistingFailure', readonly errors: ReadonlyArray<{ readonly __typename?: 'InternalError', readonly code: ErrorCodes, readonly message: string } | { readonly __typename?: 'ValidationError', readonly code: ErrorCodes, readonly message: string }> } | { readonly __typename?: 'CreateLoanInquiryFromExistingSuccess', readonly loanInquiry: { readonly __typename?: 'LoanInquiry', readonly id: string } }> };

export type OfferDetailsFragment = { readonly __typename?: 'Offer', readonly id: string, readonly inMonthlyPaymentRange: boolean, readonly redirectUrl: string, readonly apr: string, readonly autopay?: Maybe<boolean>, readonly secure?: Maybe<boolean>, readonly lenderImageSlug: string, readonly loanTermInMonths: number, readonly loanAmount: number, readonly monthlyPayment: string, readonly score: number, readonly disclosure: string, readonly lenderName: string, readonly offerType: string };

export type GetOffersQueryVariables = Exact<{
  id: Scalars['String'];
}>;


export type GetOffersQuery = { readonly __typename?: 'Query', readonly loanInquiry?: Maybe<{ readonly __typename?: 'LoanInquiry', readonly id: string, readonly minOffer?: Maybe<number>, readonly maxOffer?: Maybe<number>, readonly fico?: Maybe<string>, readonly jointApplication: boolean, readonly loanPrincipal?: Maybe<number>, readonly requestedAmount?: Maybe<number>, readonly householdIncome?: Maybe<number>, readonly zeroPercentCards: boolean, readonly monthlyPaymentMin?: Maybe<number>, readonly monthlyPaymentMax?: Maybe<number>, readonly recommendedLoanAmount?: Maybe<number>, readonly rateCap?: Maybe<number>, readonly homeowner?: Maybe<{ readonly __typename?: 'Homeowner', readonly id: string, readonly firstName: string }>, readonly organization?: Maybe<{ readonly __typename?: 'Organization', readonly id: string, readonly featureFlags: ReadonlyArray<{ readonly __typename?: 'FeatureFlag', readonly id: string }>, readonly planFeatureFlags: ReadonlyArray<{ readonly __typename?: 'FeatureFlag', readonly id: string }> }>, readonly offers?: Maybe<{ readonly __typename?: 'OfferConnection', readonly nodes?: Maybe<ReadonlyArray<Maybe<(
        { readonly __typename?: 'Offer', readonly id: string }
        & OfferDetailsFragment
      )>>> }> }> };

export type PaymentProofFragment = { readonly __typename?: 'MonthlyPaymentCalculation', readonly id: string, readonly minApr: number, readonly loanTermInMonths: string };

export type GetPaymentProofDataQueryVariables = Exact<{
  ficoBucket: Scalars['String'];
  loanPrincipal: Scalars['Float'];
}>;


export type GetPaymentProofDataQuery = { readonly __typename?: 'Query', readonly monthlyPaymentCalculation?: Maybe<{ readonly __typename?: 'MonthlyPaymentCalculationConnection', readonly nodes?: Maybe<ReadonlyArray<Maybe<(
      { readonly __typename?: 'MonthlyPaymentCalculation', readonly id: string }
      & PaymentProofFragment
    )>>> }> };

export type TeamContractorFragment = { readonly __typename?: 'Contractor', readonly id: string, readonly firstName: string, readonly lastName: string, readonly phoneNumber: string, readonly role: string, readonly paymentsRole: PaymentsRole, readonly leadsCount: number, readonly fundedCount: number, readonly fundedAmount: number, readonly status: ContractorStatus, readonly email: string, readonly admin: boolean };

export type TeamMemberInviteFragment = { readonly __typename?: 'MemberInvite', readonly id: string, readonly email: string };

export type TeamOrganizationFragment = { readonly __typename?: 'Organization', readonly id: string, readonly availableSeats: number, readonly stripeConnectAccount?: Maybe<{ readonly __typename?: 'StripeConnectAccount', readonly id: string, readonly fullAccess: boolean }>, readonly contractors: { readonly __typename?: 'ContractorConnection', readonly nodes?: Maybe<ReadonlyArray<Maybe<(
      { readonly __typename?: 'Contractor', readonly id: string }
      & TeamContractorFragment
    )>>> }, readonly outstandingMemberInvites: { readonly __typename?: 'MemberInviteConnection', readonly nodes?: Maybe<ReadonlyArray<Maybe<(
      { readonly __typename?: 'MemberInvite', readonly id: string }
      & TeamMemberInviteFragment
    )>>> } };

export type GetTeamDataQueryVariables = Exact<{ [key: string]: never; }>;


export type GetTeamDataQuery = { readonly __typename?: 'Query', readonly organization?: Maybe<(
    { readonly __typename?: 'Organization', readonly id: string }
    & TeamOrganizationFragment
  )>, readonly contractor?: Maybe<{ readonly __typename?: 'Contractor', readonly id: string, readonly paymentsRole: PaymentsRole }> };

export type SendMemberInvitesMutationVariables = Exact<{
  emails: ReadonlyArray<Scalars['String']> | Scalars['String'];
}>;


export type SendMemberInvitesMutation = { readonly __typename?: 'Mutation', readonly sendMemberInvites?: Maybe<{ readonly __typename?: 'SendMemberInvitesFailure', readonly errors: ReadonlyArray<{ readonly __typename?: 'InternalError', readonly message: string, readonly path?: Maybe<ReadonlyArray<string>>, readonly code: ErrorCodes } | { readonly __typename?: 'ValidationError', readonly message: string, readonly path?: Maybe<ReadonlyArray<string>>, readonly code: ErrorCodes }> } | { readonly __typename?: 'SendMemberInvitesSuccess', readonly organization: (
      { readonly __typename?: 'Organization', readonly id: string }
      & TeamOrganizationFragment
    ) }> };

export type ResendMemberInviteEmailMutationVariables = Exact<{
  memberInviteId: Scalars['ID'];
}>;


export type ResendMemberInviteEmailMutation = { readonly __typename?: 'Mutation', readonly resendMemberInviteEmail?: Maybe<{ readonly __typename?: 'ResendMemberInviteEmailFailure', readonly errors: ReadonlyArray<{ readonly __typename?: 'InternalError', readonly message: string, readonly path?: Maybe<ReadonlyArray<string>>, readonly code: ErrorCodes } | { readonly __typename?: 'ValidationError', readonly message: string, readonly path?: Maybe<ReadonlyArray<string>>, readonly code: ErrorCodes }> } | { readonly __typename?: 'ResendMemberInviteEmailSuccess', readonly memberInvite: { readonly __typename?: 'MemberInvite', readonly id: string } }> };

export type DeactivateContractorMutationVariables = Exact<{
  contractorId: Scalars['ID'];
}>;


export type DeactivateContractorMutation = { readonly __typename?: 'Mutation', readonly deactivateContractor?: Maybe<{ readonly __typename?: 'DeactivateContractorFailure', readonly errors: ReadonlyArray<{ readonly __typename?: 'InternalError', readonly message: string, readonly path?: Maybe<ReadonlyArray<string>>, readonly code: ErrorCodes } | { readonly __typename?: 'ValidationError', readonly message: string, readonly path?: Maybe<ReadonlyArray<string>>, readonly code: ErrorCodes }> } | { readonly __typename?: 'DeactivateContractorSuccess', readonly organization: (
      { readonly __typename?: 'Organization', readonly id: string }
      & TeamOrganizationFragment
    ) }> };

export type UpdateContractorTeamMutationVariables = Exact<{
  contractorId: Scalars['ID'];
  attributes: ContractorAttributes;
}>;


export type UpdateContractorTeamMutation = { readonly __typename?: 'Mutation', readonly upsertContractor?: Maybe<{ readonly __typename?: 'UpsertContractorFailure', readonly errors: ReadonlyArray<{ readonly __typename?: 'InternalError', readonly message: string, readonly path?: Maybe<ReadonlyArray<string>>, readonly code: ErrorCodes } | { readonly __typename?: 'ValidationError', readonly message: string, readonly path?: Maybe<ReadonlyArray<string>>, readonly code: ErrorCodes }> } | { readonly __typename?: 'UpsertContractorSuccess', readonly contractor: (
      { readonly __typename?: 'Contractor', readonly id: string }
      & TeamContractorFragment
    ) }> };

export type CheckTermsAcceptanceQueryVariables = Exact<{ [key: string]: never; }>;


export type CheckTermsAcceptanceQuery = { readonly __typename?: 'Query', readonly organization?: Maybe<{ readonly __typename?: 'Organization', readonly id: string, readonly contractServiceAccount?: Maybe<{ readonly __typename?: 'ContractServiceAccount', readonly id: string, readonly termsAgreedAt?: Maybe<string> }> }> };

export type UpdateOrganizationWebsitesInfoMutationVariables = Exact<{
  attributes: OrganizationAttributes;
}>;


export type UpdateOrganizationWebsitesInfoMutation = { readonly __typename?: 'Mutation', readonly upsertOrganization?: Maybe<{ readonly __typename?: 'UpsertOrganizationFailure', readonly errors: ReadonlyArray<{ readonly __typename?: 'InternalError', readonly message: string, readonly path?: Maybe<ReadonlyArray<string>>, readonly code: ErrorCodes } | { readonly __typename?: 'ValidationError', readonly message: string, readonly path?: Maybe<ReadonlyArray<string>>, readonly code: ErrorCodes }> } | { readonly __typename?: 'UpsertOrganizationSuccess', readonly organization: { readonly __typename?: 'Organization', readonly id: string, readonly descriptionOfOperations?: Maybe<string>, readonly backgroundPicture?: Maybe<string> } }> };

export type GetToolsDataQueryVariables = Exact<{ [key: string]: never; }>;


export type GetToolsDataQuery = { readonly __typename?: 'Query', readonly contractor?: Maybe<{ readonly __typename?: 'Contractor', readonly id: string, readonly email: string, readonly admin: boolean, readonly activeCustomizedInvoiceTemplate?: Maybe<{ readonly __typename?: 'CustomizedInvoiceTemplate', readonly id: string, readonly createdAt: string }>, readonly sendFinancingLinkTemplate: { readonly __typename?: 'Template', readonly id: string, readonly templateString: string }, readonly signatureTemplate: { readonly __typename?: 'Template', readonly id: string, readonly templateString: string } }>, readonly organization?: Maybe<{ readonly __typename?: 'Organization', readonly id: string, readonly contractServiceAccount?: Maybe<{ readonly __typename?: 'ContractServiceAccount', readonly id: string, readonly termsAgreedAt?: Maybe<string> }> }> };

export type GetFinancingContractorQueryVariables = Exact<{ [key: string]: never; }>;


export type GetFinancingContractorQuery = { readonly __typename?: 'Query', readonly contractor?: Maybe<{ readonly __typename?: 'Contractor', readonly id: string }> };

export type GetFinancingClientsQueryVariables = Exact<{
  admin?: Maybe<Scalars['Boolean']>;
  type?: Maybe<HomeownerEventBucket>;
  orderBy?: Maybe<HomeownerOrderers>;
  searchTerm?: Maybe<Scalars['String']>;
  afterCursor?: Maybe<Scalars['String']>;
}>;


export type GetFinancingClientsQuery = { readonly __typename?: 'Query', readonly homeownerSearch: { readonly __typename?: 'HomeownerConnection', readonly totalCount: number, readonly edges?: Maybe<ReadonlyArray<Maybe<{ readonly __typename?: 'HomeownerEdge', readonly node?: Maybe<(
        { readonly __typename?: 'Homeowner', readonly id: string, readonly contractor?: Maybe<{ readonly __typename?: 'Contractor', readonly id: string }> }
        & WorkflowsClientFragment
      )> }>>>, readonly pageInfo: { readonly __typename?: 'PageInfo', readonly startCursor?: Maybe<string>, readonly endCursor?: Maybe<string>, readonly hasNextPage: boolean, readonly hasPreviousPage: boolean } } };

export type FinancingEventFragment = { readonly __typename?: 'HearthEvent', readonly id: string, readonly eventType: HearthEventEventTypes, readonly eventBody?: Maybe<Record<string, any>>, readonly eventAt: string };

export type WorkflowsClientFragment = { readonly __typename?: 'Homeowner', readonly id: string, readonly fullName: string, readonly hearthEvents: { readonly __typename?: 'HearthEventConnection', readonly nodes?: Maybe<ReadonlyArray<Maybe<(
      { readonly __typename?: 'HearthEvent', readonly id: string }
      & FinancingEventFragment
    )>>> } };

export type GetWorkflowsContainerQueryVariables = Exact<{ [key: string]: never; }>;


export type GetWorkflowsContainerQuery = { readonly __typename?: 'Query', readonly contractor?: Maybe<{ readonly __typename?: 'Contractor', readonly id: string, readonly demoMode: boolean }> };

export type WorkflowEmptyStateQueryVariables = Exact<{ [key: string]: never; }>;


export type WorkflowEmptyStateQuery = { readonly __typename?: 'Query', readonly organization?: Maybe<{ readonly __typename?: 'Organization', readonly id: string, readonly stripeConnectAccount?: Maybe<{ readonly __typename?: 'StripeConnectAccount', readonly id: string, readonly status: ConnectAccountStatus, readonly fullAccess: boolean }> }>, readonly contractor?: Maybe<{ readonly __typename?: 'Contractor', readonly id: string, readonly role: string, readonly paymentsRole: PaymentsRole, readonly trainingCompleted: boolean }> };

export type ClientViewContractDataFragment = { readonly __typename?: 'ContractServiceContract', readonly id: string, readonly status: ContractStatus, readonly dueDate: string, readonly createdAt: string, readonly contractNumber: number, readonly creatorId?: Maybe<string>, readonly receiverSignature: { readonly __typename?: 'ContractServiceSignature', readonly id: string, readonly signer: { readonly __typename?: 'ContractServiceSigner', readonly id: string, readonly fullName: string, readonly email: string } } };

export type GetWorkflowsDataQueryVariables = Exact<{ [key: string]: never; }>;


export type GetWorkflowsDataQuery = { readonly __typename?: 'Query', readonly contractor?: Maybe<{ readonly __typename?: 'Contractor', readonly id: string, readonly admin: boolean }>, readonly organization?: Maybe<{ readonly __typename?: 'Organization', readonly id: string, readonly contractServiceAccount?: Maybe<{ readonly __typename?: 'ContractServiceAccount', readonly id: string, readonly termsAgreedAt?: Maybe<string>, readonly contracts: { readonly __typename?: 'ContractServiceContractConnection', readonly nodes?: Maybe<ReadonlyArray<Maybe<(
          { readonly __typename?: 'ContractServiceContract', readonly id: string }
          & ClientViewContractIndexFragment
        )>>> } }> }> };

export type GetStartedOrganizationTemplateInfoFragment = { readonly __typename?: 'Organization', readonly id: string, readonly companyName: string, readonly businessEmail?: Maybe<string>, readonly businessPhone?: Maybe<string>, readonly fullAddress: string, readonly facebookUrl?: Maybe<string>, readonly twitterUrl?: Maybe<string>, readonly linkedinUrl?: Maybe<string>, readonly instagramUrl?: Maybe<string>, readonly website?: Maybe<string>, readonly logoUrl?: Maybe<string>, readonly kycBusiness?: Maybe<{ readonly __typename?: 'KycBusiness', readonly id: string, readonly url?: Maybe<string> }> };

export type GetStartedInvoiceCustomizationSettingsFragment = { readonly __typename?: 'CustomizedInvoiceTemplate', readonly id: string, readonly templateType: InvoiceTemplateType, readonly primaryColor: OrganizationTheme, readonly background: Background, readonly logo: boolean, readonly website: boolean, readonly signatureMessage?: Maybe<SignatureMessage>, readonly socialLinks: { readonly __typename?: 'SocialMediaLinks', readonly facebookUrl?: Maybe<boolean>, readonly twitterUrl?: Maybe<boolean>, readonly instagramUrl?: Maybe<boolean>, readonly linkedinUrl?: Maybe<boolean> } };

export type GetStartedContractorTemplateInfoFragment = { readonly __typename?: 'Contractor', readonly id: string, readonly fullName: string, readonly customizedInvoiceTemplates: { readonly __typename?: 'CustomizedInvoiceTemplateConnection', readonly totalCount: number }, readonly activeCustomizedInvoiceTemplate?: Maybe<(
    { readonly __typename?: 'CustomizedInvoiceTemplate', readonly id: string }
    & GetStartedInvoiceCustomizationSettingsFragment
  )> };

export type GetStartedCustomizedInvoiceTemplateInfoQueryVariables = Exact<{ [key: string]: never; }>;


export type GetStartedCustomizedInvoiceTemplateInfoQuery = { readonly __typename?: 'Query', readonly contractor?: Maybe<(
    { readonly __typename?: 'Contractor', readonly id: string }
    & GetStartedContractorTemplateInfoFragment
  )>, readonly organization?: Maybe<(
    { readonly __typename?: 'Organization', readonly id: string }
    & GetStartedOrganizationTemplateInfoFragment
  )> };

export type GetStartedCreateInvoiceTemplateMutationVariables = Exact<{
  attributes: CustomizedInvoiceTemplateAttributes;
}>;


export type GetStartedCreateInvoiceTemplateMutation = { readonly __typename?: 'Mutation', readonly upsertCustomizedInvoiceTemplate?: Maybe<{ readonly __typename?: 'UpsertCustomizedInvoiceTemplateFailure', readonly errors: ReadonlyArray<{ readonly __typename?: 'InternalError', readonly message: string, readonly path?: Maybe<ReadonlyArray<string>>, readonly code: ErrorCodes } | { readonly __typename?: 'ValidationError', readonly message: string, readonly path?: Maybe<ReadonlyArray<string>>, readonly code: ErrorCodes }> } | { readonly __typename?: 'UpsertCustomizedInvoiceTemplateSuccess', readonly invoiceTemplate: (
      { readonly __typename?: 'CustomizedInvoiceTemplate', readonly id: string }
      & GetStartedInvoiceCustomizationSettingsFragment
    ) }> };

export type GetStartedContractorFragment = { readonly __typename?: 'Contractor', readonly id: string, readonly admin: boolean, readonly trainingCompleted: boolean, readonly firstAppLoginAt?: Maybe<string> };

export type GetStartedOrganizationFragment = { readonly __typename?: 'Organization', readonly id: string, readonly logo?: Maybe<string>, readonly bannerInstalledAt?: Maybe<string> };

export type GetGetStartedDataQueryVariables = Exact<{ [key: string]: never; }>;


export type GetGetStartedDataQuery = { readonly __typename?: 'Query', readonly contractor?: Maybe<(
    { readonly __typename?: 'Contractor', readonly id: string }
    & GetStartedContractorFragment
  )>, readonly organization?: Maybe<(
    { readonly __typename?: 'Organization', readonly id: string }
    & GetStartedOrganizationFragment
  )> };

export type QuickActionsContractorDataFragment = { readonly __typename?: 'Contractor', readonly id: string, readonly admin: boolean, readonly paymentsAdmin: boolean, readonly paymentsRole: PaymentsRole };

export type QuickActionsOrganizationDataFragment = { readonly __typename?: 'Organization', readonly id: string, readonly stripeConnectAccount?: Maybe<{ readonly __typename?: 'StripeConnectAccount', readonly id: string, readonly status: ConnectAccountStatus }>, readonly contractServiceAccount?: Maybe<{ readonly __typename?: 'ContractServiceAccount', readonly id: string, readonly termsAgreedAt?: Maybe<string> }> };

export type GetQuickActionsMenuDataQueryVariables = Exact<{ [key: string]: never; }>;


export type GetQuickActionsMenuDataQuery = { readonly __typename?: 'Query', readonly contractor?: Maybe<(
    { readonly __typename?: 'Contractor', readonly id: string }
    & QuickActionsContractorDataFragment
  )>, readonly organization?: Maybe<(
    { readonly __typename?: 'Organization', readonly id: string }
    & QuickActionsOrganizationDataFragment
  )> };

export type HomeownerQuoteViewContractorFragment = { readonly __typename?: 'Contractor', readonly id: string, readonly fullName: string, readonly phoneNumber: string, readonly email: string, readonly fullUrl: string };

export type HomeownerQuoteViewOrganizationFragment = { readonly __typename?: 'Organization', readonly id: string, readonly companyName: string, readonly logoUrl?: Maybe<string>, readonly address?: Maybe<string>, readonly addressLine2?: Maybe<string>, readonly state?: Maybe<string>, readonly city: string, readonly zipCode?: Maybe<string>, readonly businessPhone?: Maybe<string>, readonly businessEmail?: Maybe<string>, readonly businessLicenseNumber?: Maybe<string> };

export type HomeownerQuoteViewHomeownerAddressFragment = { readonly __typename?: 'HomeownerAddress', readonly id: string, readonly addressLineOne?: Maybe<string>, readonly addressLineTwo?: Maybe<string>, readonly city: string, readonly state?: Maybe<string>, readonly zipCode?: Maybe<string>, readonly homeowner: { readonly __typename?: 'Homeowner', readonly id: string, readonly fullName: string, readonly firstName: string, readonly lastName: string, readonly phoneNumber: string, readonly email: string, readonly contractor?: Maybe<(
      { readonly __typename?: 'Contractor' }
      & HomeownerQuoteViewContractorFragment
    )>, readonly organization?: Maybe<(
      { readonly __typename?: 'Organization' }
      & HomeownerQuoteViewOrganizationFragment
    )> } };

export type HomeownerQuoteViewLineItemFragment = { readonly __typename?: 'QuoteLineItem', readonly id: string, readonly description: string, readonly name: string, readonly priceInCents: number, readonly quantity: number, readonly totalInCents: number };

export type HomeownerQuoteViewPhotoFragment = { readonly __typename?: 'QuoteUpload', readonly id: string, readonly displayLink: string, readonly filename: string };

export type HomeownerQuoteViewPhotosFragment = { readonly __typename?: 'Quote', readonly id: string, readonly photos: { readonly __typename?: 'QuoteUploadConnection', readonly nodes?: Maybe<ReadonlyArray<Maybe<(
      { readonly __typename?: 'QuoteUpload' }
      & HomeownerQuoteViewPhotoFragment
    )>>> } };

export type HomeownerQuoteViewDocumentFragment = { readonly __typename?: 'QuoteUpload', readonly id: string, readonly filename: string, readonly displayLink: string, readonly downloadLink: string };

export type HomeownerQuoteDocumentsFragment = { readonly __typename?: 'Quote', readonly id: string, readonly documents: { readonly __typename?: 'QuoteUploadConnection', readonly nodes?: Maybe<ReadonlyArray<Maybe<(
      { readonly __typename?: 'QuoteUpload' }
      & HomeownerQuoteViewDocumentFragment
    )>>> } };

export type HomeownerQuoteViewQuoteFragment = (
  { readonly __typename?: 'Quote', readonly id: string, readonly name: string, readonly quoteNumber: number, readonly status: QuoteStatus, readonly createdAt: string, readonly expiresAt: string, readonly canceledAt?: Maybe<string>, readonly decisionAt?: Maybe<string>, readonly description: string, readonly personalNote?: Maybe<string>, readonly discountInCents: number, readonly totalFeesInCents: number, readonly totalTaxInCents: number, readonly totalInCents: number, readonly showFinancing: boolean, readonly changesRequested?: Maybe<string>, readonly latestQuote?: Maybe<{ readonly __typename?: 'Quote', readonly id: string }>, readonly priorQuote?: Maybe<{ readonly __typename?: 'Quote', readonly id: string }>, readonly lineItems: ReadonlyArray<(
    { readonly __typename?: 'QuoteLineItem', readonly id: string }
    & HomeownerQuoteViewLineItemFragment
  )>, readonly homeownerAddress: (
    { readonly __typename?: 'HomeownerAddress', readonly id: string }
    & HomeownerQuoteViewHomeownerAddressFragment
  ) }
  & HomeownerQuoteDocumentsFragment
  & HomeownerQuoteViewPhotosFragment
);

export type GetHomeownerQuoteViewDataQueryVariables = Exact<{
  quoteId: Scalars['ID'];
}>;


export type GetHomeownerQuoteViewDataQuery = { readonly __typename?: 'Query', readonly quote?: Maybe<(
    { readonly __typename?: 'Quote', readonly id: string }
    & HomeownerQuoteViewQuoteFragment
  )> };

export type AcceptHomeownerQuoteMutationVariables = Exact<{
  id: Scalars['ID'];
}>;


export type AcceptHomeownerQuoteMutation = { readonly __typename?: 'Mutation', readonly quoteHomeownerAccept?: Maybe<{ readonly __typename?: 'QuoteHomeownerAcceptFailure', readonly errors: ReadonlyArray<{ readonly __typename?: 'InternalError', readonly message: string, readonly path?: Maybe<ReadonlyArray<string>>, readonly code: ErrorCodes } | { readonly __typename?: 'ValidationError', readonly message: string, readonly path?: Maybe<ReadonlyArray<string>>, readonly code: ErrorCodes }> } | { readonly __typename?: 'QuoteHomeownerAcceptSuccess', readonly quote: (
      { readonly __typename?: 'Quote', readonly id: string }
      & HomeownerQuoteViewQuoteFragment
    ) }> };

export type RequestChangesHomeownerQuoteMutationVariables = Exact<{
  id: Scalars['ID'];
  changesRequested: Scalars['String'];
}>;


export type RequestChangesHomeownerQuoteMutation = { readonly __typename?: 'Mutation', readonly quoteHomeownerRequestChanges?: Maybe<{ readonly __typename?: 'QuoteHomeownerRequestChangesFailure', readonly errors: ReadonlyArray<{ readonly __typename?: 'InternalError', readonly message: string, readonly path?: Maybe<ReadonlyArray<string>>, readonly code: ErrorCodes } | { readonly __typename?: 'ValidationError', readonly message: string, readonly path?: Maybe<ReadonlyArray<string>>, readonly code: ErrorCodes }> } | { readonly __typename?: 'QuoteHomeownerRequestChangesSuccess' }> };

export type QuoteViewedMutationVariables = Exact<{
  quoteId: Scalars['ID'];
  contractorId: Scalars['ID'];
}>;


export type QuoteViewedMutation = { readonly __typename?: 'Mutation', readonly quoteViewed?: Maybe<{ readonly __typename?: 'QuoteViewedFailure', readonly errors: ReadonlyArray<{ readonly __typename?: 'InternalError', readonly message: string, readonly path?: Maybe<ReadonlyArray<string>>, readonly code: ErrorCodes } | { readonly __typename?: 'ValidationError', readonly message: string, readonly path?: Maybe<ReadonlyArray<string>>, readonly code: ErrorCodes }> } | { readonly __typename?: 'QuoteViewedSuccess' }> };

export type QuoteRequestFlowOrganizationFragment = (
  { readonly __typename?: 'Organization', readonly id: string, readonly quoteAccount?: Maybe<{ readonly __typename?: 'QuoteAccount', readonly id: string, readonly quoteTemplates: { readonly __typename?: 'QuoteTemplateConnection', readonly nodes?: Maybe<ReadonlyArray<Maybe<{ readonly __typename?: 'QuoteTemplate', readonly id: string }>>> } }> }
  & HomeownerQuoteViewOrganizationFragment
);

export type QuoteRequestFlowContractorFragment = (
  { readonly __typename?: 'Contractor', readonly id: string, readonly trainingCompleted: boolean, readonly firstUnblockedAt?: Maybe<string> }
  & HomeownerQuoteViewContractorFragment
);

export type QuoteRequestFlowHomeownerFragment = (
  { readonly __typename?: 'Homeowner', readonly id: string }
  & AddClientFieldGroupHomeownerFragment
);

export type QuoteRequestFlowQuoteTemplateLineItemFragment = { readonly __typename?: 'QuoteTemplateLineItem', readonly id: string, readonly name: string, readonly priceInCents: number, readonly description: string, readonly quantity: number, readonly totalInCents: number };

export type GetQuoteRequestFlowDataQueryVariables = Exact<{
  homeownerId?: Maybe<Scalars['String']>;
}>;


export type GetQuoteRequestFlowDataQuery = { readonly __typename?: 'Query', readonly organization?: Maybe<(
    { readonly __typename?: 'Organization', readonly id: string }
    & QuoteRequestFlowOrganizationFragment
  )>, readonly contractor?: Maybe<(
    { readonly __typename?: 'Contractor', readonly id: string }
    & QuoteRequestFlowContractorFragment
  )>, readonly homeowner?: Maybe<(
    { readonly __typename?: 'Homeowner', readonly id: string }
    & QuoteRequestFlowHomeownerFragment
  )> };

export type QuoteRequestFlowCreateQuoteMutationVariables = Exact<{
  name: Scalars['String'];
  description: Scalars['String'];
  personalNote?: Maybe<Scalars['String']>;
  theme: OrganizationTheme;
  quoteTemplateId: Scalars['ID'];
  homeownerAddressId: Scalars['ID'];
  photoUploadIds: ReadonlyArray<Scalars['ID']> | Scalars['ID'];
  documentUploadIds: ReadonlyArray<Scalars['ID']> | Scalars['ID'];
  lineItems: ReadonlyArray<QuoteLineItemParams> | QuoteLineItemParams;
  totalTaxInCents: Scalars['Int'];
  totalFeesInCents: Scalars['Int'];
  discountInCents: Scalars['Int'];
  expiresAt: Scalars['ISO8601DateTime'];
  showFinancing: Scalars['Boolean'];
  priorQuoteId?: Maybe<Scalars['ID']>;
  mediums: ReadonlyArray<ContactMedium> | ContactMedium;
}>;


export type QuoteRequestFlowCreateQuoteMutation = { readonly __typename?: 'Mutation', readonly quoteCreate?: Maybe<{ readonly __typename?: 'QuoteCreateFailure', readonly errors: ReadonlyArray<{ readonly __typename?: 'InternalError', readonly message: string, readonly path?: Maybe<ReadonlyArray<string>>, readonly code: ErrorCodes } | { readonly __typename?: 'ValidationError', readonly message: string, readonly path?: Maybe<ReadonlyArray<string>>, readonly code: ErrorCodes }> } | { readonly __typename?: 'QuoteCreateSuccess', readonly quote: { readonly __typename?: 'Quote', readonly id: string, readonly name: string, readonly showFinancing: boolean, readonly priorQuote?: Maybe<{ readonly __typename?: 'Quote', readonly id: string }>, readonly homeownerAddress: { readonly __typename?: 'HomeownerAddress', readonly id: string, readonly homeowner: { readonly __typename?: 'Homeowner', readonly id: string } } } }> };

export type QuoteUploadCreateMutationVariables = Exact<{
  quoteAccountId: Scalars['ID'];
  uploadType: Scalars['ID'];
  filename: Scalars['ID'];
  base64String: Scalars['ID'];
}>;


export type QuoteUploadCreateMutation = { readonly __typename?: 'Mutation', readonly quoteUploadCreate?: Maybe<{ readonly __typename?: 'QuoteUploadCreateFailure', readonly errors: ReadonlyArray<{ readonly __typename?: 'InternalError', readonly message: string, readonly path?: Maybe<ReadonlyArray<string>>, readonly code: ErrorCodes } | { readonly __typename?: 'ValidationError', readonly message: string, readonly path?: Maybe<ReadonlyArray<string>>, readonly code: ErrorCodes }> } | { readonly __typename?: 'QuoteUploadCreateSuccess', readonly quoteUpload: { readonly __typename?: 'QuoteUpload', readonly id: string, readonly displayLink: string, readonly downloadLink: string } }> };

export type QuoteWorkflowContractorFragment = { readonly __typename?: 'Contractor', readonly id: string, readonly admin: boolean, readonly fullName: string, readonly phoneNumber: string, readonly email: string, readonly fullUrl: string, readonly trainingCompleted: boolean, readonly firstUnblockedAt?: Maybe<string> };

export type QuoteWorkflowOrganizationFragment = { readonly __typename?: 'Organization', readonly id: string, readonly companyName: string, readonly logoUrl?: Maybe<string>, readonly address?: Maybe<string>, readonly addressLine2?: Maybe<string>, readonly state?: Maybe<string>, readonly city: string, readonly zipCode?: Maybe<string>, readonly businessPhone?: Maybe<string>, readonly businessEmail?: Maybe<string>, readonly businessLicenseNumber?: Maybe<string>, readonly quoteAccount?: Maybe<{ readonly __typename?: 'QuoteAccount', readonly id: string }> };

export type QuoteWorkflowHomeownerFragment = { readonly __typename?: 'Homeowner', readonly id: string, readonly fullName: string };

export type QuoteWorkflowHomeownerAddressFragment = { readonly __typename?: 'HomeownerAddress', readonly id: string, readonly homeowner: (
    { readonly __typename?: 'Homeowner' }
    & QuoteWorkflowHomeownerFragment
  ) };

export type QuoteWorkflowQuoteFragment = { readonly __typename?: 'Quote', readonly id: string, readonly name: string, readonly quoteNumber: number, readonly status: QuoteStatus, readonly createdAt: string, readonly expiresAt: string, readonly canceledAt?: Maybe<string>, readonly totalInCents: number, readonly contractor: (
    { readonly __typename?: 'Contractor', readonly id: string }
    & QuoteWorkflowContractorFragment
  ), readonly homeownerAddress: (
    { readonly __typename?: 'HomeownerAddress', readonly id: string }
    & QuoteWorkflowHomeownerAddressFragment
  ), readonly priorQuote?: Maybe<{ readonly __typename?: 'Quote', readonly id: string }> };

export type GetOrganizationQuotesQueryVariables = Exact<{
  admin: Scalars['Boolean'];
  status?: Maybe<ReadonlyArray<QuoteStatus> | QuoteStatus>;
  homeownerSearch?: Maybe<Scalars['String']>;
}>;


export type GetOrganizationQuotesQuery = { readonly __typename?: 'Query', readonly organization?: Maybe<{ readonly __typename?: 'Organization', readonly id: string, readonly quoteAccount?: Maybe<{ readonly __typename?: 'QuoteAccount', readonly id: string, readonly quotes: { readonly __typename?: 'QuoteConnection', readonly nodes?: Maybe<ReadonlyArray<Maybe<(
          { readonly __typename?: 'Quote', readonly id: string }
          & QuoteWorkflowQuoteFragment
        )>>> } }> }> };

export type GetQuotesWorkflowContractorAndOrgQueryVariables = Exact<{ [key: string]: never; }>;


export type GetQuotesWorkflowContractorAndOrgQuery = { readonly __typename?: 'Query', readonly contractor?: Maybe<(
    { readonly __typename?: 'Contractor' }
    & QuoteWorkflowContractorFragment
  )>, readonly organization?: Maybe<(
    { readonly __typename?: 'Organization' }
    & QuoteWorkflowOrganizationFragment
  )> };

export type QuoteAccountCreateMutationVariables = Exact<{
  termsString: Scalars['String'];
}>;


export type QuoteAccountCreateMutation = { readonly __typename?: 'Mutation', readonly quoteAccountCreate?: Maybe<{ readonly __typename?: 'QuoteAccountCreateFailure', readonly errors: ReadonlyArray<{ readonly __typename?: 'InternalError', readonly message: string, readonly path?: Maybe<ReadonlyArray<string>>, readonly code: ErrorCodes } | { readonly __typename?: 'ValidationError', readonly message: string, readonly path?: Maybe<ReadonlyArray<string>>, readonly code: ErrorCodes }> } | { readonly __typename?: 'QuoteAccountCreateSuccess', readonly quoteAccount: { readonly __typename?: 'QuoteAccount', readonly id: string } }> };

export type QuoteTemplateCreateMutationVariables = Exact<{
  name: Scalars['String'];
  description: Scalars['String'];
  theme: QuoteTheme;
  totalTaxInCents: Scalars['Int'];
  totalFeesInCents: Scalars['Int'];
  discountInCents: Scalars['Int'];
  lineItems: ReadonlyArray<TemplateLineItemParams> | TemplateLineItemParams;
}>;


export type QuoteTemplateCreateMutation = { readonly __typename?: 'Mutation', readonly quoteTemplateCreate?: Maybe<{ readonly __typename?: 'QuoteTemplateCreateFailure', readonly errors: ReadonlyArray<{ readonly __typename?: 'InternalError', readonly message: string, readonly path?: Maybe<ReadonlyArray<string>>, readonly code: ErrorCodes } | { readonly __typename?: 'ValidationError', readonly message: string, readonly path?: Maybe<ReadonlyArray<string>>, readonly code: ErrorCodes }> } | { readonly __typename?: 'QuoteTemplateCreateSuccess', readonly quoteTemplate: { readonly __typename?: 'QuoteTemplate', readonly id: string } }> };

export type GetContractorWebinarPickerDataQueryVariables = Exact<{ [key: string]: never; }>;


export type GetContractorWebinarPickerDataQuery = { readonly __typename?: 'Query', readonly contractor?: Maybe<{ readonly __typename?: 'Contractor', readonly id: string, readonly trainingScheduledAt?: Maybe<string>, readonly firstName: string }> };

export type OnboardingContractorFragment = { readonly __typename?: 'Contractor', readonly id: string, readonly enterpriseAdmin: boolean, readonly passwordSet: boolean, readonly firstPasswordSetAt?: Maybe<string>, readonly firstName: string, readonly lastName: string };

export type OnboardingOrganizationFragment = { readonly __typename?: 'Organization', readonly id: string, readonly setupFlowCompleted: boolean, readonly kycSkippedAt?: Maybe<string>, readonly subscriptionContract: { readonly __typename?: 'SubscriptionContract', readonly status: string, readonly toBeSignedContract?: Maybe<{ readonly __typename?: 'SignedContract', readonly id: string, readonly html: string, readonly text: string }> }, readonly stripeConnectAccount?: Maybe<{ readonly __typename?: 'StripeConnectAccount', readonly id: string, readonly status: ConnectAccountStatus }> };

export type GetOnboardingDataQueryVariables = Exact<{ [key: string]: never; }>;


export type GetOnboardingDataQuery = { readonly __typename?: 'Query', readonly contractor?: Maybe<(
    { readonly __typename?: 'Contractor', readonly id: string }
    & OnboardingContractorFragment
  )>, readonly organization?: Maybe<(
    { readonly __typename?: 'Organization', readonly id: string }
    & OnboardingOrganizationFragment
  )> };

export type OnboardingSignAccountContractMutationVariables = Exact<{
  contractId: Scalars['ID'];
}>;


export type OnboardingSignAccountContractMutation = { readonly __typename?: 'Mutation', readonly signAccountContract?: Maybe<{ readonly __typename?: 'SignAccountContractFailure', readonly errors: ReadonlyArray<{ readonly __typename?: 'InternalError', readonly message: string, readonly path?: Maybe<ReadonlyArray<string>>, readonly code: ErrorCodes } | { readonly __typename?: 'ValidationError', readonly message: string, readonly path?: Maybe<ReadonlyArray<string>>, readonly code: ErrorCodes }> } | { readonly __typename?: 'SignAccountContractSuccess', readonly organization: (
      { readonly __typename?: 'Organization', readonly id: string }
      & OnboardingOrganizationFragment
    ) }> };

export type OnboardingUpdateContractorMutationVariables = Exact<{
  attributes: ContractorAttributes;
}>;


export type OnboardingUpdateContractorMutation = { readonly __typename?: 'Mutation', readonly upsertContractor?: Maybe<{ readonly __typename?: 'UpsertContractorFailure', readonly errors: ReadonlyArray<{ readonly __typename?: 'InternalError', readonly message: string, readonly path?: Maybe<ReadonlyArray<string>>, readonly code: ErrorCodes } | { readonly __typename?: 'ValidationError', readonly message: string, readonly path?: Maybe<ReadonlyArray<string>>, readonly code: ErrorCodes }> } | { readonly __typename?: 'UpsertContractorSuccess', readonly contractor: (
      { readonly __typename?: 'Contractor', readonly id: string }
      & OnboardingContractorFragment
    ) }> };

export type OnboardingUpdateOrganizationMutationVariables = Exact<{
  attributes: OrganizationAttributes;
}>;


export type OnboardingUpdateOrganizationMutation = { readonly __typename?: 'Mutation', readonly upsertOrganization?: Maybe<{ readonly __typename?: 'UpsertOrganizationFailure', readonly errors: ReadonlyArray<{ readonly __typename?: 'InternalError', readonly message: string, readonly path?: Maybe<ReadonlyArray<string>>, readonly code: ErrorCodes } | { readonly __typename?: 'ValidationError', readonly message: string, readonly path?: Maybe<ReadonlyArray<string>>, readonly code: ErrorCodes }> } | { readonly __typename?: 'UpsertOrganizationSuccess', readonly organization: (
      { readonly __typename?: 'Organization', readonly id: string }
      & OnboardingOrganizationFragment
    ) }> };

export type OnboardingRecordDashboardPersonalizationAnswersMutationVariables = Exact<{
  response: ReadonlyArray<HearthOnboardingResponseAttributes> | HearthOnboardingResponseAttributes;
}>;


export type OnboardingRecordDashboardPersonalizationAnswersMutation = { readonly __typename?: 'Mutation', readonly recordPersonalizeDashboardResponse?: Maybe<{ readonly __typename?: 'RecordHearthOnboardingPersonalizeDashboardResponseFailure', readonly errors: ReadonlyArray<{ readonly __typename?: 'InternalError', readonly message: string, readonly path?: Maybe<ReadonlyArray<string>>, readonly code: ErrorCodes } | { readonly __typename?: 'ValidationError', readonly message: string, readonly path?: Maybe<ReadonlyArray<string>>, readonly code: ErrorCodes }> } | { readonly __typename?: 'RecordHearthOnboardingPersonalizeDashboardResponseSuccess', readonly questionnaireResponse?: Maybe<{ readonly __typename?: 'QuestionnaireResponse', readonly id: string }> }> };

export type UpdateSetSeatsPasswordMutationVariables = Exact<{
  id: Scalars['ID'];
  attributes: ContractorAttributes;
}>;


export type UpdateSetSeatsPasswordMutation = { readonly __typename?: 'Mutation', readonly updateContractor?: Maybe<{ readonly __typename?: 'UpdateContractorPayload', readonly contractor?: Maybe<{ readonly __typename?: 'Contractor', readonly id: string, readonly firstPasswordSetAt?: Maybe<string>, readonly passwordSet: boolean }>, readonly errors?: Maybe<ReadonlyArray<{ readonly __typename?: 'ValidationError', readonly message: string, readonly path?: Maybe<ReadonlyArray<string>> }>> }> };

export type GetOrgLogoQueryVariables = Exact<{
  orgUuid: Scalars['ID'];
}>;


export type GetOrgLogoQuery = { readonly __typename?: 'Query', readonly organization?: Maybe<{ readonly __typename?: 'Organization', readonly id: string, readonly logoUrl?: Maybe<string> }> };

export type FetchHomeownerSignatureLinkMutationVariables = Exact<{
  contractServiceSignatureId: Scalars['ID'];
  signingToken: Scalars['String'];
}>;


export type FetchHomeownerSignatureLinkMutation = { readonly __typename?: 'Mutation', readonly contractServiceSigningLinkFetch?: Maybe<{ readonly __typename?: 'ContractServiceSigningLinkFetchFailure', readonly errors: ReadonlyArray<{ readonly __typename?: 'InternalError', readonly message: string, readonly path?: Maybe<ReadonlyArray<string>>, readonly code: ErrorCodes } | { readonly __typename?: 'ValidationError', readonly message: string, readonly path?: Maybe<ReadonlyArray<string>>, readonly code: ErrorCodes }> } | { readonly __typename?: 'ContractServiceSigningLinkFetchSuccess', readonly signatureLink: string }> };

export type FetchContractServiceSignatureQueryVariables = Exact<{
  contractServiceSignatureId: Scalars['ID'];
  signingToken: Scalars['String'];
}>;


export type FetchContractServiceSignatureQuery = { readonly __typename?: 'Query', readonly contractServiceSignature?: Maybe<{ readonly __typename?: 'ContractServiceSignature', readonly id: string, readonly status: SignatureStatus, readonly contractServiceSigner: { readonly __typename?: 'ContractServiceSigner', readonly id: string, readonly fullName: string, readonly email: string, readonly homeowner?: Maybe<{ readonly __typename?: 'Homeowner', readonly id: string }> }, readonly contractServiceContract: { readonly __typename?: 'ContractServiceContract', readonly id: string, readonly base64Pdf?: Maybe<string>, readonly attachedInvoice?: Maybe<{ readonly __typename?: 'ConnectInvoice', readonly id: string, readonly status: ConnectInvoiceStatus }> } }> };

export type FetchHomeownerNameQueryVariables = Exact<{
  homeownerId: Scalars['String'];
}>;


export type FetchHomeownerNameQuery = { readonly __typename?: 'Query', readonly homeowner?: Maybe<{ readonly __typename?: 'Homeowner', readonly id: string, readonly fullName: string }> };

export type GetDashboardNavDataQueryVariables = Exact<{ [key: string]: never; }>;


export type GetDashboardNavDataQuery = { readonly __typename?: 'Query', readonly contractor?: Maybe<{ readonly __typename?: 'Contractor', readonly id: string, readonly admin: boolean, readonly firstName: string, readonly lastSignInAt?: Maybe<string>, readonly enterpriseAdmin: boolean, readonly hasHomeownerFeedback: boolean, readonly affiliateReferralCode?: Maybe<string>, readonly customSettings: { readonly __typename?: 'CustomContractorSettings', readonly sendNewProductTourSeen202201: boolean, readonly showNewProductTour202201: boolean } }>, readonly organization?: Maybe<{ readonly __typename?: 'Organization', readonly id: string, readonly logoUrl?: Maybe<string>, readonly companyName: string, readonly insuranceEligible: boolean, readonly contractServiceAccount?: Maybe<{ readonly __typename?: 'ContractServiceAccount', readonly id: string, readonly termsAgreedAt?: Maybe<string> }> }> };

export type UpsertContractorDashoardNavInfoMutationVariables = Exact<{
  customSettings: CustomContractorSettingsAttributes;
}>;


export type UpsertContractorDashoardNavInfoMutation = { readonly __typename?: 'Mutation', readonly upsertContractor?: Maybe<{ readonly __typename?: 'UpsertContractorFailure', readonly errors: ReadonlyArray<{ readonly __typename?: 'InternalError', readonly message: string, readonly path?: Maybe<ReadonlyArray<string>>, readonly code: ErrorCodes } | { readonly __typename?: 'ValidationError', readonly message: string, readonly path?: Maybe<ReadonlyArray<string>>, readonly code: ErrorCodes }> } | { readonly __typename?: 'UpsertContractorSuccess', readonly contractor: { readonly __typename?: 'Contractor', readonly id: string, readonly customSettings: { readonly __typename?: 'CustomContractorSettings', readonly sendNewProductTourSeen202201: boolean } } }> };

export type GetDemoModeQueryVariables = Exact<{ [key: string]: never; }>;


export type GetDemoModeQuery = { readonly __typename?: 'Query', readonly contractor?: Maybe<{ readonly __typename?: 'Contractor', readonly id: string, readonly demoMode: boolean }> };

export type UpsertDemoModeMutationVariables = Exact<{
  attributes: ContractorAttributes;
}>;


export type UpsertDemoModeMutation = { readonly __typename?: 'Mutation', readonly upsertContractor?: Maybe<{ readonly __typename?: 'UpsertContractorFailure', readonly errors: ReadonlyArray<{ readonly __typename?: 'InternalError', readonly message: string, readonly path?: Maybe<ReadonlyArray<string>>, readonly code: ErrorCodes } | { readonly __typename?: 'ValidationError', readonly message: string, readonly path?: Maybe<ReadonlyArray<string>>, readonly code: ErrorCodes }> } | { readonly __typename?: 'UpsertContractorSuccess', readonly contractor: { readonly __typename?: 'Contractor', readonly id: string, readonly demoMode: boolean } }> };

export type CheckOffersQueryVariables = Exact<{
  id: Scalars['String'];
}>;


export type CheckOffersQuery = { readonly __typename?: 'Query', readonly loanInquiry?: Maybe<{ readonly __typename?: 'LoanInquiry', readonly id: string, readonly homeowner?: Maybe<{ readonly __typename?: 'Homeowner', readonly id: string, readonly firstName: string, readonly lastName: string, readonly email: string }>, readonly contractor?: Maybe<{ readonly __typename?: 'Contractor', readonly id: string, readonly featureFlags: ReadonlyArray<{ readonly __typename?: 'FeatureFlag', readonly id: string }> }>, readonly organization?: Maybe<{ readonly __typename?: 'Organization', readonly id: string }>, readonly offers?: Maybe<{ readonly __typename?: 'OfferConnection', readonly totalCount: number }> }> };

export type OAuthConnectInvoicePlaidTokenMutationVariables = Exact<{
  plaidPublicToken: Scalars['String'];
  connectInvoiceId: Scalars['ID'];
  plaidAccountId: Scalars['String'];
}>;


export type OAuthConnectInvoicePlaidTokenMutation = { readonly __typename?: 'Mutation', readonly addPlaidTokenToConnectInvoice?: Maybe<{ readonly __typename?: 'AddPlaidTokenToConnectInvoiceFailure', readonly errors: ReadonlyArray<{ readonly __typename?: 'InternalError', readonly code: ErrorCodes, readonly message: string } | { readonly __typename?: 'ValidationError', readonly code: ErrorCodes, readonly message: string }> } | { readonly __typename?: 'AddPlaidTokenToConnectInvoiceSuccess', readonly connectInvoice: { readonly __typename?: 'ConnectInvoice', readonly id: string, readonly plaidAccount?: Maybe<{ readonly __typename?: 'PlaidAccount', readonly id: string, readonly mask: string, readonly name: string, readonly verificationStatus: PlaidVerificationStatus, readonly verified: boolean }> } }> };

export type GetContractTemplateStatusQueryVariables = Exact<{ [key: string]: never; }>;


export type GetContractTemplateStatusQuery = { readonly __typename?: 'Query', readonly organization?: Maybe<{ readonly __typename?: 'Organization', readonly id: string, readonly contractServiceAccount?: Maybe<{ readonly __typename?: 'ContractServiceAccount', readonly id: string, readonly termsAgreedAt?: Maybe<string> }> }>, readonly contractor?: Maybe<{ readonly __typename?: 'Contractor', readonly id: string, readonly admin: boolean }> };

export const FullContractorFragmentDoc = gql`
    fragment FullContractor on Contractor {
  affiliateReferralCode
  affiliateUrl
  appVersion
  createdAt
  currentDeviceId
  email
  emailNotifications
  firstName
  firstVisit
  hearthUid
  id
  lastName
  manualEntry
  onboarded
  onboardedAt
  passwordSet
  phoneNumber
  profileCompletedAt
  pushNotifications
  role
  demoMode
  demoModeSetAt
  signInCount
  textNotifications
  trainingScheduled
  trainingCompleted
  trainingScheduledAt
  trainingTime
  urlPath
  weeklyQualifiedVolume
  emailTemplateId
  textTemplateId
  calendlyCancelLink
  featureFlags {
    id
  }
  needsMoreTraining
  trainingVideoWatchedAt
  hasSeenGraduationScreen
  vertical
  tryPaymentsSeen
  hidePaymentsTab
  admin
  enterpriseAdmin
  webinarRedirectLink
}
    `;
export const FullOrganizationFragmentDoc = gql`
    fragment FullOrganization on Organization {
  activeContractorCount
  address
  answeredBusinessQuestions
  answeredProjectLeads
  backgroundPicture
  bannerInstalledAt
  businessEmail
  businessPhone
  descriptionOfOperations
  city
  companyName
  companyType
  createdAt
  featureFlags {
    id
  }
  planFeatureFlags {
    id
  }
  fullAddress
  hasFinancing
  id
  infoSetting
  latitude
  logoUrl
  longitude
  onboarded
  onboardedAt
  partnership {
    coupon
    label
    logoUrl
    pageVariant
    referralType
    urlPath
  }
  planName
  renewsAt
  requireContract
  sandboxOrg
  totalSeats
  usedSeats
  sentMemberInvites
  settings
  setupFlowCompleted
  setupFlowCompletedAt
  state
  statedNoTeam
  status
  subscriptionContract {
    status
    toBeSignedContract {
      html
      id
      text
    }
  }
  trainingCallLink
  urlPath
  verticalId
  website
  zipCode
}
    `;
export const OrganizationBrandFragmentDoc = gql`
    fragment OrganizationBrand on Organization {
  id
  logoUrl
  companyName
}
    `;
export const ContractorUrlFragmentDoc = gql`
    fragment ContractorUrl on Contractor {
  id
  urlPath
}
    `;
export const ClientImportHomeownerFragmentDoc = gql`
    fragment ClientImportHomeowner on Homeowner {
  id
  firstName
  lastName
  fullName
  phoneNumber
  email
  defaultHomeownerAddress {
    id
    addressLineOne
    addressLineTwo
    city
    state
    zipCode
    homeowner {
      id
      firstName
      lastName
      phoneNumber
      email
    }
  }
}
    `;
export const ClientViewContractIndexFragmentDoc = gql`
    fragment ClientViewContractIndex on ContractServiceContract {
  id
  name
  status
  dueDate
  createdAt
  contractNumber
  creatorId
  projectContractHomeowner {
    id
  }
  receiverSignature {
    id
    signer {
      id
      fullName
      email
    }
  }
}
    `;
export const ClientContractDetailHomeownerFragmentDoc = gql`
    fragment ClientContractDetailHomeowner on Homeowner {
  id
  fullName
}
    `;
export const ClientContractDetailContractorFragmentDoc = gql`
    fragment ClientContractDetailContractor on Contractor {
  id
  fullName
}
    `;
export const ClientContractDetailContractFragmentDoc = gql`
    fragment ClientContractDetailContract on ContractServiceContract {
  id
  name
  contractNumber
  status
  dueDate
  createdAt
  base64Pdf
  creatorId
  projectContractHomeowner {
    id
    ...ClientContractDetailHomeowner
  }
  projectContractContractor {
    id
    ...ClientContractDetailContractor
  }
}
    ${ClientContractDetailHomeownerFragmentDoc}
${ClientContractDetailContractorFragmentDoc}`;
export const FinancingDetailOfferInfoFragmentDoc = gql`
    fragment FinancingDetailOfferInfo on Offer {
  id
  loanAmount
  apr
  loanTermInMonths
  monthlyPayment
}
    `;
export const FinancingDetailLoanInfoFragmentDoc = gql`
    fragment FinancingDetailLoanInfo on LoanInquiry {
  id
  offers {
    totalCount
  }
  highestOffer {
    id
    ...FinancingDetailOfferInfo
  }
  lowestOffer {
    id
    ...FinancingDetailOfferInfo
  }
  requestedOffer {
    id
    ...FinancingDetailOfferInfo
  }
}
    ${FinancingDetailOfferInfoFragmentDoc}`;
export const FinancingDetailEventFragmentDoc = gql`
    fragment FinancingDetailEvent on HearthEvent {
  id
  eventBody
  eventType
  eventAt
}
    `;
export const FinancingDetailHomeownerFragmentDoc = gql`
    fragment FinancingDetailHomeowner on Homeowner {
  id
  fullName
  fico
  financingStatus
  requestedAmount
  firstName
  fundingDate
  fundingAmount
  primaryLoanInquiry {
    id
    ...FinancingDetailLoanInfo
  }
  selectedHearthEvents(events: $events, scope: $scope) {
    nodes {
      id
      ...FinancingDetailEvent
    }
  }
}
    ${FinancingDetailLoanInfoFragmentDoc}
${FinancingDetailEventFragmentDoc}`;
export const InvoiceDetailAttachmentFragmentDoc = gql`
    fragment InvoiceDetailAttachment on InvoiceAttachment {
  id
  attachmentFileName
  link
}
    `;
export const ClientDetailInvoiceFragmentDoc = gql`
    fragment ClientDetailInvoice on ConnectInvoice {
  id
  invoiceNumber
  status
  dueDate
  description
  amountRequested
  creditCardEnabled
  debitCardEnabled
  achEnabled
  paidWith
  paidWithCardType
  firstName
  refundedAmount
  refundableAmount
  lastRefundedAt
  postRefundAmount
  customerPaysCardFee
  debitCardFee
  cardFee
  customerPaysAchFee
  personalNote
  achFee
  contractor {
    id
    fullName
  }
  invoiceAttachments {
    nodes {
      id
      ...InvoiceDetailAttachment
    }
  }
}
    ${InvoiceDetailAttachmentFragmentDoc}`;
export const ClientDetailInvoiceActivityFragmentDoc = gql`
    fragment ClientDetailInvoiceActivity on ConnectActivity {
  id
  activityDate
  content
  connectActivityTypeId
}
    `;
export const ClientDetailEventFragmentDoc = gql`
    fragment ClientDetailEvent on HearthEvent {
  id
  eventBody
  eventType
  eventAt
}
    `;
export const HomeownerQuoteViewLineItemFragmentDoc = gql`
    fragment HomeownerQuoteViewLineItem on QuoteLineItem {
  id
  description
  name
  priceInCents
  quantity
  totalInCents
}
    `;
export const HomeownerQuoteViewContractorFragmentDoc = gql`
    fragment HomeownerQuoteViewContractor on Contractor {
  id
  fullName
  phoneNumber
  email
  fullUrl
}
    `;
export const HomeownerQuoteViewOrganizationFragmentDoc = gql`
    fragment HomeownerQuoteViewOrganization on Organization {
  id
  companyName
  logoUrl
  address
  addressLine2
  state
  city
  zipCode
  businessPhone
  businessEmail
  businessLicenseNumber
}
    `;
export const HomeownerQuoteViewHomeownerAddressFragmentDoc = gql`
    fragment HomeownerQuoteViewHomeownerAddress on HomeownerAddress {
  id
  addressLineOne
  addressLineTwo
  city
  state
  zipCode
  homeowner {
    id
    fullName
    firstName
    lastName
    phoneNumber
    email
    contractor {
      ...HomeownerQuoteViewContractor
    }
    organization {
      ...HomeownerQuoteViewOrganization
    }
  }
}
    ${HomeownerQuoteViewContractorFragmentDoc}
${HomeownerQuoteViewOrganizationFragmentDoc}`;
export const HomeownerQuoteViewDocumentFragmentDoc = gql`
    fragment HomeownerQuoteViewDocument on QuoteUpload {
  id
  filename
  displayLink
  downloadLink
}
    `;
export const HomeownerQuoteDocumentsFragmentDoc = gql`
    fragment HomeownerQuoteDocuments on Quote {
  id
  documents {
    nodes {
      ...HomeownerQuoteViewDocument
    }
  }
}
    ${HomeownerQuoteViewDocumentFragmentDoc}`;
export const HomeownerQuoteViewPhotoFragmentDoc = gql`
    fragment HomeownerQuoteViewPhoto on QuoteUpload {
  id
  displayLink
  filename
}
    `;
export const HomeownerQuoteViewPhotosFragmentDoc = gql`
    fragment HomeownerQuoteViewPhotos on Quote {
  id
  photos {
    nodes {
      ...HomeownerQuoteViewPhoto
    }
  }
}
    ${HomeownerQuoteViewPhotoFragmentDoc}`;
export const HomeownerQuoteViewQuoteFragmentDoc = gql`
    fragment HomeownerQuoteViewQuote on Quote {
  id
  name
  quoteNumber
  status
  createdAt
  expiresAt
  canceledAt
  decisionAt
  description
  personalNote
  discountInCents
  totalFeesInCents
  totalTaxInCents
  totalInCents
  showFinancing
  changesRequested
  latestQuote {
    id
  }
  priorQuote {
    id
  }
  lineItems {
    id
    ...HomeownerQuoteViewLineItem
  }
  homeownerAddress {
    id
    ...HomeownerQuoteViewHomeownerAddress
  }
  ...HomeownerQuoteDocuments
  ...HomeownerQuoteViewPhotos
}
    ${HomeownerQuoteViewLineItemFragmentDoc}
${HomeownerQuoteViewHomeownerAddressFragmentDoc}
${HomeownerQuoteDocumentsFragmentDoc}
${HomeownerQuoteViewPhotosFragmentDoc}`;
export const ClientDetailQuoteFragmentDoc = gql`
    fragment ClientDetailQuote on Quote {
  id
  showFinancing
  priorQuote {
    id
  }
  ...HomeownerQuoteViewQuote
}
    ${HomeownerQuoteViewQuoteFragmentDoc}`;
export const ClientDetailQuoteContractorFragmentDoc = gql`
    fragment ClientDetailQuoteContractor on Contractor {
  id
  trainingCompleted
  firstUnblockedAt
  admin
  ...HomeownerQuoteViewContractor
}
    ${HomeownerQuoteViewContractorFragmentDoc}`;
export const QuoteRequestFlowOrganizationFragmentDoc = gql`
    fragment QuoteRequestFlowOrganization on Organization {
  id
  quoteAccount {
    id
    quoteTemplates {
      nodes {
        id
      }
    }
  }
  ...HomeownerQuoteViewOrganization
}
    ${HomeownerQuoteViewOrganizationFragmentDoc}`;
export const ClientDetailQuoteOrganizationFragmentDoc = gql`
    fragment ClientDetailQuoteOrganization on Organization {
  id
  contractServiceAccount {
    id
    termsAgreedAt
  }
  ...QuoteRequestFlowOrganization
}
    ${QuoteRequestFlowOrganizationFragmentDoc}`;
export const ClientQuoteDetailsFragmentDoc = gql`
    fragment ClientQuoteDetails on Quote {
  id
  name
  createdAt
  expiresAt
  status
  totalInCents
  priorQuote {
    id
  }
  contractor {
    id
    fullName
  }
}
    `;
export const ClientOverviewInvoiceFragmentDoc = gql`
    fragment ClientOverviewInvoice on ConnectInvoice {
  id
  invoiceNumber
  status
  dueDate
  description
  refundedAmount
  refundableAmount
  amountRequested
  sentAt
  contractor {
    id
    fullName
  }
}
    `;
export const ClientDetailContractFragmentDoc = gql`
    fragment ClientDetailContract on ContractServiceContract {
  id
  name
  status
  createdAt
  dueDate
  contractNumber
  homeownerAddress
  projectContractContractor {
    id
    fullName
  }
}
    `;
export const ClientOfferDetailFragmentDoc = gql`
    fragment ClientOfferDetail on Offer {
  id
  loanAmount
}
    `;
export const ClientLoanInquiryInfoFragmentDoc = gql`
    fragment ClientLoanInquiryInfo on LoanInquiry {
  id
  address
  city
  state
  zipCode
  offers {
    totalCount
  }
  highestOffer {
    id
    ...ClientOfferDetail
  }
}
    ${ClientOfferDetailFragmentDoc}`;
export const ClientOverviewEventFragmentDoc = gql`
    fragment ClientOverviewEvent on HearthEvent {
  id
  eventBody
  eventType
  eventAt
}
    `;
export const ClientDetailOverviewFragmentDoc = gql`
    fragment ClientDetailOverview on Homeowner {
  id
  fullName
  firstName
  lastName
  email
  phoneNumber
  defaultHomeownerAddress {
    id
    addressLineOne
    addressLineTwo
    city
    state
    zipCode
  }
  fundingDate
  fundingAmount
  requestedAmount
  paidPaymentsAmount
  outstandingPaymentsAmount
  overduePaymentsAmount
  contractServiceSignatures {
    nodes {
      id
      status
      role
      contract {
        id
        ...ClientDetailContract
      }
    }
  }
  primaryLoanInquiry {
    id
    ...ClientLoanInquiryInfo
  }
  selectedHearthEvents(events: $events, scope: $scope) {
    nodes {
      id
      ...ClientOverviewEvent
    }
  }
}
    ${ClientDetailContractFragmentDoc}
${ClientLoanInquiryInfoFragmentDoc}
${ClientOverviewEventFragmentDoc}`;
export const ClientEventFragmentDoc = gql`
    fragment ClientEvent on HearthEvent {
  id
  eventType
  eventBody
  eventAt
}
    `;
export const IndexClientFragmentDoc = gql`
    fragment IndexClient on Homeowner {
  id
  fullName
  hearthEvents(first: 1, bucket: $type) {
    nodes {
      id
      ...ClientEvent
    }
  }
  selectedHearthEvents(
    first: 10
    events: [homeowner_project_contract_sent, homeowner_project_contract_signed]
  ) {
    nodes {
      id
      eventAt
      eventType
    }
  }
}
    ${ClientEventFragmentDoc}`;
export const ClientInvoiceIndexConnectInvoiceFragmentDoc = gql`
    fragment ClientInvoiceIndexConnectInvoice on ConnectInvoice {
  id
  contractor {
    id
  }
  invoiceNumber
  fullName
  description
  amountRequested
  status
  dueDate
  refundedAmount
  refundableAmount
  homeowner {
    id
  }
}
    `;
export const ClientInvoiceViewableActivityFragmentDoc = gql`
    fragment ClientInvoiceViewableActivity on ConnectActivity {
  id
  activityDate
  content
  connectActivityTypeId
}
    `;
export const ConnectInvoiceAttachmentFragmentDoc = gql`
    fragment ConnectInvoiceAttachment on InvoiceAttachment {
  id
  attachmentFileName
  link
}
    `;
export const ClientInvoiceFragmentDoc = gql`
    fragment ClientInvoice on ConnectInvoice {
  id
  invoiceNumber
  achFee
  amountRequested
  cardFee
  customerPaysAchFee
  customerPaysCardFee
  debitCardFee
  description
  dueDate
  email
  fullName
  firstName
  lastRefundedAt
  paidWith
  paidWithCardType
  personalNote
  phoneNumber
  postRefundAmount
  refundableAmount
  refundedAmount
  status
  sentAt
  scheduledFor
  syncedToQuickbooks
  creditCardEnabled
  debitCardEnabled
  achEnabled
  paymentsCapabilityStatus
  viewableActivities {
    nodes {
      id
      ...ClientInvoiceViewableActivity
    }
  }
  invoiceAttachments {
    nodes {
      id
      ...ConnectInvoiceAttachment
    }
  }
}
    ${ClientInvoiceViewableActivityFragmentDoc}
${ConnectInvoiceAttachmentFragmentDoc}`;
export const ClientViewConnectInvoiceFragmentDoc = gql`
    fragment ClientViewConnectInvoice on ConnectInvoice {
  id
  invoiceNumber
  status
  dueDate
  description
  refundedAmount
  refundableAmount
  amountRequested
  sentAt
  scheduledFor
  syncedToQuickbooks
}
    `;
export const ClientOfferInfoFragmentDoc = gql`
    fragment ClientOfferInfo on Offer {
  id
  loanAmount
  loanTermInMonths
  monthlyPayment
  apr
}
    `;
export const ClientViewPrimaryLoanInquiryFragmentDoc = gql`
    fragment ClientViewPrimaryLoanInquiry on LoanInquiry {
  id
  address
  city
  state
  zipCode
  totalOffers
  createdAt
  qualified
  offers {
    nodes {
      id
    }
  }
  lowestOffer {
    id
    ...ClientOfferInfo
  }
  requestedOffer {
    id
    ...ClientOfferInfo
  }
  highestOffer {
    id
    ...ClientOfferInfo
  }
}
    ${ClientOfferInfoFragmentDoc}`;
export const ClientViewEventFragmentDoc = gql`
    fragment ClientViewEvent on HearthEvent {
  id
  eventBody
  eventType
  eventAt
}
    `;
export const ClientViewHomeownerFragmentDoc = gql`
    fragment ClientViewHomeowner on Homeowner {
  id
  fullName
  firstName
  lastName
  email
  fico
  phoneNumber
  financingStatus
  fundingAmount
  fundingDate
  fundingLender
  requestedAmount
  contractServiceSignatures {
    nodes {
      id
      status
      role
      contract {
        id
        status
        createdAt
        dueDate
        name
        contractNumber
      }
    }
  }
  connectInvoices {
    nodes {
      id
      ...ClientViewConnectInvoice
    }
  }
  primaryLoanInquiry {
    id
    ...ClientViewPrimaryLoanInquiry
  }
  selectedHearthEvents(events: $events, scope: $scope) {
    nodes {
      id
      ...ClientViewEvent
    }
  }
}
    ${ClientViewConnectInvoiceFragmentDoc}
${ClientViewPrimaryLoanInquiryFragmentDoc}
${ClientViewEventFragmentDoc}`;
export const ClientProfileContractFragmentDoc = gql`
    fragment ClientProfileContract on ContractServiceContract {
  id
  status
  name
}
    `;
export const ContractServiceAccountStatusFragmentDoc = gql`
    fragment ContractServiceAccountStatus on ContractServiceAccount {
  id
  termsAgreedAt
  contracts {
    nodes {
      id
      ...ClientProfileContract
    }
  }
}
    ${ClientProfileContractFragmentDoc}`;
export const OrganizationContractWizardInfoFragmentDoc = gql`
    fragment OrganizationContractWizardInfo on Organization {
  id
  logo
  companyName
  businessLicenseNumber
  address
  state
  city
  zipCode
  logoUrl
  contractServiceAccount {
    id
  }
}
    `;
export const OrganizationTemplateInfoFragmentDoc = gql`
    fragment OrganizationTemplateInfo on Organization {
  id
  companyName
  businessEmail
  businessPhone
  fullAddress
  facebookUrl
  twitterUrl
  linkedinUrl
  instagramUrl
  website
  logoUrl
  kycBusiness {
    id
    url
  }
}
    `;
export const InvoiceCustomizationSettingsFragmentDoc = gql`
    fragment InvoiceCustomizationSettings on CustomizedInvoiceTemplate {
  id
  templateType
  primaryColor
  background
  logo
  website
  signatureMessage
  socialLinks {
    facebookUrl
    twitterUrl
    instagramUrl
    linkedinUrl
  }
}
    `;
export const ContractorTemplateInfoFragmentDoc = gql`
    fragment ContractorTemplateInfo on Contractor {
  id
  role
  fullName
  customSettings {
    paymentsApprovalModalSeen
  }
  customizedInvoiceTemplates {
    totalCount
  }
  activeCustomizedInvoiceTemplate {
    id
    ...InvoiceCustomizationSettings
  }
}
    ${InvoiceCustomizationSettingsFragmentDoc}`;
export const ApprovedContractorFragmentDoc = gql`
    fragment ApprovedContractor on Contractor {
  id
  firstName
  paymentsAdmin
  customSettings {
    paymentsApprovalModalSeen
  }
  allInvoices: visibleConnectInvoices {
    totalCount
  }
}
    `;
export const ApprovedOrgFragmentDoc = gql`
    fragment ApprovedOrg on Organization {
  id
  stripeConnectAccount {
    id
    status
  }
}
    `;
export const ActionBarContractorFragmentDoc = gql`
    fragment ActionBarContractor on Contractor {
  id
  admin
  paymentsAdmin
  paymentsRole
}
    `;
export const PaymentsCardConnectAccountFragmentDoc = gql`
    fragment PaymentsCardConnectAccount on StripeConnectAccount {
  id
  status
  balance
  approvedAt
  pendingBalance
  requireStripeExternalAccount
}
    `;
export const OrganizationRewardsFragmentDoc = gql`
    fragment OrganizationRewards on Organization {
  id
  rewardsFlagSetAt
}
    `;
export const ContractorRewardsFragmentDoc = gql`
    fragment ContractorRewards on Contractor {
  id
  email
  firstName
  firstUnblockedAt
  hearthRewardsPaymentsVolume
  customSettings {
    rewardsAvailable
    rewardsClaimed
    paymentRewardsEarned
  }
}
    `;
export const QuickPollFragmentDoc = gql`
    fragment QuickPoll on QuestionnaireQuestion {
  id
  text
  allowedAnswers
  options {
    nodes {
      id
      answerId
      text
    }
  }
  questionMeta
}
    `;
export const SuggestedActionCtaPartsFragmentDoc = gql`
    fragment SuggestedActionCtaParts on SuggestedActionCta {
  id
  copy
  webLink
}
    `;
export const SuggestedActionPartsFragmentDoc = gql`
    fragment SuggestedActionParts on SuggestedAction {
  id
  suggestedActionTypeId
  onboardingActionable
  metadata
  title
  copy
  createdAt
  ctas {
    nodes {
      id
      ...SuggestedActionCtaParts
    }
  }
}
    ${SuggestedActionCtaPartsFragmentDoc}`;
export const ContractorSuggestedActionsInfoFragmentDoc = gql`
    fragment ContractorSuggestedActionsInfo on Contractor {
  id
  urlPath
  suggestedActionsComplete
  suggestedActions(scope: actionable) {
    nodes {
      id
      ...SuggestedActionParts
    }
  }
}
    ${SuggestedActionPartsFragmentDoc}`;
export const OrganizationSuggestedActionsInfoFragmentDoc = gql`
    fragment OrganizationSuggestedActionsInfo on Organization {
  id
  stripeConnectAccount {
    id
    fullAccess
  }
}
    `;
export const WebinarEventFragmentDoc = gql`
    fragment WebinarEvent on HearthEvent {
  id
  eventBody
}
    `;
export const DashboardContractFragmentDoc = gql`
    fragment DashboardContract on SubscriptionContract {
  status
  toBeSignedContract {
    id
    html
    text
  }
}
    `;
export const DashboardOrgFragmentDoc = gql`
    fragment DashboardOrg on Organization {
  id
  createdAt
  subscriptionContract {
    ...DashboardContract
  }
  stripeConnectAccount {
    id
    approvedAt
    status
  }
}
    ${DashboardContractFragmentDoc}`;
export const DashboardContractorFragmentDoc = gql`
    fragment DashboardContractor on Contractor {
  id
  urlPath
  admin
  paymentsAdmin
  firstName
  trainingCompleted
  firstUnblockedAt
  trainingScheduledAt
  customSettings {
    newDashboardWelcomeModalSeen
    hearthOnboardingModalSeen
    highlightPaymentsOverlaySeenCount
    paymentsApprovalModalSeen
    financingUnlockedModalSeen
    financingUnlockedHighlightSeen
    sendNewProductTourSeen202201
  }
  allInvoices: visibleConnectInvoices {
    totalCount
  }
}
    `;
export const OrganizationContractTemplateInfoFragmentDoc = gql`
    fragment OrganizationContractTemplateInfo on Organization {
  id
  companyName
  businessLicenseNumber
  businessPhone
  address
  city
  state
  zipCode
  logoUrl
  contractServiceAccount {
    id
  }
}
    `;
export const ContractTemplateVersionFragmentDoc = gql`
    fragment ContractTemplateVersion on ContractServiceContractTemplate {
  id
  template
  versionName
  default
  baseTemplate {
    id
  }
  updatedAt
  editor {
    id
    fullName
  }
}
    `;
export const OrganizationBasicBusinessInfoFragmentDoc = gql`
    fragment OrganizationBasicBusinessInfo on Organization {
  id
  companyName
  businessEmail
  businessPhone
  fullAddress
  facebookUrl
  twitterUrl
  linkedinUrl
  instagramUrl
  website
  logoUrl
  stripeConnectAccount {
    id
    cardFeeFixedAmount
    cardFeePercentageAmount
  }
}
    `;
export const OrganizationBusinessInfoFragmentDoc = gql`
    fragment OrganizationBusinessInfo on Organization {
  id
  fullAddress
  ...OrganizationBasicBusinessInfo
}
    ${OrganizationBasicBusinessInfoFragmentDoc}`;
export const VisibleAttachmentFragmentDoc = gql`
    fragment VisibleAttachment on InvoiceAttachment {
  id
  attachmentFileName
  link
}
    `;
export const CurrentConnectInvoiceHomeownerFragmentDoc = gql`
    fragment CurrentConnectInvoiceHomeowner on Homeowner {
  id
  firstName
  lastName
  fullName
  email
  phoneNumber
  financingStatus
  activeInvoiceCount
  outstandingInvoiceCount
  outstandingInvoiceAmount
  homeownerFeedbackResponses(feedbackType: payments) {
    totalCount
  }
}
    `;
export const ConnectInvoiceHomeownerFragmentDoc = gql`
    fragment ConnectInvoiceHomeowner on ConnectInvoice {
  id
  invoiceNumber
  description
  status
  statusLabel
  dueDate
  paidAt
  lastRefundedAt
  amountRequested
  postRefundAmount
  refundedAmount
  refundableAmount
  invoiceAttachments {
    nodes {
      id
      attachmentFileName
      link
    }
  }
}
    `;
export const ConnectInvoiceOrganizationFragmentDoc = gql`
    fragment ConnectInvoiceOrganization on Organization {
  id
  companyName
  fullAddress
  businessPhone
  businessEmail
  logoUrl
}
    `;
export const HomeownerLeadFragmentDoc = gql`
    fragment HomeownerLead on Homeowner {
  id
  firstName
  lastName
  phoneNumber
}
    `;
export const LeadsContractorFragmentDoc = gql`
    fragment LeadsContractor on Contractor {
  id
  createdAt
  homeowners {
    nodes {
      id
      ...HomeownerLead
    }
  }
}
    ${HomeownerLeadFragmentDoc}`;
export const InsightsInvoiceFragmentDoc = gql`
    fragment InsightsInvoice on ConnectInvoice {
  id
  createdAt
  sentAt
  paidAt
  amountRequested
  dueDate
  status
}
    `;
export const InsightsContractFragmentDoc = gql`
    fragment InsightsContract on ContractServiceContract {
  id
  status
  createdAt
  dueDate
  amount
  receiverSignature {
    id
    signer {
      id
      fullName
    }
  }
}
    `;
export const InsightsFinancingInsightsAmountFragmentDoc = gql`
    fragment InsightsFinancingInsightsAmount on FinancingInsightsAmount {
  countByDay {
    date
    count
    amount
  }
}
    `;
export const ActiveInvoiceTemplateFragmentDoc = gql`
    fragment ActiveInvoiceTemplate on CustomizedInvoiceTemplate {
  id
  templateType
  primaryColor
  logo
  website
  background
  signatureMessage
  socialLinks {
    facebookUrl
    twitterUrl
    linkedinUrl
    instagramUrl
  }
}
    `;
export const StripeConnectAccountKycFragmentDoc = gql`
    fragment StripeConnectAccountKyc on StripeConnectAccount {
  id
  hearthVerificationStatus
  requirements {
    errors {
      code
      reason
      requirement
    }
    currentlyDue
    pendingVerification
    disabledReason
  }
  status
  accountType
}
    `;
export const StripeConnectAccountKycTransferDestinationFragmentDoc = gql`
    fragment StripeConnectAccountKycTransferDestination on StripeConnectAccount {
  id
  externalTransferDestinations {
    standardDestinations {
      ... on StripeCard {
        id
        name
        brand
        last4
      }
      ... on StripeBankAccount {
        id
        bankName
        routingNumber
        last4
        status
      }
    }
  }
}
    `;
export const KycDocumentsInfoFragmentDoc = gql`
    fragment KycDocumentsInfo on Document {
  id
  attachmentUrl
  attachmentFileName
  documentType
}
    `;
export const KycPersonInfoFragmentDoc = gql`
    fragment KycPersonInfo on KycPerson {
  id
  birthday
  email
  firstName
  lastName
  phoneNumber
  representative
  title
  addressLine1
  addressLine2
  city
  state
  zipCode
  owner
  stripeVerificationStatus
  stripeRequirements {
    errors {
      code
      reason
      requirement
    }
    pastDue
  }
}
    `;
export const KycRequirementInfoFragmentDoc = gql`
    fragment KycRequirementInfo on KycRequirement {
  id
  group
  updatedAt
  requiredFields
}
    `;
export const KycBusinessInfoFragmentDoc = gql`
    fragment KycBusinessInfo on KycBusiness {
  id
  addressLine1
  addressLine2
  city
  state
  dbaName
  email
  foundedDate
  hasLiens
  legalName
  mccDescription
  phoneNumber
  productDescription
  ratingScore
  ratingWebsite
  revenueRange
  taxId
  businessType
  url
  yearlyRevenueInCents
  zipCode
  plaidLinkToken
  kycDocuments {
    nodes {
      id
      ...KycDocumentsInfo
    }
  }
  kycPeople {
    nodes {
      id
      ...KycPersonInfo
    }
  }
  kycRequirements {
    nodes {
      id
      ...KycRequirementInfo
    }
  }
}
    ${KycDocumentsInfoFragmentDoc}
${KycPersonInfoFragmentDoc}
${KycRequirementInfoFragmentDoc}`;
export const OrganizationKycFragmentDoc = gql`
    fragment OrganizationKyc on Organization {
  id
  stripeConnectAccount {
    id
    ...StripeConnectAccountKyc
    ...StripeConnectAccountKycTransferDestination
  }
  kycBusiness {
    id
    ...KycBusinessInfo
    pastDueKycRequirements {
      nodes {
        id
        ...KycRequirementInfo
      }
    }
  }
  companyName
  businessPhone
  fullAddress
  address
  addressLine2
  state
  city
  zipCode
}
    ${StripeConnectAccountKycFragmentDoc}
${StripeConnectAccountKycTransferDestinationFragmentDoc}
${KycBusinessInfoFragmentDoc}
${KycRequirementInfoFragmentDoc}`;
export const ContractorKycFragmentDoc = gql`
    fragment ContractorKyc on Contractor {
  id
  firstName
  lastName
  phoneNumber
  email
  paymentsRole
  admin
}
    `;
export const StripeCardPartsFragmentDoc = gql`
    fragment StripeCardParts on StripeCard {
  id
  name
  brand
  expMonth
  expYear
  last4
  defaultForCurrency
  instantAvailable
  standardAvailable
}
    `;
export const StripeBankAccountPartsFragmentDoc = gql`
    fragment StripeBankAccountParts on StripeBankAccount {
  id
  accountHolderName
  bankName
  last4
  routingNumber
  status
  defaultForCurrency
}
    `;
export const PaymentRefundFragmentFragmentDoc = gql`
    fragment PaymentRefundFragment on ConnectInvoice {
  id
  amountRequested
  refundedAmount
  refundableAmount
  chargedAmount
  homeownerFeeAmount
}
    `;
export const PaymentStripeRedirectStripeConnectAccountFragmentDoc = gql`
    fragment PaymentStripeRedirectStripeConnectAccount on StripeConnectAccount {
  id
  hearthVerificationStatus
  requirements {
    errors {
      code
      reason
      requirement
    }
    currentlyDue
    eventuallyDue
    pendingVerification
    disabledReason
  }
  futureRequirements {
    currentlyDue
    eventuallyDue
  }
  status
  accountType
}
    `;
export const PaymentStripeRedirectOrganizationFragmentDoc = gql`
    fragment PaymentStripeRedirectOrganization on Organization {
  id
  stripeConnectAccount {
    id
    ...PaymentStripeRedirectStripeConnectAccount
  }
}
    ${PaymentStripeRedirectStripeConnectAccountFragmentDoc}`;
export const ProfileOrganizationFragmentDoc = gql`
    fragment ProfileOrganization on Organization {
  id
  address
  city
  state
  zipCode
  companyName
  businessEmail
  businessPhone
  companyName
  logoUrl
}
    `;
export const ProfileContractorFragmentDoc = gql`
    fragment ProfileContractor on Contractor {
  id
  firstName
  lastName
  email
  phoneNumber
  admin
}
    `;
export const FinancingFeedbackFragmentDoc = gql`
    fragment FinancingFeedback on HomeownerFeedbackResponse {
  id
  hearthRating
  contractorExperience
  additionalFinancingFeedback
  submittedAt
  averageFinancingRating
}
    `;
export const PaymentsFeedbackFragmentDoc = gql`
    fragment PaymentsFeedback on HomeownerFeedbackResponse {
  id
  digitalPayments
  workQuality
  customerService
  additionalPaymentsFeedback
  submittedAt
  averagePaymentsRating
}
    `;
export const ContractTemplateInfoFragmentDoc = gql`
    fragment ContractTemplateInfo on ContractServiceContractTemplate {
  id
  versionName
  template
  updatedAt
  default
  baseTemplate {
    id
  }
}
    `;
export const RequestFlowContractorFragmentDoc = gql`
    fragment RequestFlowContractor on Contractor {
  id
  demoMode
  hasEditedCustomizedInvoiceTemplate
  paymentsAdmin
  phoneNumber
  email
  fullName
  trainingCompleted
  firstUnblockedAt
  customSettings {
    customizeInvoiceBannerDismissed
  }
}
    `;
export const RequestFlowOrganizationFragmentDoc = gql`
    fragment RequestFlowOrganization on Organization {
  id
  companyName
  fullAddress
  mailingAddress
  mailingAddressLineTwo
  address
  city
  state
  zipCode
  businessLicenseNumber
  logoUrl
  stripeConnectAccount {
    id
    achEnabled
    creditCardEnabled
    debitCardEnabled
    customerPaysCardFee
    customerPaysAchFee
    achFeeFixedAmount
    achFeePercentageAmount
    cardFeeFixedAmount
    cardFeePercentageAmount
    fullAccess
    requireStripeExternalAccount
  }
}
    `;
export const RequestFlowContractServiceContractTemplateFragmentDoc = gql`
    fragment RequestFlowContractServiceContractTemplate on ContractServiceContractTemplate {
  id
  template
}
    `;
export const ReminderFragmentDoc = gql`
    fragment Reminder on ReminderSetting {
  id
  name
  settingName
  enabled
  medium
}
    `;
export const StripeCardSettingsFragmentDoc = gql`
    fragment StripeCardSettings on StripeCard {
  id
  brand
  last4
  defaultForCurrency
}
    `;
export const StripeBankAccountSettingsFragmentDoc = gql`
    fragment StripeBankAccountSettings on StripeBankAccount {
  id
  bankName
  last4
  defaultForCurrency
}
    `;
export const SettingsOrganizationFragmentDoc = gql`
    fragment SettingsOrganization on Organization {
  id
  infoSetting
  requireContract
  rateCap
  stripeConnectAccount {
    id
    fullAccess
  }
}
    `;
export const SettingsContractorFragmentDoc = gql`
    fragment SettingsContractor on Contractor {
  id
  admin
  textNotifications
  emailNotifications
  demoMode
}
    `;
export const OfferDetailsFragmentDoc = gql`
    fragment OfferDetails on Offer {
  id
  inMonthlyPaymentRange
  redirectUrl
  apr
  autopay
  secure
  lenderImageSlug
  loanTermInMonths
  loanAmount
  monthlyPayment
  score
  disclosure
  lenderName
  offerType
}
    `;
export const PaymentProofFragmentDoc = gql`
    fragment PaymentProof on MonthlyPaymentCalculation {
  id
  minApr
  loanTermInMonths
}
    `;
export const TeamContractorFragmentDoc = gql`
    fragment TeamContractor on Contractor {
  id
  firstName
  lastName
  phoneNumber
  role
  paymentsRole
  leadsCount
  fundedCount
  fundedAmount
  status
  email
  admin
}
    `;
export const TeamMemberInviteFragmentDoc = gql`
    fragment TeamMemberInvite on MemberInvite {
  id
  email
}
    `;
export const TeamOrganizationFragmentDoc = gql`
    fragment TeamOrganization on Organization {
  id
  availableSeats
  stripeConnectAccount {
    id
    fullAccess
  }
  contractors {
    nodes {
      id
      ...TeamContractor
    }
  }
  outstandingMemberInvites {
    nodes {
      id
      ...TeamMemberInvite
    }
  }
}
    ${TeamContractorFragmentDoc}
${TeamMemberInviteFragmentDoc}`;
export const FinancingEventFragmentDoc = gql`
    fragment FinancingEvent on HearthEvent {
  id
  eventType
  eventBody
  eventAt
}
    `;
export const WorkflowsClientFragmentDoc = gql`
    fragment WorkflowsClient on Homeowner {
  id
  fullName
  hearthEvents(first: 1, bucket: $type) {
    nodes {
      id
      ...FinancingEvent
    }
  }
}
    ${FinancingEventFragmentDoc}`;
export const ClientViewContractDataFragmentDoc = gql`
    fragment ClientViewContractData on ContractServiceContract {
  id
  status
  dueDate
  createdAt
  contractNumber
  creatorId
  receiverSignature {
    id
    signer {
      id
      fullName
      email
    }
  }
}
    `;
export const GetStartedOrganizationTemplateInfoFragmentDoc = gql`
    fragment GetStartedOrganizationTemplateInfo on Organization {
  id
  companyName
  businessEmail
  businessPhone
  fullAddress
  facebookUrl
  twitterUrl
  linkedinUrl
  instagramUrl
  website
  logoUrl
  kycBusiness {
    id
    url
  }
}
    `;
export const GetStartedInvoiceCustomizationSettingsFragmentDoc = gql`
    fragment GetStartedInvoiceCustomizationSettings on CustomizedInvoiceTemplate {
  id
  templateType
  primaryColor
  background
  logo
  website
  signatureMessage
  socialLinks {
    facebookUrl
    twitterUrl
    instagramUrl
    linkedinUrl
  }
}
    `;
export const GetStartedContractorTemplateInfoFragmentDoc = gql`
    fragment GetStartedContractorTemplateInfo on Contractor {
  id
  fullName
  customizedInvoiceTemplates {
    totalCount
  }
  activeCustomizedInvoiceTemplate {
    id
    ...GetStartedInvoiceCustomizationSettings
  }
}
    ${GetStartedInvoiceCustomizationSettingsFragmentDoc}`;
export const GetStartedContractorFragmentDoc = gql`
    fragment GetStartedContractor on Contractor {
  id
  admin
  trainingCompleted
  firstAppLoginAt
}
    `;
export const GetStartedOrganizationFragmentDoc = gql`
    fragment GetStartedOrganization on Organization {
  id
  logo
  bannerInstalledAt
}
    `;
export const QuickActionsContractorDataFragmentDoc = gql`
    fragment QuickActionsContractorData on Contractor {
  id
  admin
  paymentsAdmin
  paymentsRole
}
    `;
export const QuickActionsOrganizationDataFragmentDoc = gql`
    fragment QuickActionsOrganizationData on Organization {
  id
  stripeConnectAccount {
    id
    status
  }
  contractServiceAccount {
    id
    termsAgreedAt
  }
}
    `;
export const QuoteRequestFlowContractorFragmentDoc = gql`
    fragment QuoteRequestFlowContractor on Contractor {
  id
  trainingCompleted
  firstUnblockedAt
  ...HomeownerQuoteViewContractor
}
    ${HomeownerQuoteViewContractorFragmentDoc}`;
export const AddClientFieldGroupHomeownerFragmentDoc = gql`
    fragment AddClientFieldGroupHomeowner on Homeowner {
  id
  firstName
  lastName
  phoneNumber
  email
  defaultHomeownerAddress {
    id
    addressLineOne
    addressLineTwo
    city
    state
    zipCode
    homeowner {
      id
      firstName
      lastName
      phoneNumber
      email
    }
  }
}
    `;
export const QuoteRequestFlowHomeownerFragmentDoc = gql`
    fragment QuoteRequestFlowHomeowner on Homeowner {
  id
  ...AddClientFieldGroupHomeowner
}
    ${AddClientFieldGroupHomeownerFragmentDoc}`;
export const QuoteRequestFlowQuoteTemplateLineItemFragmentDoc = gql`
    fragment QuoteRequestFlowQuoteTemplateLineItem on QuoteTemplateLineItem {
  id
  name
  priceInCents
  description
  quantity
  totalInCents
}
    `;
export const QuoteWorkflowOrganizationFragmentDoc = gql`
    fragment QuoteWorkflowOrganization on Organization {
  id
  companyName
  logoUrl
  address
  addressLine2
  state
  city
  zipCode
  businessPhone
  businessEmail
  businessLicenseNumber
  quoteAccount {
    id
  }
}
    `;
export const QuoteWorkflowContractorFragmentDoc = gql`
    fragment QuoteWorkflowContractor on Contractor {
  id
  admin
  fullName
  phoneNumber
  email
  fullUrl
  trainingCompleted
  firstUnblockedAt
}
    `;
export const QuoteWorkflowHomeownerFragmentDoc = gql`
    fragment QuoteWorkflowHomeowner on Homeowner {
  id
  fullName
}
    `;
export const QuoteWorkflowHomeownerAddressFragmentDoc = gql`
    fragment QuoteWorkflowHomeownerAddress on HomeownerAddress {
  id
  homeowner {
    ...QuoteWorkflowHomeowner
  }
}
    ${QuoteWorkflowHomeownerFragmentDoc}`;
export const QuoteWorkflowQuoteFragmentDoc = gql`
    fragment QuoteWorkflowQuote on Quote {
  id
  contractor {
    id
    ...QuoteWorkflowContractor
  }
  homeownerAddress {
    id
    ...QuoteWorkflowHomeownerAddress
  }
  name
  quoteNumber
  status
  createdAt
  expiresAt
  canceledAt
  totalInCents
  priorQuote {
    id
  }
}
    ${QuoteWorkflowContractorFragmentDoc}
${QuoteWorkflowHomeownerAddressFragmentDoc}`;
export const OnboardingContractorFragmentDoc = gql`
    fragment OnboardingContractor on Contractor {
  id
  enterpriseAdmin
  passwordSet
  firstPasswordSetAt
  firstName
  lastName
}
    `;
export const OnboardingOrganizationFragmentDoc = gql`
    fragment OnboardingOrganization on Organization {
  id
  setupFlowCompleted
  kycSkippedAt
  subscriptionContract {
    status
    toBeSignedContract {
      id
      html
      text
    }
  }
  stripeConnectAccount {
    id
    status
  }
}
    `;
export const UpdateOrganizationLogoDocument = gql`
    mutation UpdateOrganizationLogo($attributes: OrganizationAttributes!) {
  upsertOrganization(attributes: $attributes) {
    ... on UpsertOrganizationSuccess {
      organization {
        id
        logoUrl
      }
    }
    ... on UpsertOrganizationFailure {
      errors {
        message
        path
        code
      }
    }
  }
}
    `;

/**
 * __useUpdateOrganizationLogoMutation__
 *
 * To run a mutation, you first call `useUpdateOrganizationLogoMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateOrganizationLogoMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateOrganizationLogoMutation, { data, loading, error }] = useUpdateOrganizationLogoMutation({
 *   variables: {
 *      attributes: // value for 'attributes'
 *   },
 * });
 */
export function useUpdateOrganizationLogoMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<UpdateOrganizationLogoMutation, UpdateOrganizationLogoMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useMutation<UpdateOrganizationLogoMutation, UpdateOrganizationLogoMutationVariables>(UpdateOrganizationLogoDocument, options);
      }
export type UpdateOrganizationLogoMutationHookResult = ReturnType<typeof useUpdateOrganizationLogoMutation>;
export type UpdateOrganizationLogoMutationResult = ApolloReactCommon.MutationResult<UpdateOrganizationLogoMutation>;
export type UpdateOrganizationLogoMutationOptions = ApolloReactCommon.BaseMutationOptions<UpdateOrganizationLogoMutation, UpdateOrganizationLogoMutationVariables>;
export const GetAuthenticatedInfoDocument = gql`
    query GetAuthenticatedInfo {
  featureFlags {
    id
  }
  contractor {
    id
    admin
    passwordSet
  }
  organization {
    id
    onboarded
    subscriptionContract {
      status
    }
  }
}
    `;

/**
 * __useGetAuthenticatedInfoQuery__
 *
 * To run a query within a React component, call `useGetAuthenticatedInfoQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetAuthenticatedInfoQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetAuthenticatedInfoQuery({
 *   variables: {
 *   },
 * });
 */
export function useGetAuthenticatedInfoQuery(baseOptions?: ApolloReactHooks.QueryHookOptions<GetAuthenticatedInfoQuery, GetAuthenticatedInfoQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<GetAuthenticatedInfoQuery, GetAuthenticatedInfoQueryVariables>(GetAuthenticatedInfoDocument, options);
      }
export function useGetAuthenticatedInfoLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<GetAuthenticatedInfoQuery, GetAuthenticatedInfoQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<GetAuthenticatedInfoQuery, GetAuthenticatedInfoQueryVariables>(GetAuthenticatedInfoDocument, options);
        }
export type GetAuthenticatedInfoQueryHookResult = ReturnType<typeof useGetAuthenticatedInfoQuery>;
export type GetAuthenticatedInfoLazyQueryHookResult = ReturnType<typeof useGetAuthenticatedInfoLazyQuery>;
export type GetAuthenticatedInfoQueryResult = ApolloReactCommon.QueryResult<GetAuthenticatedInfoQuery, GetAuthenticatedInfoQueryVariables>;
export const GetSessionDocument = gql`
    query GetSession {
  session @client {
    hearthUid
  }
}
    `;

/**
 * __useGetSessionQuery__
 *
 * To run a query within a React component, call `useGetSessionQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetSessionQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetSessionQuery({
 *   variables: {
 *   },
 * });
 */
export function useGetSessionQuery(baseOptions?: ApolloReactHooks.QueryHookOptions<GetSessionQuery, GetSessionQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<GetSessionQuery, GetSessionQueryVariables>(GetSessionDocument, options);
      }
export function useGetSessionLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<GetSessionQuery, GetSessionQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<GetSessionQuery, GetSessionQueryVariables>(GetSessionDocument, options);
        }
export type GetSessionQueryHookResult = ReturnType<typeof useGetSessionQuery>;
export type GetSessionLazyQueryHookResult = ReturnType<typeof useGetSessionLazyQuery>;
export type GetSessionQueryResult = ApolloReactCommon.QueryResult<GetSessionQuery, GetSessionQueryVariables>;
export const SendDefaultFinancingInfoDocument = gql`
    mutation SendDefaultFinancingInfo($id: ID!, $mediums: [ContactMedium!]!) {
  sendDefaultFinancingInfo(homeownerId: $id, mediums: $mediums) {
    ... on SendDefaultFinancingInfoSuccess {
      homeowner {
        id
        email
      }
    }
    ... on SendDefaultFinancingInfoFailure {
      errors {
        message
        path
        code
      }
    }
  }
}
    `;

/**
 * __useSendDefaultFinancingInfoMutation__
 *
 * To run a mutation, you first call `useSendDefaultFinancingInfoMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useSendDefaultFinancingInfoMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [sendDefaultFinancingInfoMutation, { data, loading, error }] = useSendDefaultFinancingInfoMutation({
 *   variables: {
 *      id: // value for 'id'
 *      mediums: // value for 'mediums'
 *   },
 * });
 */
export function useSendDefaultFinancingInfoMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<SendDefaultFinancingInfoMutation, SendDefaultFinancingInfoMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useMutation<SendDefaultFinancingInfoMutation, SendDefaultFinancingInfoMutationVariables>(SendDefaultFinancingInfoDocument, options);
      }
export type SendDefaultFinancingInfoMutationHookResult = ReturnType<typeof useSendDefaultFinancingInfoMutation>;
export type SendDefaultFinancingInfoMutationResult = ApolloReactCommon.MutationResult<SendDefaultFinancingInfoMutation>;
export type SendDefaultFinancingInfoMutationOptions = ApolloReactCommon.BaseMutationOptions<SendDefaultFinancingInfoMutation, SendDefaultFinancingInfoMutationVariables>;
export const GetTrainingWebinarSessionsDocument = gql`
    query GetTrainingWebinarSessions($webinarType: HearthWebinar!, $status: String!) {
  livestormWebinars(webinarType: $webinarType, status: $status) {
    id
    attributes {
      estimatedStartedAt
    }
  }
}
    `;

/**
 * __useGetTrainingWebinarSessionsQuery__
 *
 * To run a query within a React component, call `useGetTrainingWebinarSessionsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetTrainingWebinarSessionsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetTrainingWebinarSessionsQuery({
 *   variables: {
 *      webinarType: // value for 'webinarType'
 *      status: // value for 'status'
 *   },
 * });
 */
export function useGetTrainingWebinarSessionsQuery(baseOptions: ApolloReactHooks.QueryHookOptions<GetTrainingWebinarSessionsQuery, GetTrainingWebinarSessionsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<GetTrainingWebinarSessionsQuery, GetTrainingWebinarSessionsQueryVariables>(GetTrainingWebinarSessionsDocument, options);
      }
export function useGetTrainingWebinarSessionsLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<GetTrainingWebinarSessionsQuery, GetTrainingWebinarSessionsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<GetTrainingWebinarSessionsQuery, GetTrainingWebinarSessionsQueryVariables>(GetTrainingWebinarSessionsDocument, options);
        }
export type GetTrainingWebinarSessionsQueryHookResult = ReturnType<typeof useGetTrainingWebinarSessionsQuery>;
export type GetTrainingWebinarSessionsLazyQueryHookResult = ReturnType<typeof useGetTrainingWebinarSessionsLazyQuery>;
export type GetTrainingWebinarSessionsQueryResult = ApolloReactCommon.QueryResult<GetTrainingWebinarSessionsQuery, GetTrainingWebinarSessionsQueryVariables>;
export const SendInviteAndScheduleWebinarDocument = gql`
    mutation SendInviteAndScheduleWebinar($emails: [String!]!, $trainingScheduledAt: ISO8601DateTime!, $sessionId: String!) {
  sendInviteAndScheduleWebinar(
    emails: $emails
    trainingScheduledAt: $trainingScheduledAt
    sessionId: $sessionId
  ) {
    ... on SendInviteAndScheduleWebinarSuccess {
      organization {
        id
      }
    }
    ... on SendInviteAndScheduleWebinarFailure {
      errors {
        message
        path
        code
      }
    }
  }
}
    `;

/**
 * __useSendInviteAndScheduleWebinarMutation__
 *
 * To run a mutation, you first call `useSendInviteAndScheduleWebinarMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useSendInviteAndScheduleWebinarMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [sendInviteAndScheduleWebinarMutation, { data, loading, error }] = useSendInviteAndScheduleWebinarMutation({
 *   variables: {
 *      emails: // value for 'emails'
 *      trainingScheduledAt: // value for 'trainingScheduledAt'
 *      sessionId: // value for 'sessionId'
 *   },
 * });
 */
export function useSendInviteAndScheduleWebinarMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<SendInviteAndScheduleWebinarMutation, SendInviteAndScheduleWebinarMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useMutation<SendInviteAndScheduleWebinarMutation, SendInviteAndScheduleWebinarMutationVariables>(SendInviteAndScheduleWebinarDocument, options);
      }
export type SendInviteAndScheduleWebinarMutationHookResult = ReturnType<typeof useSendInviteAndScheduleWebinarMutation>;
export type SendInviteAndScheduleWebinarMutationResult = ApolloReactCommon.MutationResult<SendInviteAndScheduleWebinarMutation>;
export type SendInviteAndScheduleWebinarMutationOptions = ApolloReactCommon.BaseMutationOptions<SendInviteAndScheduleWebinarMutation, SendInviteAndScheduleWebinarMutationVariables>;
export const ScheduleWebinarDocument = gql`
    mutation ScheduleWebinar($id: ID!, $trainingScheduledAt: ISO8601DateTime!, $sessionId: String!) {
  scheduleWebinar(
    contractorId: $id
    trainingScheduledAt: $trainingScheduledAt
    sessionId: $sessionId
  ) {
    ... on ScheduleWebinarSuccess {
      contractor {
        id
        trainingScheduledAt
      }
    }
    ... on ScheduleWebinarFailure {
      errors {
        message
        path
        code
      }
    }
  }
}
    `;

/**
 * __useScheduleWebinarMutation__
 *
 * To run a mutation, you first call `useScheduleWebinarMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useScheduleWebinarMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [scheduleWebinarMutation, { data, loading, error }] = useScheduleWebinarMutation({
 *   variables: {
 *      id: // value for 'id'
 *      trainingScheduledAt: // value for 'trainingScheduledAt'
 *      sessionId: // value for 'sessionId'
 *   },
 * });
 */
export function useScheduleWebinarMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<ScheduleWebinarMutation, ScheduleWebinarMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useMutation<ScheduleWebinarMutation, ScheduleWebinarMutationVariables>(ScheduleWebinarDocument, options);
      }
export type ScheduleWebinarMutationHookResult = ReturnType<typeof useScheduleWebinarMutation>;
export type ScheduleWebinarMutationResult = ApolloReactCommon.MutationResult<ScheduleWebinarMutation>;
export type ScheduleWebinarMutationOptions = ApolloReactCommon.BaseMutationOptions<ScheduleWebinarMutation, ScheduleWebinarMutationVariables>;
export const RefreshDataDocument = gql`
    query RefreshData {
  contractor {
    id
    ...FullContractor
  }
  organization {
    id
    ...FullOrganization
  }
  featureFlags {
    id
  }
}
    ${FullContractorFragmentDoc}
${FullOrganizationFragmentDoc}`;

/**
 * __useRefreshDataQuery__
 *
 * To run a query within a React component, call `useRefreshDataQuery` and pass it any options that fit your needs.
 * When your component renders, `useRefreshDataQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useRefreshDataQuery({
 *   variables: {
 *   },
 * });
 */
export function useRefreshDataQuery(baseOptions?: ApolloReactHooks.QueryHookOptions<RefreshDataQuery, RefreshDataQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<RefreshDataQuery, RefreshDataQueryVariables>(RefreshDataDocument, options);
      }
export function useRefreshDataLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<RefreshDataQuery, RefreshDataQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<RefreshDataQuery, RefreshDataQueryVariables>(RefreshDataDocument, options);
        }
export type RefreshDataQueryHookResult = ReturnType<typeof useRefreshDataQuery>;
export type RefreshDataLazyQueryHookResult = ReturnType<typeof useRefreshDataLazyQuery>;
export type RefreshDataQueryResult = ApolloReactCommon.QueryResult<RefreshDataQuery, RefreshDataQueryVariables>;
export const FetchContractorDocument = gql`
    query FetchContractor {
  contractor {
    id
    ...FullContractor
  }
}
    ${FullContractorFragmentDoc}`;

/**
 * __useFetchContractorQuery__
 *
 * To run a query within a React component, call `useFetchContractorQuery` and pass it any options that fit your needs.
 * When your component renders, `useFetchContractorQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useFetchContractorQuery({
 *   variables: {
 *   },
 * });
 */
export function useFetchContractorQuery(baseOptions?: ApolloReactHooks.QueryHookOptions<FetchContractorQuery, FetchContractorQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<FetchContractorQuery, FetchContractorQueryVariables>(FetchContractorDocument, options);
      }
export function useFetchContractorLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<FetchContractorQuery, FetchContractorQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<FetchContractorQuery, FetchContractorQueryVariables>(FetchContractorDocument, options);
        }
export type FetchContractorQueryHookResult = ReturnType<typeof useFetchContractorQuery>;
export type FetchContractorLazyQueryHookResult = ReturnType<typeof useFetchContractorLazyQuery>;
export type FetchContractorQueryResult = ApolloReactCommon.QueryResult<FetchContractorQuery, FetchContractorQueryVariables>;
export const FetchFullOrganizationDocument = gql`
    query FetchFullOrganization {
  organization {
    id
    ...FullOrganization
  }
}
    ${FullOrganizationFragmentDoc}`;

/**
 * __useFetchFullOrganizationQuery__
 *
 * To run a query within a React component, call `useFetchFullOrganizationQuery` and pass it any options that fit your needs.
 * When your component renders, `useFetchFullOrganizationQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useFetchFullOrganizationQuery({
 *   variables: {
 *   },
 * });
 */
export function useFetchFullOrganizationQuery(baseOptions?: ApolloReactHooks.QueryHookOptions<FetchFullOrganizationQuery, FetchFullOrganizationQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<FetchFullOrganizationQuery, FetchFullOrganizationQueryVariables>(FetchFullOrganizationDocument, options);
      }
export function useFetchFullOrganizationLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<FetchFullOrganizationQuery, FetchFullOrganizationQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<FetchFullOrganizationQuery, FetchFullOrganizationQueryVariables>(FetchFullOrganizationDocument, options);
        }
export type FetchFullOrganizationQueryHookResult = ReturnType<typeof useFetchFullOrganizationQuery>;
export type FetchFullOrganizationLazyQueryHookResult = ReturnType<typeof useFetchFullOrganizationLazyQuery>;
export type FetchFullOrganizationQueryResult = ApolloReactCommon.QueryResult<FetchFullOrganizationQuery, FetchFullOrganizationQueryVariables>;
export const GetPaywallInfoDocument = gql`
    query GetPaywallInfo {
  organization {
    id
    planName
    canceledAt
  }
}
    `;

/**
 * __useGetPaywallInfoQuery__
 *
 * To run a query within a React component, call `useGetPaywallInfoQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetPaywallInfoQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetPaywallInfoQuery({
 *   variables: {
 *   },
 * });
 */
export function useGetPaywallInfoQuery(baseOptions?: ApolloReactHooks.QueryHookOptions<GetPaywallInfoQuery, GetPaywallInfoQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<GetPaywallInfoQuery, GetPaywallInfoQueryVariables>(GetPaywallInfoDocument, options);
      }
export function useGetPaywallInfoLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<GetPaywallInfoQuery, GetPaywallInfoQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<GetPaywallInfoQuery, GetPaywallInfoQueryVariables>(GetPaywallInfoDocument, options);
        }
export type GetPaywallInfoQueryHookResult = ReturnType<typeof useGetPaywallInfoQuery>;
export type GetPaywallInfoLazyQueryHookResult = ReturnType<typeof useGetPaywallInfoLazyQuery>;
export type GetPaywallInfoQueryResult = ApolloReactCommon.QueryResult<GetPaywallInfoQuery, GetPaywallInfoQueryVariables>;
export const GetQuickBooksDismissibleBannerDataDocument = gql`
    query GetQuickBooksDismissibleBannerData {
  contractor {
    id
    paidConnectInvoices {
      totalCount
    }
    customSettings {
      quickbooksBannerDismissed
    }
    organization {
      id
      quickbooksBusiness {
        id
      }
    }
    admin
  }
}
    `;

/**
 * __useGetQuickBooksDismissibleBannerDataQuery__
 *
 * To run a query within a React component, call `useGetQuickBooksDismissibleBannerDataQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetQuickBooksDismissibleBannerDataQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetQuickBooksDismissibleBannerDataQuery({
 *   variables: {
 *   },
 * });
 */
export function useGetQuickBooksDismissibleBannerDataQuery(baseOptions?: ApolloReactHooks.QueryHookOptions<GetQuickBooksDismissibleBannerDataQuery, GetQuickBooksDismissibleBannerDataQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<GetQuickBooksDismissibleBannerDataQuery, GetQuickBooksDismissibleBannerDataQueryVariables>(GetQuickBooksDismissibleBannerDataDocument, options);
      }
export function useGetQuickBooksDismissibleBannerDataLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<GetQuickBooksDismissibleBannerDataQuery, GetQuickBooksDismissibleBannerDataQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<GetQuickBooksDismissibleBannerDataQuery, GetQuickBooksDismissibleBannerDataQueryVariables>(GetQuickBooksDismissibleBannerDataDocument, options);
        }
export type GetQuickBooksDismissibleBannerDataQueryHookResult = ReturnType<typeof useGetQuickBooksDismissibleBannerDataQuery>;
export type GetQuickBooksDismissibleBannerDataLazyQueryHookResult = ReturnType<typeof useGetQuickBooksDismissibleBannerDataLazyQuery>;
export type GetQuickBooksDismissibleBannerDataQueryResult = ApolloReactCommon.QueryResult<GetQuickBooksDismissibleBannerDataQuery, GetQuickBooksDismissibleBannerDataQueryVariables>;
export const SetQuickbooksBannerDismissedDocument = gql`
    mutation SetQuickbooksBannerDismissed($customSettings: CustomContractorSettingsAttributes!) {
  upsertContractor(customSettings: $customSettings) {
    ... on UpsertContractorSuccess {
      contractor {
        id
        customSettings {
          quickbooksBannerDismissed
        }
      }
    }
    ... on UpsertContractorFailure {
      errors {
        message
        path
        code
      }
    }
  }
}
    `;

/**
 * __useSetQuickbooksBannerDismissedMutation__
 *
 * To run a mutation, you first call `useSetQuickbooksBannerDismissedMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useSetQuickbooksBannerDismissedMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [setQuickbooksBannerDismissedMutation, { data, loading, error }] = useSetQuickbooksBannerDismissedMutation({
 *   variables: {
 *      customSettings: // value for 'customSettings'
 *   },
 * });
 */
export function useSetQuickbooksBannerDismissedMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<SetQuickbooksBannerDismissedMutation, SetQuickbooksBannerDismissedMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useMutation<SetQuickbooksBannerDismissedMutation, SetQuickbooksBannerDismissedMutationVariables>(SetQuickbooksBannerDismissedDocument, options);
      }
export type SetQuickbooksBannerDismissedMutationHookResult = ReturnType<typeof useSetQuickbooksBannerDismissedMutation>;
export type SetQuickbooksBannerDismissedMutationResult = ApolloReactCommon.MutationResult<SetQuickbooksBannerDismissedMutation>;
export type SetQuickbooksBannerDismissedMutationOptions = ApolloReactCommon.BaseMutationOptions<SetQuickbooksBannerDismissedMutation, SetQuickbooksBannerDismissedMutationVariables>;
export const FetchHomeownerOrganizationDocument = gql`
    query FetchHomeownerOrganization($homeownerId: String!) {
  homeowner(id: $homeownerId) {
    id
    organization {
      id
      ...OrganizationBrand
    }
    contractor {
      id
      ...ContractorUrl
    }
  }
}
    ${OrganizationBrandFragmentDoc}
${ContractorUrlFragmentDoc}`;

/**
 * __useFetchHomeownerOrganizationQuery__
 *
 * To run a query within a React component, call `useFetchHomeownerOrganizationQuery` and pass it any options that fit your needs.
 * When your component renders, `useFetchHomeownerOrganizationQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useFetchHomeownerOrganizationQuery({
 *   variables: {
 *      homeownerId: // value for 'homeownerId'
 *   },
 * });
 */
export function useFetchHomeownerOrganizationQuery(baseOptions: ApolloReactHooks.QueryHookOptions<FetchHomeownerOrganizationQuery, FetchHomeownerOrganizationQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<FetchHomeownerOrganizationQuery, FetchHomeownerOrganizationQueryVariables>(FetchHomeownerOrganizationDocument, options);
      }
export function useFetchHomeownerOrganizationLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<FetchHomeownerOrganizationQuery, FetchHomeownerOrganizationQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<FetchHomeownerOrganizationQuery, FetchHomeownerOrganizationQueryVariables>(FetchHomeownerOrganizationDocument, options);
        }
export type FetchHomeownerOrganizationQueryHookResult = ReturnType<typeof useFetchHomeownerOrganizationQuery>;
export type FetchHomeownerOrganizationLazyQueryHookResult = ReturnType<typeof useFetchHomeownerOrganizationLazyQuery>;
export type FetchHomeownerOrganizationQueryResult = ApolloReactCommon.QueryResult<FetchHomeownerOrganizationQuery, FetchHomeownerOrganizationQueryVariables>;
export const FetchInvoiceOrganizationDocument = gql`
    query FetchInvoiceOrganization($invoiceId: ID!) {
  connectInvoice(id: $invoiceId) {
    id
    organization {
      id
      ...OrganizationBrand
    }
    contractor {
      id
      ...ContractorUrl
    }
  }
}
    ${OrganizationBrandFragmentDoc}
${ContractorUrlFragmentDoc}`;

/**
 * __useFetchInvoiceOrganizationQuery__
 *
 * To run a query within a React component, call `useFetchInvoiceOrganizationQuery` and pass it any options that fit your needs.
 * When your component renders, `useFetchInvoiceOrganizationQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useFetchInvoiceOrganizationQuery({
 *   variables: {
 *      invoiceId: // value for 'invoiceId'
 *   },
 * });
 */
export function useFetchInvoiceOrganizationQuery(baseOptions: ApolloReactHooks.QueryHookOptions<FetchInvoiceOrganizationQuery, FetchInvoiceOrganizationQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<FetchInvoiceOrganizationQuery, FetchInvoiceOrganizationQueryVariables>(FetchInvoiceOrganizationDocument, options);
      }
export function useFetchInvoiceOrganizationLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<FetchInvoiceOrganizationQuery, FetchInvoiceOrganizationQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<FetchInvoiceOrganizationQuery, FetchInvoiceOrganizationQueryVariables>(FetchInvoiceOrganizationDocument, options);
        }
export type FetchInvoiceOrganizationQueryHookResult = ReturnType<typeof useFetchInvoiceOrganizationQuery>;
export type FetchInvoiceOrganizationLazyQueryHookResult = ReturnType<typeof useFetchInvoiceOrganizationLazyQuery>;
export type FetchInvoiceOrganizationQueryResult = ApolloReactCommon.QueryResult<FetchInvoiceOrganizationQuery, FetchInvoiceOrganizationQueryVariables>;
export const SendEmailLeadsDocument = gql`
    mutation SendEmailLeads($contractorId: ID!, $file: String!, $emails: String!) {
  sendEmailLead(contractorId: $contractorId, file: $file, emails: $emails) {
    ... on SendEmailLeadSuccess {
      organization {
        id
      }
      count
    }
    ... on SendEmailLeadFailure {
      errors {
        message
        path
        code
      }
    }
  }
}
    `;

/**
 * __useSendEmailLeadsMutation__
 *
 * To run a mutation, you first call `useSendEmailLeadsMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useSendEmailLeadsMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [sendEmailLeadsMutation, { data, loading, error }] = useSendEmailLeadsMutation({
 *   variables: {
 *      contractorId: // value for 'contractorId'
 *      file: // value for 'file'
 *      emails: // value for 'emails'
 *   },
 * });
 */
export function useSendEmailLeadsMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<SendEmailLeadsMutation, SendEmailLeadsMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useMutation<SendEmailLeadsMutation, SendEmailLeadsMutationVariables>(SendEmailLeadsDocument, options);
      }
export type SendEmailLeadsMutationHookResult = ReturnType<typeof useSendEmailLeadsMutation>;
export type SendEmailLeadsMutationResult = ApolloReactCommon.MutationResult<SendEmailLeadsMutation>;
export type SendEmailLeadsMutationOptions = ApolloReactCommon.BaseMutationOptions<SendEmailLeadsMutation, SendEmailLeadsMutationVariables>;
export const GetSetupLaterDocument = gql`
    query GetSetupLater {
  contractor {
    id
    role
    appVersion
    onboardedAt
    setupFlowAppLoginLater
    setupFlowInstallBannersLater
    setupFlowWatchArticleVideoLater
    setupFlowInviteTeamLater
    setupFlowInstallBanners
    setupFlowAddTeamMembers
    setupFlowTextLinkSent
    setupFlowWatchArticleVideo
    admin
    enterpriseAdmin
    organization {
      id
      website
      bannerInstalledAt
      totalSeats
      statedNoTeam
      sentMemberInvites
    }
  }
}
    `;

/**
 * __useGetSetupLaterQuery__
 *
 * To run a query within a React component, call `useGetSetupLaterQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetSetupLaterQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetSetupLaterQuery({
 *   variables: {
 *   },
 * });
 */
export function useGetSetupLaterQuery(baseOptions?: ApolloReactHooks.QueryHookOptions<GetSetupLaterQuery, GetSetupLaterQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<GetSetupLaterQuery, GetSetupLaterQueryVariables>(GetSetupLaterDocument, options);
      }
export function useGetSetupLaterLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<GetSetupLaterQuery, GetSetupLaterQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<GetSetupLaterQuery, GetSetupLaterQueryVariables>(GetSetupLaterDocument, options);
        }
export type GetSetupLaterQueryHookResult = ReturnType<typeof useGetSetupLaterQuery>;
export type GetSetupLaterLazyQueryHookResult = ReturnType<typeof useGetSetupLaterLazyQuery>;
export type GetSetupLaterQueryResult = ApolloReactCommon.QueryResult<GetSetupLaterQuery, GetSetupLaterQueryVariables>;
export const GetEnterpriseInfoDocument = gql`
    query GetEnterpriseInfo {
  contractor {
    id
    role
    admin
    enterpriseAdmin
    enterpriseOrgs {
      nodes {
        id
        companyName
        logoUrl
      }
    }
    organization {
      id
      companyName
      logoUrl
    }
  }
}
    `;

/**
 * __useGetEnterpriseInfoQuery__
 *
 * To run a query within a React component, call `useGetEnterpriseInfoQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetEnterpriseInfoQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetEnterpriseInfoQuery({
 *   variables: {
 *   },
 * });
 */
export function useGetEnterpriseInfoQuery(baseOptions?: ApolloReactHooks.QueryHookOptions<GetEnterpriseInfoQuery, GetEnterpriseInfoQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<GetEnterpriseInfoQuery, GetEnterpriseInfoQueryVariables>(GetEnterpriseInfoDocument, options);
      }
export function useGetEnterpriseInfoLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<GetEnterpriseInfoQuery, GetEnterpriseInfoQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<GetEnterpriseInfoQuery, GetEnterpriseInfoQueryVariables>(GetEnterpriseInfoDocument, options);
        }
export type GetEnterpriseInfoQueryHookResult = ReturnType<typeof useGetEnterpriseInfoQuery>;
export type GetEnterpriseInfoLazyQueryHookResult = ReturnType<typeof useGetEnterpriseInfoLazyQuery>;
export type GetEnterpriseInfoQueryResult = ApolloReactCommon.QueryResult<GetEnterpriseInfoQuery, GetEnterpriseInfoQueryVariables>;
export const SwitchEnterpriseOrgDocument = gql`
    mutation SwitchEnterpriseOrg($organizationId: ID!) {
  switchEnterpriseOrg(organizationId: $organizationId) {
    ... on SwitchEnterpriseOrgSuccess {
      contractor {
        id
        admin
      }
    }
    ... on SwitchEnterpriseOrgFailure {
      errors {
        code
        message
      }
    }
  }
}
    `;

/**
 * __useSwitchEnterpriseOrgMutation__
 *
 * To run a mutation, you first call `useSwitchEnterpriseOrgMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useSwitchEnterpriseOrgMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [switchEnterpriseOrgMutation, { data, loading, error }] = useSwitchEnterpriseOrgMutation({
 *   variables: {
 *      organizationId: // value for 'organizationId'
 *   },
 * });
 */
export function useSwitchEnterpriseOrgMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<SwitchEnterpriseOrgMutation, SwitchEnterpriseOrgMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useMutation<SwitchEnterpriseOrgMutation, SwitchEnterpriseOrgMutationVariables>(SwitchEnterpriseOrgDocument, options);
      }
export type SwitchEnterpriseOrgMutationHookResult = ReturnType<typeof useSwitchEnterpriseOrgMutation>;
export type SwitchEnterpriseOrgMutationResult = ApolloReactCommon.MutationResult<SwitchEnterpriseOrgMutation>;
export type SwitchEnterpriseOrgMutationOptions = ApolloReactCommon.BaseMutationOptions<SwitchEnterpriseOrgMutation, SwitchEnterpriseOrgMutationVariables>;
export const CreateUnitBankingApplicationDocument = gql`
    mutation CreateUnitBankingApplication($orgId: String!) {
  CreateGinzaApplicationForm(orgID: $orgId) {
    URL
  }
}
    `;

/**
 * __useCreateUnitBankingApplicationMutation__
 *
 * To run a mutation, you first call `useCreateUnitBankingApplicationMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateUnitBankingApplicationMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createUnitBankingApplicationMutation, { data, loading, error }] = useCreateUnitBankingApplicationMutation({
 *   variables: {
 *      orgId: // value for 'orgId'
 *   },
 * });
 */
export function useCreateUnitBankingApplicationMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<CreateUnitBankingApplicationMutation, CreateUnitBankingApplicationMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useMutation<CreateUnitBankingApplicationMutation, CreateUnitBankingApplicationMutationVariables>(CreateUnitBankingApplicationDocument, options);
      }
export type CreateUnitBankingApplicationMutationHookResult = ReturnType<typeof useCreateUnitBankingApplicationMutation>;
export type CreateUnitBankingApplicationMutationResult = ApolloReactCommon.MutationResult<CreateUnitBankingApplicationMutation>;
export type CreateUnitBankingApplicationMutationOptions = ApolloReactCommon.BaseMutationOptions<CreateUnitBankingApplicationMutation, CreateUnitBankingApplicationMutationVariables>;
export const GetOrganizationIdDocument = gql`
    query GetOrganizationId {
  organization {
    id
  }
}
    `;

/**
 * __useGetOrganizationIdQuery__
 *
 * To run a query within a React component, call `useGetOrganizationIdQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetOrganizationIdQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetOrganizationIdQuery({
 *   variables: {
 *   },
 * });
 */
export function useGetOrganizationIdQuery(baseOptions?: ApolloReactHooks.QueryHookOptions<GetOrganizationIdQuery, GetOrganizationIdQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<GetOrganizationIdQuery, GetOrganizationIdQueryVariables>(GetOrganizationIdDocument, options);
      }
export function useGetOrganizationIdLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<GetOrganizationIdQuery, GetOrganizationIdQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<GetOrganizationIdQuery, GetOrganizationIdQueryVariables>(GetOrganizationIdDocument, options);
        }
export type GetOrganizationIdQueryHookResult = ReturnType<typeof useGetOrganizationIdQuery>;
export type GetOrganizationIdLazyQueryHookResult = ReturnType<typeof useGetOrganizationIdLazyQuery>;
export type GetOrganizationIdQueryResult = ApolloReactCommon.QueryResult<GetOrganizationIdQuery, GetOrganizationIdQueryVariables>;
export const GetUnitBankingApplicationStageDocument = gql`
    query GetUnitBankingApplicationStage($orgId: String) {
  GetGinzaApplicationForms(orgID: $orgId) {
    stage
  }
}
    `;

/**
 * __useGetUnitBankingApplicationStageQuery__
 *
 * To run a query within a React component, call `useGetUnitBankingApplicationStageQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetUnitBankingApplicationStageQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetUnitBankingApplicationStageQuery({
 *   variables: {
 *      orgId: // value for 'orgId'
 *   },
 * });
 */
export function useGetUnitBankingApplicationStageQuery(baseOptions?: ApolloReactHooks.QueryHookOptions<GetUnitBankingApplicationStageQuery, GetUnitBankingApplicationStageQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<GetUnitBankingApplicationStageQuery, GetUnitBankingApplicationStageQueryVariables>(GetUnitBankingApplicationStageDocument, options);
      }
export function useGetUnitBankingApplicationStageLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<GetUnitBankingApplicationStageQuery, GetUnitBankingApplicationStageQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<GetUnitBankingApplicationStageQuery, GetUnitBankingApplicationStageQueryVariables>(GetUnitBankingApplicationStageDocument, options);
        }
export type GetUnitBankingApplicationStageQueryHookResult = ReturnType<typeof useGetUnitBankingApplicationStageQuery>;
export type GetUnitBankingApplicationStageLazyQueryHookResult = ReturnType<typeof useGetUnitBankingApplicationStageLazyQuery>;
export type GetUnitBankingApplicationStageQueryResult = ApolloReactCommon.QueryResult<GetUnitBankingApplicationStageQuery, GetUnitBankingApplicationStageQueryVariables>;
export const GetClientImportDataDocument = gql`
    query GetClientImportData($searchTerm: String!) {
  homeownerSearch(admin: true, searchTerm: $searchTerm) {
    nodes {
      id
      ...ClientImportHomeowner
    }
  }
}
    ${ClientImportHomeownerFragmentDoc}`;

/**
 * __useGetClientImportDataQuery__
 *
 * To run a query within a React component, call `useGetClientImportDataQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetClientImportDataQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetClientImportDataQuery({
 *   variables: {
 *      searchTerm: // value for 'searchTerm'
 *   },
 * });
 */
export function useGetClientImportDataQuery(baseOptions: ApolloReactHooks.QueryHookOptions<GetClientImportDataQuery, GetClientImportDataQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<GetClientImportDataQuery, GetClientImportDataQueryVariables>(GetClientImportDataDocument, options);
      }
export function useGetClientImportDataLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<GetClientImportDataQuery, GetClientImportDataQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<GetClientImportDataQuery, GetClientImportDataQueryVariables>(GetClientImportDataDocument, options);
        }
export type GetClientImportDataQueryHookResult = ReturnType<typeof useGetClientImportDataQuery>;
export type GetClientImportDataLazyQueryHookResult = ReturnType<typeof useGetClientImportDataLazyQuery>;
export type GetClientImportDataQueryResult = ApolloReactCommon.QueryResult<GetClientImportDataQuery, GetClientImportDataQueryVariables>;
export const GetContractHomeownerNameDocument = gql`
    query getContractHomeownerName {
  organization {
    id
    contractServiceAccount {
      id
      contracts {
        nodes {
          id
          receiverSignature {
            signer {
              id
              fullName
              email
            }
          }
        }
      }
    }
  }
}
    `;

/**
 * __useGetContractHomeownerNameQuery__
 *
 * To run a query within a React component, call `useGetContractHomeownerNameQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetContractHomeownerNameQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetContractHomeownerNameQuery({
 *   variables: {
 *   },
 * });
 */
export function useGetContractHomeownerNameQuery(baseOptions?: ApolloReactHooks.QueryHookOptions<GetContractHomeownerNameQuery, GetContractHomeownerNameQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<GetContractHomeownerNameQuery, GetContractHomeownerNameQueryVariables>(GetContractHomeownerNameDocument, options);
      }
export function useGetContractHomeownerNameLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<GetContractHomeownerNameQuery, GetContractHomeownerNameQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<GetContractHomeownerNameQuery, GetContractHomeownerNameQueryVariables>(GetContractHomeownerNameDocument, options);
        }
export type GetContractHomeownerNameQueryHookResult = ReturnType<typeof useGetContractHomeownerNameQuery>;
export type GetContractHomeownerNameLazyQueryHookResult = ReturnType<typeof useGetContractHomeownerNameLazyQuery>;
export type GetContractHomeownerNameQueryResult = ApolloReactCommon.QueryResult<GetContractHomeownerNameQuery, GetContractHomeownerNameQueryVariables>;
export const ContractServiceAccountStatusDocument = gql`
    query ContractServiceAccountStatus {
  contractor {
    id
    admin
  }
  organization {
    id
    contractServiceAccount {
      id
      termsAgreedAt
      contracts {
        nodes {
          id
          ...ClientViewContractIndex
        }
      }
    }
  }
}
    ${ClientViewContractIndexFragmentDoc}`;

/**
 * __useContractServiceAccountStatusQuery__
 *
 * To run a query within a React component, call `useContractServiceAccountStatusQuery` and pass it any options that fit your needs.
 * When your component renders, `useContractServiceAccountStatusQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useContractServiceAccountStatusQuery({
 *   variables: {
 *   },
 * });
 */
export function useContractServiceAccountStatusQuery(baseOptions?: ApolloReactHooks.QueryHookOptions<ContractServiceAccountStatusQuery, ContractServiceAccountStatusQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<ContractServiceAccountStatusQuery, ContractServiceAccountStatusQueryVariables>(ContractServiceAccountStatusDocument, options);
      }
export function useContractServiceAccountStatusLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<ContractServiceAccountStatusQuery, ContractServiceAccountStatusQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<ContractServiceAccountStatusQuery, ContractServiceAccountStatusQueryVariables>(ContractServiceAccountStatusDocument, options);
        }
export type ContractServiceAccountStatusQueryHookResult = ReturnType<typeof useContractServiceAccountStatusQuery>;
export type ContractServiceAccountStatusLazyQueryHookResult = ReturnType<typeof useContractServiceAccountStatusLazyQuery>;
export type ContractServiceAccountStatusQueryResult = ApolloReactCommon.QueryResult<ContractServiceAccountStatusQuery, ContractServiceAccountStatusQueryVariables>;
export const GetClientDetailContractDocument = gql`
    query getClientDetailContract($contractId: ID!) {
  contractServiceContract(id: $contractId) {
    id
    ...ClientContractDetailContract
  }
}
    ${ClientContractDetailContractFragmentDoc}`;

/**
 * __useGetClientDetailContractQuery__
 *
 * To run a query within a React component, call `useGetClientDetailContractQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetClientDetailContractQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetClientDetailContractQuery({
 *   variables: {
 *      contractId: // value for 'contractId'
 *   },
 * });
 */
export function useGetClientDetailContractQuery(baseOptions: ApolloReactHooks.QueryHookOptions<GetClientDetailContractQuery, GetClientDetailContractQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<GetClientDetailContractQuery, GetClientDetailContractQueryVariables>(GetClientDetailContractDocument, options);
      }
export function useGetClientDetailContractLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<GetClientDetailContractQuery, GetClientDetailContractQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<GetClientDetailContractQuery, GetClientDetailContractQueryVariables>(GetClientDetailContractDocument, options);
        }
export type GetClientDetailContractQueryHookResult = ReturnType<typeof useGetClientDetailContractQuery>;
export type GetClientDetailContractLazyQueryHookResult = ReturnType<typeof useGetClientDetailContractLazyQuery>;
export type GetClientDetailContractQueryResult = ApolloReactCommon.QueryResult<GetClientDetailContractQuery, GetClientDetailContractQueryVariables>;
export const GetFinancingClientDetailsDocument = gql`
    query GetFinancingClientDetails($homeownerId: String!, $events: [HearthEventEventTypes!]!, $scope: HearthEventScope) {
  homeowner(id: $homeownerId) {
    id
    ...FinancingDetailHomeowner
  }
}
    ${FinancingDetailHomeownerFragmentDoc}`;

/**
 * __useGetFinancingClientDetailsQuery__
 *
 * To run a query within a React component, call `useGetFinancingClientDetailsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetFinancingClientDetailsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetFinancingClientDetailsQuery({
 *   variables: {
 *      homeownerId: // value for 'homeownerId'
 *      events: // value for 'events'
 *      scope: // value for 'scope'
 *   },
 * });
 */
export function useGetFinancingClientDetailsQuery(baseOptions: ApolloReactHooks.QueryHookOptions<GetFinancingClientDetailsQuery, GetFinancingClientDetailsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<GetFinancingClientDetailsQuery, GetFinancingClientDetailsQueryVariables>(GetFinancingClientDetailsDocument, options);
      }
export function useGetFinancingClientDetailsLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<GetFinancingClientDetailsQuery, GetFinancingClientDetailsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<GetFinancingClientDetailsQuery, GetFinancingClientDetailsQueryVariables>(GetFinancingClientDetailsDocument, options);
        }
export type GetFinancingClientDetailsQueryHookResult = ReturnType<typeof useGetFinancingClientDetailsQuery>;
export type GetFinancingClientDetailsLazyQueryHookResult = ReturnType<typeof useGetFinancingClientDetailsLazyQuery>;
export type GetFinancingClientDetailsQueryResult = ApolloReactCommon.QueryResult<GetFinancingClientDetailsQuery, GetFinancingClientDetailsQueryVariables>;
export const GetClientDetailsInvoiceDocument = gql`
    query GetClientDetailsInvoice($invoiceId: ID!) {
  connectInvoice(id: $invoiceId) {
    id
    ...ClientDetailInvoice
    homeowner {
      fullName
      id
      primaryLoanInquiry {
        id
        address
        city
        state
        zipCode
      }
    }
    viewableActivities {
      nodes {
        id
        ...ClientDetailInvoiceActivity
      }
    }
    contractor {
      id
      fullName
    }
  }
}
    ${ClientDetailInvoiceFragmentDoc}
${ClientDetailInvoiceActivityFragmentDoc}`;

/**
 * __useGetClientDetailsInvoiceQuery__
 *
 * To run a query within a React component, call `useGetClientDetailsInvoiceQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetClientDetailsInvoiceQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetClientDetailsInvoiceQuery({
 *   variables: {
 *      invoiceId: // value for 'invoiceId'
 *   },
 * });
 */
export function useGetClientDetailsInvoiceQuery(baseOptions: ApolloReactHooks.QueryHookOptions<GetClientDetailsInvoiceQuery, GetClientDetailsInvoiceQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<GetClientDetailsInvoiceQuery, GetClientDetailsInvoiceQueryVariables>(GetClientDetailsInvoiceDocument, options);
      }
export function useGetClientDetailsInvoiceLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<GetClientDetailsInvoiceQuery, GetClientDetailsInvoiceQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<GetClientDetailsInvoiceQuery, GetClientDetailsInvoiceQueryVariables>(GetClientDetailsInvoiceDocument, options);
        }
export type GetClientDetailsInvoiceQueryHookResult = ReturnType<typeof useGetClientDetailsInvoiceQuery>;
export type GetClientDetailsInvoiceLazyQueryHookResult = ReturnType<typeof useGetClientDetailsInvoiceLazyQuery>;
export type GetClientDetailsInvoiceQueryResult = ApolloReactCommon.QueryResult<GetClientDetailsInvoiceQuery, GetClientDetailsInvoiceQueryVariables>;
export const GetClientDetailsRecentActivityDocument = gql`
    query GetClientDetailsRecentActivity($homeownerId: String!, $events: [HearthEventEventTypes!]!, $scope: HearthEventScope) {
  homeowner(id: $homeownerId) {
    id
    selectedHearthEvents(events: $events, scope: $scope) {
      nodes {
        id
        ...ClientViewEvent
      }
    }
  }
}
    ${ClientViewEventFragmentDoc}`;

/**
 * __useGetClientDetailsRecentActivityQuery__
 *
 * To run a query within a React component, call `useGetClientDetailsRecentActivityQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetClientDetailsRecentActivityQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetClientDetailsRecentActivityQuery({
 *   variables: {
 *      homeownerId: // value for 'homeownerId'
 *      events: // value for 'events'
 *      scope: // value for 'scope'
 *   },
 * });
 */
export function useGetClientDetailsRecentActivityQuery(baseOptions: ApolloReactHooks.QueryHookOptions<GetClientDetailsRecentActivityQuery, GetClientDetailsRecentActivityQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<GetClientDetailsRecentActivityQuery, GetClientDetailsRecentActivityQueryVariables>(GetClientDetailsRecentActivityDocument, options);
      }
export function useGetClientDetailsRecentActivityLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<GetClientDetailsRecentActivityQuery, GetClientDetailsRecentActivityQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<GetClientDetailsRecentActivityQuery, GetClientDetailsRecentActivityQueryVariables>(GetClientDetailsRecentActivityDocument, options);
        }
export type GetClientDetailsRecentActivityQueryHookResult = ReturnType<typeof useGetClientDetailsRecentActivityQuery>;
export type GetClientDetailsRecentActivityLazyQueryHookResult = ReturnType<typeof useGetClientDetailsRecentActivityLazyQuery>;
export type GetClientDetailsRecentActivityQueryResult = ApolloReactCommon.QueryResult<GetClientDetailsRecentActivityQuery, GetClientDetailsRecentActivityQueryVariables>;
export const GetClientDetailQuoteDocument = gql`
    query GetClientDetailQuote($quoteId: ID!) {
  quote(id: $quoteId) {
    id
    ...ClientDetailQuote
  }
  organization {
    id
    ...ClientDetailQuoteOrganization
  }
  contractor {
    id
    ...ClientDetailQuoteContractor
  }
}
    ${ClientDetailQuoteFragmentDoc}
${ClientDetailQuoteOrganizationFragmentDoc}
${ClientDetailQuoteContractorFragmentDoc}`;

/**
 * __useGetClientDetailQuoteQuery__
 *
 * To run a query within a React component, call `useGetClientDetailQuoteQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetClientDetailQuoteQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetClientDetailQuoteQuery({
 *   variables: {
 *      quoteId: // value for 'quoteId'
 *   },
 * });
 */
export function useGetClientDetailQuoteQuery(baseOptions: ApolloReactHooks.QueryHookOptions<GetClientDetailQuoteQuery, GetClientDetailQuoteQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<GetClientDetailQuoteQuery, GetClientDetailQuoteQueryVariables>(GetClientDetailQuoteDocument, options);
      }
export function useGetClientDetailQuoteLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<GetClientDetailQuoteQuery, GetClientDetailQuoteQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<GetClientDetailQuoteQuery, GetClientDetailQuoteQueryVariables>(GetClientDetailQuoteDocument, options);
        }
export type GetClientDetailQuoteQueryHookResult = ReturnType<typeof useGetClientDetailQuoteQuery>;
export type GetClientDetailQuoteLazyQueryHookResult = ReturnType<typeof useGetClientDetailQuoteLazyQuery>;
export type GetClientDetailQuoteQueryResult = ApolloReactCommon.QueryResult<GetClientDetailQuoteQuery, GetClientDetailQuoteQueryVariables>;
export const QuoteCancelDocument = gql`
    mutation QuoteCancel($quoteId: ID!) {
  quoteCancel(quoteId: $quoteId) {
    ... on QuoteCancelSuccess {
      quote {
        id
      }
    }
    ... on QuoteCancelFailure {
      errors {
        message
        path
        code
      }
    }
  }
}
    `;

/**
 * __useQuoteCancelMutation__
 *
 * To run a mutation, you first call `useQuoteCancelMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useQuoteCancelMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [quoteCancelMutation, { data, loading, error }] = useQuoteCancelMutation({
 *   variables: {
 *      quoteId: // value for 'quoteId'
 *   },
 * });
 */
export function useQuoteCancelMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<QuoteCancelMutation, QuoteCancelMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useMutation<QuoteCancelMutation, QuoteCancelMutationVariables>(QuoteCancelDocument, options);
      }
export type QuoteCancelMutationHookResult = ReturnType<typeof useQuoteCancelMutation>;
export type QuoteCancelMutationResult = ApolloReactCommon.MutationResult<QuoteCancelMutation>;
export type QuoteCancelMutationOptions = ApolloReactCommon.BaseMutationOptions<QuoteCancelMutation, QuoteCancelMutationVariables>;
export const QuoteResendDocument = gql`
    mutation QuoteResend($quoteId: ID!) {
  quoteResend(quoteId: $quoteId) {
    ... on QuoteResendSuccess {
      quote {
        id
      }
    }
    ... on QuoteResendFailure {
      errors {
        message
        path
        code
      }
    }
  }
}
    `;

/**
 * __useQuoteResendMutation__
 *
 * To run a mutation, you first call `useQuoteResendMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useQuoteResendMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [quoteResendMutation, { data, loading, error }] = useQuoteResendMutation({
 *   variables: {
 *      quoteId: // value for 'quoteId'
 *   },
 * });
 */
export function useQuoteResendMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<QuoteResendMutation, QuoteResendMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useMutation<QuoteResendMutation, QuoteResendMutationVariables>(QuoteResendDocument, options);
      }
export type QuoteResendMutationHookResult = ReturnType<typeof useQuoteResendMutation>;
export type QuoteResendMutationResult = ApolloReactCommon.MutationResult<QuoteResendMutation>;
export type QuoteResendMutationOptions = ApolloReactCommon.BaseMutationOptions<QuoteResendMutation, QuoteResendMutationVariables>;
export const UpsertHomeownerDocument = gql`
    mutation UpsertHomeowner($homeownerId: ID, $firstName: String!, $lastName: String!, $phoneNumber: String!, $email: String!, $defaultAddress: AddressAttributes) {
  upsertHomeowner(
    homeownerId: $homeownerId
    firstName: $firstName
    lastName: $lastName
    phoneNumber: $phoneNumber
    email: $email
    defaultAddress: $defaultAddress
  ) {
    ... on UpsertHomeownerSuccess {
      homeowner {
        id
        defaultHomeownerAddress {
          id
        }
      }
    }
    ... on UpsertHomeownerFailure {
      errors {
        message
        path
        code
      }
    }
  }
}
    `;

/**
 * __useUpsertHomeownerMutation__
 *
 * To run a mutation, you first call `useUpsertHomeownerMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpsertHomeownerMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [upsertHomeownerMutation, { data, loading, error }] = useUpsertHomeownerMutation({
 *   variables: {
 *      homeownerId: // value for 'homeownerId'
 *      firstName: // value for 'firstName'
 *      lastName: // value for 'lastName'
 *      phoneNumber: // value for 'phoneNumber'
 *      email: // value for 'email'
 *      defaultAddress: // value for 'defaultAddress'
 *   },
 * });
 */
export function useUpsertHomeownerMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<UpsertHomeownerMutation, UpsertHomeownerMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useMutation<UpsertHomeownerMutation, UpsertHomeownerMutationVariables>(UpsertHomeownerDocument, options);
      }
export type UpsertHomeownerMutationHookResult = ReturnType<typeof useUpsertHomeownerMutation>;
export type UpsertHomeownerMutationResult = ApolloReactCommon.MutationResult<UpsertHomeownerMutation>;
export type UpsertHomeownerMutationOptions = ApolloReactCommon.BaseMutationOptions<UpsertHomeownerMutation, UpsertHomeownerMutationVariables>;
export const GetClientOverviewDocument = gql`
    query GetClientOverview($homeownerId: String!, $events: [HearthEventEventTypes!]!, $scope: HearthEventScope) {
  homeowner(id: $homeownerId) {
    id
    ...ClientDetailOverview
    connectInvoices {
      nodes {
        id
        ...ClientOverviewInvoice
      }
    }
    contractServiceSignatures {
      nodes {
        id
        contract {
          id
          ...ClientDetailContract
        }
      }
    }
    quotes {
      nodes {
        id
        ...ClientQuoteDetails
      }
    }
  }
  contractor {
    id
    paymentsRole
    paymentsAdmin
    admin
  }
  organization {
    id
    stripeConnectAccount {
      id
      status
    }
    contractServiceAccount {
      id
      termsAgreedAt
    }
  }
}
    ${ClientDetailOverviewFragmentDoc}
${ClientOverviewInvoiceFragmentDoc}
${ClientDetailContractFragmentDoc}
${ClientQuoteDetailsFragmentDoc}`;

/**
 * __useGetClientOverviewQuery__
 *
 * To run a query within a React component, call `useGetClientOverviewQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetClientOverviewQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetClientOverviewQuery({
 *   variables: {
 *      homeownerId: // value for 'homeownerId'
 *      events: // value for 'events'
 *      scope: // value for 'scope'
 *   },
 * });
 */
export function useGetClientOverviewQuery(baseOptions: ApolloReactHooks.QueryHookOptions<GetClientOverviewQuery, GetClientOverviewQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<GetClientOverviewQuery, GetClientOverviewQueryVariables>(GetClientOverviewDocument, options);
      }
export function useGetClientOverviewLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<GetClientOverviewQuery, GetClientOverviewQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<GetClientOverviewQuery, GetClientOverviewQueryVariables>(GetClientOverviewDocument, options);
        }
export type GetClientOverviewQueryHookResult = ReturnType<typeof useGetClientOverviewQuery>;
export type GetClientOverviewLazyQueryHookResult = ReturnType<typeof useGetClientOverviewLazyQuery>;
export type GetClientOverviewQueryResult = ApolloReactCommon.QueryResult<GetClientOverviewQuery, GetClientOverviewQueryVariables>;
export const AddNewButtonDocument = gql`
    query AddNewButton {
  organization {
    id
    stripeConnectAccount {
      id
      status
      fullAccess
    }
    contractServiceAccount {
      id
      termsAgreedAt
    }
  }
  contractor {
    id
    admin
    role
    paymentsRole
    trainingCompleted
  }
}
    `;

/**
 * __useAddNewButtonQuery__
 *
 * To run a query within a React component, call `useAddNewButtonQuery` and pass it any options that fit your needs.
 * When your component renders, `useAddNewButtonQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useAddNewButtonQuery({
 *   variables: {
 *   },
 * });
 */
export function useAddNewButtonQuery(baseOptions?: ApolloReactHooks.QueryHookOptions<AddNewButtonQuery, AddNewButtonQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<AddNewButtonQuery, AddNewButtonQueryVariables>(AddNewButtonDocument, options);
      }
export function useAddNewButtonLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<AddNewButtonQuery, AddNewButtonQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<AddNewButtonQuery, AddNewButtonQueryVariables>(AddNewButtonDocument, options);
        }
export type AddNewButtonQueryHookResult = ReturnType<typeof useAddNewButtonQuery>;
export type AddNewButtonLazyQueryHookResult = ReturnType<typeof useAddNewButtonLazyQuery>;
export type AddNewButtonQueryResult = ApolloReactCommon.QueryResult<AddNewButtonQuery, AddNewButtonQueryVariables>;
export const ClientViewMenuDocument = gql`
    query ClientViewMenu {
  contractor {
    id
    admin
    paymentsRole
    customSettings {
      clientViewViewByTooltipSeen
    }
  }
  organization {
    id
    stripeConnectAccount {
      id
      fullAccess
    }
    contractServiceAccount {
      id
      termsAgreedAt
    }
  }
}
    `;

/**
 * __useClientViewMenuQuery__
 *
 * To run a query within a React component, call `useClientViewMenuQuery` and pass it any options that fit your needs.
 * When your component renders, `useClientViewMenuQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useClientViewMenuQuery({
 *   variables: {
 *   },
 * });
 */
export function useClientViewMenuQuery(baseOptions?: ApolloReactHooks.QueryHookOptions<ClientViewMenuQuery, ClientViewMenuQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<ClientViewMenuQuery, ClientViewMenuQueryVariables>(ClientViewMenuDocument, options);
      }
export function useClientViewMenuLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<ClientViewMenuQuery, ClientViewMenuQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<ClientViewMenuQuery, ClientViewMenuQueryVariables>(ClientViewMenuDocument, options);
        }
export type ClientViewMenuQueryHookResult = ReturnType<typeof useClientViewMenuQuery>;
export type ClientViewMenuLazyQueryHookResult = ReturnType<typeof useClientViewMenuLazyQuery>;
export type ClientViewMenuQueryResult = ApolloReactCommon.QueryResult<ClientViewMenuQuery, ClientViewMenuQueryVariables>;
export const SetClientViewViewBySeenDocument = gql`
    mutation SetClientViewViewBySeen($customSettings: CustomContractorSettingsAttributes!) {
  upsertContractor(customSettings: $customSettings) {
    ... on UpsertContractorSuccess {
      contractor {
        id
        customSettings {
          clientViewViewByTooltipSeen
        }
      }
    }
    ... on UpsertContractorFailure {
      errors {
        message
        path
        code
      }
    }
  }
}
    `;

/**
 * __useSetClientViewViewBySeenMutation__
 *
 * To run a mutation, you first call `useSetClientViewViewBySeenMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useSetClientViewViewBySeenMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [setClientViewViewBySeenMutation, { data, loading, error }] = useSetClientViewViewBySeenMutation({
 *   variables: {
 *      customSettings: // value for 'customSettings'
 *   },
 * });
 */
export function useSetClientViewViewBySeenMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<SetClientViewViewBySeenMutation, SetClientViewViewBySeenMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useMutation<SetClientViewViewBySeenMutation, SetClientViewViewBySeenMutationVariables>(SetClientViewViewBySeenDocument, options);
      }
export type SetClientViewViewBySeenMutationHookResult = ReturnType<typeof useSetClientViewViewBySeenMutation>;
export type SetClientViewViewBySeenMutationResult = ApolloReactCommon.MutationResult<SetClientViewViewBySeenMutation>;
export type SetClientViewViewBySeenMutationOptions = ApolloReactCommon.BaseMutationOptions<SetClientViewViewBySeenMutation, SetClientViewViewBySeenMutationVariables>;
export const GetClientIndexContractorAndOrganizationDocument = gql`
    query GetClientIndexContractorAndOrganization {
  contractor {
    id
    role
    paymentsRole
    admin
  }
  organization {
    id
    stripeConnectAccount {
      id
      status
      fullAccess
    }
    contractServiceAccount {
      id
      termsAgreedAt
    }
  }
}
    `;

/**
 * __useGetClientIndexContractorAndOrganizationQuery__
 *
 * To run a query within a React component, call `useGetClientIndexContractorAndOrganizationQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetClientIndexContractorAndOrganizationQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetClientIndexContractorAndOrganizationQuery({
 *   variables: {
 *   },
 * });
 */
export function useGetClientIndexContractorAndOrganizationQuery(baseOptions?: ApolloReactHooks.QueryHookOptions<GetClientIndexContractorAndOrganizationQuery, GetClientIndexContractorAndOrganizationQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<GetClientIndexContractorAndOrganizationQuery, GetClientIndexContractorAndOrganizationQueryVariables>(GetClientIndexContractorAndOrganizationDocument, options);
      }
export function useGetClientIndexContractorAndOrganizationLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<GetClientIndexContractorAndOrganizationQuery, GetClientIndexContractorAndOrganizationQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<GetClientIndexContractorAndOrganizationQuery, GetClientIndexContractorAndOrganizationQueryVariables>(GetClientIndexContractorAndOrganizationDocument, options);
        }
export type GetClientIndexContractorAndOrganizationQueryHookResult = ReturnType<typeof useGetClientIndexContractorAndOrganizationQuery>;
export type GetClientIndexContractorAndOrganizationLazyQueryHookResult = ReturnType<typeof useGetClientIndexContractorAndOrganizationLazyQuery>;
export type GetClientIndexContractorAndOrganizationQueryResult = ApolloReactCommon.QueryResult<GetClientIndexContractorAndOrganizationQuery, GetClientIndexContractorAndOrganizationQueryVariables>;
export const GetClientsDocument = gql`
    query GetClients($admin: Boolean, $type: HomeownerEventBucket, $orderBy: HomeownerOrderers, $searchTerm: String, $afterCursor: String) {
  homeownerSearch(
    admin: $admin
    type: $type
    orderBy: $orderBy
    first: 20
    searchTerm: $searchTerm
    after: $afterCursor
  ) {
    edges {
      node {
        id
        ...IndexClient
      }
    }
    pageInfo {
      startCursor
      endCursor
      hasNextPage
      hasPreviousPage
    }
    totalCount
  }
}
    ${IndexClientFragmentDoc}`;

/**
 * __useGetClientsQuery__
 *
 * To run a query within a React component, call `useGetClientsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetClientsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetClientsQuery({
 *   variables: {
 *      admin: // value for 'admin'
 *      type: // value for 'type'
 *      orderBy: // value for 'orderBy'
 *      searchTerm: // value for 'searchTerm'
 *      afterCursor: // value for 'afterCursor'
 *   },
 * });
 */
export function useGetClientsQuery(baseOptions?: ApolloReactHooks.QueryHookOptions<GetClientsQuery, GetClientsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<GetClientsQuery, GetClientsQueryVariables>(GetClientsDocument, options);
      }
export function useGetClientsLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<GetClientsQuery, GetClientsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<GetClientsQuery, GetClientsQueryVariables>(GetClientsDocument, options);
        }
export type GetClientsQueryHookResult = ReturnType<typeof useGetClientsQuery>;
export type GetClientsLazyQueryHookResult = ReturnType<typeof useGetClientsLazyQuery>;
export type GetClientsQueryResult = ApolloReactCommon.QueryResult<GetClientsQuery, GetClientsQueryVariables>;
export const ContractorPaymentsRoleDocument = gql`
    query ContractorPaymentsRole {
  contractor {
    id
    paymentsRole
  }
}
    `;

/**
 * __useContractorPaymentsRoleQuery__
 *
 * To run a query within a React component, call `useContractorPaymentsRoleQuery` and pass it any options that fit your needs.
 * When your component renders, `useContractorPaymentsRoleQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useContractorPaymentsRoleQuery({
 *   variables: {
 *   },
 * });
 */
export function useContractorPaymentsRoleQuery(baseOptions?: ApolloReactHooks.QueryHookOptions<ContractorPaymentsRoleQuery, ContractorPaymentsRoleQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<ContractorPaymentsRoleQuery, ContractorPaymentsRoleQueryVariables>(ContractorPaymentsRoleDocument, options);
      }
export function useContractorPaymentsRoleLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<ContractorPaymentsRoleQuery, ContractorPaymentsRoleQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<ContractorPaymentsRoleQuery, ContractorPaymentsRoleQueryVariables>(ContractorPaymentsRoleDocument, options);
        }
export type ContractorPaymentsRoleQueryHookResult = ReturnType<typeof useContractorPaymentsRoleQuery>;
export type ContractorPaymentsRoleLazyQueryHookResult = ReturnType<typeof useContractorPaymentsRoleLazyQuery>;
export type ContractorPaymentsRoleQueryResult = ApolloReactCommon.QueryResult<ContractorPaymentsRoleQuery, ContractorPaymentsRoleQueryVariables>;
export const ClientInvoiceIndexDocument = gql`
    query ClientInvoiceIndex {
  contractor {
    id
    paymentsRole
    authorizedViewableConnectInvoices {
      nodes {
        id
        ...ClientInvoiceIndexConnectInvoice
      }
    }
  }
}
    ${ClientInvoiceIndexConnectInvoiceFragmentDoc}`;

/**
 * __useClientInvoiceIndexQuery__
 *
 * To run a query within a React component, call `useClientInvoiceIndexQuery` and pass it any options that fit your needs.
 * When your component renders, `useClientInvoiceIndexQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useClientInvoiceIndexQuery({
 *   variables: {
 *   },
 * });
 */
export function useClientInvoiceIndexQuery(baseOptions?: ApolloReactHooks.QueryHookOptions<ClientInvoiceIndexQuery, ClientInvoiceIndexQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<ClientInvoiceIndexQuery, ClientInvoiceIndexQueryVariables>(ClientInvoiceIndexDocument, options);
      }
export function useClientInvoiceIndexLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<ClientInvoiceIndexQuery, ClientInvoiceIndexQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<ClientInvoiceIndexQuery, ClientInvoiceIndexQueryVariables>(ClientInvoiceIndexDocument, options);
        }
export type ClientInvoiceIndexQueryHookResult = ReturnType<typeof useClientInvoiceIndexQuery>;
export type ClientInvoiceIndexLazyQueryHookResult = ReturnType<typeof useClientInvoiceIndexLazyQuery>;
export type ClientInvoiceIndexQueryResult = ApolloReactCommon.QueryResult<ClientInvoiceIndexQuery, ClientInvoiceIndexQueryVariables>;
export const FetchAccountBalanceDocument = gql`
    query FetchAccountBalance {
  contractor {
    id
    paidPaymentsAmount
    unpaidPaymentsAmount
    overduePaymentsAmount
    paymentsRole
  }
  organization {
    id
    stripeConnectAccount {
      id
      balance
      pendingBalance
    }
  }
}
    `;

/**
 * __useFetchAccountBalanceQuery__
 *
 * To run a query within a React component, call `useFetchAccountBalanceQuery` and pass it any options that fit your needs.
 * When your component renders, `useFetchAccountBalanceQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useFetchAccountBalanceQuery({
 *   variables: {
 *   },
 * });
 */
export function useFetchAccountBalanceQuery(baseOptions?: ApolloReactHooks.QueryHookOptions<FetchAccountBalanceQuery, FetchAccountBalanceQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<FetchAccountBalanceQuery, FetchAccountBalanceQueryVariables>(FetchAccountBalanceDocument, options);
      }
export function useFetchAccountBalanceLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<FetchAccountBalanceQuery, FetchAccountBalanceQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<FetchAccountBalanceQuery, FetchAccountBalanceQueryVariables>(FetchAccountBalanceDocument, options);
        }
export type FetchAccountBalanceQueryHookResult = ReturnType<typeof useFetchAccountBalanceQuery>;
export type FetchAccountBalanceLazyQueryHookResult = ReturnType<typeof useFetchAccountBalanceLazyQuery>;
export type FetchAccountBalanceQueryResult = ApolloReactCommon.QueryResult<FetchAccountBalanceQuery, FetchAccountBalanceQueryVariables>;
export const GetClientViewContainerDocument = gql`
    query GetClientViewContainer {
  contractor {
    id
    demoMode
  }
}
    `;

/**
 * __useGetClientViewContainerQuery__
 *
 * To run a query within a React component, call `useGetClientViewContainerQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetClientViewContainerQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetClientViewContainerQuery({
 *   variables: {
 *   },
 * });
 */
export function useGetClientViewContainerQuery(baseOptions?: ApolloReactHooks.QueryHookOptions<GetClientViewContainerQuery, GetClientViewContainerQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<GetClientViewContainerQuery, GetClientViewContainerQueryVariables>(GetClientViewContainerDocument, options);
      }
export function useGetClientViewContainerLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<GetClientViewContainerQuery, GetClientViewContainerQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<GetClientViewContainerQuery, GetClientViewContainerQueryVariables>(GetClientViewContainerDocument, options);
        }
export type GetClientViewContainerQueryHookResult = ReturnType<typeof useGetClientViewContainerQuery>;
export type GetClientViewContainerLazyQueryHookResult = ReturnType<typeof useGetClientViewContainerLazyQuery>;
export type GetClientViewContainerQueryResult = ApolloReactCommon.QueryResult<GetClientViewContainerQuery, GetClientViewContainerQueryVariables>;
export const GetClientContractDocument = gql`
    query getClientContract($contractId: ID!) {
  contractServiceContract(id: $contractId) {
    id
    contractNumber
    name
    status
    dueDate
    createdAt
    base64Pdf
    creatorId
    name
  }
}
    `;

/**
 * __useGetClientContractQuery__
 *
 * To run a query within a React component, call `useGetClientContractQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetClientContractQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetClientContractQuery({
 *   variables: {
 *      contractId: // value for 'contractId'
 *   },
 * });
 */
export function useGetClientContractQuery(baseOptions: ApolloReactHooks.QueryHookOptions<GetClientContractQuery, GetClientContractQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<GetClientContractQuery, GetClientContractQueryVariables>(GetClientContractDocument, options);
      }
export function useGetClientContractLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<GetClientContractQuery, GetClientContractQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<GetClientContractQuery, GetClientContractQueryVariables>(GetClientContractDocument, options);
        }
export type GetClientContractQueryHookResult = ReturnType<typeof useGetClientContractQuery>;
export type GetClientContractLazyQueryHookResult = ReturnType<typeof useGetClientContractLazyQuery>;
export type GetClientContractQueryResult = ApolloReactCommon.QueryResult<GetClientContractQuery, GetClientContractQueryVariables>;
export const ResendContractDocument = gql`
    mutation ResendContract($contractId: ID!) {
  contractServiceResendProjectContract(contractServiceContractId: $contractId) {
    ... on ContractServiceResendProjectContractSuccess {
      __typename
    }
    ... on ContractServiceResendProjectContractFailure {
      errors {
        message
        path
        code
      }
    }
  }
}
    `;

/**
 * __useResendContractMutation__
 *
 * To run a mutation, you first call `useResendContractMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useResendContractMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [resendContractMutation, { data, loading, error }] = useResendContractMutation({
 *   variables: {
 *      contractId: // value for 'contractId'
 *   },
 * });
 */
export function useResendContractMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<ResendContractMutation, ResendContractMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useMutation<ResendContractMutation, ResendContractMutationVariables>(ResendContractDocument, options);
      }
export type ResendContractMutationHookResult = ReturnType<typeof useResendContractMutation>;
export type ResendContractMutationResult = ApolloReactCommon.MutationResult<ResendContractMutation>;
export type ResendContractMutationOptions = ApolloReactCommon.BaseMutationOptions<ResendContractMutation, ResendContractMutationVariables>;
export const CancelContractDocument = gql`
    mutation CancelContract($contractId: ID!) {
  contractServiceCancelContract(contractServiceContractId: $contractId) {
    ... on ContractServiceCancelContractSuccess {
      contractServiceContract {
        id
      }
    }
    ... on ContractServiceCancelContractFailure {
      errors {
        message
        path
        code
      }
    }
  }
}
    `;

/**
 * __useCancelContractMutation__
 *
 * To run a mutation, you first call `useCancelContractMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCancelContractMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [cancelContractMutation, { data, loading, error }] = useCancelContractMutation({
 *   variables: {
 *      contractId: // value for 'contractId'
 *   },
 * });
 */
export function useCancelContractMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<CancelContractMutation, CancelContractMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useMutation<CancelContractMutation, CancelContractMutationVariables>(CancelContractDocument, options);
      }
export type CancelContractMutationHookResult = ReturnType<typeof useCancelContractMutation>;
export type CancelContractMutationResult = ApolloReactCommon.MutationResult<CancelContractMutation>;
export type CancelContractMutationOptions = ApolloReactCommon.BaseMutationOptions<CancelContractMutation, CancelContractMutationVariables>;
export const GetClientInvoiceDocument = gql`
    query GetClientInvoice($invoiceId: ID!) {
  connectInvoice(id: $invoiceId) {
    id
    ...ClientInvoice
    homeowner {
      id
      primaryLoanInquiry {
        id
        address
        city
        state
        zipCode
      }
    }
    contractor {
      id
      fullName
    }
  }
}
    ${ClientInvoiceFragmentDoc}`;

/**
 * __useGetClientInvoiceQuery__
 *
 * To run a query within a React component, call `useGetClientInvoiceQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetClientInvoiceQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetClientInvoiceQuery({
 *   variables: {
 *      invoiceId: // value for 'invoiceId'
 *   },
 * });
 */
export function useGetClientInvoiceQuery(baseOptions: ApolloReactHooks.QueryHookOptions<GetClientInvoiceQuery, GetClientInvoiceQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<GetClientInvoiceQuery, GetClientInvoiceQueryVariables>(GetClientInvoiceDocument, options);
      }
export function useGetClientInvoiceLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<GetClientInvoiceQuery, GetClientInvoiceQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<GetClientInvoiceQuery, GetClientInvoiceQueryVariables>(GetClientInvoiceDocument, options);
        }
export type GetClientInvoiceQueryHookResult = ReturnType<typeof useGetClientInvoiceQuery>;
export type GetClientInvoiceLazyQueryHookResult = ReturnType<typeof useGetClientInvoiceLazyQuery>;
export type GetClientInvoiceQueryResult = ApolloReactCommon.QueryResult<GetClientInvoiceQuery, GetClientInvoiceQueryVariables>;
export const ManuallyPayInvoiceDocument = gql`
    mutation ManuallyPayInvoice($connectInvoiceId: ID!, $paymentType: String!, $paymentDate: ISO8601DateTime!) {
  manuallyPayInvoice(
    connectInvoiceId: $connectInvoiceId
    paymentType: $paymentType
    paymentDate: $paymentDate
  ) {
    ... on ManuallyPayInvoiceSuccess {
      connectInvoice {
        id
      }
    }
    ... on ManuallyPayInvoiceFailure {
      errors {
        message
        path
        code
      }
    }
  }
}
    `;

/**
 * __useManuallyPayInvoiceMutation__
 *
 * To run a mutation, you first call `useManuallyPayInvoiceMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useManuallyPayInvoiceMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [manuallyPayInvoiceMutation, { data, loading, error }] = useManuallyPayInvoiceMutation({
 *   variables: {
 *      connectInvoiceId: // value for 'connectInvoiceId'
 *      paymentType: // value for 'paymentType'
 *      paymentDate: // value for 'paymentDate'
 *   },
 * });
 */
export function useManuallyPayInvoiceMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<ManuallyPayInvoiceMutation, ManuallyPayInvoiceMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useMutation<ManuallyPayInvoiceMutation, ManuallyPayInvoiceMutationVariables>(ManuallyPayInvoiceDocument, options);
      }
export type ManuallyPayInvoiceMutationHookResult = ReturnType<typeof useManuallyPayInvoiceMutation>;
export type ManuallyPayInvoiceMutationResult = ApolloReactCommon.MutationResult<ManuallyPayInvoiceMutation>;
export type ManuallyPayInvoiceMutationOptions = ApolloReactCommon.BaseMutationOptions<ManuallyPayInvoiceMutation, ManuallyPayInvoiceMutationVariables>;
export const SendPaymentReminderDocument = gql`
    mutation SendPaymentReminder($invoiceId: ID!, $mediums: [ContactMedium!]!) {
  sendHomeownerPaymentReminder(connectInvoiceId: $invoiceId, mediums: $mediums) {
    connectInvoice {
      id
    }
  }
}
    `;

/**
 * __useSendPaymentReminderMutation__
 *
 * To run a mutation, you first call `useSendPaymentReminderMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useSendPaymentReminderMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [sendPaymentReminderMutation, { data, loading, error }] = useSendPaymentReminderMutation({
 *   variables: {
 *      invoiceId: // value for 'invoiceId'
 *      mediums: // value for 'mediums'
 *   },
 * });
 */
export function useSendPaymentReminderMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<SendPaymentReminderMutation, SendPaymentReminderMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useMutation<SendPaymentReminderMutation, SendPaymentReminderMutationVariables>(SendPaymentReminderDocument, options);
      }
export type SendPaymentReminderMutationHookResult = ReturnType<typeof useSendPaymentReminderMutation>;
export type SendPaymentReminderMutationResult = ApolloReactCommon.MutationResult<SendPaymentReminderMutation>;
export type SendPaymentReminderMutationOptions = ApolloReactCommon.BaseMutationOptions<SendPaymentReminderMutation, SendPaymentReminderMutationVariables>;
export const CancelInvoiceDocument = gql`
    mutation CancelInvoice($connectInvoiceId: ID!) {
  cancelInvoice(connectInvoiceId: $connectInvoiceId) {
    ... on CancelInvoiceSuccess {
      connectInvoice {
        id
      }
    }
    ... on CancelInvoiceFailure {
      errors {
        message
        path
        code
      }
    }
  }
}
    `;

/**
 * __useCancelInvoiceMutation__
 *
 * To run a mutation, you first call `useCancelInvoiceMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCancelInvoiceMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [cancelInvoiceMutation, { data, loading, error }] = useCancelInvoiceMutation({
 *   variables: {
 *      connectInvoiceId: // value for 'connectInvoiceId'
 *   },
 * });
 */
export function useCancelInvoiceMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<CancelInvoiceMutation, CancelInvoiceMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useMutation<CancelInvoiceMutation, CancelInvoiceMutationVariables>(CancelInvoiceDocument, options);
      }
export type CancelInvoiceMutationHookResult = ReturnType<typeof useCancelInvoiceMutation>;
export type CancelInvoiceMutationResult = ApolloReactCommon.MutationResult<CancelInvoiceMutation>;
export type CancelInvoiceMutationOptions = ApolloReactCommon.BaseMutationOptions<CancelInvoiceMutation, CancelInvoiceMutationVariables>;
export const GetClientProfileDocument = gql`
    query GetClientProfile($homeownerId: String!, $events: [HearthEventEventTypes!]!, $scope: HearthEventScope) {
  homeowner(id: $homeownerId) {
    id
    ...ClientViewHomeowner
  }
  contractor {
    id
    role
    paymentsRole
    admin
  }
  organization {
    id
    stripeConnectAccount {
      id
      status
      fullAccess
    }
    contractServiceAccount {
      id
      ...ContractServiceAccountStatus
    }
  }
}
    ${ClientViewHomeownerFragmentDoc}
${ContractServiceAccountStatusFragmentDoc}`;

/**
 * __useGetClientProfileQuery__
 *
 * To run a query within a React component, call `useGetClientProfileQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetClientProfileQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetClientProfileQuery({
 *   variables: {
 *      homeownerId: // value for 'homeownerId'
 *      events: // value for 'events'
 *      scope: // value for 'scope'
 *   },
 * });
 */
export function useGetClientProfileQuery(baseOptions: ApolloReactHooks.QueryHookOptions<GetClientProfileQuery, GetClientProfileQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<GetClientProfileQuery, GetClientProfileQueryVariables>(GetClientProfileDocument, options);
      }
export function useGetClientProfileLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<GetClientProfileQuery, GetClientProfileQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<GetClientProfileQuery, GetClientProfileQueryVariables>(GetClientProfileDocument, options);
        }
export type GetClientProfileQueryHookResult = ReturnType<typeof useGetClientProfileQuery>;
export type GetClientProfileLazyQueryHookResult = ReturnType<typeof useGetClientProfileLazyQuery>;
export type GetClientProfileQueryResult = ApolloReactCommon.QueryResult<GetClientProfileQuery, GetClientProfileQueryVariables>;
export const ArchiveClientDocument = gql`
    mutation ArchiveClient($homeownerId: ID!, $contractorId: ID!, $archive: Boolean!) {
  archiveHomeowner(
    homeownerId: $homeownerId
    contractorId: $contractorId
    archive: $archive
  ) {
    ... on ArchiveHomeownerSuccess {
      homeowner {
        id
      }
      contractor {
        id
      }
    }
    ... on ArchiveHomeownerFailure {
      errors {
        message
        path
        code
      }
    }
  }
}
    `;

/**
 * __useArchiveClientMutation__
 *
 * To run a mutation, you first call `useArchiveClientMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useArchiveClientMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [archiveClientMutation, { data, loading, error }] = useArchiveClientMutation({
 *   variables: {
 *      homeownerId: // value for 'homeownerId'
 *      contractorId: // value for 'contractorId'
 *      archive: // value for 'archive'
 *   },
 * });
 */
export function useArchiveClientMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<ArchiveClientMutation, ArchiveClientMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useMutation<ArchiveClientMutation, ArchiveClientMutationVariables>(ArchiveClientDocument, options);
      }
export type ArchiveClientMutationHookResult = ReturnType<typeof useArchiveClientMutation>;
export type ArchiveClientMutationResult = ApolloReactCommon.MutationResult<ArchiveClientMutation>;
export type ArchiveClientMutationOptions = ApolloReactCommon.BaseMutationOptions<ArchiveClientMutation, ArchiveClientMutationVariables>;
export const HomeownerResendOffersEmailDocument = gql`
    mutation HomeownerResendOffersEmail($id: ID!, $email: String!) {
  homeownerResendOffersEmail(loanInquiryUuid: $id, addressTo: $email) {
    ... on HomeownerResendOffersEmailSuccess {
      loanInquiry {
        id
      }
    }
    ... on HomeownerResendOffersEmailFailure {
      errors {
        message
        path
        code
      }
    }
  }
}
    `;

/**
 * __useHomeownerResendOffersEmailMutation__
 *
 * To run a mutation, you first call `useHomeownerResendOffersEmailMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useHomeownerResendOffersEmailMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [homeownerResendOffersEmailMutation, { data, loading, error }] = useHomeownerResendOffersEmailMutation({
 *   variables: {
 *      id: // value for 'id'
 *      email: // value for 'email'
 *   },
 * });
 */
export function useHomeownerResendOffersEmailMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<HomeownerResendOffersEmailMutation, HomeownerResendOffersEmailMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useMutation<HomeownerResendOffersEmailMutation, HomeownerResendOffersEmailMutationVariables>(HomeownerResendOffersEmailDocument, options);
      }
export type HomeownerResendOffersEmailMutationHookResult = ReturnType<typeof useHomeownerResendOffersEmailMutation>;
export type HomeownerResendOffersEmailMutationResult = ApolloReactCommon.MutationResult<HomeownerResendOffersEmailMutation>;
export type HomeownerResendOffersEmailMutationOptions = ApolloReactCommon.BaseMutationOptions<HomeownerResendOffersEmailMutation, HomeownerResendOffersEmailMutationVariables>;
export const GetContractWizardDataDocument = gql`
    query GetContractWizardData {
  contractor {
    id
    email
    fullName
    phoneNumber
  }
  organization {
    id
    ...OrganizationContractWizardInfo
  }
  contractServiceBaseTemplate(type: project_contract) {
    id
    template
  }
}
    ${OrganizationContractWizardInfoFragmentDoc}`;

/**
 * __useGetContractWizardDataQuery__
 *
 * To run a query within a React component, call `useGetContractWizardDataQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetContractWizardDataQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetContractWizardDataQuery({
 *   variables: {
 *   },
 * });
 */
export function useGetContractWizardDataQuery(baseOptions?: ApolloReactHooks.QueryHookOptions<GetContractWizardDataQuery, GetContractWizardDataQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<GetContractWizardDataQuery, GetContractWizardDataQueryVariables>(GetContractWizardDataDocument, options);
      }
export function useGetContractWizardDataLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<GetContractWizardDataQuery, GetContractWizardDataQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<GetContractWizardDataQuery, GetContractWizardDataQueryVariables>(GetContractWizardDataDocument, options);
        }
export type GetContractWizardDataQueryHookResult = ReturnType<typeof useGetContractWizardDataQuery>;
export type GetContractWizardDataLazyQueryHookResult = ReturnType<typeof useGetContractWizardDataLazyQuery>;
export type GetContractWizardDataQueryResult = ApolloReactCommon.QueryResult<GetContractWizardDataQuery, GetContractWizardDataQueryVariables>;
export const UpdateOrganizationCompanyInfoDocument = gql`
    mutation UpdateOrganizationCompanyInfo($attributes: OrganizationAttributes!) {
  upsertOrganization(attributes: $attributes) {
    ... on UpsertOrganizationSuccess {
      organization {
        id
        ...OrganizationContractWizardInfo
      }
    }
    ... on UpsertOrganizationFailure {
      errors {
        message
        path
        code
      }
    }
  }
}
    ${OrganizationContractWizardInfoFragmentDoc}`;

/**
 * __useUpdateOrganizationCompanyInfoMutation__
 *
 * To run a mutation, you first call `useUpdateOrganizationCompanyInfoMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateOrganizationCompanyInfoMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateOrganizationCompanyInfoMutation, { data, loading, error }] = useUpdateOrganizationCompanyInfoMutation({
 *   variables: {
 *      attributes: // value for 'attributes'
 *   },
 * });
 */
export function useUpdateOrganizationCompanyInfoMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<UpdateOrganizationCompanyInfoMutation, UpdateOrganizationCompanyInfoMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useMutation<UpdateOrganizationCompanyInfoMutation, UpdateOrganizationCompanyInfoMutationVariables>(UpdateOrganizationCompanyInfoDocument, options);
      }
export type UpdateOrganizationCompanyInfoMutationHookResult = ReturnType<typeof useUpdateOrganizationCompanyInfoMutation>;
export type UpdateOrganizationCompanyInfoMutationResult = ApolloReactCommon.MutationResult<UpdateOrganizationCompanyInfoMutation>;
export type UpdateOrganizationCompanyInfoMutationOptions = ApolloReactCommon.BaseMutationOptions<UpdateOrganizationCompanyInfoMutation, UpdateOrganizationCompanyInfoMutationVariables>;
export const CreateContractServiceAccountDocument = gql`
    mutation CreateContractServiceAccount {
  contractServiceAccountCreate {
    ... on ContractServiceAccountCreateSuccess {
      contractServiceAccount {
        id
      }
    }
    ... on ContractServiceAccountCreateFailure {
      errors {
        message
        path
        code
      }
    }
  }
}
    `;

/**
 * __useCreateContractServiceAccountMutation__
 *
 * To run a mutation, you first call `useCreateContractServiceAccountMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateContractServiceAccountMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createContractServiceAccountMutation, { data, loading, error }] = useCreateContractServiceAccountMutation({
 *   variables: {
 *   },
 * });
 */
export function useCreateContractServiceAccountMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<CreateContractServiceAccountMutation, CreateContractServiceAccountMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useMutation<CreateContractServiceAccountMutation, CreateContractServiceAccountMutationVariables>(CreateContractServiceAccountDocument, options);
      }
export type CreateContractServiceAccountMutationHookResult = ReturnType<typeof useCreateContractServiceAccountMutation>;
export type CreateContractServiceAccountMutationResult = ApolloReactCommon.MutationResult<CreateContractServiceAccountMutation>;
export type CreateContractServiceAccountMutationOptions = ApolloReactCommon.BaseMutationOptions<CreateContractServiceAccountMutation, CreateContractServiceAccountMutationVariables>;
export const UpsertContractServiceContractTemplateDocument = gql`
    mutation UpsertContractServiceContractTemplate($contractServiceAccountId: ID!, $baseTemplateId: String!, $template: JSON!) {
  contractServiceContractTemplateUpsert(
    contractServiceAccountId: $contractServiceAccountId
    templateParams: {type: project_contract, template: $template, baseTemplateId: $baseTemplateId}
  ) {
    ... on ContractServiceTemplateUpsertSuccess {
      contractServiceContractTemplate {
        id
        version
        baseTemplate {
          id
        }
      }
    }
    ... on ContractServiceTemplateUpsertFailure {
      errors {
        message
        path
        code
      }
    }
  }
}
    `;

/**
 * __useUpsertContractServiceContractTemplateMutation__
 *
 * To run a mutation, you first call `useUpsertContractServiceContractTemplateMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpsertContractServiceContractTemplateMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [upsertContractServiceContractTemplateMutation, { data, loading, error }] = useUpsertContractServiceContractTemplateMutation({
 *   variables: {
 *      contractServiceAccountId: // value for 'contractServiceAccountId'
 *      baseTemplateId: // value for 'baseTemplateId'
 *      template: // value for 'template'
 *   },
 * });
 */
export function useUpsertContractServiceContractTemplateMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<UpsertContractServiceContractTemplateMutation, UpsertContractServiceContractTemplateMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useMutation<UpsertContractServiceContractTemplateMutation, UpsertContractServiceContractTemplateMutationVariables>(UpsertContractServiceContractTemplateDocument, options);
      }
export type UpsertContractServiceContractTemplateMutationHookResult = ReturnType<typeof useUpsertContractServiceContractTemplateMutation>;
export type UpsertContractServiceContractTemplateMutationResult = ApolloReactCommon.MutationResult<UpsertContractServiceContractTemplateMutation>;
export type UpsertContractServiceContractTemplateMutationOptions = ApolloReactCommon.BaseMutationOptions<UpsertContractServiceContractTemplateMutation, UpsertContractServiceContractTemplateMutationVariables>;
export const UpsertContractTemplateVersionDocument = gql`
    mutation UpsertContractTemplateVersion($contractServiceAccountId: ID!, $baseTemplateId: String!, $template: JSON!, $versionName: String!, $contractorId: ID!) {
  contractServiceContractTemplateVersionUpsert(
    contractServiceAccountId: $contractServiceAccountId
    templateParams: {type: project_contract, template: $template, baseTemplateId: $baseTemplateId, versionName: $versionName, editedBy: $contractorId}
  ) {
    ... on ContractServiceTemplateVersionUpsertSuccess {
      contractServiceContractTemplate {
        id
        version
        baseTemplate {
          id
        }
      }
    }
    ... on ContractServiceTemplateVersionUpsertFailure {
      errors {
        message
        path
        code
      }
    }
  }
}
    `;

/**
 * __useUpsertContractTemplateVersionMutation__
 *
 * To run a mutation, you first call `useUpsertContractTemplateVersionMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpsertContractTemplateVersionMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [upsertContractTemplateVersionMutation, { data, loading, error }] = useUpsertContractTemplateVersionMutation({
 *   variables: {
 *      contractServiceAccountId: // value for 'contractServiceAccountId'
 *      baseTemplateId: // value for 'baseTemplateId'
 *      template: // value for 'template'
 *      versionName: // value for 'versionName'
 *      contractorId: // value for 'contractorId'
 *   },
 * });
 */
export function useUpsertContractTemplateVersionMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<UpsertContractTemplateVersionMutation, UpsertContractTemplateVersionMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useMutation<UpsertContractTemplateVersionMutation, UpsertContractTemplateVersionMutationVariables>(UpsertContractTemplateVersionDocument, options);
      }
export type UpsertContractTemplateVersionMutationHookResult = ReturnType<typeof useUpsertContractTemplateVersionMutation>;
export type UpsertContractTemplateVersionMutationResult = ApolloReactCommon.MutationResult<UpsertContractTemplateVersionMutation>;
export type UpsertContractTemplateVersionMutationOptions = ApolloReactCommon.BaseMutationOptions<UpsertContractTemplateVersionMutation, UpsertContractTemplateVersionMutationVariables>;
export const GenerateWizardContractPreviewPdfDocument = gql`
    mutation GenerateWizardContractPreviewPdf($html: String!) {
  contractGeneratorRestGeneratePdf(input: {html: $html}) @rest(endpoint: "contractGenerator", method: "POST", path: "/pdf_generator", type: "ContractGeneratorRestGeneratePdfResult") {
    pdf
  }
}
    `;

/**
 * __useGenerateWizardContractPreviewPdfMutation__
 *
 * To run a mutation, you first call `useGenerateWizardContractPreviewPdfMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useGenerateWizardContractPreviewPdfMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [generateWizardContractPreviewPdfMutation, { data, loading, error }] = useGenerateWizardContractPreviewPdfMutation({
 *   variables: {
 *      html: // value for 'html'
 *   },
 * });
 */
export function useGenerateWizardContractPreviewPdfMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<GenerateWizardContractPreviewPdfMutation, GenerateWizardContractPreviewPdfMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useMutation<GenerateWizardContractPreviewPdfMutation, GenerateWizardContractPreviewPdfMutationVariables>(GenerateWizardContractPreviewPdfDocument, options);
      }
export type GenerateWizardContractPreviewPdfMutationHookResult = ReturnType<typeof useGenerateWizardContractPreviewPdfMutation>;
export type GenerateWizardContractPreviewPdfMutationResult = ApolloReactCommon.MutationResult<GenerateWizardContractPreviewPdfMutation>;
export type GenerateWizardContractPreviewPdfMutationOptions = ApolloReactCommon.BaseMutationOptions<GenerateWizardContractPreviewPdfMutation, GenerateWizardContractPreviewPdfMutationVariables>;
export const GetMapDataDocument = gql`
    query GetMapData($homeownerSearchKey: String!) {
  homeowner(searchKey: $homeownerSearchKey) {
    contractor {
      id
      firstName
      organization {
        companyTypeLabel
        city
        firstSignedUpAt
        firstFundDate
      }
    }
    numLendersQualified
    fundingTime
    fundingAmount
    fundingLender
    projectType
  }
}
    `;

/**
 * __useGetMapDataQuery__
 *
 * To run a query within a React component, call `useGetMapDataQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetMapDataQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetMapDataQuery({
 *   variables: {
 *      homeownerSearchKey: // value for 'homeownerSearchKey'
 *   },
 * });
 */
export function useGetMapDataQuery(baseOptions: ApolloReactHooks.QueryHookOptions<GetMapDataQuery, GetMapDataQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<GetMapDataQuery, GetMapDataQueryVariables>(GetMapDataDocument, options);
      }
export function useGetMapDataLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<GetMapDataQuery, GetMapDataQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<GetMapDataQuery, GetMapDataQueryVariables>(GetMapDataDocument, options);
        }
export type GetMapDataQueryHookResult = ReturnType<typeof useGetMapDataQuery>;
export type GetMapDataLazyQueryHookResult = ReturnType<typeof useGetMapDataLazyQuery>;
export type GetMapDataQueryResult = ApolloReactCommon.QueryResult<GetMapDataQuery, GetMapDataQueryVariables>;
export const GetCustomizedInvoiceTemplateInfoDocument = gql`
    query GetCustomizedInvoiceTemplateInfo {
  contractor {
    id
    ...ContractorTemplateInfo
  }
  organization {
    id
    ...OrganizationTemplateInfo
  }
}
    ${ContractorTemplateInfoFragmentDoc}
${OrganizationTemplateInfoFragmentDoc}`;

/**
 * __useGetCustomizedInvoiceTemplateInfoQuery__
 *
 * To run a query within a React component, call `useGetCustomizedInvoiceTemplateInfoQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetCustomizedInvoiceTemplateInfoQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetCustomizedInvoiceTemplateInfoQuery({
 *   variables: {
 *   },
 * });
 */
export function useGetCustomizedInvoiceTemplateInfoQuery(baseOptions?: ApolloReactHooks.QueryHookOptions<GetCustomizedInvoiceTemplateInfoQuery, GetCustomizedInvoiceTemplateInfoQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<GetCustomizedInvoiceTemplateInfoQuery, GetCustomizedInvoiceTemplateInfoQueryVariables>(GetCustomizedInvoiceTemplateInfoDocument, options);
      }
export function useGetCustomizedInvoiceTemplateInfoLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<GetCustomizedInvoiceTemplateInfoQuery, GetCustomizedInvoiceTemplateInfoQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<GetCustomizedInvoiceTemplateInfoQuery, GetCustomizedInvoiceTemplateInfoQueryVariables>(GetCustomizedInvoiceTemplateInfoDocument, options);
        }
export type GetCustomizedInvoiceTemplateInfoQueryHookResult = ReturnType<typeof useGetCustomizedInvoiceTemplateInfoQuery>;
export type GetCustomizedInvoiceTemplateInfoLazyQueryHookResult = ReturnType<typeof useGetCustomizedInvoiceTemplateInfoLazyQuery>;
export type GetCustomizedInvoiceTemplateInfoQueryResult = ApolloReactCommon.QueryResult<GetCustomizedInvoiceTemplateInfoQuery, GetCustomizedInvoiceTemplateInfoQueryVariables>;
export const UpdateOrganizationInvoiceTemplateSettingsDocument = gql`
    mutation UpdateOrganizationInvoiceTemplateSettings($attributes: OrganizationAttributes!) {
  upsertOrganization(attributes: $attributes) {
    ... on UpsertOrganizationSuccess {
      organization {
        id
        ...OrganizationTemplateInfo
      }
    }
    ... on UpsertOrganizationFailure {
      errors {
        message
        path
        code
      }
    }
  }
}
    ${OrganizationTemplateInfoFragmentDoc}`;

/**
 * __useUpdateOrganizationInvoiceTemplateSettingsMutation__
 *
 * To run a mutation, you first call `useUpdateOrganizationInvoiceTemplateSettingsMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateOrganizationInvoiceTemplateSettingsMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateOrganizationInvoiceTemplateSettingsMutation, { data, loading, error }] = useUpdateOrganizationInvoiceTemplateSettingsMutation({
 *   variables: {
 *      attributes: // value for 'attributes'
 *   },
 * });
 */
export function useUpdateOrganizationInvoiceTemplateSettingsMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<UpdateOrganizationInvoiceTemplateSettingsMutation, UpdateOrganizationInvoiceTemplateSettingsMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useMutation<UpdateOrganizationInvoiceTemplateSettingsMutation, UpdateOrganizationInvoiceTemplateSettingsMutationVariables>(UpdateOrganizationInvoiceTemplateSettingsDocument, options);
      }
export type UpdateOrganizationInvoiceTemplateSettingsMutationHookResult = ReturnType<typeof useUpdateOrganizationInvoiceTemplateSettingsMutation>;
export type UpdateOrganizationInvoiceTemplateSettingsMutationResult = ApolloReactCommon.MutationResult<UpdateOrganizationInvoiceTemplateSettingsMutation>;
export type UpdateOrganizationInvoiceTemplateSettingsMutationOptions = ApolloReactCommon.BaseMutationOptions<UpdateOrganizationInvoiceTemplateSettingsMutation, UpdateOrganizationInvoiceTemplateSettingsMutationVariables>;
export const CreateInvoiceTemplateDocument = gql`
    mutation CreateInvoiceTemplate($attributes: CustomizedInvoiceTemplateAttributes!) {
  upsertCustomizedInvoiceTemplate(templateAttributes: $attributes) {
    ... on UpsertCustomizedInvoiceTemplateSuccess {
      invoiceTemplate {
        id
        ...InvoiceCustomizationSettings
      }
    }
    ... on UpsertCustomizedInvoiceTemplateFailure {
      errors {
        message
        path
        code
      }
    }
  }
}
    ${InvoiceCustomizationSettingsFragmentDoc}`;

/**
 * __useCreateInvoiceTemplateMutation__
 *
 * To run a mutation, you first call `useCreateInvoiceTemplateMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateInvoiceTemplateMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createInvoiceTemplateMutation, { data, loading, error }] = useCreateInvoiceTemplateMutation({
 *   variables: {
 *      attributes: // value for 'attributes'
 *   },
 * });
 */
export function useCreateInvoiceTemplateMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<CreateInvoiceTemplateMutation, CreateInvoiceTemplateMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useMutation<CreateInvoiceTemplateMutation, CreateInvoiceTemplateMutationVariables>(CreateInvoiceTemplateDocument, options);
      }
export type CreateInvoiceTemplateMutationHookResult = ReturnType<typeof useCreateInvoiceTemplateMutation>;
export type CreateInvoiceTemplateMutationResult = ApolloReactCommon.MutationResult<CreateInvoiceTemplateMutation>;
export type CreateInvoiceTemplateMutationOptions = ApolloReactCommon.BaseMutationOptions<CreateInvoiceTemplateMutation, CreateInvoiceTemplateMutationVariables>;
export const GetHearthPayApprovedDataDocument = gql`
    query GetHearthPayApprovedData {
  contractor {
    id
    ...ApprovedContractor
  }
  organization {
    id
    ...ApprovedOrg
  }
}
    ${ApprovedContractorFragmentDoc}
${ApprovedOrgFragmentDoc}`;

/**
 * __useGetHearthPayApprovedDataQuery__
 *
 * To run a query within a React component, call `useGetHearthPayApprovedDataQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetHearthPayApprovedDataQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetHearthPayApprovedDataQuery({
 *   variables: {
 *   },
 * });
 */
export function useGetHearthPayApprovedDataQuery(baseOptions?: ApolloReactHooks.QueryHookOptions<GetHearthPayApprovedDataQuery, GetHearthPayApprovedDataQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<GetHearthPayApprovedDataQuery, GetHearthPayApprovedDataQueryVariables>(GetHearthPayApprovedDataDocument, options);
      }
export function useGetHearthPayApprovedDataLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<GetHearthPayApprovedDataQuery, GetHearthPayApprovedDataQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<GetHearthPayApprovedDataQuery, GetHearthPayApprovedDataQueryVariables>(GetHearthPayApprovedDataDocument, options);
        }
export type GetHearthPayApprovedDataQueryHookResult = ReturnType<typeof useGetHearthPayApprovedDataQuery>;
export type GetHearthPayApprovedDataLazyQueryHookResult = ReturnType<typeof useGetHearthPayApprovedDataLazyQuery>;
export type GetHearthPayApprovedDataQueryResult = ApolloReactCommon.QueryResult<GetHearthPayApprovedDataQuery, GetHearthPayApprovedDataQueryVariables>;
export const GetInsightsCalloutDataDocument = gql`
    query GetInsightsCalloutData {
  contractor {
    id
    admin
    customSettings {
      insightsCalloutSeen
    }
  }
}
    `;

/**
 * __useGetInsightsCalloutDataQuery__
 *
 * To run a query within a React component, call `useGetInsightsCalloutDataQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetInsightsCalloutDataQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetInsightsCalloutDataQuery({
 *   variables: {
 *   },
 * });
 */
export function useGetInsightsCalloutDataQuery(baseOptions?: ApolloReactHooks.QueryHookOptions<GetInsightsCalloutDataQuery, GetInsightsCalloutDataQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<GetInsightsCalloutDataQuery, GetInsightsCalloutDataQueryVariables>(GetInsightsCalloutDataDocument, options);
      }
export function useGetInsightsCalloutDataLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<GetInsightsCalloutDataQuery, GetInsightsCalloutDataQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<GetInsightsCalloutDataQuery, GetInsightsCalloutDataQueryVariables>(GetInsightsCalloutDataDocument, options);
        }
export type GetInsightsCalloutDataQueryHookResult = ReturnType<typeof useGetInsightsCalloutDataQuery>;
export type GetInsightsCalloutDataLazyQueryHookResult = ReturnType<typeof useGetInsightsCalloutDataLazyQuery>;
export type GetInsightsCalloutDataQueryResult = ApolloReactCommon.QueryResult<GetInsightsCalloutDataQuery, GetInsightsCalloutDataQueryVariables>;
export const SetInsightsCalloutSeenDocument = gql`
    mutation SetInsightsCalloutSeen {
  upsertContractor(customSettings: {insightsCalloutSeen: true}) {
    ... on UpsertContractorFailure {
      errors {
        message
        path
        code
      }
    }
  }
}
    `;

/**
 * __useSetInsightsCalloutSeenMutation__
 *
 * To run a mutation, you first call `useSetInsightsCalloutSeenMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useSetInsightsCalloutSeenMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [setInsightsCalloutSeenMutation, { data, loading, error }] = useSetInsightsCalloutSeenMutation({
 *   variables: {
 *   },
 * });
 */
export function useSetInsightsCalloutSeenMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<SetInsightsCalloutSeenMutation, SetInsightsCalloutSeenMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useMutation<SetInsightsCalloutSeenMutation, SetInsightsCalloutSeenMutationVariables>(SetInsightsCalloutSeenDocument, options);
      }
export type SetInsightsCalloutSeenMutationHookResult = ReturnType<typeof useSetInsightsCalloutSeenMutation>;
export type SetInsightsCalloutSeenMutationResult = ApolloReactCommon.MutationResult<SetInsightsCalloutSeenMutation>;
export type SetInsightsCalloutSeenMutationOptions = ApolloReactCommon.BaseMutationOptions<SetInsightsCalloutSeenMutation, SetInsightsCalloutSeenMutationVariables>;
export const GetDashboardActionBarInfoDocument = gql`
    query GetDashboardActionBarInfo {
  contractor {
    id
    ...ActionBarContractor
  }
  organization {
    id
    stripeConnectAccount {
      id
      status
    }
    contractServiceAccount {
      id
      termsAgreedAt
    }
  }
}
    ${ActionBarContractorFragmentDoc}`;

/**
 * __useGetDashboardActionBarInfoQuery__
 *
 * To run a query within a React component, call `useGetDashboardActionBarInfoQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetDashboardActionBarInfoQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetDashboardActionBarInfoQuery({
 *   variables: {
 *   },
 * });
 */
export function useGetDashboardActionBarInfoQuery(baseOptions?: ApolloReactHooks.QueryHookOptions<GetDashboardActionBarInfoQuery, GetDashboardActionBarInfoQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<GetDashboardActionBarInfoQuery, GetDashboardActionBarInfoQueryVariables>(GetDashboardActionBarInfoDocument, options);
      }
export function useGetDashboardActionBarInfoLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<GetDashboardActionBarInfoQuery, GetDashboardActionBarInfoQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<GetDashboardActionBarInfoQuery, GetDashboardActionBarInfoQueryVariables>(GetDashboardActionBarInfoDocument, options);
        }
export type GetDashboardActionBarInfoQueryHookResult = ReturnType<typeof useGetDashboardActionBarInfoQuery>;
export type GetDashboardActionBarInfoLazyQueryHookResult = ReturnType<typeof useGetDashboardActionBarInfoLazyQuery>;
export type GetDashboardActionBarInfoQueryResult = ApolloReactCommon.QueryResult<GetDashboardActionBarInfoQuery, GetDashboardActionBarInfoQueryVariables>;
export const GetOrganizationHearthPayDataDocument = gql`
    query GetOrganizationHearthPayData {
  contractor {
    id
    paymentsAdmin
    paidPaymentsAmount
    unpaidPaymentsAmount
    overduePaymentsAmount
  }
  organization {
    id
    stripeConnectAccount {
      id
      ...PaymentsCardConnectAccount
    }
    visibleConnectInvoices {
      totalCount
      nodes {
        id
        amountRequested
        dueDate
        status
      }
    }
  }
}
    ${PaymentsCardConnectAccountFragmentDoc}`;

/**
 * __useGetOrganizationHearthPayDataQuery__
 *
 * To run a query within a React component, call `useGetOrganizationHearthPayDataQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetOrganizationHearthPayDataQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetOrganizationHearthPayDataQuery({
 *   variables: {
 *   },
 * });
 */
export function useGetOrganizationHearthPayDataQuery(baseOptions?: ApolloReactHooks.QueryHookOptions<GetOrganizationHearthPayDataQuery, GetOrganizationHearthPayDataQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<GetOrganizationHearthPayDataQuery, GetOrganizationHearthPayDataQueryVariables>(GetOrganizationHearthPayDataDocument, options);
      }
export function useGetOrganizationHearthPayDataLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<GetOrganizationHearthPayDataQuery, GetOrganizationHearthPayDataQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<GetOrganizationHearthPayDataQuery, GetOrganizationHearthPayDataQueryVariables>(GetOrganizationHearthPayDataDocument, options);
        }
export type GetOrganizationHearthPayDataQueryHookResult = ReturnType<typeof useGetOrganizationHearthPayDataQuery>;
export type GetOrganizationHearthPayDataLazyQueryHookResult = ReturnType<typeof useGetOrganizationHearthPayDataLazyQuery>;
export type GetOrganizationHearthPayDataQueryResult = ApolloReactCommon.QueryResult<GetOrganizationHearthPayDataQuery, GetOrganizationHearthPayDataQueryVariables>;
export const GetHearthPayStatusInfoDocument = gql`
    query GetHearthPayStatusInfo {
  contractor {
    id
    paymentsAdmin
    paymentsRole
  }
  organization {
    id
    stripeConnectAccount {
      id
      status
    }
  }
}
    `;

/**
 * __useGetHearthPayStatusInfoQuery__
 *
 * To run a query within a React component, call `useGetHearthPayStatusInfoQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetHearthPayStatusInfoQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetHearthPayStatusInfoQuery({
 *   variables: {
 *   },
 * });
 */
export function useGetHearthPayStatusInfoQuery(baseOptions?: ApolloReactHooks.QueryHookOptions<GetHearthPayStatusInfoQuery, GetHearthPayStatusInfoQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<GetHearthPayStatusInfoQuery, GetHearthPayStatusInfoQueryVariables>(GetHearthPayStatusInfoDocument, options);
      }
export function useGetHearthPayStatusInfoLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<GetHearthPayStatusInfoQuery, GetHearthPayStatusInfoQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<GetHearthPayStatusInfoQuery, GetHearthPayStatusInfoQueryVariables>(GetHearthPayStatusInfoDocument, options);
        }
export type GetHearthPayStatusInfoQueryHookResult = ReturnType<typeof useGetHearthPayStatusInfoQuery>;
export type GetHearthPayStatusInfoLazyQueryHookResult = ReturnType<typeof useGetHearthPayStatusInfoLazyQuery>;
export type GetHearthPayStatusInfoQueryResult = ApolloReactCommon.QueryResult<GetHearthPayStatusInfoQuery, GetHearthPayStatusInfoQueryVariables>;
export const GetPaymentsStatusDocument = gql`
    query GetPaymentsStatus {
  organization {
    id
    stripeConnectAccount {
      id
      status
    }
  }
}
    `;

/**
 * __useGetPaymentsStatusQuery__
 *
 * To run a query within a React component, call `useGetPaymentsStatusQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetPaymentsStatusQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetPaymentsStatusQuery({
 *   variables: {
 *   },
 * });
 */
export function useGetPaymentsStatusQuery(baseOptions?: ApolloReactHooks.QueryHookOptions<GetPaymentsStatusQuery, GetPaymentsStatusQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<GetPaymentsStatusQuery, GetPaymentsStatusQueryVariables>(GetPaymentsStatusDocument, options);
      }
export function useGetPaymentsStatusLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<GetPaymentsStatusQuery, GetPaymentsStatusQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<GetPaymentsStatusQuery, GetPaymentsStatusQueryVariables>(GetPaymentsStatusDocument, options);
        }
export type GetPaymentsStatusQueryHookResult = ReturnType<typeof useGetPaymentsStatusQuery>;
export type GetPaymentsStatusLazyQueryHookResult = ReturnType<typeof useGetPaymentsStatusLazyQuery>;
export type GetPaymentsStatusQueryResult = ApolloReactCommon.QueryResult<GetPaymentsStatusQuery, GetPaymentsStatusQueryVariables>;
export const GetRewardsAvailabilityDocument = gql`
    query GetRewardsAvailability {
  resource(category: "hearth_rewards_may_2021", type: "giftcard") {
    id
    resourceValue
  }
}
    `;

/**
 * __useGetRewardsAvailabilityQuery__
 *
 * To run a query within a React component, call `useGetRewardsAvailabilityQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetRewardsAvailabilityQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetRewardsAvailabilityQuery({
 *   variables: {
 *   },
 * });
 */
export function useGetRewardsAvailabilityQuery(baseOptions?: ApolloReactHooks.QueryHookOptions<GetRewardsAvailabilityQuery, GetRewardsAvailabilityQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<GetRewardsAvailabilityQuery, GetRewardsAvailabilityQueryVariables>(GetRewardsAvailabilityDocument, options);
      }
export function useGetRewardsAvailabilityLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<GetRewardsAvailabilityQuery, GetRewardsAvailabilityQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<GetRewardsAvailabilityQuery, GetRewardsAvailabilityQueryVariables>(GetRewardsAvailabilityDocument, options);
        }
export type GetRewardsAvailabilityQueryHookResult = ReturnType<typeof useGetRewardsAvailabilityQuery>;
export type GetRewardsAvailabilityLazyQueryHookResult = ReturnType<typeof useGetRewardsAvailabilityLazyQuery>;
export type GetRewardsAvailabilityQueryResult = ApolloReactCommon.QueryResult<GetRewardsAvailabilityQuery, GetRewardsAvailabilityQueryVariables>;
export const GetContractorRewardsDataDocument = gql`
    query GetContractorRewardsData {
  organization {
    id
    ...OrganizationRewards
  }
  contractor {
    id
    ...ContractorRewards
  }
}
    ${OrganizationRewardsFragmentDoc}
${ContractorRewardsFragmentDoc}`;

/**
 * __useGetContractorRewardsDataQuery__
 *
 * To run a query within a React component, call `useGetContractorRewardsDataQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetContractorRewardsDataQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetContractorRewardsDataQuery({
 *   variables: {
 *   },
 * });
 */
export function useGetContractorRewardsDataQuery(baseOptions?: ApolloReactHooks.QueryHookOptions<GetContractorRewardsDataQuery, GetContractorRewardsDataQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<GetContractorRewardsDataQuery, GetContractorRewardsDataQueryVariables>(GetContractorRewardsDataDocument, options);
      }
export function useGetContractorRewardsDataLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<GetContractorRewardsDataQuery, GetContractorRewardsDataQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<GetContractorRewardsDataQuery, GetContractorRewardsDataQueryVariables>(GetContractorRewardsDataDocument, options);
        }
export type GetContractorRewardsDataQueryHookResult = ReturnType<typeof useGetContractorRewardsDataQuery>;
export type GetContractorRewardsDataLazyQueryHookResult = ReturnType<typeof useGetContractorRewardsDataLazyQuery>;
export type GetContractorRewardsDataQueryResult = ApolloReactCommon.QueryResult<GetContractorRewardsDataQuery, GetContractorRewardsDataQueryVariables>;
export const ClaimRewardsGiftcardDocument = gql`
    mutation ClaimRewardsGiftcard {
  claimHearthRewardsGiftcard {
    ... on ClaimHearthRewardsGiftcardSuccess {
      contractor {
        id
        customSettings {
          rewardsAvailable
        }
      }
      claimAmount
    }
    ... on ClaimHearthRewardsGiftcardFailure {
      errors {
        message
        path
        code
      }
    }
  }
}
    `;

/**
 * __useClaimRewardsGiftcardMutation__
 *
 * To run a mutation, you first call `useClaimRewardsGiftcardMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useClaimRewardsGiftcardMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [claimRewardsGiftcardMutation, { data, loading, error }] = useClaimRewardsGiftcardMutation({
 *   variables: {
 *   },
 * });
 */
export function useClaimRewardsGiftcardMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<ClaimRewardsGiftcardMutation, ClaimRewardsGiftcardMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useMutation<ClaimRewardsGiftcardMutation, ClaimRewardsGiftcardMutationVariables>(ClaimRewardsGiftcardDocument, options);
      }
export type ClaimRewardsGiftcardMutationHookResult = ReturnType<typeof useClaimRewardsGiftcardMutation>;
export type ClaimRewardsGiftcardMutationResult = ApolloReactCommon.MutationResult<ClaimRewardsGiftcardMutation>;
export type ClaimRewardsGiftcardMutationOptions = ApolloReactCommon.BaseMutationOptions<ClaimRewardsGiftcardMutation, ClaimRewardsGiftcardMutationVariables>;
export const GetQuickPollDataDocument = gql`
    query GetQuickPollData {
  questionnaire(id: "quick_poll_questionnaire") {
    id
    questions {
      nodes {
        id
        ...QuickPoll
      }
    }
  }
}
    ${QuickPollFragmentDoc}`;

/**
 * __useGetQuickPollDataQuery__
 *
 * To run a query within a React component, call `useGetQuickPollDataQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetQuickPollDataQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetQuickPollDataQuery({
 *   variables: {
 *   },
 * });
 */
export function useGetQuickPollDataQuery(baseOptions?: ApolloReactHooks.QueryHookOptions<GetQuickPollDataQuery, GetQuickPollDataQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<GetQuickPollDataQuery, GetQuickPollDataQueryVariables>(GetQuickPollDataDocument, options);
      }
export function useGetQuickPollDataLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<GetQuickPollDataQuery, GetQuickPollDataQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<GetQuickPollDataQuery, GetQuickPollDataQueryVariables>(GetQuickPollDataDocument, options);
        }
export type GetQuickPollDataQueryHookResult = ReturnType<typeof useGetQuickPollDataQuery>;
export type GetQuickPollDataLazyQueryHookResult = ReturnType<typeof useGetQuickPollDataLazyQuery>;
export type GetQuickPollDataQueryResult = ApolloReactCommon.QueryResult<GetQuickPollDataQuery, GetQuickPollDataQueryVariables>;
export const RecordQuickPollResponseDocument = gql`
    mutation RecordQuickPollResponse($response: JSON!) {
  recordQuickPollResponse(response: $response) {
    ... on RecordQuickPollResponseSuccess {
      questionnaireResponse {
        id
      }
    }
    ... on RecordQuickPollResponseFailure {
      errors {
        message
        path
        code
      }
    }
  }
}
    `;

/**
 * __useRecordQuickPollResponseMutation__
 *
 * To run a mutation, you first call `useRecordQuickPollResponseMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useRecordQuickPollResponseMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [recordQuickPollResponseMutation, { data, loading, error }] = useRecordQuickPollResponseMutation({
 *   variables: {
 *      response: // value for 'response'
 *   },
 * });
 */
export function useRecordQuickPollResponseMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<RecordQuickPollResponseMutation, RecordQuickPollResponseMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useMutation<RecordQuickPollResponseMutation, RecordQuickPollResponseMutationVariables>(RecordQuickPollResponseDocument, options);
      }
export type RecordQuickPollResponseMutationHookResult = ReturnType<typeof useRecordQuickPollResponseMutation>;
export type RecordQuickPollResponseMutationResult = ApolloReactCommon.MutationResult<RecordQuickPollResponseMutation>;
export type RecordQuickPollResponseMutationOptions = ApolloReactCommon.BaseMutationOptions<RecordQuickPollResponseMutation, RecordQuickPollResponseMutationVariables>;
export const GetSeatsTrainingStatusDocument = gql`
    query GetSeatsTrainingStatus {
  contractor {
    id
    admin
    trainingScheduledAt
    trainingCompleted
  }
}
    `;

/**
 * __useGetSeatsTrainingStatusQuery__
 *
 * To run a query within a React component, call `useGetSeatsTrainingStatusQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetSeatsTrainingStatusQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetSeatsTrainingStatusQuery({
 *   variables: {
 *   },
 * });
 */
export function useGetSeatsTrainingStatusQuery(baseOptions?: ApolloReactHooks.QueryHookOptions<GetSeatsTrainingStatusQuery, GetSeatsTrainingStatusQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<GetSeatsTrainingStatusQuery, GetSeatsTrainingStatusQueryVariables>(GetSeatsTrainingStatusDocument, options);
      }
export function useGetSeatsTrainingStatusLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<GetSeatsTrainingStatusQuery, GetSeatsTrainingStatusQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<GetSeatsTrainingStatusQuery, GetSeatsTrainingStatusQueryVariables>(GetSeatsTrainingStatusDocument, options);
        }
export type GetSeatsTrainingStatusQueryHookResult = ReturnType<typeof useGetSeatsTrainingStatusQuery>;
export type GetSeatsTrainingStatusLazyQueryHookResult = ReturnType<typeof useGetSeatsTrainingStatusLazyQuery>;
export type GetSeatsTrainingStatusQueryResult = ApolloReactCommon.QueryResult<GetSeatsTrainingStatusQuery, GetSeatsTrainingStatusQueryVariables>;
export const GetSuggestedActionsDataDocument = gql`
    query GetSuggestedActionsData {
  organization {
    id
    ...OrganizationSuggestedActionsInfo
  }
  contractor {
    id
    ...ContractorSuggestedActionsInfo
  }
}
    ${OrganizationSuggestedActionsInfoFragmentDoc}
${ContractorSuggestedActionsInfoFragmentDoc}`;

/**
 * __useGetSuggestedActionsDataQuery__
 *
 * To run a query within a React component, call `useGetSuggestedActionsDataQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetSuggestedActionsDataQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetSuggestedActionsDataQuery({
 *   variables: {
 *   },
 * });
 */
export function useGetSuggestedActionsDataQuery(baseOptions?: ApolloReactHooks.QueryHookOptions<GetSuggestedActionsDataQuery, GetSuggestedActionsDataQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<GetSuggestedActionsDataQuery, GetSuggestedActionsDataQueryVariables>(GetSuggestedActionsDataDocument, options);
      }
export function useGetSuggestedActionsDataLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<GetSuggestedActionsDataQuery, GetSuggestedActionsDataQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<GetSuggestedActionsDataQuery, GetSuggestedActionsDataQueryVariables>(GetSuggestedActionsDataDocument, options);
        }
export type GetSuggestedActionsDataQueryHookResult = ReturnType<typeof useGetSuggestedActionsDataQuery>;
export type GetSuggestedActionsDataLazyQueryHookResult = ReturnType<typeof useGetSuggestedActionsDataLazyQuery>;
export type GetSuggestedActionsDataQueryResult = ApolloReactCommon.QueryResult<GetSuggestedActionsDataQuery, GetSuggestedActionsDataQueryVariables>;
export const ClickSuggestedActionDocument = gql`
    mutation ClickSuggestedAction($id: ID!) {
  suggestedActionClick(suggestedActionId: $id) {
    ... on SuggestedActionClickSuccess {
      suggestedAction {
        id
        status
      }
    }
    ... on SuggestedActionClickFailure {
      errors {
        message
        path
        code
      }
    }
  }
}
    `;

/**
 * __useClickSuggestedActionMutation__
 *
 * To run a mutation, you first call `useClickSuggestedActionMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useClickSuggestedActionMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [clickSuggestedActionMutation, { data, loading, error }] = useClickSuggestedActionMutation({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useClickSuggestedActionMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<ClickSuggestedActionMutation, ClickSuggestedActionMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useMutation<ClickSuggestedActionMutation, ClickSuggestedActionMutationVariables>(ClickSuggestedActionDocument, options);
      }
export type ClickSuggestedActionMutationHookResult = ReturnType<typeof useClickSuggestedActionMutation>;
export type ClickSuggestedActionMutationResult = ApolloReactCommon.MutationResult<ClickSuggestedActionMutation>;
export type ClickSuggestedActionMutationOptions = ApolloReactCommon.BaseMutationOptions<ClickSuggestedActionMutation, ClickSuggestedActionMutationVariables>;
export const DismissSuggestedActionDocument = gql`
    mutation DismissSuggestedAction($id: ID!) {
  suggestedActionDismiss(suggestedActionId: $id) {
    ... on SuggestedActionDismissSuccess {
      suggestedAction {
        id
        status
      }
    }
    ... on SuggestedActionDismissFailure {
      errors {
        message
        path
        code
      }
    }
  }
}
    `;

/**
 * __useDismissSuggestedActionMutation__
 *
 * To run a mutation, you first call `useDismissSuggestedActionMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDismissSuggestedActionMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [dismissSuggestedActionMutation, { data, loading, error }] = useDismissSuggestedActionMutation({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useDismissSuggestedActionMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<DismissSuggestedActionMutation, DismissSuggestedActionMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useMutation<DismissSuggestedActionMutation, DismissSuggestedActionMutationVariables>(DismissSuggestedActionDocument, options);
      }
export type DismissSuggestedActionMutationHookResult = ReturnType<typeof useDismissSuggestedActionMutation>;
export type DismissSuggestedActionMutationResult = ApolloReactCommon.MutationResult<DismissSuggestedActionMutation>;
export type DismissSuggestedActionMutationOptions = ApolloReactCommon.BaseMutationOptions<DismissSuggestedActionMutation, DismissSuggestedActionMutationVariables>;
export const GetUpcomingWebinarsDocument = gql`
    query GetUpcomingWebinars {
  contractor {
    id
    upcomingWebinars {
      nodes {
        id
        ...WebinarEvent
      }
    }
  }
}
    ${WebinarEventFragmentDoc}`;

/**
 * __useGetUpcomingWebinarsQuery__
 *
 * To run a query within a React component, call `useGetUpcomingWebinarsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetUpcomingWebinarsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetUpcomingWebinarsQuery({
 *   variables: {
 *   },
 * });
 */
export function useGetUpcomingWebinarsQuery(baseOptions?: ApolloReactHooks.QueryHookOptions<GetUpcomingWebinarsQuery, GetUpcomingWebinarsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<GetUpcomingWebinarsQuery, GetUpcomingWebinarsQueryVariables>(GetUpcomingWebinarsDocument, options);
      }
export function useGetUpcomingWebinarsLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<GetUpcomingWebinarsQuery, GetUpcomingWebinarsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<GetUpcomingWebinarsQuery, GetUpcomingWebinarsQueryVariables>(GetUpcomingWebinarsDocument, options);
        }
export type GetUpcomingWebinarsQueryHookResult = ReturnType<typeof useGetUpcomingWebinarsQuery>;
export type GetUpcomingWebinarsLazyQueryHookResult = ReturnType<typeof useGetUpcomingWebinarsLazyQuery>;
export type GetUpcomingWebinarsQueryResult = ApolloReactCommon.QueryResult<GetUpcomingWebinarsQuery, GetUpcomingWebinarsQueryVariables>;
export const GetBaseDashboardInfoDocument = gql`
    query GetBaseDashboardInfo {
  featureFlags {
    id
  }
  contractor {
    id
    ...DashboardContractor
  }
  organization {
    id
    ...DashboardOrg
  }
}
    ${DashboardContractorFragmentDoc}
${DashboardOrgFragmentDoc}`;

/**
 * __useGetBaseDashboardInfoQuery__
 *
 * To run a query within a React component, call `useGetBaseDashboardInfoQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetBaseDashboardInfoQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetBaseDashboardInfoQuery({
 *   variables: {
 *   },
 * });
 */
export function useGetBaseDashboardInfoQuery(baseOptions?: ApolloReactHooks.QueryHookOptions<GetBaseDashboardInfoQuery, GetBaseDashboardInfoQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<GetBaseDashboardInfoQuery, GetBaseDashboardInfoQueryVariables>(GetBaseDashboardInfoDocument, options);
      }
export function useGetBaseDashboardInfoLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<GetBaseDashboardInfoQuery, GetBaseDashboardInfoQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<GetBaseDashboardInfoQuery, GetBaseDashboardInfoQueryVariables>(GetBaseDashboardInfoDocument, options);
        }
export type GetBaseDashboardInfoQueryHookResult = ReturnType<typeof useGetBaseDashboardInfoQuery>;
export type GetBaseDashboardInfoLazyQueryHookResult = ReturnType<typeof useGetBaseDashboardInfoLazyQuery>;
export type GetBaseDashboardInfoQueryResult = ApolloReactCommon.QueryResult<GetBaseDashboardInfoQuery, GetBaseDashboardInfoQueryVariables>;
export const UpsertContractorDashoardInfoDocument = gql`
    mutation UpsertContractorDashoardInfo($customSettings: CustomContractorSettingsAttributes!) {
  upsertContractor(customSettings: $customSettings) {
    ... on UpsertContractorSuccess {
      contractor {
        id
        customSettings {
          newDashboardWelcomeModalSeen
          highlightPaymentsOverlaySeenCount
          paymentsApprovalModalSeen
          hearthOnboardingModalSeen
          financingUnlockedModalSeen
          financingUnlockedHighlightSeen
        }
      }
    }
    ... on UpsertContractorFailure {
      errors {
        message
        path
        code
      }
    }
  }
}
    `;

/**
 * __useUpsertContractorDashoardInfoMutation__
 *
 * To run a mutation, you first call `useUpsertContractorDashoardInfoMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpsertContractorDashoardInfoMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [upsertContractorDashoardInfoMutation, { data, loading, error }] = useUpsertContractorDashoardInfoMutation({
 *   variables: {
 *      customSettings: // value for 'customSettings'
 *   },
 * });
 */
export function useUpsertContractorDashoardInfoMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<UpsertContractorDashoardInfoMutation, UpsertContractorDashoardInfoMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useMutation<UpsertContractorDashoardInfoMutation, UpsertContractorDashoardInfoMutationVariables>(UpsertContractorDashoardInfoDocument, options);
      }
export type UpsertContractorDashoardInfoMutationHookResult = ReturnType<typeof useUpsertContractorDashoardInfoMutation>;
export type UpsertContractorDashoardInfoMutationResult = ApolloReactCommon.MutationResult<UpsertContractorDashoardInfoMutation>;
export type UpsertContractorDashoardInfoMutationOptions = ApolloReactCommon.BaseMutationOptions<UpsertContractorDashoardInfoMutation, UpsertContractorDashoardInfoMutationVariables>;
export const GetFirstTemplateBannerDataDocument = gql`
    query GetFirstTemplateBannerData {
  contractor {
    id
    customSettings {
      firstTemplateBannerDismissed
    }
  }
}
    `;

/**
 * __useGetFirstTemplateBannerDataQuery__
 *
 * To run a query within a React component, call `useGetFirstTemplateBannerDataQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetFirstTemplateBannerDataQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetFirstTemplateBannerDataQuery({
 *   variables: {
 *   },
 * });
 */
export function useGetFirstTemplateBannerDataQuery(baseOptions?: ApolloReactHooks.QueryHookOptions<GetFirstTemplateBannerDataQuery, GetFirstTemplateBannerDataQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<GetFirstTemplateBannerDataQuery, GetFirstTemplateBannerDataQueryVariables>(GetFirstTemplateBannerDataDocument, options);
      }
export function useGetFirstTemplateBannerDataLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<GetFirstTemplateBannerDataQuery, GetFirstTemplateBannerDataQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<GetFirstTemplateBannerDataQuery, GetFirstTemplateBannerDataQueryVariables>(GetFirstTemplateBannerDataDocument, options);
        }
export type GetFirstTemplateBannerDataQueryHookResult = ReturnType<typeof useGetFirstTemplateBannerDataQuery>;
export type GetFirstTemplateBannerDataLazyQueryHookResult = ReturnType<typeof useGetFirstTemplateBannerDataLazyQuery>;
export type GetFirstTemplateBannerDataQueryResult = ApolloReactCommon.QueryResult<GetFirstTemplateBannerDataQuery, GetFirstTemplateBannerDataQueryVariables>;
export const GetViewContractTemplateDocument = gql`
    query GetViewContractTemplate {
  contractor {
    id
    phoneNumber
    fullName
    email
  }
  organization {
    id
    companyName
    fullAddress
    address
    city
    state
    zipCode
    logoUrl
    businessPhone
    businessLicenseNumber
  }
  contractServiceContractTemplate(type: project_contract) {
    id
    template
  }
}
    `;

/**
 * __useGetViewContractTemplateQuery__
 *
 * To run a query within a React component, call `useGetViewContractTemplateQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetViewContractTemplateQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetViewContractTemplateQuery({
 *   variables: {
 *   },
 * });
 */
export function useGetViewContractTemplateQuery(baseOptions?: ApolloReactHooks.QueryHookOptions<GetViewContractTemplateQuery, GetViewContractTemplateQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<GetViewContractTemplateQuery, GetViewContractTemplateQueryVariables>(GetViewContractTemplateDocument, options);
      }
export function useGetViewContractTemplateLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<GetViewContractTemplateQuery, GetViewContractTemplateQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<GetViewContractTemplateQuery, GetViewContractTemplateQueryVariables>(GetViewContractTemplateDocument, options);
        }
export type GetViewContractTemplateQueryHookResult = ReturnType<typeof useGetViewContractTemplateQuery>;
export type GetViewContractTemplateLazyQueryHookResult = ReturnType<typeof useGetViewContractTemplateLazyQuery>;
export type GetViewContractTemplateQueryResult = ApolloReactCommon.QueryResult<GetViewContractTemplateQuery, GetViewContractTemplateQueryVariables>;
export const GenerateViewContractPreviewPdfDocument = gql`
    mutation GenerateViewContractPreviewPdf($html: String!) {
  contractGeneratorRestGeneratePdf(input: {html: $html}) @rest(endpoint: "contractGenerator", method: "POST", path: "/pdf_generator", type: "ContractGeneratorRestGeneratePdfResult") {
    pdf
  }
}
    `;

/**
 * __useGenerateViewContractPreviewPdfMutation__
 *
 * To run a mutation, you first call `useGenerateViewContractPreviewPdfMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useGenerateViewContractPreviewPdfMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [generateViewContractPreviewPdfMutation, { data, loading, error }] = useGenerateViewContractPreviewPdfMutation({
 *   variables: {
 *      html: // value for 'html'
 *   },
 * });
 */
export function useGenerateViewContractPreviewPdfMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<GenerateViewContractPreviewPdfMutation, GenerateViewContractPreviewPdfMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useMutation<GenerateViewContractPreviewPdfMutation, GenerateViewContractPreviewPdfMutationVariables>(GenerateViewContractPreviewPdfDocument, options);
      }
export type GenerateViewContractPreviewPdfMutationHookResult = ReturnType<typeof useGenerateViewContractPreviewPdfMutation>;
export type GenerateViewContractPreviewPdfMutationResult = ApolloReactCommon.MutationResult<GenerateViewContractPreviewPdfMutation>;
export type GenerateViewContractPreviewPdfMutationOptions = ApolloReactCommon.BaseMutationOptions<GenerateViewContractPreviewPdfMutation, GenerateViewContractPreviewPdfMutationVariables>;
export const EditContractAdminCheckDocument = gql`
    query EditContractAdminCheck {
  contractor {
    id
    admin
  }
  contractServiceContractTemplate(type: project_contract) {
    id
    updatedAt
  }
}
    `;

/**
 * __useEditContractAdminCheckQuery__
 *
 * To run a query within a React component, call `useEditContractAdminCheckQuery` and pass it any options that fit your needs.
 * When your component renders, `useEditContractAdminCheckQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useEditContractAdminCheckQuery({
 *   variables: {
 *   },
 * });
 */
export function useEditContractAdminCheckQuery(baseOptions?: ApolloReactHooks.QueryHookOptions<EditContractAdminCheckQuery, EditContractAdminCheckQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<EditContractAdminCheckQuery, EditContractAdminCheckQueryVariables>(EditContractAdminCheckDocument, options);
      }
export function useEditContractAdminCheckLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<EditContractAdminCheckQuery, EditContractAdminCheckQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<EditContractAdminCheckQuery, EditContractAdminCheckQueryVariables>(EditContractAdminCheckDocument, options);
        }
export type EditContractAdminCheckQueryHookResult = ReturnType<typeof useEditContractAdminCheckQuery>;
export type EditContractAdminCheckLazyQueryHookResult = ReturnType<typeof useEditContractAdminCheckLazyQuery>;
export type EditContractAdminCheckQueryResult = ApolloReactCommon.QueryResult<EditContractAdminCheckQuery, EditContractAdminCheckQueryVariables>;
export const GetDefaultTosDocument = gql`
    query GetDefaultTos {
  contractServiceBaseTemplate(type: project_contract) {
    id
    template
  }
}
    `;

/**
 * __useGetDefaultTosQuery__
 *
 * To run a query within a React component, call `useGetDefaultTosQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetDefaultTosQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetDefaultTosQuery({
 *   variables: {
 *   },
 * });
 */
export function useGetDefaultTosQuery(baseOptions?: ApolloReactHooks.QueryHookOptions<GetDefaultTosQuery, GetDefaultTosQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<GetDefaultTosQuery, GetDefaultTosQueryVariables>(GetDefaultTosDocument, options);
      }
export function useGetDefaultTosLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<GetDefaultTosQuery, GetDefaultTosQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<GetDefaultTosQuery, GetDefaultTosQueryVariables>(GetDefaultTosDocument, options);
        }
export type GetDefaultTosQueryHookResult = ReturnType<typeof useGetDefaultTosQuery>;
export type GetDefaultTosLazyQueryHookResult = ReturnType<typeof useGetDefaultTosLazyQuery>;
export type GetDefaultTosQueryResult = ApolloReactCommon.QueryResult<GetDefaultTosQuery, GetDefaultTosQueryVariables>;
export const SetFirstTemplateBannerDismissedDocument = gql`
    mutation SetFirstTemplateBannerDismissed {
  upsertContractor(customSettings: {firstTemplateBannerDismissed: true}) {
    ... on UpsertContractorFailure {
      errors {
        message
        path
        code
      }
    }
  }
}
    `;

/**
 * __useSetFirstTemplateBannerDismissedMutation__
 *
 * To run a mutation, you first call `useSetFirstTemplateBannerDismissedMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useSetFirstTemplateBannerDismissedMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [setFirstTemplateBannerDismissedMutation, { data, loading, error }] = useSetFirstTemplateBannerDismissedMutation({
 *   variables: {
 *   },
 * });
 */
export function useSetFirstTemplateBannerDismissedMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<SetFirstTemplateBannerDismissedMutation, SetFirstTemplateBannerDismissedMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useMutation<SetFirstTemplateBannerDismissedMutation, SetFirstTemplateBannerDismissedMutationVariables>(SetFirstTemplateBannerDismissedDocument, options);
      }
export type SetFirstTemplateBannerDismissedMutationHookResult = ReturnType<typeof useSetFirstTemplateBannerDismissedMutation>;
export type SetFirstTemplateBannerDismissedMutationResult = ApolloReactCommon.MutationResult<SetFirstTemplateBannerDismissedMutation>;
export type SetFirstTemplateBannerDismissedMutationOptions = ApolloReactCommon.BaseMutationOptions<SetFirstTemplateBannerDismissedMutation, SetFirstTemplateBannerDismissedMutationVariables>;
export const GetContractServiceAccountIdDocument = gql`
    query GetContractServiceAccountId {
  organization {
    id
    contractServiceAccount {
      id
    }
  }
}
    `;

/**
 * __useGetContractServiceAccountIdQuery__
 *
 * To run a query within a React component, call `useGetContractServiceAccountIdQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetContractServiceAccountIdQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetContractServiceAccountIdQuery({
 *   variables: {
 *   },
 * });
 */
export function useGetContractServiceAccountIdQuery(baseOptions?: ApolloReactHooks.QueryHookOptions<GetContractServiceAccountIdQuery, GetContractServiceAccountIdQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<GetContractServiceAccountIdQuery, GetContractServiceAccountIdQueryVariables>(GetContractServiceAccountIdDocument, options);
      }
export function useGetContractServiceAccountIdLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<GetContractServiceAccountIdQuery, GetContractServiceAccountIdQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<GetContractServiceAccountIdQuery, GetContractServiceAccountIdQueryVariables>(GetContractServiceAccountIdDocument, options);
        }
export type GetContractServiceAccountIdQueryHookResult = ReturnType<typeof useGetContractServiceAccountIdQuery>;
export type GetContractServiceAccountIdLazyQueryHookResult = ReturnType<typeof useGetContractServiceAccountIdLazyQuery>;
export type GetContractServiceAccountIdQueryResult = ApolloReactCommon.QueryResult<GetContractServiceAccountIdQuery, GetContractServiceAccountIdQueryVariables>;
export const SetTermsAcceptanceDocument = gql`
    mutation SetTermsAcceptance($contractServiceAccountId: String!, $termsAgreed: String!) {
  contractServiceSignTerms(
    contractServiceAccountId: $contractServiceAccountId
    termsAgreed: $termsAgreed
  ) {
    ... on ContractServiceSignTermsSuccess {
      contractServiceAccount {
        id
        termsAgreed
      }
    }
    ... on ContractServiceSignTermsFailure {
      errors {
        message
        path
        code
      }
    }
  }
}
    `;

/**
 * __useSetTermsAcceptanceMutation__
 *
 * To run a mutation, you first call `useSetTermsAcceptanceMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useSetTermsAcceptanceMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [setTermsAcceptanceMutation, { data, loading, error }] = useSetTermsAcceptanceMutation({
 *   variables: {
 *      contractServiceAccountId: // value for 'contractServiceAccountId'
 *      termsAgreed: // value for 'termsAgreed'
 *   },
 * });
 */
export function useSetTermsAcceptanceMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<SetTermsAcceptanceMutation, SetTermsAcceptanceMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useMutation<SetTermsAcceptanceMutation, SetTermsAcceptanceMutationVariables>(SetTermsAcceptanceDocument, options);
      }
export type SetTermsAcceptanceMutationHookResult = ReturnType<typeof useSetTermsAcceptanceMutation>;
export type SetTermsAcceptanceMutationResult = ApolloReactCommon.MutationResult<SetTermsAcceptanceMutation>;
export type SetTermsAcceptanceMutationOptions = ApolloReactCommon.BaseMutationOptions<SetTermsAcceptanceMutation, SetTermsAcceptanceMutationVariables>;
export const GetEditContractTemplateDocument = gql`
    query GetEditContractTemplate {
  organization {
    id
    ...OrganizationContractTemplateInfo
  }
  contractor {
    id
    phoneNumber
    email
    admin
    fullName
  }
  contractServiceContractTemplate(type: project_contract) {
    id
    versionName
    template
    baseTemplate {
      id
    }
  }
}
    ${OrganizationContractTemplateInfoFragmentDoc}`;

/**
 * __useGetEditContractTemplateQuery__
 *
 * To run a query within a React component, call `useGetEditContractTemplateQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetEditContractTemplateQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetEditContractTemplateQuery({
 *   variables: {
 *   },
 * });
 */
export function useGetEditContractTemplateQuery(baseOptions?: ApolloReactHooks.QueryHookOptions<GetEditContractTemplateQuery, GetEditContractTemplateQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<GetEditContractTemplateQuery, GetEditContractTemplateQueryVariables>(GetEditContractTemplateDocument, options);
      }
export function useGetEditContractTemplateLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<GetEditContractTemplateQuery, GetEditContractTemplateQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<GetEditContractTemplateQuery, GetEditContractTemplateQueryVariables>(GetEditContractTemplateDocument, options);
        }
export type GetEditContractTemplateQueryHookResult = ReturnType<typeof useGetEditContractTemplateQuery>;
export type GetEditContractTemplateLazyQueryHookResult = ReturnType<typeof useGetEditContractTemplateLazyQuery>;
export type GetEditContractTemplateQueryResult = ApolloReactCommon.QueryResult<GetEditContractTemplateQuery, GetEditContractTemplateQueryVariables>;
export const GetContractBaseTemplatesDocument = gql`
    query GetContractBaseTemplates {
  contractServiceBaseTemplate(type: project_contract) {
    id
    template
  }
}
    `;

/**
 * __useGetContractBaseTemplatesQuery__
 *
 * To run a query within a React component, call `useGetContractBaseTemplatesQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetContractBaseTemplatesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetContractBaseTemplatesQuery({
 *   variables: {
 *   },
 * });
 */
export function useGetContractBaseTemplatesQuery(baseOptions?: ApolloReactHooks.QueryHookOptions<GetContractBaseTemplatesQuery, GetContractBaseTemplatesQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<GetContractBaseTemplatesQuery, GetContractBaseTemplatesQueryVariables>(GetContractBaseTemplatesDocument, options);
      }
export function useGetContractBaseTemplatesLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<GetContractBaseTemplatesQuery, GetContractBaseTemplatesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<GetContractBaseTemplatesQuery, GetContractBaseTemplatesQueryVariables>(GetContractBaseTemplatesDocument, options);
        }
export type GetContractBaseTemplatesQueryHookResult = ReturnType<typeof useGetContractBaseTemplatesQuery>;
export type GetContractBaseTemplatesLazyQueryHookResult = ReturnType<typeof useGetContractBaseTemplatesLazyQuery>;
export type GetContractBaseTemplatesQueryResult = ApolloReactCommon.QueryResult<GetContractBaseTemplatesQuery, GetContractBaseTemplatesQueryVariables>;
export const UpsertOrganizationContractHeaderInfoDocument = gql`
    mutation UpsertOrganizationContractHeaderInfo($attributes: OrganizationAttributes!) {
  upsertOrganization(attributes: $attributes) {
    ... on UpsertOrganizationSuccess {
      organization {
        id
        ...OrganizationContractTemplateInfo
      }
    }
    ... on UpsertOrganizationFailure {
      errors {
        message
        path
        code
      }
    }
  }
}
    ${OrganizationContractTemplateInfoFragmentDoc}`;

/**
 * __useUpsertOrganizationContractHeaderInfoMutation__
 *
 * To run a mutation, you first call `useUpsertOrganizationContractHeaderInfoMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpsertOrganizationContractHeaderInfoMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [upsertOrganizationContractHeaderInfoMutation, { data, loading, error }] = useUpsertOrganizationContractHeaderInfoMutation({
 *   variables: {
 *      attributes: // value for 'attributes'
 *   },
 * });
 */
export function useUpsertOrganizationContractHeaderInfoMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<UpsertOrganizationContractHeaderInfoMutation, UpsertOrganizationContractHeaderInfoMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useMutation<UpsertOrganizationContractHeaderInfoMutation, UpsertOrganizationContractHeaderInfoMutationVariables>(UpsertOrganizationContractHeaderInfoDocument, options);
      }
export type UpsertOrganizationContractHeaderInfoMutationHookResult = ReturnType<typeof useUpsertOrganizationContractHeaderInfoMutation>;
export type UpsertOrganizationContractHeaderInfoMutationResult = ApolloReactCommon.MutationResult<UpsertOrganizationContractHeaderInfoMutation>;
export type UpsertOrganizationContractHeaderInfoMutationOptions = ApolloReactCommon.BaseMutationOptions<UpsertOrganizationContractHeaderInfoMutation, UpsertOrganizationContractHeaderInfoMutationVariables>;
export const UpsertContractTemplateDocument = gql`
    mutation UpsertContractTemplate($contractServiceAccountId: ID!, $baseTemplateId: String!, $template: JSON!) {
  contractServiceContractTemplateUpsert(
    contractServiceAccountId: $contractServiceAccountId
    templateParams: {type: project_contract, template: $template, baseTemplateId: $baseTemplateId}
  ) {
    ... on ContractServiceTemplateUpsertSuccess {
      contractServiceContractTemplate {
        id
        version
        baseTemplate {
          id
        }
      }
    }
    ... on ContractServiceTemplateUpsertFailure {
      errors {
        message
        path
        code
      }
    }
  }
}
    `;

/**
 * __useUpsertContractTemplateMutation__
 *
 * To run a mutation, you first call `useUpsertContractTemplateMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpsertContractTemplateMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [upsertContractTemplateMutation, { data, loading, error }] = useUpsertContractTemplateMutation({
 *   variables: {
 *      contractServiceAccountId: // value for 'contractServiceAccountId'
 *      baseTemplateId: // value for 'baseTemplateId'
 *      template: // value for 'template'
 *   },
 * });
 */
export function useUpsertContractTemplateMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<UpsertContractTemplateMutation, UpsertContractTemplateMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useMutation<UpsertContractTemplateMutation, UpsertContractTemplateMutationVariables>(UpsertContractTemplateDocument, options);
      }
export type UpsertContractTemplateMutationHookResult = ReturnType<typeof useUpsertContractTemplateMutation>;
export type UpsertContractTemplateMutationResult = ApolloReactCommon.MutationResult<UpsertContractTemplateMutation>;
export type UpsertContractTemplateMutationOptions = ApolloReactCommon.BaseMutationOptions<UpsertContractTemplateMutation, UpsertContractTemplateMutationVariables>;
export const UpsertEditContractTemplateVersionDocument = gql`
    mutation UpsertEditContractTemplateVersion($templateId: ID, $contractServiceAccountId: ID!, $baseTemplateId: String!, $template: JSON!, $versionName: String!, $contractorId: ID!) {
  contractServiceContractTemplateVersionUpsert(
    contractServiceAccountId: $contractServiceAccountId
    templateParams: {id: $templateId, type: project_contract, template: $template, baseTemplateId: $baseTemplateId, versionName: $versionName, editedBy: $contractorId}
  ) {
    ... on ContractServiceTemplateVersionUpsertSuccess {
      contractServiceContractTemplate {
        id
        version
        baseTemplate {
          id
        }
      }
    }
    ... on ContractServiceTemplateVersionUpsertFailure {
      errors {
        message
        path
        code
      }
    }
  }
}
    `;

/**
 * __useUpsertEditContractTemplateVersionMutation__
 *
 * To run a mutation, you first call `useUpsertEditContractTemplateVersionMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpsertEditContractTemplateVersionMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [upsertEditContractTemplateVersionMutation, { data, loading, error }] = useUpsertEditContractTemplateVersionMutation({
 *   variables: {
 *      templateId: // value for 'templateId'
 *      contractServiceAccountId: // value for 'contractServiceAccountId'
 *      baseTemplateId: // value for 'baseTemplateId'
 *      template: // value for 'template'
 *      versionName: // value for 'versionName'
 *      contractorId: // value for 'contractorId'
 *   },
 * });
 */
export function useUpsertEditContractTemplateVersionMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<UpsertEditContractTemplateVersionMutation, UpsertEditContractTemplateVersionMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useMutation<UpsertEditContractTemplateVersionMutation, UpsertEditContractTemplateVersionMutationVariables>(UpsertEditContractTemplateVersionDocument, options);
      }
export type UpsertEditContractTemplateVersionMutationHookResult = ReturnType<typeof useUpsertEditContractTemplateVersionMutation>;
export type UpsertEditContractTemplateVersionMutationResult = ApolloReactCommon.MutationResult<UpsertEditContractTemplateVersionMutation>;
export type UpsertEditContractTemplateVersionMutationOptions = ApolloReactCommon.BaseMutationOptions<UpsertEditContractTemplateVersionMutation, UpsertEditContractTemplateVersionMutationVariables>;
export const GetAllContractTemplatesDocument = gql`
    query GetAllContractTemplates {
  organization {
    id
    contractServiceAccount {
      id
      latestVersionContractTemplates {
        nodes {
          id
          ...ContractTemplateVersion
        }
      }
    }
  }
}
    ${ContractTemplateVersionFragmentDoc}`;

/**
 * __useGetAllContractTemplatesQuery__
 *
 * To run a query within a React component, call `useGetAllContractTemplatesQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetAllContractTemplatesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetAllContractTemplatesQuery({
 *   variables: {
 *   },
 * });
 */
export function useGetAllContractTemplatesQuery(baseOptions?: ApolloReactHooks.QueryHookOptions<GetAllContractTemplatesQuery, GetAllContractTemplatesQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<GetAllContractTemplatesQuery, GetAllContractTemplatesQueryVariables>(GetAllContractTemplatesDocument, options);
      }
export function useGetAllContractTemplatesLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<GetAllContractTemplatesQuery, GetAllContractTemplatesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<GetAllContractTemplatesQuery, GetAllContractTemplatesQueryVariables>(GetAllContractTemplatesDocument, options);
        }
export type GetAllContractTemplatesQueryHookResult = ReturnType<typeof useGetAllContractTemplatesQuery>;
export type GetAllContractTemplatesLazyQueryHookResult = ReturnType<typeof useGetAllContractTemplatesLazyQuery>;
export type GetAllContractTemplatesQueryResult = ApolloReactCommon.QueryResult<GetAllContractTemplatesQuery, GetAllContractTemplatesQueryVariables>;
export const SetDefaultContractTemplateDocument = gql`
    mutation SetDefaultContractTemplate($contractServiceContractTemplateId: ID!) {
  contractServiceMarkDefaultTemplate(
    contractServiceContractTemplateId: $contractServiceContractTemplateId
  ) {
    ... on ContractServiceMarkDefaultTemplateSuccess {
      contractServiceContractTemplate {
        id
      }
    }
    ... on ContractServiceMarkDefaultTemplateFailure {
      errors {
        message
        path
        code
      }
    }
  }
}
    `;

/**
 * __useSetDefaultContractTemplateMutation__
 *
 * To run a mutation, you first call `useSetDefaultContractTemplateMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useSetDefaultContractTemplateMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [setDefaultContractTemplateMutation, { data, loading, error }] = useSetDefaultContractTemplateMutation({
 *   variables: {
 *      contractServiceContractTemplateId: // value for 'contractServiceContractTemplateId'
 *   },
 * });
 */
export function useSetDefaultContractTemplateMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<SetDefaultContractTemplateMutation, SetDefaultContractTemplateMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useMutation<SetDefaultContractTemplateMutation, SetDefaultContractTemplateMutationVariables>(SetDefaultContractTemplateDocument, options);
      }
export type SetDefaultContractTemplateMutationHookResult = ReturnType<typeof useSetDefaultContractTemplateMutation>;
export type SetDefaultContractTemplateMutationResult = ApolloReactCommon.MutationResult<SetDefaultContractTemplateMutation>;
export type SetDefaultContractTemplateMutationOptions = ApolloReactCommon.BaseMutationOptions<SetDefaultContractTemplateMutation, SetDefaultContractTemplateMutationVariables>;
export const DeleteAllTemplatesByVersionNameDocument = gql`
    mutation DeleteAllTemplatesByVersionName($versionName: String!) {
  contractServiceContractTemplateDeleteByName(versionName: $versionName) {
    ... on ContractServiceTemplateDeleteByNameSuccess {
      contractServiceContractTemplateVersionName
    }
    ... on ContractServiceTemplateDeleteByNameFailure {
      errors {
        message
        path
        code
      }
    }
  }
}
    `;

/**
 * __useDeleteAllTemplatesByVersionNameMutation__
 *
 * To run a mutation, you first call `useDeleteAllTemplatesByVersionNameMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteAllTemplatesByVersionNameMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteAllTemplatesByVersionNameMutation, { data, loading, error }] = useDeleteAllTemplatesByVersionNameMutation({
 *   variables: {
 *      versionName: // value for 'versionName'
 *   },
 * });
 */
export function useDeleteAllTemplatesByVersionNameMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<DeleteAllTemplatesByVersionNameMutation, DeleteAllTemplatesByVersionNameMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useMutation<DeleteAllTemplatesByVersionNameMutation, DeleteAllTemplatesByVersionNameMutationVariables>(DeleteAllTemplatesByVersionNameDocument, options);
      }
export type DeleteAllTemplatesByVersionNameMutationHookResult = ReturnType<typeof useDeleteAllTemplatesByVersionNameMutation>;
export type DeleteAllTemplatesByVersionNameMutationResult = ApolloReactCommon.MutationResult<DeleteAllTemplatesByVersionNameMutation>;
export type DeleteAllTemplatesByVersionNameMutationOptions = ApolloReactCommon.BaseMutationOptions<DeleteAllTemplatesByVersionNameMutation, DeleteAllTemplatesByVersionNameMutationVariables>;
export const GenerateEditContractPreviewPdfDocument = gql`
    mutation GenerateEditContractPreviewPdf($html: String!) {
  contractGeneratorRestGeneratePdf(input: {html: $html}) @rest(endpoint: "contractGenerator", method: "POST", path: "/pdf_generator", type: "ContractGeneratorRestGeneratePdfResult") {
    pdf
  }
}
    `;

/**
 * __useGenerateEditContractPreviewPdfMutation__
 *
 * To run a mutation, you first call `useGenerateEditContractPreviewPdfMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useGenerateEditContractPreviewPdfMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [generateEditContractPreviewPdfMutation, { data, loading, error }] = useGenerateEditContractPreviewPdfMutation({
 *   variables: {
 *      html: // value for 'html'
 *   },
 * });
 */
export function useGenerateEditContractPreviewPdfMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<GenerateEditContractPreviewPdfMutation, GenerateEditContractPreviewPdfMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useMutation<GenerateEditContractPreviewPdfMutation, GenerateEditContractPreviewPdfMutationVariables>(GenerateEditContractPreviewPdfDocument, options);
      }
export type GenerateEditContractPreviewPdfMutationHookResult = ReturnType<typeof useGenerateEditContractPreviewPdfMutation>;
export type GenerateEditContractPreviewPdfMutationResult = ApolloReactCommon.MutationResult<GenerateEditContractPreviewPdfMutation>;
export type GenerateEditContractPreviewPdfMutationOptions = ApolloReactCommon.BaseMutationOptions<GenerateEditContractPreviewPdfMutation, GenerateEditContractPreviewPdfMutationVariables>;
export const HearthCashPaintedDoorResponseDocument = gql`
    mutation HearthCashPaintedDoorResponse($customSettings: CustomContractorSettingsAttributes!) {
  upsertContractor(customSettings: $customSettings) {
    ... on UpsertContractorSuccess {
      contractor {
        id
        customSettings {
          hearthCashPaintedDoorWaitlistJoined
        }
      }
    }
    ... on UpsertContractorFailure {
      errors {
        message
        path
        code
      }
    }
  }
}
    `;

/**
 * __useHearthCashPaintedDoorResponseMutation__
 *
 * To run a mutation, you first call `useHearthCashPaintedDoorResponseMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useHearthCashPaintedDoorResponseMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [hearthCashPaintedDoorResponseMutation, { data, loading, error }] = useHearthCashPaintedDoorResponseMutation({
 *   variables: {
 *      customSettings: // value for 'customSettings'
 *   },
 * });
 */
export function useHearthCashPaintedDoorResponseMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<HearthCashPaintedDoorResponseMutation, HearthCashPaintedDoorResponseMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useMutation<HearthCashPaintedDoorResponseMutation, HearthCashPaintedDoorResponseMutationVariables>(HearthCashPaintedDoorResponseDocument, options);
      }
export type HearthCashPaintedDoorResponseMutationHookResult = ReturnType<typeof useHearthCashPaintedDoorResponseMutation>;
export type HearthCashPaintedDoorResponseMutationResult = ApolloReactCommon.MutationResult<HearthCashPaintedDoorResponseMutation>;
export type HearthCashPaintedDoorResponseMutationOptions = ApolloReactCommon.BaseMutationOptions<HearthCashPaintedDoorResponseMutation, HearthCashPaintedDoorResponseMutationVariables>;
export const GetIncompleteFinancingFeedbackResponseDocument = gql`
    query GetIncompleteFinancingFeedbackResponse($uuid: ID!) {
  homeownerFeedbackResponse(uuid: $uuid) {
    id
    uuid
    status
  }
}
    `;

/**
 * __useGetIncompleteFinancingFeedbackResponseQuery__
 *
 * To run a query within a React component, call `useGetIncompleteFinancingFeedbackResponseQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetIncompleteFinancingFeedbackResponseQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetIncompleteFinancingFeedbackResponseQuery({
 *   variables: {
 *      uuid: // value for 'uuid'
 *   },
 * });
 */
export function useGetIncompleteFinancingFeedbackResponseQuery(baseOptions: ApolloReactHooks.QueryHookOptions<GetIncompleteFinancingFeedbackResponseQuery, GetIncompleteFinancingFeedbackResponseQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<GetIncompleteFinancingFeedbackResponseQuery, GetIncompleteFinancingFeedbackResponseQueryVariables>(GetIncompleteFinancingFeedbackResponseDocument, options);
      }
export function useGetIncompleteFinancingFeedbackResponseLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<GetIncompleteFinancingFeedbackResponseQuery, GetIncompleteFinancingFeedbackResponseQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<GetIncompleteFinancingFeedbackResponseQuery, GetIncompleteFinancingFeedbackResponseQueryVariables>(GetIncompleteFinancingFeedbackResponseDocument, options);
        }
export type GetIncompleteFinancingFeedbackResponseQueryHookResult = ReturnType<typeof useGetIncompleteFinancingFeedbackResponseQuery>;
export type GetIncompleteFinancingFeedbackResponseLazyQueryHookResult = ReturnType<typeof useGetIncompleteFinancingFeedbackResponseLazyQuery>;
export type GetIncompleteFinancingFeedbackResponseQueryResult = ApolloReactCommon.QueryResult<GetIncompleteFinancingFeedbackResponseQuery, GetIncompleteFinancingFeedbackResponseQueryVariables>;
export const CreateHomeownerFinancingFeedbackResponseDocument = gql`
    mutation CreateHomeownerFinancingFeedbackResponse($uuid: ID!, $attributes: HomeownerFeedbackResponseAttributes!) {
  upsertHomeownerFinancingFeedback(uuid: $uuid, attributes: $attributes) {
    ... on UpsertHomeownerFinancingFeedbackSuccess {
      homeownerFeedbackResponse {
        id
        uuid
        status
      }
    }
    ... on UpsertHomeownerFinancingFeedbackFailure {
      errors {
        message
        path
        code
      }
    }
  }
}
    `;

/**
 * __useCreateHomeownerFinancingFeedbackResponseMutation__
 *
 * To run a mutation, you first call `useCreateHomeownerFinancingFeedbackResponseMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateHomeownerFinancingFeedbackResponseMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createHomeownerFinancingFeedbackResponseMutation, { data, loading, error }] = useCreateHomeownerFinancingFeedbackResponseMutation({
 *   variables: {
 *      uuid: // value for 'uuid'
 *      attributes: // value for 'attributes'
 *   },
 * });
 */
export function useCreateHomeownerFinancingFeedbackResponseMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<CreateHomeownerFinancingFeedbackResponseMutation, CreateHomeownerFinancingFeedbackResponseMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useMutation<CreateHomeownerFinancingFeedbackResponseMutation, CreateHomeownerFinancingFeedbackResponseMutationVariables>(CreateHomeownerFinancingFeedbackResponseDocument, options);
      }
export type CreateHomeownerFinancingFeedbackResponseMutationHookResult = ReturnType<typeof useCreateHomeownerFinancingFeedbackResponseMutation>;
export type CreateHomeownerFinancingFeedbackResponseMutationResult = ApolloReactCommon.MutationResult<CreateHomeownerFinancingFeedbackResponseMutation>;
export type CreateHomeownerFinancingFeedbackResponseMutationOptions = ApolloReactCommon.BaseMutationOptions<CreateHomeownerFinancingFeedbackResponseMutation, CreateHomeownerFinancingFeedbackResponseMutationVariables>;
export const FetchOrganizationDocument = gql`
    query FetchOrganization($organizationUuid: ID!) {
  organization(uuid: $organizationUuid) {
    id
    ...OrganizationBusinessInfo
  }
}
    ${OrganizationBusinessInfoFragmentDoc}`;

/**
 * __useFetchOrganizationQuery__
 *
 * To run a query within a React component, call `useFetchOrganizationQuery` and pass it any options that fit your needs.
 * When your component renders, `useFetchOrganizationQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useFetchOrganizationQuery({
 *   variables: {
 *      organizationUuid: // value for 'organizationUuid'
 *   },
 * });
 */
export function useFetchOrganizationQuery(baseOptions: ApolloReactHooks.QueryHookOptions<FetchOrganizationQuery, FetchOrganizationQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<FetchOrganizationQuery, FetchOrganizationQueryVariables>(FetchOrganizationDocument, options);
      }
export function useFetchOrganizationLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<FetchOrganizationQuery, FetchOrganizationQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<FetchOrganizationQuery, FetchOrganizationQueryVariables>(FetchOrganizationDocument, options);
        }
export type FetchOrganizationQueryHookResult = ReturnType<typeof useFetchOrganizationQuery>;
export type FetchOrganizationLazyQueryHookResult = ReturnType<typeof useFetchOrganizationLazyQuery>;
export type FetchOrganizationQueryResult = ApolloReactCommon.QueryResult<FetchOrganizationQuery, FetchOrganizationQueryVariables>;
export const FetchInvoiceDocument = gql`
    query FetchInvoice($connectInvoiceId: ID!) {
  connectInvoice(id: $connectInvoiceId) {
    id
    invoiceNumber
    amountRequested
    description
    personalNote
    scheduledFor
    dueDate
    status
    paymentsCapabilityStatus
    paid
    paidWith
    requirePaymentMethod
    achEnabled
    creditCardEnabled
    debitCardEnabled
    refundedAmount
    refundableAmount
    chargedAmount
    includesFinancing
    outstandingInvoiceNumber
    onlinePaymentsRequested
    sentAt
    fullName
    phoneNumber
    email
    initiatedRefunds {
      nodes {
        id
        amount
        description
        amount
      }
    }
    plaidLinkToken
    plaidAccount {
      id
      mask
      name
      verificationStatus
      verified
    }
    organization {
      id
      ...OrganizationBusinessInfo
    }
    contractor {
      id
      featureFlags {
        id
      }
      fullUrl
    }
    homeowner {
      id
      ...CurrentConnectInvoiceHomeowner
    }
    homeownerAchFee
    homeownerCardFee
    homeownerDebitCardFee
    invoiceAttachments {
      nodes {
        id
        ...VisibleAttachment
      }
    }
    customizedInvoiceTemplate {
      id
      templateType
      primaryColor
      logo
      website
      background
      signatureMessage
      socialLinks {
        facebookUrl
        twitterUrl
        linkedinUrl
        instagramUrl
      }
    }
  }
}
    ${OrganizationBusinessInfoFragmentDoc}
${CurrentConnectInvoiceHomeownerFragmentDoc}
${VisibleAttachmentFragmentDoc}`;

/**
 * __useFetchInvoiceQuery__
 *
 * To run a query within a React component, call `useFetchInvoiceQuery` and pass it any options that fit your needs.
 * When your component renders, `useFetchInvoiceQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useFetchInvoiceQuery({
 *   variables: {
 *      connectInvoiceId: // value for 'connectInvoiceId'
 *   },
 * });
 */
export function useFetchInvoiceQuery(baseOptions: ApolloReactHooks.QueryHookOptions<FetchInvoiceQuery, FetchInvoiceQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<FetchInvoiceQuery, FetchInvoiceQueryVariables>(FetchInvoiceDocument, options);
      }
export function useFetchInvoiceLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<FetchInvoiceQuery, FetchInvoiceQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<FetchInvoiceQuery, FetchInvoiceQueryVariables>(FetchInvoiceDocument, options);
        }
export type FetchInvoiceQueryHookResult = ReturnType<typeof useFetchInvoiceQuery>;
export type FetchInvoiceLazyQueryHookResult = ReturnType<typeof useFetchInvoiceLazyQuery>;
export type FetchInvoiceQueryResult = ApolloReactCommon.QueryResult<FetchInvoiceQuery, FetchInvoiceQueryVariables>;
export const PayConnectInvoiceDocument = gql`
    mutation PayConnectInvoice($connectInvoiceId: ID!, $token: String, $homeownerTermsAgreed: String!, $cardType: StripeChargeCard) {
  payConnectInvoice(
    connectInvoiceId: $connectInvoiceId
    token: $token
    homeownerTermsAgreed: $homeownerTermsAgreed
    cardType: $cardType
  ) {
    ... on PayConnectInvoiceSuccess {
      connectInvoice {
        id
        status
        paidWith
        paidWithCardType
        organization {
          id
        }
        homeowner {
          id
          ...CurrentConnectInvoiceHomeowner
        }
      }
    }
    ... on PayConnectInvoiceFailure {
      errors {
        code
        message
      }
    }
  }
}
    ${CurrentConnectInvoiceHomeownerFragmentDoc}`;

/**
 * __usePayConnectInvoiceMutation__
 *
 * To run a mutation, you first call `usePayConnectInvoiceMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `usePayConnectInvoiceMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [payConnectInvoiceMutation, { data, loading, error }] = usePayConnectInvoiceMutation({
 *   variables: {
 *      connectInvoiceId: // value for 'connectInvoiceId'
 *      token: // value for 'token'
 *      homeownerTermsAgreed: // value for 'homeownerTermsAgreed'
 *      cardType: // value for 'cardType'
 *   },
 * });
 */
export function usePayConnectInvoiceMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<PayConnectInvoiceMutation, PayConnectInvoiceMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useMutation<PayConnectInvoiceMutation, PayConnectInvoiceMutationVariables>(PayConnectInvoiceDocument, options);
      }
export type PayConnectInvoiceMutationHookResult = ReturnType<typeof usePayConnectInvoiceMutation>;
export type PayConnectInvoiceMutationResult = ApolloReactCommon.MutationResult<PayConnectInvoiceMutation>;
export type PayConnectInvoiceMutationOptions = ApolloReactCommon.BaseMutationOptions<PayConnectInvoiceMutation, PayConnectInvoiceMutationVariables>;
export const UpdatePlaidTokenDocument = gql`
    mutation UpdatePlaidToken($plaidPublicToken: String!, $connectInvoiceId: ID!, $plaidAccountId: String!) {
  addPlaidTokenToConnectInvoice(
    plaidPublicToken: $plaidPublicToken
    connectInvoiceId: $connectInvoiceId
    plaidAccountId: $plaidAccountId
  ) {
    ... on AddPlaidTokenToConnectInvoiceSuccess {
      connectInvoice {
        id
        plaidAccount {
          id
          mask
          name
          verificationStatus
          verified
        }
      }
    }
    ... on AddPlaidTokenToConnectInvoiceFailure {
      errors {
        code
        message
      }
    }
  }
}
    `;

/**
 * __useUpdatePlaidTokenMutation__
 *
 * To run a mutation, you first call `useUpdatePlaidTokenMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdatePlaidTokenMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updatePlaidTokenMutation, { data, loading, error }] = useUpdatePlaidTokenMutation({
 *   variables: {
 *      plaidPublicToken: // value for 'plaidPublicToken'
 *      connectInvoiceId: // value for 'connectInvoiceId'
 *      plaidAccountId: // value for 'plaidAccountId'
 *   },
 * });
 */
export function useUpdatePlaidTokenMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<UpdatePlaidTokenMutation, UpdatePlaidTokenMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useMutation<UpdatePlaidTokenMutation, UpdatePlaidTokenMutationVariables>(UpdatePlaidTokenDocument, options);
      }
export type UpdatePlaidTokenMutationHookResult = ReturnType<typeof useUpdatePlaidTokenMutation>;
export type UpdatePlaidTokenMutationResult = ApolloReactCommon.MutationResult<UpdatePlaidTokenMutation>;
export type UpdatePlaidTokenMutationOptions = ApolloReactCommon.BaseMutationOptions<UpdatePlaidTokenMutation, UpdatePlaidTokenMutationVariables>;
export const RemovePlaidTokenDocument = gql`
    mutation RemovePlaidToken($connectInvoiceId: ID!) {
  removePlaidTokenFromConnectInvoice(connectInvoiceId: $connectInvoiceId) {
    ... on RemovePlaidTokenFromConnectInvoiceSuccess {
      connectInvoice {
        id
        status
        plaidLinkToken
        plaidAccount {
          id
          mask
          name
          verificationStatus
          verified
        }
      }
    }
    ... on RemovePlaidTokenFromConnectInvoiceFailure {
      errors {
        code
        message
      }
    }
  }
}
    `;

/**
 * __useRemovePlaidTokenMutation__
 *
 * To run a mutation, you first call `useRemovePlaidTokenMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useRemovePlaidTokenMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [removePlaidTokenMutation, { data, loading, error }] = useRemovePlaidTokenMutation({
 *   variables: {
 *      connectInvoiceId: // value for 'connectInvoiceId'
 *   },
 * });
 */
export function useRemovePlaidTokenMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<RemovePlaidTokenMutation, RemovePlaidTokenMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useMutation<RemovePlaidTokenMutation, RemovePlaidTokenMutationVariables>(RemovePlaidTokenDocument, options);
      }
export type RemovePlaidTokenMutationHookResult = ReturnType<typeof useRemovePlaidTokenMutation>;
export type RemovePlaidTokenMutationResult = ApolloReactCommon.MutationResult<RemovePlaidTokenMutation>;
export type RemovePlaidTokenMutationOptions = ApolloReactCommon.BaseMutationOptions<RemovePlaidTokenMutation, RemovePlaidTokenMutationVariables>;
export const MarkInvoiceFirstViewedAtDocument = gql`
    mutation MarkInvoiceFirstViewedAt($connectInvoiceId: ID!) {
  markConnectInvoiceFirstViewedAt(connectInvoiceId: $connectInvoiceId) {
    ... on MarkConnectInvoiceFirstViewedAtSuccess {
      connectInvoice {
        id
      }
    }
  }
}
    `;

/**
 * __useMarkInvoiceFirstViewedAtMutation__
 *
 * To run a mutation, you first call `useMarkInvoiceFirstViewedAtMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useMarkInvoiceFirstViewedAtMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [markInvoiceFirstViewedAtMutation, { data, loading, error }] = useMarkInvoiceFirstViewedAtMutation({
 *   variables: {
 *      connectInvoiceId: // value for 'connectInvoiceId'
 *   },
 * });
 */
export function useMarkInvoiceFirstViewedAtMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<MarkInvoiceFirstViewedAtMutation, MarkInvoiceFirstViewedAtMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useMutation<MarkInvoiceFirstViewedAtMutation, MarkInvoiceFirstViewedAtMutationVariables>(MarkInvoiceFirstViewedAtDocument, options);
      }
export type MarkInvoiceFirstViewedAtMutationHookResult = ReturnType<typeof useMarkInvoiceFirstViewedAtMutation>;
export type MarkInvoiceFirstViewedAtMutationResult = ApolloReactCommon.MutationResult<MarkInvoiceFirstViewedAtMutation>;
export type MarkInvoiceFirstViewedAtMutationOptions = ApolloReactCommon.BaseMutationOptions<MarkInvoiceFirstViewedAtMutation, MarkInvoiceFirstViewedAtMutationVariables>;
export const ConnectInvoiceRequestOnlinePaymentsDocument = gql`
    mutation ConnectInvoiceRequestOnlinePayments($connectInvoiceId: ID!) {
  connectInvoiceRequestOnlinePayments(connectInvoiceId: $connectInvoiceId) {
    ... on ConnectInvoiceRequestOnlinePaymentsSuccess {
      connectInvoice {
        id
        onlinePaymentsRequested
      }
    }
    ... on ConnectInvoiceRequestOnlinePaymentsFailure {
      errors {
        message
        path
        code
      }
    }
  }
}
    `;

/**
 * __useConnectInvoiceRequestOnlinePaymentsMutation__
 *
 * To run a mutation, you first call `useConnectInvoiceRequestOnlinePaymentsMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useConnectInvoiceRequestOnlinePaymentsMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [connectInvoiceRequestOnlinePaymentsMutation, { data, loading, error }] = useConnectInvoiceRequestOnlinePaymentsMutation({
 *   variables: {
 *      connectInvoiceId: // value for 'connectInvoiceId'
 *   },
 * });
 */
export function useConnectInvoiceRequestOnlinePaymentsMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<ConnectInvoiceRequestOnlinePaymentsMutation, ConnectInvoiceRequestOnlinePaymentsMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useMutation<ConnectInvoiceRequestOnlinePaymentsMutation, ConnectInvoiceRequestOnlinePaymentsMutationVariables>(ConnectInvoiceRequestOnlinePaymentsDocument, options);
      }
export type ConnectInvoiceRequestOnlinePaymentsMutationHookResult = ReturnType<typeof useConnectInvoiceRequestOnlinePaymentsMutation>;
export type ConnectInvoiceRequestOnlinePaymentsMutationResult = ApolloReactCommon.MutationResult<ConnectInvoiceRequestOnlinePaymentsMutation>;
export type ConnectInvoiceRequestOnlinePaymentsMutationOptions = ApolloReactCommon.BaseMutationOptions<ConnectInvoiceRequestOnlinePaymentsMutation, ConnectInvoiceRequestOnlinePaymentsMutationVariables>;
export const CreateHomeownerPaymentsFeedbackResponseDocument = gql`
    mutation CreateHomeownerPaymentsFeedbackResponse($connectInvoiceId: ID!, $attributes: HomeownerFeedbackResponseAttributes!) {
  upsertHomeownerPaymentsFeedback(
    connectInvoiceId: $connectInvoiceId
    attributes: $attributes
  ) {
    ... on UpsertHomeownerPaymentsFeedbackSuccess {
      homeownerFeedbackResponse {
        id
      }
    }
    ... on UpsertHomeownerPaymentsFeedbackFailure {
      errors {
        message
        path
        code
      }
    }
  }
}
    `;

/**
 * __useCreateHomeownerPaymentsFeedbackResponseMutation__
 *
 * To run a mutation, you first call `useCreateHomeownerPaymentsFeedbackResponseMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateHomeownerPaymentsFeedbackResponseMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createHomeownerPaymentsFeedbackResponseMutation, { data, loading, error }] = useCreateHomeownerPaymentsFeedbackResponseMutation({
 *   variables: {
 *      connectInvoiceId: // value for 'connectInvoiceId'
 *      attributes: // value for 'attributes'
 *   },
 * });
 */
export function useCreateHomeownerPaymentsFeedbackResponseMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<CreateHomeownerPaymentsFeedbackResponseMutation, CreateHomeownerPaymentsFeedbackResponseMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useMutation<CreateHomeownerPaymentsFeedbackResponseMutation, CreateHomeownerPaymentsFeedbackResponseMutationVariables>(CreateHomeownerPaymentsFeedbackResponseDocument, options);
      }
export type CreateHomeownerPaymentsFeedbackResponseMutationHookResult = ReturnType<typeof useCreateHomeownerPaymentsFeedbackResponseMutation>;
export type CreateHomeownerPaymentsFeedbackResponseMutationResult = ApolloReactCommon.MutationResult<CreateHomeownerPaymentsFeedbackResponseMutation>;
export type CreateHomeownerPaymentsFeedbackResponseMutationOptions = ApolloReactCommon.BaseMutationOptions<CreateHomeownerPaymentsFeedbackResponseMutation, CreateHomeownerPaymentsFeedbackResponseMutationVariables>;
export const FetchHomeownerInvoicesDocument = gql`
    query FetchHomeownerInvoices($homeownerId: String!, $organizationId: ID, $statuses: [ConnectInvoiceStatus]) {
  homeowner(id: $homeownerId) {
    id
    firstName
    lastName
    contractor {
      id
      featureFlags {
        id
      }
    }
    fullName
    phoneNumber
    email
    connectInvoices(statuses: $statuses, organizationId: $organizationId) {
      nodes {
        id
        ...ConnectInvoiceHomeowner
      }
    }
    organization {
      id
      ...ConnectInvoiceOrganization
    }
  }
}
    ${ConnectInvoiceHomeownerFragmentDoc}
${ConnectInvoiceOrganizationFragmentDoc}`;

/**
 * __useFetchHomeownerInvoicesQuery__
 *
 * To run a query within a React component, call `useFetchHomeownerInvoicesQuery` and pass it any options that fit your needs.
 * When your component renders, `useFetchHomeownerInvoicesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useFetchHomeownerInvoicesQuery({
 *   variables: {
 *      homeownerId: // value for 'homeownerId'
 *      organizationId: // value for 'organizationId'
 *      statuses: // value for 'statuses'
 *   },
 * });
 */
export function useFetchHomeownerInvoicesQuery(baseOptions: ApolloReactHooks.QueryHookOptions<FetchHomeownerInvoicesQuery, FetchHomeownerInvoicesQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<FetchHomeownerInvoicesQuery, FetchHomeownerInvoicesQueryVariables>(FetchHomeownerInvoicesDocument, options);
      }
export function useFetchHomeownerInvoicesLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<FetchHomeownerInvoicesQuery, FetchHomeownerInvoicesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<FetchHomeownerInvoicesQuery, FetchHomeownerInvoicesQueryVariables>(FetchHomeownerInvoicesDocument, options);
        }
export type FetchHomeownerInvoicesQueryHookResult = ReturnType<typeof useFetchHomeownerInvoicesQuery>;
export type FetchHomeownerInvoicesLazyQueryHookResult = ReturnType<typeof useFetchHomeownerInvoicesLazyQuery>;
export type FetchHomeownerInvoicesQueryResult = ApolloReactCommon.QueryResult<FetchHomeownerInvoicesQuery, FetchHomeownerInvoicesQueryVariables>;
export const GetHomeownerLeadsInfoDocument = gql`
    query GetHomeownerLeadsInfo {
  contractor {
    id
    ...LeadsContractor
  }
}
    ${LeadsContractorFragmentDoc}`;

/**
 * __useGetHomeownerLeadsInfoQuery__
 *
 * To run a query within a React component, call `useGetHomeownerLeadsInfoQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetHomeownerLeadsInfoQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetHomeownerLeadsInfoQuery({
 *   variables: {
 *   },
 * });
 */
export function useGetHomeownerLeadsInfoQuery(baseOptions?: ApolloReactHooks.QueryHookOptions<GetHomeownerLeadsInfoQuery, GetHomeownerLeadsInfoQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<GetHomeownerLeadsInfoQuery, GetHomeownerLeadsInfoQueryVariables>(GetHomeownerLeadsInfoDocument, options);
      }
export function useGetHomeownerLeadsInfoLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<GetHomeownerLeadsInfoQuery, GetHomeownerLeadsInfoQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<GetHomeownerLeadsInfoQuery, GetHomeownerLeadsInfoQueryVariables>(GetHomeownerLeadsInfoDocument, options);
        }
export type GetHomeownerLeadsInfoQueryHookResult = ReturnType<typeof useGetHomeownerLeadsInfoQuery>;
export type GetHomeownerLeadsInfoLazyQueryHookResult = ReturnType<typeof useGetHomeownerLeadsInfoLazyQuery>;
export type GetHomeownerLeadsInfoQueryResult = ApolloReactCommon.QueryResult<GetHomeownerLeadsInfoQuery, GetHomeownerLeadsInfoQueryVariables>;
export const UpdateHackathonHomeownerLeadDocument = gql`
    mutation UpdateHackathonHomeownerLead {
  updateHackathonHomeowner {
    ... on UpdateHackathonHomeownerLeadSuccess {
      homeowner {
        id
      }
    }
    ... on UpdateHackathonHomeownerLeadFailure {
      errors {
        message
        path
        code
      }
    }
  }
}
    `;

/**
 * __useUpdateHackathonHomeownerLeadMutation__
 *
 * To run a mutation, you first call `useUpdateHackathonHomeownerLeadMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateHackathonHomeownerLeadMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateHackathonHomeownerLeadMutation, { data, loading, error }] = useUpdateHackathonHomeownerLeadMutation({
 *   variables: {
 *   },
 * });
 */
export function useUpdateHackathonHomeownerLeadMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<UpdateHackathonHomeownerLeadMutation, UpdateHackathonHomeownerLeadMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useMutation<UpdateHackathonHomeownerLeadMutation, UpdateHackathonHomeownerLeadMutationVariables>(UpdateHackathonHomeownerLeadDocument, options);
      }
export type UpdateHackathonHomeownerLeadMutationHookResult = ReturnType<typeof useUpdateHackathonHomeownerLeadMutation>;
export type UpdateHackathonHomeownerLeadMutationResult = ApolloReactCommon.MutationResult<UpdateHackathonHomeownerLeadMutation>;
export type UpdateHackathonHomeownerLeadMutationOptions = ApolloReactCommon.BaseMutationOptions<UpdateHackathonHomeownerLeadMutation, UpdateHackathonHomeownerLeadMutationVariables>;
export const CreateFeedbackDocument = gql`
    mutation CreateFeedback($feedback: String!, $type: InsightsFeedback!) {
  createInsightsFeedback(feedback: $feedback, type: $type) {
    ... on CreateInsightsFeedbackSuccess {
      contractor {
        id
      }
    }
    ... on CreateInsightsFeedbackFailure {
      errors {
        message
        path
        code
      }
    }
  }
}
    `;

/**
 * __useCreateFeedbackMutation__
 *
 * To run a mutation, you first call `useCreateFeedbackMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateFeedbackMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createFeedbackMutation, { data, loading, error }] = useCreateFeedbackMutation({
 *   variables: {
 *      feedback: // value for 'feedback'
 *      type: // value for 'type'
 *   },
 * });
 */
export function useCreateFeedbackMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<CreateFeedbackMutation, CreateFeedbackMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useMutation<CreateFeedbackMutation, CreateFeedbackMutationVariables>(CreateFeedbackDocument, options);
      }
export type CreateFeedbackMutationHookResult = ReturnType<typeof useCreateFeedbackMutation>;
export type CreateFeedbackMutationResult = ApolloReactCommon.MutationResult<CreateFeedbackMutation>;
export type CreateFeedbackMutationOptions = ApolloReactCommon.BaseMutationOptions<CreateFeedbackMutation, CreateFeedbackMutationVariables>;
export const GetInsightsDocument = gql`
    query GetInsights {
  organization {
    id
    stripeConnectAccount {
      id
      status
    }
    visibleConnectInvoices {
      nodes {
        id
        ...InsightsInvoice
      }
    }
    contractServiceAccount {
      id
      termsAgreedAt
      contracts {
        nodes {
          id
          ...InsightsContract
        }
      }
    }
    allTimePrequalifiedFinancingAmount: financingInsightsAmountData(
      type: pre_qualified
      range: all_time
    ) {
      ...InsightsFinancingInsightsAmount
    }
    allTimeCompletedFinancingAmount: financingInsightsAmountData(
      type: completed
      range: all_time
    ) {
      ...InsightsFinancingInsightsAmount
    }
    allTimeFundedFinancingAmount: financingInsightsAmountData(
      type: funded
      range: all_time
    ) {
      ...InsightsFinancingInsightsAmount
    }
  }
}
    ${InsightsInvoiceFragmentDoc}
${InsightsContractFragmentDoc}
${InsightsFinancingInsightsAmountFragmentDoc}`;

/**
 * __useGetInsightsQuery__
 *
 * To run a query within a React component, call `useGetInsightsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetInsightsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetInsightsQuery({
 *   variables: {
 *   },
 * });
 */
export function useGetInsightsQuery(baseOptions?: ApolloReactHooks.QueryHookOptions<GetInsightsQuery, GetInsightsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<GetInsightsQuery, GetInsightsQueryVariables>(GetInsightsDocument, options);
      }
export function useGetInsightsLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<GetInsightsQuery, GetInsightsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<GetInsightsQuery, GetInsightsQueryVariables>(GetInsightsDocument, options);
        }
export type GetInsightsQueryHookResult = ReturnType<typeof useGetInsightsQuery>;
export type GetInsightsLazyQueryHookResult = ReturnType<typeof useGetInsightsLazyQuery>;
export type GetInsightsQueryResult = ApolloReactCommon.QueryResult<GetInsightsQuery, GetInsightsQueryVariables>;
export const TrendDataDocument = gql`
    query TrendData($type: FinancingInsightsFilter!) {
  organization {
    id
    financingInsightsTrendData(type: $type) {
      rollingCounts {
        date
        count
        amount
      }
      pastYearSum
    }
  }
}
    `;

/**
 * __useTrendDataQuery__
 *
 * To run a query within a React component, call `useTrendDataQuery` and pass it any options that fit your needs.
 * When your component renders, `useTrendDataQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useTrendDataQuery({
 *   variables: {
 *      type: // value for 'type'
 *   },
 * });
 */
export function useTrendDataQuery(baseOptions: ApolloReactHooks.QueryHookOptions<TrendDataQuery, TrendDataQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<TrendDataQuery, TrendDataQueryVariables>(TrendDataDocument, options);
      }
export function useTrendDataLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<TrendDataQuery, TrendDataQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<TrendDataQuery, TrendDataQueryVariables>(TrendDataDocument, options);
        }
export type TrendDataQueryHookResult = ReturnType<typeof useTrendDataQuery>;
export type TrendDataLazyQueryHookResult = ReturnType<typeof useTrendDataLazyQuery>;
export type TrendDataQueryResult = ApolloReactCommon.QueryResult<TrendDataQuery, TrendDataQueryVariables>;
export const FinancingInsightsCustomerProfileDocument = gql`
    query financingInsightsCustomerProfile($range: FinancingInsightsTimeRange!) {
  organization {
    id
    financingInsightsCustomerProfile(range: $range) {
      meanFico
      meanIncome
      medianIncome
      medianApr
      meanRequestedAmount
      priorMedianApr
      priorMeanRequestedAmount
    }
  }
}
    `;

/**
 * __useFinancingInsightsCustomerProfileQuery__
 *
 * To run a query within a React component, call `useFinancingInsightsCustomerProfileQuery` and pass it any options that fit your needs.
 * When your component renders, `useFinancingInsightsCustomerProfileQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useFinancingInsightsCustomerProfileQuery({
 *   variables: {
 *      range: // value for 'range'
 *   },
 * });
 */
export function useFinancingInsightsCustomerProfileQuery(baseOptions: ApolloReactHooks.QueryHookOptions<FinancingInsightsCustomerProfileQuery, FinancingInsightsCustomerProfileQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<FinancingInsightsCustomerProfileQuery, FinancingInsightsCustomerProfileQueryVariables>(FinancingInsightsCustomerProfileDocument, options);
      }
export function useFinancingInsightsCustomerProfileLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<FinancingInsightsCustomerProfileQuery, FinancingInsightsCustomerProfileQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<FinancingInsightsCustomerProfileQuery, FinancingInsightsCustomerProfileQueryVariables>(FinancingInsightsCustomerProfileDocument, options);
        }
export type FinancingInsightsCustomerProfileQueryHookResult = ReturnType<typeof useFinancingInsightsCustomerProfileQuery>;
export type FinancingInsightsCustomerProfileLazyQueryHookResult = ReturnType<typeof useFinancingInsightsCustomerProfileLazyQuery>;
export type FinancingInsightsCustomerProfileQueryResult = ApolloReactCommon.QueryResult<FinancingInsightsCustomerProfileQuery, FinancingInsightsCustomerProfileQueryVariables>;
export const FunnelDataDocument = gql`
    query FunnelData($range: FinancingInsightsTimeRange!) {
  organization {
    id
    financingInsightsFunnelData(range: $range) {
      requestedAmount
      preQualifiedAmount
      fundedAmount
      requestedCount
      preQualifiedCount
      fundedCount
    }
  }
}
    `;

/**
 * __useFunnelDataQuery__
 *
 * To run a query within a React component, call `useFunnelDataQuery` and pass it any options that fit your needs.
 * When your component renders, `useFunnelDataQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useFunnelDataQuery({
 *   variables: {
 *      range: // value for 'range'
 *   },
 * });
 */
export function useFunnelDataQuery(baseOptions: ApolloReactHooks.QueryHookOptions<FunnelDataQuery, FunnelDataQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<FunnelDataQuery, FunnelDataQueryVariables>(FunnelDataDocument, options);
      }
export function useFunnelDataLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<FunnelDataQuery, FunnelDataQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<FunnelDataQuery, FunnelDataQueryVariables>(FunnelDataDocument, options);
        }
export type FunnelDataQueryHookResult = ReturnType<typeof useFunnelDataQuery>;
export type FunnelDataLazyQueryHookResult = ReturnType<typeof useFunnelDataLazyQuery>;
export type FunnelDataQueryResult = ApolloReactCommon.QueryResult<FunnelDataQuery, FunnelDataQueryVariables>;
export const GetInsuranceDataDocument = gql`
    query GetInsuranceData {
  organization {
    id
    insuranceEligible
  }
  contractor {
    id
    customSettings {
      insuranceInquiryRequestMethod
    }
  }
}
    `;

/**
 * __useGetInsuranceDataQuery__
 *
 * To run a query within a React component, call `useGetInsuranceDataQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetInsuranceDataQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetInsuranceDataQuery({
 *   variables: {
 *   },
 * });
 */
export function useGetInsuranceDataQuery(baseOptions?: ApolloReactHooks.QueryHookOptions<GetInsuranceDataQuery, GetInsuranceDataQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<GetInsuranceDataQuery, GetInsuranceDataQueryVariables>(GetInsuranceDataDocument, options);
      }
export function useGetInsuranceDataLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<GetInsuranceDataQuery, GetInsuranceDataQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<GetInsuranceDataQuery, GetInsuranceDataQueryVariables>(GetInsuranceDataDocument, options);
        }
export type GetInsuranceDataQueryHookResult = ReturnType<typeof useGetInsuranceDataQuery>;
export type GetInsuranceDataLazyQueryHookResult = ReturnType<typeof useGetInsuranceDataLazyQuery>;
export type GetInsuranceDataQueryResult = ApolloReactCommon.QueryResult<GetInsuranceDataQuery, GetInsuranceDataQueryVariables>;
export const SetInsuranceSeenDocument = gql`
    mutation SetInsuranceSeen($id: ID!) {
  updateContractor(id: $id, attributes: {insuranceSidebarTooltipSeen: true}) {
    contractor {
      id
      customSettings {
        insuranceSidebarTooltipSeen
      }
    }
    errors {
      message
      path
    }
  }
}
    `;

/**
 * __useSetInsuranceSeenMutation__
 *
 * To run a mutation, you first call `useSetInsuranceSeenMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useSetInsuranceSeenMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [setInsuranceSeenMutation, { data, loading, error }] = useSetInsuranceSeenMutation({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useSetInsuranceSeenMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<SetInsuranceSeenMutation, SetInsuranceSeenMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useMutation<SetInsuranceSeenMutation, SetInsuranceSeenMutationVariables>(SetInsuranceSeenDocument, options);
      }
export type SetInsuranceSeenMutationHookResult = ReturnType<typeof useSetInsuranceSeenMutation>;
export type SetInsuranceSeenMutationResult = ApolloReactCommon.MutationResult<SetInsuranceSeenMutation>;
export type SetInsuranceSeenMutationOptions = ApolloReactCommon.BaseMutationOptions<SetInsuranceSeenMutation, SetInsuranceSeenMutationVariables>;
export const SetInsuranceInquiryRequestMethodDocument = gql`
    mutation SetInsuranceInquiryRequestMethod($id: ID!, $method: String!) {
  updateContractor(id: $id, attributes: {insuranceInquiryRequestMethod: $method}) {
    contractor {
      id
      customSettings {
        insuranceInquiryRequestMethod
      }
    }
    errors {
      message
      path
    }
  }
}
    `;

/**
 * __useSetInsuranceInquiryRequestMethodMutation__
 *
 * To run a mutation, you first call `useSetInsuranceInquiryRequestMethodMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useSetInsuranceInquiryRequestMethodMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [setInsuranceInquiryRequestMethodMutation, { data, loading, error }] = useSetInsuranceInquiryRequestMethodMutation({
 *   variables: {
 *      id: // value for 'id'
 *      method: // value for 'method'
 *   },
 * });
 */
export function useSetInsuranceInquiryRequestMethodMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<SetInsuranceInquiryRequestMethodMutation, SetInsuranceInquiryRequestMethodMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useMutation<SetInsuranceInquiryRequestMethodMutation, SetInsuranceInquiryRequestMethodMutationVariables>(SetInsuranceInquiryRequestMethodDocument, options);
      }
export type SetInsuranceInquiryRequestMethodMutationHookResult = ReturnType<typeof useSetInsuranceInquiryRequestMethodMutation>;
export type SetInsuranceInquiryRequestMethodMutationResult = ApolloReactCommon.MutationResult<SetInsuranceInquiryRequestMethodMutation>;
export type SetInsuranceInquiryRequestMethodMutationOptions = ApolloReactCommon.BaseMutationOptions<SetInsuranceInquiryRequestMethodMutation, SetInsuranceInquiryRequestMethodMutationVariables>;
export const FetchCustomInvoicePreviewDocument = gql`
    query FetchCustomInvoicePreview {
  organization {
    id
    kycBusiness {
      id
      url
    }
    ...OrganizationBusinessInfo
  }
  contractor {
    id
    activeCustomizedInvoiceTemplate {
      id
      ...ActiveInvoiceTemplate
    }
  }
}
    ${OrganizationBusinessInfoFragmentDoc}
${ActiveInvoiceTemplateFragmentDoc}`;

/**
 * __useFetchCustomInvoicePreviewQuery__
 *
 * To run a query within a React component, call `useFetchCustomInvoicePreviewQuery` and pass it any options that fit your needs.
 * When your component renders, `useFetchCustomInvoicePreviewQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useFetchCustomInvoicePreviewQuery({
 *   variables: {
 *   },
 * });
 */
export function useFetchCustomInvoicePreviewQuery(baseOptions?: ApolloReactHooks.QueryHookOptions<FetchCustomInvoicePreviewQuery, FetchCustomInvoicePreviewQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<FetchCustomInvoicePreviewQuery, FetchCustomInvoicePreviewQueryVariables>(FetchCustomInvoicePreviewDocument, options);
      }
export function useFetchCustomInvoicePreviewLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<FetchCustomInvoicePreviewQuery, FetchCustomInvoicePreviewQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<FetchCustomInvoicePreviewQuery, FetchCustomInvoicePreviewQueryVariables>(FetchCustomInvoicePreviewDocument, options);
        }
export type FetchCustomInvoicePreviewQueryHookResult = ReturnType<typeof useFetchCustomInvoicePreviewQuery>;
export type FetchCustomInvoicePreviewLazyQueryHookResult = ReturnType<typeof useFetchCustomInvoicePreviewLazyQuery>;
export type FetchCustomInvoicePreviewQueryResult = ApolloReactCommon.QueryResult<FetchCustomInvoicePreviewQuery, FetchCustomInvoicePreviewQueryVariables>;
export const GetCustomInvoiceBannerConditionsDocument = gql`
    query GetCustomInvoiceBannerConditions {
  contractor {
    id
    paymentsAdmin
  }
  organization {
    id
    stripeConnectAccount {
      id
      fullAccess
    }
  }
}
    `;

/**
 * __useGetCustomInvoiceBannerConditionsQuery__
 *
 * To run a query within a React component, call `useGetCustomInvoiceBannerConditionsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetCustomInvoiceBannerConditionsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetCustomInvoiceBannerConditionsQuery({
 *   variables: {
 *   },
 * });
 */
export function useGetCustomInvoiceBannerConditionsQuery(baseOptions?: ApolloReactHooks.QueryHookOptions<GetCustomInvoiceBannerConditionsQuery, GetCustomInvoiceBannerConditionsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<GetCustomInvoiceBannerConditionsQuery, GetCustomInvoiceBannerConditionsQueryVariables>(GetCustomInvoiceBannerConditionsDocument, options);
      }
export function useGetCustomInvoiceBannerConditionsLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<GetCustomInvoiceBannerConditionsQuery, GetCustomInvoiceBannerConditionsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<GetCustomInvoiceBannerConditionsQuery, GetCustomInvoiceBannerConditionsQueryVariables>(GetCustomInvoiceBannerConditionsDocument, options);
        }
export type GetCustomInvoiceBannerConditionsQueryHookResult = ReturnType<typeof useGetCustomInvoiceBannerConditionsQuery>;
export type GetCustomInvoiceBannerConditionsLazyQueryHookResult = ReturnType<typeof useGetCustomInvoiceBannerConditionsLazyQuery>;
export type GetCustomInvoiceBannerConditionsQueryResult = ApolloReactCommon.QueryResult<GetCustomInvoiceBannerConditionsQuery, GetCustomInvoiceBannerConditionsQueryVariables>;
export const GetKycDataDocument = gql`
    query GetKycData {
  organization {
    id
    ...OrganizationKyc
  }
  contractor {
    id
    ...ContractorKyc
  }
}
    ${OrganizationKycFragmentDoc}
${ContractorKycFragmentDoc}`;

/**
 * __useGetKycDataQuery__
 *
 * To run a query within a React component, call `useGetKycDataQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetKycDataQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetKycDataQuery({
 *   variables: {
 *   },
 * });
 */
export function useGetKycDataQuery(baseOptions?: ApolloReactHooks.QueryHookOptions<GetKycDataQuery, GetKycDataQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<GetKycDataQuery, GetKycDataQueryVariables>(GetKycDataDocument, options);
      }
export function useGetKycDataLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<GetKycDataQuery, GetKycDataQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<GetKycDataQuery, GetKycDataQueryVariables>(GetKycDataDocument, options);
        }
export type GetKycDataQueryHookResult = ReturnType<typeof useGetKycDataQuery>;
export type GetKycDataLazyQueryHookResult = ReturnType<typeof useGetKycDataLazyQuery>;
export type GetKycDataQueryResult = ApolloReactCommon.QueryResult<GetKycDataQuery, GetKycDataQueryVariables>;
export const InitiateKycDocument = gql`
    mutation InitiateKyc($contractId: ID!) {
  signAccountContract(contractId: $contractId) {
    ... on SignAccountContractSuccess {
      stripeConnectAccount {
        id
        ...StripeConnectAccountKyc
      }
    }
    ... on SignAccountContractFailure {
      errors {
        message
        path
        code
      }
    }
  }
}
    ${StripeConnectAccountKycFragmentDoc}`;

/**
 * __useInitiateKycMutation__
 *
 * To run a mutation, you first call `useInitiateKycMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useInitiateKycMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [initiateKycMutation, { data, loading, error }] = useInitiateKycMutation({
 *   variables: {
 *      contractId: // value for 'contractId'
 *   },
 * });
 */
export function useInitiateKycMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<InitiateKycMutation, InitiateKycMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useMutation<InitiateKycMutation, InitiateKycMutationVariables>(InitiateKycDocument, options);
      }
export type InitiateKycMutationHookResult = ReturnType<typeof useInitiateKycMutation>;
export type InitiateKycMutationResult = ApolloReactCommon.MutationResult<InitiateKycMutation>;
export type InitiateKycMutationOptions = ApolloReactCommon.BaseMutationOptions<InitiateKycMutation, InitiateKycMutationVariables>;
export const UpsertKycBusinessInfoDocument = gql`
    mutation UpsertKycBusinessInfo($stripeConnectAccountId: ID!, $attributes: KycBusinessAttributes!) {
  paymentsSetupSubmitBusinessInfo(
    stripeConnectAccountId: $stripeConnectAccountId
    kycBusinessData: $attributes
  ) {
    ... on SubmitBusinessInfoSuccess {
      stripeConnectAccount {
        id
        ...StripeConnectAccountKyc
      }
      kycBusiness {
        id
        ...KycBusinessInfo
      }
    }
    ... on SubmitBusinessInfoFailure {
      errors {
        message
        path
        code
      }
    }
  }
}
    ${StripeConnectAccountKycFragmentDoc}
${KycBusinessInfoFragmentDoc}`;

/**
 * __useUpsertKycBusinessInfoMutation__
 *
 * To run a mutation, you first call `useUpsertKycBusinessInfoMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpsertKycBusinessInfoMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [upsertKycBusinessInfoMutation, { data, loading, error }] = useUpsertKycBusinessInfoMutation({
 *   variables: {
 *      stripeConnectAccountId: // value for 'stripeConnectAccountId'
 *      attributes: // value for 'attributes'
 *   },
 * });
 */
export function useUpsertKycBusinessInfoMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<UpsertKycBusinessInfoMutation, UpsertKycBusinessInfoMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useMutation<UpsertKycBusinessInfoMutation, UpsertKycBusinessInfoMutationVariables>(UpsertKycBusinessInfoDocument, options);
      }
export type UpsertKycBusinessInfoMutationHookResult = ReturnType<typeof useUpsertKycBusinessInfoMutation>;
export type UpsertKycBusinessInfoMutationResult = ApolloReactCommon.MutationResult<UpsertKycBusinessInfoMutation>;
export type UpsertKycBusinessInfoMutationOptions = ApolloReactCommon.BaseMutationOptions<UpsertKycBusinessInfoMutation, UpsertKycBusinessInfoMutationVariables>;
export const UpsertKycPersonInfoDocument = gql`
    mutation UpsertKycPersonInfo($id: ID, $stripeConnectAccountId: ID!, $attributes: KycPersonAttributes!) {
  paymentsSetupSubmitPersonInfo(
    kycPersonId: $id
    stripeConnectAccountId: $stripeConnectAccountId
    kycPersonData: $attributes
  ) {
    ... on SubmitPersonInfoSuccess {
      stripeConnectAccount {
        id
        ...StripeConnectAccountKyc
      }
      kycBusiness {
        id
        ...KycBusinessInfo
      }
    }
    ... on SubmitPersonInfoFailure {
      errors {
        message
        path
        code
      }
    }
  }
}
    ${StripeConnectAccountKycFragmentDoc}
${KycBusinessInfoFragmentDoc}`;

/**
 * __useUpsertKycPersonInfoMutation__
 *
 * To run a mutation, you first call `useUpsertKycPersonInfoMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpsertKycPersonInfoMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [upsertKycPersonInfoMutation, { data, loading, error }] = useUpsertKycPersonInfoMutation({
 *   variables: {
 *      id: // value for 'id'
 *      stripeConnectAccountId: // value for 'stripeConnectAccountId'
 *      attributes: // value for 'attributes'
 *   },
 * });
 */
export function useUpsertKycPersonInfoMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<UpsertKycPersonInfoMutation, UpsertKycPersonInfoMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useMutation<UpsertKycPersonInfoMutation, UpsertKycPersonInfoMutationVariables>(UpsertKycPersonInfoDocument, options);
      }
export type UpsertKycPersonInfoMutationHookResult = ReturnType<typeof useUpsertKycPersonInfoMutation>;
export type UpsertKycPersonInfoMutationResult = ApolloReactCommon.MutationResult<UpsertKycPersonInfoMutation>;
export type UpsertKycPersonInfoMutationOptions = ApolloReactCommon.BaseMutationOptions<UpsertKycPersonInfoMutation, UpsertKycPersonInfoMutationVariables>;
export const DeleteKycPersonDocument = gql`
    mutation DeleteKycPerson($id: ID!, $stripeConnectAccountId: ID!) {
  paymentsSetupDeletePerson(
    kycPersonId: $id
    stripeConnectAccountId: $stripeConnectAccountId
  ) {
    ... on DeletePersonSuccess {
      stripeConnectAccount {
        id
        ...StripeConnectAccountKyc
      }
      kycBusiness {
        id
        ...KycBusinessInfo
      }
    }
    ... on DeletePersonFailure {
      errors {
        message
        path
        code
      }
    }
  }
}
    ${StripeConnectAccountKycFragmentDoc}
${KycBusinessInfoFragmentDoc}`;

/**
 * __useDeleteKycPersonMutation__
 *
 * To run a mutation, you first call `useDeleteKycPersonMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteKycPersonMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteKycPersonMutation, { data, loading, error }] = useDeleteKycPersonMutation({
 *   variables: {
 *      id: // value for 'id'
 *      stripeConnectAccountId: // value for 'stripeConnectAccountId'
 *   },
 * });
 */
export function useDeleteKycPersonMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<DeleteKycPersonMutation, DeleteKycPersonMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useMutation<DeleteKycPersonMutation, DeleteKycPersonMutationVariables>(DeleteKycPersonDocument, options);
      }
export type DeleteKycPersonMutationHookResult = ReturnType<typeof useDeleteKycPersonMutation>;
export type DeleteKycPersonMutationResult = ApolloReactCommon.MutationResult<DeleteKycPersonMutation>;
export type DeleteKycPersonMutationOptions = ApolloReactCommon.BaseMutationOptions<DeleteKycPersonMutation, DeleteKycPersonMutationVariables>;
export const SubmitApplicationKycDocument = gql`
    mutation SubmitApplicationKyc($stripeConnectAccountId: ID!, $reapplication: Boolean!) {
  paymentsSetupSubmitApplication(
    stripeConnectAccountId: $stripeConnectAccountId
    reapplication: $reapplication
  ) {
    ... on SubmitApplicationSuccess {
      stripeConnectAccount {
        id
        ...StripeConnectAccountKyc
      }
    }
    ... on SubmitApplicationFailure {
      errors {
        message
        path
        code
      }
    }
  }
}
    ${StripeConnectAccountKycFragmentDoc}`;

/**
 * __useSubmitApplicationKycMutation__
 *
 * To run a mutation, you first call `useSubmitApplicationKycMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useSubmitApplicationKycMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [submitApplicationKycMutation, { data, loading, error }] = useSubmitApplicationKycMutation({
 *   variables: {
 *      stripeConnectAccountId: // value for 'stripeConnectAccountId'
 *      reapplication: // value for 'reapplication'
 *   },
 * });
 */
export function useSubmitApplicationKycMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<SubmitApplicationKycMutation, SubmitApplicationKycMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useMutation<SubmitApplicationKycMutation, SubmitApplicationKycMutationVariables>(SubmitApplicationKycDocument, options);
      }
export type SubmitApplicationKycMutationHookResult = ReturnType<typeof useSubmitApplicationKycMutation>;
export type SubmitApplicationKycMutationResult = ApolloReactCommon.MutationResult<SubmitApplicationKycMutation>;
export type SubmitApplicationKycMutationOptions = ApolloReactCommon.BaseMutationOptions<SubmitApplicationKycMutation, SubmitApplicationKycMutationVariables>;
export const GetConnectAccountOnboardingLoginDocument = gql`
    mutation GetConnectAccountOnboardingLogin($organizationId: ID!, $refreshUrl: String!, $returnUrl: String!, $type: String!) {
  getStripeAccountLink(
    organizationId: $organizationId
    refreshUrl: $refreshUrl
    returnUrl: $returnUrl
    type: $type
  ) {
    ... on GetStripeAccountLinkSuccess {
      connectAccountLoginLink
    }
    ... on GetStripeAccountLinkFailure {
      errors {
        code
        message
        path
      }
    }
  }
}
    `;

/**
 * __useGetConnectAccountOnboardingLoginMutation__
 *
 * To run a mutation, you first call `useGetConnectAccountOnboardingLoginMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useGetConnectAccountOnboardingLoginMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [getConnectAccountOnboardingLoginMutation, { data, loading, error }] = useGetConnectAccountOnboardingLoginMutation({
 *   variables: {
 *      organizationId: // value for 'organizationId'
 *      refreshUrl: // value for 'refreshUrl'
 *      returnUrl: // value for 'returnUrl'
 *      type: // value for 'type'
 *   },
 * });
 */
export function useGetConnectAccountOnboardingLoginMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<GetConnectAccountOnboardingLoginMutation, GetConnectAccountOnboardingLoginMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useMutation<GetConnectAccountOnboardingLoginMutation, GetConnectAccountOnboardingLoginMutationVariables>(GetConnectAccountOnboardingLoginDocument, options);
      }
export type GetConnectAccountOnboardingLoginMutationHookResult = ReturnType<typeof useGetConnectAccountOnboardingLoginMutation>;
export type GetConnectAccountOnboardingLoginMutationResult = ApolloReactCommon.MutationResult<GetConnectAccountOnboardingLoginMutation>;
export type GetConnectAccountOnboardingLoginMutationOptions = ApolloReactCommon.BaseMutationOptions<GetConnectAccountOnboardingLoginMutation, GetConnectAccountOnboardingLoginMutationVariables>;
export const UploadKycReapplyDocumentsDocument = gql`
    mutation UploadKycReapplyDocuments($kycBusinessId: ID!, $documents: [DocumentAttributes!], $removedUploadIds: [String!]) {
  kycSubmitVerificationDocuments(
    kycBusinessId: $kycBusinessId
    uploads: $documents
    removedUploadIds: $removedUploadIds
  ) {
    ... on SubmitVerificationDocumentsSuccess {
      kycBusiness {
        id
      }
    }
    ... on SubmitVerificationDocumentsFailure {
      errors {
        message
        path
        code
      }
    }
  }
}
    `;

/**
 * __useUploadKycReapplyDocumentsMutation__
 *
 * To run a mutation, you first call `useUploadKycReapplyDocumentsMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUploadKycReapplyDocumentsMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [uploadKycReapplyDocumentsMutation, { data, loading, error }] = useUploadKycReapplyDocumentsMutation({
 *   variables: {
 *      kycBusinessId: // value for 'kycBusinessId'
 *      documents: // value for 'documents'
 *      removedUploadIds: // value for 'removedUploadIds'
 *   },
 * });
 */
export function useUploadKycReapplyDocumentsMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<UploadKycReapplyDocumentsMutation, UploadKycReapplyDocumentsMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useMutation<UploadKycReapplyDocumentsMutation, UploadKycReapplyDocumentsMutationVariables>(UploadKycReapplyDocumentsDocument, options);
      }
export type UploadKycReapplyDocumentsMutationHookResult = ReturnType<typeof useUploadKycReapplyDocumentsMutation>;
export type UploadKycReapplyDocumentsMutationResult = ApolloReactCommon.MutationResult<UploadKycReapplyDocumentsMutation>;
export type UploadKycReapplyDocumentsMutationOptions = ApolloReactCommon.BaseMutationOptions<UploadKycReapplyDocumentsMutation, UploadKycReapplyDocumentsMutationVariables>;
export const UpdateOrganizationKycInfoDocument = gql`
    mutation UpdateOrganizationKycInfo($attributes: OrganizationAttributes!) {
  upsertOrganization(attributes: $attributes) {
    ... on UpsertOrganizationSuccess {
      organization {
        id
        ...OrganizationKyc
      }
    }
    ... on UpsertOrganizationFailure {
      errors {
        message
        path
        code
      }
    }
  }
}
    ${OrganizationKycFragmentDoc}`;

/**
 * __useUpdateOrganizationKycInfoMutation__
 *
 * To run a mutation, you first call `useUpdateOrganizationKycInfoMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateOrganizationKycInfoMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateOrganizationKycInfoMutation, { data, loading, error }] = useUpdateOrganizationKycInfoMutation({
 *   variables: {
 *      attributes: // value for 'attributes'
 *   },
 * });
 */
export function useUpdateOrganizationKycInfoMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<UpdateOrganizationKycInfoMutation, UpdateOrganizationKycInfoMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useMutation<UpdateOrganizationKycInfoMutation, UpdateOrganizationKycInfoMutationVariables>(UpdateOrganizationKycInfoDocument, options);
      }
export type UpdateOrganizationKycInfoMutationHookResult = ReturnType<typeof useUpdateOrganizationKycInfoMutation>;
export type UpdateOrganizationKycInfoMutationResult = ApolloReactCommon.MutationResult<UpdateOrganizationKycInfoMutation>;
export type UpdateOrganizationKycInfoMutationOptions = ApolloReactCommon.BaseMutationOptions<UpdateOrganizationKycInfoMutation, UpdateOrganizationKycInfoMutationVariables>;
export const UpdateContractorKycInfoDocument = gql`
    mutation UpdateContractorKycInfo($attributes: ContractorAttributes!) {
  upsertContractor(attributes: $attributes) {
    ... on UpsertContractorSuccess {
      contractor {
        id
        ...ContractorKyc
      }
    }
    ... on UpsertContractorFailure {
      errors {
        message
        path
        code
      }
    }
  }
}
    ${ContractorKycFragmentDoc}`;

/**
 * __useUpdateContractorKycInfoMutation__
 *
 * To run a mutation, you first call `useUpdateContractorKycInfoMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateContractorKycInfoMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateContractorKycInfoMutation, { data, loading, error }] = useUpdateContractorKycInfoMutation({
 *   variables: {
 *      attributes: // value for 'attributes'
 *   },
 * });
 */
export function useUpdateContractorKycInfoMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<UpdateContractorKycInfoMutation, UpdateContractorKycInfoMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useMutation<UpdateContractorKycInfoMutation, UpdateContractorKycInfoMutationVariables>(UpdateContractorKycInfoDocument, options);
      }
export type UpdateContractorKycInfoMutationHookResult = ReturnType<typeof useUpdateContractorKycInfoMutation>;
export type UpdateContractorKycInfoMutationResult = ApolloReactCommon.MutationResult<UpdateContractorKycInfoMutation>;
export type UpdateContractorKycInfoMutationOptions = ApolloReactCommon.BaseMutationOptions<UpdateContractorKycInfoMutation, UpdateContractorKycInfoMutationVariables>;
export const GetPayoutDataDocument = gql`
    query GetPayoutData {
  contractor {
    id
  }
  organization {
    id
    stripeConnectAccount {
      id
      transferBalances {
        grossTransferAmount
        alreadyPayedOut
        totalAvailableStandard
        totalAvailableInstant
        totalPending
        hasCompletedPayout
        cardTransferFees
        achTransferFees
      }
      externalTransferDestinations {
        standardDestinations {
          ... on StripeCard {
            id
            ...StripeCardParts
          }
          ... on StripeBankAccount {
            id
            ...StripeBankAccountParts
          }
        }
        instantDestinations {
          id
          ...StripeCardParts
        }
      }
    }
  }
}
    ${StripeCardPartsFragmentDoc}
${StripeBankAccountPartsFragmentDoc}`;

/**
 * __useGetPayoutDataQuery__
 *
 * To run a query within a React component, call `useGetPayoutDataQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetPayoutDataQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetPayoutDataQuery({
 *   variables: {
 *   },
 * });
 */
export function useGetPayoutDataQuery(baseOptions?: ApolloReactHooks.QueryHookOptions<GetPayoutDataQuery, GetPayoutDataQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<GetPayoutDataQuery, GetPayoutDataQueryVariables>(GetPayoutDataDocument, options);
      }
export function useGetPayoutDataLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<GetPayoutDataQuery, GetPayoutDataQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<GetPayoutDataQuery, GetPayoutDataQueryVariables>(GetPayoutDataDocument, options);
        }
export type GetPayoutDataQueryHookResult = ReturnType<typeof useGetPayoutDataQuery>;
export type GetPayoutDataLazyQueryHookResult = ReturnType<typeof useGetPayoutDataLazyQuery>;
export type GetPayoutDataQueryResult = ApolloReactCommon.QueryResult<GetPayoutDataQuery, GetPayoutDataQueryVariables>;
export const CreatePayoutDocument = gql`
    mutation CreatePayout($contractorId: ID!, $amountInCents: Int!, $destination: String!, $instant: Boolean!) {
  createConnectPayout(
    contractorId: $contractorId
    amountInCents: $amountInCents
    destination: $destination
    instant: $instant
  ) {
    ... on CreateConnectPayoutSuccess {
      amountInCents
      stripePayouts {
        stripePayoutId
        amountInCents
      }
    }
    ... on CreateConnectPayoutFailure {
      errors {
        message
        path
        code
      }
    }
  }
}
    `;

/**
 * __useCreatePayoutMutation__
 *
 * To run a mutation, you first call `useCreatePayoutMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreatePayoutMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createPayoutMutation, { data, loading, error }] = useCreatePayoutMutation({
 *   variables: {
 *      contractorId: // value for 'contractorId'
 *      amountInCents: // value for 'amountInCents'
 *      destination: // value for 'destination'
 *      instant: // value for 'instant'
 *   },
 * });
 */
export function useCreatePayoutMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<CreatePayoutMutation, CreatePayoutMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useMutation<CreatePayoutMutation, CreatePayoutMutationVariables>(CreatePayoutDocument, options);
      }
export type CreatePayoutMutationHookResult = ReturnType<typeof useCreatePayoutMutation>;
export type CreatePayoutMutationResult = ApolloReactCommon.MutationResult<CreatePayoutMutation>;
export type CreatePayoutMutationOptions = ApolloReactCommon.BaseMutationOptions<CreatePayoutMutation, CreatePayoutMutationVariables>;
export const GetPaymentPayoutDetailsDocument = gql`
    query GetPaymentPayoutDetails {
  organization {
    id
    stripeConnectAccount {
      id
      firstPayoutAddedAt
    }
    kycBusiness {
      id
      plaidLinkToken
    }
  }
}
    `;

/**
 * __useGetPaymentPayoutDetailsQuery__
 *
 * To run a query within a React component, call `useGetPaymentPayoutDetailsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetPaymentPayoutDetailsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetPaymentPayoutDetailsQuery({
 *   variables: {
 *   },
 * });
 */
export function useGetPaymentPayoutDetailsQuery(baseOptions?: ApolloReactHooks.QueryHookOptions<GetPaymentPayoutDetailsQuery, GetPaymentPayoutDetailsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<GetPaymentPayoutDetailsQuery, GetPaymentPayoutDetailsQueryVariables>(GetPaymentPayoutDetailsDocument, options);
      }
export function useGetPaymentPayoutDetailsLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<GetPaymentPayoutDetailsQuery, GetPaymentPayoutDetailsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<GetPaymentPayoutDetailsQuery, GetPaymentPayoutDetailsQueryVariables>(GetPaymentPayoutDetailsDocument, options);
        }
export type GetPaymentPayoutDetailsQueryHookResult = ReturnType<typeof useGetPaymentPayoutDetailsQuery>;
export type GetPaymentPayoutDetailsLazyQueryHookResult = ReturnType<typeof useGetPaymentPayoutDetailsLazyQuery>;
export type GetPaymentPayoutDetailsQueryResult = ApolloReactCommon.QueryResult<GetPaymentPayoutDetailsQuery, GetPaymentPayoutDetailsQueryVariables>;
export const AddPayoutExternalAccountDocument = gql`
    mutation AddPayoutExternalAccount($stripeConnectAccountId: ID!, $externalAccountToken: String!) {
  paymentsSetupAddExternalAccount(
    stripeConnectAccountId: $stripeConnectAccountId
    externalAccountToken: $externalAccountToken
  ) {
    ... on AttachExternalAccountSuccess {
      stripeConnectAccount {
        id
      }
    }
    ... on AttachExternalAccountFailure {
      errors {
        message
        path
        code
      }
    }
  }
}
    `;

/**
 * __useAddPayoutExternalAccountMutation__
 *
 * To run a mutation, you first call `useAddPayoutExternalAccountMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useAddPayoutExternalAccountMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [addPayoutExternalAccountMutation, { data, loading, error }] = useAddPayoutExternalAccountMutation({
 *   variables: {
 *      stripeConnectAccountId: // value for 'stripeConnectAccountId'
 *      externalAccountToken: // value for 'externalAccountToken'
 *   },
 * });
 */
export function useAddPayoutExternalAccountMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<AddPayoutExternalAccountMutation, AddPayoutExternalAccountMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useMutation<AddPayoutExternalAccountMutation, AddPayoutExternalAccountMutationVariables>(AddPayoutExternalAccountDocument, options);
      }
export type AddPayoutExternalAccountMutationHookResult = ReturnType<typeof useAddPayoutExternalAccountMutation>;
export type AddPayoutExternalAccountMutationResult = ApolloReactCommon.MutationResult<AddPayoutExternalAccountMutation>;
export type AddPayoutExternalAccountMutationOptions = ApolloReactCommon.BaseMutationOptions<AddPayoutExternalAccountMutation, AddPayoutExternalAccountMutationVariables>;
export const AttachPlaidBankAccountDocument = gql`
    mutation AttachPlaidBankAccount($stripeConnectAccountId: ID!, $kycBusinessId: ID!, $plaidAccountId: String!, $plaidPublicToken: String!) {
  paymentsSetupAttachPlaidBankAccountToConnectAccount(
    stripeConnectAccountId: $stripeConnectAccountId
    kycBusinessId: $kycBusinessId
    plaidAccountId: $plaidAccountId
    plaidPublicToken: $plaidPublicToken
  ) {
    ... on AttachPlaidBankAccountToConnectAccountSuccess {
      kycBusiness {
        id
        plaidLinkToken
      }
    }
    ... on AttachPlaidBankAccountToConnectAccountFailure {
      errors {
        message
        path
        code
      }
    }
  }
}
    `;

/**
 * __useAttachPlaidBankAccountMutation__
 *
 * To run a mutation, you first call `useAttachPlaidBankAccountMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useAttachPlaidBankAccountMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [attachPlaidBankAccountMutation, { data, loading, error }] = useAttachPlaidBankAccountMutation({
 *   variables: {
 *      stripeConnectAccountId: // value for 'stripeConnectAccountId'
 *      kycBusinessId: // value for 'kycBusinessId'
 *      plaidAccountId: // value for 'plaidAccountId'
 *      plaidPublicToken: // value for 'plaidPublicToken'
 *   },
 * });
 */
export function useAttachPlaidBankAccountMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<AttachPlaidBankAccountMutation, AttachPlaidBankAccountMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useMutation<AttachPlaidBankAccountMutation, AttachPlaidBankAccountMutationVariables>(AttachPlaidBankAccountDocument, options);
      }
export type AttachPlaidBankAccountMutationHookResult = ReturnType<typeof useAttachPlaidBankAccountMutation>;
export type AttachPlaidBankAccountMutationResult = ApolloReactCommon.MutationResult<AttachPlaidBankAccountMutation>;
export type AttachPlaidBankAccountMutationOptions = ApolloReactCommon.BaseMutationOptions<AttachPlaidBankAccountMutation, AttachPlaidBankAccountMutationVariables>;
export const UpdateConnectAccountPayoutDocument = gql`
    mutation UpdateConnectAccountPayout($stripeConnectAccountId: ID!, $attributes: StripeConnectAccountAttributes!) {
  updateStripeConnectAccount(
    stripeConnectAccountId: $stripeConnectAccountId
    attributes: $attributes
  ) {
    ... on UpdateStripeConnectAccountSuccess {
      stripeConnectAccount {
        id
        firstPayoutAddedAt
      }
    }
    ... on UpdateStripeConnectAccountFailure {
      errors {
        message
        path
        code
      }
    }
  }
}
    `;

/**
 * __useUpdateConnectAccountPayoutMutation__
 *
 * To run a mutation, you first call `useUpdateConnectAccountPayoutMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateConnectAccountPayoutMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateConnectAccountPayoutMutation, { data, loading, error }] = useUpdateConnectAccountPayoutMutation({
 *   variables: {
 *      stripeConnectAccountId: // value for 'stripeConnectAccountId'
 *      attributes: // value for 'attributes'
 *   },
 * });
 */
export function useUpdateConnectAccountPayoutMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<UpdateConnectAccountPayoutMutation, UpdateConnectAccountPayoutMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useMutation<UpdateConnectAccountPayoutMutation, UpdateConnectAccountPayoutMutationVariables>(UpdateConnectAccountPayoutDocument, options);
      }
export type UpdateConnectAccountPayoutMutationHookResult = ReturnType<typeof useUpdateConnectAccountPayoutMutation>;
export type UpdateConnectAccountPayoutMutationResult = ApolloReactCommon.MutationResult<UpdateConnectAccountPayoutMutation>;
export type UpdateConnectAccountPayoutMutationOptions = ApolloReactCommon.BaseMutationOptions<UpdateConnectAccountPayoutMutation, UpdateConnectAccountPayoutMutationVariables>;
export const GetPaymentRefundInformationDocument = gql`
    query GetPaymentRefundInformation($id: ID!) {
  connectInvoice(id: $id) {
    id
    fullName
    paid
    manuallyPaid
    ...PaymentRefundFragment
  }
}
    ${PaymentRefundFragmentFragmentDoc}`;

/**
 * __useGetPaymentRefundInformationQuery__
 *
 * To run a query within a React component, call `useGetPaymentRefundInformationQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetPaymentRefundInformationQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetPaymentRefundInformationQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useGetPaymentRefundInformationQuery(baseOptions: ApolloReactHooks.QueryHookOptions<GetPaymentRefundInformationQuery, GetPaymentRefundInformationQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<GetPaymentRefundInformationQuery, GetPaymentRefundInformationQueryVariables>(GetPaymentRefundInformationDocument, options);
      }
export function useGetPaymentRefundInformationLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<GetPaymentRefundInformationQuery, GetPaymentRefundInformationQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<GetPaymentRefundInformationQuery, GetPaymentRefundInformationQueryVariables>(GetPaymentRefundInformationDocument, options);
        }
export type GetPaymentRefundInformationQueryHookResult = ReturnType<typeof useGetPaymentRefundInformationQuery>;
export type GetPaymentRefundInformationLazyQueryHookResult = ReturnType<typeof useGetPaymentRefundInformationLazyQuery>;
export type GetPaymentRefundInformationQueryResult = ApolloReactCommon.QueryResult<GetPaymentRefundInformationQuery, GetPaymentRefundInformationQueryVariables>;
export const RefundConnectInvoiceDocument = gql`
    mutation RefundConnectInvoice($id: ID!, $amount: Int!, $reasonType: ConnectRefundReason, $description: String) {
  refundConnectInvoice(
    connectInvoiceId: $id
    amount: $amount
    reasonType: $reasonType
    description: $description
  ) {
    ... on RefundConnectInvoiceSuccess {
      connectInvoice {
        id
        ...PaymentRefundFragment
        viewableActivities {
          nodes {
            id
            activityDate
            content
            connectActivityTypeId
          }
        }
      }
    }
    ... on RefundConnectInvoiceFailure {
      errors {
        code
        message
        path
      }
    }
  }
}
    ${PaymentRefundFragmentFragmentDoc}`;

/**
 * __useRefundConnectInvoiceMutation__
 *
 * To run a mutation, you first call `useRefundConnectInvoiceMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useRefundConnectInvoiceMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [refundConnectInvoiceMutation, { data, loading, error }] = useRefundConnectInvoiceMutation({
 *   variables: {
 *      id: // value for 'id'
 *      amount: // value for 'amount'
 *      reasonType: // value for 'reasonType'
 *      description: // value for 'description'
 *   },
 * });
 */
export function useRefundConnectInvoiceMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<RefundConnectInvoiceMutation, RefundConnectInvoiceMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useMutation<RefundConnectInvoiceMutation, RefundConnectInvoiceMutationVariables>(RefundConnectInvoiceDocument, options);
      }
export type RefundConnectInvoiceMutationHookResult = ReturnType<typeof useRefundConnectInvoiceMutation>;
export type RefundConnectInvoiceMutationResult = ApolloReactCommon.MutationResult<RefundConnectInvoiceMutation>;
export type RefundConnectInvoiceMutationOptions = ApolloReactCommon.BaseMutationOptions<RefundConnectInvoiceMutation, RefundConnectInvoiceMutationVariables>;
export const GetPaymentFaqDataDocument = gql`
    query GetPaymentFAQData {
  organization {
    id
    currentTransactionForNewPaymentsAccounts {
      achFeeFixedAmount
      cardFeePercentageAmount
    }
  }
}
    `;

/**
 * __useGetPaymentFaqDataQuery__
 *
 * To run a query within a React component, call `useGetPaymentFaqDataQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetPaymentFaqDataQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetPaymentFaqDataQuery({
 *   variables: {
 *   },
 * });
 */
export function useGetPaymentFaqDataQuery(baseOptions?: ApolloReactHooks.QueryHookOptions<GetPaymentFaqDataQuery, GetPaymentFaqDataQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<GetPaymentFaqDataQuery, GetPaymentFaqDataQueryVariables>(GetPaymentFaqDataDocument, options);
      }
export function useGetPaymentFaqDataLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<GetPaymentFaqDataQuery, GetPaymentFaqDataQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<GetPaymentFaqDataQuery, GetPaymentFaqDataQueryVariables>(GetPaymentFaqDataDocument, options);
        }
export type GetPaymentFaqDataQueryHookResult = ReturnType<typeof useGetPaymentFaqDataQuery>;
export type GetPaymentFaqDataLazyQueryHookResult = ReturnType<typeof useGetPaymentFaqDataLazyQuery>;
export type GetPaymentFaqDataQueryResult = ApolloReactCommon.QueryResult<GetPaymentFaqDataQuery, GetPaymentFaqDataQueryVariables>;
export const GetPaymentSetupDataDocument = gql`
    query GetPaymentSetupData {
  organization {
    id
    stripeConnectAccount {
      id
    }
    customSettings {
      paymentsRewardsExpiredAt
      paymentsRewardsQualifiedAt
    }
    currentTransactionForNewPaymentsAccounts {
      achFeeFixedAmount
      cardFeePercentageAmount
    }
    paymentsContract {
      id
      text
    }
  }
}
    `;

/**
 * __useGetPaymentSetupDataQuery__
 *
 * To run a query within a React component, call `useGetPaymentSetupDataQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetPaymentSetupDataQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetPaymentSetupDataQuery({
 *   variables: {
 *   },
 * });
 */
export function useGetPaymentSetupDataQuery(baseOptions?: ApolloReactHooks.QueryHookOptions<GetPaymentSetupDataQuery, GetPaymentSetupDataQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<GetPaymentSetupDataQuery, GetPaymentSetupDataQueryVariables>(GetPaymentSetupDataDocument, options);
      }
export function useGetPaymentSetupDataLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<GetPaymentSetupDataQuery, GetPaymentSetupDataQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<GetPaymentSetupDataQuery, GetPaymentSetupDataQueryVariables>(GetPaymentSetupDataDocument, options);
        }
export type GetPaymentSetupDataQueryHookResult = ReturnType<typeof useGetPaymentSetupDataQuery>;
export type GetPaymentSetupDataLazyQueryHookResult = ReturnType<typeof useGetPaymentSetupDataLazyQuery>;
export type GetPaymentSetupDataQueryResult = ApolloReactCommon.QueryResult<GetPaymentSetupDataQuery, GetPaymentSetupDataQueryVariables>;
export const GetPaymentsApprovedDataDocument = gql`
    query getPaymentsApprovedData {
  contractor {
    id
    firstName
    paymentsAdmin
  }
}
    `;

/**
 * __useGetPaymentsApprovedDataQuery__
 *
 * To run a query within a React component, call `useGetPaymentsApprovedDataQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetPaymentsApprovedDataQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetPaymentsApprovedDataQuery({
 *   variables: {
 *   },
 * });
 */
export function useGetPaymentsApprovedDataQuery(baseOptions?: ApolloReactHooks.QueryHookOptions<GetPaymentsApprovedDataQuery, GetPaymentsApprovedDataQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<GetPaymentsApprovedDataQuery, GetPaymentsApprovedDataQueryVariables>(GetPaymentsApprovedDataDocument, options);
      }
export function useGetPaymentsApprovedDataLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<GetPaymentsApprovedDataQuery, GetPaymentsApprovedDataQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<GetPaymentsApprovedDataQuery, GetPaymentsApprovedDataQueryVariables>(GetPaymentsApprovedDataDocument, options);
        }
export type GetPaymentsApprovedDataQueryHookResult = ReturnType<typeof useGetPaymentsApprovedDataQuery>;
export type GetPaymentsApprovedDataLazyQueryHookResult = ReturnType<typeof useGetPaymentsApprovedDataLazyQuery>;
export type GetPaymentsApprovedDataQueryResult = ApolloReactCommon.QueryResult<GetPaymentsApprovedDataQuery, GetPaymentsApprovedDataQueryVariables>;
export const GetPaymentStripeRedirectDataDocument = gql`
    query GetPaymentStripeRedirectData {
  organization {
    id
    ...PaymentStripeRedirectOrganization
  }
}
    ${PaymentStripeRedirectOrganizationFragmentDoc}`;

/**
 * __useGetPaymentStripeRedirectDataQuery__
 *
 * To run a query within a React component, call `useGetPaymentStripeRedirectDataQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetPaymentStripeRedirectDataQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetPaymentStripeRedirectDataQuery({
 *   variables: {
 *   },
 * });
 */
export function useGetPaymentStripeRedirectDataQuery(baseOptions?: ApolloReactHooks.QueryHookOptions<GetPaymentStripeRedirectDataQuery, GetPaymentStripeRedirectDataQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<GetPaymentStripeRedirectDataQuery, GetPaymentStripeRedirectDataQueryVariables>(GetPaymentStripeRedirectDataDocument, options);
      }
export function useGetPaymentStripeRedirectDataLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<GetPaymentStripeRedirectDataQuery, GetPaymentStripeRedirectDataQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<GetPaymentStripeRedirectDataQuery, GetPaymentStripeRedirectDataQueryVariables>(GetPaymentStripeRedirectDataDocument, options);
        }
export type GetPaymentStripeRedirectDataQueryHookResult = ReturnType<typeof useGetPaymentStripeRedirectDataQuery>;
export type GetPaymentStripeRedirectDataLazyQueryHookResult = ReturnType<typeof useGetPaymentStripeRedirectDataLazyQuery>;
export type GetPaymentStripeRedirectDataQueryResult = ApolloReactCommon.QueryResult<GetPaymentStripeRedirectDataQuery, GetPaymentStripeRedirectDataQueryVariables>;
export const PaymentStripeRedirectGenerateConnectOnboardingLinkDocument = gql`
    mutation PaymentStripeRedirectGenerateConnectOnboardingLink($organizationId: ID!, $refreshUrl: String!, $returnUrl: String!) {
  getStripeAccountLink(
    organizationId: $organizationId
    refreshUrl: $refreshUrl
    returnUrl: $returnUrl
    type: "account_onboarding"
  ) {
    ... on GetStripeAccountLinkSuccess {
      connectAccountLoginLink
    }
    ... on GetStripeAccountLinkFailure {
      errors {
        code
        message
        path
      }
    }
  }
}
    `;

/**
 * __usePaymentStripeRedirectGenerateConnectOnboardingLinkMutation__
 *
 * To run a mutation, you first call `usePaymentStripeRedirectGenerateConnectOnboardingLinkMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `usePaymentStripeRedirectGenerateConnectOnboardingLinkMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [paymentStripeRedirectGenerateConnectOnboardingLinkMutation, { data, loading, error }] = usePaymentStripeRedirectGenerateConnectOnboardingLinkMutation({
 *   variables: {
 *      organizationId: // value for 'organizationId'
 *      refreshUrl: // value for 'refreshUrl'
 *      returnUrl: // value for 'returnUrl'
 *   },
 * });
 */
export function usePaymentStripeRedirectGenerateConnectOnboardingLinkMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<PaymentStripeRedirectGenerateConnectOnboardingLinkMutation, PaymentStripeRedirectGenerateConnectOnboardingLinkMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useMutation<PaymentStripeRedirectGenerateConnectOnboardingLinkMutation, PaymentStripeRedirectGenerateConnectOnboardingLinkMutationVariables>(PaymentStripeRedirectGenerateConnectOnboardingLinkDocument, options);
      }
export type PaymentStripeRedirectGenerateConnectOnboardingLinkMutationHookResult = ReturnType<typeof usePaymentStripeRedirectGenerateConnectOnboardingLinkMutation>;
export type PaymentStripeRedirectGenerateConnectOnboardingLinkMutationResult = ApolloReactCommon.MutationResult<PaymentStripeRedirectGenerateConnectOnboardingLinkMutation>;
export type PaymentStripeRedirectGenerateConnectOnboardingLinkMutationOptions = ApolloReactCommon.BaseMutationOptions<PaymentStripeRedirectGenerateConnectOnboardingLinkMutation, PaymentStripeRedirectGenerateConnectOnboardingLinkMutationVariables>;
export const GetPrePaymentsDataDocument = gql`
    query GetPrePaymentsData {
  contractor {
    id
    tryPaymentsSeen
    paymentsRole
    customSettings {
      tryPaymentsSeenWeb
    }
  }
  organization {
    id
    paymentsContract {
      id
      text
    }
  }
}
    `;

/**
 * __useGetPrePaymentsDataQuery__
 *
 * To run a query within a React component, call `useGetPrePaymentsDataQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetPrePaymentsDataQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetPrePaymentsDataQuery({
 *   variables: {
 *   },
 * });
 */
export function useGetPrePaymentsDataQuery(baseOptions?: ApolloReactHooks.QueryHookOptions<GetPrePaymentsDataQuery, GetPrePaymentsDataQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<GetPrePaymentsDataQuery, GetPrePaymentsDataQueryVariables>(GetPrePaymentsDataDocument, options);
      }
export function useGetPrePaymentsDataLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<GetPrePaymentsDataQuery, GetPrePaymentsDataQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<GetPrePaymentsDataQuery, GetPrePaymentsDataQueryVariables>(GetPrePaymentsDataDocument, options);
        }
export type GetPrePaymentsDataQueryHookResult = ReturnType<typeof useGetPrePaymentsDataQuery>;
export type GetPrePaymentsDataLazyQueryHookResult = ReturnType<typeof useGetPrePaymentsDataLazyQuery>;
export type GetPrePaymentsDataQueryResult = ApolloReactCommon.QueryResult<GetPrePaymentsDataQuery, GetPrePaymentsDataQueryVariables>;
export const SendSampleInvoiceDocument = gql`
    mutation SendSampleInvoice($id: ID!) {
  sendContractorSampleInvoice(contractorId: $id) {
    contractor {
      id
      tryPaymentsSeen
    }
  }
}
    `;

/**
 * __useSendSampleInvoiceMutation__
 *
 * To run a mutation, you first call `useSendSampleInvoiceMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useSendSampleInvoiceMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [sendSampleInvoiceMutation, { data, loading, error }] = useSendSampleInvoiceMutation({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useSendSampleInvoiceMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<SendSampleInvoiceMutation, SendSampleInvoiceMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useMutation<SendSampleInvoiceMutation, SendSampleInvoiceMutationVariables>(SendSampleInvoiceDocument, options);
      }
export type SendSampleInvoiceMutationHookResult = ReturnType<typeof useSendSampleInvoiceMutation>;
export type SendSampleInvoiceMutationResult = ApolloReactCommon.MutationResult<SendSampleInvoiceMutation>;
export type SendSampleInvoiceMutationOptions = ApolloReactCommon.BaseMutationOptions<SendSampleInvoiceMutation, SendSampleInvoiceMutationVariables>;
export const UpdateContractorPaymentsDataDocument = gql`
    mutation UpdateContractorPaymentsData($id: ID!, $attributes: ContractorAttributes!) {
  updateContractor(id: $id, attributes: $attributes) {
    contractor {
      id
      tryPaymentsSeen
    }
    errors {
      message
    }
  }
}
    `;

/**
 * __useUpdateContractorPaymentsDataMutation__
 *
 * To run a mutation, you first call `useUpdateContractorPaymentsDataMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateContractorPaymentsDataMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateContractorPaymentsDataMutation, { data, loading, error }] = useUpdateContractorPaymentsDataMutation({
 *   variables: {
 *      id: // value for 'id'
 *      attributes: // value for 'attributes'
 *   },
 * });
 */
export function useUpdateContractorPaymentsDataMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<UpdateContractorPaymentsDataMutation, UpdateContractorPaymentsDataMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useMutation<UpdateContractorPaymentsDataMutation, UpdateContractorPaymentsDataMutationVariables>(UpdateContractorPaymentsDataDocument, options);
      }
export type UpdateContractorPaymentsDataMutationHookResult = ReturnType<typeof useUpdateContractorPaymentsDataMutation>;
export type UpdateContractorPaymentsDataMutationResult = ApolloReactCommon.MutationResult<UpdateContractorPaymentsDataMutation>;
export type UpdateContractorPaymentsDataMutationOptions = ApolloReactCommon.BaseMutationOptions<UpdateContractorPaymentsDataMutation, UpdateContractorPaymentsDataMutationVariables>;
export const GetPresaleCourseDataDocument = gql`
    query getPresaleCourseData($email: String!) {
  presaleLead(email: $email) {
    id
    email
    marketoUuid
    courseCompletedAt
    articleInteractions {
      nodes {
        id
        article {
          id
          contentfulId
        }
        interactionType
        interactionValue
      }
    }
  }
}
    `;

/**
 * __useGetPresaleCourseDataQuery__
 *
 * To run a query within a React component, call `useGetPresaleCourseDataQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetPresaleCourseDataQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetPresaleCourseDataQuery({
 *   variables: {
 *      email: // value for 'email'
 *   },
 * });
 */
export function useGetPresaleCourseDataQuery(baseOptions: ApolloReactHooks.QueryHookOptions<GetPresaleCourseDataQuery, GetPresaleCourseDataQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<GetPresaleCourseDataQuery, GetPresaleCourseDataQueryVariables>(GetPresaleCourseDataDocument, options);
      }
export function useGetPresaleCourseDataLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<GetPresaleCourseDataQuery, GetPresaleCourseDataQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<GetPresaleCourseDataQuery, GetPresaleCourseDataQueryVariables>(GetPresaleCourseDataDocument, options);
        }
export type GetPresaleCourseDataQueryHookResult = ReturnType<typeof useGetPresaleCourseDataQuery>;
export type GetPresaleCourseDataLazyQueryHookResult = ReturnType<typeof useGetPresaleCourseDataLazyQuery>;
export type GetPresaleCourseDataQueryResult = ApolloReactCommon.QueryResult<GetPresaleCourseDataQuery, GetPresaleCourseDataQueryVariables>;
export const GetProfileDataDocument = gql`
    query GetProfileData {
  organization {
    id
    ...ProfileOrganization
  }
  contractor {
    id
    ...ProfileContractor
  }
}
    ${ProfileOrganizationFragmentDoc}
${ProfileContractorFragmentDoc}`;

/**
 * __useGetProfileDataQuery__
 *
 * To run a query within a React component, call `useGetProfileDataQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetProfileDataQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetProfileDataQuery({
 *   variables: {
 *   },
 * });
 */
export function useGetProfileDataQuery(baseOptions?: ApolloReactHooks.QueryHookOptions<GetProfileDataQuery, GetProfileDataQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<GetProfileDataQuery, GetProfileDataQueryVariables>(GetProfileDataDocument, options);
      }
export function useGetProfileDataLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<GetProfileDataQuery, GetProfileDataQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<GetProfileDataQuery, GetProfileDataQueryVariables>(GetProfileDataDocument, options);
        }
export type GetProfileDataQueryHookResult = ReturnType<typeof useGetProfileDataQuery>;
export type GetProfileDataLazyQueryHookResult = ReturnType<typeof useGetProfileDataLazyQuery>;
export type GetProfileDataQueryResult = ApolloReactCommon.QueryResult<GetProfileDataQuery, GetProfileDataQueryVariables>;
export const UpdateOrganizationProfileDocument = gql`
    mutation UpdateOrganizationProfile($attributes: OrganizationAttributes!) {
  upsertOrganization(attributes: $attributes) {
    ... on UpsertOrganizationSuccess {
      organization {
        id
        ...ProfileOrganization
      }
    }
    ... on UpsertOrganizationFailure {
      errors {
        message
        path
        code
      }
    }
  }
}
    ${ProfileOrganizationFragmentDoc}`;

/**
 * __useUpdateOrganizationProfileMutation__
 *
 * To run a mutation, you first call `useUpdateOrganizationProfileMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateOrganizationProfileMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateOrganizationProfileMutation, { data, loading, error }] = useUpdateOrganizationProfileMutation({
 *   variables: {
 *      attributes: // value for 'attributes'
 *   },
 * });
 */
export function useUpdateOrganizationProfileMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<UpdateOrganizationProfileMutation, UpdateOrganizationProfileMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useMutation<UpdateOrganizationProfileMutation, UpdateOrganizationProfileMutationVariables>(UpdateOrganizationProfileDocument, options);
      }
export type UpdateOrganizationProfileMutationHookResult = ReturnType<typeof useUpdateOrganizationProfileMutation>;
export type UpdateOrganizationProfileMutationResult = ApolloReactCommon.MutationResult<UpdateOrganizationProfileMutation>;
export type UpdateOrganizationProfileMutationOptions = ApolloReactCommon.BaseMutationOptions<UpdateOrganizationProfileMutation, UpdateOrganizationProfileMutationVariables>;
export const UpdateContractorProfileDocument = gql`
    mutation UpdateContractorProfile($attributes: ContractorAttributes!) {
  upsertContractor(attributes: $attributes) {
    ... on UpsertContractorSuccess {
      contractor {
        id
        ...ProfileContractor
      }
    }
    ... on UpsertContractorFailure {
      errors {
        message
        path
        code
      }
    }
  }
}
    ${ProfileContractorFragmentDoc}`;

/**
 * __useUpdateContractorProfileMutation__
 *
 * To run a mutation, you first call `useUpdateContractorProfileMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateContractorProfileMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateContractorProfileMutation, { data, loading, error }] = useUpdateContractorProfileMutation({
 *   variables: {
 *      attributes: // value for 'attributes'
 *   },
 * });
 */
export function useUpdateContractorProfileMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<UpdateContractorProfileMutation, UpdateContractorProfileMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useMutation<UpdateContractorProfileMutation, UpdateContractorProfileMutationVariables>(UpdateContractorProfileDocument, options);
      }
export type UpdateContractorProfileMutationHookResult = ReturnType<typeof useUpdateContractorProfileMutation>;
export type UpdateContractorProfileMutationResult = ApolloReactCommon.MutationResult<UpdateContractorProfileMutation>;
export type UpdateContractorProfileMutationOptions = ApolloReactCommon.BaseMutationOptions<UpdateContractorProfileMutation, UpdateContractorProfileMutationVariables>;
export const GetHomeownerFeedbackInfoDocument = gql`
    query GetHomeownerFeedbackInfo($homeownerId: String!) {
  homeowner(id: $homeownerId) {
    id
    fullName
    homeownerPaymentsFeedback {
      id
      ...PaymentsFeedback
    }
    homeownerFinancingFeedback {
      id
      ...FinancingFeedback
    }
  }
}
    ${PaymentsFeedbackFragmentDoc}
${FinancingFeedbackFragmentDoc}`;

/**
 * __useGetHomeownerFeedbackInfoQuery__
 *
 * To run a query within a React component, call `useGetHomeownerFeedbackInfoQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetHomeownerFeedbackInfoQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetHomeownerFeedbackInfoQuery({
 *   variables: {
 *      homeownerId: // value for 'homeownerId'
 *   },
 * });
 */
export function useGetHomeownerFeedbackInfoQuery(baseOptions: ApolloReactHooks.QueryHookOptions<GetHomeownerFeedbackInfoQuery, GetHomeownerFeedbackInfoQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<GetHomeownerFeedbackInfoQuery, GetHomeownerFeedbackInfoQueryVariables>(GetHomeownerFeedbackInfoDocument, options);
      }
export function useGetHomeownerFeedbackInfoLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<GetHomeownerFeedbackInfoQuery, GetHomeownerFeedbackInfoQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<GetHomeownerFeedbackInfoQuery, GetHomeownerFeedbackInfoQueryVariables>(GetHomeownerFeedbackInfoDocument, options);
        }
export type GetHomeownerFeedbackInfoQueryHookResult = ReturnType<typeof useGetHomeownerFeedbackInfoQuery>;
export type GetHomeownerFeedbackInfoLazyQueryHookResult = ReturnType<typeof useGetHomeownerFeedbackInfoLazyQuery>;
export type GetHomeownerFeedbackInfoQueryResult = ApolloReactCommon.QueryResult<GetHomeownerFeedbackInfoQuery, GetHomeownerFeedbackInfoQueryVariables>;
export const GetReportingDataDocument = gql`
    query GetReportingData {
  contractor {
    id
    fullName
    email
    fullUrl
    homeownerFinancingFeedbackMetrics {
      avgContractorSatisfaction
      avgContractorSatisfactionDifference
      avgHearthSatisfaction
      avgHearthSatisfactionDifference
    }
    homeownerPaymentsFeedbackMetrics {
      avgContractorSatisfaction
      avgContractorSatisfactionDifference
      avgHearthSatisfaction
      avgHearthSatisfactionDifference
    }
    homeownerFinancingFeedback {
      nodes {
        id
        homeownerId
        fullName
        submittedAt
        contractorExperience
        hearthRating
        additionalFinancingFeedback
      }
    }
    homeownerPaymentsFeedback {
      nodes {
        id
        homeownerId
        fullName
        submittedAt
        digitalPayments
        workQuality
        customerService
        additionalPaymentsFeedback
      }
    }
  }
}
    `;

/**
 * __useGetReportingDataQuery__
 *
 * To run a query within a React component, call `useGetReportingDataQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetReportingDataQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetReportingDataQuery({
 *   variables: {
 *   },
 * });
 */
export function useGetReportingDataQuery(baseOptions?: ApolloReactHooks.QueryHookOptions<GetReportingDataQuery, GetReportingDataQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<GetReportingDataQuery, GetReportingDataQueryVariables>(GetReportingDataDocument, options);
      }
export function useGetReportingDataLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<GetReportingDataQuery, GetReportingDataQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<GetReportingDataQuery, GetReportingDataQueryVariables>(GetReportingDataDocument, options);
        }
export type GetReportingDataQueryHookResult = ReturnType<typeof useGetReportingDataQuery>;
export type GetReportingDataLazyQueryHookResult = ReturnType<typeof useGetReportingDataLazyQuery>;
export type GetReportingDataQueryResult = ApolloReactCommon.QueryResult<GetReportingDataQuery, GetReportingDataQueryVariables>;
export const GetContractTemplatesDetailsDocument = gql`
    query GetContractTemplatesDetails {
  organization {
    id
    contractServiceAccount {
      id
      latestVersionContractTemplates {
        nodes {
          id
          ...ContractTemplateInfo
        }
      }
    }
  }
  contractor {
    id
  }
}
    ${ContractTemplateInfoFragmentDoc}`;

/**
 * __useGetContractTemplatesDetailsQuery__
 *
 * To run a query within a React component, call `useGetContractTemplatesDetailsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetContractTemplatesDetailsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetContractTemplatesDetailsQuery({
 *   variables: {
 *   },
 * });
 */
export function useGetContractTemplatesDetailsQuery(baseOptions?: ApolloReactHooks.QueryHookOptions<GetContractTemplatesDetailsQuery, GetContractTemplatesDetailsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<GetContractTemplatesDetailsQuery, GetContractTemplatesDetailsQueryVariables>(GetContractTemplatesDetailsDocument, options);
      }
export function useGetContractTemplatesDetailsLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<GetContractTemplatesDetailsQuery, GetContractTemplatesDetailsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<GetContractTemplatesDetailsQuery, GetContractTemplatesDetailsQueryVariables>(GetContractTemplatesDetailsDocument, options);
        }
export type GetContractTemplatesDetailsQueryHookResult = ReturnType<typeof useGetContractTemplatesDetailsQuery>;
export type GetContractTemplatesDetailsLazyQueryHookResult = ReturnType<typeof useGetContractTemplatesDetailsLazyQuery>;
export type GetContractTemplatesDetailsQueryResult = ApolloReactCommon.QueryResult<GetContractTemplatesDetailsQuery, GetContractTemplatesDetailsQueryVariables>;
export const CreateContractDocument = gql`
    mutation CreateContract($renderedHtml: String!, $homeownerId: ID!, $templateId: ID!, $mediums: [ContactMedium!]!, $attachedInvoiceParams: ConnectInvoiceParams, $dueDate: ISO8601DateTime!, $personalNote: String, $files: [File!], $renderArgs: JSON, $sendFinancingLink: Boolean, $name: String) {
  contractServiceCreateContract(
    renderedHtml: $renderedHtml
    homeownerId: $homeownerId
    templateId: $templateId
    mediums: $mediums
    attachedInvoiceParams: $attachedInvoiceParams
    dueDate: $dueDate
    personalNote: $personalNote
    files: $files
    renderArgs: $renderArgs
    sendFinancingLink: $sendFinancingLink
    name: $name
  ) {
    ... on ContractServiceCreateContractSuccess {
      contractServiceContract {
        id
      }
      contractorSignature {
        id
      }
      contractorSignatureToken
      attachedInvoice {
        id
      }
    }
    ... on ContractServiceCreateContractFailure {
      errors {
        message
        path
        code
      }
    }
  }
}
    `;

/**
 * __useCreateContractMutation__
 *
 * To run a mutation, you first call `useCreateContractMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateContractMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createContractMutation, { data, loading, error }] = useCreateContractMutation({
 *   variables: {
 *      renderedHtml: // value for 'renderedHtml'
 *      homeownerId: // value for 'homeownerId'
 *      templateId: // value for 'templateId'
 *      mediums: // value for 'mediums'
 *      attachedInvoiceParams: // value for 'attachedInvoiceParams'
 *      dueDate: // value for 'dueDate'
 *      personalNote: // value for 'personalNote'
 *      files: // value for 'files'
 *      renderArgs: // value for 'renderArgs'
 *      sendFinancingLink: // value for 'sendFinancingLink'
 *      name: // value for 'name'
 *   },
 * });
 */
export function useCreateContractMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<CreateContractMutation, CreateContractMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useMutation<CreateContractMutation, CreateContractMutationVariables>(CreateContractDocument, options);
      }
export type CreateContractMutationHookResult = ReturnType<typeof useCreateContractMutation>;
export type CreateContractMutationResult = ApolloReactCommon.MutationResult<CreateContractMutation>;
export type CreateContractMutationOptions = ApolloReactCommon.BaseMutationOptions<CreateContractMutation, CreateContractMutationVariables>;
export const FetchContractorSignatureLinkDocument = gql`
    mutation FetchContractorSignatureLink($contractServiceSignatureId: ID!, $signingToken: String!) {
  contractServiceSigningLinkFetch(
    contractServiceSignatureId: $contractServiceSignatureId
    signingToken: $signingToken
  ) {
    ... on ContractServiceSigningLinkFetchSuccess {
      signatureLink
      contractServiceSignature {
        id
        contractServiceContract {
          id
          projectContractHomeowner {
            id
          }
          attachedInvoice {
            id
          }
        }
      }
    }
    ... on ContractServiceSigningLinkFetchFailure {
      errors {
        message
        path
        code
      }
    }
  }
}
    `;

/**
 * __useFetchContractorSignatureLinkMutation__
 *
 * To run a mutation, you first call `useFetchContractorSignatureLinkMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useFetchContractorSignatureLinkMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [fetchContractorSignatureLinkMutation, { data, loading, error }] = useFetchContractorSignatureLinkMutation({
 *   variables: {
 *      contractServiceSignatureId: // value for 'contractServiceSignatureId'
 *      signingToken: // value for 'signingToken'
 *   },
 * });
 */
export function useFetchContractorSignatureLinkMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<FetchContractorSignatureLinkMutation, FetchContractorSignatureLinkMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useMutation<FetchContractorSignatureLinkMutation, FetchContractorSignatureLinkMutationVariables>(FetchContractorSignatureLinkDocument, options);
      }
export type FetchContractorSignatureLinkMutationHookResult = ReturnType<typeof useFetchContractorSignatureLinkMutation>;
export type FetchContractorSignatureLinkMutationResult = ApolloReactCommon.MutationResult<FetchContractorSignatureLinkMutation>;
export type FetchContractorSignatureLinkMutationOptions = ApolloReactCommon.BaseMutationOptions<FetchContractorSignatureLinkMutation, FetchContractorSignatureLinkMutationVariables>;
export const QuoteAssociateContractDocument = gql`
    mutation QuoteAssociateContract($contractServiceContractId: ID!, $quoteId: ID!) {
  quoteAssociateContract(
    contractServiceContractId: $contractServiceContractId
    quoteId: $quoteId
  ) {
    ... on QuoteAssociateContractSuccess {
      quote {
        id
      }
    }
    ... on QuoteAssociateContractFailure {
      errors {
        message
        path
        code
      }
    }
  }
}
    `;

/**
 * __useQuoteAssociateContractMutation__
 *
 * To run a mutation, you first call `useQuoteAssociateContractMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useQuoteAssociateContractMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [quoteAssociateContractMutation, { data, loading, error }] = useQuoteAssociateContractMutation({
 *   variables: {
 *      contractServiceContractId: // value for 'contractServiceContractId'
 *      quoteId: // value for 'quoteId'
 *   },
 * });
 */
export function useQuoteAssociateContractMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<QuoteAssociateContractMutation, QuoteAssociateContractMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useMutation<QuoteAssociateContractMutation, QuoteAssociateContractMutationVariables>(QuoteAssociateContractDocument, options);
      }
export type QuoteAssociateContractMutationHookResult = ReturnType<typeof useQuoteAssociateContractMutation>;
export type QuoteAssociateContractMutationResult = ApolloReactCommon.MutationResult<QuoteAssociateContractMutation>;
export type QuoteAssociateContractMutationOptions = ApolloReactCommon.BaseMutationOptions<QuoteAssociateContractMutation, QuoteAssociateContractMutationVariables>;
export const GetTooltipNameFieldDocument = gql`
    query GetTooltipNameField($eventTypes: [HearthEventEventTypes!]) {
  contractor {
    id
    hearthEvents(eventTypes: $eventTypes) {
      totalCount
    }
  }
}
    `;

/**
 * __useGetTooltipNameFieldQuery__
 *
 * To run a query within a React component, call `useGetTooltipNameFieldQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetTooltipNameFieldQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetTooltipNameFieldQuery({
 *   variables: {
 *      eventTypes: // value for 'eventTypes'
 *   },
 * });
 */
export function useGetTooltipNameFieldQuery(baseOptions?: ApolloReactHooks.QueryHookOptions<GetTooltipNameFieldQuery, GetTooltipNameFieldQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<GetTooltipNameFieldQuery, GetTooltipNameFieldQueryVariables>(GetTooltipNameFieldDocument, options);
      }
export function useGetTooltipNameFieldLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<GetTooltipNameFieldQuery, GetTooltipNameFieldQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<GetTooltipNameFieldQuery, GetTooltipNameFieldQueryVariables>(GetTooltipNameFieldDocument, options);
        }
export type GetTooltipNameFieldQueryHookResult = ReturnType<typeof useGetTooltipNameFieldQuery>;
export type GetTooltipNameFieldLazyQueryHookResult = ReturnType<typeof useGetTooltipNameFieldLazyQuery>;
export type GetTooltipNameFieldQueryResult = ApolloReactCommon.QueryResult<GetTooltipNameFieldQuery, GetTooltipNameFieldQueryVariables>;
export const GetPersonalizedTemplateDocument = gql`
    query GetPersonalizedTemplate {
  contractor {
    id
    sendFinancingLinkTemplate {
      id
      templateString
      subject
      generatedTemplate(templateParams: {})
    }
  }
}
    `;

/**
 * __useGetPersonalizedTemplateQuery__
 *
 * To run a query within a React component, call `useGetPersonalizedTemplateQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetPersonalizedTemplateQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetPersonalizedTemplateQuery({
 *   variables: {
 *   },
 * });
 */
export function useGetPersonalizedTemplateQuery(baseOptions?: ApolloReactHooks.QueryHookOptions<GetPersonalizedTemplateQuery, GetPersonalizedTemplateQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<GetPersonalizedTemplateQuery, GetPersonalizedTemplateQueryVariables>(GetPersonalizedTemplateDocument, options);
      }
export function useGetPersonalizedTemplateLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<GetPersonalizedTemplateQuery, GetPersonalizedTemplateQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<GetPersonalizedTemplateQuery, GetPersonalizedTemplateQueryVariables>(GetPersonalizedTemplateDocument, options);
        }
export type GetPersonalizedTemplateQueryHookResult = ReturnType<typeof useGetPersonalizedTemplateQuery>;
export type GetPersonalizedTemplateLazyQueryHookResult = ReturnType<typeof useGetPersonalizedTemplateLazyQuery>;
export type GetPersonalizedTemplateQueryResult = ApolloReactCommon.QueryResult<GetPersonalizedTemplateQuery, GetPersonalizedTemplateQueryVariables>;
export const SubmitClientRequestFormDocument = gql`
    mutation SubmitClientRequestForm($homeownerId: ID, $homeownerAttributes: MinimalHomeownerAttributes, $invoiceAttributes: [ConnectInvoiceParams!], $financingAttributes: FinancingParams, $mediums: [ContactMedium!]!, $paymentIncludesFinancing: Boolean) {
  clientAllInOneRequestForm(
    homeownerId: $homeownerId
    homeownerAttributes: $homeownerAttributes
    invoiceAttributes: $invoiceAttributes
    financingAttributes: $financingAttributes
    mediums: $mediums
    paymentIncludesFinancing: $paymentIncludesFinancing
  ) {
    ... on AllInOneRequestFormSuccess {
      financingSent
      homeowner {
        id
        fullName
        financingStatus
        contractor {
          id
          visibleConnectInvoices {
            totalCount
          }
        }
      }
      connectInvoices {
        nodes {
          id
          customerPaysAchFee
          customerPaysCardFee
          scheduledFor
        }
      }
    }
    ... on AllInOneRequestFormFailure {
      errors {
        code
        message
        path
      }
    }
  }
}
    `;

/**
 * __useSubmitClientRequestFormMutation__
 *
 * To run a mutation, you first call `useSubmitClientRequestFormMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useSubmitClientRequestFormMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [submitClientRequestFormMutation, { data, loading, error }] = useSubmitClientRequestFormMutation({
 *   variables: {
 *      homeownerId: // value for 'homeownerId'
 *      homeownerAttributes: // value for 'homeownerAttributes'
 *      invoiceAttributes: // value for 'invoiceAttributes'
 *      financingAttributes: // value for 'financingAttributes'
 *      mediums: // value for 'mediums'
 *      paymentIncludesFinancing: // value for 'paymentIncludesFinancing'
 *   },
 * });
 */
export function useSubmitClientRequestFormMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<SubmitClientRequestFormMutation, SubmitClientRequestFormMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useMutation<SubmitClientRequestFormMutation, SubmitClientRequestFormMutationVariables>(SubmitClientRequestFormDocument, options);
      }
export type SubmitClientRequestFormMutationHookResult = ReturnType<typeof useSubmitClientRequestFormMutation>;
export type SubmitClientRequestFormMutationResult = ApolloReactCommon.MutationResult<SubmitClientRequestFormMutation>;
export type SubmitClientRequestFormMutationOptions = ApolloReactCommon.BaseMutationOptions<SubmitClientRequestFormMutation, SubmitClientRequestFormMutationVariables>;
export const SetCustomizeInvoiceBannerDismissedDocument = gql`
    mutation SetCustomizeInvoiceBannerDismissed($customSettings: CustomContractorSettingsAttributes!) {
  upsertContractor(customSettings: $customSettings) {
    ... on UpsertContractorSuccess {
      contractor {
        id
        customSettings {
          customizeInvoiceBannerDismissed
        }
      }
    }
    ... on UpsertContractorFailure {
      errors {
        message
        path
        code
      }
    }
  }
}
    `;

/**
 * __useSetCustomizeInvoiceBannerDismissedMutation__
 *
 * To run a mutation, you first call `useSetCustomizeInvoiceBannerDismissedMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useSetCustomizeInvoiceBannerDismissedMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [setCustomizeInvoiceBannerDismissedMutation, { data, loading, error }] = useSetCustomizeInvoiceBannerDismissedMutation({
 *   variables: {
 *      customSettings: // value for 'customSettings'
 *   },
 * });
 */
export function useSetCustomizeInvoiceBannerDismissedMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<SetCustomizeInvoiceBannerDismissedMutation, SetCustomizeInvoiceBannerDismissedMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useMutation<SetCustomizeInvoiceBannerDismissedMutation, SetCustomizeInvoiceBannerDismissedMutationVariables>(SetCustomizeInvoiceBannerDismissedDocument, options);
      }
export type SetCustomizeInvoiceBannerDismissedMutationHookResult = ReturnType<typeof useSetCustomizeInvoiceBannerDismissedMutation>;
export type SetCustomizeInvoiceBannerDismissedMutationResult = ApolloReactCommon.MutationResult<SetCustomizeInvoiceBannerDismissedMutation>;
export type SetCustomizeInvoiceBannerDismissedMutationOptions = ApolloReactCommon.BaseMutationOptions<SetCustomizeInvoiceBannerDismissedMutation, SetCustomizeInvoiceBannerDismissedMutationVariables>;
export const FetchHomeownerFlowValuesDocument = gql`
    query FetchHomeownerFlowValues($homeownerId: String) {
  contractor {
    id
    ...RequestFlowContractor
  }
  organization {
    id
    ...RequestFlowOrganization
  }
  homeowner(id: $homeownerId) {
    id
    firstName
    lastName
    phoneNumber
    email
    defaultHomeownerAddress {
      id
      addressLineOne
      addressLineTwo
      city
      state
      zipCode
    }
  }
  contractServiceContractTemplate(type: project_contract) {
    id
    ...RequestFlowContractServiceContractTemplate
  }
}
    ${RequestFlowContractorFragmentDoc}
${RequestFlowOrganizationFragmentDoc}
${RequestFlowContractServiceContractTemplateFragmentDoc}`;

/**
 * __useFetchHomeownerFlowValuesQuery__
 *
 * To run a query within a React component, call `useFetchHomeownerFlowValuesQuery` and pass it any options that fit your needs.
 * When your component renders, `useFetchHomeownerFlowValuesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useFetchHomeownerFlowValuesQuery({
 *   variables: {
 *      homeownerId: // value for 'homeownerId'
 *   },
 * });
 */
export function useFetchHomeownerFlowValuesQuery(baseOptions?: ApolloReactHooks.QueryHookOptions<FetchHomeownerFlowValuesQuery, FetchHomeownerFlowValuesQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<FetchHomeownerFlowValuesQuery, FetchHomeownerFlowValuesQueryVariables>(FetchHomeownerFlowValuesDocument, options);
      }
export function useFetchHomeownerFlowValuesLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<FetchHomeownerFlowValuesQuery, FetchHomeownerFlowValuesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<FetchHomeownerFlowValuesQuery, FetchHomeownerFlowValuesQueryVariables>(FetchHomeownerFlowValuesDocument, options);
        }
export type FetchHomeownerFlowValuesQueryHookResult = ReturnType<typeof useFetchHomeownerFlowValuesQuery>;
export type FetchHomeownerFlowValuesLazyQueryHookResult = ReturnType<typeof useFetchHomeownerFlowValuesLazyQuery>;
export type FetchHomeownerFlowValuesQueryResult = ApolloReactCommon.QueryResult<FetchHomeownerFlowValuesQuery, FetchHomeownerFlowValuesQueryVariables>;
export const GenerateRequestFlowContractPreviewPdfDocument = gql`
    mutation GenerateRequestFlowContractPreviewPdf($html: String!) {
  contractGeneratorRestGeneratePdf(input: {html: $html}) @rest(endpoint: "contractGenerator", method: "POST", path: "/pdf_generator", type: "ContractGeneratorRestGeneratePdfResult") {
    pdf
  }
}
    `;

/**
 * __useGenerateRequestFlowContractPreviewPdfMutation__
 *
 * To run a mutation, you first call `useGenerateRequestFlowContractPreviewPdfMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useGenerateRequestFlowContractPreviewPdfMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [generateRequestFlowContractPreviewPdfMutation, { data, loading, error }] = useGenerateRequestFlowContractPreviewPdfMutation({
 *   variables: {
 *      html: // value for 'html'
 *   },
 * });
 */
export function useGenerateRequestFlowContractPreviewPdfMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<GenerateRequestFlowContractPreviewPdfMutation, GenerateRequestFlowContractPreviewPdfMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useMutation<GenerateRequestFlowContractPreviewPdfMutation, GenerateRequestFlowContractPreviewPdfMutationVariables>(GenerateRequestFlowContractPreviewPdfDocument, options);
      }
export type GenerateRequestFlowContractPreviewPdfMutationHookResult = ReturnType<typeof useGenerateRequestFlowContractPreviewPdfMutation>;
export type GenerateRequestFlowContractPreviewPdfMutationResult = ApolloReactCommon.MutationResult<GenerateRequestFlowContractPreviewPdfMutation>;
export type GenerateRequestFlowContractPreviewPdfMutationOptions = ApolloReactCommon.BaseMutationOptions<GenerateRequestFlowContractPreviewPdfMutation, GenerateRequestFlowContractPreviewPdfMutationVariables>;
export const UpsertArticleInteractionDocument = gql`
    mutation upsertArticleInteraction($articleContentfulId: String, $interactionType: ArticleInteractionType!, $interactableType: ArticleInteractable!, $metadata: JSON) {
  upsertArticleInteraction(
    articleContentfulId: $articleContentfulId
    interactionType: $interactionType
    articleInteractableType: $interactableType
    metadata: $metadata
  ) {
    ... on UpsertArticleInteractionSuccess {
      articleInteraction {
        id
        interactionType
      }
    }
    ... on UpsertArticleInteractionFailure {
      errors {
        code
        message
      }
    }
  }
}
    `;

/**
 * __useUpsertArticleInteractionMutation__
 *
 * To run a mutation, you first call `useUpsertArticleInteractionMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpsertArticleInteractionMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [upsertArticleInteractionMutation, { data, loading, error }] = useUpsertArticleInteractionMutation({
 *   variables: {
 *      articleContentfulId: // value for 'articleContentfulId'
 *      interactionType: // value for 'interactionType'
 *      interactableType: // value for 'interactableType'
 *      metadata: // value for 'metadata'
 *   },
 * });
 */
export function useUpsertArticleInteractionMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<UpsertArticleInteractionMutation, UpsertArticleInteractionMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useMutation<UpsertArticleInteractionMutation, UpsertArticleInteractionMutationVariables>(UpsertArticleInteractionDocument, options);
      }
export type UpsertArticleInteractionMutationHookResult = ReturnType<typeof useUpsertArticleInteractionMutation>;
export type UpsertArticleInteractionMutationResult = ApolloReactCommon.MutationResult<UpsertArticleInteractionMutation>;
export type UpsertArticleInteractionMutationOptions = ApolloReactCommon.BaseMutationOptions<UpsertArticleInteractionMutation, UpsertArticleInteractionMutationVariables>;
export const FetchContractorLifecycleDocument = gql`
    query FetchContractorLifecycle {
  contractor {
    id
    learnCenterLifecycle
  }
}
    `;

/**
 * __useFetchContractorLifecycleQuery__
 *
 * To run a query within a React component, call `useFetchContractorLifecycleQuery` and pass it any options that fit your needs.
 * When your component renders, `useFetchContractorLifecycleQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useFetchContractorLifecycleQuery({
 *   variables: {
 *   },
 * });
 */
export function useFetchContractorLifecycleQuery(baseOptions?: ApolloReactHooks.QueryHookOptions<FetchContractorLifecycleQuery, FetchContractorLifecycleQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<FetchContractorLifecycleQuery, FetchContractorLifecycleQueryVariables>(FetchContractorLifecycleDocument, options);
      }
export function useFetchContractorLifecycleLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<FetchContractorLifecycleQuery, FetchContractorLifecycleQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<FetchContractorLifecycleQuery, FetchContractorLifecycleQueryVariables>(FetchContractorLifecycleDocument, options);
        }
export type FetchContractorLifecycleQueryHookResult = ReturnType<typeof useFetchContractorLifecycleQuery>;
export type FetchContractorLifecycleLazyQueryHookResult = ReturnType<typeof useFetchContractorLifecycleLazyQuery>;
export type FetchContractorLifecycleQueryResult = ApolloReactCommon.QueryResult<FetchContractorLifecycleQuery, FetchContractorLifecycleQueryVariables>;
export const CheckReturningApplicantDocument = gql`
    query CheckReturningApplicant($hearthUid: String!) {
  hearthUidSelector(hearthUid: $hearthUid) {
    loanInquiries {
      nodes {
        id
        createdAt
        qualified
      }
    }
  }
}
    `;

/**
 * __useCheckReturningApplicantQuery__
 *
 * To run a query within a React component, call `useCheckReturningApplicantQuery` and pass it any options that fit your needs.
 * When your component renders, `useCheckReturningApplicantQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useCheckReturningApplicantQuery({
 *   variables: {
 *      hearthUid: // value for 'hearthUid'
 *   },
 * });
 */
export function useCheckReturningApplicantQuery(baseOptions: ApolloReactHooks.QueryHookOptions<CheckReturningApplicantQuery, CheckReturningApplicantQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<CheckReturningApplicantQuery, CheckReturningApplicantQueryVariables>(CheckReturningApplicantDocument, options);
      }
export function useCheckReturningApplicantLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<CheckReturningApplicantQuery, CheckReturningApplicantQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<CheckReturningApplicantQuery, CheckReturningApplicantQueryVariables>(CheckReturningApplicantDocument, options);
        }
export type CheckReturningApplicantQueryHookResult = ReturnType<typeof useCheckReturningApplicantQuery>;
export type CheckReturningApplicantLazyQueryHookResult = ReturnType<typeof useCheckReturningApplicantLazyQuery>;
export type CheckReturningApplicantQueryResult = ApolloReactCommon.QueryResult<CheckReturningApplicantQuery, CheckReturningApplicantQueryVariables>;
export const FindPreviousOffersDocument = gql`
    query FindPreviousOffers($email: String!, $date: ISO8601DateTime!) {
  qualifiedLoanInquiries(email: $email, birthday: $date) {
    nodes {
      id
      projectType
      hearthUid
      loanPrincipal
      createdAt
      contractor {
        id
        urlPath
      }
    }
  }
}
    `;

/**
 * __useFindPreviousOffersQuery__
 *
 * To run a query within a React component, call `useFindPreviousOffersQuery` and pass it any options that fit your needs.
 * When your component renders, `useFindPreviousOffersQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useFindPreviousOffersQuery({
 *   variables: {
 *      email: // value for 'email'
 *      date: // value for 'date'
 *   },
 * });
 */
export function useFindPreviousOffersQuery(baseOptions: ApolloReactHooks.QueryHookOptions<FindPreviousOffersQuery, FindPreviousOffersQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<FindPreviousOffersQuery, FindPreviousOffersQueryVariables>(FindPreviousOffersDocument, options);
      }
export function useFindPreviousOffersLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<FindPreviousOffersQuery, FindPreviousOffersQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<FindPreviousOffersQuery, FindPreviousOffersQueryVariables>(FindPreviousOffersDocument, options);
        }
export type FindPreviousOffersQueryHookResult = ReturnType<typeof useFindPreviousOffersQuery>;
export type FindPreviousOffersLazyQueryHookResult = ReturnType<typeof useFindPreviousOffersLazyQuery>;
export type FindPreviousOffersQueryResult = ApolloReactCommon.QueryResult<FindPreviousOffersQuery, FindPreviousOffersQueryVariables>;
export const GetApiTokenDocument = gql`
    query GetApiToken {
  organization {
    id
    apiToken {
      id
      delimitedPlaintextKey
    }
  }
}
    `;

/**
 * __useGetApiTokenQuery__
 *
 * To run a query within a React component, call `useGetApiTokenQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetApiTokenQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetApiTokenQuery({
 *   variables: {
 *   },
 * });
 */
export function useGetApiTokenQuery(baseOptions?: ApolloReactHooks.QueryHookOptions<GetApiTokenQuery, GetApiTokenQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<GetApiTokenQuery, GetApiTokenQueryVariables>(GetApiTokenDocument, options);
      }
export function useGetApiTokenLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<GetApiTokenQuery, GetApiTokenQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<GetApiTokenQuery, GetApiTokenQueryVariables>(GetApiTokenDocument, options);
        }
export type GetApiTokenQueryHookResult = ReturnType<typeof useGetApiTokenQuery>;
export type GetApiTokenLazyQueryHookResult = ReturnType<typeof useGetApiTokenLazyQuery>;
export type GetApiTokenQueryResult = ApolloReactCommon.QueryResult<GetApiTokenQuery, GetApiTokenQueryVariables>;
export const GetHearthPaySettingsDocument = gql`
    query GetHearthPaySettings {
  organization {
    id
    quickbooksBusiness {
      id
      autoSyncInvoices
    }
    stripeConnectAccount {
      id
      achEnabled
      creditCardEnabled
      debitCardEnabled
      achFeeFixedAmount
      cardFeeFixedAmount
      cardFeePercentageAmount
      customerPaysAchFee
      customerPaysCardFee
      allowPassingCreditCardFeesToCustomer
      externalTransferDestinations {
        standardDestinations {
          ... on StripeCard {
            id
            ...StripeCardSettings
          }
          ... on StripeBankAccount {
            id
            ...StripeBankAccountSettings
          }
        }
      }
    }
  }
  contractor {
    id
    email
    role
    paymentReminders
    paymentsRole
    firstName
    contractorReminderSettings {
      id
      ...Reminder
    }
    homeownerReminderSettings {
      id
      ...Reminder
    }
  }
  connectInvoices(status: [created, scheduled, scheduled_after_fund]) {
    nodes {
      id
      fullName
      amountRequested
      dueDate
    }
  }
}
    ${StripeCardSettingsFragmentDoc}
${StripeBankAccountSettingsFragmentDoc}
${ReminderFragmentDoc}`;

/**
 * __useGetHearthPaySettingsQuery__
 *
 * To run a query within a React component, call `useGetHearthPaySettingsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetHearthPaySettingsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetHearthPaySettingsQuery({
 *   variables: {
 *   },
 * });
 */
export function useGetHearthPaySettingsQuery(baseOptions?: ApolloReactHooks.QueryHookOptions<GetHearthPaySettingsQuery, GetHearthPaySettingsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<GetHearthPaySettingsQuery, GetHearthPaySettingsQueryVariables>(GetHearthPaySettingsDocument, options);
      }
export function useGetHearthPaySettingsLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<GetHearthPaySettingsQuery, GetHearthPaySettingsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<GetHearthPaySettingsQuery, GetHearthPaySettingsQueryVariables>(GetHearthPaySettingsDocument, options);
        }
export type GetHearthPaySettingsQueryHookResult = ReturnType<typeof useGetHearthPaySettingsQuery>;
export type GetHearthPaySettingsLazyQueryHookResult = ReturnType<typeof useGetHearthPaySettingsLazyQuery>;
export type GetHearthPaySettingsQueryResult = ApolloReactCommon.QueryResult<GetHearthPaySettingsQuery, GetHearthPaySettingsQueryVariables>;
export const UpdateAcceptedPaymentsDocument = gql`
    mutation UpdateAcceptedPayments($attributes: AcceptedPaymentsAttributes!) {
  updateAcceptedPayments(attributes: $attributes) {
    ... on UpdateAcceptedPaymentsSuccess {
      stripeConnectAccount {
        id
        achEnabled
        creditCardEnabled
        debitCardEnabled
        customerPaysAchFee
        customerPaysCardFee
      }
    }
    ... on UpdateAcceptedPaymentsFailure {
      errors {
        message
        path
        code
      }
    }
  }
}
    `;

/**
 * __useUpdateAcceptedPaymentsMutation__
 *
 * To run a mutation, you first call `useUpdateAcceptedPaymentsMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateAcceptedPaymentsMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateAcceptedPaymentsMutation, { data, loading, error }] = useUpdateAcceptedPaymentsMutation({
 *   variables: {
 *      attributes: // value for 'attributes'
 *   },
 * });
 */
export function useUpdateAcceptedPaymentsMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<UpdateAcceptedPaymentsMutation, UpdateAcceptedPaymentsMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useMutation<UpdateAcceptedPaymentsMutation, UpdateAcceptedPaymentsMutationVariables>(UpdateAcceptedPaymentsDocument, options);
      }
export type UpdateAcceptedPaymentsMutationHookResult = ReturnType<typeof useUpdateAcceptedPaymentsMutation>;
export type UpdateAcceptedPaymentsMutationResult = ApolloReactCommon.MutationResult<UpdateAcceptedPaymentsMutation>;
export type UpdateAcceptedPaymentsMutationOptions = ApolloReactCommon.BaseMutationOptions<UpdateAcceptedPaymentsMutation, UpdateAcceptedPaymentsMutationVariables>;
export const UpdateRemindersDocument = gql`
    mutation UpdateReminders($enable: Boolean!, $id: ID!) {
  updateReminderSetting(reminderSettingId: $id, enable: $enable) {
    ... on UpdateReminderSettingSuccess {
      reminderSetting {
        id
        enabled
        name
        settingName
      }
    }
    ... on UpdateReminderSettingFailure {
      errors {
        message
        path
        code
      }
    }
  }
}
    `;

/**
 * __useUpdateRemindersMutation__
 *
 * To run a mutation, you first call `useUpdateRemindersMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateRemindersMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateRemindersMutation, { data, loading, error }] = useUpdateRemindersMutation({
 *   variables: {
 *      enable: // value for 'enable'
 *      id: // value for 'id'
 *   },
 * });
 */
export function useUpdateRemindersMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<UpdateRemindersMutation, UpdateRemindersMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useMutation<UpdateRemindersMutation, UpdateRemindersMutationVariables>(UpdateRemindersDocument, options);
      }
export type UpdateRemindersMutationHookResult = ReturnType<typeof useUpdateRemindersMutation>;
export type UpdateRemindersMutationResult = ApolloReactCommon.MutationResult<UpdateRemindersMutation>;
export type UpdateRemindersMutationOptions = ApolloReactCommon.BaseMutationOptions<UpdateRemindersMutation, UpdateRemindersMutationVariables>;
export const UpdateQuickbooksSyncSettingsDocument = gql`
    mutation UpdateQuickbooksSyncSettings($quickbooksBusinessId: ID!, $settings: QuickbooksBusinessSettings!) {
  updateQuickbooksSyncSettings(
    quickbooksBusinessId: $quickbooksBusinessId
    settings: $settings
  ) {
    ... on UpdateQuickbooksSyncSettingsSuccess {
      quickbooksBusiness {
        id
        autoSyncInvoices
      }
    }
    ... on UpdateQuickbooksSyncSettingsFailure {
      errors {
        message
        path
        code
      }
    }
  }
}
    `;

/**
 * __useUpdateQuickbooksSyncSettingsMutation__
 *
 * To run a mutation, you first call `useUpdateQuickbooksSyncSettingsMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateQuickbooksSyncSettingsMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateQuickbooksSyncSettingsMutation, { data, loading, error }] = useUpdateQuickbooksSyncSettingsMutation({
 *   variables: {
 *      quickbooksBusinessId: // value for 'quickbooksBusinessId'
 *      settings: // value for 'settings'
 *   },
 * });
 */
export function useUpdateQuickbooksSyncSettingsMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<UpdateQuickbooksSyncSettingsMutation, UpdateQuickbooksSyncSettingsMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useMutation<UpdateQuickbooksSyncSettingsMutation, UpdateQuickbooksSyncSettingsMutationVariables>(UpdateQuickbooksSyncSettingsDocument, options);
      }
export type UpdateQuickbooksSyncSettingsMutationHookResult = ReturnType<typeof useUpdateQuickbooksSyncSettingsMutation>;
export type UpdateQuickbooksSyncSettingsMutationResult = ApolloReactCommon.MutationResult<UpdateQuickbooksSyncSettingsMutation>;
export type UpdateQuickbooksSyncSettingsMutationOptions = ApolloReactCommon.BaseMutationOptions<UpdateQuickbooksSyncSettingsMutation, UpdateQuickbooksSyncSettingsMutationVariables>;
export const ExportPaymentDataDocument = gql`
    mutation ExportPaymentData($type: ExportPaymentData!) {
  exportPaymentData(type: $type) {
    ... on ExportPaymentDataSuccess {
      contractor {
        id
      }
    }
    ... on ExportPaymentDataFailure {
      errors {
        message
        path
        code
      }
    }
  }
}
    `;

/**
 * __useExportPaymentDataMutation__
 *
 * To run a mutation, you first call `useExportPaymentDataMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useExportPaymentDataMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [exportPaymentDataMutation, { data, loading, error }] = useExportPaymentDataMutation({
 *   variables: {
 *      type: // value for 'type'
 *   },
 * });
 */
export function useExportPaymentDataMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<ExportPaymentDataMutation, ExportPaymentDataMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useMutation<ExportPaymentDataMutation, ExportPaymentDataMutationVariables>(ExportPaymentDataDocument, options);
      }
export type ExportPaymentDataMutationHookResult = ReturnType<typeof useExportPaymentDataMutation>;
export type ExportPaymentDataMutationResult = ApolloReactCommon.MutationResult<ExportPaymentDataMutation>;
export type ExportPaymentDataMutationOptions = ApolloReactCommon.BaseMutationOptions<ExportPaymentDataMutation, ExportPaymentDataMutationVariables>;
export const GetSettingsDataDocument = gql`
    query GetSettingsData {
  organization {
    id
    ...SettingsOrganization
  }
  contractor {
    id
    ...SettingsContractor
  }
}
    ${SettingsOrganizationFragmentDoc}
${SettingsContractorFragmentDoc}`;

/**
 * __useGetSettingsDataQuery__
 *
 * To run a query within a React component, call `useGetSettingsDataQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetSettingsDataQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetSettingsDataQuery({
 *   variables: {
 *   },
 * });
 */
export function useGetSettingsDataQuery(baseOptions?: ApolloReactHooks.QueryHookOptions<GetSettingsDataQuery, GetSettingsDataQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<GetSettingsDataQuery, GetSettingsDataQueryVariables>(GetSettingsDataDocument, options);
      }
export function useGetSettingsDataLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<GetSettingsDataQuery, GetSettingsDataQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<GetSettingsDataQuery, GetSettingsDataQueryVariables>(GetSettingsDataDocument, options);
        }
export type GetSettingsDataQueryHookResult = ReturnType<typeof useGetSettingsDataQuery>;
export type GetSettingsDataLazyQueryHookResult = ReturnType<typeof useGetSettingsDataLazyQuery>;
export type GetSettingsDataQueryResult = ApolloReactCommon.QueryResult<GetSettingsDataQuery, GetSettingsDataQueryVariables>;
export const UpdateOrganizationSettingsDocument = gql`
    mutation UpdateOrganizationSettings($attributes: OrganizationAttributes!) {
  upsertOrganization(attributes: $attributes) {
    ... on UpsertOrganizationSuccess {
      organization {
        id
        ...SettingsOrganization
      }
    }
    ... on UpsertOrganizationFailure {
      errors {
        message
        path
        code
      }
    }
  }
}
    ${SettingsOrganizationFragmentDoc}`;

/**
 * __useUpdateOrganizationSettingsMutation__
 *
 * To run a mutation, you first call `useUpdateOrganizationSettingsMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateOrganizationSettingsMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateOrganizationSettingsMutation, { data, loading, error }] = useUpdateOrganizationSettingsMutation({
 *   variables: {
 *      attributes: // value for 'attributes'
 *   },
 * });
 */
export function useUpdateOrganizationSettingsMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<UpdateOrganizationSettingsMutation, UpdateOrganizationSettingsMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useMutation<UpdateOrganizationSettingsMutation, UpdateOrganizationSettingsMutationVariables>(UpdateOrganizationSettingsDocument, options);
      }
export type UpdateOrganizationSettingsMutationHookResult = ReturnType<typeof useUpdateOrganizationSettingsMutation>;
export type UpdateOrganizationSettingsMutationResult = ApolloReactCommon.MutationResult<UpdateOrganizationSettingsMutation>;
export type UpdateOrganizationSettingsMutationOptions = ApolloReactCommon.BaseMutationOptions<UpdateOrganizationSettingsMutation, UpdateOrganizationSettingsMutationVariables>;
export const UpdateContractorSettingsDocument = gql`
    mutation UpdateContractorSettings($attributes: ContractorAttributes!) {
  upsertContractor(attributes: $attributes) {
    ... on UpsertContractorSuccess {
      contractor {
        id
        ...SettingsContractor
      }
    }
    ... on UpsertContractorFailure {
      errors {
        message
        path
        code
      }
    }
  }
}
    ${SettingsContractorFragmentDoc}`;

/**
 * __useUpdateContractorSettingsMutation__
 *
 * To run a mutation, you first call `useUpdateContractorSettingsMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateContractorSettingsMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateContractorSettingsMutation, { data, loading, error }] = useUpdateContractorSettingsMutation({
 *   variables: {
 *      attributes: // value for 'attributes'
 *   },
 * });
 */
export function useUpdateContractorSettingsMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<UpdateContractorSettingsMutation, UpdateContractorSettingsMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useMutation<UpdateContractorSettingsMutation, UpdateContractorSettingsMutationVariables>(UpdateContractorSettingsDocument, options);
      }
export type UpdateContractorSettingsMutationHookResult = ReturnType<typeof useUpdateContractorSettingsMutation>;
export type UpdateContractorSettingsMutationResult = ApolloReactCommon.MutationResult<UpdateContractorSettingsMutation>;
export type UpdateContractorSettingsMutationOptions = ApolloReactCommon.BaseMutationOptions<UpdateContractorSettingsMutation, UpdateContractorSettingsMutationVariables>;
export const SendResetPasswordLinkDocument = gql`
    mutation SendResetPasswordLink {
  sendResetPasswordLink {
    ... on SendResetPasswordLinkSuccess {
      contractor {
        id
      }
    }
    ... on SendResetPasswordLinkFailure {
      errors {
        message
        path
        code
      }
    }
  }
}
    `;

/**
 * __useSendResetPasswordLinkMutation__
 *
 * To run a mutation, you first call `useSendResetPasswordLinkMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useSendResetPasswordLinkMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [sendResetPasswordLinkMutation, { data, loading, error }] = useSendResetPasswordLinkMutation({
 *   variables: {
 *   },
 * });
 */
export function useSendResetPasswordLinkMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<SendResetPasswordLinkMutation, SendResetPasswordLinkMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useMutation<SendResetPasswordLinkMutation, SendResetPasswordLinkMutationVariables>(SendResetPasswordLinkDocument, options);
      }
export type SendResetPasswordLinkMutationHookResult = ReturnType<typeof useSendResetPasswordLinkMutation>;
export type SendResetPasswordLinkMutationResult = ApolloReactCommon.MutationResult<SendResetPasswordLinkMutation>;
export type SendResetPasswordLinkMutationOptions = ApolloReactCommon.BaseMutationOptions<SendResetPasswordLinkMutation, SendResetPasswordLinkMutationVariables>;
export const GenerateApiTokenDocument = gql`
    mutation GenerateApiToken {
  generateApiToken {
    ... on GenerateApiTokenSuccess {
      organization {
        id
        apiToken {
          id
          delimitedPlaintextKey
        }
      }
    }
    ... on GenerateApiTokenFailure {
      errors {
        message
        path
        code
      }
    }
  }
}
    `;

/**
 * __useGenerateApiTokenMutation__
 *
 * To run a mutation, you first call `useGenerateApiTokenMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useGenerateApiTokenMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [generateApiTokenMutation, { data, loading, error }] = useGenerateApiTokenMutation({
 *   variables: {
 *   },
 * });
 */
export function useGenerateApiTokenMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<GenerateApiTokenMutation, GenerateApiTokenMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useMutation<GenerateApiTokenMutation, GenerateApiTokenMutationVariables>(GenerateApiTokenDocument, options);
      }
export type GenerateApiTokenMutationHookResult = ReturnType<typeof useGenerateApiTokenMutation>;
export type GenerateApiTokenMutationResult = ApolloReactCommon.MutationResult<GenerateApiTokenMutation>;
export type GenerateApiTokenMutationOptions = ApolloReactCommon.BaseMutationOptions<GenerateApiTokenMutation, GenerateApiTokenMutationVariables>;
export const UpdateTemplateDocument = gql`
    mutation UpdateTemplate($templateId: ID!, $templateString: String!) {
  upsertTemplate(templateId: $templateId, templateString: $templateString) {
    ... on UpsertTemplateSuccess {
      template {
        id
        templateString
      }
    }
    ... on UpsertTemplateFailure {
      errors {
        message
        path
        code
      }
    }
  }
}
    `;

/**
 * __useUpdateTemplateMutation__
 *
 * To run a mutation, you first call `useUpdateTemplateMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateTemplateMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateTemplateMutation, { data, loading, error }] = useUpdateTemplateMutation({
 *   variables: {
 *      templateId: // value for 'templateId'
 *      templateString: // value for 'templateString'
 *   },
 * });
 */
export function useUpdateTemplateMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<UpdateTemplateMutation, UpdateTemplateMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useMutation<UpdateTemplateMutation, UpdateTemplateMutationVariables>(UpdateTemplateDocument, options);
      }
export type UpdateTemplateMutationHookResult = ReturnType<typeof useUpdateTemplateMutation>;
export type UpdateTemplateMutationResult = ApolloReactCommon.MutationResult<UpdateTemplateMutation>;
export type UpdateTemplateMutationOptions = ApolloReactCommon.BaseMutationOptions<UpdateTemplateMutation, UpdateTemplateMutationVariables>;
export const CreateLoanInquiryFromExistingDocument = gql`
    mutation CreateLoanInquiryFromExisting($loanInquiryUuid: String!, $terms: Boolean!, $termsString: String!, $loanPrincipal: Int!) {
  createLoanInquiryFromExisting(
    loanInquiryUuid: $loanInquiryUuid
    terms: $terms
    termsString: $termsString
    loanPrincipal: $loanPrincipal
  ) {
    ... on CreateLoanInquiryFromExistingSuccess {
      loanInquiry {
        id
        state
      }
    }
    ... on CreateLoanInquiryFromExistingFailure {
      errors {
        code
        message
      }
    }
  }
}
    `;

/**
 * __useCreateLoanInquiryFromExistingMutation__
 *
 * To run a mutation, you first call `useCreateLoanInquiryFromExistingMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateLoanInquiryFromExistingMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createLoanInquiryFromExistingMutation, { data, loading, error }] = useCreateLoanInquiryFromExistingMutation({
 *   variables: {
 *      loanInquiryUuid: // value for 'loanInquiryUuid'
 *      terms: // value for 'terms'
 *      termsString: // value for 'termsString'
 *      loanPrincipal: // value for 'loanPrincipal'
 *   },
 * });
 */
export function useCreateLoanInquiryFromExistingMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<CreateLoanInquiryFromExistingMutation, CreateLoanInquiryFromExistingMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useMutation<CreateLoanInquiryFromExistingMutation, CreateLoanInquiryFromExistingMutationVariables>(CreateLoanInquiryFromExistingDocument, options);
      }
export type CreateLoanInquiryFromExistingMutationHookResult = ReturnType<typeof useCreateLoanInquiryFromExistingMutation>;
export type CreateLoanInquiryFromExistingMutationResult = ApolloReactCommon.MutationResult<CreateLoanInquiryFromExistingMutation>;
export type CreateLoanInquiryFromExistingMutationOptions = ApolloReactCommon.BaseMutationOptions<CreateLoanInquiryFromExistingMutation, CreateLoanInquiryFromExistingMutationVariables>;
export const CreateAndSubmitLoanInquiryFromExistingDocument = gql`
    mutation CreateAndSubmitLoanInquiryFromExisting($loanInquiryUuid: String!, $terms: Boolean!, $termsString: String!, $loanPrincipal: Int!) {
  createLoanInquiryFromExisting(
    loanInquiryUuid: $loanInquiryUuid
    terms: $terms
    termsString: $termsString
    loanPrincipal: $loanPrincipal
    submit: true
  ) {
    ... on CreateLoanInquiryFromExistingSuccess {
      loanInquiry {
        id
      }
    }
    ... on CreateLoanInquiryFromExistingFailure {
      errors {
        code
        message
      }
    }
  }
}
    `;

/**
 * __useCreateAndSubmitLoanInquiryFromExistingMutation__
 *
 * To run a mutation, you first call `useCreateAndSubmitLoanInquiryFromExistingMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateAndSubmitLoanInquiryFromExistingMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createAndSubmitLoanInquiryFromExistingMutation, { data, loading, error }] = useCreateAndSubmitLoanInquiryFromExistingMutation({
 *   variables: {
 *      loanInquiryUuid: // value for 'loanInquiryUuid'
 *      terms: // value for 'terms'
 *      termsString: // value for 'termsString'
 *      loanPrincipal: // value for 'loanPrincipal'
 *   },
 * });
 */
export function useCreateAndSubmitLoanInquiryFromExistingMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<CreateAndSubmitLoanInquiryFromExistingMutation, CreateAndSubmitLoanInquiryFromExistingMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useMutation<CreateAndSubmitLoanInquiryFromExistingMutation, CreateAndSubmitLoanInquiryFromExistingMutationVariables>(CreateAndSubmitLoanInquiryFromExistingDocument, options);
      }
export type CreateAndSubmitLoanInquiryFromExistingMutationHookResult = ReturnType<typeof useCreateAndSubmitLoanInquiryFromExistingMutation>;
export type CreateAndSubmitLoanInquiryFromExistingMutationResult = ApolloReactCommon.MutationResult<CreateAndSubmitLoanInquiryFromExistingMutation>;
export type CreateAndSubmitLoanInquiryFromExistingMutationOptions = ApolloReactCommon.BaseMutationOptions<CreateAndSubmitLoanInquiryFromExistingMutation, CreateAndSubmitLoanInquiryFromExistingMutationVariables>;
export const GetOffersDocument = gql`
    query GetOffers($id: String!) {
  loanInquiry(loanInquiryUuid: $id) {
    id
    minOffer
    maxOffer
    fico
    jointApplication
    loanPrincipal
    requestedAmount
    householdIncome
    zeroPercentCards
    monthlyPaymentMin
    monthlyPaymentMax
    recommendedLoanAmount
    rateCap
    homeowner {
      id
      firstName
    }
    organization {
      id
      featureFlags {
        id
      }
      planFeatureFlags {
        id
      }
    }
    offers {
      nodes {
        id
        ...OfferDetails
      }
    }
  }
}
    ${OfferDetailsFragmentDoc}`;

/**
 * __useGetOffersQuery__
 *
 * To run a query within a React component, call `useGetOffersQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetOffersQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetOffersQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useGetOffersQuery(baseOptions: ApolloReactHooks.QueryHookOptions<GetOffersQuery, GetOffersQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<GetOffersQuery, GetOffersQueryVariables>(GetOffersDocument, options);
      }
export function useGetOffersLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<GetOffersQuery, GetOffersQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<GetOffersQuery, GetOffersQueryVariables>(GetOffersDocument, options);
        }
export type GetOffersQueryHookResult = ReturnType<typeof useGetOffersQuery>;
export type GetOffersLazyQueryHookResult = ReturnType<typeof useGetOffersLazyQuery>;
export type GetOffersQueryResult = ApolloReactCommon.QueryResult<GetOffersQuery, GetOffersQueryVariables>;
export const GetPaymentProofDataDocument = gql`
    query getPaymentProofData($ficoBucket: String!, $loanPrincipal: Float!) {
  monthlyPaymentCalculation(
    ficoBucket: $ficoBucket
    loanPrincipal: $loanPrincipal
  ) {
    nodes {
      id
      ...PaymentProof
    }
  }
}
    ${PaymentProofFragmentDoc}`;

/**
 * __useGetPaymentProofDataQuery__
 *
 * To run a query within a React component, call `useGetPaymentProofDataQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetPaymentProofDataQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetPaymentProofDataQuery({
 *   variables: {
 *      ficoBucket: // value for 'ficoBucket'
 *      loanPrincipal: // value for 'loanPrincipal'
 *   },
 * });
 */
export function useGetPaymentProofDataQuery(baseOptions: ApolloReactHooks.QueryHookOptions<GetPaymentProofDataQuery, GetPaymentProofDataQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<GetPaymentProofDataQuery, GetPaymentProofDataQueryVariables>(GetPaymentProofDataDocument, options);
      }
export function useGetPaymentProofDataLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<GetPaymentProofDataQuery, GetPaymentProofDataQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<GetPaymentProofDataQuery, GetPaymentProofDataQueryVariables>(GetPaymentProofDataDocument, options);
        }
export type GetPaymentProofDataQueryHookResult = ReturnType<typeof useGetPaymentProofDataQuery>;
export type GetPaymentProofDataLazyQueryHookResult = ReturnType<typeof useGetPaymentProofDataLazyQuery>;
export type GetPaymentProofDataQueryResult = ApolloReactCommon.QueryResult<GetPaymentProofDataQuery, GetPaymentProofDataQueryVariables>;
export const GetTeamDataDocument = gql`
    query GetTeamData {
  organization {
    id
    ...TeamOrganization
  }
  contractor {
    id
    paymentsRole
  }
}
    ${TeamOrganizationFragmentDoc}`;

/**
 * __useGetTeamDataQuery__
 *
 * To run a query within a React component, call `useGetTeamDataQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetTeamDataQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetTeamDataQuery({
 *   variables: {
 *   },
 * });
 */
export function useGetTeamDataQuery(baseOptions?: ApolloReactHooks.QueryHookOptions<GetTeamDataQuery, GetTeamDataQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<GetTeamDataQuery, GetTeamDataQueryVariables>(GetTeamDataDocument, options);
      }
export function useGetTeamDataLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<GetTeamDataQuery, GetTeamDataQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<GetTeamDataQuery, GetTeamDataQueryVariables>(GetTeamDataDocument, options);
        }
export type GetTeamDataQueryHookResult = ReturnType<typeof useGetTeamDataQuery>;
export type GetTeamDataLazyQueryHookResult = ReturnType<typeof useGetTeamDataLazyQuery>;
export type GetTeamDataQueryResult = ApolloReactCommon.QueryResult<GetTeamDataQuery, GetTeamDataQueryVariables>;
export const SendMemberInvitesDocument = gql`
    mutation SendMemberInvites($emails: [String!]!) {
  sendMemberInvites(emails: $emails) {
    ... on SendMemberInvitesSuccess {
      organization {
        id
        ...TeamOrganization
      }
    }
    ... on SendMemberInvitesFailure {
      errors {
        message
        path
        code
      }
    }
  }
}
    ${TeamOrganizationFragmentDoc}`;

/**
 * __useSendMemberInvitesMutation__
 *
 * To run a mutation, you first call `useSendMemberInvitesMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useSendMemberInvitesMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [sendMemberInvitesMutation, { data, loading, error }] = useSendMemberInvitesMutation({
 *   variables: {
 *      emails: // value for 'emails'
 *   },
 * });
 */
export function useSendMemberInvitesMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<SendMemberInvitesMutation, SendMemberInvitesMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useMutation<SendMemberInvitesMutation, SendMemberInvitesMutationVariables>(SendMemberInvitesDocument, options);
      }
export type SendMemberInvitesMutationHookResult = ReturnType<typeof useSendMemberInvitesMutation>;
export type SendMemberInvitesMutationResult = ApolloReactCommon.MutationResult<SendMemberInvitesMutation>;
export type SendMemberInvitesMutationOptions = ApolloReactCommon.BaseMutationOptions<SendMemberInvitesMutation, SendMemberInvitesMutationVariables>;
export const ResendMemberInviteEmailDocument = gql`
    mutation ResendMemberInviteEmail($memberInviteId: ID!) {
  resendMemberInviteEmail(memberInviteId: $memberInviteId) {
    ... on ResendMemberInviteEmailSuccess {
      memberInvite {
        id
      }
    }
    ... on ResendMemberInviteEmailFailure {
      errors {
        message
        path
        code
      }
    }
  }
}
    `;

/**
 * __useResendMemberInviteEmailMutation__
 *
 * To run a mutation, you first call `useResendMemberInviteEmailMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useResendMemberInviteEmailMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [resendMemberInviteEmailMutation, { data, loading, error }] = useResendMemberInviteEmailMutation({
 *   variables: {
 *      memberInviteId: // value for 'memberInviteId'
 *   },
 * });
 */
export function useResendMemberInviteEmailMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<ResendMemberInviteEmailMutation, ResendMemberInviteEmailMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useMutation<ResendMemberInviteEmailMutation, ResendMemberInviteEmailMutationVariables>(ResendMemberInviteEmailDocument, options);
      }
export type ResendMemberInviteEmailMutationHookResult = ReturnType<typeof useResendMemberInviteEmailMutation>;
export type ResendMemberInviteEmailMutationResult = ApolloReactCommon.MutationResult<ResendMemberInviteEmailMutation>;
export type ResendMemberInviteEmailMutationOptions = ApolloReactCommon.BaseMutationOptions<ResendMemberInviteEmailMutation, ResendMemberInviteEmailMutationVariables>;
export const DeactivateContractorDocument = gql`
    mutation DeactivateContractor($contractorId: ID!) {
  deactivateContractor(contractorId: $contractorId) {
    ... on DeactivateContractorSuccess {
      organization {
        id
        ...TeamOrganization
      }
    }
    ... on DeactivateContractorFailure {
      errors {
        message
        path
        code
      }
    }
  }
}
    ${TeamOrganizationFragmentDoc}`;

/**
 * __useDeactivateContractorMutation__
 *
 * To run a mutation, you first call `useDeactivateContractorMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeactivateContractorMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deactivateContractorMutation, { data, loading, error }] = useDeactivateContractorMutation({
 *   variables: {
 *      contractorId: // value for 'contractorId'
 *   },
 * });
 */
export function useDeactivateContractorMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<DeactivateContractorMutation, DeactivateContractorMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useMutation<DeactivateContractorMutation, DeactivateContractorMutationVariables>(DeactivateContractorDocument, options);
      }
export type DeactivateContractorMutationHookResult = ReturnType<typeof useDeactivateContractorMutation>;
export type DeactivateContractorMutationResult = ApolloReactCommon.MutationResult<DeactivateContractorMutation>;
export type DeactivateContractorMutationOptions = ApolloReactCommon.BaseMutationOptions<DeactivateContractorMutation, DeactivateContractorMutationVariables>;
export const UpdateContractorTeamDocument = gql`
    mutation UpdateContractorTeam($contractorId: ID!, $attributes: ContractorAttributes!) {
  upsertContractor(contractorId: $contractorId, attributes: $attributes) {
    ... on UpsertContractorSuccess {
      contractor {
        id
        ...TeamContractor
      }
    }
    ... on UpsertContractorFailure {
      errors {
        message
        path
        code
      }
    }
  }
}
    ${TeamContractorFragmentDoc}`;

/**
 * __useUpdateContractorTeamMutation__
 *
 * To run a mutation, you first call `useUpdateContractorTeamMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateContractorTeamMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateContractorTeamMutation, { data, loading, error }] = useUpdateContractorTeamMutation({
 *   variables: {
 *      contractorId: // value for 'contractorId'
 *      attributes: // value for 'attributes'
 *   },
 * });
 */
export function useUpdateContractorTeamMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<UpdateContractorTeamMutation, UpdateContractorTeamMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useMutation<UpdateContractorTeamMutation, UpdateContractorTeamMutationVariables>(UpdateContractorTeamDocument, options);
      }
export type UpdateContractorTeamMutationHookResult = ReturnType<typeof useUpdateContractorTeamMutation>;
export type UpdateContractorTeamMutationResult = ApolloReactCommon.MutationResult<UpdateContractorTeamMutation>;
export type UpdateContractorTeamMutationOptions = ApolloReactCommon.BaseMutationOptions<UpdateContractorTeamMutation, UpdateContractorTeamMutationVariables>;
export const CheckTermsAcceptanceDocument = gql`
    query CheckTermsAcceptance {
  organization {
    id
    contractServiceAccount {
      id
      termsAgreedAt
    }
  }
}
    `;

/**
 * __useCheckTermsAcceptanceQuery__
 *
 * To run a query within a React component, call `useCheckTermsAcceptanceQuery` and pass it any options that fit your needs.
 * When your component renders, `useCheckTermsAcceptanceQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useCheckTermsAcceptanceQuery({
 *   variables: {
 *   },
 * });
 */
export function useCheckTermsAcceptanceQuery(baseOptions?: ApolloReactHooks.QueryHookOptions<CheckTermsAcceptanceQuery, CheckTermsAcceptanceQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<CheckTermsAcceptanceQuery, CheckTermsAcceptanceQueryVariables>(CheckTermsAcceptanceDocument, options);
      }
export function useCheckTermsAcceptanceLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<CheckTermsAcceptanceQuery, CheckTermsAcceptanceQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<CheckTermsAcceptanceQuery, CheckTermsAcceptanceQueryVariables>(CheckTermsAcceptanceDocument, options);
        }
export type CheckTermsAcceptanceQueryHookResult = ReturnType<typeof useCheckTermsAcceptanceQuery>;
export type CheckTermsAcceptanceLazyQueryHookResult = ReturnType<typeof useCheckTermsAcceptanceLazyQuery>;
export type CheckTermsAcceptanceQueryResult = ApolloReactCommon.QueryResult<CheckTermsAcceptanceQuery, CheckTermsAcceptanceQueryVariables>;
export const UpdateOrganizationWebsitesInfoDocument = gql`
    mutation UpdateOrganizationWebsitesInfo($attributes: OrganizationAttributes!) {
  upsertOrganization(attributes: $attributes) {
    ... on UpsertOrganizationSuccess {
      organization {
        id
        descriptionOfOperations
        backgroundPicture
      }
    }
    ... on UpsertOrganizationFailure {
      errors {
        message
        path
        code
      }
    }
  }
}
    `;

/**
 * __useUpdateOrganizationWebsitesInfoMutation__
 *
 * To run a mutation, you first call `useUpdateOrganizationWebsitesInfoMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateOrganizationWebsitesInfoMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateOrganizationWebsitesInfoMutation, { data, loading, error }] = useUpdateOrganizationWebsitesInfoMutation({
 *   variables: {
 *      attributes: // value for 'attributes'
 *   },
 * });
 */
export function useUpdateOrganizationWebsitesInfoMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<UpdateOrganizationWebsitesInfoMutation, UpdateOrganizationWebsitesInfoMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useMutation<UpdateOrganizationWebsitesInfoMutation, UpdateOrganizationWebsitesInfoMutationVariables>(UpdateOrganizationWebsitesInfoDocument, options);
      }
export type UpdateOrganizationWebsitesInfoMutationHookResult = ReturnType<typeof useUpdateOrganizationWebsitesInfoMutation>;
export type UpdateOrganizationWebsitesInfoMutationResult = ApolloReactCommon.MutationResult<UpdateOrganizationWebsitesInfoMutation>;
export type UpdateOrganizationWebsitesInfoMutationOptions = ApolloReactCommon.BaseMutationOptions<UpdateOrganizationWebsitesInfoMutation, UpdateOrganizationWebsitesInfoMutationVariables>;
export const GetToolsDataDocument = gql`
    query GetToolsData {
  contractor {
    id
    email
    admin
    activeCustomizedInvoiceTemplate {
      id
      createdAt
    }
    sendFinancingLinkTemplate {
      id
      templateString
    }
    signatureTemplate {
      id
      templateString
    }
  }
  organization {
    id
    contractServiceAccount {
      id
      termsAgreedAt
    }
  }
}
    `;

/**
 * __useGetToolsDataQuery__
 *
 * To run a query within a React component, call `useGetToolsDataQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetToolsDataQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetToolsDataQuery({
 *   variables: {
 *   },
 * });
 */
export function useGetToolsDataQuery(baseOptions?: ApolloReactHooks.QueryHookOptions<GetToolsDataQuery, GetToolsDataQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<GetToolsDataQuery, GetToolsDataQueryVariables>(GetToolsDataDocument, options);
      }
export function useGetToolsDataLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<GetToolsDataQuery, GetToolsDataQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<GetToolsDataQuery, GetToolsDataQueryVariables>(GetToolsDataDocument, options);
        }
export type GetToolsDataQueryHookResult = ReturnType<typeof useGetToolsDataQuery>;
export type GetToolsDataLazyQueryHookResult = ReturnType<typeof useGetToolsDataLazyQuery>;
export type GetToolsDataQueryResult = ApolloReactCommon.QueryResult<GetToolsDataQuery, GetToolsDataQueryVariables>;
export const GetFinancingContractorDocument = gql`
    query GetFinancingContractor {
  contractor {
    id
  }
}
    `;

/**
 * __useGetFinancingContractorQuery__
 *
 * To run a query within a React component, call `useGetFinancingContractorQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetFinancingContractorQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetFinancingContractorQuery({
 *   variables: {
 *   },
 * });
 */
export function useGetFinancingContractorQuery(baseOptions?: ApolloReactHooks.QueryHookOptions<GetFinancingContractorQuery, GetFinancingContractorQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<GetFinancingContractorQuery, GetFinancingContractorQueryVariables>(GetFinancingContractorDocument, options);
      }
export function useGetFinancingContractorLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<GetFinancingContractorQuery, GetFinancingContractorQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<GetFinancingContractorQuery, GetFinancingContractorQueryVariables>(GetFinancingContractorDocument, options);
        }
export type GetFinancingContractorQueryHookResult = ReturnType<typeof useGetFinancingContractorQuery>;
export type GetFinancingContractorLazyQueryHookResult = ReturnType<typeof useGetFinancingContractorLazyQuery>;
export type GetFinancingContractorQueryResult = ApolloReactCommon.QueryResult<GetFinancingContractorQuery, GetFinancingContractorQueryVariables>;
export const GetFinancingClientsDocument = gql`
    query GetFinancingClients($admin: Boolean, $type: HomeownerEventBucket, $orderBy: HomeownerOrderers, $searchTerm: String, $afterCursor: String) {
  homeownerSearch(
    admin: $admin
    type: $type
    orderBy: $orderBy
    first: 20
    searchTerm: $searchTerm
    after: $afterCursor
  ) {
    edges {
      node {
        id
        contractor {
          id
        }
        ...WorkflowsClient
      }
    }
    pageInfo {
      startCursor
      endCursor
      hasNextPage
      hasPreviousPage
    }
    totalCount
  }
}
    ${WorkflowsClientFragmentDoc}`;

/**
 * __useGetFinancingClientsQuery__
 *
 * To run a query within a React component, call `useGetFinancingClientsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetFinancingClientsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetFinancingClientsQuery({
 *   variables: {
 *      admin: // value for 'admin'
 *      type: // value for 'type'
 *      orderBy: // value for 'orderBy'
 *      searchTerm: // value for 'searchTerm'
 *      afterCursor: // value for 'afterCursor'
 *   },
 * });
 */
export function useGetFinancingClientsQuery(baseOptions?: ApolloReactHooks.QueryHookOptions<GetFinancingClientsQuery, GetFinancingClientsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<GetFinancingClientsQuery, GetFinancingClientsQueryVariables>(GetFinancingClientsDocument, options);
      }
export function useGetFinancingClientsLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<GetFinancingClientsQuery, GetFinancingClientsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<GetFinancingClientsQuery, GetFinancingClientsQueryVariables>(GetFinancingClientsDocument, options);
        }
export type GetFinancingClientsQueryHookResult = ReturnType<typeof useGetFinancingClientsQuery>;
export type GetFinancingClientsLazyQueryHookResult = ReturnType<typeof useGetFinancingClientsLazyQuery>;
export type GetFinancingClientsQueryResult = ApolloReactCommon.QueryResult<GetFinancingClientsQuery, GetFinancingClientsQueryVariables>;
export const GetWorkflowsContainerDocument = gql`
    query GetWorkflowsContainer {
  contractor {
    id
    demoMode
  }
}
    `;

/**
 * __useGetWorkflowsContainerQuery__
 *
 * To run a query within a React component, call `useGetWorkflowsContainerQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetWorkflowsContainerQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetWorkflowsContainerQuery({
 *   variables: {
 *   },
 * });
 */
export function useGetWorkflowsContainerQuery(baseOptions?: ApolloReactHooks.QueryHookOptions<GetWorkflowsContainerQuery, GetWorkflowsContainerQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<GetWorkflowsContainerQuery, GetWorkflowsContainerQueryVariables>(GetWorkflowsContainerDocument, options);
      }
export function useGetWorkflowsContainerLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<GetWorkflowsContainerQuery, GetWorkflowsContainerQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<GetWorkflowsContainerQuery, GetWorkflowsContainerQueryVariables>(GetWorkflowsContainerDocument, options);
        }
export type GetWorkflowsContainerQueryHookResult = ReturnType<typeof useGetWorkflowsContainerQuery>;
export type GetWorkflowsContainerLazyQueryHookResult = ReturnType<typeof useGetWorkflowsContainerLazyQuery>;
export type GetWorkflowsContainerQueryResult = ApolloReactCommon.QueryResult<GetWorkflowsContainerQuery, GetWorkflowsContainerQueryVariables>;
export const WorkflowEmptyStateDocument = gql`
    query WorkflowEmptyState {
  organization {
    id
    stripeConnectAccount {
      id
      status
      fullAccess
    }
  }
  contractor {
    id
    role
    paymentsRole
    trainingCompleted
  }
}
    `;

/**
 * __useWorkflowEmptyStateQuery__
 *
 * To run a query within a React component, call `useWorkflowEmptyStateQuery` and pass it any options that fit your needs.
 * When your component renders, `useWorkflowEmptyStateQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useWorkflowEmptyStateQuery({
 *   variables: {
 *   },
 * });
 */
export function useWorkflowEmptyStateQuery(baseOptions?: ApolloReactHooks.QueryHookOptions<WorkflowEmptyStateQuery, WorkflowEmptyStateQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<WorkflowEmptyStateQuery, WorkflowEmptyStateQueryVariables>(WorkflowEmptyStateDocument, options);
      }
export function useWorkflowEmptyStateLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<WorkflowEmptyStateQuery, WorkflowEmptyStateQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<WorkflowEmptyStateQuery, WorkflowEmptyStateQueryVariables>(WorkflowEmptyStateDocument, options);
        }
export type WorkflowEmptyStateQueryHookResult = ReturnType<typeof useWorkflowEmptyStateQuery>;
export type WorkflowEmptyStateLazyQueryHookResult = ReturnType<typeof useWorkflowEmptyStateLazyQuery>;
export type WorkflowEmptyStateQueryResult = ApolloReactCommon.QueryResult<WorkflowEmptyStateQuery, WorkflowEmptyStateQueryVariables>;
export const GetWorkflowsDataDocument = gql`
    query GetWorkflowsData {
  contractor {
    id
    admin
  }
  organization {
    id
    contractServiceAccount {
      id
      termsAgreedAt
      contracts {
        nodes {
          id
          ...ClientViewContractIndex
        }
      }
    }
  }
}
    ${ClientViewContractIndexFragmentDoc}`;

/**
 * __useGetWorkflowsDataQuery__
 *
 * To run a query within a React component, call `useGetWorkflowsDataQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetWorkflowsDataQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetWorkflowsDataQuery({
 *   variables: {
 *   },
 * });
 */
export function useGetWorkflowsDataQuery(baseOptions?: ApolloReactHooks.QueryHookOptions<GetWorkflowsDataQuery, GetWorkflowsDataQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<GetWorkflowsDataQuery, GetWorkflowsDataQueryVariables>(GetWorkflowsDataDocument, options);
      }
export function useGetWorkflowsDataLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<GetWorkflowsDataQuery, GetWorkflowsDataQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<GetWorkflowsDataQuery, GetWorkflowsDataQueryVariables>(GetWorkflowsDataDocument, options);
        }
export type GetWorkflowsDataQueryHookResult = ReturnType<typeof useGetWorkflowsDataQuery>;
export type GetWorkflowsDataLazyQueryHookResult = ReturnType<typeof useGetWorkflowsDataLazyQuery>;
export type GetWorkflowsDataQueryResult = ApolloReactCommon.QueryResult<GetWorkflowsDataQuery, GetWorkflowsDataQueryVariables>;
export const GetStartedCustomizedInvoiceTemplateInfoDocument = gql`
    query GetStartedCustomizedInvoiceTemplateInfo {
  contractor {
    id
    ...GetStartedContractorTemplateInfo
  }
  organization {
    id
    ...GetStartedOrganizationTemplateInfo
  }
}
    ${GetStartedContractorTemplateInfoFragmentDoc}
${GetStartedOrganizationTemplateInfoFragmentDoc}`;

/**
 * __useGetStartedCustomizedInvoiceTemplateInfoQuery__
 *
 * To run a query within a React component, call `useGetStartedCustomizedInvoiceTemplateInfoQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetStartedCustomizedInvoiceTemplateInfoQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetStartedCustomizedInvoiceTemplateInfoQuery({
 *   variables: {
 *   },
 * });
 */
export function useGetStartedCustomizedInvoiceTemplateInfoQuery(baseOptions?: ApolloReactHooks.QueryHookOptions<GetStartedCustomizedInvoiceTemplateInfoQuery, GetStartedCustomizedInvoiceTemplateInfoQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<GetStartedCustomizedInvoiceTemplateInfoQuery, GetStartedCustomizedInvoiceTemplateInfoQueryVariables>(GetStartedCustomizedInvoiceTemplateInfoDocument, options);
      }
export function useGetStartedCustomizedInvoiceTemplateInfoLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<GetStartedCustomizedInvoiceTemplateInfoQuery, GetStartedCustomizedInvoiceTemplateInfoQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<GetStartedCustomizedInvoiceTemplateInfoQuery, GetStartedCustomizedInvoiceTemplateInfoQueryVariables>(GetStartedCustomizedInvoiceTemplateInfoDocument, options);
        }
export type GetStartedCustomizedInvoiceTemplateInfoQueryHookResult = ReturnType<typeof useGetStartedCustomizedInvoiceTemplateInfoQuery>;
export type GetStartedCustomizedInvoiceTemplateInfoLazyQueryHookResult = ReturnType<typeof useGetStartedCustomizedInvoiceTemplateInfoLazyQuery>;
export type GetStartedCustomizedInvoiceTemplateInfoQueryResult = ApolloReactCommon.QueryResult<GetStartedCustomizedInvoiceTemplateInfoQuery, GetStartedCustomizedInvoiceTemplateInfoQueryVariables>;
export const GetStartedCreateInvoiceTemplateDocument = gql`
    mutation GetStartedCreateInvoiceTemplate($attributes: CustomizedInvoiceTemplateAttributes!) {
  upsertCustomizedInvoiceTemplate(templateAttributes: $attributes) {
    ... on UpsertCustomizedInvoiceTemplateSuccess {
      invoiceTemplate {
        id
        ...GetStartedInvoiceCustomizationSettings
      }
    }
    ... on UpsertCustomizedInvoiceTemplateFailure {
      errors {
        message
        path
        code
      }
    }
  }
}
    ${GetStartedInvoiceCustomizationSettingsFragmentDoc}`;

/**
 * __useGetStartedCreateInvoiceTemplateMutation__
 *
 * To run a mutation, you first call `useGetStartedCreateInvoiceTemplateMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useGetStartedCreateInvoiceTemplateMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [getStartedCreateInvoiceTemplateMutation, { data, loading, error }] = useGetStartedCreateInvoiceTemplateMutation({
 *   variables: {
 *      attributes: // value for 'attributes'
 *   },
 * });
 */
export function useGetStartedCreateInvoiceTemplateMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<GetStartedCreateInvoiceTemplateMutation, GetStartedCreateInvoiceTemplateMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useMutation<GetStartedCreateInvoiceTemplateMutation, GetStartedCreateInvoiceTemplateMutationVariables>(GetStartedCreateInvoiceTemplateDocument, options);
      }
export type GetStartedCreateInvoiceTemplateMutationHookResult = ReturnType<typeof useGetStartedCreateInvoiceTemplateMutation>;
export type GetStartedCreateInvoiceTemplateMutationResult = ApolloReactCommon.MutationResult<GetStartedCreateInvoiceTemplateMutation>;
export type GetStartedCreateInvoiceTemplateMutationOptions = ApolloReactCommon.BaseMutationOptions<GetStartedCreateInvoiceTemplateMutation, GetStartedCreateInvoiceTemplateMutationVariables>;
export const GetGetStartedDataDocument = gql`
    query GetGetStartedData {
  contractor {
    id
    ...GetStartedContractor
  }
  organization {
    id
    ...GetStartedOrganization
  }
}
    ${GetStartedContractorFragmentDoc}
${GetStartedOrganizationFragmentDoc}`;

/**
 * __useGetGetStartedDataQuery__
 *
 * To run a query within a React component, call `useGetGetStartedDataQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetGetStartedDataQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetGetStartedDataQuery({
 *   variables: {
 *   },
 * });
 */
export function useGetGetStartedDataQuery(baseOptions?: ApolloReactHooks.QueryHookOptions<GetGetStartedDataQuery, GetGetStartedDataQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<GetGetStartedDataQuery, GetGetStartedDataQueryVariables>(GetGetStartedDataDocument, options);
      }
export function useGetGetStartedDataLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<GetGetStartedDataQuery, GetGetStartedDataQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<GetGetStartedDataQuery, GetGetStartedDataQueryVariables>(GetGetStartedDataDocument, options);
        }
export type GetGetStartedDataQueryHookResult = ReturnType<typeof useGetGetStartedDataQuery>;
export type GetGetStartedDataLazyQueryHookResult = ReturnType<typeof useGetGetStartedDataLazyQuery>;
export type GetGetStartedDataQueryResult = ApolloReactCommon.QueryResult<GetGetStartedDataQuery, GetGetStartedDataQueryVariables>;
export const GetQuickActionsMenuDataDocument = gql`
    query GetQuickActionsMenuData {
  contractor {
    id
    ...QuickActionsContractorData
  }
  organization {
    id
    ...QuickActionsOrganizationData
  }
}
    ${QuickActionsContractorDataFragmentDoc}
${QuickActionsOrganizationDataFragmentDoc}`;

/**
 * __useGetQuickActionsMenuDataQuery__
 *
 * To run a query within a React component, call `useGetQuickActionsMenuDataQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetQuickActionsMenuDataQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetQuickActionsMenuDataQuery({
 *   variables: {
 *   },
 * });
 */
export function useGetQuickActionsMenuDataQuery(baseOptions?: ApolloReactHooks.QueryHookOptions<GetQuickActionsMenuDataQuery, GetQuickActionsMenuDataQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<GetQuickActionsMenuDataQuery, GetQuickActionsMenuDataQueryVariables>(GetQuickActionsMenuDataDocument, options);
      }
export function useGetQuickActionsMenuDataLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<GetQuickActionsMenuDataQuery, GetQuickActionsMenuDataQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<GetQuickActionsMenuDataQuery, GetQuickActionsMenuDataQueryVariables>(GetQuickActionsMenuDataDocument, options);
        }
export type GetQuickActionsMenuDataQueryHookResult = ReturnType<typeof useGetQuickActionsMenuDataQuery>;
export type GetQuickActionsMenuDataLazyQueryHookResult = ReturnType<typeof useGetQuickActionsMenuDataLazyQuery>;
export type GetQuickActionsMenuDataQueryResult = ApolloReactCommon.QueryResult<GetQuickActionsMenuDataQuery, GetQuickActionsMenuDataQueryVariables>;
export const GetHomeownerQuoteViewDataDocument = gql`
    query GetHomeownerQuoteViewData($quoteId: ID!) {
  quote(id: $quoteId) {
    id
    ...HomeownerQuoteViewQuote
  }
}
    ${HomeownerQuoteViewQuoteFragmentDoc}`;

/**
 * __useGetHomeownerQuoteViewDataQuery__
 *
 * To run a query within a React component, call `useGetHomeownerQuoteViewDataQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetHomeownerQuoteViewDataQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetHomeownerQuoteViewDataQuery({
 *   variables: {
 *      quoteId: // value for 'quoteId'
 *   },
 * });
 */
export function useGetHomeownerQuoteViewDataQuery(baseOptions: ApolloReactHooks.QueryHookOptions<GetHomeownerQuoteViewDataQuery, GetHomeownerQuoteViewDataQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<GetHomeownerQuoteViewDataQuery, GetHomeownerQuoteViewDataQueryVariables>(GetHomeownerQuoteViewDataDocument, options);
      }
export function useGetHomeownerQuoteViewDataLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<GetHomeownerQuoteViewDataQuery, GetHomeownerQuoteViewDataQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<GetHomeownerQuoteViewDataQuery, GetHomeownerQuoteViewDataQueryVariables>(GetHomeownerQuoteViewDataDocument, options);
        }
export type GetHomeownerQuoteViewDataQueryHookResult = ReturnType<typeof useGetHomeownerQuoteViewDataQuery>;
export type GetHomeownerQuoteViewDataLazyQueryHookResult = ReturnType<typeof useGetHomeownerQuoteViewDataLazyQuery>;
export type GetHomeownerQuoteViewDataQueryResult = ApolloReactCommon.QueryResult<GetHomeownerQuoteViewDataQuery, GetHomeownerQuoteViewDataQueryVariables>;
export const AcceptHomeownerQuoteDocument = gql`
    mutation AcceptHomeownerQuote($id: ID!) {
  quoteHomeownerAccept(quoteId: $id) {
    ... on QuoteHomeownerAcceptSuccess {
      quote {
        id
        ...HomeownerQuoteViewQuote
      }
    }
    ... on QuoteHomeownerAcceptFailure {
      errors {
        message
        path
        code
      }
    }
  }
}
    ${HomeownerQuoteViewQuoteFragmentDoc}`;

/**
 * __useAcceptHomeownerQuoteMutation__
 *
 * To run a mutation, you first call `useAcceptHomeownerQuoteMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useAcceptHomeownerQuoteMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [acceptHomeownerQuoteMutation, { data, loading, error }] = useAcceptHomeownerQuoteMutation({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useAcceptHomeownerQuoteMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<AcceptHomeownerQuoteMutation, AcceptHomeownerQuoteMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useMutation<AcceptHomeownerQuoteMutation, AcceptHomeownerQuoteMutationVariables>(AcceptHomeownerQuoteDocument, options);
      }
export type AcceptHomeownerQuoteMutationHookResult = ReturnType<typeof useAcceptHomeownerQuoteMutation>;
export type AcceptHomeownerQuoteMutationResult = ApolloReactCommon.MutationResult<AcceptHomeownerQuoteMutation>;
export type AcceptHomeownerQuoteMutationOptions = ApolloReactCommon.BaseMutationOptions<AcceptHomeownerQuoteMutation, AcceptHomeownerQuoteMutationVariables>;
export const RequestChangesHomeownerQuoteDocument = gql`
    mutation RequestChangesHomeownerQuote($id: ID!, $changesRequested: String!) {
  quoteHomeownerRequestChanges(quoteId: $id, changesRequested: $changesRequested) {
    ... on QuoteHomeownerRequestChangesFailure {
      errors {
        message
        path
        code
      }
    }
  }
}
    `;

/**
 * __useRequestChangesHomeownerQuoteMutation__
 *
 * To run a mutation, you first call `useRequestChangesHomeownerQuoteMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useRequestChangesHomeownerQuoteMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [requestChangesHomeownerQuoteMutation, { data, loading, error }] = useRequestChangesHomeownerQuoteMutation({
 *   variables: {
 *      id: // value for 'id'
 *      changesRequested: // value for 'changesRequested'
 *   },
 * });
 */
export function useRequestChangesHomeownerQuoteMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<RequestChangesHomeownerQuoteMutation, RequestChangesHomeownerQuoteMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useMutation<RequestChangesHomeownerQuoteMutation, RequestChangesHomeownerQuoteMutationVariables>(RequestChangesHomeownerQuoteDocument, options);
      }
export type RequestChangesHomeownerQuoteMutationHookResult = ReturnType<typeof useRequestChangesHomeownerQuoteMutation>;
export type RequestChangesHomeownerQuoteMutationResult = ApolloReactCommon.MutationResult<RequestChangesHomeownerQuoteMutation>;
export type RequestChangesHomeownerQuoteMutationOptions = ApolloReactCommon.BaseMutationOptions<RequestChangesHomeownerQuoteMutation, RequestChangesHomeownerQuoteMutationVariables>;
export const QuoteViewedDocument = gql`
    mutation QuoteViewed($quoteId: ID!, $contractorId: ID!) {
  quoteViewed(quoteId: $quoteId, contractorId: $contractorId) {
    ... on QuoteViewedFailure {
      errors {
        message
        path
        code
      }
    }
  }
}
    `;

/**
 * __useQuoteViewedMutation__
 *
 * To run a mutation, you first call `useQuoteViewedMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useQuoteViewedMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [quoteViewedMutation, { data, loading, error }] = useQuoteViewedMutation({
 *   variables: {
 *      quoteId: // value for 'quoteId'
 *      contractorId: // value for 'contractorId'
 *   },
 * });
 */
export function useQuoteViewedMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<QuoteViewedMutation, QuoteViewedMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useMutation<QuoteViewedMutation, QuoteViewedMutationVariables>(QuoteViewedDocument, options);
      }
export type QuoteViewedMutationHookResult = ReturnType<typeof useQuoteViewedMutation>;
export type QuoteViewedMutationResult = ApolloReactCommon.MutationResult<QuoteViewedMutation>;
export type QuoteViewedMutationOptions = ApolloReactCommon.BaseMutationOptions<QuoteViewedMutation, QuoteViewedMutationVariables>;
export const GetQuoteRequestFlowDataDocument = gql`
    query GetQuoteRequestFlowData($homeownerId: String) {
  organization {
    id
    ...QuoteRequestFlowOrganization
  }
  contractor {
    id
    ...QuoteRequestFlowContractor
  }
  homeowner(id: $homeownerId) {
    id
    ...QuoteRequestFlowHomeowner
  }
}
    ${QuoteRequestFlowOrganizationFragmentDoc}
${QuoteRequestFlowContractorFragmentDoc}
${QuoteRequestFlowHomeownerFragmentDoc}`;

/**
 * __useGetQuoteRequestFlowDataQuery__
 *
 * To run a query within a React component, call `useGetQuoteRequestFlowDataQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetQuoteRequestFlowDataQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetQuoteRequestFlowDataQuery({
 *   variables: {
 *      homeownerId: // value for 'homeownerId'
 *   },
 * });
 */
export function useGetQuoteRequestFlowDataQuery(baseOptions?: ApolloReactHooks.QueryHookOptions<GetQuoteRequestFlowDataQuery, GetQuoteRequestFlowDataQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<GetQuoteRequestFlowDataQuery, GetQuoteRequestFlowDataQueryVariables>(GetQuoteRequestFlowDataDocument, options);
      }
export function useGetQuoteRequestFlowDataLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<GetQuoteRequestFlowDataQuery, GetQuoteRequestFlowDataQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<GetQuoteRequestFlowDataQuery, GetQuoteRequestFlowDataQueryVariables>(GetQuoteRequestFlowDataDocument, options);
        }
export type GetQuoteRequestFlowDataQueryHookResult = ReturnType<typeof useGetQuoteRequestFlowDataQuery>;
export type GetQuoteRequestFlowDataLazyQueryHookResult = ReturnType<typeof useGetQuoteRequestFlowDataLazyQuery>;
export type GetQuoteRequestFlowDataQueryResult = ApolloReactCommon.QueryResult<GetQuoteRequestFlowDataQuery, GetQuoteRequestFlowDataQueryVariables>;
export const QuoteRequestFlowCreateQuoteDocument = gql`
    mutation QuoteRequestFlowCreateQuote($name: String!, $description: String!, $personalNote: String, $theme: OrganizationTheme!, $quoteTemplateId: ID!, $homeownerAddressId: ID!, $photoUploadIds: [ID!]!, $documentUploadIds: [ID!]!, $lineItems: [QuoteLineItemParams!]!, $totalTaxInCents: Int!, $totalFeesInCents: Int!, $discountInCents: Int!, $expiresAt: ISO8601DateTime!, $showFinancing: Boolean!, $priorQuoteId: ID, $mediums: [ContactMedium!]!) {
  quoteCreate(
    name: $name
    description: $description
    personalNote: $personalNote
    theme: $theme
    quoteTemplateId: $quoteTemplateId
    homeownerAddressId: $homeownerAddressId
    photoUploadIds: $photoUploadIds
    documentUploadIds: $documentUploadIds
    lineItems: $lineItems
    totalTaxInCents: $totalTaxInCents
    totalFeesInCents: $totalFeesInCents
    discountInCents: $discountInCents
    expiresAt: $expiresAt
    showFinancing: $showFinancing
    priorQuoteId: $priorQuoteId
    mediums: $mediums
  ) {
    ... on QuoteCreateSuccess {
      quote {
        id
        name
        priorQuote {
          id
        }
        homeownerAddress {
          id
          homeowner {
            id
          }
        }
        showFinancing
      }
    }
    ... on QuoteCreateFailure {
      errors {
        message
        path
        code
      }
    }
  }
}
    `;

/**
 * __useQuoteRequestFlowCreateQuoteMutation__
 *
 * To run a mutation, you first call `useQuoteRequestFlowCreateQuoteMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useQuoteRequestFlowCreateQuoteMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [quoteRequestFlowCreateQuoteMutation, { data, loading, error }] = useQuoteRequestFlowCreateQuoteMutation({
 *   variables: {
 *      name: // value for 'name'
 *      description: // value for 'description'
 *      personalNote: // value for 'personalNote'
 *      theme: // value for 'theme'
 *      quoteTemplateId: // value for 'quoteTemplateId'
 *      homeownerAddressId: // value for 'homeownerAddressId'
 *      photoUploadIds: // value for 'photoUploadIds'
 *      documentUploadIds: // value for 'documentUploadIds'
 *      lineItems: // value for 'lineItems'
 *      totalTaxInCents: // value for 'totalTaxInCents'
 *      totalFeesInCents: // value for 'totalFeesInCents'
 *      discountInCents: // value for 'discountInCents'
 *      expiresAt: // value for 'expiresAt'
 *      showFinancing: // value for 'showFinancing'
 *      priorQuoteId: // value for 'priorQuoteId'
 *      mediums: // value for 'mediums'
 *   },
 * });
 */
export function useQuoteRequestFlowCreateQuoteMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<QuoteRequestFlowCreateQuoteMutation, QuoteRequestFlowCreateQuoteMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useMutation<QuoteRequestFlowCreateQuoteMutation, QuoteRequestFlowCreateQuoteMutationVariables>(QuoteRequestFlowCreateQuoteDocument, options);
      }
export type QuoteRequestFlowCreateQuoteMutationHookResult = ReturnType<typeof useQuoteRequestFlowCreateQuoteMutation>;
export type QuoteRequestFlowCreateQuoteMutationResult = ApolloReactCommon.MutationResult<QuoteRequestFlowCreateQuoteMutation>;
export type QuoteRequestFlowCreateQuoteMutationOptions = ApolloReactCommon.BaseMutationOptions<QuoteRequestFlowCreateQuoteMutation, QuoteRequestFlowCreateQuoteMutationVariables>;
export const QuoteUploadCreateDocument = gql`
    mutation QuoteUploadCreate($quoteAccountId: ID!, $uploadType: ID!, $filename: ID!, $base64String: ID!) {
  quoteUploadCreate(
    quoteAccountId: $quoteAccountId
    uploadType: $uploadType
    filename: $filename
    base64String: $base64String
  ) {
    ... on QuoteUploadCreateSuccess {
      quoteUpload {
        id
        displayLink
        downloadLink
      }
    }
    ... on QuoteUploadCreateFailure {
      errors {
        message
        path
        code
      }
    }
  }
}
    `;

/**
 * __useQuoteUploadCreateMutation__
 *
 * To run a mutation, you first call `useQuoteUploadCreateMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useQuoteUploadCreateMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [quoteUploadCreateMutation, { data, loading, error }] = useQuoteUploadCreateMutation({
 *   variables: {
 *      quoteAccountId: // value for 'quoteAccountId'
 *      uploadType: // value for 'uploadType'
 *      filename: // value for 'filename'
 *      base64String: // value for 'base64String'
 *   },
 * });
 */
export function useQuoteUploadCreateMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<QuoteUploadCreateMutation, QuoteUploadCreateMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useMutation<QuoteUploadCreateMutation, QuoteUploadCreateMutationVariables>(QuoteUploadCreateDocument, options);
      }
export type QuoteUploadCreateMutationHookResult = ReturnType<typeof useQuoteUploadCreateMutation>;
export type QuoteUploadCreateMutationResult = ApolloReactCommon.MutationResult<QuoteUploadCreateMutation>;
export type QuoteUploadCreateMutationOptions = ApolloReactCommon.BaseMutationOptions<QuoteUploadCreateMutation, QuoteUploadCreateMutationVariables>;
export const GetOrganizationQuotesDocument = gql`
    query GetOrganizationQuotes($admin: Boolean!, $status: [QuoteStatus!], $homeownerSearch: String) {
  organization {
    id
    quoteAccount {
      id
      quotes(admin: $admin, status: $status, homeownerSearch: $homeownerSearch) {
        nodes {
          id
          ...QuoteWorkflowQuote
        }
      }
    }
  }
}
    ${QuoteWorkflowQuoteFragmentDoc}`;

/**
 * __useGetOrganizationQuotesQuery__
 *
 * To run a query within a React component, call `useGetOrganizationQuotesQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetOrganizationQuotesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetOrganizationQuotesQuery({
 *   variables: {
 *      admin: // value for 'admin'
 *      status: // value for 'status'
 *      homeownerSearch: // value for 'homeownerSearch'
 *   },
 * });
 */
export function useGetOrganizationQuotesQuery(baseOptions: ApolloReactHooks.QueryHookOptions<GetOrganizationQuotesQuery, GetOrganizationQuotesQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<GetOrganizationQuotesQuery, GetOrganizationQuotesQueryVariables>(GetOrganizationQuotesDocument, options);
      }
export function useGetOrganizationQuotesLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<GetOrganizationQuotesQuery, GetOrganizationQuotesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<GetOrganizationQuotesQuery, GetOrganizationQuotesQueryVariables>(GetOrganizationQuotesDocument, options);
        }
export type GetOrganizationQuotesQueryHookResult = ReturnType<typeof useGetOrganizationQuotesQuery>;
export type GetOrganizationQuotesLazyQueryHookResult = ReturnType<typeof useGetOrganizationQuotesLazyQuery>;
export type GetOrganizationQuotesQueryResult = ApolloReactCommon.QueryResult<GetOrganizationQuotesQuery, GetOrganizationQuotesQueryVariables>;
export const GetQuotesWorkflowContractorAndOrgDocument = gql`
    query GetQuotesWorkflowContractorAndOrg {
  contractor {
    ...QuoteWorkflowContractor
  }
  organization {
    ...QuoteWorkflowOrganization
  }
}
    ${QuoteWorkflowContractorFragmentDoc}
${QuoteWorkflowOrganizationFragmentDoc}`;

/**
 * __useGetQuotesWorkflowContractorAndOrgQuery__
 *
 * To run a query within a React component, call `useGetQuotesWorkflowContractorAndOrgQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetQuotesWorkflowContractorAndOrgQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetQuotesWorkflowContractorAndOrgQuery({
 *   variables: {
 *   },
 * });
 */
export function useGetQuotesWorkflowContractorAndOrgQuery(baseOptions?: ApolloReactHooks.QueryHookOptions<GetQuotesWorkflowContractorAndOrgQuery, GetQuotesWorkflowContractorAndOrgQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<GetQuotesWorkflowContractorAndOrgQuery, GetQuotesWorkflowContractorAndOrgQueryVariables>(GetQuotesWorkflowContractorAndOrgDocument, options);
      }
export function useGetQuotesWorkflowContractorAndOrgLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<GetQuotesWorkflowContractorAndOrgQuery, GetQuotesWorkflowContractorAndOrgQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<GetQuotesWorkflowContractorAndOrgQuery, GetQuotesWorkflowContractorAndOrgQueryVariables>(GetQuotesWorkflowContractorAndOrgDocument, options);
        }
export type GetQuotesWorkflowContractorAndOrgQueryHookResult = ReturnType<typeof useGetQuotesWorkflowContractorAndOrgQuery>;
export type GetQuotesWorkflowContractorAndOrgLazyQueryHookResult = ReturnType<typeof useGetQuotesWorkflowContractorAndOrgLazyQuery>;
export type GetQuotesWorkflowContractorAndOrgQueryResult = ApolloReactCommon.QueryResult<GetQuotesWorkflowContractorAndOrgQuery, GetQuotesWorkflowContractorAndOrgQueryVariables>;
export const QuoteAccountCreateDocument = gql`
    mutation QuoteAccountCreate($termsString: String!) {
  quoteAccountCreate(termsString: $termsString) {
    ... on QuoteAccountCreateSuccess {
      quoteAccount {
        id
      }
    }
    ... on QuoteAccountCreateFailure {
      errors {
        message
        path
        code
      }
    }
  }
}
    `;

/**
 * __useQuoteAccountCreateMutation__
 *
 * To run a mutation, you first call `useQuoteAccountCreateMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useQuoteAccountCreateMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [quoteAccountCreateMutation, { data, loading, error }] = useQuoteAccountCreateMutation({
 *   variables: {
 *      termsString: // value for 'termsString'
 *   },
 * });
 */
export function useQuoteAccountCreateMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<QuoteAccountCreateMutation, QuoteAccountCreateMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useMutation<QuoteAccountCreateMutation, QuoteAccountCreateMutationVariables>(QuoteAccountCreateDocument, options);
      }
export type QuoteAccountCreateMutationHookResult = ReturnType<typeof useQuoteAccountCreateMutation>;
export type QuoteAccountCreateMutationResult = ApolloReactCommon.MutationResult<QuoteAccountCreateMutation>;
export type QuoteAccountCreateMutationOptions = ApolloReactCommon.BaseMutationOptions<QuoteAccountCreateMutation, QuoteAccountCreateMutationVariables>;
export const QuoteTemplateCreateDocument = gql`
    mutation QuoteTemplateCreate($name: String!, $description: String!, $theme: QuoteTheme!, $totalTaxInCents: Int!, $totalFeesInCents: Int!, $discountInCents: Int!, $lineItems: [TemplateLineItemParams!]!) {
  quoteTemplateCreate(
    name: $name
    description: $description
    theme: $theme
    totalTaxInCents: $totalTaxInCents
    totalFeesInCents: $totalFeesInCents
    discountInCents: $discountInCents
    lineItems: $lineItems
  ) {
    ... on QuoteTemplateCreateSuccess {
      quoteTemplate {
        id
      }
    }
    ... on QuoteTemplateCreateFailure {
      errors {
        message
        path
        code
      }
    }
  }
}
    `;

/**
 * __useQuoteTemplateCreateMutation__
 *
 * To run a mutation, you first call `useQuoteTemplateCreateMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useQuoteTemplateCreateMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [quoteTemplateCreateMutation, { data, loading, error }] = useQuoteTemplateCreateMutation({
 *   variables: {
 *      name: // value for 'name'
 *      description: // value for 'description'
 *      theme: // value for 'theme'
 *      totalTaxInCents: // value for 'totalTaxInCents'
 *      totalFeesInCents: // value for 'totalFeesInCents'
 *      discountInCents: // value for 'discountInCents'
 *      lineItems: // value for 'lineItems'
 *   },
 * });
 */
export function useQuoteTemplateCreateMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<QuoteTemplateCreateMutation, QuoteTemplateCreateMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useMutation<QuoteTemplateCreateMutation, QuoteTemplateCreateMutationVariables>(QuoteTemplateCreateDocument, options);
      }
export type QuoteTemplateCreateMutationHookResult = ReturnType<typeof useQuoteTemplateCreateMutation>;
export type QuoteTemplateCreateMutationResult = ApolloReactCommon.MutationResult<QuoteTemplateCreateMutation>;
export type QuoteTemplateCreateMutationOptions = ApolloReactCommon.BaseMutationOptions<QuoteTemplateCreateMutation, QuoteTemplateCreateMutationVariables>;
export const GetContractorWebinarPickerDataDocument = gql`
    query GetContractorWebinarPickerData {
  contractor {
    id
    trainingScheduledAt
    firstName
  }
}
    `;

/**
 * __useGetContractorWebinarPickerDataQuery__
 *
 * To run a query within a React component, call `useGetContractorWebinarPickerDataQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetContractorWebinarPickerDataQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetContractorWebinarPickerDataQuery({
 *   variables: {
 *   },
 * });
 */
export function useGetContractorWebinarPickerDataQuery(baseOptions?: ApolloReactHooks.QueryHookOptions<GetContractorWebinarPickerDataQuery, GetContractorWebinarPickerDataQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<GetContractorWebinarPickerDataQuery, GetContractorWebinarPickerDataQueryVariables>(GetContractorWebinarPickerDataDocument, options);
      }
export function useGetContractorWebinarPickerDataLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<GetContractorWebinarPickerDataQuery, GetContractorWebinarPickerDataQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<GetContractorWebinarPickerDataQuery, GetContractorWebinarPickerDataQueryVariables>(GetContractorWebinarPickerDataDocument, options);
        }
export type GetContractorWebinarPickerDataQueryHookResult = ReturnType<typeof useGetContractorWebinarPickerDataQuery>;
export type GetContractorWebinarPickerDataLazyQueryHookResult = ReturnType<typeof useGetContractorWebinarPickerDataLazyQuery>;
export type GetContractorWebinarPickerDataQueryResult = ApolloReactCommon.QueryResult<GetContractorWebinarPickerDataQuery, GetContractorWebinarPickerDataQueryVariables>;
export const GetOnboardingDataDocument = gql`
    query GetOnboardingData {
  contractor {
    id
    ...OnboardingContractor
  }
  organization {
    id
    ...OnboardingOrganization
  }
}
    ${OnboardingContractorFragmentDoc}
${OnboardingOrganizationFragmentDoc}`;

/**
 * __useGetOnboardingDataQuery__
 *
 * To run a query within a React component, call `useGetOnboardingDataQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetOnboardingDataQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetOnboardingDataQuery({
 *   variables: {
 *   },
 * });
 */
export function useGetOnboardingDataQuery(baseOptions?: ApolloReactHooks.QueryHookOptions<GetOnboardingDataQuery, GetOnboardingDataQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<GetOnboardingDataQuery, GetOnboardingDataQueryVariables>(GetOnboardingDataDocument, options);
      }
export function useGetOnboardingDataLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<GetOnboardingDataQuery, GetOnboardingDataQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<GetOnboardingDataQuery, GetOnboardingDataQueryVariables>(GetOnboardingDataDocument, options);
        }
export type GetOnboardingDataQueryHookResult = ReturnType<typeof useGetOnboardingDataQuery>;
export type GetOnboardingDataLazyQueryHookResult = ReturnType<typeof useGetOnboardingDataLazyQuery>;
export type GetOnboardingDataQueryResult = ApolloReactCommon.QueryResult<GetOnboardingDataQuery, GetOnboardingDataQueryVariables>;
export const OnboardingSignAccountContractDocument = gql`
    mutation OnboardingSignAccountContract($contractId: ID!) {
  signAccountContract(contractId: $contractId, stripeTosAcceptance: true) {
    ... on SignAccountContractSuccess {
      organization {
        id
        ...OnboardingOrganization
      }
    }
    ... on SignAccountContractFailure {
      errors {
        message
        path
        code
      }
    }
  }
}
    ${OnboardingOrganizationFragmentDoc}`;

/**
 * __useOnboardingSignAccountContractMutation__
 *
 * To run a mutation, you first call `useOnboardingSignAccountContractMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useOnboardingSignAccountContractMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [onboardingSignAccountContractMutation, { data, loading, error }] = useOnboardingSignAccountContractMutation({
 *   variables: {
 *      contractId: // value for 'contractId'
 *   },
 * });
 */
export function useOnboardingSignAccountContractMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<OnboardingSignAccountContractMutation, OnboardingSignAccountContractMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useMutation<OnboardingSignAccountContractMutation, OnboardingSignAccountContractMutationVariables>(OnboardingSignAccountContractDocument, options);
      }
export type OnboardingSignAccountContractMutationHookResult = ReturnType<typeof useOnboardingSignAccountContractMutation>;
export type OnboardingSignAccountContractMutationResult = ApolloReactCommon.MutationResult<OnboardingSignAccountContractMutation>;
export type OnboardingSignAccountContractMutationOptions = ApolloReactCommon.BaseMutationOptions<OnboardingSignAccountContractMutation, OnboardingSignAccountContractMutationVariables>;
export const OnboardingUpdateContractorDocument = gql`
    mutation OnboardingUpdateContractor($attributes: ContractorAttributes!) {
  upsertContractor(attributes: $attributes) {
    ... on UpsertContractorSuccess {
      contractor {
        id
        ...OnboardingContractor
      }
    }
    ... on UpsertContractorFailure {
      errors {
        message
        path
        code
      }
    }
  }
}
    ${OnboardingContractorFragmentDoc}`;

/**
 * __useOnboardingUpdateContractorMutation__
 *
 * To run a mutation, you first call `useOnboardingUpdateContractorMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useOnboardingUpdateContractorMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [onboardingUpdateContractorMutation, { data, loading, error }] = useOnboardingUpdateContractorMutation({
 *   variables: {
 *      attributes: // value for 'attributes'
 *   },
 * });
 */
export function useOnboardingUpdateContractorMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<OnboardingUpdateContractorMutation, OnboardingUpdateContractorMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useMutation<OnboardingUpdateContractorMutation, OnboardingUpdateContractorMutationVariables>(OnboardingUpdateContractorDocument, options);
      }
export type OnboardingUpdateContractorMutationHookResult = ReturnType<typeof useOnboardingUpdateContractorMutation>;
export type OnboardingUpdateContractorMutationResult = ApolloReactCommon.MutationResult<OnboardingUpdateContractorMutation>;
export type OnboardingUpdateContractorMutationOptions = ApolloReactCommon.BaseMutationOptions<OnboardingUpdateContractorMutation, OnboardingUpdateContractorMutationVariables>;
export const OnboardingUpdateOrganizationDocument = gql`
    mutation OnboardingUpdateOrganization($attributes: OrganizationAttributes!) {
  upsertOrganization(attributes: $attributes) {
    ... on UpsertOrganizationSuccess {
      organization {
        id
        ...OnboardingOrganization
      }
    }
    ... on UpsertOrganizationFailure {
      errors {
        message
        path
        code
      }
    }
  }
}
    ${OnboardingOrganizationFragmentDoc}`;

/**
 * __useOnboardingUpdateOrganizationMutation__
 *
 * To run a mutation, you first call `useOnboardingUpdateOrganizationMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useOnboardingUpdateOrganizationMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [onboardingUpdateOrganizationMutation, { data, loading, error }] = useOnboardingUpdateOrganizationMutation({
 *   variables: {
 *      attributes: // value for 'attributes'
 *   },
 * });
 */
export function useOnboardingUpdateOrganizationMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<OnboardingUpdateOrganizationMutation, OnboardingUpdateOrganizationMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useMutation<OnboardingUpdateOrganizationMutation, OnboardingUpdateOrganizationMutationVariables>(OnboardingUpdateOrganizationDocument, options);
      }
export type OnboardingUpdateOrganizationMutationHookResult = ReturnType<typeof useOnboardingUpdateOrganizationMutation>;
export type OnboardingUpdateOrganizationMutationResult = ApolloReactCommon.MutationResult<OnboardingUpdateOrganizationMutation>;
export type OnboardingUpdateOrganizationMutationOptions = ApolloReactCommon.BaseMutationOptions<OnboardingUpdateOrganizationMutation, OnboardingUpdateOrganizationMutationVariables>;
export const OnboardingRecordDashboardPersonalizationAnswersDocument = gql`
    mutation OnboardingRecordDashboardPersonalizationAnswers($response: [HearthOnboardingResponseAttributes!]!) {
  recordPersonalizeDashboardResponse(response: $response) {
    ... on RecordHearthOnboardingPersonalizeDashboardResponseSuccess {
      questionnaireResponse {
        id
      }
    }
    ... on RecordHearthOnboardingPersonalizeDashboardResponseFailure {
      errors {
        message
        path
        code
      }
    }
  }
}
    `;

/**
 * __useOnboardingRecordDashboardPersonalizationAnswersMutation__
 *
 * To run a mutation, you first call `useOnboardingRecordDashboardPersonalizationAnswersMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useOnboardingRecordDashboardPersonalizationAnswersMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [onboardingRecordDashboardPersonalizationAnswersMutation, { data, loading, error }] = useOnboardingRecordDashboardPersonalizationAnswersMutation({
 *   variables: {
 *      response: // value for 'response'
 *   },
 * });
 */
export function useOnboardingRecordDashboardPersonalizationAnswersMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<OnboardingRecordDashboardPersonalizationAnswersMutation, OnboardingRecordDashboardPersonalizationAnswersMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useMutation<OnboardingRecordDashboardPersonalizationAnswersMutation, OnboardingRecordDashboardPersonalizationAnswersMutationVariables>(OnboardingRecordDashboardPersonalizationAnswersDocument, options);
      }
export type OnboardingRecordDashboardPersonalizationAnswersMutationHookResult = ReturnType<typeof useOnboardingRecordDashboardPersonalizationAnswersMutation>;
export type OnboardingRecordDashboardPersonalizationAnswersMutationResult = ApolloReactCommon.MutationResult<OnboardingRecordDashboardPersonalizationAnswersMutation>;
export type OnboardingRecordDashboardPersonalizationAnswersMutationOptions = ApolloReactCommon.BaseMutationOptions<OnboardingRecordDashboardPersonalizationAnswersMutation, OnboardingRecordDashboardPersonalizationAnswersMutationVariables>;
export const UpdateSetSeatsPasswordDocument = gql`
    mutation UpdateSetSeatsPassword($id: ID!, $attributes: ContractorAttributes!) {
  updateContractor(id: $id, attributes: $attributes) {
    contractor {
      id
      firstPasswordSetAt
      passwordSet
    }
    errors {
      message
      path
    }
  }
}
    `;

/**
 * __useUpdateSetSeatsPasswordMutation__
 *
 * To run a mutation, you first call `useUpdateSetSeatsPasswordMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateSetSeatsPasswordMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateSetSeatsPasswordMutation, { data, loading, error }] = useUpdateSetSeatsPasswordMutation({
 *   variables: {
 *      id: // value for 'id'
 *      attributes: // value for 'attributes'
 *   },
 * });
 */
export function useUpdateSetSeatsPasswordMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<UpdateSetSeatsPasswordMutation, UpdateSetSeatsPasswordMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useMutation<UpdateSetSeatsPasswordMutation, UpdateSetSeatsPasswordMutationVariables>(UpdateSetSeatsPasswordDocument, options);
      }
export type UpdateSetSeatsPasswordMutationHookResult = ReturnType<typeof useUpdateSetSeatsPasswordMutation>;
export type UpdateSetSeatsPasswordMutationResult = ApolloReactCommon.MutationResult<UpdateSetSeatsPasswordMutation>;
export type UpdateSetSeatsPasswordMutationOptions = ApolloReactCommon.BaseMutationOptions<UpdateSetSeatsPasswordMutation, UpdateSetSeatsPasswordMutationVariables>;
export const GetOrgLogoDocument = gql`
    query GetOrgLogo($orgUuid: ID!) {
  organization(uuid: $orgUuid) {
    id
    logoUrl
  }
}
    `;

/**
 * __useGetOrgLogoQuery__
 *
 * To run a query within a React component, call `useGetOrgLogoQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetOrgLogoQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetOrgLogoQuery({
 *   variables: {
 *      orgUuid: // value for 'orgUuid'
 *   },
 * });
 */
export function useGetOrgLogoQuery(baseOptions: ApolloReactHooks.QueryHookOptions<GetOrgLogoQuery, GetOrgLogoQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<GetOrgLogoQuery, GetOrgLogoQueryVariables>(GetOrgLogoDocument, options);
      }
export function useGetOrgLogoLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<GetOrgLogoQuery, GetOrgLogoQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<GetOrgLogoQuery, GetOrgLogoQueryVariables>(GetOrgLogoDocument, options);
        }
export type GetOrgLogoQueryHookResult = ReturnType<typeof useGetOrgLogoQuery>;
export type GetOrgLogoLazyQueryHookResult = ReturnType<typeof useGetOrgLogoLazyQuery>;
export type GetOrgLogoQueryResult = ApolloReactCommon.QueryResult<GetOrgLogoQuery, GetOrgLogoQueryVariables>;
export const FetchHomeownerSignatureLinkDocument = gql`
    mutation FetchHomeownerSignatureLink($contractServiceSignatureId: ID!, $signingToken: String!) {
  contractServiceSigningLinkFetch(
    contractServiceSignatureId: $contractServiceSignatureId
    signingToken: $signingToken
  ) {
    ... on ContractServiceSigningLinkFetchSuccess {
      signatureLink
    }
    ... on ContractServiceSigningLinkFetchFailure {
      errors {
        message
        path
        code
      }
    }
  }
}
    `;

/**
 * __useFetchHomeownerSignatureLinkMutation__
 *
 * To run a mutation, you first call `useFetchHomeownerSignatureLinkMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useFetchHomeownerSignatureLinkMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [fetchHomeownerSignatureLinkMutation, { data, loading, error }] = useFetchHomeownerSignatureLinkMutation({
 *   variables: {
 *      contractServiceSignatureId: // value for 'contractServiceSignatureId'
 *      signingToken: // value for 'signingToken'
 *   },
 * });
 */
export function useFetchHomeownerSignatureLinkMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<FetchHomeownerSignatureLinkMutation, FetchHomeownerSignatureLinkMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useMutation<FetchHomeownerSignatureLinkMutation, FetchHomeownerSignatureLinkMutationVariables>(FetchHomeownerSignatureLinkDocument, options);
      }
export type FetchHomeownerSignatureLinkMutationHookResult = ReturnType<typeof useFetchHomeownerSignatureLinkMutation>;
export type FetchHomeownerSignatureLinkMutationResult = ApolloReactCommon.MutationResult<FetchHomeownerSignatureLinkMutation>;
export type FetchHomeownerSignatureLinkMutationOptions = ApolloReactCommon.BaseMutationOptions<FetchHomeownerSignatureLinkMutation, FetchHomeownerSignatureLinkMutationVariables>;
export const FetchContractServiceSignatureDocument = gql`
    query FetchContractServiceSignature($contractServiceSignatureId: ID!, $signingToken: String!) {
  contractServiceSignature(
    id: $contractServiceSignatureId
    signingToken: $signingToken
  ) {
    id
    status
    contractServiceSigner {
      id
      fullName
      email
      homeowner {
        id
      }
    }
    contractServiceContract {
      id
      base64Pdf
      attachedInvoice {
        id
        status
      }
    }
  }
}
    `;

/**
 * __useFetchContractServiceSignatureQuery__
 *
 * To run a query within a React component, call `useFetchContractServiceSignatureQuery` and pass it any options that fit your needs.
 * When your component renders, `useFetchContractServiceSignatureQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useFetchContractServiceSignatureQuery({
 *   variables: {
 *      contractServiceSignatureId: // value for 'contractServiceSignatureId'
 *      signingToken: // value for 'signingToken'
 *   },
 * });
 */
export function useFetchContractServiceSignatureQuery(baseOptions: ApolloReactHooks.QueryHookOptions<FetchContractServiceSignatureQuery, FetchContractServiceSignatureQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<FetchContractServiceSignatureQuery, FetchContractServiceSignatureQueryVariables>(FetchContractServiceSignatureDocument, options);
      }
export function useFetchContractServiceSignatureLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<FetchContractServiceSignatureQuery, FetchContractServiceSignatureQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<FetchContractServiceSignatureQuery, FetchContractServiceSignatureQueryVariables>(FetchContractServiceSignatureDocument, options);
        }
export type FetchContractServiceSignatureQueryHookResult = ReturnType<typeof useFetchContractServiceSignatureQuery>;
export type FetchContractServiceSignatureLazyQueryHookResult = ReturnType<typeof useFetchContractServiceSignatureLazyQuery>;
export type FetchContractServiceSignatureQueryResult = ApolloReactCommon.QueryResult<FetchContractServiceSignatureQuery, FetchContractServiceSignatureQueryVariables>;
export const FetchHomeownerNameDocument = gql`
    query FetchHomeownerName($homeownerId: String!) {
  homeowner(id: $homeownerId) {
    id
    fullName
  }
}
    `;

/**
 * __useFetchHomeownerNameQuery__
 *
 * To run a query within a React component, call `useFetchHomeownerNameQuery` and pass it any options that fit your needs.
 * When your component renders, `useFetchHomeownerNameQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useFetchHomeownerNameQuery({
 *   variables: {
 *      homeownerId: // value for 'homeownerId'
 *   },
 * });
 */
export function useFetchHomeownerNameQuery(baseOptions: ApolloReactHooks.QueryHookOptions<FetchHomeownerNameQuery, FetchHomeownerNameQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<FetchHomeownerNameQuery, FetchHomeownerNameQueryVariables>(FetchHomeownerNameDocument, options);
      }
export function useFetchHomeownerNameLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<FetchHomeownerNameQuery, FetchHomeownerNameQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<FetchHomeownerNameQuery, FetchHomeownerNameQueryVariables>(FetchHomeownerNameDocument, options);
        }
export type FetchHomeownerNameQueryHookResult = ReturnType<typeof useFetchHomeownerNameQuery>;
export type FetchHomeownerNameLazyQueryHookResult = ReturnType<typeof useFetchHomeownerNameLazyQuery>;
export type FetchHomeownerNameQueryResult = ApolloReactCommon.QueryResult<FetchHomeownerNameQuery, FetchHomeownerNameQueryVariables>;
export const GetDashboardNavDataDocument = gql`
    query GetDashboardNavData {
  contractor {
    id
    admin
    firstName
    lastSignInAt
    enterpriseAdmin
    hasHomeownerFeedback
    affiliateReferralCode
    customSettings {
      sendNewProductTourSeen202201
      showNewProductTour202201
    }
  }
  organization {
    id
    logoUrl
    companyName
    insuranceEligible
    contractServiceAccount {
      id
      termsAgreedAt
    }
  }
}
    `;

/**
 * __useGetDashboardNavDataQuery__
 *
 * To run a query within a React component, call `useGetDashboardNavDataQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetDashboardNavDataQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetDashboardNavDataQuery({
 *   variables: {
 *   },
 * });
 */
export function useGetDashboardNavDataQuery(baseOptions?: ApolloReactHooks.QueryHookOptions<GetDashboardNavDataQuery, GetDashboardNavDataQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<GetDashboardNavDataQuery, GetDashboardNavDataQueryVariables>(GetDashboardNavDataDocument, options);
      }
export function useGetDashboardNavDataLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<GetDashboardNavDataQuery, GetDashboardNavDataQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<GetDashboardNavDataQuery, GetDashboardNavDataQueryVariables>(GetDashboardNavDataDocument, options);
        }
export type GetDashboardNavDataQueryHookResult = ReturnType<typeof useGetDashboardNavDataQuery>;
export type GetDashboardNavDataLazyQueryHookResult = ReturnType<typeof useGetDashboardNavDataLazyQuery>;
export type GetDashboardNavDataQueryResult = ApolloReactCommon.QueryResult<GetDashboardNavDataQuery, GetDashboardNavDataQueryVariables>;
export const UpsertContractorDashoardNavInfoDocument = gql`
    mutation UpsertContractorDashoardNavInfo($customSettings: CustomContractorSettingsAttributes!) {
  upsertContractor(customSettings: $customSettings) {
    ... on UpsertContractorSuccess {
      contractor {
        id
        customSettings {
          sendNewProductTourSeen202201
        }
      }
    }
    ... on UpsertContractorFailure {
      errors {
        message
        path
        code
      }
    }
  }
}
    `;

/**
 * __useUpsertContractorDashoardNavInfoMutation__
 *
 * To run a mutation, you first call `useUpsertContractorDashoardNavInfoMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpsertContractorDashoardNavInfoMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [upsertContractorDashoardNavInfoMutation, { data, loading, error }] = useUpsertContractorDashoardNavInfoMutation({
 *   variables: {
 *      customSettings: // value for 'customSettings'
 *   },
 * });
 */
export function useUpsertContractorDashoardNavInfoMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<UpsertContractorDashoardNavInfoMutation, UpsertContractorDashoardNavInfoMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useMutation<UpsertContractorDashoardNavInfoMutation, UpsertContractorDashoardNavInfoMutationVariables>(UpsertContractorDashoardNavInfoDocument, options);
      }
export type UpsertContractorDashoardNavInfoMutationHookResult = ReturnType<typeof useUpsertContractorDashoardNavInfoMutation>;
export type UpsertContractorDashoardNavInfoMutationResult = ApolloReactCommon.MutationResult<UpsertContractorDashoardNavInfoMutation>;
export type UpsertContractorDashoardNavInfoMutationOptions = ApolloReactCommon.BaseMutationOptions<UpsertContractorDashoardNavInfoMutation, UpsertContractorDashoardNavInfoMutationVariables>;
export const GetDemoModeDocument = gql`
    query GetDemoMode {
  contractor {
    id
    demoMode
  }
}
    `;

/**
 * __useGetDemoModeQuery__
 *
 * To run a query within a React component, call `useGetDemoModeQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetDemoModeQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetDemoModeQuery({
 *   variables: {
 *   },
 * });
 */
export function useGetDemoModeQuery(baseOptions?: ApolloReactHooks.QueryHookOptions<GetDemoModeQuery, GetDemoModeQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<GetDemoModeQuery, GetDemoModeQueryVariables>(GetDemoModeDocument, options);
      }
export function useGetDemoModeLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<GetDemoModeQuery, GetDemoModeQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<GetDemoModeQuery, GetDemoModeQueryVariables>(GetDemoModeDocument, options);
        }
export type GetDemoModeQueryHookResult = ReturnType<typeof useGetDemoModeQuery>;
export type GetDemoModeLazyQueryHookResult = ReturnType<typeof useGetDemoModeLazyQuery>;
export type GetDemoModeQueryResult = ApolloReactCommon.QueryResult<GetDemoModeQuery, GetDemoModeQueryVariables>;
export const UpsertDemoModeDocument = gql`
    mutation UpsertDemoMode($attributes: ContractorAttributes!) {
  upsertContractor(attributes: $attributes) {
    ... on UpsertContractorSuccess {
      contractor {
        id
        demoMode
      }
    }
    ... on UpsertContractorFailure {
      errors {
        message
        path
        code
      }
    }
  }
}
    `;

/**
 * __useUpsertDemoModeMutation__
 *
 * To run a mutation, you first call `useUpsertDemoModeMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpsertDemoModeMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [upsertDemoModeMutation, { data, loading, error }] = useUpsertDemoModeMutation({
 *   variables: {
 *      attributes: // value for 'attributes'
 *   },
 * });
 */
export function useUpsertDemoModeMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<UpsertDemoModeMutation, UpsertDemoModeMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useMutation<UpsertDemoModeMutation, UpsertDemoModeMutationVariables>(UpsertDemoModeDocument, options);
      }
export type UpsertDemoModeMutationHookResult = ReturnType<typeof useUpsertDemoModeMutation>;
export type UpsertDemoModeMutationResult = ApolloReactCommon.MutationResult<UpsertDemoModeMutation>;
export type UpsertDemoModeMutationOptions = ApolloReactCommon.BaseMutationOptions<UpsertDemoModeMutation, UpsertDemoModeMutationVariables>;
export const CheckOffersDocument = gql`
    query CheckOffers($id: String!) {
  loanInquiry(loanInquiryUuid: $id) {
    id
    homeowner {
      id
      firstName
      lastName
      email
    }
    contractor {
      id
      featureFlags {
        id
      }
    }
    organization {
      id
    }
    offers {
      totalCount
    }
  }
}
    `;

/**
 * __useCheckOffersQuery__
 *
 * To run a query within a React component, call `useCheckOffersQuery` and pass it any options that fit your needs.
 * When your component renders, `useCheckOffersQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useCheckOffersQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useCheckOffersQuery(baseOptions: ApolloReactHooks.QueryHookOptions<CheckOffersQuery, CheckOffersQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<CheckOffersQuery, CheckOffersQueryVariables>(CheckOffersDocument, options);
      }
export function useCheckOffersLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<CheckOffersQuery, CheckOffersQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<CheckOffersQuery, CheckOffersQueryVariables>(CheckOffersDocument, options);
        }
export type CheckOffersQueryHookResult = ReturnType<typeof useCheckOffersQuery>;
export type CheckOffersLazyQueryHookResult = ReturnType<typeof useCheckOffersLazyQuery>;
export type CheckOffersQueryResult = ApolloReactCommon.QueryResult<CheckOffersQuery, CheckOffersQueryVariables>;
export const OAuthConnectInvoicePlaidTokenDocument = gql`
    mutation OAuthConnectInvoicePlaidToken($plaidPublicToken: String!, $connectInvoiceId: ID!, $plaidAccountId: String!) {
  addPlaidTokenToConnectInvoice(
    plaidPublicToken: $plaidPublicToken
    connectInvoiceId: $connectInvoiceId
    plaidAccountId: $plaidAccountId
  ) {
    ... on AddPlaidTokenToConnectInvoiceSuccess {
      connectInvoice {
        id
        plaidAccount {
          id
          mask
          name
          verificationStatus
          verified
        }
      }
    }
    ... on AddPlaidTokenToConnectInvoiceFailure {
      errors {
        code
        message
      }
    }
  }
}
    `;

/**
 * __useOAuthConnectInvoicePlaidTokenMutation__
 *
 * To run a mutation, you first call `useOAuthConnectInvoicePlaidTokenMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useOAuthConnectInvoicePlaidTokenMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [oAuthConnectInvoicePlaidTokenMutation, { data, loading, error }] = useOAuthConnectInvoicePlaidTokenMutation({
 *   variables: {
 *      plaidPublicToken: // value for 'plaidPublicToken'
 *      connectInvoiceId: // value for 'connectInvoiceId'
 *      plaidAccountId: // value for 'plaidAccountId'
 *   },
 * });
 */
export function useOAuthConnectInvoicePlaidTokenMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<OAuthConnectInvoicePlaidTokenMutation, OAuthConnectInvoicePlaidTokenMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useMutation<OAuthConnectInvoicePlaidTokenMutation, OAuthConnectInvoicePlaidTokenMutationVariables>(OAuthConnectInvoicePlaidTokenDocument, options);
      }
export type OAuthConnectInvoicePlaidTokenMutationHookResult = ReturnType<typeof useOAuthConnectInvoicePlaidTokenMutation>;
export type OAuthConnectInvoicePlaidTokenMutationResult = ApolloReactCommon.MutationResult<OAuthConnectInvoicePlaidTokenMutation>;
export type OAuthConnectInvoicePlaidTokenMutationOptions = ApolloReactCommon.BaseMutationOptions<OAuthConnectInvoicePlaidTokenMutation, OAuthConnectInvoicePlaidTokenMutationVariables>;
export const GetContractTemplateStatusDocument = gql`
    query GetContractTemplateStatus {
  organization {
    id
    contractServiceAccount {
      id
      termsAgreedAt
    }
  }
  contractor {
    id
    admin
  }
}
    `;

/**
 * __useGetContractTemplateStatusQuery__
 *
 * To run a query within a React component, call `useGetContractTemplateStatusQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetContractTemplateStatusQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetContractTemplateStatusQuery({
 *   variables: {
 *   },
 * });
 */
export function useGetContractTemplateStatusQuery(baseOptions?: ApolloReactHooks.QueryHookOptions<GetContractTemplateStatusQuery, GetContractTemplateStatusQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<GetContractTemplateStatusQuery, GetContractTemplateStatusQueryVariables>(GetContractTemplateStatusDocument, options);
      }
export function useGetContractTemplateStatusLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<GetContractTemplateStatusQuery, GetContractTemplateStatusQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<GetContractTemplateStatusQuery, GetContractTemplateStatusQueryVariables>(GetContractTemplateStatusDocument, options);
        }
export type GetContractTemplateStatusQueryHookResult = ReturnType<typeof useGetContractTemplateStatusQuery>;
export type GetContractTemplateStatusLazyQueryHookResult = ReturnType<typeof useGetContractTemplateStatusLazyQuery>;
export type GetContractTemplateStatusQueryResult = ApolloReactCommon.QueryResult<GetContractTemplateStatusQuery, GetContractTemplateStatusQueryVariables>;